(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.hJ.eg === region.iE.eg)
	{
		return 'on line ' + region.hJ.eg;
	}
	return 'on lines ' + region.hJ.eg + ' through ' + region.iE.eg;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.lB,
		impl.nh,
		impl.mN,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		bx: func(record.bx),
		hL: record.hL,
		hv: record.hv
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.bx;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.hL;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.hv) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.lB,
		impl.nh,
		impl.mN,
		function(sendToApp, initialModel) {
			var view = impl.nm;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.lB,
		impl.nh,
		impl.mN,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.hG && impl.hG(sendToApp)
			var view = impl.nm;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.kG);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.na) && (_VirtualDom_doc.title = title = doc.na);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.l6;
	var onUrlRequest = impl.l7;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		hG: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.jz === next.jz
							&& curr.iS === next.iS
							&& curr.jt.a === next.jt.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		lB: function(flags)
		{
			return A3(impl.lB, flags, _Browser_getUrl(), key);
		},
		nm: impl.nm,
		nh: impl.nh,
		mN: impl.mN
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { lt: 'hidden', kW: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { lt: 'mozHidden', kW: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { lt: 'msHidden', kW: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { lt: 'webkitHidden', kW: 'webkitvisibilitychange' }
		: { lt: 'hidden', kW: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		jL: _Browser_getScene(),
		W: {
			kg: _Browser_window.pageXOffset,
			kh: _Browser_window.pageYOffset,
			hY: _Browser_doc.documentElement.clientWidth,
			gH: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		hY: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		gH: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			jL: {
				hY: node.scrollWidth,
				gH: node.scrollHeight
			},
			W: {
				kg: node.scrollLeft,
				kh: node.scrollTop,
				hY: node.clientWidth,
				gH: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			jL: _Browser_getScene(),
			W: {
				kg: x,
				kh: y,
				hY: _Browser_doc.documentElement.clientWidth,
				gH: _Browser_doc.documentElement.clientHeight
			},
			lc: {
				kg: x + rect.left,
				kh: y + rect.top,
				hY: rect.width,
				gH: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}



// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.gr.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.gr.b, xhr)); });
		$elm$core$Maybe$isJust(request.j2) && _Http_track(router, xhr, request.j2.a);

		try {
			xhr.open(request.lW, request.nj, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.nj));
		}

		_Http_configureRequest(xhr, request);

		request.kG.a && xhr.setRequestHeader('Content-Type', request.kG.a);
		xhr.send(request.kG.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.iP; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.m9.a || 0;
	xhr.responseType = request.gr.d;
	xhr.withCredentials = request.kw;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		nj: xhr.responseURL,
		mJ: xhr.status,
		mK: xhr.statusText,
		iP: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			my: event.loaded,
			dB: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			mh: event.loaded,
			dB: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}

// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.lZ) { flags += 'm'; }
	if (options.kU) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $author$project$Main$RouteMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Routing$UrlChange = function (a) {
	return {$: 0, a: a};
};
var $author$project$Routing$UrlRequest = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.F) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.J),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.J);
		} else {
			var treeLen = builder.F * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.M) : builder.M;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.F);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.J) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.J);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{M: nodeList, F: (len / $elm$core$Array$branchFactor) | 0, J: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {iL: fragment, iS: host, jp: path, jt: port_, jz: protocol, es: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Main$CfgDeviceMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$ResponsiveDesign$Desktop = 2;
var $author$project$DataState$Initial = {$: 0};
var $author$project$Main$UserMsg = function (a) {
	return {$: 9, a: a};
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Interop$Browser$toBrowser = _Platform_outgoingPort(
	'toBrowser',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'event',
					$elm$json$Json$Encode$string($.iF)),
					_Utils_Tuple2(
					'payload',
					$elm$core$Basics$identity($.jq))
				]));
	});
var $author$project$Interop$Browser$postMessage = F2(
	function (name, payload) {
		return $author$project$Interop$Browser$toBrowser(
			{iF: name, jq: payload});
	});
var $author$project$Pages$User$getUserState = A2($author$project$Interop$Browser$postMessage, 'GET_USER_STATE', $elm$json$Json$Encode$null);
var $author$project$ResponsiveDesign$Phone = 0;
var $author$project$ResponsiveDesign$Tablet = 1;
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Basics$neq = _Utils_notEqual;
var $author$project$Main$getViewport = F2(
	function (currViewport, size) {
		return ((size.hY < 1022) && (!(!currViewport))) ? $elm$core$Maybe$Just(0) : (((size.hY >= 1022) && ((size.hY <= 1300) && (currViewport !== 1))) ? $elm$core$Maybe$Just(1) : (((size.hY > 1300) && (currViewport !== 2)) ? $elm$core$Maybe$Just(2) : $elm$core$Maybe$Nothing));
	});
var $author$project$Dialogs$ContactUs$init = {d_: false};
var $author$project$Dialogs$Gallery$ImageNoStatus = 0;
var $author$project$Dialogs$Gallery$ImagesLoading = {$: 0};
var $author$project$Dialogs$Gallery$init = {
	bU: _Utils_Tuple2(false, $elm$core$Maybe$Nothing),
	bX: false,
	ah: $author$project$Dialogs$Gallery$ImagesLoading,
	bu: 0
};
var $author$project$Dialogs$LiveCapture$init = {cV: $elm$core$Maybe$Nothing, c6: $elm$core$Maybe$Nothing, c8: false};
var $author$project$Dialogs$ReleaseNotes$init = {bX: false};
var $author$project$FabricStatus$Disconnected = 1;
var $author$project$FabricStatus$init = 1;
var $author$project$Pages$CfgDevice$Core$InfoTab = 3;
var $author$project$Pages$CfgDevice$Core$ScheduleTab = 0;
var $author$project$Pages$CfgDevice$Core$SettingsTabMsg = function (a) {
	return {$: 9, a: a};
};
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $author$project$Pages$CfgDevice$Design$CreateNewMode = 0;
var $author$project$Pages$CfgDevice$Design$ImageNoStatus = 0;
var $author$project$Pages$CfgDevice$Design$ImagesLoading = {$: 0};
var $author$project$Pages$CfgDevice$Design$TemplateSynced = 0;
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$ColorPicker$init = $elm$core$Dict$empty;
var $author$project$DataState$init = $author$project$DataState$Initial;
var $author$project$Select$init = $elm$core$Dict$empty;
var $author$project$Pages$User$init = {cG: $author$project$DataState$init, e3: $elm$core$Maybe$Nothing, dr: $elm$core$Maybe$Nothing, dt: true, r: $author$project$Select$init, ew: $elm$core$Maybe$Nothing, co: false, ax: $elm$core$Maybe$Nothing, eK: $author$project$DataState$Initial};
var $author$project$Reusable$DatePicker$DatePickerMsg = function (a) {
	return {$: 2, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$CurrentDate = function (a) {
	return {$: 0, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$DatePicker = $elm$core$Basics$identity;
var $elm$time$Time$May = 4;
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $elm$core$Basics$modBy = _Basics_modBy;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $CurrySoftware$elm_datepicker$DatePicker$Date$initDate = A3($justinmimbs$date$Date$fromCalendarDate, 1992, 4, 31);
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.hJ, posixMinutes) < 0) {
					return posixMinutes + era.c;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		iA: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		ja: month,
		nr: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).iA;
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).ja;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).nr;
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$here = _Time_here(0);
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $justinmimbs$date$Date$today = A3($elm$core$Task$map2, $justinmimbs$date$Date$fromPosix, $elm$time$Time$here, $elm$time$Time$now);
var $CurrySoftware$elm_datepicker$DatePicker$init = _Utils_Tuple2(
	{
		af: $elm$core$Maybe$Just($CurrySoftware$elm_datepicker$DatePicker$Date$initDate),
		bq: false,
		aG: $elm$core$Maybe$Nothing,
		a6: false,
		bK: $CurrySoftware$elm_datepicker$DatePicker$Date$initDate
	},
	A2($elm$core$Task$perform, $CurrySoftware$elm_datepicker$DatePicker$CurrentDate, $justinmimbs$date$Date$today));
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Reusable$DatePicker$init = function () {
	var _v0 = $CurrySoftware$elm_datepicker$DatePicker$init;
	var datePicker = _v0.a;
	var datePickerFx = _v0.b;
	return _Utils_Tuple2(
		{a0: $elm$core$Maybe$Nothing, a1: datePicker, c8: false},
		A2($elm$core$Platform$Cmd$map, $author$project$Reusable$DatePicker$DatePickerMsg, datePickerFx));
}();
var $author$project$Reusable$Tooltip$init = $elm$core$Dict$empty;
var $author$project$Pages$CfgDevice$Design$init = function (seed) {
	return {
		cF: false,
		bO: '',
		bQ: _Utils_Tuple2(false, $elm$core$Maybe$Nothing),
		eU: _List_Nil,
		aA: $author$project$ColorPicker$init,
		cQ: false,
		cR: false,
		bW: false,
		cU: false,
		d4: '',
		ah: $author$project$Pages$CfgDevice$Design$ImagesLoading,
		ee: false,
		bu: 0,
		H: $elm$core$Maybe$Nothing,
		b7: $elm$core$Dict$empty,
		ei: 0.37,
		ai: $elm$core$Maybe$Nothing,
		g1: $author$project$DataState$init,
		aj: $author$project$DataState$init,
		dm: _Utils_Tuple2(false, 0),
		bz: $elm$core$Maybe$Nothing,
		cf: false,
		dn: false,
		av: $elm$core$Maybe$Nothing,
		er: false,
		jM: seed,
		r: $author$project$Select$init,
		a9: $author$project$Reusable$DatePicker$init.a,
		aw: $elm$core$Maybe$Nothing,
		aR: $elm$core$Maybe$Nothing,
		bb: $elm$core$Maybe$Nothing,
		aS: $elm$core$Maybe$Nothing,
		dx: $elm$core$Maybe$Nothing,
		a: $author$project$DataState$init,
		h: $elm$core$Maybe$Nothing,
		jR: _List_Nil,
		cn: _Utils_Tuple2(false, $elm$core$Maybe$Nothing),
		dy: false,
		dz: false,
		aV: $elm$core$Maybe$Nothing,
		S: $elm$core$Set$fromList(
			_List_fromArray(
				['global-shared-style', 'text-style'])),
		dE: false,
		ey: $elm$core$Maybe$Nothing,
		eA: false,
		cv: false,
		bI: 0,
		eB: 0,
		al: _List_Nil,
		bJ: '',
		fQ: $author$project$Reusable$Tooltip$init,
		fS: $elm$core$Maybe$Nothing,
		eI: false,
		j7: $author$project$Pages$User$init,
		dL: $elm$core$Set$empty,
		ki: $elm$core$Maybe$Nothing
	};
};
var $author$project$Pages$CfgDevice$Schedule$init = {eU: _List_Nil, mo: $elm$core$Dict$empty, r: $author$project$Select$init, jR: _List_Nil, al: _List_Nil, fQ: $author$project$Reusable$Tooltip$init};
var $author$project$Pages$CfgDevice$Settings$DatePickerMsg = function (a) {
	return {$: 5, a: a};
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$Pages$CfgDevice$Settings$init = _Utils_Tuple2(
	{bS: $elm$core$Maybe$Nothing, aA: $author$project$ColorPicker$init, cO: false, cP: false, dY: $elm$core$Maybe$Nothing, ee: false, b8: $author$project$Reusable$DatePicker$init.a, gZ: '', fl: $elm$core$Maybe$Nothing, el: $elm$core$Maybe$Nothing, hq: '', mo: $elm$core$Dict$empty, eu: $elm$core$Maybe$Nothing, r: $author$project$Select$init, dv: $elm$core$Maybe$Nothing, cl: $elm$core$Maybe$Nothing, jP: $elm$core$Maybe$Nothing, bH: $elm$core$Maybe$Nothing, fQ: $author$project$Reusable$Tooltip$init},
	A2($elm$core$Platform$Cmd$map, $author$project$Pages$CfgDevice$Settings$DatePickerMsg, $author$project$Reusable$DatePicker$init.b));
var $aforemny$material_components_web_elm$Material$Snackbar$MessageId = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Snackbar$Queue = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Snackbar$initialQueue = {cc: _List_Nil, em: 0};
var $elm$random$Random$Seed = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$random$Random$next = function (_v0) {
	var state0 = _v0.a;
	var incr = _v0.b;
	return A2($elm$random$Random$Seed, ((state0 * 1664525) + incr) >>> 0, incr);
};
var $elm$random$Random$initialSeed = function (x) {
	var _v0 = $elm$random$Random$next(
		A2($elm$random$Random$Seed, 0, 1013904223));
	var state1 = _v0.a;
	var incr = _v0.b;
	var state2 = (state1 + x) >>> 0;
	return $elm$random$Random$next(
		A2($elm$random$Random$Seed, state2, incr));
};
var $author$project$Pages$CfgDevice$Core$init = function (randomVal) {
	return _Utils_Tuple2(
		{
			kV: $elm$core$Maybe$Nothing,
			P: $author$project$Pages$CfgDevice$Design$init(
				$elm$random$Random$initialSeed(randomVal)),
			ao: $author$project$DataState$Initial,
			ch: $elm$core$Set$empty,
			a7: $author$project$Pages$CfgDevice$Schedule$init,
			ba: 0,
			bG: 3,
			aU: $author$project$Pages$CfgDevice$Settings$init.a,
			cp: $aforemny$material_components_web_elm$Material$Snackbar$initialQueue,
			fQ: $author$project$Reusable$Tooltip$init,
			j7: $author$project$Pages$User$init
		},
		A2($elm$core$Platform$Cmd$map, $author$project$Pages$CfgDevice$Core$SettingsTabMsg, $author$project$Pages$CfgDevice$Settings$init.b));
};
var $author$project$Pages$Dashboard$ShowAllDevices = 0;
var $author$project$Pages$Dashboard$init = {
	bj: _Utils_Tuple2(false, $elm$core$Maybe$Nothing),
	cP: _Utils_Tuple2(false, _List_Nil),
	cW: _Utils_Tuple2(false, $elm$core$Maybe$Nothing),
	bm: '',
	aE: $elm$core$Maybe$Nothing,
	bY: 0,
	r: $author$project$Select$init,
	a8: $elm$core$Maybe$Nothing,
	cp: $aforemny$material_components_web_elm$Material$Snackbar$initialQueue,
	fQ: $author$project$Reusable$Tooltip$init
};
var $author$project$Pages$Faq$One = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Faq$Steps = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Faq$init = {
	f2: _List_fromArray(
		[
			{
			_: $author$project$Pages$Faq$One('\r\n            There are two options available for use with SchoolCafe TV -\r\n            Chromebox and Chromebit'),
			Y: 'What are the devices available?'
		},
			{
			_: A2(
				$author$project$Pages$Faq$Steps,
				$elm$core$Maybe$Just('Please follow the instructions below in testclassic'),
				_List_fromArray(
					['After unboxing, connect the device to a power source', 'Connect Chromebox to TV using HDMI cable', 'Power on the device, it will now check for network connection', 'If network connection fails, Use keyboard and mouse to configure network settings', 'After successful connection, the device will reboot and registration code will be displayed', 'Use the on screen instructions to register your device'])),
			Y: 'How do I setup a new device?'
		},
			{
			_: A2(
				$author$project$Pages$Faq$Steps,
				$elm$core$Maybe$Just('Schoolcafe TV will communicate with following services'),
				_List_fromArray(
					['https://www.schoolcafe.tv', 'https://fabric.schoolcafe.tv', 'https://iili.io', 'https://www.youtube.com', 'https:/s.ytimg.com'])),
			Y: 'Do I have to change the firewall & Network Settings?'
		},
			{
			_: $author$project$Pages$Faq$One('\r\n              Menu items can be updated from PrimeroEdge Menu Planning module. \r\n              After editing the menu items run the "Reload Menu" command on all online devices to display the edited items.\r\n            '),
			Y: 'How do I update the menu item displayed on TV ?'
		},
			{
			_: $author$project$Pages$Faq$One('\r\n            To upload new menu items and pictures please use PrimeroEdge Menu Planning Module.\r\n            Schoolcafe TV will automatically pickup the changes during the next cycle.\r\n          '),
			Y: 'Where do we change or upload new menu item pictures?'
		},
			{
			_: $author$project$Pages$Faq$One('\r\n          Each device has to be registered only once during the setup. Syncing between all the devices in the school or district is\r\n          possible using the "Sync" feature after device registration.\r\n          '),
			Y: 'Do I have to manually configure each device in my school (or even the whole district)?'
		},
			{
			_: $author$project$Pages$Faq$One('\r\n            Currently audo playback is only supported with a youtube video. Ethereal template has a widget dedicated to play youtube videos.\r\n          '),
			Y: 'Can I play audio with a menu?'
		},
			{
			_: $author$project$Pages$Faq$One('\r\n          This feature will be coming in future releases, please contact us for supporting custom images.\r\n          '),
			Y: 'Can I upload a custom image or logo of my school anywhere?'
		},
			{
			_: $author$project$Pages$Faq$One('\r\n            The Device will continue to display the current menu until the end of the menu cycle. During the next\r\n          menu cycle, the device will display an error message indicating the device is unable to communicate with server.\r\n          '),
			Y: 'What happens if the network goes down?'
		},
			{
			_: A2(
				$author$project$Pages$Faq$Steps,
				$elm$core$Maybe$Nothing,
				_List_fromArray(
					['Google Chrome (Latest)', 'Edge Browser (Latest)', 'Firefox (Latest)', 'Safari on iOs and MacOs (Latest)'])),
			Y: 'What are the supported browsers for the Admin Web application?'
		}
		]),
	d_: false,
	d7: $elm$core$Maybe$Nothing
};
var $author$project$Pages$Faqs$One = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Faqs$Steps = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Faqs$init = {
	f2: _List_fromArray(
		[
			{
			_: $author$project$Pages$Faqs$One('\r\n            There are two options available for use with SchoolCafe TV -\r\n            Chromebox and Chromebit'),
			Y: 'What are the devices available?'
		},
			{
			_: A2(
				$author$project$Pages$Faqs$Steps,
				$elm$core$Maybe$Just('Please follow the instructions below in testclassic'),
				_List_fromArray(
					['After unboxing, connect the device to a power source', 'Connect Chromebox to TV using HDMI cable', 'Power on the device, it will now check for network connection', 'If network connection fails, Use keyboard and mouse to configure network settings', 'After successful connection, the device will reboot and registration code will be displayed', 'Use the on screen instructions to register your device'])),
			Y: 'How do I setup a new device?'
		},
			{
			_: A2(
				$author$project$Pages$Faqs$Steps,
				$elm$core$Maybe$Just('Schoolcafe TV will communicate with following services'),
				_List_fromArray(
					['https://www.schoolcafe.tv', 'https://fabric.schoolcafe.tv', 'https://iili.io', 'https://www.youtube.com', 'https:/s.ytimg.com'])),
			Y: 'Do I have to change the firewall & Network Settings?'
		},
			{
			_: $author$project$Pages$Faqs$One('\r\n              Menu items can be updated from PrimeroEdge Menu Planning module. \r\n              After editing the menu items run the "Reload Menu" command on all online devices to display the edited items.\r\n            '),
			Y: 'How do I update the menu item displayed on TV ?'
		},
			{
			_: $author$project$Pages$Faqs$One('\r\n            To upload new menu items and pictures please use PrimeroEdge Menu Planning Module.\r\n            Schoolcafe TV will automatically pickup the changes during the next cycle.\r\n          '),
			Y: 'Where do we change or upload new menu item pictures?'
		},
			{
			_: $author$project$Pages$Faqs$One('\r\n          Each device has to be registered only once during the setup. Syncing between all the devices in the school or district is\r\n          possible using the "Sync" feature after device registration.\r\n          '),
			Y: 'Do I have to manually configure each device in my school (or even the whole district)?'
		},
			{
			_: $author$project$Pages$Faqs$One('\r\n            Currently audo playback is only supported with a youtube video. Ethereal template has a widget dedicated to play youtube videos.\r\n          '),
			Y: 'Can I play audio with a menu?'
		},
			{
			_: $author$project$Pages$Faqs$One('\r\n          This feature will be coming in future releases, please contact us for supporting custom images.\r\n          '),
			Y: 'Can I upload a custom image or logo of my school anywhere?'
		},
			{
			_: $author$project$Pages$Faqs$One('\r\n            The Device will continue to display the current menu until the end of the menu cycle. During the next\r\n          menu cycle, the device will display an error message indicating the device is unable to communicate with server.\r\n          '),
			Y: 'What happens if the network goes down?'
		},
			{
			_: A2(
				$author$project$Pages$Faqs$Steps,
				$elm$core$Maybe$Nothing,
				_List_fromArray(
					['Google Chrome (Latest)', 'Edge Browser (Latest)', 'Firefox (Latest)', 'Safari on iOs and MacOs (Latest)'])),
			Y: 'What are the supported browsers for the Admin Web application?'
		}
		]),
	d7: $elm$core$Maybe$Nothing
};
var $author$project$Pages$LinkNewDevice$InitialSetup = 0;
var $author$project$Entity$Device$UnknownState = {$: 4};
var $author$project$Entity$ServingLine$allLines = 'All lines';
var $author$project$Entity$ServingLine$allServingLinesOption = {k1: 10, g8: $author$project$Entity$ServingLine$allLines};
var $author$project$Pages$LinkNewDevice$initActivationCode = {bZ: $elm$core$Maybe$Nothing, b_: $elm$core$Maybe$Nothing, ck: $elm$core$Maybe$Nothing, cy: $elm$core$Maybe$Nothing};
var $author$project$Entity$MealType$Breakfast = 0;
var $author$project$Entity$Schedule$Defaults$breakfastEndTime = {c5: 10, dk: 0};
var $author$project$Entity$Schedule$Defaults$breakfastStartTime = {c5: 6, dk: 0};
var $author$project$Entity$Schedule$Defaults$initBreakfast = F2(
	function (servingLines, hiddenCategories) {
		return {
			e2: $author$project$Entity$Schedule$Defaults$breakfastEndTime,
			fi: true,
			fp: {i8: 0, jR: servingLines},
			g8: 'Breakfast',
			fI: $author$project$Entity$Schedule$Defaults$breakfastStartTime,
			fN: 'Sonorous'
		};
	});
var $author$project$Entity$MealType$Lunch = 1;
var $author$project$Entity$Schedule$Defaults$lunchEndTime = {c5: 18, dk: 0};
var $author$project$Entity$Schedule$Defaults$lunchStartTime = {c5: 10, dk: 0};
var $author$project$Entity$Schedule$Defaults$initLunch = F2(
	function (servingLines, hiddenCategories) {
		return {
			e2: $author$project$Entity$Schedule$Defaults$lunchEndTime,
			fi: true,
			fp: {i8: 1, jR: servingLines},
			g8: 'Lunch',
			fI: $author$project$Entity$Schedule$Defaults$lunchStartTime,
			fN: 'Singularity'
		};
	});
var $author$project$Entity$MealType$Supper = 2;
var $author$project$Entity$Schedule$Defaults$supperEndTime = {c5: 21, dk: 0};
var $author$project$Entity$Schedule$Defaults$supperStartTime = {c5: 18, dk: 0};
var $author$project$Entity$Schedule$Defaults$initSupper = F2(
	function (servingLines, hiddenCategories) {
		return {
			e2: $author$project$Entity$Schedule$Defaults$supperEndTime,
			fi: true,
			fp: {i8: 2, jR: servingLines},
			g8: 'Supper',
			fI: $author$project$Entity$Schedule$Defaults$supperStartTime,
			fN: 'Singularity'
		};
	});
var $author$project$Pages$LinkNewDevice$init = {
	u: $author$project$Pages$LinkNewDevice$initActivationCode,
	fY: $elm$core$Maybe$Nothing,
	bR: A2(
		$author$project$Entity$Schedule$Defaults$initBreakfast,
		_List_fromArray(
			[$author$project$Entity$ServingLine$allServingLinesOption.g8]),
		_List_Nil),
	eU: $author$project$DataState$Initial,
	w: 0,
	iB: $elm$core$Maybe$Nothing,
	aC: $elm$core$Maybe$Nothing,
	A: $author$project$Entity$Device$UnknownState,
	bs: _List_Nil,
	a3: _List_Nil,
	bt: _List_Nil,
	aH: false,
	b9: A2(
		$author$project$Entity$Schedule$Defaults$initLunch,
		_List_fromArray(
			[$author$project$Entity$ServingLine$allServingLinesOption.g8]),
		_List_Nil),
	en: true,
	du: $elm$core$Maybe$Nothing,
	r: $author$project$Select$init,
	jR: $author$project$DataState$Initial,
	cp: $aforemny$material_components_web_elm$Material$Snackbar$initialQueue,
	ct: A2(
		$author$project$Entity$Schedule$Defaults$initSupper,
		_List_fromArray(
			[$author$project$Entity$ServingLine$allServingLinesOption.g8]),
		_List_Nil)
};
var $author$project$Pages$MenuItemList$init = function (randomValue) {
	return {
		cE: false,
		bN: false,
		cS: false,
		cT: false,
		cX: false,
		cY: false,
		cZ: false,
		V: _Utils_Tuple2('', $elm$core$Maybe$Nothing),
		at: _Utils_Tuple2('0.00', $elm$core$Maybe$Nothing),
		E: _Utils_Tuple2('', $elm$core$Maybe$Nothing),
		g1: $author$project$DataState$Initial,
		jM: $elm$random$Random$initialSeed(randomValue),
		r: $author$project$Select$init,
		bF: $elm$core$Maybe$Nothing,
		B: $elm$core$Maybe$Nothing,
		fQ: $author$project$Reusable$Tooltip$init
	};
};
var $author$project$Pages$SyncDevices$init = {
	bk: _Utils_Tuple2(false, $elm$core$Maybe$Nothing),
	X: _List_Nil,
	ar: $elm$core$Maybe$Nothing,
	r: $author$project$Select$init,
	dw: $elm$core$Maybe$Nothing,
	ak: $elm$core$Dict$empty,
	bc: true,
	bd: true,
	be: true
};
var $author$project$Routing$LoginPage = {$: 0};
var $author$project$Routing$init = F2(
	function (url, key) {
		return {b4: key, dq: $author$project$Routing$LoginPage, nj: url};
	});
var $author$project$Routing$NotFoundPage = {$: 9};
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {b$: frag, ci: params, bL: unvisited, eL: value, cC: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.bL;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.eL);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.eL);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.jp),
					$elm$url$Url$Parser$prepareQuery(url.es),
					url.iL,
					$elm$core$Basics$identity)));
	});
var $author$project$Routing$ConfigureDevicePage = {$: 6};
var $author$project$Routing$ContactUsPage = {$: 7};
var $author$project$Routing$DashboardPage = {$: 2};
var $author$project$Routing$DontSkip = 1;
var $author$project$Routing$FaqPage = {$: 8};
var $author$project$Routing$LinkNewDevicePage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Routing$MenuItemListPage = {$: 4};
var $author$project$Routing$SkipFirstStep = 0;
var $author$project$Routing$SyncDevicesPage = {$: 5};
var $author$project$Routing$UserPage = {$: 1};
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.cC;
		var unvisited = _v0.bL;
		var params = _v0.ci;
		var frag = _v0.b$;
		var value = _v0.eL;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.cC;
			var unvisited = _v1.bL;
			var params = _v1.ci;
			var frag = _v1.b$;
			var value = _v1.eL;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.cC;
		var unvisited = _v0.bL;
		var params = _v0.ci;
		var frag = _v0.b$;
		var value = _v0.eL;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Routing$routeParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$Routing$LoginPage, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$LoginPage,
			$elm$url$Url$Parser$s('login')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$DashboardPage,
			$elm$url$Url$Parser$s('dashboard')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$ConfigureDevicePage,
			$elm$url$Url$Parser$s('device')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$LinkNewDevicePage(1),
			$elm$url$Url$Parser$s('new-device')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$LinkNewDevicePage(0),
			$elm$url$Url$Parser$s('activate')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$LinkNewDevicePage(0),
			$elm$url$Url$Parser$s('link')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$MenuItemListPage,
			$elm$url$Url$Parser$s('menu-items')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$SyncDevicesPage,
			$elm$url$Url$Parser$s('sync')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$UserPage,
			$elm$url$Url$Parser$s('user')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$ContactUsPage,
			$elm$url$Url$Parser$s('contact-us')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$FaqPage,
			$elm$url$Url$Parser$s('faq'))
		]));
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Routing$parseUrl = function (url) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Routing$NotFoundPage,
		A2($elm$url$Url$Parser$parse, $author$project$Routing$routeParser, url));
};
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$Routing$reversePage = function (route) {
	switch (route.$) {
		case 0:
			return '/';
		case 1:
			return '/user';
		case 2:
			return '/dashboard';
		case 6:
			return '/device';
		case 9:
			return '/404';
		case 3:
			var opt = route.a;
			if (!opt) {
				return '/activate';
			} else {
				return '/new-device';
			}
		case 5:
			return '/sync';
		case 4:
			return '/menu-items';
		case 7:
			return '/contact-us';
		default:
			return '/faq';
	}
};
var $author$project$Main$initModel = F3(
	function (flags, url, key) {
		var initViewport = A2(
			$elm$core$Maybe$withDefault,
			2,
			A2(
				$author$project$Main$getViewport,
				2,
				{
					gH: 0,
					hY: $elm$core$Basics$floor(flags.kf)
				}));
		return _Utils_Tuple2(
			{
				K: $author$project$Pages$CfgDevice$Core$init(flags.fe).a,
				dT: $author$project$Dialogs$ContactUs$init,
				aB: $author$project$Pages$Dashboard$init,
				aD: $author$project$FabricStatus$init,
				d5: $author$project$Pages$Faq$init,
				d6: $author$project$Pages$Faqs$init,
				k: flags,
				c3: $author$project$Dialogs$Gallery$init,
				as: initViewport === 2,
				b3: false,
				de: $author$project$Dialogs$LiveCapture$init,
				cb: $author$project$Pages$MenuItemList$init(flags.fe),
				ce: $author$project$Pages$LinkNewDevice$init,
				$7: false,
				ds: $author$project$Dialogs$ReleaseNotes$init,
				I: A2($author$project$Routing$init, url, key),
				aQ: $author$project$DataState$Initial,
				cp: $aforemny$material_components_web_elm$Material$Snackbar$initialQueue,
				cu: $author$project$Pages$SyncDevices$init,
				j7: $author$project$Pages$User$init,
				W: initViewport
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$browser$Browser$Navigation$pushUrl,
						key,
						$author$project$Routing$reversePage(
							$author$project$Routing$parseUrl(url))),
						A2($elm$core$Platform$Cmd$map, $author$project$Main$UserMsg, $author$project$Pages$User$getUserState),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Main$CfgDeviceMsg,
						$author$project$Pages$CfgDevice$Core$init(flags.fe).b)
					])));
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Main$FabricMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Main$GalleryMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Main$LinkNewDeviceMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Main$LiveCaptureMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Main$NoOp = {$: 0};
var $author$project$Main$ReleaseNotesMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Main$SyncDevicesMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Main$UpdateViewport = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $author$project$Main$Toast = function (a) {
	return {$: 23, a: a};
};
var $author$project$Main$ToggleSidebar = {$: 5};
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$Main$browserDecoder = F2(
	function (model, event) {
		switch (event) {
			case 'OPEN_SIDEBAR':
				return model.b3 ? $elm$json$Json$Decode$fail('already open') : $elm$json$Json$Decode$succeed($author$project$Main$ToggleSidebar);
			case 'CLOSE_SIDEBAR':
				return model.b3 ? $elm$json$Json$Decode$succeed($author$project$Main$ToggleSidebar) : $elm$json$Json$Decode$fail('already closed');
			case 'SHOW_GLOBAL_TOAST':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Main$Toast,
					A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
			default:
				return $elm$json$Json$Decode$fail('');
		}
	});
var $author$project$Pages$User$getAccessToken = function (model) {
	var _v0 = model.eK;
	if (_v0.$ === 4) {
		var user = _v0.a;
		return $elm$core$Maybe$Just(user.h5);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $elm$browser$Browser$Events$Window = 1;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {js: pids, jX: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {iF: event, b4: key};
	});
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.js,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.b4;
		var event = _v0.iF;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.jX);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onResize = function (func) {
	return A3(
		$elm$browser$Browser$Events$on,
		1,
		'resize',
		A2(
			$elm$json$Json$Decode$field,
			'target',
			A3(
				$elm$json$Json$Decode$map2,
				func,
				A2($elm$json$Json$Decode$field, 'innerWidth', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'innerHeight', $elm$json$Json$Decode$int))));
};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $author$project$Interop$Browser$fromBrowser = _Platform_incomingPort('fromBrowser', $elm$json$Json$Decode$value);
var $author$project$Interop$Browser$subscribe = F2(
	function (msgDecoder, whenFail) {
		return $author$project$Interop$Browser$fromBrowser(
			A2(
				$elm$core$Basics$composeR,
				$elm$json$Json$Decode$decodeValue(
					A2(
						$elm$json$Json$Decode$andThen,
						msgDecoder,
						A2($elm$json$Json$Decode$field, 'event', $elm$json$Json$Decode$string))),
				whenFail));
	});
var $author$project$Dialogs$Gallery$NoOp = {$: 0};
var $author$project$Dialogs$Gallery$CopiedUrl = function (a) {
	return {$: 11, a: a};
};
var $author$project$Dialogs$Gallery$OpenDialog = {$: 1};
var $author$project$Dialogs$Gallery$UploadImageFail = function (a) {
	return {$: 4, a: a};
};
var $author$project$Dialogs$Gallery$UploadImageSuccess = function (a) {
	return {$: 5, a: a};
};
var $author$project$Dialogs$Gallery$browserDecoder = F2(
	function (model, event) {
		switch (event) {
			case 'OPEN_MEDIA_LIBRARY':
				return (!model.bX) ? $elm$json$Json$Decode$succeed($author$project$Dialogs$Gallery$OpenDialog) : $elm$json$Json$Decode$succeed($author$project$Dialogs$Gallery$NoOp);
			case 'IMAGE_UPLOAD_FAIL':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Dialogs$Gallery$UploadImageFail,
					A2($elm$json$Json$Decode$field, 'msg', $elm$json$Json$Decode$string));
			case 'IMAGE_UPLOAD_SUCCESS':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Dialogs$Gallery$UploadImageSuccess,
					A2($elm$json$Json$Decode$field, 'msg', $elm$json$Json$Decode$string));
			case 'IMAGE_URL_COPIED':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Dialogs$Gallery$CopiedUrl,
					A2($elm$json$Json$Decode$field, 'payload', $elm$json$Json$Decode$string));
			default:
				return $elm$json$Json$Decode$fail('');
		}
	});
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Dialogs$Gallery$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$author$project$Interop$Browser$subscribe,
				$author$project$Dialogs$Gallery$browserDecoder(model),
				$elm$core$Result$withDefault($author$project$Dialogs$Gallery$NoOp))
			]));
};
var $author$project$Dialogs$LiveCapture$NoOp = {$: 0};
var $author$project$Dialogs$LiveCapture$RecvScreenshot = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $author$project$Interop$Fabric$dataDecoder = function (a) {
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['payload', '@@data']),
		a);
};
var $author$project$Interop$Fabric$replyIdDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['payload', '@@replyId']),
	$elm$json$Json$Decode$string);
var $author$project$Dialogs$LiveCapture$fabricDecoder = function (event) {
	if (event === 'RESP_SCREENSHOT') {
		return A3(
			$elm$json$Json$Decode$map2,
			$author$project$Dialogs$LiveCapture$RecvScreenshot,
			$author$project$Interop$Fabric$dataDecoder($elm$json$Json$Decode$string),
			$author$project$Interop$Fabric$replyIdDecoder);
	} else {
		return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$Interop$Fabric$fromFabric = _Platform_incomingPort('fromFabric', $elm$json$Json$Decode$value);
var $author$project$Interop$Fabric$subscribe = F2(
	function (msgDecoder, whenFail) {
		return $author$project$Interop$Fabric$fromFabric(
			A2(
				$elm$core$Basics$composeR,
				$elm$json$Json$Decode$decodeValue(
					A2(
						$elm$json$Json$Decode$andThen,
						msgDecoder,
						A2($elm$json$Json$Decode$field, 'event', $elm$json$Json$Decode$string))),
				whenFail));
	});
var $author$project$Dialogs$LiveCapture$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$author$project$Interop$Fabric$subscribe,
				$author$project$Dialogs$LiveCapture$fabricDecoder,
				$elm$core$Result$withDefault($author$project$Dialogs$LiveCapture$NoOp))
			]));
};
var $author$project$Dialogs$ReleaseNotes$NoOp = {$: 0};
var $author$project$Dialogs$ReleaseNotes$StoredVersion = function (a) {
	return {$: 3, a: a};
};
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$Dialogs$ReleaseNotes$browserDecoder = function (eventName) {
	if (eventName === 'RESP_STORED_VERSION') {
		return A2(
			$elm$json$Json$Decode$map,
			$author$project$Dialogs$ReleaseNotes$StoredVersion,
			A2(
				$elm$json$Json$Decode$field,
				'version',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)));
	} else {
		return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$Dialogs$ReleaseNotes$subscriptions = function (model) {
	return A2(
		$author$project$Interop$Browser$subscribe,
		$author$project$Dialogs$ReleaseNotes$browserDecoder,
		$elm$core$Result$withDefault($author$project$Dialogs$ReleaseNotes$NoOp));
};
var $author$project$FabricStatus$NoOp = {$: 0};
var $author$project$FabricStatus$Connected = 0;
var $author$project$FabricStatus$Reconnecting = 2;
var $author$project$FabricStatus$ServerState = function (a) {
	return {$: 1, a: a};
};
var $author$project$FabricStatus$msgDecoder = function (str) {
	switch (str) {
		case 'connect':
			return $elm$json$Json$Decode$succeed(
				$author$project$FabricStatus$ServerState(0));
		case 'reconnecting':
			return $elm$json$Json$Decode$succeed(
				$author$project$FabricStatus$ServerState(2));
		case 'disconnect':
			return $elm$json$Json$Decode$succeed(
				$author$project$FabricStatus$ServerState(1));
		default:
			return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$FabricStatus$subscriptions = function (_v0) {
	return A2(
		$author$project$Interop$Fabric$subscribe,
		$author$project$FabricStatus$msgDecoder,
		$elm$core$Result$withDefault($author$project$FabricStatus$NoOp));
};
var $author$project$Pages$CfgDevice$Core$DesignTabMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$CfgDevice$Core$NoOp = {$: 0};
var $author$project$Pages$CfgDevice$Core$RefreshNowPlaying = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$CfgDevice$Core$ScheduleTabMsg = function (a) {
	return {$: 8, a: a};
};
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {jx: processes, jY: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.jx;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.jY);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $author$project$Pages$CfgDevice$Core$DeviceInfo = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$CfgDevice$Core$DeviceOffline = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Core$DeviceOnline = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Core$RespCurrSchedule = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$CfgDevice$Core$SocketIoDisconnect = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$CfgDevice$Core$SocketIoReconnect = function (a) {
	return {$: 16, a: a};
};
var $author$project$Entity$School$School = F2(
	function (id, name) {
		return {aF: id, g8: name};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Entity$School$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'schoolName',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'schoolId',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Entity$School$School)));
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Interop$Fabric$mapPayload2 = F3(
	function (func, d1, d2) {
		return A3(
			$elm$json$Json$Decode$map2,
			func,
			A2($elm$json$Json$Decode$field, 'payload', d1),
			A2($elm$json$Json$Decode$field, 'payload', d2));
	});
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Pages$CfgDevice$Core$fabricDecoder = F2(
	function (model, event) {
		switch (event) {
			case 'DEVICE_OFFLINE':
				return A3(
					$elm$json$Json$Decode$map2,
					$author$project$Pages$CfgDevice$Core$DeviceOffline,
					A2($elm$json$Json$Decode$field, 'payload', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$succeed(true));
			case 'DEVICE_ONLINE':
				return A3(
					$author$project$Interop$Fabric$mapPayload2,
					$author$project$Pages$CfgDevice$Core$DeviceOnline,
					A2($elm$json$Json$Decode$field, 'deviceId', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'deviceSocketId', $elm$json$Json$Decode$string));
			case 'RESP_ADMIN_CONNECT':
				return A3(
					$author$project$Interop$Fabric$mapPayload2,
					$author$project$Pages$CfgDevice$Core$DeviceOnline,
					A2($elm$json$Json$Decode$field, 'deviceId', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'deviceSocketId', $elm$json$Json$Decode$string));
			case 'ADMIN_CONNECT_FAIL':
				return A3(
					$elm$json$Json$Decode$map2,
					$author$project$Pages$CfgDevice$Core$DeviceOffline,
					A2($elm$json$Json$Decode$field, 'deviceId', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$succeed(true));
			case 'RESP_DEVICE_INFO':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Pages$CfgDevice$Core$DeviceInfo,
					$author$project$Interop$Fabric$dataDecoder(
						A4(
							$elm$json$Json$Decode$map3,
							F3(
								function (a, b, c) {
									return _Utils_Tuple3(a, b, c);
								}),
							A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$field, 'school', $author$project$Entity$School$decoder))));
			case 'RESP_CURR_SCHEDULE':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Pages$CfgDevice$Core$RespCurrSchedule,
					$author$project$Interop$Fabric$dataDecoder(
						A3(
							$elm$json$Json$Decode$map2,
							F2(
								function (a, b) {
									return _Utils_Tuple2(a, b);
								}),
							A2($elm$json$Json$Decode$field, 'deviceId', $elm$json$Json$Decode$string),
							A2(
								$elm$json$Json$Decode$field,
								'nowPlaying',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)))));
			case 'disconnect':
				var _v1 = model.ao;
				if (_v1.$ === 4) {
					var dict = _v1.a;
					return $elm$json$Json$Decode$succeed(
						$author$project$Pages$CfgDevice$Core$SocketIoDisconnect(
							$elm$core$Dict$values(dict)));
				} else {
					return $elm$json$Json$Decode$fail('No devices');
				}
			case 'reconnect':
				var _v2 = model.ao;
				if (_v2.$ === 4) {
					var dict = _v2.a;
					return $elm$json$Json$Decode$succeed(
						$author$project$Pages$CfgDevice$Core$SocketIoReconnect(
							$elm$core$Dict$values(dict)));
				} else {
					return $elm$json$Json$Decode$fail('');
				}
			default:
				return $elm$json$Json$Decode$fail('');
		}
	});
var $author$project$Pages$CfgDevice$Design$Animate = function (a) {
	return {$: 102, a: a};
};
var $author$project$Pages$CfgDevice$Design$NoOp = {$: 0};
var $author$project$Pages$CfgDevice$Design$ImageUrlCopied = F3(
	function (a, b, c) {
		return {$: 111, a: a, b: b, c: c};
	});
var $author$project$Pages$CfgDevice$Design$YoutubePlaylistId = F2(
	function (a, b) {
		return {$: 62, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Design$YoutubeVideoId = F2(
	function (a, b) {
		return {$: 61, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Design$browserDecoder = F2(
	function (model, event) {
		switch (event) {
			case 'YOUTUBE_VIDEO_ID_SUCCESS':
				return A3(
					$elm$json$Json$Decode$map2,
					$author$project$Pages$CfgDevice$Design$YoutubeVideoId,
					A2($elm$json$Json$Decode$field, 'widgetId', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'videoId', $elm$json$Json$Decode$string));
			case 'YOUTUBE_PLAYLIST_SUCCESS':
				return A3(
					$elm$json$Json$Decode$map2,
					$author$project$Pages$CfgDevice$Design$YoutubePlaylistId,
					A2($elm$json$Json$Decode$field, 'widgetId', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'playlistId', $elm$json$Json$Decode$string));
			case 'IMAGE_URL_COPIED':
				var _v1 = _Utils_Tuple2(model.a, model.h);
				if ((_v1.a.$ === 4) && (!_v1.b.$)) {
					var template = _v1.a.a;
					var widgetPos = _v1.b.a;
					return A2(
						$elm$json$Json$Decode$map,
						A2($author$project$Pages$CfgDevice$Design$ImageUrlCopied, template, widgetPos),
						A2($elm$json$Json$Decode$field, 'payload', $elm$json$Json$Decode$string));
				} else {
					return $elm$json$Json$Decode$fail('');
				}
			default:
				return $elm$json$Json$Decode$fail('');
		}
	});
var $author$project$Pages$CfgDevice$Design$PublishTemplateSuccess = {$: 65};
var $author$project$Pages$CfgDevice$Design$RespTemplate = function (a) {
	return {$: 67, a: a};
};
var $author$project$Pages$CfgDevice$Design$RespTemplates = function (a) {
	return {$: 66, a: a};
};
var $author$project$Template$Core$MinimalTemplate = F2(
	function (name, tags) {
		return {g8: name, aX: tags};
	});
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Template$Core$decodeMinimal = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'tags',
	A2(
		$elm$json$Json$Decode$andThen,
		A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $elm$core$Set$fromList),
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Template$Core$MinimalTemplate)));
var $author$project$Template$Core$Template = F9(
	function (name, tags, createdBy, createdOn, frames, widgets, styles, liveEdit, partiallyFill) {
		return {k2: createdBy, iw: createdOn, G: frames, eh: liveEdit, g8: name, ho: partiallyFill, z: styles, aX: tags, n: widgets};
	});
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {iv: col, k0: contextStack, jv: problem, jI: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.jI, s.iv, x, s.l));
	});
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.b),
			s.c) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.b);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.c, offset) < 0,
					0,
					{iv: col, l: s0.l, o: s0.o, c: offset, jI: row, b: s0.b});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.c, s.jI, s.iv, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.c, s1.c, s0.b),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$core$Basics$round = _Basics_round;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$core$String$toFloat = _String_toFloat;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$append = _String_append;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.c, s.b);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{iv: 1, l: s.l, o: s.o, c: s.c + 1, jI: s.jI + 1, b: s.b}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{iv: s.iv + 1, l: s.l, o: s.o, c: newOffset, jI: s.jI, b: s.b}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$core$Basics$not = _Basics_not;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.c, s.jI, s.iv, s.b);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{iv: newCol, l: s.l, o: s.o, c: newOffset, jI: newRow, b: s.b});
	};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {iv: col, jv: problem, jI: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.jI, p.iv, p.jv);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{iv: 1, l: _List_Nil, o: 1, c: 0, jI: 1, b: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Utils$dateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(str);
		if (_v0.$ === 1) {
			var err = _v0.a;
			return $elm$json$Json$Decode$fail('Failed to decode date');
		} else {
			var time = _v0.a;
			return $elm$json$Json$Decode$succeed(
				A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, time));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Entity$Style$Css = F3(
	function (enableTextStyle, enableSize, css) {
		return {a$: css, d1: enableSize, d2: enableTextStyle};
	});
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Entity$Style$decodeCss = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'css',
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'enableSize',
		$elm$json$Json$Decode$bool,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'enableTextStyle',
			$elm$json$Json$Decode$bool,
			false,
			$elm$json$Json$Decode$succeed($author$project$Entity$Style$Css))));
var $author$project$Entity$Style$decodeSharedStyles = $elm$json$Json$Decode$dict($author$project$Entity$Style$decodeCss);
var $author$project$Template$Frame$Frame = F5(
	function (layout, interval, orientation, gradientBg, background) {
		return {f6: background, ag: gradientBg, lH: interval, da: layout, fz: orientation};
	});
var $author$project$Template$Widget$Background$BgColor = function (a) {
	return {$: 0, a: a};
};
var $author$project$Template$Widget$Background$bgColor = function (value) {
	return $author$project$Template$Widget$Background$BgColor(value);
};
var $author$project$Template$Frame$Column = F2(
	function (rows, flexGrow) {
		return {ae: flexGrow, jJ: rows};
	});
var $author$project$Template$Widget$Core$BoundedWidget = function (a) {
	return {$: 0, a: a};
};
var $author$project$Template$Widget$Core$EmptySection = {$: 2};
var $author$project$Template$Widget$Core$SharedWidget = function (a) {
	return {$: 1, a: a};
};
var $author$project$Template$Widget$Core$decodeSection = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			function (a) {
				if (!a.$) {
					var id = a.a;
					return $elm$json$Json$Decode$succeed(
						$author$project$Template$Widget$Core$BoundedWidget(id));
				} else {
					return $elm$json$Json$Decode$succeed($author$project$Template$Widget$Core$EmptySection);
				}
			},
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
			A2(
			$elm$json$Json$Decode$andThen,
			function (sec) {
				switch (sec) {
					case 'bounded':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$Template$Widget$Core$BoundedWidget,
							A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
					case 'shared':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$Template$Widget$Core$SharedWidget,
							A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
					case 'empty':
						return $elm$json$Json$Decode$succeed($author$project$Template$Widget$Core$EmptySection);
					default:
						return $elm$json$Json$Decode$fail('Unknown section');
				}
			},
			A2($elm$json$Json$Decode$field, 'section', $elm$json$Json$Decode$string))
		]));
var $author$project$Template$Frame$decodeColumn = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A3(
			$elm$json$Json$Decode$map2,
			$author$project$Template$Frame$Column,
			A2(
				$elm$json$Json$Decode$field,
				'rows',
				$elm$json$Json$Decode$list($author$project$Template$Widget$Core$decodeSection)),
			A2($elm$json$Json$Decode$field, 'flexGrow', $elm$json$Json$Decode$int)),
			A2(
			$elm$json$Json$Decode$andThen,
			function (rows) {
				return $elm$json$Json$Decode$succeed(
					{ae: 1, jJ: rows});
			},
			$elm$json$Json$Decode$list($author$project$Template$Widget$Core$decodeSection))
		]));
var $author$project$Template$Frame$Orientation$Horizontal = 0;
var $author$project$Template$Frame$Orientation$Vertical = 1;
var $author$project$Template$Frame$Orientation$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'horizontal':
				return $elm$json$Json$Decode$succeed(0);
			case 'vertical':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Not an orientation');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Template$Widget$Background$BgImage = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Template$Widget$Background$BgLocalImage = F4(
	function (a, b, c, d) {
		return {$: 2, a: a, b: b, c: c, d: d};
	});
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$Template$Widget$Background$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (bgType) {
		switch (bgType) {
			case 'color':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Template$Widget$Background$BgColor,
					A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$string));
			case 'image':
				return A4(
					$elm$json$Json$Decode$map3,
					$author$project$Template$Widget$Background$BgImage,
					A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'brightness', $elm$json$Json$Decode$float),
					A2($elm$json$Json$Decode$field, 'blur', $elm$json$Json$Decode$float));
			case 'local-image':
				return A5(
					$elm$json$Json$Decode$map4,
					$author$project$Template$Widget$Background$BgLocalImage,
					A2($elm$json$Json$Decode$field, 'adminUrl', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'localUrl', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'brightness', $elm$json$Json$Decode$float),
					A2($elm$json$Json$Decode$field, 'blur', $elm$json$Json$Decode$float));
			default:
				return $elm$json$Json$Decode$fail('Unknown Background');
		}
	},
	A2($elm$json$Json$Decode$field, 'bgType', $elm$json$Json$Decode$string));
var $author$project$Template$Frame$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'background',
	$author$project$Template$Widget$Background$decoder,
	$author$project$Template$Widget$Background$bgColor('#000000'),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'gradientBg',
		$elm$json$Json$Decode$bool,
		false,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'orientation',
			$author$project$Template$Frame$Orientation$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'interval',
				$elm$json$Json$Decode$float,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'layout',
					$elm$json$Json$Decode$list($author$project$Template$Frame$decodeColumn),
					$elm$json$Json$Decode$succeed($author$project$Template$Frame$Frame))))));
var $author$project$Template$Widget$Core$Empty = {$: 0};
var $author$project$Template$Widget$Core$Image = function (a) {
	return {$: 2, a: a};
};
var $author$project$Template$Widget$Core$MenuItemListWidget = function (a) {
	return {$: 5, a: a};
};
var $author$project$Template$Widget$Core$MenuPlanning = function (a) {
	return {$: 4, a: a};
};
var $author$project$Template$Widget$Core$TextBox = function (a) {
	return {$: 1, a: a};
};
var $author$project$Template$Widget$Core$Youtube = function (a) {
	return {$: 3, a: a};
};
var $author$project$Template$Widget$Image$Config = F4(
	function (anim, imageUrl, style, size) {
		return {bf: anim, ly: imageUrl, dB: size, cs: style};
	});
var $author$project$Entity$Style$BoundedStyle = function (a) {
	return {$: 1, a: a};
};
var $author$project$Entity$Style$bounded = function (css) {
	return $author$project$Entity$Style$BoundedStyle(css);
};
var $author$project$Entity$Style$SharedStyle = function (a) {
	return {$: 0, a: a};
};
var $author$project$Entity$Style$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (style) {
		switch (style) {
			case 'bounded':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Entity$Style$BoundedStyle,
					A2($elm$json$Json$Decode$field, 'value', $author$project$Entity$Style$decodeCss));
			case 'shared':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Entity$Style$SharedStyle,
					A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$string));
			default:
				return $elm$json$Json$Decode$fail('not a valid key');
		}
	},
	A2($elm$json$Json$Decode$field, 'style', $elm$json$Json$Decode$string));
var $author$project$Template$Animation$Appear = 0;
var $author$project$Template$Animation$FadeBottom = 5;
var $author$project$Template$Animation$FadeIn = 1;
var $author$project$Template$Animation$FadeLeft = 3;
var $author$project$Template$Animation$FadeRight = 4;
var $author$project$Template$Animation$FadeTop = 2;
var $author$project$Template$Animation$FlipHorizontal = 7;
var $author$project$Template$Animation$FlipVertical = 6;
var $author$project$Template$Animation$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (effect) {
		switch (effect) {
			case 'appear':
				return $elm$json$Json$Decode$succeed(0);
			case 'fade-in':
				return $elm$json$Json$Decode$succeed(1);
			case 'fade-top':
				return $elm$json$Json$Decode$succeed(2);
			case 'fade-bottom':
				return $elm$json$Json$Decode$succeed(5);
			case 'fade-right':
				return $elm$json$Json$Decode$succeed(4);
			case 'flip-horizontal':
				return $elm$json$Json$Decode$succeed(7);
			case 'flip-vertical':
				return $elm$json$Json$Decode$succeed(6);
			case 'fade-left':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Invalid Effect');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Template$Animation$fadeIn = 1;
var $author$project$Template$Widget$Image$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'size',
	$elm$json$Json$Decode$string,
	'contain',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'style',
		$author$project$Entity$Style$decoder,
		$author$project$Entity$Style$bounded(
			{a$: $elm$core$Dict$empty, d1: true, d2: false}),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'imageUrl',
			$elm$json$Json$Decode$string,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'anim',
				$author$project$Template$Animation$decoder,
				$author$project$Template$Animation$fadeIn,
				$elm$json$Json$Decode$succeed($author$project$Template$Widget$Image$Config)))));
var $author$project$Template$Widget$MenuItemList$Config = F6(
	function (anim, listId, listName, title, description, pricing) {
		return {bf: anim, k9: description, i7: listId, E: listName, hw: pricing, na: title};
	});
var $author$project$Template$Widget$MenuItemList$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'pricing',
	$author$project$Entity$Style$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$author$project$Entity$Style$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'title',
			$author$project$Entity$Style$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'listName',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'listId',
					$elm$json$Json$Decode$string,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'anim',
						$author$project$Template$Animation$decoder,
						$author$project$Template$Animation$fadeIn,
						$elm$json$Json$Decode$succeed($author$project$Template$Widget$MenuItemList$Config)))))));
var $author$project$Template$Widget$MenuPlanning$Big = 1;
var $author$project$Template$Widget$MenuPlanning$Compact = 3;
var $author$project$Template$Widget$MenuPlanning$Config = function (servingLine) {
	return function (category) {
		return function (marketingName) {
			return function (maxItems) {
				return function (menuItems) {
					return function (anim) {
						return function (scaleFactor) {
							return function (layout) {
								return function (title) {
									return function (location) {
										return function (image) {
											return function (description) {
												return function (calories) {
													return function (ratings) {
														return function (foodComponents) {
															return function (cardSize) {
																return {bf: anim, kR: calories, ip: cardSize, iq: category, k9: description, gA: foodComponents, gL: image, da: layout, gY: location, ai: marketingName, ej: maxItems, aj: menuItems, mf: ratings, hD: scaleFactor, mz: servingLine, na: title};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Template$Widget$MenuPlanning$OverlayImage = 0;
var $author$project$Template$Widget$MenuPlanning$Small = 2;
var $author$project$Template$Widget$MenuPlanning$categoryDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'category',
			A2(
				$elm$json$Json$Decode$andThen,
				A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $elm$core$Maybe$Just),
				$elm$json$Json$Decode$string)),
			A2(
			$elm$json$Json$Decode$field,
			'category',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string))
		]));
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $author$project$Template$Widget$MenuPlanning$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'cardSize',
	A2(
		$elm$json$Json$Decode$andThen,
		function (size) {
			switch (size) {
				case 'overlay-image':
					return $elm$json$Json$Decode$succeed(0);
				case 'big':
					return $elm$json$Json$Decode$succeed(1);
				case 'small':
					return $elm$json$Json$Decode$succeed(2);
				case 'compact':
					return $elm$json$Json$Decode$succeed(3);
				default:
					return $elm$json$Json$Decode$fail('');
			}
		},
		$elm$json$Json$Decode$string),
	2,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'foodComponents',
		$author$project$Entity$Style$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'ratings',
			$author$project$Entity$Style$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'calories',
				$author$project$Entity$Style$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'description',
					$author$project$Entity$Style$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'image',
						$author$project$Entity$Style$decoder,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'location',
							$author$project$Entity$Style$decoder,
							$author$project$Entity$Style$bounded(
								{
									a$: $elm$core$Dict$fromList(
										_List_fromArray(
											[
												_Utils_Tuple2('display', 'initial')
											])),
									d1: false,
									d2: true
								}),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'title',
								$author$project$Entity$Style$decoder,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'layout',
									$author$project$Entity$Style$decoder,
									$author$project$Entity$Style$bounded(
										{
											a$: $elm$core$Dict$fromList(
												_List_fromArray(
													[
														_Utils_Tuple2('visibility', 'visible'),
														_Utils_Tuple2('width', '98%'),
														_Utils_Tuple2('height', '100%')
													])),
											d1: true,
											d2: false
										}),
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'scaleFactor',
										$elm$json$Json$Decode$float,
										1,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'anim',
											$author$project$Template$Animation$decoder,
											A2(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
												_List_Nil,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'maxItems',
													$elm$json$Json$Decode$int,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'marketingName',
														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
														$elm$core$Maybe$Nothing,
														A2(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
															$author$project$Template$Widget$MenuPlanning$categoryDecoder,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'servingLine',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																$elm$core$Maybe$Nothing,
																$elm$json$Json$Decode$succeed($author$project$Template$Widget$MenuPlanning$Config)))))))))))))))));
var $author$project$Template$Widget$TextBox$Config = F4(
	function (style, size, anim, text) {
		return {bf: anim, dB: size, cs: style, hO: text};
	});
var $author$project$Entity$Style$EnableSize = 1;
var $author$project$Entity$Style$elSize = 1;
var $author$project$Entity$Style$EnableTextStyle = 0;
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Entity$Style$initBounded = F2(
	function (attrs, css) {
		return $author$project$Entity$Style$BoundedStyle(
			{
				a$: $elm$core$Dict$fromList(css),
				d1: A2($elm$core$List$member, 1, attrs),
				d2: A2($elm$core$List$member, 0, attrs)
			});
	});
var $author$project$Template$Widget$TextBox$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'text',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'anim',
		$author$project$Template$Animation$decoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'size',
			$author$project$Entity$Style$decoder,
			A2(
				$author$project$Entity$Style$initBounded,
				_List_fromArray(
					[$author$project$Entity$Style$elSize]),
				_List_fromArray(
					[
						_Utils_Tuple2('width', '98%'),
						_Utils_Tuple2('height', '22%')
					])),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'style',
				$author$project$Entity$Style$decoder,
				$elm$json$Json$Decode$succeed($author$project$Template$Widget$TextBox$Config)))));
var $author$project$Template$Widget$Youtube$Config = F3(
	function (video, width, height) {
		return {gH: height, ka: video, hY: width};
	});
var $author$project$Template$Widget$Youtube$Playlist = function (a) {
	return {$: 1, a: a};
};
var $author$project$Template$Widget$Youtube$Video = function (a) {
	return {$: 0, a: a};
};
var $author$project$Template$Widget$Youtube$video = function (id) {
	return {
		gH: 467,
		ka: $author$project$Template$Widget$Youtube$Video(id),
		hY: 830
	};
};
var $author$project$Template$Widget$Youtube$decoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Template$Widget$Youtube$video),
			A2($elm$json$Json$Decode$field, 'videoId', $elm$json$Json$Decode$string)),
			A2(
			$elm$json$Json$Decode$andThen,
			function (type_) {
				switch (type_) {
					case 'video':
						return A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'height',
							$elm$json$Json$Decode$float,
							467,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'width',
								$elm$json$Json$Decode$float,
								830,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									A2($elm$json$Json$Decode$map, $author$project$Template$Widget$Youtube$Video, $elm$json$Json$Decode$string),
									$elm$json$Json$Decode$succeed($author$project$Template$Widget$Youtube$Config))));
					case 'playlist':
						return A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'height',
							$elm$json$Json$Decode$float,
							467,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'width',
								$elm$json$Json$Decode$float,
								830,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									A2($elm$json$Json$Decode$map, $author$project$Template$Widget$Youtube$Playlist, $elm$json$Json$Decode$string),
									$elm$json$Json$Decode$succeed($author$project$Template$Widget$Youtube$Config))));
					default:
						return $elm$json$Json$Decode$fail('Unknown video type');
				}
			},
			A2($elm$json$Json$Decode$field, 'videoType', $elm$json$Json$Decode$string))
		]));
var $author$project$Template$Widget$Core$decodeWidget = function (widget) {
	switch (widget) {
		case 'empty':
			return $elm$json$Json$Decode$succeed($author$project$Template$Widget$Core$Empty);
		case 'text-box':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Template$Widget$Core$TextBox,
				A2($elm$json$Json$Decode$field, 'config', $author$project$Template$Widget$TextBox$decoder));
		case 'image':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Template$Widget$Core$Image,
				A2($elm$json$Json$Decode$field, 'config', $author$project$Template$Widget$Image$decoder));
		case 'youtube':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Template$Widget$Core$Youtube,
				A2($elm$json$Json$Decode$field, 'config', $author$project$Template$Widget$Youtube$decoder));
		case 'menu-planning':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Template$Widget$Core$MenuPlanning,
				A2($elm$json$Json$Decode$field, 'config', $author$project$Template$Widget$MenuPlanning$decoder));
		case 'menu-item-list':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Template$Widget$Core$MenuItemListWidget,
				A2($elm$json$Json$Decode$field, 'config', $author$project$Template$Widget$MenuItemList$decoder));
		default:
			return $elm$json$Json$Decode$fail('Not a widget');
	}
};
var $author$project$Template$Widget$Core$decoder = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Template$Widget$Core$decodeWidget,
	A2($elm$json$Json$Decode$field, 'widget', $elm$json$Json$Decode$string));
var $author$project$Template$Core$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'partiallyFill',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'liveEdit',
		$elm$json$Json$Decode$bool,
		false,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'styles',
			$author$project$Entity$Style$decodeSharedStyles,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'widgets',
				$elm$json$Json$Decode$dict($author$project$Template$Widget$Core$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'frames',
					$elm$json$Json$Decode$list($author$project$Template$Frame$decoder),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'createdOn',
						$author$project$Utils$dateDecoder,
						A3($justinmimbs$date$Date$fromCalendarDate, 2000, 0, 1),
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'createdBy',
							$elm$json$Json$Decode$string,
							'Unknown',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'tags',
								A2(
									$elm$json$Json$Decode$andThen,
									A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $elm$core$Set$fromList),
									$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
								$elm$core$Set$empty,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'name',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Template$Core$Template))))))))));
var $author$project$Pages$CfgDevice$Design$fabricDecoder = function (event) {
	switch (event) {
		case 'RESP_AVAILABLE_TEMPLATES':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Pages$CfgDevice$Design$RespTemplates,
				$author$project$Interop$Fabric$dataDecoder(
					$elm$json$Json$Decode$list($author$project$Template$Core$decodeMinimal)));
		case 'RESP_TEMPLATE':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Pages$CfgDevice$Design$RespTemplate,
				$author$project$Interop$Fabric$dataDecoder($author$project$Template$Core$decoder));
		case 'PUBLISH_TEMPLATE_SUCCESS':
			return $elm$json$Json$Decode$succeed($author$project$Pages$CfgDevice$Design$PublishTemplateSuccess);
		default:
			return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$Pages$CfgDevice$Design$UploadImageFail = function (a) {
	return {$: 117, a: a};
};
var $author$project$Pages$CfgDevice$Design$UploadImageSuccess = function (a) {
	return {$: 118, a: a};
};
var $author$project$Pages$CfgDevice$Design$imageUploadBrowserDecoder = F2(
	function (model, event) {
		switch (event) {
			case 'IMAGE_UPLOAD_FAIL':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Pages$CfgDevice$Design$UploadImageFail,
					A2($elm$json$Json$Decode$field, 'msg', $elm$json$Json$Decode$string));
			case 'IMAGE_UPLOAD_SUCCESS':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Pages$CfgDevice$Design$UploadImageSuccess,
					A2($elm$json$Json$Decode$field, 'msg', $elm$json$Json$Decode$string));
			default:
				return $elm$json$Json$Decode$fail('');
		}
	});
var $mdgriffith$elm_style_animation$Animation$Model$Tick = $elm$core$Basics$identity;
var $mdgriffith$elm_style_animation$Animation$isRunning = function (_v0) {
	var model = _v0;
	return model.fF;
};
var $elm$browser$Browser$AnimationManager$Time = function (a) {
	return {$: 0, a: a};
};
var $elm$browser$Browser$AnimationManager$State = F3(
	function (subs, request, oldTime) {
		return {hb: oldTime, jE: request, jX: subs};
	});
var $elm$browser$Browser$AnimationManager$init = $elm$core$Task$succeed(
	A3($elm$browser$Browser$AnimationManager$State, _List_Nil, $elm$core$Maybe$Nothing, 0));
var $elm$browser$Browser$AnimationManager$now = _Browser_now(0);
var $elm$browser$Browser$AnimationManager$rAF = _Browser_rAF(0);
var $elm$browser$Browser$AnimationManager$onEffects = F3(
	function (router, subs, _v0) {
		var request = _v0.jE;
		var oldTime = _v0.hb;
		var _v1 = _Utils_Tuple2(request, subs);
		if (_v1.a.$ === 1) {
			if (!_v1.b.b) {
				var _v2 = _v1.a;
				return $elm$browser$Browser$AnimationManager$init;
			} else {
				var _v4 = _v1.a;
				return A2(
					$elm$core$Task$andThen,
					function (pid) {
						return A2(
							$elm$core$Task$andThen,
							function (time) {
								return $elm$core$Task$succeed(
									A3(
										$elm$browser$Browser$AnimationManager$State,
										subs,
										$elm$core$Maybe$Just(pid),
										time));
							},
							$elm$browser$Browser$AnimationManager$now);
					},
					$elm$core$Process$spawn(
						A2(
							$elm$core$Task$andThen,
							$elm$core$Platform$sendToSelf(router),
							$elm$browser$Browser$AnimationManager$rAF)));
			}
		} else {
			if (!_v1.b.b) {
				var pid = _v1.a.a;
				return A2(
					$elm$core$Task$andThen,
					function (_v3) {
						return $elm$browser$Browser$AnimationManager$init;
					},
					$elm$core$Process$kill(pid));
			} else {
				return $elm$core$Task$succeed(
					A3($elm$browser$Browser$AnimationManager$State, subs, request, oldTime));
			}
		}
	});
var $elm$browser$Browser$AnimationManager$onSelfMsg = F3(
	function (router, newTime, _v0) {
		var subs = _v0.jX;
		var oldTime = _v0.hb;
		var send = function (sub) {
			if (!sub.$) {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(
						$elm$time$Time$millisToPosix(newTime)));
			} else {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(newTime - oldTime));
			}
		};
		return A2(
			$elm$core$Task$andThen,
			function (pid) {
				return A2(
					$elm$core$Task$andThen,
					function (_v1) {
						return $elm$core$Task$succeed(
							A3(
								$elm$browser$Browser$AnimationManager$State,
								subs,
								$elm$core$Maybe$Just(pid),
								newTime));
					},
					$elm$core$Task$sequence(
						A2($elm$core$List$map, send, subs)));
			},
			$elm$core$Process$spawn(
				A2(
					$elm$core$Task$andThen,
					$elm$core$Platform$sendToSelf(router),
					$elm$browser$Browser$AnimationManager$rAF)));
	});
var $elm$browser$Browser$AnimationManager$Delta = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$AnimationManager$subMap = F2(
	function (func, sub) {
		if (!sub.$) {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Time(
				A2($elm$core$Basics$composeL, func, tagger));
		} else {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Delta(
				A2($elm$core$Basics$composeL, func, tagger));
		}
	});
_Platform_effectManagers['Browser.AnimationManager'] = _Platform_createManager($elm$browser$Browser$AnimationManager$init, $elm$browser$Browser$AnimationManager$onEffects, $elm$browser$Browser$AnimationManager$onSelfMsg, 0, $elm$browser$Browser$AnimationManager$subMap);
var $elm$browser$Browser$AnimationManager$subscription = _Platform_leaf('Browser.AnimationManager');
var $elm$browser$Browser$AnimationManager$onAnimationFrame = function (tagger) {
	return $elm$browser$Browser$AnimationManager$subscription(
		$elm$browser$Browser$AnimationManager$Time(tagger));
};
var $elm$browser$Browser$Events$onAnimationFrame = $elm$browser$Browser$AnimationManager$onAnimationFrame;
var $mdgriffith$elm_style_animation$Animation$subscription = F2(
	function (msg, states) {
		return A2($elm$core$List$any, $mdgriffith$elm_style_animation$Animation$isRunning, states) ? A2(
			$elm$core$Platform$Sub$map,
			msg,
			$elm$browser$Browser$Events$onAnimationFrame($elm$core$Basics$identity)) : $elm$core$Platform$Sub$none;
	});
var $author$project$Pages$CfgDevice$Design$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$author$project$Interop$Fabric$subscribe,
				$author$project$Pages$CfgDevice$Design$fabricDecoder,
				$elm$core$Result$withDefault($author$project$Pages$CfgDevice$Design$NoOp)),
				A2(
				$author$project$Interop$Browser$subscribe,
				$author$project$Pages$CfgDevice$Design$browserDecoder(model),
				$elm$core$Result$withDefault($author$project$Pages$CfgDevice$Design$NoOp)),
				A2(
				$author$project$Interop$Browser$subscribe,
				$author$project$Pages$CfgDevice$Design$imageUploadBrowserDecoder(model),
				$elm$core$Result$withDefault($author$project$Pages$CfgDevice$Design$NoOp)),
				A2(
				$mdgriffith$elm_style_animation$Animation$subscription,
				$author$project$Pages$CfgDevice$Design$Animate,
				$elm$core$List$concat(
					$elm$core$Dict$values(model.b7)))
			]));
};
var $author$project$Pages$CfgDevice$Schedule$NoOp = {$: 0};
var $author$project$Pages$CfgDevice$Schedule$RespTemplates = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$CfgDevice$Schedule$Schedules = function (a) {
	return {$: 3, a: a};
};
var $author$project$Entity$Schedule$Core$Schedule = F6(
	function (name, isEnabled, template, startTime, endTime, menuPlanning) {
		return {e2: endTime, fi: isEnabled, fp: menuPlanning, g8: name, fI: startTime, fN: template};
	});
var $author$project$Entity$Schedule$MenuPlanning$MenuPlanning = F2(
	function (servingLines, mealType) {
		return {i8: mealType, jR: servingLines};
	});
var $author$project$Entity$MealType$fromString = function (meal) {
	switch (meal) {
		case 'breakfast':
			return $elm$core$Maybe$Just(0);
		case 'lunch':
			return $elm$core$Maybe$Just(1);
		case 'supper':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Entity$MealType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (meal) {
		var _v0 = $author$project$Entity$MealType$fromString(meal);
		if (_v0.$ === 1) {
			return $elm$json$Json$Decode$fail('Not a valid mealtype');
		} else {
			var aMeal = _v0.a;
			return $elm$json$Json$Decode$succeed(aMeal);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Entity$Schedule$MenuPlanning$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'mealType',
	$author$project$Entity$MealType$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'servingLines',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Entity$Schedule$MenuPlanning$MenuPlanning)));
var $author$project$Entity$Schedule$Time$Time = F2(
	function (hour, minute) {
		return {c5: hour, dk: minute};
	});
var $author$project$Entity$Schedule$Time$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'minute',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'hour',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Entity$Schedule$Time$Time)));
var $author$project$Entity$Schedule$Core$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'menuPlanning',
	$author$project$Entity$Schedule$MenuPlanning$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'endTime',
		$author$project$Entity$Schedule$Time$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'startTime',
			$author$project$Entity$Schedule$Time$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'template',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'isEnabled',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Entity$Schedule$Core$Schedule)))))));
var $author$project$Pages$CfgDevice$Schedule$fabricDecoder = function (event) {
	switch (event) {
		case 'RESP_ALL_SCHEDULES':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Pages$CfgDevice$Schedule$Schedules,
				$author$project$Interop$Fabric$dataDecoder(
					$elm$json$Json$Decode$dict($author$project$Entity$Schedule$Core$decoder)));
		case 'RESP_AVAILABLE_TEMPLATES':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Pages$CfgDevice$Schedule$RespTemplates,
				$author$project$Interop$Fabric$dataDecoder(
					$elm$json$Json$Decode$list($author$project$Template$Core$decodeMinimal)));
		default:
			return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$Pages$CfgDevice$Schedule$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$author$project$Interop$Fabric$subscribe,
				$author$project$Pages$CfgDevice$Schedule$fabricDecoder,
				$elm$core$Result$withDefault($author$project$Pages$CfgDevice$Schedule$NoOp))
			]));
};
var $author$project$Pages$CfgDevice$Settings$NoOp = {$: 0};
var $author$project$Pages$CfgDevice$Settings$ImgUrlCopied = function (a) {
	return {$: 38, a: a};
};
var $author$project$Pages$CfgDevice$Settings$browserDecoder = F2(
	function (model, event) {
		if (event === 'IMAGE_URL_COPIED') {
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Pages$CfgDevice$Settings$ImgUrlCopied,
				A2($elm$json$Json$Decode$field, 'payload', $elm$json$Json$Decode$string));
		} else {
			return $elm$json$Json$Decode$fail('');
		}
	});
var $author$project$Pages$CfgDevice$Settings$DeviceSerialNumber = function (a) {
	return {$: 32, a: a};
};
var $author$project$Pages$CfgDevice$Settings$RespBackupFail = function (a) {
	return {$: 36, a: a};
};
var $author$project$Pages$CfgDevice$Settings$RespBackupSuccess = {$: 35};
var $author$project$Pages$CfgDevice$Settings$RespCpuInfo = function (a) {
	return {$: 33, a: a};
};
var $author$project$Pages$CfgDevice$Settings$RespManifest = function (a) {
	return {$: 31, a: a};
};
var $author$project$Pages$CfgDevice$Settings$RespMemInfo = function (a) {
	return {$: 34, a: a};
};
var $author$project$Pages$CfgDevice$Settings$RespSchedules = function (a) {
	return {$: 27, a: a};
};
var $author$project$Pages$CfgDevice$Settings$SelectScreensaver = function (a) {
	return {$: 26, a: a};
};
var $author$project$Pages$CfgDevice$Settings$StatusBarTheme = function (a) {
	return {$: 25, a: a};
};
var $author$project$Pages$CfgDevice$Settings$ToCore = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$CfgDevice$Settings$Toast = function (a) {
	return {$: 3, a: a};
};
var $author$project$Entity$CpuInfo$Model = F6(
	function (numOfProcessors, archName, modelName, features, processors, temperatures) {
		return {ie: archName, iI: features, i9: modelName, je: numOfProcessors, jy: processors, jZ: temperatures};
	});
var $author$project$Entity$CpuInfo$Processor = function (usage) {
	return {eJ: usage};
};
var $author$project$Entity$CpuInfo$Usage = F4(
	function (user, kernel, idle, total) {
		return {iV: idle, i3: kernel, j1: total, j7: user};
	});
var $author$project$Entity$CpuInfo$decodeProcessor = function () {
	var usageDecoder = A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'total',
		$elm$json$Json$Decode$float,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'idle',
			$elm$json$Json$Decode$float,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'kernel',
				$elm$json$Json$Decode$float,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'user',
					$elm$json$Json$Decode$float,
					$elm$json$Json$Decode$succeed($author$project$Entity$CpuInfo$Usage)))));
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'usage',
		usageDecoder,
		$elm$json$Json$Decode$succeed($author$project$Entity$CpuInfo$Processor));
}();
var $author$project$Entity$CpuInfo$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'temperatures',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$float),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'processors',
		$elm$json$Json$Decode$list($author$project$Entity$CpuInfo$decodeProcessor),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'features',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'modelName',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'archName',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'numOfProcessors',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$Entity$CpuInfo$Model)))))));
var $author$project$Entity$Manifest$Model = F2(
	function (name, version) {
		return {g8: name, hW: version};
	});
var $author$project$Entity$Manifest$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'version',
	$elm$json$Json$Decode$string,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'name',
		$elm$json$Json$Decode$string,
		'Unknown',
		$elm$json$Json$Decode$succeed($author$project$Entity$Manifest$Model)));
var $author$project$Entity$MemInfo$Model = F2(
	function (capacity, availableCapacity) {
		return {$8: availableCapacity, io: capacity};
	});
var $author$project$Entity$MemInfo$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'availableCapacity',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'capacity',
		$elm$json$Json$Decode$float,
		$elm$json$Json$Decode$succeed($author$project$Entity$MemInfo$Model)));
var $author$project$Entity$Screensaver$DarkBackground = 0;
var $author$project$Entity$Screensaver$Images = 1;
var $author$project$Entity$Screensaver$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (opt) {
		switch (opt) {
			case 'dark-background':
				return $elm$json$Json$Decode$succeed(0);
			case 'images':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Not a screensaver opt');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Entity$StatusBarTheme$Theme = function (hideBar) {
	return function (fontFamily) {
		return function (fontColor) {
			return function (fontSize) {
				return function (background) {
					return function (showLogo) {
						return function (width) {
							return function (height) {
								return function (logoUrl) {
									return function (permTextFontSize) {
										return function (permText) {
											return {f6: background, gx: fontColor, gy: fontFamily, gz: fontSize, gH: height, gK: hideBar, gZ: logoUrl, hq: permText, hr: permTextFontSize, hH: showLogo, hY: width};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Entity$StatusBarTheme$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'permText',
	$elm$json$Json$Decode$string,
	'This institution is an equal opportunity provider.',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'permTextFontSize',
		$elm$json$Json$Decode$float,
		48,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'logoUrl',
			$elm$json$Json$Decode$string,
			'./images/icon.png',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'height',
				$elm$json$Json$Decode$float,
				110,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'width',
					$elm$json$Json$Decode$float,
					110,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'showLogo',
						$elm$json$Json$Decode$bool,
						true,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'background',
							$elm$json$Json$Decode$string,
							'none',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'fontSize',
								$elm$json$Json$Decode$float,
								48,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'fontColor',
									$elm$json$Json$Decode$string,
									'#FFFFFF',
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'fontFamily',
										$elm$json$Json$Decode$string,
										'Roboto',
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'hideBar',
											$elm$json$Json$Decode$bool,
											false,
											$elm$json$Json$Decode$succeed($author$project$Entity$StatusBarTheme$Theme))))))))))));
var $author$project$Pages$CfgDevice$Settings$fabricDecoder = function (key) {
	switch (key) {
		case 'RESP_STATUS_BAR_THEME':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Pages$CfgDevice$Settings$StatusBarTheme,
				$author$project$Interop$Fabric$dataDecoder($author$project$Entity$StatusBarTheme$decoder));
		case 'RESP_ALL_SCHEDULES':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Pages$CfgDevice$Settings$RespSchedules,
				$author$project$Interop$Fabric$dataDecoder(
					$elm$json$Json$Decode$dict($author$project$Entity$Schedule$Core$decoder)));
		case 'SAVE_OK_SERIAL_NUMBER':
			return A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeL, $author$project$Pages$CfgDevice$Settings$ToCore, $author$project$Pages$CfgDevice$Settings$Toast),
				$author$project$Interop$Fabric$dataDecoder($elm$json$Json$Decode$string));
		case 'SAVE_ERR_SERIAL_NUMBER':
			return A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeL, $author$project$Pages$CfgDevice$Settings$ToCore, $author$project$Pages$CfgDevice$Settings$Toast),
				$author$project$Interop$Fabric$dataDecoder($elm$json$Json$Decode$string));
		case 'OK_MANIFEST':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Pages$CfgDevice$Settings$RespManifest,
				$author$project$Interop$Fabric$dataDecoder($author$project$Entity$Manifest$decoder));
		case 'RESP_OK_SERIAL_NUMBER':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Pages$CfgDevice$Settings$DeviceSerialNumber,
				$author$project$Interop$Fabric$dataDecoder($elm$json$Json$Decode$string));
		case 'RESP_CPU_INFO':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Pages$CfgDevice$Settings$RespCpuInfo,
				$author$project$Interop$Fabric$dataDecoder($author$project$Entity$CpuInfo$decoder));
		case 'RESP_MEM_INFO':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Pages$CfgDevice$Settings$RespMemInfo,
				$author$project$Interop$Fabric$dataDecoder($author$project$Entity$MemInfo$decoder));
		case 'RESP_BACKUP_DEVICE_SUCCESS':
			return $elm$json$Json$Decode$succeed($author$project$Pages$CfgDevice$Settings$RespBackupSuccess);
		case 'RESP_BACKUP_DEVICE_FAIL':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Pages$CfgDevice$Settings$RespBackupFail,
				$author$project$Interop$Fabric$dataDecoder($elm$json$Json$Decode$string));
		case 'RESP_SCREENSAVER':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Pages$CfgDevice$Settings$SelectScreensaver,
				$author$project$Interop$Fabric$dataDecoder($author$project$Entity$Screensaver$decoder));
		default:
			return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$Pages$CfgDevice$Settings$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$author$project$Interop$Fabric$subscribe,
				$author$project$Pages$CfgDevice$Settings$fabricDecoder,
				$elm$core$Result$withDefault($author$project$Pages$CfgDevice$Settings$NoOp)),
				A2(
				$author$project$Interop$Browser$subscribe,
				$author$project$Pages$CfgDevice$Settings$browserDecoder(model),
				$elm$core$Result$withDefault($author$project$Pages$CfgDevice$Settings$NoOp))
			]));
};
var $author$project$Pages$CfgDevice$Core$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$author$project$Interop$Fabric$subscribe,
				$author$project$Pages$CfgDevice$Core$fabricDecoder(model),
				$elm$core$Result$withDefault($author$project$Pages$CfgDevice$Core$NoOp)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$CfgDevice$Core$DesignTabMsg,
				$author$project$Pages$CfgDevice$Design$subscriptions(model.P)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$CfgDevice$Core$ScheduleTabMsg,
				$author$project$Pages$CfgDevice$Schedule$subscriptions(model.a7)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$CfgDevice$Core$SettingsTabMsg,
				$author$project$Pages$CfgDevice$Settings$subscriptions(model.aU)),
				A2($elm$time$Time$every, 1000 * 60, $author$project$Pages$CfgDevice$Core$RefreshNowPlaying)
			]));
};
var $author$project$Pages$LinkNewDevice$NoOp = {$: 2};
var $author$project$Pages$LinkNewDevice$CancelActivation = {$: 5};
var $author$project$Pages$LinkNewDevice$DeviceConnectFail = {$: 14};
var $author$project$Pages$LinkNewDevice$DeviceConnectSuccess = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Pages$LinkNewDevice$DeviceOffline = {$: 17};
var $author$project$Pages$LinkNewDevice$OkayToProceed = {$: 18};
var $author$project$Pages$LinkNewDevice$PostDevice = F2(
	function (a, b) {
		return {$: 28, a: a, b: b};
	});
var $author$project$Pages$LinkNewDevice$fabricDecoder = F4(
	function (flags, token, model, event) {
		switch (event) {
			case 'reconnect':
				return $elm$json$Json$Decode$succeed($author$project$Pages$LinkNewDevice$CancelActivation);
			case 'RESP_DEVICE_ID':
				return A3(
					$elm$json$Json$Decode$map2,
					$author$project$Pages$LinkNewDevice$DeviceConnectSuccess,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['payload', 'deviceId']),
						$elm$json$Json$Decode$string),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['payload', 'deviceSocketId']),
						$elm$json$Json$Decode$string));
			case 'INVALID_ACTIVATION_CODE':
				return $elm$json$Json$Decode$succeed($author$project$Pages$LinkNewDevice$DeviceConnectFail);
			case 'DEVICE_OFFLINE':
				var _v1 = model.iB;
				if (!_v1.$) {
					var devId = _v1.a;
					return A2(
						$elm$json$Json$Decode$andThen,
						function (id) {
							return _Utils_eq(id, devId) ? $elm$json$Json$Decode$succeed($author$project$Pages$LinkNewDevice$DeviceOffline) : $elm$json$Json$Decode$fail('Is not the right deviceId');
						},
						A2($elm$json$Json$Decode$field, 'payload', $elm$json$Json$Decode$string));
				} else {
					return $elm$json$Json$Decode$fail('Not registering any device');
				}
			case 'ACK_SELECT_SCHOOL':
				return $elm$json$Json$Decode$succeed($author$project$Pages$LinkNewDevice$OkayToProceed);
			case 'ACK_SELECT_CATEGORIES':
				return $elm$json$Json$Decode$succeed($author$project$Pages$LinkNewDevice$OkayToProceed);
			case 'ACK_SELECT_SERVING_LINES':
				return $elm$json$Json$Decode$succeed($author$project$Pages$LinkNewDevice$OkayToProceed);
			case 'ACK_SELECT_NAME':
				return $elm$json$Json$Decode$succeed($author$project$Pages$LinkNewDevice$OkayToProceed);
			case 'RESP_ACTIVATE_DEVICE':
				return $elm$json$Json$Decode$succeed(
					A2($author$project$Pages$LinkNewDevice$PostDevice, flags, token));
			default:
				return $elm$json$Json$Decode$fail('');
		}
	});
var $author$project$Pages$LinkNewDevice$subscriptions = F3(
	function (flags, token, model) {
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2(
					$author$project$Interop$Fabric$subscribe,
					A3($author$project$Pages$LinkNewDevice$fabricDecoder, flags, token, model),
					$elm$core$Result$withDefault($author$project$Pages$LinkNewDevice$NoOp))
				]));
	});
var $author$project$Pages$SyncDevices$NoOp = {$: 0};
var $author$project$Pages$SyncDevices$RespImportSchedules = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$SyncDevices$RespImportTemplates = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$SyncDevices$RespImportTheme = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$SyncDevices$SyncSchedulesSuccess = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$SyncDevices$SyncStatusBarSuccess = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$SyncDevices$SyncTemplatesSucess = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$SyncDevices$fabricDecoder = function (event) {
	switch (event) {
		case 'RESP_IMPORT_TEMPLATES':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Pages$SyncDevices$RespImportTemplates,
				$author$project$Interop$Fabric$dataDecoder(
					$elm$json$Json$Decode$dict($author$project$Template$Core$decoder)));
		case 'RESP_IMPORT_SCHEDULES':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Pages$SyncDevices$RespImportSchedules,
				$author$project$Interop$Fabric$dataDecoder(
					$elm$json$Json$Decode$dict($author$project$Entity$Schedule$Core$decoder)));
		case 'RESP_IMPORT_STATUS_BAR_THEME':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Pages$SyncDevices$RespImportTheme,
				$author$project$Interop$Fabric$dataDecoder($author$project$Entity$StatusBarTheme$decoder));
		case 'SYNC_TEMPLATES_SUCCESS':
			return A2($elm$json$Json$Decode$map, $author$project$Pages$SyncDevices$SyncTemplatesSucess, $author$project$Interop$Fabric$replyIdDecoder);
		case 'SYNC_SCHEDULES_SUCCESS':
			return A2($elm$json$Json$Decode$map, $author$project$Pages$SyncDevices$SyncSchedulesSuccess, $author$project$Interop$Fabric$replyIdDecoder);
		case 'SYNC_STATUS_BAR_THEME_SUCCESS':
			return A2($elm$json$Json$Decode$map, $author$project$Pages$SyncDevices$SyncStatusBarSuccess, $author$project$Interop$Fabric$replyIdDecoder);
		default:
			return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$Pages$SyncDevices$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$author$project$Interop$Fabric$subscribe,
				$author$project$Pages$SyncDevices$fabricDecoder,
				$elm$core$Result$withDefault($author$project$Pages$SyncDevices$NoOp))
			]));
};
var $author$project$Pages$User$NoOp = {$: 0};
var $author$project$Pages$User$ValidateExpiryTimeInterval = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$User$LogoutUser = {$: 15};
var $author$project$Pages$User$ParsedExpiryDate = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$User$UserDataFromStorage = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$User$User = function (userId) {
	return function (adminName) {
		return function (userName) {
			return function (firstName) {
				return function (accessToken) {
					return function (accessLevel) {
						return function (issuedTime) {
							return function (expiryTime) {
								return function (district) {
									return function (email) {
										return {h4: accessLevel, h5: accessToken, eO: adminName, iC: district, iD: email, e4: expiryTime, li: firstName, i0: issuedTime, j8: userId, ax: userName};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$User$Admin = 2;
var $author$project$Pages$User$Anonymous = 4;
var $author$project$Pages$User$Parent = 0;
var $author$project$Pages$User$Student = 1;
var $author$project$Pages$User$SuperAdmin = 3;
var $author$project$Pages$User$accessLevelDecoder = function () {
	var convert = function (level) {
		switch (level) {
			case '4':
				return 3;
			case '3':
				return 2;
			case '2':
				return 1;
			case '1':
				return 0;
			default:
				return 4;
		}
	};
	return A2($elm$json$Json$Decode$map, convert, $elm$json$Json$Decode$string);
}();
var $author$project$Pages$User$adminNameDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (_v0) {
		var a = _v0.a;
		var b = _v0.b;
		return $elm$json$Json$Decode$succeed(b + (' (' + (a + ')')));
	},
	A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (a, b) {
				return _Utils_Tuple2(a, b);
			}),
		A2($elm$json$Json$Decode$field, 'userName', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'FirstName', $elm$json$Json$Decode$string)));
var $author$project$Entity$District$District = F2(
	function (name, id) {
		return {aF: id, g8: name};
	});
var $author$project$Entity$District$districtDecoderFromUser = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'ISDId',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'DistrictName',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Entity$District$District)));
var $author$project$Pages$User$stringToIntDecoder = function () {
	var convert = function (raw) {
		return $elm$core$String$toInt(raw);
	};
	return A2($elm$json$Json$Decode$map, convert, $elm$json$Json$Decode$string);
}();
var $author$project$Pages$User$userDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'Email',
	$elm$json$Json$Decode$string,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Entity$District$districtDecoderFromUser,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'.expires',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'.issued',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'AccessLevel',
					$author$project$Pages$User$accessLevelDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'access_token',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'FirstName',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'userName',
								$elm$json$Json$Decode$string,
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
									$author$project$Pages$User$adminNameDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'UserId',
										$author$project$Pages$User$stringToIntDecoder,
										$elm$json$Json$Decode$succeed($author$project$Pages$User$User)))))))))));
var $author$project$Pages$User$browserDecoder = function (event) {
	switch (event) {
		case 'USER_STATE_FROM_STORAGE':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Pages$User$UserDataFromStorage,
				A2($elm$json$Json$Decode$field, 'payload', $author$project$Pages$User$userDecoder));
		case 'USER_INACTIVE':
			return $elm$json$Json$Decode$succeed($author$project$Pages$User$LogoutUser);
		case 'PARSED_EXPIRY_DATE':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Pages$User$ParsedExpiryDate,
				A2($elm$json$Json$Decode$field, 'payload', $elm$json$Json$Decode$string));
		default:
			return $elm$json$Json$Decode$fail('Not a user event');
	}
};
var $author$project$Pages$User$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$author$project$Interop$Browser$subscribe,
				$author$project$Pages$User$browserDecoder,
				$elm$core$Result$withDefault($author$project$Pages$User$NoOp)),
				A2(
				$elm$time$Time$every,
				A2($elm$core$Maybe$withDefault, 60 * 1000, model.e3),
				$author$project$Pages$User$ValidateExpiryTimeInterval)
			]));
};
var $author$project$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$author$project$Interop$Browser$subscribe,
				$author$project$Main$browserDecoder(model),
				$elm$core$Result$withDefault($author$project$Main$NoOp)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$UserMsg,
				$author$project$Pages$User$subscriptions(model.j7)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$FabricMsg,
				$author$project$FabricStatus$subscriptions(model.aD)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$CfgDeviceMsg,
				$author$project$Pages$CfgDevice$Core$subscriptions(model.K)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$SyncDevicesMsg,
				$author$project$Pages$SyncDevices$subscriptions(model.cu)),
				function () {
				var _v0 = $author$project$Pages$User$getAccessToken(model.j7);
				if (_v0.$ === 1) {
					return $elm$core$Platform$Sub$none;
				} else {
					var token = _v0.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Main$LinkNewDeviceMsg,
						A3($author$project$Pages$LinkNewDevice$subscriptions, model.k, token, model.ce));
				}
			}(),
				$elm$browser$Browser$Events$onResize($author$project$Main$UpdateViewport),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$LiveCaptureMsg,
				$author$project$Dialogs$LiveCapture$subscriptions(model.de)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$GalleryMsg,
				$author$project$Dialogs$Gallery$subscriptions(model.c3)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$ReleaseNotesMsg,
				$author$project$Dialogs$ReleaseNotes$subscriptions(model.ds))
			]));
};
var $author$project$Pages$CfgDevice$Core$ConfigureDevice = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Main$DashboardMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$DataState$Error = function (a) {
	return {$: 2, a: a};
};
var $author$project$Main$FaqMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Main$FaqsMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$CfgDevice$Core$ForceDeleteDevice = F3(
	function (a, b, c) {
		return {$: 11, a: a, b: b, c: c};
	});
var $author$project$Main$MenuItemListMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$DataState$Ready = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$SchoolsData = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$CfgDevice$Core$addDevice = F2(
	function (device, model) {
		return _Utils_update(
			model,
			{
				ao: function () {
					var _v0 = model.ao;
					if (_v0.$ === 4) {
						var devices = _v0.a;
						return $author$project$DataState$Ready(
							A3($elm$core$Dict$insert, device.aF, device, devices));
					} else {
						return model.ao;
					}
				}()
			});
	});
var $aforemny$material_components_web_elm$Material$Snackbar$close = F2(
	function (messageId, _v0) {
		var queue = _v0;
		return _Utils_update(
			queue,
			{
				cc: function () {
					var _v1 = queue.cc;
					if (!_v1.b) {
						return _List_Nil;
					} else {
						var _v2 = _v1.a;
						var currentMessageId = _v2.a;
						var otherMessages = _v1.b;
						return _Utils_eq(currentMessageId, messageId) ? otherMessages : queue.cc;
					}
				}()
			});
	});
var $author$project$Utils$cmd = function (msg) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed(msg));
};
var $author$project$Pages$User$get = F2(
	function (func, state) {
		if (state.$ === 4) {
			var user = state.a;
			return $elm$core$Maybe$Just(
				func(user));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Pages$User$getDistrictId = function (model) {
	var _v0 = model.ew;
	if (!_v0.$) {
		var id = _v0.a.aF;
		var name = _v0.a.g8;
		return $elm$core$Maybe$Just(id);
	} else {
		var _v1 = model.eK;
		if (_v1.$ === 4) {
			var user = _v1.a;
			return $elm$core$Maybe$Just(user.iC.aF);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$crossOrigin = F3(
	function (prePath, pathSegments, parameters) {
		return prePath + ('/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters)));
	});
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.mJ));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$expectString = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		$elm$http$Http$resolve($elm$core$Result$Ok));
};
var $lukewestby$elm_http_builder$HttpBuilder$requestWithMethodAndUrl = F2(
	function (method, url) {
		return {
			kG: $elm$http$Http$emptyBody,
			gr: $elm$http$Http$expectString(
				function (_v0) {
					return 0;
				}),
			iP: _List_Nil,
			lW: method,
			m9: $elm$core$Maybe$Nothing,
			j2: $elm$core$Maybe$Nothing,
			nj: url,
			dM: false
		};
	});
var $lukewestby$elm_http_builder$HttpBuilder$get = $lukewestby$elm_http_builder$HttpBuilder$requestWithMethodAndUrl('GET');
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {jD: reqs, jX: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.j2;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.jD));
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.jX)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					kw: r.kw,
					kG: r.kG,
					gr: A2(_Http_mapExpect, func, r.gr),
					iP: r.iP,
					lW: r.lW,
					m9: r.m9,
					j2: r.j2,
					nj: r.nj
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{kw: false, kG: r.kG, gr: r.gr, iP: r.iP, lW: r.lW, m9: r.m9, j2: r.j2, nj: r.nj}));
};
var $elm$http$Http$riskyRequest = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{kw: true, kG: r.kG, gr: r.gr, iP: r.iP, lW: r.lW, m9: r.m9, j2: r.j2, nj: r.nj}));
};
var $lukewestby$elm_http_builder$HttpBuilder$request = function (builder) {
	var req = builder.dM ? $elm$http$Http$riskyRequest : $elm$http$Http$request;
	return req(
		{kG: builder.kG, gr: builder.gr, iP: builder.iP, lW: builder.lW, m9: builder.m9, j2: builder.j2, nj: builder.nj});
};
var $author$project$Entity$School$serverDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'SchoolName',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'SchoolId',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Entity$School$School)));
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $lukewestby$elm_http_builder$HttpBuilder$withExpect = F2(
	function (expect, builder) {
		return {kG: builder.kG, gr: expect, iP: builder.iP, lW: builder.lW, m9: builder.m9, j2: builder.j2, nj: builder.nj, dM: builder.dM};
	});
var $author$project$Entity$School$getSchools = F4(
	function (urlPrefix, accessToken, district, toMsg) {
		var url = A3(
			$elm$url$Url$Builder$crossOrigin,
			urlPrefix,
			_List_fromArray(
				['api', 'GetSchoolsList']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'districtId', district.aF)
				]));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2(
					$elm$http$Http$expectJson,
					toMsg,
					$elm$json$Json$Decode$list($author$project$Entity$School$serverDecoder)),
				$lukewestby$elm_http_builder$HttpBuilder$get(url)));
	});
var $author$project$Dialogs$ReleaseNotes$getStoredVersion = A2($author$project$Interop$Browser$postMessage, 'GET_STORED_VERSION', $elm$json$Json$Encode$null);
var $author$project$Pages$MenuItemList$AllMenuItemLists = function (a) {
	return {$: 25, a: a};
};
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $lukewestby$elm_http_builder$HttpBuilder$withHeader = F3(
	function (key, value, builder) {
		return _Utils_update(
			builder,
			{
				iP: A2(
					$elm$core$List$cons,
					A2($elm$http$Http$header, key, value),
					builder.iP)
			});
	});
var $author$project$Utils$addAccessToken = function (accessToken) {
	return A2($lukewestby$elm_http_builder$HttpBuilder$withHeader, 'Authorization', 'Bearer ' + accessToken);
};
var $author$project$Utils$idDictDecoder = function (items) {
	return $elm$json$Json$Decode$succeed(
		$elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (m) {
					return _Utils_Tuple2(m.aF, m);
				},
				items)));
};
var $author$project$Entity$MenuItemList$MenuItemList = F3(
	function (id, name, items) {
		return {aF: id, lM: items, g8: name};
	});
var $author$project$Entity$MenuItemList$MenuItem = F5(
	function (listId, id, name, price, index) {
		return {aF: id, iX: index, i7: listId, g8: name, ju: price};
	});
var $author$project$Entity$MenuItemList$menuItemDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'Index',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'Price',
		$elm$json$Json$Decode$float,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'MenuItemName',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'MenuItemId',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'MenuItemListId',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Entity$MenuItemList$MenuItem))))));
var $author$project$Entity$MenuItemList$menuItemListDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'Items',
	A2(
		$elm$json$Json$Decode$andThen,
		$author$project$Utils$idDictDecoder,
		$elm$json$Json$Decode$list($author$project$Entity$MenuItemList$menuItemDecoder)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'MenuItemListName',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'MenuItemListId',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Entity$MenuItemList$MenuItemList))));
var $author$project$Entity$MenuItemList$loadAllLists = F3(
	function (urlPrefix, accessToken, toMsg) {
		var url = A3(
			$elm$url$Url$Builder$crossOrigin,
			urlPrefix,
			_List_fromArray(
				['api', 'MenuItemLists']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'MenuItemListId', '')
				]));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2(
					$elm$http$Http$expectJson,
					toMsg,
					A2(
						$elm$json$Json$Decode$andThen,
						$author$project$Utils$idDictDecoder,
						$elm$json$Json$Decode$list($author$project$Entity$MenuItemList$menuItemListDecoder))),
				A2(
					$author$project$Utils$addAccessToken,
					accessToken,
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Pages$MenuItemList$loadData = F2(
	function (urlPrefix, accessToken) {
		return A3($author$project$Entity$MenuItemList$loadAllLists, urlPrefix, accessToken, $author$project$Pages$MenuItemList$AllMenuItemLists);
	});
var $author$project$Pages$CfgDevice$Core$DevicesData = function (a) {
	return {$: 13, a: a};
};
var $author$project$Entity$Device$Device = F6(
	function (id, name, school, state, serialNumber, nowPlaying) {
		return {aF: id, g8: name, jd: nowPlaying, du: school, jP: serialNumber, fJ: state};
	});
var $author$project$Entity$Device$Offline = {$: 1};
var $author$project$Entity$Device$deviceIdDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$field, 'Id', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'deviceId', $elm$json$Json$Decode$string)
		]));
var $author$project$Entity$Device$deviceNameDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$field, 'Name', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string)
		]));
var $author$project$Entity$Device$deviceDecoder = function (school) {
	return A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'SerialNumber',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				$author$project$Entity$Device$Offline,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
					school,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						$author$project$Entity$Device$deviceNameDecoder,
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							$author$project$Entity$Device$deviceIdDecoder,
							$elm$json$Json$Decode$succeed($author$project$Entity$Device$Device)))))));
};
var $author$project$Entity$Device$deviceServerDecoder = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Entity$Device$deviceDecoder,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'SchoolName',
		$elm$json$Json$Decode$string,
		'',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'SchoolId',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Entity$School$School))));
var $author$project$Entity$Device$devicesDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (devices) {
		return $elm$json$Json$Decode$succeed(
			$elm$core$Dict$fromList(
				A2(
					$elm$core$List$map,
					function (device) {
						return _Utils_Tuple2(device.aF, device);
					},
					devices)));
	},
	$elm$json$Json$Decode$list($author$project$Entity$Device$deviceServerDecoder));
var $author$project$Entity$Device$getDevices = F4(
	function (urlPrefix, accessToken, maybeDistrict, toMsg) {
		var api = function () {
			if (!maybeDistrict.$) {
				var district = maybeDistrict.a;
				return _List_fromArray(
					['api', 'GetAllDevices', district.aF]);
			} else {
				return _List_fromArray(
					['api', 'Device']);
			}
		}();
		var url = A3($elm$url$Url$Builder$crossOrigin, urlPrefix, api, _List_Nil);
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, toMsg, $author$project$Entity$Device$devicesDecoder),
				A2(
					$author$project$Utils$addAccessToken,
					accessToken,
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Pages$CfgDevice$Core$loadDevices = F4(
	function (urlPrefix, token, maybeDistrict, toMsg) {
		return A2(
			$elm$core$Platform$Cmd$map,
			toMsg,
			A4($author$project$Entity$Device$getDevices, urlPrefix, token, maybeDistrict, $author$project$Pages$CfgDevice$Core$DevicesData));
	});
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$Routing$navigateTo = F2(
	function (key, page) {
		return A2(
			$elm$browser$Browser$Navigation$pushUrl,
			key,
			$author$project$Routing$reversePage(page));
	});
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Dialogs$ReleaseNotes$OpenDialog = {$: 1};
var $author$project$Dialogs$ReleaseNotes$openReleaseNotes = $author$project$Utils$cmd($author$project$Dialogs$ReleaseNotes$OpenDialog);
var $author$project$Pages$Dashboard$refreshDashboard = function (model) {
	return _Utils_update(
		model,
		{fQ: $author$project$Reusable$Tooltip$init});
};
var $author$project$Local$Commands$Browser$scrollToTop = A2($author$project$Interop$Browser$postMessage, 'SCROLL_TO_TOP', $elm$json$Json$Encode$null);
var $author$project$DataState$Loading = function (a) {
	return {$: 1, a: a};
};
var $author$project$DataState$loading = function (status) {
	return $author$project$DataState$Loading(status);
};
var $author$project$Pages$CfgDevice$Core$setLoadingDevices = function (model) {
	return _Utils_update(
		model,
		{
			ao: $author$project$DataState$loading('Loading from server')
		});
};
var $author$project$Dialogs$LiveCapture$StartLiveCapture = function (a) {
	return {$: 1, a: a};
};
var $author$project$Dialogs$LiveCapture$startLiveCapture = function (device) {
	return $author$project$Utils$cmd(
		$author$project$Dialogs$LiveCapture$StartLiveCapture(device));
};
var $aforemny$material_components_web_elm$Material$Snackbar$inc = function (_v0) {
	var messageId = _v0;
	return messageId + 1;
};
var $aforemny$material_components_web_elm$Material$Snackbar$addMessage = F2(
	function (message_, _v0) {
		var queue = _v0;
		return _Utils_update(
			queue,
			{
				cc: _Utils_ap(
					queue.cc,
					_List_fromArray(
						[
							_Utils_Tuple2(queue.em, message_)
						])),
				em: $aforemny$material_components_web_elm$Material$Snackbar$inc(queue.em)
			});
	});
var $aforemny$material_components_web_elm$Material$Snackbar$Message = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Snackbar$message = function (label) {
	return {
		fW: $elm$core$Maybe$Nothing,
		fX: $elm$core$Maybe$Nothing,
		c9: label,
		gX: false,
		hc: $elm$core$Maybe$Nothing,
		hd: $elm$core$Maybe$Nothing,
		hI: false,
		hQ: $elm$core$Maybe$Just(5000)
	};
};
var $author$project$Main$toast = F2(
	function (content, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var message = $aforemny$material_components_web_elm$Material$Snackbar$message(content);
		var newQueue = A2($aforemny$material_components_web_elm$Material$Snackbar$addMessage, message, model.cp);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{cp: newQueue}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Dialogs$ContactUs$update = F2(
	function (msg, model) {
		if (!msg) {
			return _Utils_update(
				model,
				{d_: true});
		} else {
			return _Utils_update(
				model,
				{d_: false});
		}
	});
var $author$project$Dialogs$Gallery$ImageUploadFail = 3;
var $author$project$Dialogs$Gallery$ImageUploadSuccess = 2;
var $author$project$Dialogs$Gallery$ImageUploading = 1;
var $author$project$Dialogs$Gallery$ImagesError = {$: 1};
var $author$project$Dialogs$Gallery$ImagesReady = function (a) {
	return {$: 2, a: a};
};
var $author$project$Dialogs$Gallery$DeletedImage = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $lukewestby$elm_http_builder$HttpBuilder$post = $lukewestby$elm_http_builder$HttpBuilder$requestWithMethodAndUrl('POST');
var $author$project$Dialogs$Gallery$deleteImage = F2(
	function (_v0, imageName) {
		var fabricUrl = _v0.a;
		var districtId = _v0.b;
		var url = A3(
			$elm$url$Url$Builder$crossOrigin,
			fabricUrl,
			_List_fromArray(
				['deleteImage']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'id', districtId),
					A2($elm$url$Url$Builder$string, 'name', imageName)
				]));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				$elm$http$Http$expectString(
					$author$project$Dialogs$Gallery$DeletedImage(imageName)),
				$lukewestby$elm_http_builder$HttpBuilder$post(url)));
	});
var $author$project$Dialogs$Gallery$ImagesFromServer = function (a) {
	return {$: 6, a: a};
};
var $author$project$Dialogs$Gallery$loadImages = function (_v0) {
	var fabricUrl = _v0.a;
	var districtId = _v0.b;
	var url = A3(
		$elm$url$Url$Builder$crossOrigin,
		fabricUrl,
		_List_fromArray(
			['fetchImageNames']),
		_List_fromArray(
			[
				A2($elm$url$Url$Builder$string, 'id', districtId)
			]));
	return $lukewestby$elm_http_builder$HttpBuilder$request(
		A2(
			$lukewestby$elm_http_builder$HttpBuilder$withExpect,
			A2(
				$elm$http$Http$expectJson,
				$author$project$Dialogs$Gallery$ImagesFromServer,
				A2(
					$elm$json$Json$Decode$field,
					'data',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string))),
			$lukewestby$elm_http_builder$HttpBuilder$get(url)));
};
var $author$project$Dialogs$Gallery$toImgUrl = F2(
	function (_v0, imageName) {
		var url = _v0.a;
		var districtId = _v0.b;
		return url + ('/fetchImage?' + (('id=' + districtId) + ('&redirect=true' + ('&name=' + imageName))));
	});
var $author$project$Interop$Browser$toast = function (message) {
	return A2(
		$author$project$Interop$Browser$postMessage,
		'SHOW_GLOBAL_TOAST',
		$elm$json$Json$Encode$string(message));
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Dialogs$Gallery$uploadImage = _Platform_outgoingPort(
	'uploadImage',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'accessToken',
					$elm$json$Json$Encode$string($.h5)),
					_Utils_Tuple2(
					'divId',
					$elm$json$Json$Encode$string($.gm)),
					_Utils_Tuple2(
					'imageAddr',
					function ($) {
						var a = $.a;
						var b = $.b;
						return A2(
							$elm$json$Json$Encode$list,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									$elm$json$Json$Encode$string(a),
									$elm$json$Json$Encode$string(b)
								]));
					}($.gM))
				]));
	});
var $author$project$Dialogs$Gallery$update = F3(
	function (imgAddr, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bX: true}),
					$author$project$Dialogs$Gallery$loadImages(imgAddr));
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bX: false}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var config = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bu: 1}),
					$author$project$Dialogs$Gallery$uploadImage(config));
			case 4:
				var toastMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bu: 3}),
					$author$project$Interop$Browser$toast(toastMsg));
			case 5:
				var fileName = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ah: function () {
								var _v1 = model.ah;
								if (_v1.$ === 2) {
									var images = _v1.a;
									return $author$project$Dialogs$Gallery$ImagesReady(
										A3(
											$elm$core$Dict$insert,
											fileName,
											A2($author$project$Dialogs$Gallery$toImgUrl, imgAddr, fileName),
											images));
								} else {
									return model.ah;
								}
							}(),
							bu: 2
						}),
					$author$project$Interop$Browser$toast('Successfully uploaded the image'));
			case 6:
				if (!msg.a.$) {
					var images = msg.a.a;
					var imageUrls = $elm$core$Dict$fromList(
						A2(
							$elm$core$List$map,
							function (imageName) {
								return _Utils_Tuple2(
									imageName,
									A2($author$project$Dialogs$Gallery$toImgUrl, imgAddr, imageName));
							},
							images));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ah: $author$project$Dialogs$Gallery$ImagesReady(imageUrls)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ah: $author$project$Dialogs$Gallery$ImagesError}),
						$elm$core$Platform$Cmd$none);
				}
			case 7:
				var imageName = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bU: _Utils_Tuple2(
								true,
								$elm$core$Maybe$Just(imageName))
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				if (!msg.b.$) {
					var imageAddr = msg.a;
					var imageName = msg.b.a;
					return _Utils_Tuple2(
						model,
						A2($author$project$Dialogs$Gallery$deleteImage, imageAddr, imageName));
				} else {
					var imageAddr = msg.a;
					var _v2 = msg.b;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 9:
				if (!msg.b.$) {
					var imageName = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bU: _Utils_Tuple2(false, $elm$core$Maybe$Nothing),
								ah: function () {
									var _v3 = model.ah;
									if (_v3.$ === 2) {
										var images = _v3.a;
										return $author$project$Dialogs$Gallery$ImagesReady(
											A2($elm$core$Dict$remove, imageName, images));
									} else {
										return model.ah;
									}
								}()
							}),
						$author$project$Interop$Browser$toast('Successfully deleted the file'));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 10:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bU: _Utils_Tuple2(false, $elm$core$Maybe$Nothing)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var message = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bX: false}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Dialogs$LiveCapture$ReqScreenshot = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Process$sleep = _Process_sleep;
var $andrewMacmurray$elm_delay$Delay$after = F2(
	function (time, msg) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$always(msg),
			$elm$core$Process$sleep(time));
	});
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Entity$Device$getDeviceSocketId = function (device) {
	var _v0 = device.fJ;
	if (!_v0.$) {
		var socketId = _v0.a;
		return $elm$core$Maybe$Just(socketId);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $andrewMacmurray$elm_delay$Delay$seconds = function (millis) {
	return millis * 1000;
};
var $author$project$Interop$Fabric$toFabric = _Platform_outgoingPort(
	'toFabric',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'event',
					$elm$json$Json$Encode$string($.iF)),
					_Utils_Tuple2(
					'payload',
					$elm$core$Basics$identity($.jq))
				]));
	});
var $author$project$Interop$Fabric$unicastMessage = F3(
	function (roomId, event, payload) {
		return $author$project$Interop$Fabric$toFabric(
			{
				iF: 'UNICAST_MESSAGE',
				jq: $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'roomId',
							$elm$json$Json$Encode$string(roomId)),
							_Utils_Tuple2(
							'event',
							$elm$json$Json$Encode$string(event)),
							_Utils_Tuple2('data', payload)
						]))
			});
	});
var $author$project$Dialogs$LiveCapture$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c8: true}),
					$elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cV: $elm$core$Maybe$Nothing, c6: $elm$core$Maybe$Nothing, c8: false}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var sockId = msg.a;
				return _Utils_Tuple2(
					model,
					A3($author$project$Interop$Fabric$unicastMessage, sockId, 'REQ_SCREENSHOT', $elm$json$Json$Encode$null));
			case 3:
				var imgUrl = msg.a;
				var devSockId = msg.b;
				var _v1 = model.cV;
				if (!_v1.$) {
					var sockId = _v1.a.jT;
					return _Utils_eq(devSockId, sockId) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c6: $elm$core$Maybe$Just(imgUrl)
							}),
						A2(
							$andrewMacmurray$elm_delay$Delay$after,
							$andrewMacmurray$elm_delay$Delay$seconds(1),
							$author$project$Dialogs$LiveCapture$ReqScreenshot(devSockId))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				var device = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cV: A2(
								$elm$core$Maybe$andThen,
								function (sockId) {
									return $elm$core$Maybe$Just(
										{g8: device.g8, jT: sockId});
								},
								$author$project$Entity$Device$getDeviceSocketId(device)),
							c6: $elm$core$Maybe$Nothing,
							c8: true
						}),
					function () {
						var _v2 = $author$project$Entity$Device$getDeviceSocketId(device);
						if (!_v2.$) {
							var sockId = _v2.a;
							return $author$project$Utils$cmd(
								$author$project$Dialogs$LiveCapture$ReqScreenshot(sockId));
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
		}
	});
var $author$project$Dialogs$ReleaseNotes$setStoredVersion = function (version) {
	return A2(
		$author$project$Interop$Browser$postMessage,
		'SET_STORED_VERSION',
		$elm$json$Json$Encode$string(version));
};
var $author$project$Dialogs$ReleaseNotes$update = F3(
	function (flags, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bX: true}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bX: false}),
					$elm$core$Platform$Cmd$none);
			default:
				var maybeStoredVersion = msg.a;
				if (!maybeStoredVersion.$) {
					var storedVersion = maybeStoredVersion.a;
					return _Utils_eq(flags.hW, storedVersion) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						_Utils_update(
							model,
							{bX: true}),
						$author$project$Dialogs$ReleaseNotes$setStoredVersion(flags.hW));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bX: true}),
						$author$project$Dialogs$ReleaseNotes$setStoredVersion(flags.hW));
				}
		}
	});
var $author$project$FabricStatus$update = F2(
	function (msg, model) {
		if (!msg.$) {
			return model;
		} else {
			var state = msg.a;
			return state;
		}
	});
var $author$project$Pages$CfgDevice$Core$DesignTab = 1;
var $author$project$Pages$CfgDevice$Core$ForceDeleteResp = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Core$LayoutTab = 0;
var $author$project$Entity$Device$Online = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$CfgDevice$Core$SelectMainTab = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$Pages$CfgDevice$Core$SettingsTab = 2;
var $author$project$Pages$CfgDevice$Core$StyleTab = 2;
var $author$project$Pages$CfgDevice$Core$WidgetCfgTab = 1;
var $author$project$Pages$CfgDevice$Design$applyPreviewDefaults = F2(
	function (data, model) {
		return _Utils_update(
			model,
			{
				bb: A2($elm$core$Dict$get, 'lunch', data)
			});
	});
var $author$project$Pages$CfgDevice$Settings$applyScheduleDefaults = F2(
	function (data, model) {
		return _Utils_update(
			model,
			{
				cl: A2($elm$core$Dict$get, 'lunch', data)
			});
	});
var $lukewestby$elm_http_builder$HttpBuilder$delete = $lukewestby$elm_http_builder$HttpBuilder$requestWithMethodAndUrl('DELETE');
var $author$project$Entity$Device$deleteDevice = F4(
	function (urlPrefix, token, deviceId, toMsg) {
		var url = A3(
			$elm$url$Url$Builder$crossOrigin,
			urlPrefix,
			_List_fromArray(
				['api', 'Device']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'Id', deviceId)
				]));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				$elm$http$Http$expectString(toMsg),
				A2(
					$author$project$Utils$addAccessToken,
					token,
					$lukewestby$elm_http_builder$HttpBuilder$delete(url))));
	});
var $arturopala$elm_monocle$Monocle$Optional$Optional = F2(
	function (getOption, set) {
		return {eb: getOption, cm: set};
	});
var $arturopala$elm_monocle$Monocle$Optional$flip = F3(
	function (f, b, a) {
		return A2(f, a, b);
	});
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $arturopala$elm_monocle$Monocle$Optional$compose = F2(
	function (outer, inner) {
		var set = F2(
			function (c, a) {
				return A2(
					$elm$core$Maybe$withDefault,
					a,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							inner.cm(c),
							A2($arturopala$elm_monocle$Monocle$Optional$flip, outer.cm, a)),
						outer.eb(a)));
			});
		var getOption = function (a) {
			var _v0 = outer.eb(a);
			if (!_v0.$) {
				var x = _v0.a;
				return inner.eb(x);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		return A2($arturopala$elm_monocle$Monocle$Optional$Optional, getOption, set);
	});
var $author$project$Pages$CfgDevice$Core$devicesOfModel = function () {
	var set = F2(
		function (v, m) {
			return _Utils_update(
				m,
				{ao: v});
		});
	var get = function (m) {
		var _v0 = m.ao;
		if (_v0.$ === 4) {
			return $elm$core$Maybe$Just(m.ao);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	return A2($arturopala$elm_monocle$Monocle$Optional$Optional, get, set);
}();
var $arturopala$elm_monocle$Monocle$Lens$Lens = F2(
	function (get, set) {
		return {gE: get, cm: set};
	});
var $arturopala$elm_monocle$Monocle$Optional$composeLens = F2(
	function (opt, lens) {
		var set = F2(
			function (c, a) {
				return A2(
					$elm$core$Maybe$withDefault,
					a,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							lens.cm(c),
							A2($arturopala$elm_monocle$Monocle$Optional$flip, opt.cm, a)),
						opt.eb(a)));
			});
		var getOption = function (a) {
			var _v0 = opt.eb(a);
			if (!_v0.$) {
				var b = _v0.a;
				return $elm$core$Maybe$Just(
					lens.gE(b));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		return A2($arturopala$elm_monocle$Monocle$Optional$Optional, getOption, set);
	});
var $author$project$Pages$CfgDevice$Helpers$device = function (devId) {
	var set = F2(
		function (dev, devicesState) {
			if (devicesState.$ === 4) {
				var devices = devicesState.a;
				return $author$project$DataState$Ready(
					A3($elm$core$Dict$insert, devId, dev, devices));
			} else {
				return devicesState;
			}
		});
	var get = function (devicesState) {
		if (devicesState.$ === 4) {
			var devices = devicesState.a;
			return A2($elm$core$Dict$get, devId, devices);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	return A2($arturopala$elm_monocle$Monocle$Optional$Optional, get, set);
};
var $author$project$Pages$CfgDevice$Helpers$name = function (devId) {
	return A2(
		$arturopala$elm_monocle$Monocle$Optional$composeLens,
		$author$project$Pages$CfgDevice$Helpers$device(devId),
		A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.g8;
			},
			F2(
				function (v, d) {
					return _Utils_update(
						d,
						{g8: v});
				})));
};
var $author$project$Pages$CfgDevice$Core$deviceName = function (devId) {
	return A2(
		$arturopala$elm_monocle$Monocle$Optional$compose,
		$author$project$Pages$CfgDevice$Core$devicesOfModel,
		$author$project$Pages$CfgDevice$Helpers$name(devId));
};
var $author$project$Pages$CfgDevice$Helpers$school = function (devId) {
	return A2(
		$arturopala$elm_monocle$Monocle$Optional$composeLens,
		$author$project$Pages$CfgDevice$Helpers$device(devId),
		A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.du;
			},
			F2(
				function (v, d) {
					return _Utils_update(
						d,
						{du: v});
				})));
};
var $author$project$Pages$CfgDevice$Core$deviceSchool = function (devId) {
	return A2(
		$arturopala$elm_monocle$Monocle$Optional$compose,
		$author$project$Pages$CfgDevice$Core$devicesOfModel,
		$author$project$Pages$CfgDevice$Helpers$school(devId));
};
var $author$project$Pages$CfgDevice$Helpers$state = function (devId) {
	return A2(
		$arturopala$elm_monocle$Monocle$Optional$composeLens,
		$author$project$Pages$CfgDevice$Helpers$device(devId),
		A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.fJ;
			},
			F2(
				function (v, d) {
					return _Utils_update(
						d,
						{fJ: v});
				})));
};
var $author$project$Pages$CfgDevice$Core$deviceState = function (devId) {
	return A2(
		$arturopala$elm_monocle$Monocle$Optional$compose,
		$author$project$Pages$CfgDevice$Core$devicesOfModel,
		$author$project$Pages$CfgDevice$Helpers$state(devId));
};
var $author$project$Pages$CfgDevice$Core$getSelectedDevice = function (model) {
	var _v0 = _Utils_Tuple2(model.kV, model.ao);
	if ((!_v0.a.$) && (_v0.b.$ === 4)) {
		var id = _v0.a.a;
		var devices = _v0.b.a;
		return A2($elm$core$Dict$get, id, devices);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$CfgDevice$Design$DataCategories = function (a) {
	return {$: 68, a: a};
};
var $author$project$Pages$CfgDevice$Design$DataServingLines = function (a) {
	return {$: 69, a: a};
};
var $author$project$Entity$MealCategory$Category = F2(
	function (name, count) {
		return {k1: count, g8: name};
	});
var $elm$core$String$toUpper = _String_toUpper;
var $author$project$Entity$MealCategory$categoryDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeL,
		$elm$json$Json$Decode$succeed,
		$elm$core$List$map(
			function (cat) {
				return _Utils_update(
					cat,
					{
						g8: $elm$core$String$toUpper(cat.g8)
					});
			})),
	$elm$json$Json$Decode$list(
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'Count',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'Name',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Entity$MealCategory$Category)))));
var $author$project$Entity$MealCategory$loadData = F3(
	function (urlPrefix, school, toMsg) {
		var url = A3(
			$elm$url$Url$Builder$crossOrigin,
			urlPrefix,
			_List_fromArray(
				['api', 'GetDistinctCategories']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'SchoolId', school.aF)
				]));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, toMsg, $author$project$Entity$MealCategory$categoryDecoder),
				$lukewestby$elm_http_builder$HttpBuilder$get(url)));
	});
var $author$project$Entity$ServingLine$ServingLine = F2(
	function (name, count) {
		return {k1: count, g8: name};
	});
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$Entity$ServingLine$servingLineDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeL,
		$elm$json$Json$Decode$succeed,
		$elm$core$List$sortBy(
			function ($) {
				return $.g8;
			})),
	$elm$json$Json$Decode$list(
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'Count',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'Name',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Entity$ServingLine$ServingLine)))));
var $author$project$Entity$ServingLine$loadData = F3(
	function (urlPrefix, school, toMsg) {
		var url = A3(
			$elm$url$Url$Builder$crossOrigin,
			urlPrefix,
			_List_fromArray(
				['api', 'GetDistinctLines']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'SchoolId', school.aF)
				]));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, toMsg, $author$project$Entity$ServingLine$servingLineDecoder),
				$lukewestby$elm_http_builder$HttpBuilder$get(url)));
	});
var $author$project$Pages$CfgDevice$Design$loadData = F3(
	function (urlPrefix, device, sockId) {
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A3($author$project$Interop$Fabric$unicastMessage, sockId, 'REQ_AVAILABLE_TEMPLATES', $elm$json$Json$Encode$null),
					A3($author$project$Entity$MealCategory$loadData, urlPrefix, device.du, $author$project$Pages$CfgDevice$Design$DataCategories),
					A3($author$project$Entity$ServingLine$loadData, urlPrefix, device.du, $author$project$Pages$CfgDevice$Design$DataServingLines)
				]));
	});
var $author$project$Pages$CfgDevice$Schedule$Categories = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$CfgDevice$Schedule$ServingLines = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$CfgDevice$Schedule$loadData = F4(
	function (urlPrefix, deviceId, school, sockId) {
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A3($author$project$Interop$Fabric$unicastMessage, sockId, 'REQ_ALL_SCHEDULES', $elm$json$Json$Encode$null),
					A3($author$project$Interop$Fabric$unicastMessage, sockId, 'REQ_AVAILABLE_TEMPLATES', $elm$json$Json$Encode$null),
					A3($author$project$Entity$MealCategory$loadData, urlPrefix, school, $author$project$Pages$CfgDevice$Schedule$Categories),
					A3($author$project$Entity$ServingLine$loadData, urlPrefix, school, $author$project$Pages$CfgDevice$Schedule$ServingLines)
				]));
	});
var $author$project$Pages$CfgDevice$Settings$loadData = function (sockId) {
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				A3($author$project$Interop$Fabric$unicastMessage, sockId, 'REQ_STATUS_BAR_THEME', $elm$json$Json$Encode$null),
				A3($author$project$Interop$Fabric$unicastMessage, sockId, 'REQ_ALL_SCHEDULES', $elm$json$Json$Encode$null),
				A3($author$project$Interop$Fabric$unicastMessage, sockId, 'REQ_MANIFEST', $elm$json$Json$Encode$null),
				A3($author$project$Interop$Fabric$unicastMessage, sockId, 'REQ_SERIAL_NUMBER', $elm$json$Json$Encode$null),
				A3($author$project$Interop$Fabric$unicastMessage, sockId, 'REQ_CPU_INFO', $elm$json$Json$Encode$null),
				A3($author$project$Interop$Fabric$unicastMessage, sockId, 'REQ_MEM_INFO', $elm$json$Json$Encode$null),
				A3($author$project$Interop$Fabric$unicastMessage, sockId, 'REQ_SCREENSAVER', $elm$json$Json$Encode$null)
			]));
};
var $author$project$Pages$CfgDevice$Design$ReqTemplate = function (a) {
	return {$: 63, a: a};
};
var $author$project$Pages$CfgDevice$Design$loadTemplate = function (name) {
	return $author$project$Utils$cmd(
		$author$project$Pages$CfgDevice$Design$ReqTemplate(name));
};
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $author$project$Pages$CfgDevice$Helpers$sockIdOfDevice = function () {
	var set = F2(
		function (v, d) {
			return _Utils_update(
				d,
				{
					fJ: $author$project$Entity$Device$Online(v)
				});
		});
	var get = function (dev) {
		var _v0 = dev.fJ;
		if (!_v0.$) {
			var deviceSockId = _v0.a;
			return $elm$core$Maybe$Just(deviceSockId);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	return A2($arturopala$elm_monocle$Monocle$Optional$Optional, get, set);
}();
var $author$project$Pages$CfgDevice$Helpers$sockId = function (devId) {
	return A2(
		$arturopala$elm_monocle$Monocle$Optional$compose,
		$author$project$Pages$CfgDevice$Helpers$device(devId),
		$author$project$Pages$CfgDevice$Helpers$sockIdOfDevice);
};
var $author$project$Pages$CfgDevice$Core$sockId = function (devId) {
	return A2(
		$arturopala$elm_monocle$Monocle$Optional$compose,
		$author$project$Pages$CfgDevice$Core$devicesOfModel,
		$author$project$Pages$CfgDevice$Helpers$sockId(devId));
};
var $author$project$Pages$CfgDevice$Core$nameAndSockId = F2(
	function (devId, model) {
		var _v0 = _Utils_Tuple2(
			A2(
				function ($) {
					return $.eb;
				},
				$author$project$Pages$CfgDevice$Core$deviceName(devId),
				model),
			A2(
				function ($) {
					return $.eb;
				},
				$author$project$Pages$CfgDevice$Core$sockId(devId),
				model));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var a = _v0.a.a;
			var b = _v0.b.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(a, b));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$remove, key, dict);
	});
var $author$project$Pages$CfgDevice$Core$removeDevice = F2(
	function (devId, model) {
		return _Utils_update(
			model,
			{
				ao: function () {
					var _v0 = model.ao;
					if (_v0.$ === 4) {
						var devices = _v0.a;
						return $author$project$DataState$Ready(
							A2($elm$core$Dict$remove, devId, devices));
					} else {
						return model.ao;
					}
				}()
			});
	});
var $author$project$Interop$Fabric$postMessage = F2(
	function (event, payload) {
		return $author$project$Interop$Fabric$toFabric(
			{iF: event, jq: payload});
	});
var $author$project$Pages$CfgDevice$Core$reqAdminConnect = function (devId) {
	return A2(
		$author$project$Interop$Fabric$postMessage,
		'REQ_ADMIN_CONNECT',
		$elm$json$Json$Encode$string(devId));
};
var $author$project$Pages$CfgDevice$Schedule$reqCurrentSchedule = F2(
	function (deviceId, sockId) {
		return A3(
			$author$project$Interop$Fabric$unicastMessage,
			sockId,
			'REQ_CURR_SCHEDULE',
			$elm$json$Json$Encode$string(deviceId));
	});
var $author$project$Pages$CfgDevice$Core$toast = F2(
	function (content, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var message = $aforemny$material_components_web_elm$Material$Snackbar$message(content);
		var newQueue = A2($aforemny$material_components_web_elm$Material$Snackbar$addMessage, message, model.cp);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{cp: newQueue}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$CfgDevice$Design$FillData = {$: 97};
var $author$project$Entity$MenuPlanning$ImageReady = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$CfgDevice$Design$ImageUploadFail = 3;
var $author$project$Pages$CfgDevice$Design$ImageUploadSuccess = 2;
var $author$project$Pages$CfgDevice$Design$ImageUploading = 1;
var $author$project$Pages$CfgDevice$Design$ImagesError = {$: 1};
var $author$project$Pages$CfgDevice$Design$ImagesReady = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$CfgDevice$Design$LoadImage = F4(
	function (a, b, c, d) {
		return {$: 99, a: a, b: b, c: c, d: d};
	});
var $author$project$Pages$CfgDevice$Design$LoadMenuItemList = function (a) {
	return {$: 101, a: a};
};
var $author$project$Pages$CfgDevice$Design$MenuItems = F2(
	function (a, b) {
		return {$: 98, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Design$NewTemplateWithDate = F2(
	function (a, b) {
		return {$: 52, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Design$RetryLoadImage = F3(
	function (a, b, c) {
		return {$: 100, a: a, b: b, c: c};
	});
var $author$project$Pages$CfgDevice$Design$RotatePage = function (a) {
	return {$: 105, a: a};
};
var $author$project$Pages$CfgDevice$Design$SelectDate = function (a) {
	return {$: 95, a: a};
};
var $author$project$Pages$CfgDevice$Design$SelectLayoutTab = {$: 2};
var $author$project$Pages$CfgDevice$Design$SelectStyleTab = {$: 0};
var $author$project$Pages$CfgDevice$Design$SelectWidgetTab = {$: 1};
var $author$project$Pages$CfgDevice$Design$ShowFrame = {$: 103};
var $author$project$Pages$CfgDevice$Design$TemplateDelete = F2(
	function (a, b) {
		return {$: 48, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Design$TemplateNotSynced = 1;
var $author$project$Pages$CfgDevice$Design$ToCore = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$CfgDevice$Design$Toast = function (a) {
	return {$: 3, a: a};
};
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm_community$list_extra$List$Extra$splitAt = F2(
	function (n, xs) {
		return _Utils_Tuple2(
			A2($elm$core$List$take, n, xs),
			A2($elm$core$List$drop, n, xs));
	});
var $author$project$Utils$insertAt = F3(
	function (index, ele, elements) {
		return function (_v0) {
			var a = _v0.a;
			var b = _v0.b;
			return A2($elm$core$List$append, a, b);
		}(
			A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$List$cons(ele),
				A2($elm_community$list_extra$List$Extra$splitAt, index, elements)));
	});
var $author$project$Template$Frame$addColumn = F2(
	function (colIndex, frame) {
		return _Utils_update(
			frame,
			{
				da: A3(
					$author$project$Utils$insertAt,
					colIndex,
					{
						ae: 1,
						jJ: _List_fromArray(
							[$author$project$Template$Widget$Core$EmptySection])
					},
					frame.da)
			});
	});
var $elm_community$list_extra$List$Extra$updateAt = F3(
	function (index, fn, list) {
		if (index < 0) {
			return list;
		} else {
			var tail = A2($elm$core$List$drop, index, list);
			var head = A2($elm$core$List$take, index, list);
			if (tail.b) {
				var x = tail.a;
				var xs = tail.b;
				return _Utils_ap(
					head,
					A2(
						$elm$core$List$cons,
						fn(x),
						xs));
			} else {
				return list;
			}
		}
	});
var $author$project$Template$Frame$addRow = F3(
	function (colIndex, rowIndex, frame) {
		return _Utils_update(
			frame,
			{
				da: A3(
					$elm_community$list_extra$List$Extra$updateAt,
					colIndex,
					function (col) {
						return _Utils_update(
							col,
							{
								jJ: A3($author$project$Utils$insertAt, rowIndex, $author$project$Template$Widget$Core$EmptySection, col.jJ)
							});
					},
					frame.da)
			});
	});
var $author$project$Template$Frame$addBottomSection = F3(
	function (colIndex, rowIndex, frame) {
		var _v0 = frame.fz;
		if (!_v0) {
			return A3($author$project$Template$Frame$addRow, colIndex, rowIndex + 1, frame);
		} else {
			return A2($author$project$Template$Frame$addColumn, colIndex + 1, frame);
		}
	});
var $author$project$Template$Core$update = F3(
	function (frIndex, mapFrame, template) {
		return _Utils_update(
			template,
			{
				G: A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, frame) {
							return _Utils_eq(index, frIndex) ? mapFrame(frame) : frame;
						}),
					template.G)
			});
	});
var $author$project$Template$Helpers$addBottomSection = F2(
	function (_v0, template) {
		var frameIndex = _v0.ap;
		var columnIndex = _v0.C;
		var rowIndex = _v0.y;
		return A3(
			$author$project$Template$Core$update,
			frameIndex,
			A2($author$project$Template$Frame$addBottomSection, columnIndex, rowIndex),
			template);
	});
var $author$project$Template$Frame$addLeftSection = F3(
	function (colIndex, rowIndex, frame) {
		var _v0 = frame.fz;
		if (!_v0) {
			return A2($author$project$Template$Frame$addColumn, colIndex, frame);
		} else {
			return A3($author$project$Template$Frame$addRow, colIndex, rowIndex, frame);
		}
	});
var $author$project$Template$Helpers$addLeftSection = F2(
	function (_v0, template) {
		var frameIndex = _v0.ap;
		var columnIndex = _v0.C;
		var rowIndex = _v0.y;
		return A3(
			$author$project$Template$Core$update,
			frameIndex,
			A2($author$project$Template$Frame$addLeftSection, columnIndex, rowIndex),
			template);
	});
var $author$project$Template$Frame$empty = {
	f6: $author$project$Template$Widget$Background$bgColor('radial-gradient(rgb(97, 97, 97), rgb(66, 66, 66), rgb(33, 33, 33))'),
	ag: false,
	lH: 10,
	da: _List_fromArray(
		[
			{
			ae: 1,
			jJ: _List_fromArray(
				[$author$project$Template$Widget$Core$EmptySection])
		}
		]),
	fz: 0
};
var $author$project$Entity$Style$sharedCss = F3(
	function (styleName, attrs, css) {
		return _Utils_Tuple2(
			styleName,
			{
				a$: $elm$core$Dict$fromList(css),
				d1: A2($elm$core$List$member, 1, attrs),
				d2: A2($elm$core$List$member, 0, attrs)
			});
	});
var $author$project$Entity$Style$textStyle = 0;
var $author$project$Template$Helpers$addNewTemplate = F3(
	function (adminName, createdOn, name) {
		return {
			k2: adminName,
			iw: createdOn,
			G: _List_fromArray(
				[$author$project$Template$Frame$empty]),
			eh: true,
			g8: name,
			ho: false,
			z: $elm$core$Dict$fromList(
				_List_fromArray(
					[
						A3(
						$author$project$Entity$Style$sharedCss,
						'Category Name',
						_List_fromArray(
							[$author$project$Entity$Style$textStyle]),
						_List_fromArray(
							[
								_Utils_Tuple2('font-size', '96px'),
								_Utils_Tuple2('font-family', 'Monoton'),
								_Utils_Tuple2('font-weight', 'lighter'),
								_Utils_Tuple2('text-align', 'center'),
								_Utils_Tuple2('color', '#FFFFFF')
							])),
						A3(
						$author$project$Entity$Style$sharedCss,
						'Location',
						_List_fromArray(
							[$author$project$Entity$Style$textStyle]),
						_List_fromArray(
							[
								_Utils_Tuple2('display', 'initial'),
								_Utils_Tuple2('font-size', '32px')
							])),
						A3(
						$author$project$Entity$Style$sharedCss,
						'Menu Planning - Image',
						_List_Nil,
						_List_fromArray(
							[
								_Utils_Tuple2('display', 'initial')
							])),
						A3(
						$author$project$Entity$Style$sharedCss,
						'Menu Planning - Calories',
						_List_fromArray(
							[$author$project$Entity$Style$textStyle]),
						_List_fromArray(
							[
								_Utils_Tuple2('font-size', '34px'),
								_Utils_Tuple2('font-family', 'Fjalla One'),
								_Utils_Tuple2('color', '#000000')
							])),
						A3(
						$author$project$Entity$Style$sharedCss,
						'Menu Planning - Ratings',
						_List_Nil,
						_List_fromArray(
							[
								_Utils_Tuple2('color', '#CCAA00')
							])),
						A3(
						$author$project$Entity$Style$sharedCss,
						'Menu Planning - Food Components',
						_List_Nil,
						_List_fromArray(
							[
								_Utils_Tuple2('display', 'initial')
							])),
						A3(
						$author$project$Entity$Style$sharedCss,
						'Menu Planning - Description',
						_List_fromArray(
							[$author$project$Entity$Style$textStyle]),
						_List_fromArray(
							[
								_Utils_Tuple2('font-size', '48px'),
								_Utils_Tuple2('font-family', 'Fjalla One'),
								_Utils_Tuple2('color', '#000000'),
								_Utils_Tuple2('background', '#FFFFFF')
							])),
						A3(
						$author$project$Entity$Style$sharedCss,
						'Menu Item List - Title',
						_List_fromArray(
							[$author$project$Entity$Style$textStyle]),
						_List_fromArray(
							[
								_Utils_Tuple2('font-size', '48px'),
								_Utils_Tuple2('font-family', 'Fjalla One'),
								_Utils_Tuple2('color', '#FFFFFF'),
								_Utils_Tuple2('background', 'transparent'),
								_Utils_Tuple2('text-align', 'center')
							])),
						A3(
						$author$project$Entity$Style$sharedCss,
						'Menu Item List - Description',
						_List_fromArray(
							[$author$project$Entity$Style$textStyle]),
						_List_fromArray(
							[
								_Utils_Tuple2('font-size', '32px'),
								_Utils_Tuple2('font-family', 'Fjalla One'),
								_Utils_Tuple2('color', '#FFFFFF'),
								_Utils_Tuple2('background', 'transparent')
							])),
						A3(
						$author$project$Entity$Style$sharedCss,
						'Image Widget',
						_List_fromArray(
							[$author$project$Entity$Style$elSize]),
						_List_fromArray(
							[
								_Utils_Tuple2('display', 'initial'),
								_Utils_Tuple2('width', '98%'),
								_Utils_Tuple2('height', '98%')
							]))
					])),
			aX: $elm$core$Set$fromList(
				_List_fromArray(
					['Designed'])),
			n: $elm$core$Dict$empty
		};
	});
var $author$project$Template$Frame$addRightSection = F3(
	function (colIndex, rowIndex, frame) {
		var _v0 = frame.fz;
		if (!_v0) {
			return A2($author$project$Template$Frame$addColumn, colIndex + 1, frame);
		} else {
			return A3($author$project$Template$Frame$addRow, colIndex, rowIndex + 1, frame);
		}
	});
var $author$project$Template$Helpers$addRightSection = F2(
	function (_v0, template) {
		var frameIndex = _v0.ap;
		var columnIndex = _v0.C;
		var rowIndex = _v0.y;
		return A3(
			$author$project$Template$Core$update,
			frameIndex,
			A2($author$project$Template$Frame$addRightSection, columnIndex, rowIndex),
			template);
	});
var $author$project$Template$Frame$addTopSection = F3(
	function (colIndex, rowIndex, frame) {
		var _v0 = frame.fz;
		if (!_v0) {
			return A3($author$project$Template$Frame$addRow, colIndex, rowIndex, frame);
		} else {
			return A2($author$project$Template$Frame$addColumn, colIndex, frame);
		}
	});
var $author$project$Template$Helpers$addTopSection = F2(
	function (_v0, template) {
		var frameIndex = _v0.ap;
		var columnIndex = _v0.C;
		var rowIndex = _v0.y;
		return A3(
			$author$project$Template$Core$update,
			frameIndex,
			A2($author$project$Template$Frame$addTopSection, columnIndex, rowIndex),
			template);
	});
var $author$project$Pages$CfgDevice$Design$PublishTemplate = F2(
	function (a, b) {
		return {$: 64, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Design$autoSave = function (template) {
	return template.eh ? $author$project$Utils$cmd(
		A2(
			$author$project$Pages$CfgDevice$Design$PublishTemplate,
			template,
			{hi: false})) : $elm$core$Platform$Cmd$none;
};
var $author$project$Pages$CfgDevice$Design$autoSaveStyle = function (template) {
	return template.eh ? $author$project$Utils$cmd(
		A2(
			$author$project$Pages$CfgDevice$Design$PublishTemplate,
			template,
			{hi: true})) : $elm$core$Platform$Cmd$none;
};
var $author$project$Entity$Style$empty = {a$: $elm$core$Dict$empty, d1: false, d2: false};
var $author$project$Entity$Style$toBounded = F2(
	function (sharedStyles, style) {
		if (style.$ === 1) {
			var css = style.a;
			return $author$project$Entity$Style$BoundedStyle(css);
		} else {
			var id = style.a;
			return $author$project$Entity$Style$BoundedStyle(
				A2(
					$elm$core$Maybe$withDefault,
					$author$project$Entity$Style$empty,
					A2($elm$core$Dict$get, id, sharedStyles)));
		}
	});
var $author$project$Template$Helpers$bindStyle = F2(
	function (template, a) {
		return _Utils_update(
			a,
			{
				cs: A2($author$project$Entity$Style$toBounded, template.z, a.cs)
			});
	});
var $author$project$Template$Helpers$bindSharedStyle = F3(
	function (template, maybeInnerStyle, widget) {
		switch (widget.$) {
			case 1:
				var config = widget.a;
				_v1$2:
				while (true) {
					if (!maybeInnerStyle.$) {
						switch (maybeInnerStyle.a) {
							case 1:
								var _v2 = maybeInnerStyle.a;
								return $author$project$Template$Widget$Core$TextBox(
									_Utils_update(
										config,
										{
											cs: A2($author$project$Entity$Style$toBounded, template.z, config.cs)
										}));
							case 0:
								var _v3 = maybeInnerStyle.a;
								return $author$project$Template$Widget$Core$TextBox(
									_Utils_update(
										config,
										{
											dB: A2($author$project$Entity$Style$toBounded, template.z, config.dB)
										}));
							default:
								break _v1$2;
						}
					} else {
						break _v1$2;
					}
				}
				return widget;
			case 2:
				var config = widget.a;
				return $author$project$Template$Widget$Core$Image(
					A2($author$project$Template$Helpers$bindStyle, template, config));
			case 4:
				var config = widget.a;
				if (!maybeInnerStyle.$) {
					switch (maybeInnerStyle.a) {
						case 1:
							var _v5 = maybeInnerStyle.a;
							return $author$project$Template$Widget$Core$MenuPlanning(
								_Utils_update(
									config,
									{
										na: A2($author$project$Entity$Style$toBounded, template.z, config.na)
									}));
						case 0:
							var _v6 = maybeInnerStyle.a;
							return $author$project$Template$Widget$Core$MenuPlanning(
								_Utils_update(
									config,
									{
										da: A2($author$project$Entity$Style$toBounded, template.z, config.da)
									}));
						case 2:
							var _v7 = maybeInnerStyle.a;
							return $author$project$Template$Widget$Core$MenuPlanning(
								_Utils_update(
									config,
									{
										gY: A2($author$project$Entity$Style$toBounded, template.z, config.gY)
									}));
						case 3:
							var _v8 = maybeInnerStyle.a;
							return $author$project$Template$Widget$Core$MenuPlanning(
								_Utils_update(
									config,
									{
										gL: A2($author$project$Entity$Style$toBounded, template.z, config.gL)
									}));
						case 6:
							var _v9 = maybeInnerStyle.a;
							return $author$project$Template$Widget$Core$MenuPlanning(
								_Utils_update(
									config,
									{
										k9: A2($author$project$Entity$Style$toBounded, template.z, config.k9)
									}));
						case 4:
							var _v10 = maybeInnerStyle.a;
							return $author$project$Template$Widget$Core$MenuPlanning(
								_Utils_update(
									config,
									{
										kR: A2($author$project$Entity$Style$toBounded, template.z, config.kR)
									}));
						case 5:
							var _v11 = maybeInnerStyle.a;
							return $author$project$Template$Widget$Core$MenuPlanning(
								_Utils_update(
									config,
									{
										mf: A2($author$project$Entity$Style$toBounded, template.z, config.mf)
									}));
						case 7:
							var _v12 = maybeInnerStyle.a;
							return $author$project$Template$Widget$Core$MenuPlanning(
								_Utils_update(
									config,
									{
										gA: A2($author$project$Entity$Style$toBounded, template.z, config.gA)
									}));
						default:
							var _v13 = maybeInnerStyle.a;
							return widget;
					}
				} else {
					return widget;
				}
			case 5:
				var config = widget.a;
				_v14$3:
				while (true) {
					if (!maybeInnerStyle.$) {
						switch (maybeInnerStyle.a) {
							case 1:
								var _v15 = maybeInnerStyle.a;
								return $author$project$Template$Widget$Core$MenuItemListWidget(
									_Utils_update(
										config,
										{
											na: A2($author$project$Entity$Style$toBounded, template.z, config.na)
										}));
							case 6:
								var _v16 = maybeInnerStyle.a;
								return $author$project$Template$Widget$Core$MenuItemListWidget(
									_Utils_update(
										config,
										{
											k9: A2($author$project$Entity$Style$toBounded, template.z, config.k9)
										}));
							case 8:
								var _v17 = maybeInnerStyle.a;
								return $author$project$Template$Widget$Core$MenuItemListWidget(
									_Utils_update(
										config,
										{
											hw: A2($author$project$Entity$Style$toBounded, template.z, config.hw)
										}));
							default:
								break _v14$3;
						}
					} else {
						break _v14$3;
					}
				}
				return widget;
			default:
				return widget;
		}
	});
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $author$project$Template$Frame$widgetIds = F2(
	function (filterShared, frame) {
		return A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			A2(
				$elm$core$List$map,
				function (sec) {
					switch (sec.$) {
						case 2:
							return '';
						case 1:
							var id = sec.a;
							return filterShared ? '' : id;
						default:
							var id = sec.a;
							return id;
					}
				},
				$elm$core$List$concat(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.jJ;
						},
						frame.da))));
	});
var $author$project$Template$Core$widgetIds = F2(
	function (filterShared, template) {
		return $elm$core$List$concat(
			A2(
				$elm$core$List$map,
				$author$project$Template$Frame$widgetIds(filterShared),
				template.G));
	});
var $author$project$Template$Core$cleanup = function (template) {
	return _Utils_update(
		template,
		{
			n: A2(
				$elm$core$Dict$filter,
				F2(
					function (key, _v0) {
						return A2(
							$elm$core$List$member,
							key,
							A2($author$project$Template$Core$widgetIds, false, template));
					}),
				template.n)
		});
};
var $author$project$Template$BuiltIn$categoryName = 'Category Name';
var $author$project$Template$BuiltIn$locationStyle = 'Location';
var $author$project$Template$Widget$Core$menuPlanning = function (config) {
	return $author$project$Template$Widget$Core$MenuPlanning(config);
};
var $author$project$Template$BuiltIn$menuPlanningCal = 'Menu Planning - Calories';
var $author$project$Template$BuiltIn$menuPlanningComponents = 'Menu Planning - Food Components';
var $author$project$Template$BuiltIn$menuPlanningDesc = 'Menu Planning - Description';
var $author$project$Template$BuiltIn$menuPlanningImg = 'Menu Planning - Image';
var $author$project$Template$BuiltIn$menuPlanningRatings = 'Menu Planning - Ratings';
var $author$project$Entity$Style$shared = function (id) {
	return $author$project$Entity$Style$SharedStyle(id);
};
var $author$project$Template$BuiltIn$menuPlanningWidget = function (config) {
	return $author$project$Template$Widget$Core$menuPlanning(
		{
			bf: config.bf,
			kR: $author$project$Entity$Style$shared($author$project$Template$BuiltIn$menuPlanningCal),
			ip: config.ip,
			iq: $elm$core$Maybe$Just(config.iq),
			k9: $author$project$Entity$Style$shared($author$project$Template$BuiltIn$menuPlanningDesc),
			gA: $author$project$Entity$Style$shared($author$project$Template$BuiltIn$menuPlanningComponents),
			gL: $author$project$Entity$Style$shared($author$project$Template$BuiltIn$menuPlanningImg),
			da: $author$project$Entity$Style$bounded(
				{
					a$: $elm$core$Dict$fromList(
						_List_fromArray(
							[
								_Utils_Tuple2('visibility', 'visible'),
								_Utils_Tuple2('width', '98%'),
								_Utils_Tuple2('height', '100%')
							])),
					d1: true,
					d2: false
				}),
			gY: $author$project$Entity$Style$shared($author$project$Template$BuiltIn$locationStyle),
			ai: $elm$core$Maybe$Nothing,
			ej: config.ej,
			aj: config.aj,
			mf: $author$project$Entity$Style$shared($author$project$Template$BuiltIn$menuPlanningRatings),
			hD: 1,
			mz: $elm$core$Maybe$Nothing,
			na: $author$project$Entity$Style$shared($author$project$Template$BuiltIn$categoryName)
		});
};
var $author$project$Template$BuiltIn$addMenuPlanningWidget = F2(
	function (id, config) {
		return A2(
			$elm$core$Dict$insert,
			id,
			$author$project$Template$BuiltIn$menuPlanningWidget(config));
	});
var $author$project$Template$Widget$Background$bgUnsplash = function (imageName) {
	return A3($author$project$Template$Widget$Background$BgImage, 'https://iili.io/' + imageName, 50, 0);
};
var $author$project$Template$Widget$MenuPlanning$compactCard = 3;
var $author$project$Template$Animation$fadeTop = 2;
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Template$Frame$horizontal = 0;
var $author$project$Template$BuiltIn$widgetId = F2(
	function (name, widgetName) {
		return name + ('-' + widgetName);
	});
var $author$project$Template$BuiltIn$menuWidgetId = F2(
	function (index, category) {
		return A2(
			$author$project$Template$BuiltIn$widgetId,
			category + ('--' + $elm$core$String$fromInt(index)),
			'menuplanning');
	});
var $author$project$Template$BuiltIn$auraExtraFrame = F2(
	function (_v0, _v1) {
		var category = _v0.a;
		var menuItems = _v0.b;
		var index = _v1.a;
		var frames = _v1.b;
		var widgets = _v1.c;
		var bg = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Template$Widget$Background$bgUnsplash('2FpwOOv.jpeg'),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.f6;
				},
				$elm$core$List$head(frames)));
		return _Utils_Tuple3(
			index + 1,
			A2(
				$elm$core$List$append,
				frames,
				_List_fromArray(
					[
						{
						f6: bg,
						ag: false,
						lH: 10,
						da: _List_fromArray(
							[
								{
								ae: 1,
								jJ: _List_fromArray(
									[$author$project$Template$Widget$Core$EmptySection])
							},
								{
								ae: 1,
								jJ: _List_fromArray(
									[
										$author$project$Template$Widget$Core$BoundedWidget(
										A2($author$project$Template$BuiltIn$menuWidgetId, index, category))
									])
							},
								{
								ae: 1,
								jJ: _List_fromArray(
									[$author$project$Template$Widget$Core$EmptySection])
							}
							]),
						fz: $author$project$Template$Frame$horizontal
					}
					])),
			A3(
				$author$project$Template$BuiltIn$addMenuPlanningWidget,
				A2($author$project$Template$BuiltIn$menuWidgetId, index, category),
				{
					bf: $author$project$Template$Animation$fadeTop,
					ip: $author$project$Template$Widget$MenuPlanning$compactCard,
					iq: category,
					ej: 8,
					aj: A2(
						$elm$core$List$map,
						function ($) {
							return $.aF;
						},
						menuItems)
				},
				widgets));
	});
var $author$project$Template$Widget$Background$bgBlack = $author$project$Template$Widget$Background$bgColor('radial-gradient(rgb(97, 97, 97), rgb(66, 66, 66), rgb(33, 33, 33))');
var $author$project$Template$Animation$flipVertical = 6;
var $author$project$Template$Widget$MenuPlanning$smallCard = 2;
var $author$project$Template$BuiltIn$cosmosExtraFrame = F2(
	function (_v0, _v1) {
		var category = _v0.a;
		var menuItems = _v0.b;
		var index = _v1.a;
		var frames = _v1.b;
		var widgets = _v1.c;
		var bg = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Template$Widget$Background$bgBlack,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.f6;
				},
				$elm$core$List$head(frames)));
		return _Utils_Tuple3(
			index + 1,
			A2(
				$elm$core$List$append,
				frames,
				_List_fromArray(
					[
						{
						f6: bg,
						ag: false,
						lH: 10,
						da: _List_fromArray(
							[
								{
								ae: 1,
								jJ: _List_fromArray(
									[
										$author$project$Template$Widget$Core$BoundedWidget(
										A2($author$project$Template$BuiltIn$menuWidgetId, index, category))
									])
							}
							]),
						fz: $author$project$Template$Frame$horizontal
					}
					])),
			A3(
				$author$project$Template$BuiltIn$addMenuPlanningWidget,
				A2($author$project$Template$BuiltIn$menuWidgetId, index, category),
				{
					bf: $author$project$Template$Animation$flipVertical,
					ip: $author$project$Template$Widget$MenuPlanning$smallCard,
					iq: category,
					ej: 6,
					aj: A2(
						$elm$core$List$map,
						function ($) {
							return $.aF;
						},
						menuItems)
				},
				widgets));
	});
var $author$project$Template$BuiltIn$etherealExtraFrame = F2(
	function (_v0, _v1) {
		var category = _v0.a;
		var menuItems = _v0.b;
		var index = _v1.a;
		var frames = _v1.b;
		var widgets = _v1.c;
		var bg = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Template$Widget$Background$bgUnsplash('2FpwebR.jpeg'),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.f6;
				},
				$elm$core$List$head(frames)));
		return _Utils_Tuple3(
			index + 1,
			A2(
				$elm$core$List$append,
				frames,
				_List_fromArray(
					[
						{
						f6: bg,
						ag: false,
						lH: 10,
						da: _List_fromArray(
							[
								{
								ae: 1,
								jJ: _List_fromArray(
									[
										$author$project$Template$Widget$Core$BoundedWidget(
										A2($author$project$Template$BuiltIn$menuWidgetId, index, category))
									])
							},
								{
								ae: 1,
								jJ: _List_fromArray(
									[
										$author$project$Template$Widget$Core$SharedWidget('Intro Video'),
										$author$project$Template$Widget$Core$EmptySection
									])
							}
							]),
						fz: $author$project$Template$Frame$horizontal
					}
					])),
			A3(
				$elm$core$Dict$insert,
				A2($author$project$Template$BuiltIn$menuWidgetId, index, category),
				$author$project$Template$Widget$Core$MenuPlanning(
					{
						bf: $author$project$Template$Animation$fadeIn,
						kR: $author$project$Entity$Style$shared($author$project$Template$BuiltIn$menuPlanningCal),
						ip: $author$project$Template$Widget$MenuPlanning$smallCard,
						iq: $elm$core$Maybe$Just(category),
						k9: $author$project$Entity$Style$shared($author$project$Template$BuiltIn$menuPlanningDesc),
						gA: $author$project$Entity$Style$shared($author$project$Template$BuiltIn$menuPlanningComponents),
						gL: $author$project$Entity$Style$shared($author$project$Template$BuiltIn$menuPlanningImg),
						da: $author$project$Entity$Style$bounded(
							{
								a$: $elm$core$Dict$fromList(
									_List_fromArray(
										[
											_Utils_Tuple2('visibility', 'visibile'),
											_Utils_Tuple2('width', '98%'),
											_Utils_Tuple2('height', '100%')
										])),
								d1: true,
								d2: false
							}),
						gY: $author$project$Entity$Style$shared($author$project$Template$BuiltIn$locationStyle),
						ai: $elm$core$Maybe$Nothing,
						ej: 6,
						aj: A2(
							$elm$core$List$map,
							function ($) {
								return $.aF;
							},
							menuItems),
						mf: $author$project$Entity$Style$shared($author$project$Template$BuiltIn$menuPlanningRatings),
						hD: 1,
						mz: $elm$core$Maybe$Nothing,
						na: $author$project$Entity$Style$shared($author$project$Template$BuiltIn$categoryName)
					}),
				widgets));
	});
var $author$project$Template$Widget$MenuPlanning$bigCard = 1;
var $author$project$Template$Animation$flipHorizontal = 7;
var $author$project$Template$BuiltIn$singularityExtraFrame = F2(
	function (_v0, _v1) {
		var category = _v0.a;
		var menuItems = _v0.b;
		var index = _v1.a;
		var frames = _v1.b;
		var widgets = _v1.c;
		var bg = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Template$Widget$Background$bgUnsplash('2FpwOOv.jpeg'),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.f6;
				},
				$elm$core$List$head(frames)));
		return _Utils_Tuple3(
			index + 1,
			A2(
				$elm$core$List$append,
				frames,
				_List_fromArray(
					[
						{
						f6: bg,
						ag: false,
						lH: 10,
						da: _List_fromArray(
							[
								{
								ae: 1,
								jJ: _List_fromArray(
									[
										$author$project$Template$Widget$Core$BoundedWidget(
										A2($author$project$Template$BuiltIn$menuWidgetId, index, category))
									])
							}
							]),
						fz: $author$project$Template$Frame$horizontal
					}
					])),
			A3(
				$author$project$Template$BuiltIn$addMenuPlanningWidget,
				A2($author$project$Template$BuiltIn$menuWidgetId, index, category),
				{
					bf: $author$project$Template$Animation$flipHorizontal,
					ip: $author$project$Template$Widget$MenuPlanning$bigCard,
					iq: category,
					ej: 4,
					aj: A2(
						$elm$core$List$map,
						function ($) {
							return $.aF;
						},
						menuItems)
				},
				widgets));
	});
var $author$project$Template$BuiltIn$createFrame = F3(
	function (templateName, a, b) {
		switch (templateName) {
			case 'Sonorous':
				return A2($author$project$Template$BuiltIn$singularityExtraFrame, a, b);
			case 'Singularity':
				return A2($author$project$Template$BuiltIn$singularityExtraFrame, a, b);
			case 'Carpe Diem':
				return A2($author$project$Template$BuiltIn$cosmosExtraFrame, a, b);
			case 'Cosmos':
				return A2($author$project$Template$BuiltIn$cosmosExtraFrame, a, b);
			case 'Aurora':
				return A2($author$project$Template$BuiltIn$auraExtraFrame, a, b);
			case 'Aura':
				return A2($author$project$Template$BuiltIn$auraExtraFrame, a, b);
			case 'Epiphany':
				return A2($author$project$Template$BuiltIn$etherealExtraFrame, a, b);
			case 'Ethereal':
				return A2($author$project$Template$BuiltIn$etherealExtraFrame, a, b);
			default:
				return A2($author$project$Template$BuiltIn$cosmosExtraFrame, a, b);
		}
	});
var $jschomay$elm_bounded_number$Number$Bounded$value = function (_v0) {
	var n = _v0.by;
	return n;
};
var $jschomay$elm_paginate$Paginate$Custom$currentPage = function (_v0) {
	var currentPage_ = _v0.O;
	return $jschomay$elm_bounded_number$Number$Bounded$value(currentPage_);
};
var $jschomay$elm_paginate$Paginate$currentPage = $jschomay$elm_paginate$Paginate$Custom$currentPage;
var $elm_community$list_extra$List$Extra$removeAt = F2(
	function (index, l) {
		if (index < 0) {
			return l;
		} else {
			var _v0 = A2($elm$core$List$drop, index, l);
			if (!_v0.b) {
				return l;
			} else {
				var rest = _v0.b;
				return _Utils_ap(
					A2($elm$core$List$take, index, l),
					rest);
			}
		}
	});
var $author$project$Template$Frame$delColumn = F2(
	function (colIndex, frame) {
		return _Utils_update(
			frame,
			{
				da: A2($elm_community$list_extra$List$Extra$removeAt, colIndex, frame.da)
			});
	});
var $author$project$Template$Helpers$delColumn = F2(
	function (_v0, template) {
		var frameIndex = _v0.ap;
		var columnIndex = _v0.C;
		return $author$project$Template$Core$cleanup(
			A3(
				$author$project$Template$Core$update,
				frameIndex,
				$author$project$Template$Frame$delColumn(columnIndex),
				template));
	});
var $author$project$Template$Frame$delRow = F3(
	function (colIndex, rowIndex, frame) {
		return _Utils_update(
			frame,
			{
				da: A3(
					$elm_community$list_extra$List$Extra$updateAt,
					colIndex,
					function (col) {
						return _Utils_update(
							col,
							{
								jJ: A2($elm_community$list_extra$List$Extra$removeAt, rowIndex, col.jJ)
							});
					},
					frame.da)
			});
	});
var $author$project$Template$Helpers$delRow = F2(
	function (_v0, template) {
		var frameIndex = _v0.ap;
		var columnIndex = _v0.C;
		var rowIndex = _v0.y;
		return $author$project$Template$Core$cleanup(
			A3(
				$author$project$Template$Core$update,
				frameIndex,
				A2($author$project$Template$Frame$delRow, columnIndex, rowIndex),
				template));
	});
var $author$project$Template$Core$deleteFrame = F2(
	function (frIndex, template) {
		return $author$project$Template$Core$cleanup(
			_Utils_update(
				template,
				{
					G: A2($elm_community$list_extra$List$Extra$removeAt, frIndex, template.G)
				}));
	});
var $elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $author$project$Template$Frame$replaceId = F2(
	function (_v0, frame) {
		var oldId = _v0.a;
		var newId = _v0.b;
		var updateSection = function (section) {
			if (!section.$) {
				var id = section.a;
				return _Utils_eq(id, oldId) ? $author$project$Template$Widget$Core$BoundedWidget(newId) : $author$project$Template$Widget$Core$BoundedWidget(id);
			} else {
				return section;
			}
		};
		var updateColumnFunc = function (col) {
			return _Utils_update(
				col,
				{
					jJ: A2($elm$core$List$map, updateSection, col.jJ)
				});
		};
		return _Utils_update(
			frame,
			{
				da: A2($elm$core$List$map, updateColumnFunc, frame.da)
			});
	});
var $elm$random$Random$step = F2(
	function (_v0, seed) {
		var generator = _v0;
		return generator(seed);
	});
var $danyx23$elm_uuid$Uuid$toString = function (_v0) {
	var internalString = _v0;
	return internalString;
};
var $danyx23$elm_uuid$Uuid$Uuid = $elm$core$Basics$identity;
var $elm$random$Random$Generator = $elm$core$Basics$identity;
var $elm$random$Random$map = F2(
	function (func, _v0) {
		var genA = _v0;
		return function (seed0) {
			var _v1 = genA(seed0);
			var a = _v1.a;
			var seed1 = _v1.b;
			return _Utils_Tuple2(
				func(a),
				seed1);
		};
	});
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $elm$random$Random$peel = function (_v0) {
	var state = _v0.a;
	var word = (state ^ (state >>> ((state >>> 28) + 4))) * 277803737;
	return ((word >>> 22) ^ word) >>> 0;
};
var $elm$random$Random$int = F2(
	function (a, b) {
		return function (seed0) {
			var _v0 = (_Utils_cmp(a, b) < 0) ? _Utils_Tuple2(a, b) : _Utils_Tuple2(b, a);
			var lo = _v0.a;
			var hi = _v0.b;
			var range = (hi - lo) + 1;
			if (!((range - 1) & range)) {
				return _Utils_Tuple2(
					(((range - 1) & $elm$random$Random$peel(seed0)) >>> 0) + lo,
					$elm$random$Random$next(seed0));
			} else {
				var threshhold = (((-range) >>> 0) % range) >>> 0;
				var accountForBias = function (seed) {
					accountForBias:
					while (true) {
						var x = $elm$random$Random$peel(seed);
						var seedN = $elm$random$Random$next(seed);
						if (_Utils_cmp(x, threshhold) < 0) {
							var $temp$seed = seedN;
							seed = $temp$seed;
							continue accountForBias;
						} else {
							return _Utils_Tuple2((x % range) + lo, seedN);
						}
					}
				};
				return accountForBias(seed0);
			}
		};
	});
var $danyx23$elm_uuid$Uuid$Barebones$hexGenerator = A2($elm$random$Random$int, 0, 15);
var $elm$random$Random$listHelp = F4(
	function (revList, n, gen, seed) {
		listHelp:
		while (true) {
			if (n < 1) {
				return _Utils_Tuple2(revList, seed);
			} else {
				var _v0 = gen(seed);
				var value = _v0.a;
				var newSeed = _v0.b;
				var $temp$revList = A2($elm$core$List$cons, value, revList),
					$temp$n = n - 1,
					$temp$gen = gen,
					$temp$seed = newSeed;
				revList = $temp$revList;
				n = $temp$n;
				gen = $temp$gen;
				seed = $temp$seed;
				continue listHelp;
			}
		}
	});
var $elm$random$Random$list = F2(
	function (n, _v0) {
		var gen = _v0;
		return function (seed) {
			return A4($elm$random$Random$listHelp, _List_Nil, n, gen, seed);
		};
	});
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $elm$core$String$fromList = _String_fromList;
var $elm$core$Bitwise$or = _Bitwise_or;
var $danyx23$elm_uuid$Uuid$Barebones$limitDigitRange8ToB = function (digit) {
	return (digit & 3) | 8;
};
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $elm$core$Char$fromCode = _Char_fromCode;
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{M: nodeList, F: nodeListSize, J: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $danyx23$elm_uuid$Uuid$Barebones$hexDigits = function () {
	var mapChars = F2(
		function (offset, digit) {
			return $elm$core$Char$fromCode(digit + offset);
		});
	return $elm$core$Array$fromList(
		_Utils_ap(
			A2(
				$elm$core$List$map,
				mapChars(48),
				A2($elm$core$List$range, 0, 9)),
			A2(
				$elm$core$List$map,
				mapChars(97),
				A2($elm$core$List$range, 0, 5))));
}();
var $danyx23$elm_uuid$Uuid$Barebones$mapToHex = function (index) {
	var maybeResult = A2($elm$core$Array$get, index, $danyx23$elm_uuid$Uuid$Barebones$hexDigits);
	if (maybeResult.$ === 1) {
		return 'x';
	} else {
		var result = maybeResult.a;
		return result;
	}
};
var $danyx23$elm_uuid$Uuid$Barebones$toUuidString = function (thirtyOneHexDigits) {
	return $elm$core$String$concat(
		_List_fromArray(
			[
				$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					$danyx23$elm_uuid$Uuid$Barebones$mapToHex,
					A2($elm$core$List$take, 8, thirtyOneHexDigits))),
				'-',
				$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					$danyx23$elm_uuid$Uuid$Barebones$mapToHex,
					A2(
						$elm$core$List$take,
						4,
						A2($elm$core$List$drop, 8, thirtyOneHexDigits)))),
				'-',
				'4',
				$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					$danyx23$elm_uuid$Uuid$Barebones$mapToHex,
					A2(
						$elm$core$List$take,
						3,
						A2($elm$core$List$drop, 12, thirtyOneHexDigits)))),
				'-',
				$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					$danyx23$elm_uuid$Uuid$Barebones$mapToHex,
					A2(
						$elm$core$List$map,
						$danyx23$elm_uuid$Uuid$Barebones$limitDigitRange8ToB,
						A2(
							$elm$core$List$take,
							1,
							A2($elm$core$List$drop, 15, thirtyOneHexDigits))))),
				$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					$danyx23$elm_uuid$Uuid$Barebones$mapToHex,
					A2(
						$elm$core$List$take,
						3,
						A2($elm$core$List$drop, 16, thirtyOneHexDigits)))),
				'-',
				$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					$danyx23$elm_uuid$Uuid$Barebones$mapToHex,
					A2(
						$elm$core$List$take,
						12,
						A2($elm$core$List$drop, 19, thirtyOneHexDigits))))
			]));
};
var $danyx23$elm_uuid$Uuid$Barebones$uuidStringGenerator = A2(
	$elm$random$Random$map,
	$danyx23$elm_uuid$Uuid$Barebones$toUuidString,
	A2($elm$random$Random$list, 31, $danyx23$elm_uuid$Uuid$Barebones$hexGenerator));
var $danyx23$elm_uuid$Uuid$uuidGenerator = A2($elm$random$Random$map, $elm$core$Basics$identity, $danyx23$elm_uuid$Uuid$Barebones$uuidStringGenerator);
var $author$project$Template$Helpers$duplicateFrame = F3(
	function (initSeed, frameIndex, template) {
		var insWidget = F2(
			function (_v3, widgets) {
				var oldId = _v3.a;
				var newId = _v3.b;
				return A3(
					$elm$core$Dict$insert,
					newId,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Template$Widget$Core$Empty,
						A2($elm$core$Dict$get, oldId, widgets)),
					widgets);
			});
		var genId = F2(
			function (_v1, _v2) {
				var widgetIds = _v2.a;
				var seed = _v2.b;
				return A2(
					$elm$core$Tuple$mapFirst,
					A2(
						$elm$core$Basics$composeR,
						$danyx23$elm_uuid$Uuid$toString,
						function (a) {
							return A2($elm$core$List$cons, a, widgetIds);
						}),
					A2($elm$random$Random$step, $danyx23$elm_uuid$Uuid$uuidGenerator, seed));
			});
		var frame = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Template$Frame$empty,
			A2($elm_community$list_extra$List$Extra$getAt, frameIndex, template.G));
		var oldIds = A2($author$project$Template$Frame$widgetIds, true, frame);
		var _v0 = A3(
			$elm$core$List$foldl,
			genId,
			_Utils_Tuple2(_List_Nil, initSeed),
			oldIds);
		var newIds = _v0.a;
		var newSeed = _v0.b;
		var idMap = A3(
			$elm$core$List$map2,
			F2(
				function (a, b) {
					return _Utils_Tuple2(a, b);
				}),
			oldIds,
			newIds);
		var updatedFrame = A3($elm$core$List$foldl, $author$project$Template$Frame$replaceId, frame, idMap);
		var updatedWidgets = A3($elm$core$List$foldl, insWidget, template.n, idMap);
		return _Utils_Tuple2(
			_Utils_update(
				template,
				{
					G: A3($author$project$Utils$insertAt, frameIndex + 1, updatedFrame, template.G),
					n: updatedWidgets
				}),
			newSeed);
	});
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$json$Json$Encode$dict = F3(
	function (toKey, toValue, dictionary) {
		return _Json_wrap(
			A3(
				$elm$core$Dict$foldl,
				F3(
					function (key, value, obj) {
						return A3(
							_Json_addField,
							toKey(key),
							toValue(value),
							obj);
					}),
				_Json_emptyObject(0),
				dictionary));
	});
var $author$project$Template$Frame$Orientation$encode = function (orientation) {
	if (!orientation) {
		return $elm$json$Json$Encode$string('horizontal');
	} else {
		return $elm$json$Json$Encode$string('vertical');
	}
};
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$Template$Widget$Background$encode = function (bgType) {
	switch (bgType.$) {
		case 0:
			var color = bgType.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'bgType',
						$elm$json$Json$Encode$string('color')),
						_Utils_Tuple2(
						'value',
						$elm$json$Json$Encode$string(color))
					]));
		case 1:
			var imgUrl = bgType.a;
			var brightness = bgType.b;
			var blur = bgType.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'bgType',
						$elm$json$Json$Encode$string('image')),
						_Utils_Tuple2(
						'value',
						$elm$json$Json$Encode$string(imgUrl)),
						_Utils_Tuple2(
						'brightness',
						$elm$json$Json$Encode$float(brightness)),
						_Utils_Tuple2(
						'blur',
						$elm$json$Json$Encode$float(blur))
					]));
		default:
			var adminUrl = bgType.a;
			var localUrl = bgType.b;
			var brightness = bgType.c;
			var blur = bgType.d;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'bgType',
						$elm$json$Json$Encode$string('local-image')),
						_Utils_Tuple2(
						'localUrl',
						$elm$json$Json$Encode$string(localUrl)),
						_Utils_Tuple2(
						'adminUrl',
						$elm$json$Json$Encode$string(adminUrl)),
						_Utils_Tuple2(
						'brightness',
						$elm$json$Json$Encode$float(brightness)),
						_Utils_Tuple2(
						'blur',
						$elm$json$Json$Encode$float(blur))
					]));
	}
};
var $author$project$Template$Widget$Core$encodeSection = function (section) {
	switch (section.$) {
		case 0:
			var id = section.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'section',
						$elm$json$Json$Encode$string('bounded')),
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$string(id))
					]));
		case 1:
			var id = section.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'section',
						$elm$json$Json$Encode$string('shared')),
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$string(id))
					]));
		default:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'section',
						$elm$json$Json$Encode$string('empty'))
					]));
	}
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$Template$Frame$encodeColumn = function (col) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'rows',
				A2(
					$elm$json$Json$Encode$list,
					$elm$core$Basics$identity,
					A2($elm$core$List$map, $author$project$Template$Widget$Core$encodeSection, col.jJ))),
				_Utils_Tuple2(
				'flexGrow',
				$elm$json$Json$Encode$int(col.ae))
			]));
};
var $author$project$Template$Frame$encode = function (frame) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'interval',
				$elm$json$Json$Encode$float(frame.lH)),
				_Utils_Tuple2(
				'layout',
				A2(
					$elm$json$Json$Encode$list,
					$elm$core$Basics$identity,
					A2($elm$core$List$map, $author$project$Template$Frame$encodeColumn, frame.da))),
				_Utils_Tuple2(
				'orientation',
				$author$project$Template$Frame$Orientation$encode(frame.fz)),
				_Utils_Tuple2(
				'gradientBg',
				$elm$json$Json$Encode$bool(frame.ag)),
				_Utils_Tuple2(
				'background',
				$author$project$Template$Widget$Background$encode(frame.f6))
			]));
};
var $author$project$Entity$Style$encodeCss = function (css) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'enableTextStyle',
				$elm$json$Json$Encode$bool(css.d2)),
				_Utils_Tuple2(
				'enableSize',
				$elm$json$Json$Encode$bool(css.d1)),
				_Utils_Tuple2(
				'css',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$json$Json$Encode$string, css.a$))
			]));
};
var $author$project$Entity$Style$encode = function (style) {
	if (style.$ === 1) {
		var css = style.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'style',
					$elm$json$Json$Encode$string('bounded')),
					_Utils_Tuple2(
					'value',
					$author$project$Entity$Style$encodeCss(css))
				]));
	} else {
		var val = style.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'style',
					$elm$json$Json$Encode$string('shared')),
					_Utils_Tuple2(
					'value',
					$elm$json$Json$Encode$string(val))
				]));
	}
};
var $author$project$Template$Animation$encode = function (effect) {
	var str = function () {
		switch (effect) {
			case 0:
				return 'appear';
			case 1:
				return 'fade-in';
			case 2:
				return 'fade-top';
			case 5:
				return 'fade-bottom';
			case 6:
				return 'flip-vertical';
			case 7:
				return 'flip-horizontal';
			case 4:
				return 'fade-right';
			default:
				return 'fade-left';
		}
	}();
	return $elm$json$Json$Encode$string(str);
};
var $author$project$Template$Widget$Image$encode = function (config) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'anim',
				$author$project$Template$Animation$encode(config.bf)),
				_Utils_Tuple2(
				'style',
				$author$project$Entity$Style$encode(config.cs)),
				_Utils_Tuple2(
				'imageUrl',
				$elm$json$Json$Encode$string(config.ly)),
				_Utils_Tuple2(
				'size',
				$elm$json$Json$Encode$string(config.dB))
			]));
};
var $author$project$Template$Widget$MenuItemList$encode = function (config) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'listId',
				$elm$json$Json$Encode$string(config.i7)),
				_Utils_Tuple2(
				'anim',
				$author$project$Template$Animation$encode(config.bf)),
				_Utils_Tuple2(
				'listName',
				$elm$json$Json$Encode$string(config.E)),
				_Utils_Tuple2(
				'title',
				$author$project$Entity$Style$encode(config.na)),
				_Utils_Tuple2(
				'description',
				$author$project$Entity$Style$encode(config.k9)),
				_Utils_Tuple2(
				'pricing',
				$author$project$Entity$Style$encode(config.hw))
			]));
};
var $author$project$Template$Widget$MenuPlanning$encodeCardSize = function (cardSize) {
	switch (cardSize) {
		case 0:
			return $elm$json$Json$Encode$string('overlay-image');
		case 1:
			return $elm$json$Json$Encode$string('big');
		case 2:
			return $elm$json$Json$Encode$string('small');
		default:
			return $elm$json$Json$Encode$string('compact');
	}
};
var $elm_community$json_extra$Json$Encode$Extra$maybe = function (encoder) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(encoder),
		$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
};
var $author$project$Template$Widget$MenuPlanning$encode = function (config) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'servingLine',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, config.mz)),
				_Utils_Tuple2(
				'category',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, config.iq)),
				_Utils_Tuple2(
				'marketingName',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, config.ai)),
				_Utils_Tuple2(
				'maxItems',
				$elm$json$Json$Encode$int(config.ej)),
				_Utils_Tuple2(
				'menuItems',
				A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, _List_Nil)),
				_Utils_Tuple2(
				'anim',
				$author$project$Template$Animation$encode(config.bf)),
				_Utils_Tuple2(
				'scaleFactor',
				$elm$json$Json$Encode$float(config.hD)),
				_Utils_Tuple2(
				'layout',
				$author$project$Entity$Style$encode(config.da)),
				_Utils_Tuple2(
				'title',
				$author$project$Entity$Style$encode(config.na)),
				_Utils_Tuple2(
				'location',
				$author$project$Entity$Style$encode(config.gY)),
				_Utils_Tuple2(
				'image',
				$author$project$Entity$Style$encode(config.gL)),
				_Utils_Tuple2(
				'description',
				$author$project$Entity$Style$encode(config.k9)),
				_Utils_Tuple2(
				'calories',
				$author$project$Entity$Style$encode(config.kR)),
				_Utils_Tuple2(
				'ratings',
				$author$project$Entity$Style$encode(config.mf)),
				_Utils_Tuple2(
				'foodComponents',
				$author$project$Entity$Style$encode(config.gA)),
				_Utils_Tuple2(
				'cardSize',
				$author$project$Template$Widget$MenuPlanning$encodeCardSize(config.ip))
			]));
};
var $author$project$Template$Widget$TextBox$encode = function (config) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'style',
				$author$project$Entity$Style$encode(config.cs)),
				_Utils_Tuple2(
				'size',
				$author$project$Entity$Style$encode(config.dB)),
				_Utils_Tuple2(
				'anim',
				$author$project$Template$Animation$encode(config.bf)),
				_Utils_Tuple2(
				'text',
				$elm$json$Json$Encode$string(config.hO))
			]));
};
var $author$project$Template$Widget$Youtube$encode = function (config) {
	var _v0 = config.ka;
	if (!_v0.$) {
		var vidId = _v0.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'videoType',
					$elm$json$Json$Encode$string('video')),
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(vidId)),
					_Utils_Tuple2(
					'width',
					$elm$json$Json$Encode$float(config.hY)),
					_Utils_Tuple2(
					'height',
					$elm$json$Json$Encode$float(config.gH))
				]));
	} else {
		var listId = _v0.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'videoType',
					$elm$json$Json$Encode$string('playlist')),
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(listId)),
					_Utils_Tuple2(
					'width',
					$elm$json$Json$Encode$float(config.hY)),
					_Utils_Tuple2(
					'height',
					$elm$json$Json$Encode$float(config.gH))
				]));
	}
};
var $author$project$Template$Widget$Core$encode = function (widget) {
	switch (widget.$) {
		case 0:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'widget',
						$elm$json$Json$Encode$string('empty'))
					]));
		case 1:
			var config = widget.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'widget',
						$elm$json$Json$Encode$string('text-box')),
						_Utils_Tuple2(
						'config',
						$author$project$Template$Widget$TextBox$encode(config))
					]));
		case 2:
			var config = widget.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'widget',
						$elm$json$Json$Encode$string('image')),
						_Utils_Tuple2(
						'config',
						$author$project$Template$Widget$Image$encode(config))
					]));
		case 3:
			var config = widget.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'widget',
						$elm$json$Json$Encode$string('youtube')),
						_Utils_Tuple2(
						'config',
						$author$project$Template$Widget$Youtube$encode(config))
					]));
		case 4:
			var config = widget.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'widget',
						$elm$json$Json$Encode$string('menu-planning')),
						_Utils_Tuple2(
						'config',
						$author$project$Template$Widget$MenuPlanning$encode(config))
					]));
		default:
			var config = widget.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'widget',
						$elm$json$Json$Encode$string('menu-item-list')),
						_Utils_Tuple2(
						'config',
						$author$project$Template$Widget$MenuItemList$encode(config))
					]));
	}
};
var $author$project$Entity$Style$encodeSharedStyles = A2($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Entity$Style$encodeCss);
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {iA: d, ja: m, nr: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		hj: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		nr: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.nr, 0, date.hj);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.iA;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.ja;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.hj;
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		kb: 1 + (((rd - week1Day1) / 7) | 0),
		kc: wy,
		nn: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.kb;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.kc;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.fs(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.g7(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.fs(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.gj(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.cD(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.cD(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.cD(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.hX(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.cD(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.cD(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.c, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	gj: $justinmimbs$date$Date$withOrdinalSuffix,
	g7: $justinmimbs$date$Date$monthToName,
	fs: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	hX: $justinmimbs$date$Date$weekdayToName,
	cD: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$Template$Core$encode = function (template) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(template.g8)),
				_Utils_Tuple2(
				'createdBy',
				$elm$json$Json$Encode$string(template.k2)),
				_Utils_Tuple2(
				'createdOn',
				$elm$json$Json$Encode$string(
					$justinmimbs$date$Date$toIsoString(template.iw))),
				_Utils_Tuple2(
				'tags',
				A2(
					$elm$json$Json$Encode$list,
					$elm$core$Basics$identity,
					A2(
						$elm$core$List$map,
						$elm$json$Json$Encode$string,
						$elm$core$Set$toList(template.aX)))),
				_Utils_Tuple2(
				'frames',
				A2(
					$elm$json$Json$Encode$list,
					$elm$core$Basics$identity,
					A2($elm$core$List$map, $author$project$Template$Frame$encode, template.G))),
				_Utils_Tuple2(
				'widgets',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Template$Widget$Core$encode, template.n)),
				_Utils_Tuple2(
				'styles',
				$author$project$Entity$Style$encodeSharedStyles(template.z)),
				_Utils_Tuple2(
				'liveEdit',
				$elm$json$Json$Encode$bool(template.eh)),
				_Utils_Tuple2(
				'partiallyFill',
				$elm$json$Json$Encode$bool(template.ho))
			]));
};
var $author$project$Template$UpdateConfig$encode = function (config) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'onlyStyleUpdate',
				$elm$json$Json$Encode$bool(config.hi))
			]));
};
var $author$project$DataState$error = function (err) {
	return $author$project$DataState$Error(err);
};
var $elm_community$list_extra$List$Extra$greedyGroupsOfWithStep = F3(
	function (size, step, xs) {
		var xs_ = A2($elm$core$List$drop, step, xs);
		var okayXs = $elm$core$List$length(xs) > 0;
		var okayArgs = (size > 0) && (step > 0);
		return (okayArgs && okayXs) ? A2(
			$elm$core$List$cons,
			A2($elm$core$List$take, size, xs),
			A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, step, xs_)) : _List_Nil;
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOf = F2(
	function (size, xs) {
		return A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, size, xs);
	});
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$Set$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$Set$insert, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$unique = function (list) {
	return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, $elm$core$Set$empty, list, _List_Nil);
};
var $author$project$Template$Helpers$categoryItems = F2(
	function (numOf, items) {
		var itemsInCategory = function (name) {
			return A2(
				$elm$core$List$map,
				function (groupedItems) {
					return _Utils_Tuple2(name, groupedItems);
				},
				A2(
					$elm_community$list_extra$List$Extra$greedyGroupsOf,
					numOf,
					A2(
						$elm$core$List$filter,
						function (item) {
							return _Utils_eq(
								$elm$core$String$toUpper(item.iq),
								$elm$core$String$toUpper(name));
						},
						items)));
		};
		var categories = $elm_community$list_extra$List$Extra$unique(
			A2(
				$elm$core$List$map,
				$elm$core$String$toUpper,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.iq;
					},
					items)));
		return $elm$core$List$concat(
			A2($elm$core$List$map, itemsInCategory, categories));
	});
var $author$project$Template$Widget$MenuPlanning$fillMenuItem = F2(
	function (item, config) {
		var _v0 = _Utils_Tuple2(config.mz, config.iq);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var servLine = _v0.a.a;
				var category = _v0.b.a;
				return ((_Utils_cmp(
					$elm$core$List$length(config.aj),
					config.ej) < 0) && (_Utils_eq(servLine, item.mz) && _Utils_eq(
					$elm$core$String$toUpper(category),
					$elm$core$String$toUpper(item.iq)))) ? _Utils_update(
					config,
					{
						aj: A2($elm$core$List$cons, item.aF, config.aj)
					}) : config;
			} else {
				var _v2 = _v0.b;
				return config;
			}
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var category = _v0.b.a;
				return ((_Utils_cmp(
					$elm$core$List$length(config.aj),
					config.ej) < 0) && _Utils_eq(
					$elm$core$String$toUpper(category),
					$elm$core$String$toUpper(item.iq))) ? _Utils_update(
					config,
					{
						aj: A2($elm$core$List$cons, item.aF, config.aj)
					}) : config;
			} else {
				var _v3 = _v0.a;
				var _v4 = _v0.b;
				return config;
			}
		}
	});
var $author$project$Template$Widget$Core$fillMenuItem = F2(
	function (item, widget) {
		if (widget.$ === 4) {
			var config = widget.a;
			return $author$project$Template$Widget$Core$MenuPlanning(
				A2($author$project$Template$Widget$MenuPlanning$fillMenuItem, item, config));
		} else {
			return widget;
		}
	});
var $author$project$Template$Helpers$updateWidget = F3(
	function (wid, widgetToWidget, widgetDict) {
		return A3(
			$elm$core$Dict$update,
			wid,
			function (maybeW) {
				if (!maybeW.$) {
					var wi_ = maybeW.a;
					return $elm$core$Maybe$Just(
						widgetToWidget(wi_));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			widgetDict);
	});
var $author$project$Template$Helpers$fillTemplate = F4(
	function (hasItem, fillItem, items, origTemplate) {
		var fillOnce = F2(
			function (item, template) {
				return function (ws) {
					return _Utils_update(
						template,
						{n: ws});
				}(
					A3(
						$elm$core$List$foldl,
						F2(
							function (id, widgetDict) {
								return A2(
									$elm$core$List$any,
									$elm$core$Basics$identity,
									A2(
										$elm$core$List$map,
										hasItem(item),
										$elm$core$Dict$values(widgetDict))) ? widgetDict : A3(
									$author$project$Template$Helpers$updateWidget,
									id,
									fillItem(item),
									widgetDict);
							}),
						template.n,
						$elm_community$list_extra$List$Extra$unique(
							$elm$core$List$concat(
								A2(
									$elm$core$List$map,
									$author$project$Template$Frame$widgetIds(false),
									template.G)))));
			});
		return A3($elm$core$List$foldl, fillOnce, origTemplate, items);
	});
var $author$project$Template$Widget$MenuPlanning$hasMenuItem = F2(
	function (menuItem, config) {
		return A2($elm$core$List$member, menuItem.aF, config.aj);
	});
var $author$project$Template$Widget$Core$hasMenuItem = F2(
	function (menuItem, widget) {
		if (widget.$ === 4) {
			var config = widget.a;
			return A2($author$project$Template$Widget$MenuPlanning$hasMenuItem, menuItem, config);
		} else {
			return false;
		}
	});
var $elm_community$list_extra$List$Extra$uniqueBy = F2(
	function (f, list) {
		return A4($elm_community$list_extra$List$Extra$uniqueHelp, f, $elm$core$Set$empty, list, _List_Nil);
	});
var $author$project$Template$Widget$Core$getCategories = function (widgets) {
	return $elm$core$Dict$fromList(
		A2(
			$elm_community$list_extra$List$Extra$uniqueBy,
			$elm$core$Tuple$first,
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
					$elm$core$Tuple$first),
				A2(
					$elm$core$List$map,
					function (widget) {
						if (widget.$ === 4) {
							var category = widget.a.iq;
							var servingLine = widget.a.mz;
							if (!category.$) {
								var cat = category.a;
								return _Utils_Tuple2(
									$elm$core$String$toUpper(cat),
									servingLine);
							} else {
								return _Utils_Tuple2('', $elm$core$Maybe$Nothing);
							}
						} else {
							return _Utils_Tuple2('', $elm$core$Maybe$Nothing);
						}
					},
					$elm$core$Dict$values(widgets)))));
};
var $author$project$Template$Helpers$leftOverItems = F3(
	function (hasItem, template, items) {
		var hasWidgetItem = function (item) {
			return A2(
				$elm$core$List$any,
				hasItem(item),
				$elm$core$Dict$values(template.n));
		};
		return A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, hasWidgetItem),
			items);
	});
var $author$project$Template$Helpers$leftOverMenuItems = F2(
	function (template, menuItems) {
		return A2(
			$elm$core$List$filter,
			function (item) {
				var itemCategory = $elm$core$String$toUpper(item.iq);
				var categories = $author$project$Template$Widget$Core$getCategories(template.n);
				var _v0 = A2($elm$core$Dict$get, itemCategory, categories);
				if (!_v0.$) {
					if (!_v0.a.$) {
						var srvLine = _v0.a.a;
						return _Utils_eq(srvLine, item.mz);
					} else {
						var _v1 = _v0.a;
						return true;
					}
				} else {
					return false;
				}
			},
			A3($author$project$Template$Helpers$leftOverItems, $author$project$Template$Widget$Core$hasMenuItem, template, menuItems));
	});
var $author$project$Template$Helpers$fillMenuItemsInTemplate = F3(
	function (menuItems, createFrame, emptyTemplate) {
		var partiallyFilled = A4($author$project$Template$Helpers$fillTemplate, $author$project$Template$Widget$Core$hasMenuItem, $author$project$Template$Widget$Core$fillMenuItem, menuItems, emptyTemplate);
		var droppedItems = A2(
			$elm_community$list_extra$List$Extra$uniqueBy,
			function ($) {
				return $.mg;
			},
			A2($author$project$Template$Helpers$leftOverMenuItems, partiallyFilled, menuItems));
		var _v0 = function (_v1) {
			var f = _v1.b;
			var w = _v1.c;
			return _Utils_Tuple2(f, w);
		}(
			A3(
				$elm$core$List$foldl,
				createFrame,
				_Utils_Tuple3(1, partiallyFilled.G, partiallyFilled.n),
				A2($author$project$Template$Helpers$categoryItems, 4, droppedItems)));
		var frames = _v0.a;
		var widgets = _v0.b;
		return (!partiallyFilled.ho) ? _Utils_update(
			partiallyFilled,
			{G: frames, n: widgets}) : partiallyFilled;
	});
var $elm_community$list_extra$List$Extra$filterNot = F2(
	function (pred, list) {
		return A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, pred),
			list);
	});
var $author$project$Template$Frame$background = A2(
	$arturopala$elm_monocle$Monocle$Lens$Lens,
	function ($) {
		return $.f6;
	},
	F2(
		function (v, f) {
			return _Utils_update(
				f,
				{f6: v});
		}));
var $author$project$Template$Helpers$frameBackground = F3(
	function (frIndex, value, template) {
		return _Utils_update(
			template,
			{
				G: A3(
					$elm_community$list_extra$List$Extra$updateAt,
					frIndex,
					A2(
						function ($) {
							return $.cm;
						},
						$author$project$Template$Frame$background,
						value),
					template.G)
			});
	});
var $author$project$Template$Frame$interval = A2(
	$arturopala$elm_monocle$Monocle$Lens$Lens,
	function ($) {
		return $.lH;
	},
	F2(
		function (v, f) {
			return _Utils_update(
				f,
				{lH: v});
		}));
var $author$project$Template$Helpers$frameInterval = F3(
	function (frIndex, value, template) {
		return _Utils_update(
			template,
			{
				G: A3(
					$elm_community$list_extra$List$Extra$updateAt,
					frIndex,
					A2(
						function ($) {
							return $.cm;
						},
						$author$project$Template$Frame$interval,
						value),
					template.G)
			});
	});
var $author$project$Template$Frame$orientation = A2(
	$arturopala$elm_monocle$Monocle$Lens$Lens,
	function ($) {
		return $.fz;
	},
	F2(
		function (v, f) {
			return _Utils_update(
				f,
				{fz: v});
		}));
var $author$project$Template$Helpers$frameOrientation = F3(
	function (frIndex, value, template) {
		return _Utils_update(
			template,
			{
				G: A3(
					$elm_community$list_extra$List$Extra$updateAt,
					frIndex,
					A2(
						function ($) {
							return $.cm;
						},
						$author$project$Template$Frame$orientation,
						value),
					template.G)
			});
	});
var $elm$core$String$fromFloat = _String_fromNumber;
var $jschomay$elm_paginate$Paginate$Custom$page = F2(
	function (sliceFn, _v0) {
		var itemsPerPage_ = _v0.fj;
		var currentPage_ = _v0.O;
		var items = _v0.lM;
		var from = ($jschomay$elm_bounded_number$Number$Bounded$value(currentPage_) - 1) * itemsPerPage_;
		var to = from + itemsPerPage_;
		return A3(sliceFn, from, to, items);
	});
var $jschomay$elm_paginate$Paginate$page = $jschomay$elm_paginate$Paginate$Custom$page(
	F2(
		function (from, to) {
			return A2(
				$elm$core$Basics$composeR,
				$elm$core$List$drop(from),
				$elm$core$List$take(to - from));
		}));
var $author$project$Template$Helpers$getLiveWidgets = function (maybeLiveTemplate) {
	return A2(
		$elm$core$Maybe$andThen,
		function (template) {
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					A2(
						$author$project$Template$Frame$widgetIds,
						false,
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Template$Frame$empty,
							$elm$core$List$head(
								$jschomay$elm_paginate$Paginate$page(template.G)))),
					template.n));
		},
		maybeLiveTemplate);
};
var $author$project$Template$Widget$Core$getMenuItemListIds = function (widgets) {
	return A2(
		$elm$core$List$filter,
		A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
		$elm_community$list_extra$List$Extra$unique(
			A2(
				$elm$core$List$map,
				function (widget) {
					if (widget.$ === 5) {
						var listId = widget.a.i7;
						return listId;
					} else {
						return '';
					}
				},
				$elm$core$Dict$values(widgets))));
};
var $author$project$Entity$Style$getSharedId = function (style) {
	if (!style.$) {
		var id = style.a;
		return $elm$core$Maybe$Just(id);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Template$Helpers$getSharedStyle = F2(
	function (maybeInnerStyle, widget) {
		switch (widget.$) {
			case 1:
				var cfg = widget.a;
				if (maybeInnerStyle.$ === 1) {
					return $author$project$Entity$Style$getSharedId(cfg.cs);
				} else {
					switch (maybeInnerStyle.a) {
						case 0:
							var _v2 = maybeInnerStyle.a;
							return $author$project$Entity$Style$getSharedId(cfg.dB);
						case 1:
							var _v3 = maybeInnerStyle.a;
							return $author$project$Entity$Style$getSharedId(cfg.cs);
						default:
							return $elm$core$Maybe$Nothing;
					}
				}
			case 2:
				var style = widget.a.cs;
				return $author$project$Entity$Style$getSharedId(style);
			case 4:
				var cfg = widget.a;
				if (maybeInnerStyle.$ === 1) {
					return $author$project$Entity$Style$getSharedId(cfg.da);
				} else {
					switch (maybeInnerStyle.a) {
						case 0:
							var _v5 = maybeInnerStyle.a;
							return $author$project$Entity$Style$getSharedId(cfg.da);
						case 1:
							var _v6 = maybeInnerStyle.a;
							return $author$project$Entity$Style$getSharedId(cfg.na);
						case 2:
							var _v7 = maybeInnerStyle.a;
							return $author$project$Entity$Style$getSharedId(cfg.gY);
						case 3:
							var _v8 = maybeInnerStyle.a;
							return $author$project$Entity$Style$getSharedId(cfg.gL);
						case 6:
							var _v9 = maybeInnerStyle.a;
							return $author$project$Entity$Style$getSharedId(cfg.k9);
						case 4:
							var _v10 = maybeInnerStyle.a;
							return $author$project$Entity$Style$getSharedId(cfg.kR);
						case 5:
							var _v11 = maybeInnerStyle.a;
							return $author$project$Entity$Style$getSharedId(cfg.mf);
						case 8:
							var _v12 = maybeInnerStyle.a;
							return $elm$core$Maybe$Nothing;
						default:
							var _v13 = maybeInnerStyle.a;
							return $author$project$Entity$Style$getSharedId(cfg.gA);
					}
				}
			case 5:
				var cfg = widget.a;
				if (maybeInnerStyle.$ === 1) {
					return $author$project$Entity$Style$getSharedId(cfg.k9);
				} else {
					switch (maybeInnerStyle.a) {
						case 1:
							var _v15 = maybeInnerStyle.a;
							return $author$project$Entity$Style$getSharedId(cfg.na);
						case 6:
							var _v16 = maybeInnerStyle.a;
							return $author$project$Entity$Style$getSharedId(cfg.k9);
						case 8:
							var _v17 = maybeInnerStyle.a;
							return $author$project$Entity$Style$getSharedId(cfg.hw);
						default:
							return $elm$core$Maybe$Nothing;
					}
				}
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Template$Helpers$getSection = F2(
	function (template, position) {
		return A2(
			$elm$core$Maybe$andThen,
			function (column) {
				return A2($elm_community$list_extra$List$Extra$getAt, position.y, column.jJ);
			},
			A2(
				$elm$core$Maybe$andThen,
				function (frame) {
					return A2($elm_community$list_extra$List$Extra$getAt, position.C, frame.da);
				},
				A2($elm_community$list_extra$List$Extra$getAt, position.ap, template.G)));
	});
var $author$project$Template$Helpers$getWidgetId = F2(
	function (template, position) {
		return A2(
			$elm$core$Maybe$andThen,
			function (sec) {
				switch (sec.$) {
					case 0:
						var id = sec.a;
						return $elm$core$Maybe$Just(id);
					case 1:
						var id = sec.a;
						return $elm$core$Maybe$Just(id);
					default:
						return $elm$core$Maybe$Nothing;
				}
			},
			A2($author$project$Template$Helpers$getSection, template, position));
	});
var $author$project$Template$Helpers$getWidget = F2(
	function (template, position) {
		return A2(
			$elm$core$Maybe$andThen,
			function (wid) {
				return A2(
					$elm$core$Maybe$andThen,
					function (w) {
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(wid, w));
					},
					A2($elm$core$Dict$get, wid, template.n));
			},
			A2($author$project$Template$Helpers$getWidgetId, template, position));
	});
var $jschomay$elm_paginate$Paginate$Custom$Paginated = $elm$core$Basics$identity;
var $jschomay$elm_bounded_number$Number$Bounded$Bounded = $elm$core$Basics$identity;
var $jschomay$elm_bounded_number$Number$Bounded$set = F2(
	function (n, _v0) {
		var min = _v0.fq;
		var max = _v0.fn;
		return {
			fn: max,
			fq: min,
			by: A3($elm$core$Basics$clamp, min, max, n)
		};
	});
var $jschomay$elm_paginate$Paginate$Custom$goTo = F2(
	function (i, _v0) {
		var p = _v0;
		return _Utils_update(
			p,
			{
				O: A2($jschomay$elm_bounded_number$Number$Bounded$set, i, p.O)
			});
	});
var $jschomay$elm_paginate$Paginate$goTo = $jschomay$elm_paginate$Paginate$Custom$goTo;
var $author$project$Template$Core$goToFrame = F2(
	function (frameNum, template) {
		return _Utils_update(
			template,
			{
				G: A2($jschomay$elm_paginate$Paginate$goTo, frameNum, template.G)
			});
	});
var $author$project$Template$Animation$appear = 0;
var $mdgriffith$elm_style_animation$Animation$Model$Animation = $elm$core$Basics$identity;
var $mdgriffith$elm_style_animation$Animation$extractInitialWait = function (steps) {
	var _v0 = $elm$core$List$head(steps);
	if (_v0.$ === 1) {
		return _Utils_Tuple2(
			$elm$time$Time$millisToPosix(0),
			_List_Nil);
	} else {
		var step = _v0.a;
		if (step.$ === 4) {
			var till = step.a;
			var _v2 = $mdgriffith$elm_style_animation$Animation$extractInitialWait(
				A2($elm$core$List$drop, 1, steps));
			var additionalTime = _v2.a;
			var remainingSteps = _v2.b;
			return _Utils_Tuple2(
				$elm$time$Time$millisToPosix(
					$elm$time$Time$posixToMillis(till) + $elm$time$Time$posixToMillis(additionalTime)),
				remainingSteps);
		} else {
			return _Utils_Tuple2(
				$elm$time$Time$millisToPosix(0),
				steps);
		}
	}
};
var $mdgriffith$elm_style_animation$Animation$interrupt = F2(
	function (steps, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				gT: A2(
					$elm$core$List$cons,
					$mdgriffith$elm_style_animation$Animation$extractInitialWait(steps),
					model.gT),
				fF: true
			});
	});
var $mdgriffith$elm_style_animation$Animation$initialState = function (current) {
	return {
		gT: _List_Nil,
		fF: false,
		hK: _List_Nil,
		cs: current,
		j$: {
			ix: $elm$time$Time$millisToPosix(0),
			lb: $elm$time$Time$millisToPosix(0)
		}
	};
};
var $mdgriffith$elm_style_animation$Animation$Model$Easing = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$Spring = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$pi = _Basics_pi;
var $mdgriffith$elm_style_animation$Animation$Model$AtSpeed = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_style_animation$Animation$speed = function (speedValue) {
	return $mdgriffith$elm_style_animation$Animation$Model$AtSpeed(speedValue);
};
var $mdgriffith$elm_style_animation$Animation$defaultInterpolationByProperty = function (prop) {
	var linear = function (duration) {
		return $mdgriffith$elm_style_animation$Animation$Model$Easing(
			{gn: duration, go: $elm$core$Basics$identity, hx: 1, hJ: 0});
	};
	var defaultSpring = $mdgriffith$elm_style_animation$Animation$Model$Spring(
		{iz: 26, jW: 170});
	switch (prop.$) {
		case 0:
			return defaultSpring;
		case 1:
			return linear(
				$elm$time$Time$millisToPosix(400));
		case 2:
			return defaultSpring;
		case 3:
			return defaultSpring;
		case 4:
			return defaultSpring;
		case 5:
			var name = prop.a;
			return (name === 'rotate3d') ? $mdgriffith$elm_style_animation$Animation$speed(
				{jr: $elm$core$Basics$pi}) : defaultSpring;
		case 6:
			return defaultSpring;
		case 7:
			return $mdgriffith$elm_style_animation$Animation$speed(
				{jr: $elm$core$Basics$pi});
		case 8:
			return defaultSpring;
		default:
			return defaultSpring;
	}
};
var $mdgriffith$elm_style_animation$Animation$Model$AngleProperty = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $mdgriffith$elm_style_animation$Animation$Model$ColorProperty = F5(
	function (a, b, c, d, e) {
		return {$: 1, a: a, b: b, c: c, d: d, e: e};
	});
var $mdgriffith$elm_style_animation$Animation$Model$ExactProperty = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_style_animation$Animation$Model$Path = function (a) {
	return {$: 9, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$Points = function (a) {
	return {$: 8, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$Property = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_style_animation$Animation$Model$Property2 = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $mdgriffith$elm_style_animation$Animation$Model$Property3 = F4(
	function (a, b, c, d) {
		return {$: 5, a: a, b: b, c: c, d: d};
	});
var $mdgriffith$elm_style_animation$Animation$Model$Property4 = F5(
	function (a, b, c, d, e) {
		return {$: 6, a: a, b: b, c: c, d: d, e: e};
	});
var $mdgriffith$elm_style_animation$Animation$Model$ShadowProperty = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $mdgriffith$elm_style_animation$Animation$Model$AntiClockwiseArc = function (a) {
	return {$: 17, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$ClockwiseArc = function (a) {
	return {$: 16, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$Close = {$: 18};
var $mdgriffith$elm_style_animation$Animation$Model$Curve = function (a) {
	return {$: 8, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$CurveTo = function (a) {
	return {$: 9, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$Horizontal = function (a) {
	return {$: 4, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$HorizontalTo = function (a) {
	return {$: 5, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$Line = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $mdgriffith$elm_style_animation$Animation$Model$LineTo = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_style_animation$Animation$Model$Move = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_style_animation$Animation$Model$MoveTo = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $mdgriffith$elm_style_animation$Animation$Model$Quadratic = function (a) {
	return {$: 10, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$QuadraticTo = function (a) {
	return {$: 11, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$Smooth = function (a) {
	return {$: 14, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$SmoothQuadratic = function (a) {
	return {$: 12, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$SmoothQuadraticTo = function (a) {
	return {$: 13, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$SmoothTo = function (a) {
	return {$: 15, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$Vertical = function (a) {
	return {$: 6, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$VerticalTo = function (a) {
	return {$: 7, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$mapPathMotion = F2(
	function (fn, cmd) {
		var mapCoords = function (coords) {
			return A2(
				$elm$core$List$map,
				function (_v1) {
					var x = _v1.a;
					var y = _v1.b;
					return _Utils_Tuple2(
						fn(x),
						fn(y));
				},
				coords);
		};
		switch (cmd.$) {
			case 0:
				var m1 = cmd.a;
				var m2 = cmd.b;
				return A2(
					$mdgriffith$elm_style_animation$Animation$Model$Move,
					fn(m1),
					fn(m2));
			case 1:
				var m1 = cmd.a;
				var m2 = cmd.b;
				return A2(
					$mdgriffith$elm_style_animation$Animation$Model$MoveTo,
					fn(m1),
					fn(m2));
			case 2:
				var m1 = cmd.a;
				var m2 = cmd.b;
				return A2(
					$mdgriffith$elm_style_animation$Animation$Model$Line,
					fn(m1),
					fn(m2));
			case 3:
				var m1 = cmd.a;
				var m2 = cmd.b;
				return A2(
					$mdgriffith$elm_style_animation$Animation$Model$LineTo,
					fn(m1),
					fn(m2));
			case 4:
				var motion = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$Horizontal(
					fn(motion));
			case 5:
				var motion = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$HorizontalTo(
					fn(motion));
			case 6:
				var motion = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$Vertical(
					fn(motion));
			case 7:
				var motion = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$VerticalTo(
					fn(motion));
			case 8:
				var control1 = cmd.a.dW;
				var control2 = cmd.a.dX;
				var point = cmd.a.aO;
				return $mdgriffith$elm_style_animation$Animation$Model$Curve(
					{
						dW: _Utils_Tuple2(
							fn(control1.a),
							fn(control1.b)),
						dX: _Utils_Tuple2(
							fn(control2.a),
							fn(control2.b)),
						aO: _Utils_Tuple2(
							fn(point.a),
							fn(point.b))
					});
			case 9:
				var control1 = cmd.a.dW;
				var control2 = cmd.a.dX;
				var point = cmd.a.aO;
				return $mdgriffith$elm_style_animation$Animation$Model$CurveTo(
					{
						dW: _Utils_Tuple2(
							fn(control1.a),
							fn(control1.b)),
						dX: _Utils_Tuple2(
							fn(control2.a),
							fn(control2.b)),
						aO: _Utils_Tuple2(
							fn(point.a),
							fn(point.b))
					});
			case 10:
				var control = cmd.a.dV;
				var point = cmd.a.aO;
				return $mdgriffith$elm_style_animation$Animation$Model$Quadratic(
					{
						dV: _Utils_Tuple2(
							fn(control.a),
							fn(control.b)),
						aO: _Utils_Tuple2(
							fn(point.a),
							fn(point.b))
					});
			case 11:
				var control = cmd.a.dV;
				var point = cmd.a.aO;
				return $mdgriffith$elm_style_animation$Animation$Model$QuadraticTo(
					{
						dV: _Utils_Tuple2(
							fn(control.a),
							fn(control.b)),
						aO: _Utils_Tuple2(
							fn(point.a),
							fn(point.b))
					});
			case 12:
				var coords = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$SmoothQuadratic(
					mapCoords(coords));
			case 13:
				var coords = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$SmoothQuadraticTo(
					mapCoords(coords));
			case 14:
				var coords = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$Smooth(
					mapCoords(coords));
			case 15:
				var coords = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$SmoothTo(
					mapCoords(coords));
			case 16:
				var arc = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$ClockwiseArc(
					function () {
						var y = arc.kh;
						var x = arc.kg;
						var startAngle = arc.ex;
						var radius = arc.et;
						var endAngle = arc.d3;
						return _Utils_update(
							arc,
							{
								d3: fn(endAngle),
								et: fn(radius),
								ex: fn(startAngle),
								kg: fn(x),
								kh: fn(y)
							});
					}());
			case 17:
				var arc = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$AntiClockwiseArc(
					function () {
						var y = arc.kh;
						var x = arc.kg;
						var startAngle = arc.ex;
						var radius = arc.et;
						var endAngle = arc.d3;
						return _Utils_update(
							arc,
							{
								d3: fn(endAngle),
								et: fn(radius),
								ex: fn(startAngle),
								kg: fn(x),
								kh: fn(y)
							});
					}());
			default:
				return $mdgriffith$elm_style_animation$Animation$Model$Close;
		}
	});
var $mdgriffith$elm_style_animation$Animation$Model$mapToMotion = F2(
	function (fn, prop) {
		switch (prop.$) {
			case 0:
				var name = prop.a;
				var value = prop.b;
				return A2($mdgriffith$elm_style_animation$Animation$Model$ExactProperty, name, value);
			case 1:
				var name = prop.a;
				var m1 = prop.b;
				var m2 = prop.c;
				var m3 = prop.d;
				var m4 = prop.e;
				return A5(
					$mdgriffith$elm_style_animation$Animation$Model$ColorProperty,
					name,
					fn(m1),
					fn(m2),
					fn(m3),
					fn(m4));
			case 2:
				var name = prop.a;
				var inset = prop.b;
				var shadow = prop.c;
				var size = shadow.dB;
				var red = shadow.hz;
				var offsetY = shadow.aM;
				var offsetX = shadow.aL;
				var green = shadow.gF;
				var blur = shadow.az;
				var blue = shadow.f8;
				var alpha = shadow.f3;
				return A3(
					$mdgriffith$elm_style_animation$Animation$Model$ShadowProperty,
					name,
					inset,
					{
						f3: fn(alpha),
						f8: fn(blue),
						az: fn(blur),
						gF: fn(green),
						aL: fn(offsetX),
						aM: fn(offsetY),
						hz: fn(red),
						dB: fn(size)
					});
			case 3:
				var name = prop.a;
				var m1 = prop.b;
				return A2(
					$mdgriffith$elm_style_animation$Animation$Model$Property,
					name,
					fn(m1));
			case 4:
				var name = prop.a;
				var m1 = prop.b;
				var m2 = prop.c;
				return A3(
					$mdgriffith$elm_style_animation$Animation$Model$Property2,
					name,
					fn(m1),
					fn(m2));
			case 5:
				var name = prop.a;
				var m1 = prop.b;
				var m2 = prop.c;
				var m3 = prop.d;
				return A4(
					$mdgriffith$elm_style_animation$Animation$Model$Property3,
					name,
					fn(m1),
					fn(m2),
					fn(m3));
			case 6:
				var name = prop.a;
				var m1 = prop.b;
				var m2 = prop.c;
				var m3 = prop.d;
				var m4 = prop.e;
				return A5(
					$mdgriffith$elm_style_animation$Animation$Model$Property4,
					name,
					fn(m1),
					fn(m2),
					fn(m3),
					fn(m4));
			case 7:
				var name = prop.a;
				var m1 = prop.b;
				return A2(
					$mdgriffith$elm_style_animation$Animation$Model$AngleProperty,
					name,
					fn(m1));
			case 8:
				var ms = prop.a;
				return $mdgriffith$elm_style_animation$Animation$Model$Points(
					A2(
						$elm$core$List$map,
						function (_v1) {
							var x = _v1.a;
							var y = _v1.b;
							return _Utils_Tuple2(
								fn(x),
								fn(y));
						},
						ms));
			default:
				var cmds = prop.a;
				return $mdgriffith$elm_style_animation$Animation$Model$Path(
					A2(
						$elm$core$List$map,
						$mdgriffith$elm_style_animation$Animation$Model$mapPathMotion(fn),
						cmds));
		}
	});
var $mdgriffith$elm_style_animation$Animation$setDefaultInterpolation = function (prop) {
	var interp = $mdgriffith$elm_style_animation$Animation$defaultInterpolationByProperty(prop);
	return A2(
		$mdgriffith$elm_style_animation$Animation$Model$mapToMotion,
		function (m) {
			return _Utils_update(
				m,
				{c7: interp});
		},
		prop);
};
var $mdgriffith$elm_style_animation$Animation$Render$dropWhile = F2(
	function (predicate, list) {
		dropWhile:
		while (true) {
			if (!list.b) {
				return _List_Nil;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					var $temp$predicate = predicate,
						$temp$list = xs;
					predicate = $temp$predicate;
					list = $temp$list;
					continue dropWhile;
				} else {
					return list;
				}
			}
		}
	});
var $mdgriffith$elm_style_animation$Animation$Render$takeWhile = function (predicate) {
	var takeWhileMemo = F2(
		function (memo, list) {
			takeWhileMemo:
			while (true) {
				if (!list.b) {
					return $elm$core$List$reverse(memo);
				} else {
					var x = list.a;
					var xs = list.b;
					if (predicate(x)) {
						var $temp$memo = A2($elm$core$List$cons, x, memo),
							$temp$list = xs;
						memo = $temp$memo;
						list = $temp$list;
						continue takeWhileMemo;
					} else {
						return $elm$core$List$reverse(memo);
					}
				}
			}
		});
	return takeWhileMemo(_List_Nil);
};
var $mdgriffith$elm_style_animation$Animation$Render$span = F2(
	function (p, xs) {
		return _Utils_Tuple2(
			A2($mdgriffith$elm_style_animation$Animation$Render$takeWhile, p, xs),
			A2($mdgriffith$elm_style_animation$Animation$Render$dropWhile, p, xs));
	});
var $mdgriffith$elm_style_animation$Animation$Render$groupWhile = F2(
	function (eq, xs_) {
		if (!xs_.b) {
			return _List_Nil;
		} else {
			var x = xs_.a;
			var xs = xs_.b;
			var _v1 = A2(
				$mdgriffith$elm_style_animation$Animation$Render$span,
				eq(x),
				xs);
			var ys = _v1.a;
			var zs = _v1.b;
			return A2(
				$elm$core$List$cons,
				A2($elm$core$List$cons, x, ys),
				A2($mdgriffith$elm_style_animation$Animation$Render$groupWhile, eq, zs));
		}
	});
var $mdgriffith$elm_style_animation$Animation$Model$propertyName = function (prop) {
	switch (prop.$) {
		case 0:
			var name = prop.a;
			return name;
		case 1:
			var name = prop.a;
			return name;
		case 2:
			var name = prop.a;
			return name;
		case 3:
			var name = prop.a;
			return name;
		case 4:
			var name = prop.a;
			return name;
		case 5:
			var name = prop.a;
			return name;
		case 6:
			var name = prop.a;
			return name;
		case 7:
			var name = prop.a;
			return name;
		case 8:
			return 'points';
		default:
			return 'path';
	}
};
var $mdgriffith$elm_style_animation$Animation$Render$isTransformation = function (prop) {
	return A2(
		$elm$core$List$member,
		$mdgriffith$elm_style_animation$Animation$Model$propertyName(prop),
		_List_fromArray(
			['rotate', 'rotateX', 'rotateY', 'rotateZ', 'rotate3d', 'translate', 'translate3d', 'scale', 'scale3d']));
};
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $mdgriffith$elm_style_animation$Animation$Render$warnForDoubleListedProperties = function (props) {
	var _v0 = A2(
		$elm$core$List$map,
		function (propGroup) {
			var _v1 = $elm$core$List$head(propGroup);
			if (_v1.$ === 1) {
				return '';
			} else {
				var name = _v1.a;
				return ($elm$core$List$length(propGroup) > 1) ? '' : '';
			}
		},
		A2(
			$mdgriffith$elm_style_animation$Animation$Render$groupWhile,
			$elm$core$Basics$eq,
			$elm$core$List$sort(
				A2(
					$elm$core$List$map,
					$mdgriffith$elm_style_animation$Animation$Model$propertyName,
					A2(
						$elm$core$List$filter,
						function (prop) {
							return !$mdgriffith$elm_style_animation$Animation$Render$isTransformation(prop);
						},
						props)))));
	return props;
};
var $mdgriffith$elm_style_animation$Animation$style = function (props) {
	return $mdgriffith$elm_style_animation$Animation$initialState(
		A2(
			$elm$core$List$map,
			$mdgriffith$elm_style_animation$Animation$setDefaultInterpolation,
			$mdgriffith$elm_style_animation$Animation$Render$warnForDoubleListedProperties(props)));
};
var $author$project$Template$Animation$appearMgmt = {
	L: F2(
		function (_v0, a) {
			return A2($mdgriffith$elm_style_animation$Animation$interrupt, _List_Nil, a);
		}),
	lB: $mdgriffith$elm_style_animation$Animation$style(_List_Nil),
	N: F2(
		function (_v1, a) {
			return A2($mdgriffith$elm_style_animation$Animation$interrupt, _List_Nil, a);
		})
};
var $mdgriffith$elm_style_animation$Animation$initMotion = F2(
	function (position, unit) {
		return {
			c7: $mdgriffith$elm_style_animation$Animation$Model$Spring(
				{iz: 26, jW: 170}),
			lG: $elm$core$Maybe$Nothing,
			x: position,
			hN: position,
			ng: unit,
			nk: 0
		};
	});
var $mdgriffith$elm_style_animation$Animation$custom = F3(
	function (name, value, unit) {
		return A2(
			$mdgriffith$elm_style_animation$Animation$Model$Property,
			name,
			A2($mdgriffith$elm_style_animation$Animation$initMotion, value, unit));
	});
var $mdgriffith$elm_style_animation$Animation$opacity = function (val) {
	return A3($mdgriffith$elm_style_animation$Animation$custom, 'opacity', val, '');
};
var $mdgriffith$elm_style_animation$Animation$Length = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_style_animation$Animation$Px = 1;
var $mdgriffith$elm_style_animation$Animation$px = function (myPx) {
	return A2($mdgriffith$elm_style_animation$Animation$Length, myPx, 1);
};
var $mdgriffith$elm_style_animation$Animation$Model$Set = function (a) {
	return {$: 3, a: a};
};
var $mdgriffith$elm_style_animation$Animation$set = function (props) {
	return $mdgriffith$elm_style_animation$Animation$Model$Set(props);
};
var $mdgriffith$elm_style_animation$Animation$spring = function (settings) {
	return $mdgriffith$elm_style_animation$Animation$Model$Spring(settings);
};
var $mdgriffith$elm_style_animation$Animation$styleWithEach = function (props) {
	var _v0 = $mdgriffith$elm_style_animation$Animation$Render$warnForDoubleListedProperties(
		A2($elm$core$List$map, $elm$core$Tuple$second, props));
	return $mdgriffith$elm_style_animation$Animation$initialState(
		A2(
			$elm$core$List$map,
			function (_v1) {
				var interp = _v1.a;
				var prop = _v1.b;
				return A2(
					$mdgriffith$elm_style_animation$Animation$Model$mapToMotion,
					function (m) {
						return _Utils_update(
							m,
							{c7: interp});
					},
					prop);
			},
			props));
};
var $mdgriffith$elm_style_animation$Animation$Model$To = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_style_animation$Animation$to = function (props) {
	return $mdgriffith$elm_style_animation$Animation$Model$To(props);
};
var $mdgriffith$elm_style_animation$Animation$length2 = F3(
	function (name, _v0, _v1) {
		var val = _v0.a;
		var len = _v0.b;
		var val2 = _v1.a;
		var len2 = _v1.b;
		return A3(
			$mdgriffith$elm_style_animation$Animation$Model$Property2,
			name,
			A2($mdgriffith$elm_style_animation$Animation$initMotion, val, len),
			A2($mdgriffith$elm_style_animation$Animation$initMotion, val2, len2));
	});
var $mdgriffith$elm_style_animation$Animation$lengthUnitName = function (unit) {
	switch (unit) {
		case 0:
			return '';
		case 1:
			return 'px';
		case 2:
			return '%';
		case 3:
			return 'rem';
		case 4:
			return 'em';
		case 5:
			return 'ex';
		case 6:
			return 'ch';
		case 7:
			return 'vh';
		case 8:
			return 'vw';
		case 9:
			return 'vmin';
		case 10:
			return 'vmax';
		case 11:
			return 'mm';
		case 12:
			return 'cm';
		case 13:
			return 'in';
		case 14:
			return 'pt';
		default:
			return 'pc';
	}
};
var $mdgriffith$elm_style_animation$Animation$translate = F2(
	function (_v0, _v1) {
		var valX = _v0.a;
		var len1 = _v0.b;
		var valY = _v1.a;
		var len2 = _v1.b;
		return A3(
			$mdgriffith$elm_style_animation$Animation$length2,
			'translate',
			_Utils_Tuple2(
				valX,
				$mdgriffith$elm_style_animation$Animation$lengthUnitName(len1)),
			_Utils_Tuple2(
				valY,
				$mdgriffith$elm_style_animation$Animation$lengthUnitName(len2)));
	});
var $mdgriffith$elm_style_animation$Animation$Model$Wait = function (a) {
	return {$: 4, a: a};
};
var $mdgriffith$elm_style_animation$Animation$wait = function (till) {
	return $mdgriffith$elm_style_animation$Animation$Model$Wait(till);
};
var $mdgriffith$elm_style_animation$Animation$Spring$Presets$wobbly = {iz: 12, jW: 180};
var $mdgriffith$elm_style_animation$Animation$Spring$Presets$zippy = {iz: 28, jW: 400};
var $author$project$Template$Animation$fadeBottomMgmt = {
	L: F2(
		function (index, style) {
			return A2(
				$mdgriffith$elm_style_animation$Animation$interrupt,
				_List_fromArray(
					[
						$mdgriffith$elm_style_animation$Animation$wait(
						$elm$time$Time$millisToPosix((140 * 1000) * index)),
						$mdgriffith$elm_style_animation$Animation$to(
						_List_fromArray(
							[
								$mdgriffith$elm_style_animation$Animation$opacity(0),
								A2(
								$mdgriffith$elm_style_animation$Animation$translate,
								$mdgriffith$elm_style_animation$Animation$px(0),
								$mdgriffith$elm_style_animation$Animation$px(-40))
							]))
					]),
				style);
		}),
	lB: $mdgriffith$elm_style_animation$Animation$styleWithEach(
		_List_fromArray(
			[
				_Utils_Tuple2(
				$mdgriffith$elm_style_animation$Animation$spring($mdgriffith$elm_style_animation$Animation$Spring$Presets$zippy),
				$mdgriffith$elm_style_animation$Animation$opacity(0)),
				_Utils_Tuple2(
				$mdgriffith$elm_style_animation$Animation$spring($mdgriffith$elm_style_animation$Animation$Spring$Presets$wobbly),
				A2(
					$mdgriffith$elm_style_animation$Animation$translate,
					$mdgriffith$elm_style_animation$Animation$px(0),
					$mdgriffith$elm_style_animation$Animation$px(40)))
			])),
	N: F2(
		function (index, style) {
			return A2(
				$mdgriffith$elm_style_animation$Animation$interrupt,
				_List_fromArray(
					[
						$mdgriffith$elm_style_animation$Animation$wait(
						$elm$time$Time$millisToPosix((140 * 1000) * index)),
						$mdgriffith$elm_style_animation$Animation$set(
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_style_animation$Animation$translate,
								$mdgriffith$elm_style_animation$Animation$px(0),
								$mdgriffith$elm_style_animation$Animation$px(40))
							])),
						$mdgriffith$elm_style_animation$Animation$to(
						_List_fromArray(
							[
								$mdgriffith$elm_style_animation$Animation$opacity(1),
								A2(
								$mdgriffith$elm_style_animation$Animation$translate,
								$mdgriffith$elm_style_animation$Animation$px(0),
								$mdgriffith$elm_style_animation$Animation$px(0))
							]))
					]),
				style);
		})
};
var $author$project$Template$Animation$fadeInMgmt = {
	L: F2(
		function (index, style) {
			return A2(
				$mdgriffith$elm_style_animation$Animation$interrupt,
				_List_fromArray(
					[
						$mdgriffith$elm_style_animation$Animation$wait(
						$elm$time$Time$millisToPosix((140 * 1000) * index)),
						$mdgriffith$elm_style_animation$Animation$to(
						_List_fromArray(
							[
								$mdgriffith$elm_style_animation$Animation$opacity(0)
							]))
					]),
				style);
		}),
	lB: $mdgriffith$elm_style_animation$Animation$style(
		_List_fromArray(
			[
				$mdgriffith$elm_style_animation$Animation$opacity(0)
			])),
	N: F2(
		function (index, style) {
			return A2(
				$mdgriffith$elm_style_animation$Animation$interrupt,
				_List_fromArray(
					[
						$mdgriffith$elm_style_animation$Animation$wait(
						$elm$time$Time$millisToPosix((140 * 1000) * index)),
						$mdgriffith$elm_style_animation$Animation$to(
						_List_fromArray(
							[
								$mdgriffith$elm_style_animation$Animation$opacity(1)
							]))
					]),
				style);
		})
};
var $author$project$Template$Animation$fadeLeftMgmt = {
	L: F2(
		function (index, style) {
			return A2(
				$mdgriffith$elm_style_animation$Animation$interrupt,
				_List_fromArray(
					[
						$mdgriffith$elm_style_animation$Animation$wait(
						$elm$time$Time$millisToPosix((140 * 1000) * index)),
						$mdgriffith$elm_style_animation$Animation$to(
						_List_fromArray(
							[
								$mdgriffith$elm_style_animation$Animation$opacity(0),
								A2(
								$mdgriffith$elm_style_animation$Animation$translate,
								$mdgriffith$elm_style_animation$Animation$px(40),
								$mdgriffith$elm_style_animation$Animation$px(0))
							]))
					]),
				style);
		}),
	lB: $mdgriffith$elm_style_animation$Animation$styleWithEach(
		_List_fromArray(
			[
				_Utils_Tuple2(
				$mdgriffith$elm_style_animation$Animation$spring($mdgriffith$elm_style_animation$Animation$Spring$Presets$zippy),
				$mdgriffith$elm_style_animation$Animation$opacity(0)),
				_Utils_Tuple2(
				$mdgriffith$elm_style_animation$Animation$spring($mdgriffith$elm_style_animation$Animation$Spring$Presets$wobbly),
				A2(
					$mdgriffith$elm_style_animation$Animation$translate,
					$mdgriffith$elm_style_animation$Animation$px(-40),
					$mdgriffith$elm_style_animation$Animation$px(0)))
			])),
	N: F2(
		function (index, style) {
			return A2(
				$mdgriffith$elm_style_animation$Animation$interrupt,
				_List_fromArray(
					[
						$mdgriffith$elm_style_animation$Animation$wait(
						$elm$time$Time$millisToPosix((140 * 1000) * index)),
						$mdgriffith$elm_style_animation$Animation$set(
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_style_animation$Animation$translate,
								$mdgriffith$elm_style_animation$Animation$px(-40),
								$mdgriffith$elm_style_animation$Animation$px(0))
							])),
						$mdgriffith$elm_style_animation$Animation$to(
						_List_fromArray(
							[
								$mdgriffith$elm_style_animation$Animation$opacity(1),
								A2(
								$mdgriffith$elm_style_animation$Animation$translate,
								$mdgriffith$elm_style_animation$Animation$px(0),
								$mdgriffith$elm_style_animation$Animation$px(0))
							]))
					]),
				style);
		})
};
var $author$project$Template$Animation$fadeRightMgmt = {
	L: F2(
		function (index, style) {
			return A2(
				$mdgriffith$elm_style_animation$Animation$interrupt,
				_List_fromArray(
					[
						$mdgriffith$elm_style_animation$Animation$wait(
						$elm$time$Time$millisToPosix((140 * 1000) * index)),
						$mdgriffith$elm_style_animation$Animation$to(
						_List_fromArray(
							[
								$mdgriffith$elm_style_animation$Animation$opacity(0),
								A2(
								$mdgriffith$elm_style_animation$Animation$translate,
								$mdgriffith$elm_style_animation$Animation$px(-40),
								$mdgriffith$elm_style_animation$Animation$px(0))
							]))
					]),
				style);
		}),
	lB: $mdgriffith$elm_style_animation$Animation$styleWithEach(
		_List_fromArray(
			[
				_Utils_Tuple2(
				$mdgriffith$elm_style_animation$Animation$spring($mdgriffith$elm_style_animation$Animation$Spring$Presets$zippy),
				$mdgriffith$elm_style_animation$Animation$opacity(0)),
				_Utils_Tuple2(
				$mdgriffith$elm_style_animation$Animation$spring($mdgriffith$elm_style_animation$Animation$Spring$Presets$wobbly),
				A2(
					$mdgriffith$elm_style_animation$Animation$translate,
					$mdgriffith$elm_style_animation$Animation$px(40),
					$mdgriffith$elm_style_animation$Animation$px(0)))
			])),
	N: F2(
		function (index, style) {
			return A2(
				$mdgriffith$elm_style_animation$Animation$interrupt,
				_List_fromArray(
					[
						$mdgriffith$elm_style_animation$Animation$wait(
						$elm$time$Time$millisToPosix((140 * 1000) * index)),
						$mdgriffith$elm_style_animation$Animation$set(
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_style_animation$Animation$translate,
								$mdgriffith$elm_style_animation$Animation$px(40),
								$mdgriffith$elm_style_animation$Animation$px(0))
							])),
						$mdgriffith$elm_style_animation$Animation$to(
						_List_fromArray(
							[
								$mdgriffith$elm_style_animation$Animation$opacity(1),
								A2(
								$mdgriffith$elm_style_animation$Animation$translate,
								$mdgriffith$elm_style_animation$Animation$px(0),
								$mdgriffith$elm_style_animation$Animation$px(0))
							]))
					]),
				style);
		})
};
var $author$project$Template$Animation$fadeTopMgmt = {
	L: F2(
		function (index, style) {
			return A2(
				$mdgriffith$elm_style_animation$Animation$interrupt,
				_List_fromArray(
					[
						$mdgriffith$elm_style_animation$Animation$wait(
						$elm$time$Time$millisToPosix((140 * 1000) * index)),
						$mdgriffith$elm_style_animation$Animation$to(
						_List_fromArray(
							[
								$mdgriffith$elm_style_animation$Animation$opacity(0),
								A2(
								$mdgriffith$elm_style_animation$Animation$translate,
								$mdgriffith$elm_style_animation$Animation$px(0),
								$mdgriffith$elm_style_animation$Animation$px(40))
							]))
					]),
				style);
		}),
	lB: $mdgriffith$elm_style_animation$Animation$styleWithEach(
		_List_fromArray(
			[
				_Utils_Tuple2(
				$mdgriffith$elm_style_animation$Animation$spring($mdgriffith$elm_style_animation$Animation$Spring$Presets$zippy),
				$mdgriffith$elm_style_animation$Animation$opacity(0)),
				_Utils_Tuple2(
				$mdgriffith$elm_style_animation$Animation$spring($mdgriffith$elm_style_animation$Animation$Spring$Presets$wobbly),
				A2(
					$mdgriffith$elm_style_animation$Animation$translate,
					$mdgriffith$elm_style_animation$Animation$px(0),
					$mdgriffith$elm_style_animation$Animation$px(-40)))
			])),
	N: F2(
		function (index, style) {
			return A2(
				$mdgriffith$elm_style_animation$Animation$interrupt,
				_List_fromArray(
					[
						$mdgriffith$elm_style_animation$Animation$wait(
						$elm$time$Time$millisToPosix((140 * 1000) * index)),
						$mdgriffith$elm_style_animation$Animation$set(
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_style_animation$Animation$translate,
								$mdgriffith$elm_style_animation$Animation$px(0),
								$mdgriffith$elm_style_animation$Animation$px(-40))
							])),
						$mdgriffith$elm_style_animation$Animation$to(
						_List_fromArray(
							[
								$mdgriffith$elm_style_animation$Animation$opacity(1),
								A2(
								$mdgriffith$elm_style_animation$Animation$translate,
								$mdgriffith$elm_style_animation$Animation$px(0),
								$mdgriffith$elm_style_animation$Animation$px(0))
							]))
					]),
				style);
		})
};
var $mdgriffith$elm_style_animation$Animation$Radians = $elm$core$Basics$identity;
var $mdgriffith$elm_style_animation$Animation$deg = function (a) {
	return (a / 360) * (2 * $elm$core$Basics$pi);
};
var $mdgriffith$elm_style_animation$Animation$length3 = F4(
	function (name, _v0, _v1, _v2) {
		var val = _v0.a;
		var len = _v0.b;
		var val2 = _v1.a;
		var len2 = _v1.b;
		var val3 = _v2.a;
		var len3 = _v2.b;
		return A4(
			$mdgriffith$elm_style_animation$Animation$Model$Property3,
			name,
			A2($mdgriffith$elm_style_animation$Animation$initMotion, val, len),
			A2($mdgriffith$elm_style_animation$Animation$initMotion, val2, len2),
			A2($mdgriffith$elm_style_animation$Animation$initMotion, val3, len3));
	});
var $mdgriffith$elm_style_animation$Animation$rotate3d = F3(
	function (_v0, _v1, _v2) {
		var valX = _v0;
		var valY = _v1;
		var valZ = _v2;
		return A4(
			$mdgriffith$elm_style_animation$Animation$length3,
			'rotate3d',
			_Utils_Tuple2(valX, 'rad'),
			_Utils_Tuple2(valY, 'rad'),
			_Utils_Tuple2(valZ, 'rad'));
	});
var $mdgriffith$elm_style_animation$Animation$scale = function (valX) {
	return A3($mdgriffith$elm_style_animation$Animation$custom, 'scale', valX, '');
};
var $author$project$Template$Animation$flipHorizontalMgmt = {
	L: F2(
		function (index, style) {
			return A2(
				$mdgriffith$elm_style_animation$Animation$interrupt,
				_List_fromArray(
					[
						$mdgriffith$elm_style_animation$Animation$wait(
						$elm$time$Time$millisToPosix((180 * 1000) * index)),
						$mdgriffith$elm_style_animation$Animation$to(
						_List_fromArray(
							[
								$mdgriffith$elm_style_animation$Animation$opacity(0),
								A3(
								$mdgriffith$elm_style_animation$Animation$rotate3d,
								$mdgriffith$elm_style_animation$Animation$deg(0),
								$mdgriffith$elm_style_animation$Animation$deg(60),
								$mdgriffith$elm_style_animation$Animation$deg(0))
							]))
					]),
				style);
		}),
	lB: $mdgriffith$elm_style_animation$Animation$styleWithEach(
		_List_fromArray(
			[
				_Utils_Tuple2(
				$mdgriffith$elm_style_animation$Animation$spring($mdgriffith$elm_style_animation$Animation$Spring$Presets$zippy),
				$mdgriffith$elm_style_animation$Animation$opacity(0)),
				_Utils_Tuple2(
				$mdgriffith$elm_style_animation$Animation$spring($mdgriffith$elm_style_animation$Animation$Spring$Presets$wobbly),
				$mdgriffith$elm_style_animation$Animation$scale(1)),
				_Utils_Tuple2(
				$mdgriffith$elm_style_animation$Animation$spring($mdgriffith$elm_style_animation$Animation$Spring$Presets$wobbly),
				A3(
					$mdgriffith$elm_style_animation$Animation$rotate3d,
					$mdgriffith$elm_style_animation$Animation$deg(0),
					$mdgriffith$elm_style_animation$Animation$deg(-90),
					$mdgriffith$elm_style_animation$Animation$deg(0)))
			])),
	N: F2(
		function (index, style) {
			return A2(
				$mdgriffith$elm_style_animation$Animation$interrupt,
				_List_fromArray(
					[
						$mdgriffith$elm_style_animation$Animation$set(
						_List_fromArray(
							[
								$mdgriffith$elm_style_animation$Animation$opacity(0),
								A3(
								$mdgriffith$elm_style_animation$Animation$rotate3d,
								$mdgriffith$elm_style_animation$Animation$deg(0),
								$mdgriffith$elm_style_animation$Animation$deg(-60),
								$mdgriffith$elm_style_animation$Animation$deg(0))
							])),
						$mdgriffith$elm_style_animation$Animation$wait(
						$elm$time$Time$millisToPosix((140 * 1000) * index)),
						$mdgriffith$elm_style_animation$Animation$to(
						_List_fromArray(
							[
								$mdgriffith$elm_style_animation$Animation$opacity(1),
								A3(
								$mdgriffith$elm_style_animation$Animation$rotate3d,
								$mdgriffith$elm_style_animation$Animation$deg(0),
								$mdgriffith$elm_style_animation$Animation$deg(0),
								$mdgriffith$elm_style_animation$Animation$deg(0))
							]))
					]),
				style);
		})
};
var $author$project$Template$Animation$flipVerticalMgmt = {
	L: F2(
		function (index, style) {
			return A2(
				$mdgriffith$elm_style_animation$Animation$interrupt,
				_List_fromArray(
					[
						$mdgriffith$elm_style_animation$Animation$wait(
						$elm$time$Time$millisToPosix((140 * 1000) * index)),
						$mdgriffith$elm_style_animation$Animation$to(
						_List_fromArray(
							[
								$mdgriffith$elm_style_animation$Animation$opacity(0),
								A3(
								$mdgriffith$elm_style_animation$Animation$rotate3d,
								$mdgriffith$elm_style_animation$Animation$deg(-90),
								$mdgriffith$elm_style_animation$Animation$deg(0),
								$mdgriffith$elm_style_animation$Animation$deg(0))
							]))
					]),
				style);
		}),
	lB: $mdgriffith$elm_style_animation$Animation$styleWithEach(
		_List_fromArray(
			[
				_Utils_Tuple2(
				$mdgriffith$elm_style_animation$Animation$spring($mdgriffith$elm_style_animation$Animation$Spring$Presets$zippy),
				$mdgriffith$elm_style_animation$Animation$opacity(0)),
				_Utils_Tuple2(
				$mdgriffith$elm_style_animation$Animation$spring($mdgriffith$elm_style_animation$Animation$Spring$Presets$wobbly),
				A3(
					$mdgriffith$elm_style_animation$Animation$rotate3d,
					$mdgriffith$elm_style_animation$Animation$deg(90),
					$mdgriffith$elm_style_animation$Animation$deg(0),
					$mdgriffith$elm_style_animation$Animation$deg(0)))
			])),
	N: F2(
		function (index, style) {
			return A2(
				$mdgriffith$elm_style_animation$Animation$interrupt,
				_List_fromArray(
					[
						$mdgriffith$elm_style_animation$Animation$wait(
						$elm$time$Time$millisToPosix((140 * 1000) * index)),
						$mdgriffith$elm_style_animation$Animation$to(
						_List_fromArray(
							[
								$mdgriffith$elm_style_animation$Animation$opacity(1),
								A3(
								$mdgriffith$elm_style_animation$Animation$rotate3d,
								$mdgriffith$elm_style_animation$Animation$deg(0),
								$mdgriffith$elm_style_animation$Animation$deg(0),
								$mdgriffith$elm_style_animation$Animation$deg(0))
							]))
					]),
				style);
		})
};
var $author$project$Template$Animation$init = function (effect) {
	switch (effect) {
		case 0:
			return $author$project$Template$Animation$appearMgmt.lB;
		case 1:
			return $author$project$Template$Animation$fadeInMgmt.lB;
		case 2:
			return $author$project$Template$Animation$fadeTopMgmt.lB;
		case 5:
			return $author$project$Template$Animation$fadeBottomMgmt.lB;
		case 3:
			return $author$project$Template$Animation$fadeLeftMgmt.lB;
		case 4:
			return $author$project$Template$Animation$fadeRightMgmt.lB;
		case 6:
			return $author$project$Template$Animation$flipVerticalMgmt.lB;
		default:
			return $author$project$Template$Animation$flipHorizontalMgmt.lB;
	}
};
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$Template$Widget$Core$initWithAppear = function (widgets) {
	return A2(
		$elm$core$Dict$map,
		F2(
			function (widgetId, widget) {
				if (widget.$ === 4) {
					var maxItems = widget.a.ej;
					return A2(
						$elm$core$List$repeat,
						maxItems,
						$author$project$Template$Animation$init($author$project$Template$Animation$appear));
				} else {
					return $elm$core$List$singleton(
						$author$project$Template$Animation$init($author$project$Template$Animation$appear));
				}
			}),
		widgets);
};
var $author$project$Template$Core$insertNewFrame = F2(
	function (frIndex, template) {
		return _Utils_update(
			template,
			{
				G: A3($author$project$Utils$insertAt, frIndex + 1, $author$project$Template$Frame$empty, template.G)
			});
	});
var $author$project$Template$Frame$updateRow = F4(
	function (colIndex, rowIndex, updateSection, frame) {
		return _Utils_update(
			frame,
			{
				da: A3(
					$elm_community$list_extra$List$Extra$updateAt,
					colIndex,
					function (col) {
						return _Utils_update(
							col,
							{
								jJ: A3($elm_community$list_extra$List$Extra$updateAt, rowIndex, updateSection, col.jJ)
							});
					},
					frame.da)
			});
	});
var $author$project$Template$Helpers$insertSharedWidget = F3(
	function (_v0, widgetName, template) {
		var frameIndex = _v0.ap;
		var columnIndex = _v0.C;
		var rowIndex = _v0.y;
		return A3(
			$author$project$Template$Core$update,
			frameIndex,
			A3(
				$author$project$Template$Frame$updateRow,
				columnIndex,
				rowIndex,
				$elm$core$Basics$always(
					$author$project$Template$Widget$Core$SharedWidget(widgetName))),
			template);
	});
var $author$project$Template$Helpers$insertWidget = F3(
	function (_v0, _v1, template) {
		var widgetId = _v0.a;
		var widget = _v0.b;
		var frameIndex = _v1.ap;
		var columnIndex = _v1.C;
		var rowIndex = _v1.y;
		var updatedTemplate = A3(
			$author$project$Template$Core$update,
			frameIndex,
			A3(
				$author$project$Template$Frame$updateRow,
				columnIndex,
				rowIndex,
				function (sec) {
					if (sec.$ === 1) {
						return sec;
					} else {
						return $author$project$Template$Widget$Core$BoundedWidget(widgetId);
					}
				}),
			template);
		var updatedWidgets = A3($elm$core$Dict$insert, widgetId, widget, updatedTemplate.n);
		return A2($elm$core$Dict$member, widgetId, template.n) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			_Utils_update(
				updatedTemplate,
				{n: updatedWidgets}));
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Entity$MenuPlanning$MenuItem = function (id) {
	return function (rawId) {
		return function (description) {
			return function (servingLine) {
				return function (imageUrl) {
					return function (category) {
						return function (isLocallyGrown) {
							return function (ratings) {
								return function (calories) {
									return function (carbs) {
										return function (fat) {
											return function (hasVegetable) {
												return function (hasProtein) {
													return function (hasGrain) {
														return function (hasFruit) {
															return function (hasMilk) {
																return {kR: calories, kT: carbs, iq: category, k9: description, lg: fat, ln: hasFruit, lo: hasGrain, lp: hasMilk, lq: hasProtein, lr: hasVegetable, aF: id, ly: imageUrl, lK: isLocallyGrown, mf: ratings, mg: rawId, mz: servingLine};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Entity$MenuPlanning$EmptyImage = {$: 0};
var $author$project$Entity$MenuPlanning$RedirectedImage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Entity$MenuPlanning$imageDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (imgUrl) {
		return $elm$core$String$isEmpty(imgUrl) ? $elm$json$Json$Decode$succeed($author$project$Entity$MenuPlanning$EmptyImage) : $elm$json$Json$Decode$succeed(
			$author$project$Entity$MenuPlanning$RedirectedImage(imgUrl));
	},
	$elm$json$Json$Decode$string);
var $author$project$Entity$MenuPlanning$menuItemIdDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (_v0) {
		var id = _v0.a;
		var srvLine = _v0.b;
		return $elm$json$Json$Decode$succeed(
			$elm$core$String$fromInt(id) + ('-' + srvLine));
	},
	A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (a, b) {
				return _Utils_Tuple2(a, b);
			}),
		A2($elm$json$Json$Decode$field, 'MenuItemId', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'ServingLine', $elm$json$Json$Decode$string)));
var $author$project$Entity$MenuPlanning$menuItemDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'HasMilk',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'HasFruit',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'HasGrain',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'HasProtein',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'HasVegetable',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'TotalFat',
						$elm$json$Json$Decode$float,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'Carbs',
							$elm$json$Json$Decode$float,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'Calories',
								$elm$json$Json$Decode$float,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'AverageRatings',
									$elm$json$Json$Decode$float,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'IsLocallyGrown',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'Category',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'ImageURL',
												$author$project$Entity$MenuPlanning$imageDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'ServingLine',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'MenuItemDescription',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'MenuItemId',
															$elm$json$Json$Decode$int,
															A2(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
																$author$project$Entity$MenuPlanning$menuItemIdDecoder,
																$elm$json$Json$Decode$succeed($author$project$Entity$MenuPlanning$MenuItem)))))))))))))))));
var $author$project$Entity$MealType$toString = function (meal) {
	switch (meal) {
		case 0:
			return 'breakfast';
		case 1:
			return 'lunch';
		default:
			return 'supper';
	}
};
var $author$project$Entity$MenuPlanning$loadData = F3(
	function (urlPrefix, conf, toMsg) {
		var url = A3(
			$elm$url$Url$Builder$crossOrigin,
			urlPrefix,
			_List_fromArray(
				['api', 'GetDeviceMenuItems']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'deviceId', conf.iB),
					A2(
					$elm$url$Url$Builder$string,
					'servingDate',
					$justinmimbs$date$Date$toIsoString(conf.jQ)),
					A2(
					$elm$url$Url$Builder$string,
					'ServingLine',
					A2($elm$core$String$join, '|', conf.jR)),
					A2(
					$elm$url$Url$Builder$string,
					'MealType',
					$author$project$Entity$MealType$toString(conf.i8))
				]));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A3(
				$elm$core$Basics$apR,
				A2(
					$elm$http$Http$expectJson,
					toMsg,
					$elm$json$Json$Decode$list($author$project$Entity$MenuPlanning$menuItemDecoder)),
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				$lukewestby$elm_http_builder$HttpBuilder$get(url)));
	});
var $author$project$Pages$CfgDevice$Design$ImagesFromServer = function (a) {
	return {$: 119, a: a};
};
var $author$project$Pages$CfgDevice$Design$loadImages = function (_v0) {
	var fabricUrl = _v0.a;
	var districtId = _v0.b;
	var url = A3(
		$elm$url$Url$Builder$crossOrigin,
		fabricUrl,
		_List_fromArray(
			['fetchImageNames']),
		_List_fromArray(
			[
				A2($elm$url$Url$Builder$string, 'id', districtId)
			]));
	return $lukewestby$elm_http_builder$HttpBuilder$request(
		A2(
			$lukewestby$elm_http_builder$HttpBuilder$withExpect,
			A2(
				$elm$http$Http$expectJson,
				$author$project$Pages$CfgDevice$Design$ImagesFromServer,
				A2(
					$elm$json$Json$Decode$field,
					'data',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string))),
			$lukewestby$elm_http_builder$HttpBuilder$get(url)));
};
var $author$project$Entity$MenuPlanning$decodeImg = A2(
	$elm$json$Json$Decode$andThen,
	function (data) {
		return $elm$core$String$isEmpty(data) ? $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing) : $elm$json$Json$Decode$succeed(
			$elm$core$Maybe$Just('data:image/jpeg;base64,' + data));
	},
	$elm$json$Json$Decode$string);
var $author$project$Entity$MenuPlanning$loadImg = F4(
	function (urlPrefix, menuItemId, maybeUrl, toMsg) {
		var menuItemUrl = A3(
			$elm$url$Url$Builder$crossOrigin,
			urlPrefix,
			_List_fromArray(
				['api', 'GetMenuItemImage']),
			_List_fromArray(
				[
					A2(
					$elm$url$Url$Builder$string,
					'menuItemId',
					$elm$core$String$fromInt(menuItemId))
				]));
		var req = function () {
			if (maybeUrl.$ === 1) {
				var url = maybeUrl.a;
				return $lukewestby$elm_http_builder$HttpBuilder$get(url);
			} else {
				return $lukewestby$elm_http_builder$HttpBuilder$get(menuItemUrl);
			}
		}();
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2(
					$elm$http$Http$expectJson,
					toMsg,
					A2(
						$elm$json$Json$Decode$andThen,
						A2(
							$elm$core$Basics$composeL,
							$elm$json$Json$Decode$succeed,
							function (b) {
								return _Utils_Tuple2(menuItemId, b);
							}),
						$author$project$Entity$MenuPlanning$decodeImg)),
				req));
	});
var $author$project$Entity$MenuItemList$decoderBuggyResponse = A2(
	$elm$json$Json$Decode$andThen,
	function (list) {
		var _v0 = $elm$core$List$head(list);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$json$Json$Decode$succeed(a);
		} else {
			return $elm$json$Json$Decode$fail('Empty Response');
		}
	},
	$elm$json$Json$Decode$list($author$project$Entity$MenuItemList$menuItemListDecoder));
var $author$project$Entity$MenuItemList$loadList = F3(
	function (urlPrefix, listId, toMsg) {
		var url = A3(
			$elm$url$Url$Builder$crossOrigin,
			urlPrefix,
			_List_fromArray(
				['api', 'MenuItemLists']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'SchoolId', ''),
					A2($elm$url$Url$Builder$string, 'MenuItemListId', listId)
				]));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, toMsg, $author$project$Entity$MenuItemList$decoderBuggyResponse),
				$lukewestby$elm_http_builder$HttpBuilder$get(url)));
	});
var $elm_community$list_extra$List$Extra$uncons = function (list) {
	if (!list.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var first = list.a;
		var rest = list.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(first, rest));
	}
};
var $elm_community$list_extra$List$Extra$swapAt = F3(
	function (index1, index2, l) {
		swapAt:
		while (true) {
			if (_Utils_eq(index1, index2) || (index1 < 0)) {
				return l;
			} else {
				if (_Utils_cmp(index1, index2) > 0) {
					var $temp$index1 = index2,
						$temp$index2 = index1,
						$temp$l = l;
					index1 = $temp$index1;
					index2 = $temp$index2;
					l = $temp$l;
					continue swapAt;
				} else {
					var _v0 = A2($elm_community$list_extra$List$Extra$splitAt, index1, l);
					var part1 = _v0.a;
					var tail1 = _v0.b;
					var _v1 = A2($elm_community$list_extra$List$Extra$splitAt, index2 - index1, tail1);
					var head2 = _v1.a;
					var tail2 = _v1.b;
					var _v2 = _Utils_Tuple2(
						$elm_community$list_extra$List$Extra$uncons(head2),
						$elm_community$list_extra$List$Extra$uncons(tail2));
					if ((!_v2.a.$) && (!_v2.b.$)) {
						var _v3 = _v2.a.a;
						var value1 = _v3.a;
						var part2 = _v3.b;
						var _v4 = _v2.b.a;
						var value2 = _v4.a;
						var part3 = _v4.b;
						return $elm$core$List$concat(
							_List_fromArray(
								[
									part1,
									A2($elm$core$List$cons, value2, part2),
									A2($elm$core$List$cons, value1, part3)
								]));
					} else {
						return l;
					}
				}
			}
		}
	});
var $author$project$Template$Core$swapFrame = F3(
	function (fromIndex, toIndex, template) {
		return _Utils_update(
			template,
			{
				G: A3($elm_community$list_extra$List$Extra$swapAt, fromIndex, toIndex, template.G)
			});
	});
var $author$project$Template$Helpers$moveFrameDown = F2(
	function (frIndex, template) {
		return A3($author$project$Template$Core$swapFrame, frIndex, frIndex + 1, template);
	});
var $author$project$Template$Helpers$moveFrameUp = F2(
	function (frIndex, template) {
		return A3($author$project$Template$Core$swapFrame, frIndex, frIndex - 1, template);
	});
var $author$project$Template$Frame$moveSectionDown = F3(
	function (colIndex, rowIndex, frame) {
		return _Utils_update(
			frame,
			{
				da: function () {
					var _v0 = frame.fz;
					if (!_v0) {
						return A3(
							$elm_community$list_extra$List$Extra$updateAt,
							colIndex,
							function (col) {
								return _Utils_update(
									col,
									{
										jJ: A3($elm_community$list_extra$List$Extra$swapAt, rowIndex, rowIndex + 1, col.jJ)
									});
							},
							frame.da);
					} else {
						return A3($elm_community$list_extra$List$Extra$swapAt, colIndex, colIndex + 1, frame.da);
					}
				}()
			});
	});
var $author$project$Template$Helpers$moveSectionDown = F2(
	function (_v0, template) {
		var frameIndex = _v0.ap;
		var columnIndex = _v0.C;
		var rowIndex = _v0.y;
		return A3(
			$author$project$Template$Core$update,
			frameIndex,
			A2($author$project$Template$Frame$moveSectionDown, columnIndex, rowIndex),
			template);
	});
var $author$project$Template$Frame$moveSectionLeft = F3(
	function (colIndex, rowIndex, frame) {
		return _Utils_update(
			frame,
			{
				da: function () {
					var _v0 = frame.fz;
					if (!_v0) {
						return A3($elm_community$list_extra$List$Extra$swapAt, colIndex, colIndex - 1, frame.da);
					} else {
						return A3(
							$elm_community$list_extra$List$Extra$updateAt,
							colIndex,
							function (col) {
								return _Utils_update(
									col,
									{
										jJ: A3($elm_community$list_extra$List$Extra$swapAt, rowIndex, rowIndex - 1, col.jJ)
									});
							},
							frame.da);
					}
				}()
			});
	});
var $author$project$Template$Helpers$moveSectionLeft = F2(
	function (_v0, template) {
		var frameIndex = _v0.ap;
		var columnIndex = _v0.C;
		var rowIndex = _v0.y;
		return A3(
			$author$project$Template$Core$update,
			frameIndex,
			A2($author$project$Template$Frame$moveSectionLeft, columnIndex, rowIndex),
			template);
	});
var $author$project$Template$Frame$moveSectionRight = F3(
	function (colIndex, rowIndex, frame) {
		return _Utils_update(
			frame,
			{
				da: function () {
					var _v0 = frame.fz;
					if (!_v0) {
						return A3($elm_community$list_extra$List$Extra$swapAt, colIndex, colIndex + 1, frame.da);
					} else {
						return A3(
							$elm_community$list_extra$List$Extra$updateAt,
							colIndex,
							function (col) {
								return _Utils_update(
									col,
									{
										jJ: A3($elm_community$list_extra$List$Extra$swapAt, rowIndex, rowIndex + 1, col.jJ)
									});
							},
							frame.da);
					}
				}()
			});
	});
var $author$project$Template$Helpers$moveSectionRight = F2(
	function (_v0, template) {
		var frameIndex = _v0.ap;
		var columnIndex = _v0.C;
		var rowIndex = _v0.y;
		return A3(
			$author$project$Template$Core$update,
			frameIndex,
			A2($author$project$Template$Frame$moveSectionRight, columnIndex, rowIndex),
			template);
	});
var $author$project$Template$Frame$moveSectionUp = F3(
	function (colIndex, rowIndex, frame) {
		return _Utils_update(
			frame,
			{
				da: function () {
					var _v0 = frame.fz;
					if (!_v0) {
						return A3(
							$elm_community$list_extra$List$Extra$updateAt,
							colIndex,
							function (col) {
								return _Utils_update(
									col,
									{
										jJ: A3($elm_community$list_extra$List$Extra$swapAt, rowIndex, rowIndex - 1, col.jJ)
									});
							},
							frame.da);
					} else {
						return A3($elm_community$list_extra$List$Extra$swapAt, colIndex, colIndex - 1, frame.da);
					}
				}()
			});
	});
var $author$project$Template$Helpers$moveSectionUp = F2(
	function (_v0, template) {
		var frameIndex = _v0.ap;
		var columnIndex = _v0.C;
		var rowIndex = _v0.y;
		return A3(
			$author$project$Template$Core$update,
			frameIndex,
			A2($author$project$Template$Frame$moveSectionUp, columnIndex, rowIndex),
			template);
	});
var $author$project$Interop$Browser$openMediaLibrary = A2($author$project$Interop$Browser$postMessage, 'OPEN_MEDIA_LIBRARY', $elm$json$Json$Encode$null);
var $author$project$Interop$Browser$openSidebar = A2($author$project$Interop$Browser$postMessage, 'OPEN_SIDEBAR', $elm$json$Json$Encode$null);
var $author$project$Template$Widget$Youtube$playlist = function (id) {
	return {
		gH: 467,
		ka: $author$project$Template$Widget$Youtube$Playlist(id),
		hY: 830
	};
};
var $author$project$DataState$ready = function (data) {
	return $author$project$DataState$Ready(data);
};
var $author$project$Template$Helpers$removeWidget = F2(
	function (position, template) {
		var updatedTemplate = A3(
			$author$project$Template$Core$update,
			position.ap,
			A3(
				$author$project$Template$Frame$updateRow,
				position.C,
				position.y,
				$elm$core$Basics$always($author$project$Template$Widget$Core$EmptySection)),
			template);
		var maybeSection = A2($author$project$Template$Helpers$getSection, template, position);
		var widgets = function () {
			if ((!maybeSection.$) && (!maybeSection.a.$)) {
				var widgetId = maybeSection.a.a;
				return A2($elm$core$Dict$remove, widgetId, template.n);
			} else {
				return template.n;
			}
		}();
		return _Utils_update(
			updatedTemplate,
			{n: widgets});
	});
var $jschomay$elm_paginate$Paginate$Custom$isFirst = function (_v0) {
	var currentPage_ = _v0.O;
	return $jschomay$elm_bounded_number$Number$Bounded$value(currentPage_) === 1;
};
var $jschomay$elm_paginate$Paginate$isFirst = $jschomay$elm_paginate$Paginate$Custom$isFirst;
var $jschomay$elm_bounded_number$Number$Bounded$maxBound = function (_v0) {
	var max = _v0.fn;
	return max;
};
var $jschomay$elm_paginate$Paginate$Custom$totalPages = function (_v0) {
	var currentPage_ = _v0.O;
	return $jschomay$elm_bounded_number$Number$Bounded$maxBound(currentPage_);
};
var $jschomay$elm_paginate$Paginate$Custom$last = function (paginatedList) {
	return A2(
		$jschomay$elm_paginate$Paginate$Custom$goTo,
		$jschomay$elm_paginate$Paginate$Custom$totalPages(paginatedList),
		paginatedList);
};
var $jschomay$elm_paginate$Paginate$last = $jschomay$elm_paginate$Paginate$Custom$last;
var $jschomay$elm_bounded_number$Number$Bounded$dec = F2(
	function (by, _v0) {
		var min = _v0.fq;
		var max = _v0.fn;
		var n = _v0.by;
		return {
			fn: max,
			fq: min,
			by: A3($elm$core$Basics$clamp, min, max, n - by)
		};
	});
var $jschomay$elm_paginate$Paginate$Custom$prev = function (_v0) {
	var p = _v0;
	return _Utils_update(
		p,
		{
			O: A2($jschomay$elm_bounded_number$Number$Bounded$dec, 1, p.O)
		});
};
var $jschomay$elm_paginate$Paginate$prev = $jschomay$elm_paginate$Paginate$Custom$prev;
var $author$project$Utils$rotatePageBackward = function (itemList) {
	return $jschomay$elm_paginate$Paginate$isFirst(itemList) ? $jschomay$elm_paginate$Paginate$last(itemList) : $jschomay$elm_paginate$Paginate$prev(itemList);
};
var $jschomay$elm_paginate$Paginate$Custom$first = function (paginatedList) {
	return A2($jschomay$elm_paginate$Paginate$Custom$goTo, 1, paginatedList);
};
var $jschomay$elm_paginate$Paginate$first = $jschomay$elm_paginate$Paginate$Custom$first;
var $jschomay$elm_paginate$Paginate$Custom$isLast = function (_v0) {
	var currentPage_ = _v0.O;
	return _Utils_eq(
		$jschomay$elm_bounded_number$Number$Bounded$value(currentPage_),
		$jschomay$elm_bounded_number$Number$Bounded$maxBound(currentPage_));
};
var $jschomay$elm_paginate$Paginate$isLast = $jschomay$elm_paginate$Paginate$Custom$isLast;
var $jschomay$elm_bounded_number$Number$Bounded$inc = F2(
	function (by, _v0) {
		var min = _v0.fq;
		var max = _v0.fn;
		var n = _v0.by;
		return {
			fn: max,
			fq: min,
			by: A3($elm$core$Basics$clamp, min, max, n + by)
		};
	});
var $jschomay$elm_paginate$Paginate$Custom$next = function (_v0) {
	var p = _v0;
	return _Utils_update(
		p,
		{
			O: A2($jschomay$elm_bounded_number$Number$Bounded$inc, 1, p.O)
		});
};
var $jschomay$elm_paginate$Paginate$next = $jschomay$elm_paginate$Paginate$Custom$next;
var $author$project$Utils$rotatePageForward = function (itemList) {
	return $jschomay$elm_paginate$Paginate$isLast(itemList) ? $jschomay$elm_paginate$Paginate$first(itemList) : $jschomay$elm_paginate$Paginate$next(itemList);
};
var $author$project$Reusable$DatePicker$selectedDate = function (model) {
	return model.a0;
};
var $author$project$Template$Helpers$shareEffect = F2(
	function (widget, widgets) {
		return A2(
			$elm$core$Dict$map,
			F2(
				function (k, valWidget) {
					var _v0 = _Utils_Tuple2(widget, valWidget);
					_v0$4:
					while (true) {
						switch (_v0.a.$) {
							case 1:
								if (_v0.b.$ === 1) {
									var anim = _v0.a.a.bf;
									var cfg = _v0.b.a;
									return $author$project$Template$Widget$Core$TextBox(
										_Utils_update(
											cfg,
											{bf: anim}));
								} else {
									break _v0$4;
								}
							case 2:
								if (_v0.b.$ === 2) {
									var anim = _v0.a.a.bf;
									var cfg = _v0.b.a;
									return $author$project$Template$Widget$Core$Image(
										_Utils_update(
											cfg,
											{bf: anim}));
								} else {
									break _v0$4;
								}
							case 4:
								if (_v0.b.$ === 4) {
									var anim = _v0.a.a.bf;
									var cfg = _v0.b.a;
									return $author$project$Template$Widget$Core$MenuPlanning(
										_Utils_update(
											cfg,
											{bf: anim}));
								} else {
									break _v0$4;
								}
							case 5:
								if (_v0.b.$ === 5) {
									var anim = _v0.a.a.bf;
									var cfg = _v0.b.a;
									return $author$project$Template$Widget$Core$MenuItemListWidget(
										_Utils_update(
											cfg,
											{bf: anim}));
								} else {
									break _v0$4;
								}
							default:
								break _v0$4;
						}
					}
					return valWidget;
				}),
			widgets);
	});
var $author$project$Template$Helpers$shareStyle = F4(
	function (template, maybeInnerStyle, styleId, widget) {
		switch (widget.$) {
			case 1:
				var config = widget.a;
				_v1$2:
				while (true) {
					if (!maybeInnerStyle.$) {
						switch (maybeInnerStyle.a) {
							case 1:
								var _v2 = maybeInnerStyle.a;
								return $author$project$Template$Widget$Core$TextBox(
									_Utils_update(
										config,
										{
											cs: $author$project$Entity$Style$shared(styleId)
										}));
							case 0:
								var _v3 = maybeInnerStyle.a;
								return $author$project$Template$Widget$Core$TextBox(
									_Utils_update(
										config,
										{
											dB: $author$project$Entity$Style$shared(styleId)
										}));
							default:
								break _v1$2;
						}
					} else {
						break _v1$2;
					}
				}
				return widget;
			case 2:
				var config = widget.a;
				return $author$project$Template$Widget$Core$Image(
					_Utils_update(
						config,
						{
							cs: $author$project$Entity$Style$shared(styleId)
						}));
			case 4:
				var config = widget.a;
				if (!maybeInnerStyle.$) {
					switch (maybeInnerStyle.a) {
						case 1:
							var _v5 = maybeInnerStyle.a;
							return $author$project$Template$Widget$Core$MenuPlanning(
								_Utils_update(
									config,
									{
										na: $author$project$Entity$Style$shared(styleId)
									}));
						case 0:
							var _v6 = maybeInnerStyle.a;
							return $author$project$Template$Widget$Core$MenuPlanning(
								_Utils_update(
									config,
									{
										da: $author$project$Entity$Style$shared(styleId)
									}));
						case 2:
							var _v7 = maybeInnerStyle.a;
							return $author$project$Template$Widget$Core$MenuPlanning(
								_Utils_update(
									config,
									{
										gY: $author$project$Entity$Style$shared(styleId)
									}));
						case 3:
							var _v8 = maybeInnerStyle.a;
							return $author$project$Template$Widget$Core$MenuPlanning(
								_Utils_update(
									config,
									{
										gL: $author$project$Entity$Style$shared(styleId)
									}));
						case 6:
							var _v9 = maybeInnerStyle.a;
							return $author$project$Template$Widget$Core$MenuPlanning(
								_Utils_update(
									config,
									{
										k9: $author$project$Entity$Style$shared(styleId)
									}));
						case 4:
							var _v10 = maybeInnerStyle.a;
							return $author$project$Template$Widget$Core$MenuPlanning(
								_Utils_update(
									config,
									{
										kR: $author$project$Entity$Style$shared(styleId)
									}));
						case 5:
							var _v11 = maybeInnerStyle.a;
							return $author$project$Template$Widget$Core$MenuPlanning(
								_Utils_update(
									config,
									{
										mf: $author$project$Entity$Style$shared(styleId)
									}));
						case 8:
							var _v12 = maybeInnerStyle.a;
							return widget;
						default:
							var _v13 = maybeInnerStyle.a;
							return $author$project$Template$Widget$Core$MenuPlanning(
								_Utils_update(
									config,
									{
										gA: $author$project$Entity$Style$shared(styleId)
									}));
					}
				} else {
					return widget;
				}
			case 5:
				var config = widget.a;
				_v14$3:
				while (true) {
					if (!maybeInnerStyle.$) {
						switch (maybeInnerStyle.a) {
							case 1:
								var _v15 = maybeInnerStyle.a;
								return $author$project$Template$Widget$Core$MenuItemListWidget(
									_Utils_update(
										config,
										{
											na: $author$project$Entity$Style$shared(styleId)
										}));
							case 6:
								var _v16 = maybeInnerStyle.a;
								return $author$project$Template$Widget$Core$MenuItemListWidget(
									_Utils_update(
										config,
										{
											k9: $author$project$Entity$Style$shared(styleId)
										}));
							case 8:
								var _v17 = maybeInnerStyle.a;
								return $author$project$Template$Widget$Core$MenuItemListWidget(
									_Utils_update(
										config,
										{
											hw: $author$project$Entity$Style$shared(styleId)
										}));
							default:
								break _v14$3;
						}
					} else {
						break _v14$3;
					}
				}
				return widget;
			default:
				return widget;
		}
	});
var $author$project$Template$Helpers$shareWidget = F3(
	function (widgetName, position, template) {
		var _v0 = A2($author$project$Template$Helpers$getWidget, template, position);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var widgetId = _v1.a;
			var widget = _v1.b;
			return function (t) {
				return _Utils_update(
					t,
					{
						n: A3(
							$elm$core$Dict$insert,
							widgetName,
							widget,
							A2($elm$core$Dict$remove, widgetId, t.n))
					});
			}(
				A3(
					$author$project$Template$Core$update,
					position.ap,
					A3(
						$author$project$Template$Frame$updateRow,
						position.C,
						position.y,
						$elm$core$Basics$always(
							$author$project$Template$Widget$Core$SharedWidget(widgetName))),
					template));
		} else {
			return template;
		}
	});
var $author$project$Pages$CfgDevice$Design$toImgUrl = F2(
	function (_v0, imageName) {
		var url = _v0.a;
		var districtId = _v0.b;
		return url + ('/fetchImage?' + (('id=' + districtId) + ('&redirect=true' + '&name=')));
	});
var $jschomay$elm_bounded_number$Number$Bounded$between = F2(
	function (a, b) {
		return (_Utils_cmp(a, b) < 0) ? {fn: b, fq: a, by: a} : {fn: a, fq: b, by: b};
	});
var $jschomay$elm_paginate$Paginate$Custom$init = F3(
	function (lengthFn, itemsPerPage_, items) {
		var max = (!lengthFn(items)) ? 1 : $elm$core$Basics$ceiling(
			lengthFn(items) / A2($elm$core$Basics$max, 1, itemsPerPage_));
		return {
			O: A2($jschomay$elm_bounded_number$Number$Bounded$between, 1, max),
			lM: items,
			fj: A2($elm$core$Basics$max, 1, itemsPerPage_)
		};
	});
var $jschomay$elm_paginate$Paginate$fromList = F2(
	function (a, b) {
		return A3($jschomay$elm_paginate$Paginate$Custom$init, $elm$core$List$length, a, b);
	});
var $author$project$Template$Core$toLive = function (template) {
	return {
		k2: template.k2,
		iw: template.iw,
		G: A2($jschomay$elm_paginate$Paginate$fromList, 1, template.G),
		eh: template.eh,
		g8: template.g8,
		ho: template.ho,
		z: template.z,
		aX: template.aX,
		n: template.n
	};
};
var $author$project$DataState$toMaybe = function (state) {
	if (state.$ === 4) {
		var data = state.a;
		return $elm$core$Maybe$Just(data);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $jschomay$elm_paginate$Paginate$Custom$foldMap = F2(
	function (f, _v0) {
		var items = _v0.lM;
		return f(items);
	});
var $jschomay$elm_paginate$Paginate$allItems = $jschomay$elm_paginate$Paginate$Custom$foldMap($elm$core$Basics$identity);
var $author$project$Template$Core$toRaw = function (liveTemplate) {
	var template = {
		k2: liveTemplate.k2,
		iw: liveTemplate.iw,
		G: $jschomay$elm_paginate$Paginate$allItems(liveTemplate.G),
		eh: liveTemplate.eh,
		g8: liveTemplate.g8,
		ho: liveTemplate.ho,
		z: liveTemplate.z,
		aX: liveTemplate.aX,
		n: liveTemplate.n
	};
	return _Utils_Tuple2(
		$jschomay$elm_paginate$Paginate$currentPage(liveTemplate.G),
		template);
};
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $mdgriffith$elm_style_animation$Animation$Model$refreshTiming = F2(
	function (now, timing) {
		var dt = $elm$time$Time$posixToMillis(now) - $elm$time$Time$posixToMillis(timing.ix);
		return {
			ix: now,
			lb: ((dt > 34) || (!$elm$time$Time$posixToMillis(timing.ix))) ? $elm$time$Time$millisToPosix(
				$elm$core$Basics$round(16.666)) : $elm$time$Time$millisToPosix(dt)
		};
	});
var $mdgriffith$elm_style_animation$Animation$Model$Loop = function (a) {
	return {$: 7, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$Repeat = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $mdgriffith$elm_style_animation$Animation$Model$Step = {$: 0};
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $mdgriffith$elm_style_animation$Animation$Model$isCmdDone = function (cmd) {
	var motionDone = function (motion) {
		return (!motion.nk) && _Utils_eq(motion.x, motion.hN);
	};
	switch (cmd.$) {
		case 0:
			var m1 = cmd.a;
			var m2 = cmd.b;
			return motionDone(m1) && motionDone(m2);
		case 1:
			var m1 = cmd.a;
			var m2 = cmd.b;
			return motionDone(m1) && motionDone(m2);
		case 2:
			var m1 = cmd.a;
			var m2 = cmd.b;
			return motionDone(m1) && motionDone(m2);
		case 3:
			var m1 = cmd.a;
			var m2 = cmd.b;
			return motionDone(m1) && motionDone(m2);
		case 4:
			var motion = cmd.a;
			return motionDone(motion);
		case 5:
			var motion = cmd.a;
			return motionDone(motion);
		case 6:
			var motion = cmd.a;
			return motionDone(motion);
		case 7:
			var motion = cmd.a;
			return motionDone(motion);
		case 8:
			var control1 = cmd.a.dW;
			var control2 = cmd.a.dX;
			var point = cmd.a.aO;
			return motionDone(control1.a) && (motionDone(control1.b) && (motionDone(control2.a) && (motionDone(control2.b) && (motionDone(point.a) && motionDone(point.b)))));
		case 9:
			var control1 = cmd.a.dW;
			var control2 = cmd.a.dX;
			var point = cmd.a.aO;
			return motionDone(control1.a) && (motionDone(control1.b) && (motionDone(control2.a) && (motionDone(control2.b) && (motionDone(point.a) && motionDone(point.b)))));
		case 10:
			var control = cmd.a.dV;
			var point = cmd.a.aO;
			return motionDone(control.a) && (motionDone(control.b) && (motionDone(point.a) && motionDone(point.b)));
		case 11:
			var control = cmd.a.dV;
			var point = cmd.a.aO;
			return motionDone(control.a) && (motionDone(control.b) && (motionDone(point.a) && motionDone(point.b)));
		case 12:
			var coords = cmd.a;
			return A2(
				$elm$core$List$all,
				function (_v1) {
					var x = _v1.a;
					var y = _v1.b;
					return motionDone(x) && motionDone(y);
				},
				coords);
		case 13:
			var coords = cmd.a;
			return A2(
				$elm$core$List$all,
				function (_v2) {
					var x = _v2.a;
					var y = _v2.b;
					return motionDone(x) && motionDone(y);
				},
				coords);
		case 14:
			var coords = cmd.a;
			return A2(
				$elm$core$List$all,
				function (_v3) {
					var x = _v3.a;
					var y = _v3.b;
					return motionDone(x) && motionDone(y);
				},
				coords);
		case 15:
			var coords = cmd.a;
			return A2(
				$elm$core$List$all,
				function (_v4) {
					var x = _v4.a;
					var y = _v4.b;
					return motionDone(x) && motionDone(y);
				},
				coords);
		case 16:
			var arc = cmd.a;
			return motionDone(arc.kg) && (motionDone(arc.kh) && (motionDone(arc.et) && (motionDone(arc.ex) && motionDone(arc.d3))));
		case 17:
			var arc = cmd.a;
			return motionDone(arc.kg) && (motionDone(arc.kh) && (motionDone(arc.et) && (motionDone(arc.ex) && motionDone(arc.d3))));
		default:
			return true;
	}
};
var $mdgriffith$elm_style_animation$Animation$Model$isDone = function (property) {
	var motionDone = function (motion) {
		var runningInterpolation = A2($elm$core$Maybe$withDefault, motion.c7, motion.lG);
		switch (runningInterpolation.$) {
			case 0:
				return (!motion.nk) && _Utils_eq(motion.x, motion.hN);
			case 1:
				var eased = runningInterpolation.a;
				return (eased.hx === 1) || ((!eased.hx) && _Utils_eq(motion.x, motion.hN));
			default:
				var speed = runningInterpolation.a;
				return _Utils_eq(motion.x, motion.hN);
		}
	};
	switch (property.$) {
		case 0:
			return true;
		case 1:
			var m1 = property.b;
			var m2 = property.c;
			var m3 = property.d;
			var m4 = property.e;
			return A2(
				$elm$core$List$all,
				motionDone,
				_List_fromArray(
					[m1, m2, m3, m4]));
		case 2:
			var shadow = property.c;
			return A2(
				$elm$core$List$all,
				motionDone,
				_List_fromArray(
					[shadow.aL, shadow.aM, shadow.dB, shadow.az, shadow.hz, shadow.gF, shadow.f8, shadow.f3]));
		case 3:
			var m1 = property.b;
			return motionDone(m1);
		case 4:
			var m1 = property.b;
			var m2 = property.c;
			return motionDone(m1) && motionDone(m2);
		case 5:
			var m1 = property.b;
			var m2 = property.c;
			var m3 = property.d;
			return A2(
				$elm$core$List$all,
				motionDone,
				_List_fromArray(
					[m1, m2, m3]));
		case 6:
			var m1 = property.b;
			var m2 = property.c;
			var m3 = property.d;
			var m4 = property.e;
			return A2(
				$elm$core$List$all,
				motionDone,
				_List_fromArray(
					[m1, m2, m3, m4]));
		case 7:
			var m1 = property.b;
			return motionDone(m1);
		case 8:
			var ms = property.a;
			return A2(
				$elm$core$List$all,
				function (_v1) {
					var x = _v1.a;
					var y = _v1.b;
					return motionDone(x) && motionDone(y);
				},
				ms);
		default:
			var cmds = property.a;
			return A2($elm$core$List$all, $mdgriffith$elm_style_animation$Animation$Model$isCmdDone, cmds);
	}
};
var $mdgriffith$elm_style_animation$Animation$Model$matchPoints = F2(
	function (points1, points2) {
		var diff = $elm$core$List$length(points1) - $elm$core$List$length(points2);
		if (diff > 0) {
			var _v0 = $elm$core$List$head(
				$elm$core$List$reverse(points2));
			if (_v0.$ === 1) {
				return _Utils_Tuple2(points1, points2);
			} else {
				var last2 = _v0.a;
				return _Utils_Tuple2(
					points1,
					_Utils_ap(
						points2,
						A2(
							$elm$core$List$repeat,
							$elm$core$Basics$abs(diff),
							last2)));
			}
		} else {
			if (diff < 0) {
				var _v1 = $elm$core$List$head(
					$elm$core$List$reverse(points1));
				if (_v1.$ === 1) {
					return _Utils_Tuple2(points1, points2);
				} else {
					var last1 = _v1.a;
					return _Utils_Tuple2(
						_Utils_ap(
							points1,
							A2(
								$elm$core$List$repeat,
								$elm$core$Basics$abs(diff),
								last1)),
						points2);
				}
			} else {
				return _Utils_Tuple2(points1, points2);
			}
		}
	});
var $mdgriffith$elm_style_animation$Animation$Model$setPathTarget = F2(
	function (cmd, targetCmd) {
		var setMotionTarget = F2(
			function (motion, targetMotion) {
				var _v27 = motion.c7;
				if (_v27.$ === 1) {
					var ease = _v27.a;
					return _Utils_update(
						motion,
						{
							c7: $mdgriffith$elm_style_animation$Animation$Model$Easing(
								_Utils_update(
									ease,
									{hJ: motion.x})),
							hN: targetMotion.x
						});
				} else {
					return _Utils_update(
						motion,
						{hN: targetMotion.x});
				}
			});
		switch (cmd.$) {
			case 0:
				var m1 = cmd.a;
				var m2 = cmd.b;
				if (!targetCmd.$) {
					var t1 = targetCmd.a;
					var t2 = targetCmd.b;
					return A2(
						$mdgriffith$elm_style_animation$Animation$Model$Move,
						A2(setMotionTarget, m1, t1),
						A2(setMotionTarget, m2, t2));
				} else {
					return cmd;
				}
			case 1:
				var m1 = cmd.a;
				var m2 = cmd.b;
				if (targetCmd.$ === 1) {
					var t1 = targetCmd.a;
					var t2 = targetCmd.b;
					return A2(
						$mdgriffith$elm_style_animation$Animation$Model$MoveTo,
						A2(setMotionTarget, m1, t1),
						A2(setMotionTarget, m2, t2));
				} else {
					return cmd;
				}
			case 2:
				var m1 = cmd.a;
				var m2 = cmd.b;
				if (targetCmd.$ === 2) {
					var t1 = targetCmd.a;
					var t2 = targetCmd.b;
					return A2(
						$mdgriffith$elm_style_animation$Animation$Model$Line,
						A2(setMotionTarget, m1, t1),
						A2(setMotionTarget, m2, t2));
				} else {
					return cmd;
				}
			case 3:
				var m1 = cmd.a;
				var m2 = cmd.b;
				if (targetCmd.$ === 3) {
					var t1 = targetCmd.a;
					var t2 = targetCmd.b;
					return A2(
						$mdgriffith$elm_style_animation$Animation$Model$LineTo,
						A2(setMotionTarget, m1, t1),
						A2(setMotionTarget, m2, t2));
				} else {
					return cmd;
				}
			case 4:
				var m1 = cmd.a;
				if (targetCmd.$ === 4) {
					var t1 = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$Horizontal(
						A2(setMotionTarget, m1, t1));
				} else {
					return cmd;
				}
			case 5:
				var m1 = cmd.a;
				if (targetCmd.$ === 5) {
					var t1 = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$HorizontalTo(
						A2(setMotionTarget, m1, t1));
				} else {
					return cmd;
				}
			case 6:
				var m1 = cmd.a;
				if (targetCmd.$ === 6) {
					var t1 = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$Vertical(
						A2(setMotionTarget, m1, t1));
				} else {
					return cmd;
				}
			case 7:
				var m1 = cmd.a;
				if (targetCmd.$ === 7) {
					var t1 = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$VerticalTo(
						A2(setMotionTarget, m1, t1));
				} else {
					return cmd;
				}
			case 8:
				var points = cmd.a;
				if (targetCmd.$ === 8) {
					var targets = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$Curve(
						{
							dW: _Utils_Tuple2(
								A2(setMotionTarget, points.dW.a, targets.dW.a),
								A2(setMotionTarget, points.dW.b, targets.dW.b)),
							dX: _Utils_Tuple2(
								A2(setMotionTarget, points.dX.a, targets.dX.a),
								A2(setMotionTarget, points.dX.b, targets.dX.b)),
							aO: _Utils_Tuple2(
								A2(setMotionTarget, points.aO.a, targets.aO.a),
								A2(setMotionTarget, points.aO.b, targets.aO.b))
						});
				} else {
					return cmd;
				}
			case 9:
				var points = cmd.a;
				if (targetCmd.$ === 9) {
					var targets = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$CurveTo(
						{
							dW: _Utils_Tuple2(
								A2(setMotionTarget, points.dW.a, targets.dW.a),
								A2(setMotionTarget, points.dW.b, targets.dW.b)),
							dX: _Utils_Tuple2(
								A2(setMotionTarget, points.dX.a, targets.dX.a),
								A2(setMotionTarget, points.dX.b, targets.dX.b)),
							aO: _Utils_Tuple2(
								A2(setMotionTarget, points.aO.a, targets.aO.a),
								A2(setMotionTarget, points.aO.b, targets.aO.b))
						});
				} else {
					return cmd;
				}
			case 10:
				var points = cmd.a;
				if (targetCmd.$ === 10) {
					var targets = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$Quadratic(
						{
							dV: _Utils_Tuple2(
								A2(setMotionTarget, points.dV.a, targets.dV.a),
								A2(setMotionTarget, points.dV.b, targets.dV.b)),
							aO: _Utils_Tuple2(
								A2(setMotionTarget, points.aO.a, targets.aO.a),
								A2(setMotionTarget, points.aO.b, targets.aO.b))
						});
				} else {
					return cmd;
				}
			case 11:
				var points = cmd.a;
				if (targetCmd.$ === 11) {
					var targets = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$QuadraticTo(
						{
							dV: _Utils_Tuple2(
								A2(setMotionTarget, points.dV.a, targets.dV.a),
								A2(setMotionTarget, points.dV.b, targets.dV.b)),
							aO: _Utils_Tuple2(
								A2(setMotionTarget, points.aO.a, targets.aO.a),
								A2(setMotionTarget, points.aO.b, targets.aO.b))
						});
				} else {
					return cmd;
				}
			case 12:
				var coords = cmd.a;
				if (targetCmd.$ === 12) {
					var targetCoords = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$SmoothQuadratic(
						A3(
							$elm$core$List$map2,
							F2(
								function (_v14, _v15) {
									var x1 = _v14.a;
									var y1 = _v14.b;
									var x2 = _v15.a;
									var y2 = _v15.b;
									return _Utils_Tuple2(
										A2(setMotionTarget, x1, x2),
										A2(setMotionTarget, y1, y2));
								}),
							coords,
							targetCoords));
				} else {
					return cmd;
				}
			case 13:
				var coords = cmd.a;
				if (targetCmd.$ === 13) {
					var targetCoords = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$SmoothQuadraticTo(
						A3(
							$elm$core$List$map2,
							F2(
								function (_v17, _v18) {
									var x1 = _v17.a;
									var y1 = _v17.b;
									var x2 = _v18.a;
									var y2 = _v18.b;
									return _Utils_Tuple2(
										A2(setMotionTarget, x1, x2),
										A2(setMotionTarget, y1, y2));
								}),
							coords,
							targetCoords));
				} else {
					return cmd;
				}
			case 14:
				var coords = cmd.a;
				if (targetCmd.$ === 14) {
					var targetCoords = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$Smooth(
						A3(
							$elm$core$List$map2,
							F2(
								function (_v20, _v21) {
									var x1 = _v20.a;
									var y1 = _v20.b;
									var x2 = _v21.a;
									var y2 = _v21.b;
									return _Utils_Tuple2(
										A2(setMotionTarget, x1, x2),
										A2(setMotionTarget, y1, y2));
								}),
							coords,
							targetCoords));
				} else {
					return cmd;
				}
			case 15:
				var coords = cmd.a;
				if (targetCmd.$ === 15) {
					var targetCoords = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$SmoothTo(
						A3(
							$elm$core$List$map2,
							F2(
								function (_v23, _v24) {
									var x1 = _v23.a;
									var y1 = _v23.b;
									var x2 = _v24.a;
									var y2 = _v24.b;
									return _Utils_Tuple2(
										A2(setMotionTarget, x1, x2),
										A2(setMotionTarget, y1, y2));
								}),
							coords,
							targetCoords));
				} else {
					return cmd;
				}
			case 16:
				var arc = cmd.a;
				if (targetCmd.$ === 16) {
					var target = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$ClockwiseArc(
						function () {
							var y = arc.kh;
							var x = arc.kg;
							var startAngle = arc.ex;
							var radius = arc.et;
							var endAngle = arc.d3;
							return _Utils_update(
								arc,
								{
									d3: A2(setMotionTarget, endAngle, target.d3),
									et: A2(setMotionTarget, radius, target.et),
									ex: A2(setMotionTarget, startAngle, target.ex),
									kg: A2(setMotionTarget, x, target.kg),
									kh: A2(setMotionTarget, y, target.kh)
								});
						}());
				} else {
					return cmd;
				}
			case 17:
				var arc = cmd.a;
				if (targetCmd.$ === 17) {
					var target = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$AntiClockwiseArc(
						function () {
							var y = arc.kh;
							var x = arc.kg;
							var startAngle = arc.ex;
							var radius = arc.et;
							var endAngle = arc.d3;
							return _Utils_update(
								arc,
								{
									d3: A2(setMotionTarget, endAngle, target.d3),
									et: A2(setMotionTarget, radius, target.et),
									ex: A2(setMotionTarget, startAngle, target.ex),
									kg: A2(setMotionTarget, x, target.kg),
									kh: A2(setMotionTarget, y, target.kh)
								});
						}());
				} else {
					return cmd;
				}
			default:
				return $mdgriffith$elm_style_animation$Animation$Model$Close;
		}
	});
var $mdgriffith$elm_style_animation$Animation$Model$setTarget = F3(
	function (overrideInterpolation, current, newTarget) {
		var setMotionTarget = F2(
			function (motion, targetMotion) {
				var newMotion = overrideInterpolation ? _Utils_update(
					motion,
					{
						lG: $elm$core$Maybe$Just(targetMotion.c7)
					}) : motion;
				var _v13 = newMotion.lG;
				if (_v13.$ === 1) {
					var _v14 = newMotion.c7;
					if (_v14.$ === 1) {
						var ease = _v14.a;
						return _Utils_update(
							newMotion,
							{
								c7: $mdgriffith$elm_style_animation$Animation$Model$Easing(
									_Utils_update(
										ease,
										{hx: 0, hJ: motion.x})),
								hN: targetMotion.x
							});
					} else {
						return _Utils_update(
							newMotion,
							{hN: targetMotion.x});
					}
				} else {
					var override = _v13.a;
					if (override.$ === 1) {
						var ease = override.a;
						return _Utils_update(
							newMotion,
							{
								lG: $elm$core$Maybe$Just(
									$mdgriffith$elm_style_animation$Animation$Model$Easing(
										_Utils_update(
											ease,
											{hx: 0, hJ: motion.x}))),
								hN: targetMotion.x
							});
					} else {
						return _Utils_update(
							newMotion,
							{hN: targetMotion.x});
					}
				}
			});
		switch (current.$) {
			case 0:
				var name = current.a;
				var value = current.b;
				return A2($mdgriffith$elm_style_animation$Animation$Model$ExactProperty, name, value);
			case 1:
				var name = current.a;
				var m1 = current.b;
				var m2 = current.c;
				var m3 = current.d;
				var m4 = current.e;
				if (newTarget.$ === 1) {
					var t1 = newTarget.b;
					var t2 = newTarget.c;
					var t3 = newTarget.d;
					var t4 = newTarget.e;
					return A5(
						$mdgriffith$elm_style_animation$Animation$Model$ColorProperty,
						name,
						A2(setMotionTarget, m1, t1),
						A2(setMotionTarget, m2, t2),
						A2(setMotionTarget, m3, t3),
						A2(setMotionTarget, m4, t4));
				} else {
					return current;
				}
			case 2:
				var name = current.a;
				var inset = current.b;
				var shadow = current.c;
				if (newTarget.$ === 2) {
					var targetShadow = newTarget.c;
					return A3(
						$mdgriffith$elm_style_animation$Animation$Model$ShadowProperty,
						name,
						inset,
						{
							f3: A2(setMotionTarget, shadow.f3, targetShadow.f3),
							f8: A2(setMotionTarget, shadow.f8, targetShadow.f8),
							az: A2(setMotionTarget, shadow.az, targetShadow.az),
							gF: A2(setMotionTarget, shadow.gF, targetShadow.gF),
							aL: A2(setMotionTarget, shadow.aL, targetShadow.aL),
							aM: A2(setMotionTarget, shadow.aM, targetShadow.aM),
							hz: A2(setMotionTarget, shadow.hz, targetShadow.hz),
							dB: A2(setMotionTarget, shadow.dB, targetShadow.dB)
						});
				} else {
					return current;
				}
			case 3:
				var name = current.a;
				var m1 = current.b;
				if (newTarget.$ === 3) {
					var t1 = newTarget.b;
					return A2(
						$mdgriffith$elm_style_animation$Animation$Model$Property,
						name,
						A2(setMotionTarget, m1, t1));
				} else {
					return current;
				}
			case 4:
				var name = current.a;
				var m1 = current.b;
				var m2 = current.c;
				if (newTarget.$ === 4) {
					var t1 = newTarget.b;
					var t2 = newTarget.c;
					return A3(
						$mdgriffith$elm_style_animation$Animation$Model$Property2,
						name,
						A2(setMotionTarget, m1, t1),
						A2(setMotionTarget, m2, t2));
				} else {
					return current;
				}
			case 5:
				var name = current.a;
				var m1 = current.b;
				var m2 = current.c;
				var m3 = current.d;
				if (newTarget.$ === 5) {
					var t1 = newTarget.b;
					var t2 = newTarget.c;
					var t3 = newTarget.d;
					return A4(
						$mdgriffith$elm_style_animation$Animation$Model$Property3,
						name,
						A2(setMotionTarget, m1, t1),
						A2(setMotionTarget, m2, t2),
						A2(setMotionTarget, m3, t3));
				} else {
					return current;
				}
			case 6:
				var name = current.a;
				var m1 = current.b;
				var m2 = current.c;
				var m3 = current.d;
				var m4 = current.e;
				if (newTarget.$ === 6) {
					var t1 = newTarget.b;
					var t2 = newTarget.c;
					var t3 = newTarget.d;
					var t4 = newTarget.e;
					return A5(
						$mdgriffith$elm_style_animation$Animation$Model$Property4,
						name,
						A2(setMotionTarget, m1, t1),
						A2(setMotionTarget, m2, t2),
						A2(setMotionTarget, m3, t3),
						A2(setMotionTarget, m4, t4));
				} else {
					return current;
				}
			case 7:
				var name = current.a;
				var m1 = current.b;
				if (newTarget.$ === 7) {
					var t1 = newTarget.b;
					return A2(
						$mdgriffith$elm_style_animation$Animation$Model$AngleProperty,
						name,
						A2(setMotionTarget, m1, t1));
				} else {
					return current;
				}
			case 8:
				var currentPts = current.a;
				if (newTarget.$ === 8) {
					var targetPts = newTarget.a;
					var _v9 = A2($mdgriffith$elm_style_animation$Animation$Model$matchPoints, currentPts, targetPts);
					var m1s = _v9.a;
					var m2s = _v9.b;
					return $mdgriffith$elm_style_animation$Animation$Model$Points(
						A3(
							$elm$core$List$map2,
							F2(
								function (_v10, _v11) {
									var x1 = _v10.a;
									var y1 = _v10.b;
									var x2 = _v11.a;
									var y2 = _v11.b;
									return _Utils_Tuple2(
										A2(setMotionTarget, x1, x2),
										A2(setMotionTarget, y1, y2));
								}),
							m1s,
							m2s));
				} else {
					return current;
				}
			default:
				var cmds = current.a;
				if (newTarget.$ === 9) {
					var targets = newTarget.a;
					return $mdgriffith$elm_style_animation$Animation$Model$Path(
						A3($elm$core$List$map2, $mdgriffith$elm_style_animation$Animation$Model$setPathTarget, cmds, targets));
				} else {
					return current;
				}
		}
	});
var $mdgriffith$elm_style_animation$Animation$Model$zipPropertiesGreedy = F2(
	function (initialProps, newTargetProps) {
		var propertyMatch = F2(
			function (prop1, prop2) {
				return _Utils_eq(
					$mdgriffith$elm_style_animation$Animation$Model$propertyName(prop1),
					$mdgriffith$elm_style_animation$Animation$Model$propertyName(prop2));
			});
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, _v2) {
					var stackA = _v2.a;
					var stackB = _v2.b;
					var result = _v2.c;
					var _v3 = $elm$core$List$head(stackA);
					if (_v3.$ === 1) {
						return _Utils_Tuple3(stackA, stackB, result);
					} else {
						var a = _v3.a;
						var _v4 = A2(
							$elm$core$List$partition,
							propertyMatch(a),
							stackB);
						var matchingBs = _v4.a;
						var nonMatchingBs = _v4.b;
						return _Utils_Tuple3(
							A2($elm$core$List$drop, 1, stackA),
							function () {
								if (!matchingBs.b) {
									return nonMatchingBs;
								} else {
									var b = matchingBs.a;
									var remainingBs = matchingBs.b;
									return _Utils_ap(remainingBs, nonMatchingBs);
								}
							}(),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									a,
									$elm$core$List$head(matchingBs)),
								result));
					}
				}),
			_Utils_Tuple3(initialProps, newTargetProps, _List_Nil),
			A2(
				$elm$core$List$repeat,
				$elm$core$List$length(initialProps),
				0));
		var warnings = _v0.b;
		var props = _v0.c;
		var _v6 = warnings;
		return $elm$core$List$reverse(props);
	});
var $mdgriffith$elm_style_animation$Animation$Model$startTowards = F3(
	function (overrideInterpolation, current, target) {
		return A2(
			$elm$core$List$filterMap,
			function (propPair) {
				if (!propPair.b.$) {
					var cur = propPair.a;
					var to = propPair.b.a;
					return $elm$core$Maybe$Just(
						A3($mdgriffith$elm_style_animation$Animation$Model$setTarget, overrideInterpolation, cur, to));
				} else {
					var prop = propPair.a;
					var _v1 = propPair.b;
					return $elm$core$Maybe$Just(prop);
				}
			},
			A2($mdgriffith$elm_style_animation$Animation$Model$zipPropertiesGreedy, current, target));
	});
var $mdgriffith$elm_style_animation$Animation$Model$tolerance = 0.01;
var $elm$core$Basics$truncate = _Basics_truncate;
var $mdgriffith$elm_style_animation$Animation$Model$vTolerance = 0.1;
var $mdgriffith$elm_style_animation$Animation$Model$stepInterpolation = F2(
	function (posix, motion) {
		var interpolationToUse = A2($elm$core$Maybe$withDefault, motion.c7, motion.lG);
		var dtms = $elm$time$Time$posixToMillis(posix);
		switch (interpolationToUse.$) {
			case 2:
				var perSecond = interpolationToUse.a.jr;
				var _v1 = function () {
					if (_Utils_cmp(motion.x, motion.hN) < 0) {
						var _new = motion.x + (perSecond * (dtms / 1000));
						return _Utils_Tuple2(
							_new,
							_Utils_cmp(_new, motion.hN) > -1);
					} else {
						var _new = motion.x - (perSecond * (dtms / 1000));
						return _Utils_Tuple2(
							_new,
							_Utils_cmp(_new, motion.hN) < 1);
					}
				}();
				var newPos = _v1.a;
				var finished = _v1.b;
				return finished ? _Utils_update(
					motion,
					{x: motion.hN, nk: 0.0}) : _Utils_update(
					motion,
					{x: newPos, nk: perSecond * 1000});
			case 0:
				var stiffness = interpolationToUse.a.jW;
				var damping = interpolationToUse.a.iz;
				var fspring = stiffness * (motion.hN - motion.x);
				var fdamper = ((-1) * damping) * motion.nk;
				var dt = dtms / 1000;
				var a = fspring + fdamper;
				var newVelocity = motion.nk + (a * dt);
				var newPos = motion.x + (newVelocity * dt);
				var dx = $elm$core$Basics$abs(motion.hN - newPos);
				return ((_Utils_cmp(dx, $mdgriffith$elm_style_animation$Animation$Model$tolerance) < 0) && (_Utils_cmp(
					$elm$core$Basics$abs(newVelocity),
					$mdgriffith$elm_style_animation$Animation$Model$vTolerance) < 0)) ? _Utils_update(
					motion,
					{x: motion.hN, nk: 0.0}) : _Utils_update(
					motion,
					{x: newPos, nk: newVelocity});
			default:
				var progress = interpolationToUse.a.hx;
				var duration = interpolationToUse.a.gn;
				var ease = interpolationToUse.a.go;
				var start = interpolationToUse.a.hJ;
				var durationMs = $elm$time$Time$posixToMillis(duration);
				var newProgress = (((dtms / durationMs) + progress) < 1) ? ((dtms / durationMs) + progress) : 1;
				var eased = ease(newProgress);
				var distance = motion.hN - start;
				var newPos = ((((eased * distance) + start) * 10000) | 0) / 10000;
				var newVelocity = (newProgress === 1) ? 0 : ((newPos - motion.x) / dtms);
				var _v2 = motion.lG;
				if (_v2.$ === 1) {
					return _Utils_update(
						motion,
						{
							c7: $mdgriffith$elm_style_animation$Animation$Model$Easing(
								{gn: duration, go: ease, hx: newProgress, hJ: start}),
							x: newPos,
							nk: newVelocity
						});
				} else {
					var override = _v2.a;
					return _Utils_update(
						motion,
						{
							lG: $elm$core$Maybe$Just(
								$mdgriffith$elm_style_animation$Animation$Model$Easing(
									{gn: duration, go: ease, hx: newProgress, hJ: start})),
							x: newPos,
							nk: newVelocity
						});
				}
		}
	});
var $mdgriffith$elm_style_animation$Animation$Model$stepPath = F2(
	function (dt, cmd) {
		var stepCoords = function (coords) {
			return A2(
				$elm$core$List$map,
				function (_v1) {
					var x = _v1.a;
					var y = _v1.b;
					return _Utils_Tuple2(
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, x),
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, y));
				},
				coords);
		};
		switch (cmd.$) {
			case 0:
				var m1 = cmd.a;
				var m2 = cmd.b;
				return A2(
					$mdgriffith$elm_style_animation$Animation$Model$Move,
					A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, m1),
					A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, m2));
			case 1:
				var m1 = cmd.a;
				var m2 = cmd.b;
				return A2(
					$mdgriffith$elm_style_animation$Animation$Model$MoveTo,
					A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, m1),
					A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, m2));
			case 2:
				var m1 = cmd.a;
				var m2 = cmd.b;
				return A2(
					$mdgriffith$elm_style_animation$Animation$Model$Line,
					A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, m1),
					A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, m2));
			case 3:
				var m1 = cmd.a;
				var m2 = cmd.b;
				return A2(
					$mdgriffith$elm_style_animation$Animation$Model$LineTo,
					A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, m1),
					A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, m2));
			case 4:
				var motion = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$Horizontal(
					A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion));
			case 5:
				var motion = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$HorizontalTo(
					A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion));
			case 6:
				var motion = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$Vertical(
					A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion));
			case 7:
				var motion = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$VerticalTo(
					A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion));
			case 8:
				var control1 = cmd.a.dW;
				var control2 = cmd.a.dX;
				var point = cmd.a.aO;
				return $mdgriffith$elm_style_animation$Animation$Model$Curve(
					{
						dW: _Utils_Tuple2(
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, control1.a),
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, control1.b)),
						dX: _Utils_Tuple2(
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, control2.a),
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, control2.b)),
						aO: _Utils_Tuple2(
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, point.a),
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, point.b))
					});
			case 9:
				var control1 = cmd.a.dW;
				var control2 = cmd.a.dX;
				var point = cmd.a.aO;
				return $mdgriffith$elm_style_animation$Animation$Model$CurveTo(
					{
						dW: _Utils_Tuple2(
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, control1.a),
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, control1.b)),
						dX: _Utils_Tuple2(
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, control2.a),
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, control2.b)),
						aO: _Utils_Tuple2(
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, point.a),
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, point.b))
					});
			case 10:
				var control = cmd.a.dV;
				var point = cmd.a.aO;
				return $mdgriffith$elm_style_animation$Animation$Model$Quadratic(
					{
						dV: _Utils_Tuple2(
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, control.a),
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, control.b)),
						aO: _Utils_Tuple2(
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, point.a),
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, point.b))
					});
			case 11:
				var control = cmd.a.dV;
				var point = cmd.a.aO;
				return $mdgriffith$elm_style_animation$Animation$Model$QuadraticTo(
					{
						dV: _Utils_Tuple2(
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, control.a),
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, control.b)),
						aO: _Utils_Tuple2(
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, point.a),
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, point.b))
					});
			case 12:
				var coords = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$SmoothQuadratic(
					stepCoords(coords));
			case 13:
				var coords = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$SmoothQuadraticTo(
					stepCoords(coords));
			case 14:
				var coords = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$Smooth(
					stepCoords(coords));
			case 15:
				var coords = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$SmoothTo(
					stepCoords(coords));
			case 16:
				var arc = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$ClockwiseArc(
					_Utils_update(
						arc,
						{
							d3: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, arc.d3),
							et: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, arc.et),
							ex: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, arc.ex),
							kg: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, arc.kg),
							kh: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, arc.kh)
						}));
			case 17:
				var arc = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$AntiClockwiseArc(
					_Utils_update(
						arc,
						{
							d3: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, arc.d3),
							et: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, arc.et),
							ex: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, arc.ex),
							kg: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, arc.kg),
							kh: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, arc.kh)
						}));
			default:
				return $mdgriffith$elm_style_animation$Animation$Model$Close;
		}
	});
var $mdgriffith$elm_style_animation$Animation$Model$step = F2(
	function (dt, props) {
		var stepProp = function (property) {
			switch (property.$) {
				case 0:
					var name = property.a;
					var value = property.b;
					return A2($mdgriffith$elm_style_animation$Animation$Model$ExactProperty, name, value);
				case 3:
					var name = property.a;
					var motion = property.b;
					return A2(
						$mdgriffith$elm_style_animation$Animation$Model$Property,
						name,
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion));
				case 4:
					var name = property.a;
					var motion1 = property.b;
					var motion2 = property.c;
					return A3(
						$mdgriffith$elm_style_animation$Animation$Model$Property2,
						name,
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion1),
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion2));
				case 5:
					var name = property.a;
					var motion1 = property.b;
					var motion2 = property.c;
					var motion3 = property.d;
					return A4(
						$mdgriffith$elm_style_animation$Animation$Model$Property3,
						name,
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion1),
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion2),
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion3));
				case 6:
					var name = property.a;
					var motion1 = property.b;
					var motion2 = property.c;
					var motion3 = property.d;
					var motion4 = property.e;
					return A5(
						$mdgriffith$elm_style_animation$Animation$Model$Property4,
						name,
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion1),
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion2),
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion3),
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion4));
				case 7:
					var name = property.a;
					var motion = property.b;
					return A2(
						$mdgriffith$elm_style_animation$Animation$Model$AngleProperty,
						name,
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion));
				case 1:
					var name = property.a;
					var red = property.b;
					var green = property.c;
					var blue = property.d;
					var alpha = property.e;
					return A5(
						$mdgriffith$elm_style_animation$Animation$Model$ColorProperty,
						name,
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, red),
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, green),
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, blue),
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, alpha));
				case 2:
					var name = property.a;
					var inset = property.b;
					var shadow = property.c;
					return A3(
						$mdgriffith$elm_style_animation$Animation$Model$ShadowProperty,
						name,
						inset,
						{
							f3: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, shadow.f3),
							f8: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, shadow.f8),
							az: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, shadow.az),
							gF: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, shadow.gF),
							aL: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, shadow.aL),
							aM: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, shadow.aM),
							hz: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, shadow.hz),
							dB: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, shadow.dB)
						});
				case 8:
					var points = property.a;
					return $mdgriffith$elm_style_animation$Animation$Model$Points(
						A2(
							$elm$core$List$map,
							function (_v1) {
								var x = _v1.a;
								var y = _v1.b;
								return _Utils_Tuple2(
									A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, x),
									A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, y));
							},
							points));
				default:
					var cmds = property.a;
					return $mdgriffith$elm_style_animation$Animation$Model$Path(
						A2(
							$elm$core$List$map,
							$mdgriffith$elm_style_animation$Animation$Model$stepPath(dt),
							cmds));
			}
		};
		return A2($elm$core$List$map, stepProp, props);
	});
var $mdgriffith$elm_style_animation$Animation$Model$alreadyThere = F2(
	function (current, target) {
		return A2(
			$elm$core$List$all,
			$mdgriffith$elm_style_animation$Animation$Model$isDone,
			A2(
				$mdgriffith$elm_style_animation$Animation$Model$step,
				$elm$time$Time$millisToPosix(0),
				A3($mdgriffith$elm_style_animation$Animation$Model$startTowards, false, current, target)));
	});
var $mdgriffith$elm_style_animation$Animation$Model$replaceProps = F2(
	function (props, replacements) {
		var replacementNames = A2($elm$core$List$map, $mdgriffith$elm_style_animation$Animation$Model$propertyName, replacements);
		var removed = A2(
			$elm$core$List$filter,
			function (prop) {
				return !A2(
					$elm$core$List$member,
					$mdgriffith$elm_style_animation$Animation$Model$propertyName(prop),
					replacementNames);
			},
			props);
		return _Utils_ap(removed, replacements);
	});
var $mdgriffith$elm_style_animation$Animation$Model$resolveSteps = F3(
	function (currentStyle, steps, dt) {
		resolveSteps:
		while (true) {
			var _v0 = $elm$core$List$head(steps);
			if (_v0.$ === 1) {
				return _Utils_Tuple3(currentStyle, _List_Nil, _List_Nil);
			} else {
				var currentStep = _v0.a;
				switch (currentStep.$) {
					case 4:
						var n = currentStep.a;
						if ($elm$time$Time$posixToMillis(n) <= 0) {
							var $temp$currentStyle = currentStyle,
								$temp$steps = A2($elm$core$List$drop, 1, steps),
								$temp$dt = dt;
							currentStyle = $temp$currentStyle;
							steps = $temp$steps;
							dt = $temp$dt;
							continue resolveSteps;
						} else {
							return _Utils_Tuple3(
								currentStyle,
								_List_Nil,
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_style_animation$Animation$Model$Wait(
										$elm$time$Time$millisToPosix(
											$elm$time$Time$posixToMillis(n) - $elm$time$Time$posixToMillis(dt))),
									A2($elm$core$List$drop, 1, steps)));
						}
					case 5:
						var msg = currentStep.a;
						var _v2 = A3(
							$mdgriffith$elm_style_animation$Animation$Model$resolveSteps,
							currentStyle,
							A2($elm$core$List$drop, 1, steps),
							dt);
						var newStyle = _v2.a;
						var msgs = _v2.b;
						var remainingSteps = _v2.c;
						return _Utils_Tuple3(
							newStyle,
							A2($elm$core$List$cons, msg, msgs),
							remainingSteps);
					case 1:
						var target = currentStep.a;
						if (A2($mdgriffith$elm_style_animation$Animation$Model$alreadyThere, currentStyle, target)) {
							return _Utils_Tuple3(
								currentStyle,
								_List_Nil,
								A2($elm$core$List$drop, 1, steps));
						} else {
							var $temp$currentStyle = A3($mdgriffith$elm_style_animation$Animation$Model$startTowards, false, currentStyle, target),
								$temp$steps = A2(
								$elm$core$List$cons,
								$mdgriffith$elm_style_animation$Animation$Model$Step,
								A2($elm$core$List$drop, 1, steps)),
								$temp$dt = dt;
							currentStyle = $temp$currentStyle;
							steps = $temp$steps;
							dt = $temp$dt;
							continue resolveSteps;
						}
					case 2:
						var target = currentStep.a;
						if (A2($mdgriffith$elm_style_animation$Animation$Model$alreadyThere, currentStyle, target)) {
							return _Utils_Tuple3(
								currentStyle,
								_List_Nil,
								A2($elm$core$List$drop, 1, steps));
						} else {
							var $temp$currentStyle = A3($mdgriffith$elm_style_animation$Animation$Model$startTowards, true, currentStyle, target),
								$temp$steps = A2(
								$elm$core$List$cons,
								$mdgriffith$elm_style_animation$Animation$Model$Step,
								A2($elm$core$List$drop, 1, steps)),
								$temp$dt = dt;
							currentStyle = $temp$currentStyle;
							steps = $temp$steps;
							dt = $temp$dt;
							continue resolveSteps;
						}
					case 3:
						var props = currentStep.a;
						var $temp$currentStyle = A2($mdgriffith$elm_style_animation$Animation$Model$replaceProps, currentStyle, props),
							$temp$steps = A2($elm$core$List$drop, 1, steps),
							$temp$dt = dt;
						currentStyle = $temp$currentStyle;
						steps = $temp$steps;
						dt = $temp$dt;
						continue resolveSteps;
					case 0:
						var stepped = A2($mdgriffith$elm_style_animation$Animation$Model$step, dt, currentStyle);
						return A2($elm$core$List$all, $mdgriffith$elm_style_animation$Animation$Model$isDone, stepped) ? _Utils_Tuple3(
							A2(
								$elm$core$List$map,
								$mdgriffith$elm_style_animation$Animation$Model$mapToMotion(
									function (m) {
										return _Utils_update(
											m,
											{lG: $elm$core$Maybe$Nothing});
									}),
								stepped),
							_List_Nil,
							A2($elm$core$List$drop, 1, steps)) : _Utils_Tuple3(stepped, _List_Nil, steps);
					case 7:
						var substeps = currentStep.a;
						var $temp$currentStyle = currentStyle,
							$temp$steps = _Utils_ap(
							substeps,
							_List_fromArray(
								[
									$mdgriffith$elm_style_animation$Animation$Model$Loop(substeps)
								])),
							$temp$dt = dt;
						currentStyle = $temp$currentStyle;
						steps = $temp$steps;
						dt = $temp$dt;
						continue resolveSteps;
					default:
						var n = currentStep.a;
						var substeps = currentStep.b;
						if (n <= 0) {
							var $temp$currentStyle = currentStyle,
								$temp$steps = A2($elm$core$List$drop, 1, steps),
								$temp$dt = dt;
							currentStyle = $temp$currentStyle;
							steps = $temp$steps;
							dt = $temp$dt;
							continue resolveSteps;
						} else {
							var $temp$currentStyle = currentStyle,
								$temp$steps = _Utils_ap(
								substeps,
								_Utils_ap(
									_List_fromArray(
										[
											A2($mdgriffith$elm_style_animation$Animation$Model$Repeat, n - 1, substeps)
										]),
									A2($elm$core$List$drop, 1, steps))),
								$temp$dt = dt;
							currentStyle = $temp$currentStyle;
							steps = $temp$steps;
							dt = $temp$dt;
							continue resolveSteps;
						}
				}
			}
		}
	});
var $mdgriffith$elm_style_animation$Animation$Model$updateAnimation = F2(
	function (_v0, _v1) {
		var now = _v0;
		var model = _v1;
		var timing = A2($mdgriffith$elm_style_animation$Animation$Model$refreshTiming, now, model.j$);
		var _v2 = A2(
			$elm$core$List$partition,
			function (_v4) {
				var wait = _v4.a;
				var mySteps = _v4.b;
				return $elm$time$Time$posixToMillis(wait) <= 0;
			},
			A2(
				$elm$core$List$map,
				function (_v3) {
					var wait = _v3.a;
					var mySteps = _v3.b;
					return _Utils_Tuple2(
						$elm$time$Time$millisToPosix(
							$elm$time$Time$posixToMillis(wait) - $elm$time$Time$posixToMillis(timing.lb)),
						mySteps);
				},
				model.gT));
		var readyInterruption = _v2.a;
		var queuedInterruptions = _v2.b;
		var _v5 = function () {
			var _v6 = $elm$core$List$head(readyInterruption);
			if (!_v6.$) {
				var _v7 = _v6.a;
				var wait = _v7.a;
				var interrupt = _v7.b;
				return _Utils_Tuple2(
					interrupt,
					A2(
						$elm$core$List$map,
						$mdgriffith$elm_style_animation$Animation$Model$mapToMotion(
							function (m) {
								return _Utils_update(
									m,
									{lG: $elm$core$Maybe$Nothing});
							}),
						model.cs));
			} else {
				return _Utils_Tuple2(model.hK, model.cs);
			}
		}();
		var steps = _v5.a;
		var style = _v5.b;
		var _v8 = A3($mdgriffith$elm_style_animation$Animation$Model$resolveSteps, style, steps, timing.lb);
		var revisedStyle = _v8.a;
		var sentMessages = _v8.b;
		var revisedSteps = _v8.c;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					gT: queuedInterruptions,
					fF: (!(!$elm$core$List$length(revisedSteps))) || (!(!$elm$core$List$length(queuedInterruptions))),
					hK: revisedSteps,
					cs: revisedStyle,
					j$: timing
				}),
			$elm$core$Platform$Cmd$batch(
				A2(
					$elm$core$List$map,
					function (m) {
						return A2(
							$elm$core$Task$perform,
							$elm$core$Basics$identity,
							$elm$core$Task$succeed(m));
					},
					sentMessages)));
	});
var $mdgriffith$elm_style_animation$Animation$update = F2(
	function (tick, animation) {
		return A2($mdgriffith$elm_style_animation$Animation$Model$updateAnimation, tick, animation).a;
	});
var $author$project$ColorPicker$Closed = 1;
var $author$project$ColorPicker$Open = 0;
var $author$project$ColorPicker$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return model;
			case 1:
				var uniqueId = msg.a;
				return A3($elm$core$Dict$insert, uniqueId, 0, model);
			default:
				var cfgId = msg.a;
				return A3(
					$elm$core$Dict$update,
					cfgId,
					function (maybePicker) {
						if (maybePicker.$ === 1) {
							return $elm$core$Maybe$Nothing;
						} else {
							var picker = maybePicker.a;
							return $elm$core$Maybe$Just(1);
						}
					},
					model);
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$Blur = {$: 6};
var $CurrySoftware$elm_datepicker$DatePicker$close = $CurrySoftware$elm_datepicker$DatePicker$Blur;
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $CurrySoftware$elm_datepicker$DatePicker$formatCell = function (day) {
	return $elm$html$Html$text(day);
};
var $CurrySoftware$elm_datepicker$DatePicker$Date$formatDay = function (day) {
	switch (day) {
		case 0:
			return 'Mo';
		case 1:
			return 'Tu';
		case 2:
			return 'We';
		case 3:
			return 'Th';
		case 4:
			return 'Fr';
		case 5:
			return 'Sa';
		default:
			return 'Su';
	}
};
var $CurrySoftware$elm_datepicker$DatePicker$Date$formatMonth = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.jv;
	if (problem.$ === 12) {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn) && A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2(
				$justinmimbs$date$Date$daysBeforeMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn))) + d) : $elm$core$Result$Err(
			'Invalid calendar date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(mn) + (', ' + ($elm$core$String$fromInt(d) + ')'))))));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 365, od) || ((od === 366) && $justinmimbs$date$Date$isLeapYear(y))) ? $elm$core$Result$Ok(
			$justinmimbs$date$Date$daysBeforeYear(y) + od) : $elm$core$Result$Err(
			'Invalid ordinal date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(od) + ')'))));
	});
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn) && (A3($justinmimbs$date$Date$isBetweenInt, 1, 52, wn) || ((wn === 53) && $justinmimbs$date$Date$is53WeekYear(wy)))) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn) : $elm$core$Result$Err(
			'Invalid week date (' + ($elm$core$String$fromInt(wy) + (', ' + ($elm$core$String$fromInt(wn) + (', ' + ($elm$core$String$fromInt(wdn) + ')'))))));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 0:
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 1:
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return c === '-';
									}),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (!result.$) {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq('T'))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($justinmimbs$date$Date$deadEndToString),
				$elm$core$Maybe$withDefault('')))));
var $CurrySoftware$elm_datepicker$DatePicker$Date$Off = {$: 0};
var $CurrySoftware$elm_datepicker$DatePicker$off = $CurrySoftware$elm_datepicker$DatePicker$Date$Off;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');
var $CurrySoftware$elm_datepicker$DatePicker$defaultSettings = {
	f9: $CurrySoftware$elm_datepicker$DatePicker$formatCell,
	dQ: $CurrySoftware$elm_datepicker$DatePicker$off,
	cM: 'elm-datepicker--',
	gf: _List_Nil,
	gh: $justinmimbs$date$Date$format('yyyy-MM-dd'),
	gi: $CurrySoftware$elm_datepicker$DatePicker$Date$formatDay,
	e5: 6,
	gO: _List_fromArray(
		[
			$elm$html$Html$Attributes$required(false)
		]),
	gP: _List_Nil,
	gQ: $elm$core$Maybe$Nothing,
	gR: $elm$core$Maybe$Nothing,
	fh: $elm$core$Basics$always(false),
	g6: $CurrySoftware$elm_datepicker$DatePicker$Date$formatMonth,
	hn: $justinmimbs$date$Date$fromIsoString,
	ht: 'Please pick a date...',
	h2: $elm$core$String$fromInt
};
var $CurrySoftware$elm_datepicker$DatePicker$Focus = {$: 5};
var $CurrySoftware$elm_datepicker$DatePicker$open = $CurrySoftware$elm_datepicker$DatePicker$Focus;
var $CurrySoftware$elm_datepicker$DatePicker$Disabled = function (a) {
	return {$: 2, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$EmptyString = {$: 1};
var $CurrySoftware$elm_datepicker$DatePicker$FailedInput = function (a) {
	return {$: 1, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$Invalid = function (a) {
	return {$: 0, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$None = {$: 0};
var $CurrySoftware$elm_datepicker$DatePicker$Picked = function (a) {
	return {$: 2, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$update = F3(
	function (settings, msg, _v0) {
		var model = _v0;
		var forceOpen = model.bq;
		var focused = model.af;
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							af: $elm$core$Maybe$Just(date),
							bK: date
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 1:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							af: $elm$core$Maybe$Just(date)
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 2:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{af: $elm$core$Maybe$Nothing, aG: $elm$core$Maybe$Nothing, a6: false}),
					$CurrySoftware$elm_datepicker$DatePicker$Picked(date));
			case 3:
				var text = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aG: $elm$core$Maybe$Just(text)
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 4:
				if (forceOpen) {
					return _Utils_Tuple2(model, $CurrySoftware$elm_datepicker$DatePicker$None);
				} else {
					var dateEvent = function () {
						var _v5 = model.aG;
						if (_v5.$ === 1) {
							return $CurrySoftware$elm_datepicker$DatePicker$FailedInput($CurrySoftware$elm_datepicker$DatePicker$EmptyString);
						} else {
							if (_v5.a === '') {
								return $CurrySoftware$elm_datepicker$DatePicker$FailedInput($CurrySoftware$elm_datepicker$DatePicker$EmptyString);
							} else {
								var rawInput = _v5.a;
								var _v6 = settings.hn(rawInput);
								if (!_v6.$) {
									var date = _v6.a;
									return settings.fh(date) ? $CurrySoftware$elm_datepicker$DatePicker$FailedInput(
										$CurrySoftware$elm_datepicker$DatePicker$Disabled(date)) : $CurrySoftware$elm_datepicker$DatePicker$Picked(date);
								} else {
									var e = _v6.a;
									return $CurrySoftware$elm_datepicker$DatePicker$FailedInput(
										$CurrySoftware$elm_datepicker$DatePicker$Invalid(e));
								}
							}
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								af: function () {
									if (dateEvent.$ === 2) {
										var date = dateEvent.a;
										return $elm$core$Maybe$Just(date);
									} else {
										return model.af;
									}
								}(),
								aG: function () {
									if (dateEvent.$ === 2) {
										return $elm$core$Maybe$Nothing;
									} else {
										return model.aG;
									}
								}()
							}),
						dateEvent);
				}
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bq: false, a6: true}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a6: forceOpen}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bq: true}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bq: false}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
		}
	});
var $author$project$Reusable$DatePicker$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var _v1 = A3($CurrySoftware$elm_datepicker$DatePicker$update, $CurrySoftware$elm_datepicker$DatePicker$defaultSettings, $CurrySoftware$elm_datepicker$DatePicker$open, model.a1);
				var newDatePicker = _v1.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a1: newDatePicker, c8: true}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var _v2 = A3($CurrySoftware$elm_datepicker$DatePicker$update, $CurrySoftware$elm_datepicker$DatePicker$defaultSettings, $CurrySoftware$elm_datepicker$DatePicker$close, model.a1);
				var newDatePicker = _v2.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a1: newDatePicker, c8: false}),
					$elm$core$Platform$Cmd$none);
			default:
				var subMsg = msg.a;
				var _v3 = A3($CurrySoftware$elm_datepicker$DatePicker$update, $CurrySoftware$elm_datepicker$DatePicker$defaultSettings, subMsg, model.a1);
				var newDatePicker = _v3.a;
				var dateEvent = _v3.b;
				var newDate = function () {
					if (dateEvent.$ === 2) {
						var changedDate = dateEvent.a;
						return $elm$core$Maybe$Just(changedDate);
					} else {
						return model.a0;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a0: newDate, a1: newDatePicker}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Reusable$Tooltip$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var index = msg.a;
			return A3($elm$core$Dict$insert, index, true, model);
		} else {
			var index = msg.a;
			return A3($elm$core$Dict$insert, index, false, model);
		}
	});
var $author$project$Select$Closed = 1;
var $author$project$Select$FocusId = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Select$FocusResult = function (a) {
	return {$: 3, a: a};
};
var $author$project$Select$Open = 0;
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $author$project$Select$delay = F2(
	function (time, msg) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$always(msg),
			$elm$core$Process$sleep(time));
	});
var $author$project$Select$findAndUpdate = F3(
	function (index, updateFunc, model) {
		return A3(
			$elm$core$Dict$update,
			index,
			function (maybeField) {
				if (!maybeField.$) {
					var field = maybeField.a;
					return $elm$core$Maybe$Just(
						updateFunc(field));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			model);
	});
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$Select$initSelectField = function (val) {
	return {es: $elm$core$Maybe$Nothing, fJ: val};
};
var $author$project$Select$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var index = msg.a;
				var toMsg = msg.b;
				return _Utils_Tuple2(
					A3(
						$elm$core$Dict$insert,
						index,
						$author$project$Select$initSelectField(0),
						model),
					A2(
						$elm$core$Platform$Cmd$map,
						toMsg,
						A2(
							$author$project$Select$delay,
							150,
							A2($author$project$Select$FocusId, index, toMsg))));
			case 2:
				var index = msg.a;
				var toMsg = msg.b;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Platform$Cmd$map,
						toMsg,
						A2(
							$elm$core$Task$attempt,
							$author$project$Select$FocusResult,
							$elm$browser$Browser$Dom$focus(
								A2(
									$elm$core$String$join,
									'-',
									A2($elm$core$List$map, $elm$core$String$fromInt, index))))));
			case 3:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 4:
				var index = msg.a;
				return _Utils_Tuple2(
					A3(
						$author$project$Select$findAndUpdate,
						index,
						$elm$core$Basics$always(
							$author$project$Select$initSelectField(1)),
						model),
					$elm$core$Platform$Cmd$none);
			case 5:
				var index = msg.a;
				var query = msg.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Select$findAndUpdate,
						index,
						function (field) {
							return _Utils_update(
								field,
								{
									es: $elm$core$Maybe$Just(query)
								});
						},
						model),
					$elm$core$Platform$Cmd$none);
			default:
				var index = msg.a;
				var nextMsg = msg.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Select$findAndUpdate,
						index,
						$elm$core$Basics$always(
							$author$project$Select$initSelectField(1)),
						model),
					A2(
						$elm$core$Task$perform,
						$elm$core$Basics$identity,
						$elm$core$Task$succeed(nextMsg)));
		}
	});
var $author$project$Template$Helpers$updateBoundedStyle = F3(
	function (maybeInnerType, css, widget) {
		return $elm$core$Maybe$Just(
			function () {
				switch (widget.$) {
					case 1:
						var cfg = widget.a;
						_v1$2:
						while (true) {
							if (!maybeInnerType.$) {
								switch (maybeInnerType.a) {
									case 1:
										var _v2 = maybeInnerType.a;
										return $author$project$Template$Widget$Core$TextBox(
											_Utils_update(
												cfg,
												{
													cs: $author$project$Entity$Style$bounded(css)
												}));
									case 0:
										var _v3 = maybeInnerType.a;
										return $author$project$Template$Widget$Core$TextBox(
											_Utils_update(
												cfg,
												{
													dB: $author$project$Entity$Style$bounded(css)
												}));
									default:
										break _v1$2;
								}
							} else {
								break _v1$2;
							}
						}
						return widget;
					case 2:
						var cfg = widget.a;
						return $author$project$Template$Widget$Core$Image(
							_Utils_update(
								cfg,
								{
									cs: $author$project$Entity$Style$bounded(css)
								}));
					case 4:
						var cfg = widget.a;
						if (!maybeInnerType.$) {
							switch (maybeInnerType.a) {
								case 0:
									var _v5 = maybeInnerType.a;
									return $author$project$Template$Widget$Core$MenuPlanning(
										_Utils_update(
											cfg,
											{
												da: $author$project$Entity$Style$bounded(css)
											}));
								case 1:
									var _v6 = maybeInnerType.a;
									return $author$project$Template$Widget$Core$MenuPlanning(
										_Utils_update(
											cfg,
											{
												na: $author$project$Entity$Style$bounded(css)
											}));
								case 2:
									var _v7 = maybeInnerType.a;
									return $author$project$Template$Widget$Core$MenuPlanning(
										_Utils_update(
											cfg,
											{
												gY: $author$project$Entity$Style$bounded(css)
											}));
								case 3:
									var _v8 = maybeInnerType.a;
									return $author$project$Template$Widget$Core$MenuPlanning(
										_Utils_update(
											cfg,
											{
												gL: $author$project$Entity$Style$bounded(css)
											}));
								case 6:
									var _v9 = maybeInnerType.a;
									return $author$project$Template$Widget$Core$MenuPlanning(
										_Utils_update(
											cfg,
											{
												k9: $author$project$Entity$Style$bounded(css)
											}));
								case 4:
									var _v10 = maybeInnerType.a;
									return $author$project$Template$Widget$Core$MenuPlanning(
										_Utils_update(
											cfg,
											{
												kR: $author$project$Entity$Style$bounded(css)
											}));
								case 5:
									var _v11 = maybeInnerType.a;
									return $author$project$Template$Widget$Core$MenuPlanning(
										_Utils_update(
											cfg,
											{
												mf: $author$project$Entity$Style$bounded(css)
											}));
								case 7:
									var _v12 = maybeInnerType.a;
									return $author$project$Template$Widget$Core$MenuPlanning(
										_Utils_update(
											cfg,
											{
												gA: $author$project$Entity$Style$bounded(css)
											}));
								default:
									var _v13 = maybeInnerType.a;
									return widget;
							}
						} else {
							return widget;
						}
					case 5:
						var cfg = widget.a;
						_v14$3:
						while (true) {
							if (!maybeInnerType.$) {
								switch (maybeInnerType.a) {
									case 1:
										var _v15 = maybeInnerType.a;
										return $author$project$Template$Widget$Core$MenuItemListWidget(
											_Utils_update(
												cfg,
												{
													na: $author$project$Entity$Style$bounded(css)
												}));
									case 6:
										var _v16 = maybeInnerType.a;
										return $author$project$Template$Widget$Core$MenuItemListWidget(
											_Utils_update(
												cfg,
												{
													k9: $author$project$Entity$Style$bounded(css)
												}));
									case 8:
										var _v17 = maybeInnerType.a;
										return $author$project$Template$Widget$Core$MenuItemListWidget(
											_Utils_update(
												cfg,
												{
													hw: $author$project$Entity$Style$bounded(css)
												}));
									default:
										break _v14$3;
								}
							} else {
								break _v14$3;
							}
						}
						return widget;
					default:
						return widget;
				}
			}());
	});
var $author$project$Template$Frame$updateColumn = F3(
	function (colIndex, mapColumn, frame) {
		return _Utils_update(
			frame,
			{
				da: A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, column) {
							return _Utils_eq(index, colIndex) ? mapColumn(column) : column;
						}),
					frame.da)
			});
	});
var $author$project$Template$Frame$updateFlexGrow = F3(
	function (flexGrow, colIndex, frame) {
		return A3(
			$author$project$Template$Frame$updateColumn,
			colIndex,
			function (col) {
				return _Utils_update(
					col,
					{ae: flexGrow});
			},
			frame);
	});
var $author$project$Template$Helpers$updateFlexGrow = F3(
	function (val, _v0, template) {
		var frameIndex = _v0.ap;
		var columnIndex = _v0.C;
		return A3(
			$author$project$Template$Core$update,
			frameIndex,
			A2($author$project$Template$Frame$updateFlexGrow, val, columnIndex),
			template);
	});
var $author$project$Pages$CfgDevice$Design$uploadDesignImage = _Platform_outgoingPort(
	'uploadDesignImage',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'accessToken',
					$elm$json$Json$Encode$string($.h5)),
					_Utils_Tuple2(
					'divId',
					$elm$json$Json$Encode$string($.gm)),
					_Utils_Tuple2(
					'imageAddr',
					function ($) {
						var a = $.a;
						var b = $.b;
						return A2(
							$elm$json$Json$Encode$list,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									$elm$json$Json$Encode$string(a),
									$elm$json$Json$Encode$string(b)
								]));
					}($.gM))
				]));
	});
var $author$project$Pages$CfgDevice$Design$update = F4(
	function (updateDesignConfig, sockId, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 2:
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (m) {
						return _Utils_update(
							model,
							{r: m});
					},
					A2($author$project$Select$update, msg_, model.r));
			case 3:
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fQ: A2($author$project$Reusable$Tooltip$update, msg_, model.fQ)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aA: A2($author$project$ColorPicker$update, msg_, model.aA)
						}),
					$elm$core$Platform$Cmd$none);
			case 32:
				var ele = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dL: function () {
								var _v1 = A2($elm$core$Set$member, ele, model.dL);
								if (!_v1) {
									return A2($elm$core$Set$insert, ele, model.dL);
								} else {
									return A2($elm$core$Set$remove, ele, model.dL);
								}
							}()
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var frIndex = msg.a;
				var template = msg.b;
				var updated = A2($author$project$Template$Helpers$moveFrameUp, frIndex, template);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a: $author$project$DataState$Ready(updated),
							h: A2(
								$elm$core$Maybe$andThen,
								function (position) {
									return $elm$core$Maybe$Just(
										_Utils_update(
											position,
											{ap: position.ap - 1}));
								},
								model.h)
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 13:
				var frIndex = msg.a;
				var template = msg.b;
				var updated = A2($author$project$Template$Helpers$moveFrameDown, frIndex, template);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a: $author$project$DataState$Ready(updated),
							h: A2(
								$elm$core$Maybe$andThen,
								function (position) {
									return $elm$core$Maybe$Just(
										_Utils_update(
											position,
											{ap: position.ap + 1}));
								},
								model.h)
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 5:
				var frameIndex = msg.a;
				var template = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a: $author$project$DataState$Ready(
								A2($author$project$Template$Core$insertNewFrame, frameIndex, template))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var frameIndex = msg.a;
				var template = msg.b;
				var _v2 = A3($author$project$Template$Helpers$duplicateFrame, model.jM, frameIndex, template);
				var updated = _v2.a;
				var newSeed = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jM: newSeed,
							a: $author$project$DataState$Ready(updated)
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 7:
				var frameIndex = msg.a;
				var template = msg.b;
				var updated = A2($author$project$Template$Core$deleteFrame, frameIndex, template);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cR: false,
							a: $author$project$DataState$Ready(updated)
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 8:
				var val = msg.a;
				var frameIndex = msg.b;
				var template = msg.c;
				var updated = A3($author$project$Template$Helpers$frameOrientation, frameIndex, val, template);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a: $author$project$DataState$Ready(updated)
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 9:
				var template = msg.a;
				var frameIndex = msg.b;
				var val = msg.c;
				var updated = A3($author$project$Template$Helpers$frameInterval, frameIndex, val, template);
				var minValue = 5;
				var maxValue = 180;
				return ((_Utils_cmp(val, minValue) > -1) && (_Utils_cmp(val, maxValue) < 1)) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a: $author$project$DataState$Ready(updated)
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated)) : ((_Utils_cmp(val, minValue) < 0) ? _Utils_Tuple2(
					model,
					A3(
						$elm$core$Basics$composeR,
						$author$project$Pages$CfgDevice$Design$Toast,
						A2($elm$core$Basics$composeR, $author$project$Pages$CfgDevice$Design$ToCore, $author$project$Utils$cmd),
						'Minimum value for the interval is ' + ($elm$core$String$fromInt(minValue) + ' seconds'))) : ((_Utils_cmp(val, maxValue) > 0) ? _Utils_Tuple2(
					model,
					A3(
						$elm$core$Basics$composeR,
						$author$project$Pages$CfgDevice$Design$Toast,
						A2($elm$core$Basics$composeR, $author$project$Pages$CfgDevice$Design$ToCore, $author$project$Utils$cmd),
						'Maximum value for the interval is ' + ($elm$core$String$fromFloat(maxValue) + ' seconds'))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)));
			case 10:
				var template = msg.a;
				var frameIndex = msg.b;
				var value = msg.c;
				var updated = A3($author$project$Template$Helpers$frameBackground, frameIndex, value, template);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aA: $author$project$ColorPicker$init,
							a: $author$project$DataState$Ready(updated)
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 11:
				var template = msg.a;
				var value = msg.b;
				var updated = _Utils_update(
					template,
					{
						G: A2(
							$elm$core$List$map,
							function (frame) {
								return _Utils_update(
									frame,
									{f6: value});
							},
							template.G)
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a: $author$project$DataState$Ready(updated),
							dE: false
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 16:
				var template = msg.a;
				var frameIndex = msg.b;
				var updated = A3(
					$author$project$Template$Core$update,
					frameIndex,
					$author$project$Template$Frame$addColumn(0),
					template);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a: $author$project$DataState$Ready(updated)
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 17:
				var template = msg.b;
				var position = msg.c;
				var updated = A2($author$project$Template$Helpers$addLeftSection, position, template);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a: $author$project$DataState$Ready(updated)
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 18:
				var orientation = msg.a;
				var template = msg.b;
				var position = msg.c;
				var updated = A2($author$project$Template$Helpers$addRightSection, position, template);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a: $author$project$DataState$Ready(updated),
							h: function () {
								if (!orientation) {
									return $elm$core$Maybe$Just(
										_Utils_update(
											position,
											{C: position.C + 1, y: 0}));
								} else {
									return $elm$core$Maybe$Just(
										_Utils_update(
											position,
											{y: position.y + 1}));
								}
							}()
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 19:
				var template = msg.b;
				var position = msg.c;
				var updated = A2($author$project$Template$Helpers$addTopSection, position, template);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a: $author$project$DataState$Ready(updated)
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 20:
				var orientation = msg.a;
				var template = msg.b;
				var position = msg.c;
				var updated = A2($author$project$Template$Helpers$addBottomSection, position, template);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a: $author$project$DataState$Ready(updated),
							h: $elm$core$Maybe$Just(
								_Utils_update(
									position,
									{y: position.y + 1}))
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 21:
				var template = msg.a;
				var position = msg.b;
				var updated = A2($author$project$Template$Helpers$delColumn, position, template);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cQ: false,
							bW: false,
							a: $author$project$DataState$Ready(updated),
							h: $elm$core$Maybe$Just(
								_Utils_update(
									position,
									{
										C: ((position.C - 1) < 0) ? 0 : (position.C - 1)
									}))
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 23:
				var orientation = msg.a;
				var template = msg.b;
				var position = msg.c;
				var updated = A2($author$project$Template$Helpers$moveSectionUp, position, template);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a: $author$project$DataState$Ready(updated),
							h: function () {
								if (!orientation) {
									return $elm$core$Maybe$Just(
										_Utils_update(
											position,
											{y: position.y - 1}));
								} else {
									return $elm$core$Maybe$Just(
										_Utils_update(
											position,
											{C: position.C - 1}));
								}
							}()
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 24:
				var orientation = msg.a;
				var template = msg.b;
				var position = msg.c;
				var updated = A2($author$project$Template$Helpers$moveSectionDown, position, template);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a: $author$project$DataState$Ready(updated),
							h: function () {
								if (!orientation) {
									return $elm$core$Maybe$Just(
										_Utils_update(
											position,
											{y: position.y + 1}));
								} else {
									return $elm$core$Maybe$Just(
										_Utils_update(
											position,
											{C: position.C + 1}));
								}
							}()
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 25:
				var orientation = msg.a;
				var template = msg.b;
				var position = msg.c;
				var updated = A2($author$project$Template$Helpers$moveSectionLeft, position, template);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a: $author$project$DataState$Ready(updated),
							h: function () {
								if (!orientation) {
									return $elm$core$Maybe$Just(
										_Utils_update(
											position,
											{C: position.C - 1}));
								} else {
									return $elm$core$Maybe$Just(
										_Utils_update(
											position,
											{y: position.y - 1}));
								}
							}()
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 26:
				var orientation = msg.a;
				var template = msg.b;
				var position = msg.c;
				var updated = A2($author$project$Template$Helpers$moveSectionRight, position, template);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a: $author$project$DataState$Ready(updated),
							h: function () {
								if (!orientation) {
									return $elm$core$Maybe$Just(
										_Utils_update(
											position,
											{C: position.C + 1}));
								} else {
									return $elm$core$Maybe$Just(
										_Utils_update(
											position,
											{y: position.y + 1}));
								}
							}()
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 27:
				var template = msg.a;
				var position = msg.b;
				var val = msg.c;
				var updated = A3($author$project$Template$Helpers$updateFlexGrow, val, position, template);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a: $author$project$DataState$Ready(updated)
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 22:
				var template = msg.a;
				var position = msg.b;
				var updated = A2($author$project$Template$Helpers$delRow, position, template);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bW: false,
							a: $author$project$DataState$Ready(updated),
							h: $elm$core$Maybe$Just(
								_Utils_update(
									position,
									{
										y: ((position.y - 1) < 0) ? 0 : (position.y - 1)
									}))
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 28:
				var template = msg.a;
				var position = msg.b;
				var widget = msg.c;
				var _v8 = A2($elm$random$Random$step, $danyx23$elm_uuid$Uuid$uuidGenerator, model.jM);
				var uuid = _v8.a;
				var newSeed = _v8.b;
				var widgetId = $danyx23$elm_uuid$Uuid$toString(uuid);
				var maybeTemplate = A3(
					$author$project$Template$Helpers$insertWidget,
					_Utils_Tuple2(widgetId, widget),
					position,
					template);
				if (!maybeTemplate.$) {
					var updated = maybeTemplate.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								jM: newSeed,
								a: $author$project$DataState$Ready(updated)
							}),
						$author$project$Pages$CfgDevice$Design$autoSave(updated));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{jM: newSeed}),
						$elm$core$Platform$Cmd$none);
				}
			case 29:
				var template = msg.a;
				var position = msg.b;
				var widgetName = msg.c;
				var updated = A3($author$project$Template$Helpers$insertSharedWidget, position, widgetName, template);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a: $author$project$DataState$Ready(updated)
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 30:
				var template = msg.a;
				var position = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a: $author$project$DataState$Ready(
								A2($author$project$Template$Helpers$removeWidget, position, template))
						}),
					$elm$core$Platform$Cmd$none);
			case 31:
				var ele = msg.a;
				return A2($elm$core$Set$member, ele, model.S) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							S: A2($elm$core$Set$remove, ele, model.S)
						}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							S: A2($elm$core$Set$insert, ele, model.S)
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var frIndex = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aw: $elm$core$Maybe$Just(frIndex),
							h: $elm$core$Maybe$Nothing
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Utils$cmd(
								$author$project$Pages$CfgDevice$Design$ToCore($author$project$Pages$CfgDevice$Design$SelectWidgetTab)),
								$author$project$Interop$Browser$openSidebar,
								$author$project$Pages$CfgDevice$Design$loadImages(updateDesignConfig.gM)
							])));
			case 15:
				var template = msg.a;
				var widgetId = msg.b;
				var widget = msg.c;
				var updated = _Utils_update(
					template,
					{
						n: A3($elm$core$Dict$insert, widgetId, widget, template.n)
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ai: $elm$core$Maybe$Nothing,
							a: $author$project$DataState$Ready(updated),
							bJ: ''
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 33:
				var position = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aw: $elm$core$Maybe$Nothing,
							h: $elm$core$Maybe$Just(position)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Utils$cmd(
								$author$project$Pages$CfgDevice$Design$ToCore($author$project$Pages$CfgDevice$Design$SelectLayoutTab)),
								$author$project$Interop$Browser$openSidebar
							])));
			case 34:
				var position = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aw: $elm$core$Maybe$Nothing,
							h: $elm$core$Maybe$Just(position)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Utils$cmd(
								$author$project$Pages$CfgDevice$Design$ToCore($author$project$Pages$CfgDevice$Design$SelectWidgetTab)),
								$author$project$Interop$Browser$openSidebar
							])));
			case 38:
				var template = msg.a;
				var widget = msg.b;
				var updated = _Utils_update(
					template,
					{
						n: A2($author$project$Template$Helpers$shareEffect, widget, template.n)
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a: $author$project$DataState$Ready(updated),
							cn: _Utils_Tuple2(false, $elm$core$Maybe$Nothing)
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 35:
				var maybeInnerStyle = msg.a;
				var position = msg.b;
				var maybeSharedStyle = A2(
					$elm$core$Maybe$andThen,
					$author$project$Template$Helpers$getSharedStyle(maybeInnerStyle),
					A2(
						$elm$core$Maybe$andThen,
						A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $elm$core$Tuple$second),
						A2(
							$elm$core$Maybe$andThen,
							function (a) {
								return A2($author$project$Template$Helpers$getWidget, a, position);
							},
							$author$project$DataState$toMaybe(model.a))));
				if (!maybeSharedStyle.$) {
					var styleId = maybeSharedStyle.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aw: $elm$core$Maybe$Nothing,
								aR: maybeInnerStyle,
								aS: $elm$core$Maybe$Just(styleId),
								h: $elm$core$Maybe$Nothing
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Utils$cmd(
									$author$project$Pages$CfgDevice$Design$ToCore($author$project$Pages$CfgDevice$Design$SelectStyleTab)),
									$author$project$Interop$Browser$openSidebar
								])));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aw: $elm$core$Maybe$Nothing,
								aR: maybeInnerStyle,
								aS: $elm$core$Maybe$Nothing,
								h: $elm$core$Maybe$Just(position),
								S: A2($elm$core$Set$insert, 'element-style', model.S)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Utils$cmd(
									$author$project$Pages$CfgDevice$Design$ToCore($author$project$Pages$CfgDevice$Design$SelectStyleTab)),
									$author$project$Interop$Browser$openSidebar
								])));
				}
			case 36:
				if (!msg.a.$) {
					var template = msg.a.a;
					var position = msg.b;
					var widgets = function () {
						var _v11 = A2($author$project$Template$Helpers$getWidget, template, position);
						if (!_v11.$) {
							var _v12 = _v11.a;
							var widgetId = _v12.a;
							var widget = _v12.b;
							return A3(
								$elm$core$Dict$insert,
								widgetId,
								A3($author$project$Template$Helpers$bindSharedStyle, template, model.aR, widget),
								template.n);
						} else {
							return template.n;
						}
					}();
					var updated = _Utils_update(
						template,
						{n: widgets});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bQ: _Utils_Tuple2(false, $elm$core$Maybe$Nothing),
								aS: $elm$core$Maybe$Nothing,
								a: $author$project$DataState$Ready(updated),
								h: $elm$core$Maybe$Just(position),
								S: A2($elm$core$Set$insert, 'element-style', model.S)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Utils$cmd(
									$author$project$Pages$CfgDevice$Design$ToCore($author$project$Pages$CfgDevice$Design$SelectStyleTab)),
									$author$project$Pages$CfgDevice$Design$autoSave(updated)
								])));
				} else {
					var _v13 = msg.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 37:
				var template = msg.a;
				var position = msg.b;
				var styleId = msg.c;
				var widgets = function () {
					var _v14 = A2($author$project$Template$Helpers$getWidget, template, position);
					if (!_v14.$) {
						var _v15 = _v14.a;
						var widgetId = _v15.a;
						var widget = _v15.b;
						return A3(
							$elm$core$Dict$insert,
							widgetId,
							A4($author$project$Template$Helpers$shareStyle, template, model.aR, styleId, widget),
							template.n);
					} else {
						return template.n;
					}
				}();
				var updated = _Utils_update(
					template,
					{n: widgets});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							r: $author$project$Select$init,
							aS: $elm$core$Maybe$Just(styleId),
							a: $author$project$DataState$Ready(updated),
							h: $elm$core$Maybe$Nothing,
							S: A2($elm$core$Set$insert, 'element-style', model.S)
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 41:
				var styleId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							r: $author$project$Select$init,
							aR: $elm$core$Maybe$Nothing,
							aS: $elm$core$Maybe$Just(styleId)
						}),
					$elm$core$Platform$Cmd$none);
			case 44:
				var widgetId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dx: $elm$core$Maybe$Just(widgetId)
						}),
					$elm$core$Platform$Cmd$none);
			case 45:
				var name = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ai: $elm$core$Maybe$Just(name)
						}),
					$elm$core$Platform$Cmd$none);
			case 46:
				var template = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cF: false,
							bO: '',
							a: $author$project$DataState$Ready(template)
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(template));
			case 47:
				var template = msg.a;
				var updated = $author$project$Template$Core$cleanup(template);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a: $author$project$DataState$Ready(updated)
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 48:
				var name = msg.a;
				var clearSelected = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cU: false,
							a: function () {
								if (clearSelected) {
									return $author$project$DataState$Initial;
								} else {
									return model.a;
								}
							}(),
							al: A2(
								$elm_community$list_extra$List$Extra$filterNot,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.g8;
									},
									$elm$core$Basics$eq(name)),
								model.al)
						}),
					A3(
						$author$project$Interop$Fabric$unicastMessage,
						sockId,
						'DELETE_TEMPLATE',
						$elm$json$Json$Encode$string(name)));
			case 49:
				var template = msg.a;
				var styleName = msg.b;
				var updated = _Utils_update(
					template,
					{
						z: A3(
							$elm$core$Dict$insert,
							styleName,
							{
								a$: model.cf ? $elm$core$Dict$fromList(
									_List_fromArray(
										[
											_Utils_Tuple2('width', '98%')
										])) : $elm$core$Dict$empty,
								d1: model.cf,
								d2: model.dn
							},
							template.z)
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bz: $elm$core$Maybe$Nothing,
							a: $author$project$DataState$Ready(updated),
							dy: false
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 56:
				var name = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bz: $elm$core$Maybe$Just(name)
						}),
					$elm$core$Platform$Cmd$none);
			case 57:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dn: !model.dn}),
					$elm$core$Platform$Cmd$none);
			case 58:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cf: !model.cf}),
					$elm$core$Platform$Cmd$none);
			case 50:
				var name = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							av: $elm$core$Maybe$Just(name)
						}),
					$elm$core$Platform$Cmd$none);
			case 51:
				var adminName = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$CfgDevice$Design$NewTemplateWithDate(adminName),
						$justinmimbs$date$Date$today));
			case 52:
				var adminName = msg.a;
				var date = msg.b;
				var maybeNewTemplate = function () {
					var _v18 = _Utils_Tuple3(model.a, model.bI, model.av);
					_v18$2:
					while (true) {
						if (!_v18.c.$) {
							switch (_v18.b) {
								case 0:
									var _v19 = _v18.b;
									var name = _v18.c.a;
									return $elm$core$Maybe$Just(
										A3($author$project$Template$Helpers$addNewTemplate, adminName, date, name));
								case 2:
									if (_v18.a.$ === 4) {
										var template = _v18.a.a;
										var _v20 = _v18.b;
										var name = _v18.c.a;
										return $elm$core$Maybe$Just(
											_Utils_update(
												template,
												{iw: date, g8: name}));
									} else {
										break _v18$2;
									}
								default:
									break _v18$2;
							}
						} else {
							break _v18$2;
						}
					}
					return $elm$core$Maybe$Nothing;
				}();
				if (!maybeNewTemplate.$) {
					var newTemplate = maybeNewTemplate.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								av: $elm$core$Maybe$Nothing,
								a: $author$project$DataState$Ready(newTemplate),
								cv: false,
								al: A2(
									$elm$core$List$cons,
									A2($author$project$Template$Core$MinimalTemplate, newTemplate.g8, newTemplate.aX),
									model.al)
							}),
						A3(
							$author$project$Interop$Fabric$unicastMessage,
							sockId,
							'NEW_TEMPLATE',
							$author$project$Template$Core$encode(newTemplate)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 53:
				var newTemplate = msg.a;
				var oldTemplateName = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							av: $elm$core$Maybe$Nothing,
							a: $author$project$DataState$Ready(newTemplate),
							cv: false,
							al: A2(
								$elm$core$List$cons,
								A2($author$project$Template$Core$MinimalTemplate, newTemplate.g8, newTemplate.aX),
								model.al)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3(
								$author$project$Interop$Fabric$unicastMessage,
								sockId,
								'NEW_TEMPLATE',
								$author$project$Template$Core$encode(newTemplate)),
								$author$project$Utils$cmd(
								A2($author$project$Pages$CfgDevice$Design$TemplateDelete, oldTemplateName, false))
							])));
			case 54:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cF: !model.cF}),
					$elm$core$Platform$Cmd$none);
			case 55:
				var str = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bO: str}),
					$elm$core$Platform$Cmd$none);
			case 39:
				var template = msg.a;
				var styleId = msg.b;
				var css = msg.c;
				var styles = A3($elm$core$Dict$insert, styleId, css, template.z);
				var updated = _Utils_update(
					template,
					{z: styles});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aA: $author$project$ColorPicker$init,
							r: $author$project$Select$init,
							a: $author$project$DataState$Ready(updated)
						}),
					$author$project$Pages$CfgDevice$Design$autoSaveStyle(updated));
			case 40:
				var template = msg.a;
				var widgetId = msg.b;
				var css = msg.c;
				var widgets = A3(
					$elm$core$Dict$update,
					widgetId,
					$elm$core$Maybe$andThen(
						A2($author$project$Template$Helpers$updateBoundedStyle, model.aR, css)),
					template.n);
				var updated = _Utils_update(
					template,
					{n: widgets});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aA: $author$project$ColorPicker$init,
							r: $author$project$Select$init,
							a: $author$project$DataState$Ready(
								_Utils_update(
									template,
									{n: widgets}))
						}),
					$author$project$Pages$CfgDevice$Design$autoSave(updated));
			case 66:
				var data = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{al: data}),
					$elm$core$Platform$Cmd$none);
			case 63:
				var templateName = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							r: $author$project$Select$init,
							a: $author$project$DataState$Loading('')
						}),
					A3(
						$author$project$Interop$Fabric$unicastMessage,
						sockId,
						'REQ_TEMPLATE',
						$elm$json$Json$Encode$string(templateName)));
			case 64:
				var template = msg.a;
				var updateConfig = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{eB: 1}),
					A3(
						$author$project$Interop$Fabric$unicastMessage,
						sockId,
						'PUBLISH_TEMPLATE',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'template',
									$author$project$Template$Core$encode(template)),
									_Utils_Tuple2(
									'config',
									$author$project$Template$UpdateConfig$encode(updateConfig))
								]))));
			case 65:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{eB: 0}),
					$elm$core$Platform$Cmd$none);
			case 59:
				var url = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{d4: url}),
					$elm$core$Platform$Cmd$none);
			case 60:
				var widgetId = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$Interop$Browser$postMessage,
						'GET_YOUTUBE_ID',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'url',
									$elm$json$Json$Encode$string(model.d4)),
									_Utils_Tuple2(
									'widgetId',
									$elm$json$Json$Encode$string(widgetId))
								]))));
			case 61:
				var widgetId = msg.a;
				var videoId = msg.b;
				var _v21 = _Utils_Tuple2(model.a, model.h);
				if ((_v21.a.$ === 4) && (!_v21.b.$)) {
					var template = _v21.a.a;
					var position = _v21.b.a;
					var updated = _Utils_update(
						template,
						{
							n: A3(
								$elm$core$Dict$insert,
								widgetId,
								$author$project$Template$Widget$Core$Youtube(
									$author$project$Template$Widget$Youtube$video(videoId)),
								template.n)
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a: $author$project$DataState$Ready(updated)
							}),
						$author$project$Pages$CfgDevice$Design$autoSave(updated));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 62:
				var widgetId = msg.a;
				var playlistId = msg.b;
				var _v22 = _Utils_Tuple2(model.a, model.h);
				if ((_v22.a.$ === 4) && (!_v22.b.$)) {
					var template = _v22.a.a;
					var position = _v22.b.a;
					var updated = _Utils_update(
						template,
						{
							n: A3(
								$elm$core$Dict$insert,
								widgetId,
								$author$project$Template$Widget$Core$Youtube(
									$author$project$Template$Widget$Youtube$playlist(playlistId)),
								template.n)
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a: $author$project$DataState$Ready(updated)
							}),
						$author$project$Pages$CfgDevice$Design$autoSave(updated));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 67:
				var data = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a: $author$project$DataState$Ready(data)
						}),
					$elm$core$Platform$Cmd$none);
			case 68:
				if (!msg.a.$) {
					var data = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								eU: A2(
									$elm$core$List$map,
									function ($) {
										return $.g8;
									},
									data)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 69:
				if (!msg.a.$) {
					var data = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								jR: A2(
									$elm$core$List$map,
									function ($) {
										return $.g8;
									},
									data)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 70:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cU: true}),
					$elm$core$Platform$Cmd$none);
			case 71:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cU: false}),
					$elm$core$Platform$Cmd$none);
			case 72:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cQ: true}),
					$elm$core$Platform$Cmd$none);
			case 73:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cQ: false}),
					$elm$core$Platform$Cmd$none);
			case 74:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dy: true}),
					$elm$core$Platform$Cmd$none);
			case 75:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dy: false}),
					$elm$core$Platform$Cmd$none);
			case 76:
				var mode = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cv: true, bI: mode}),
					$elm$core$Platform$Cmd$none);
			case 77:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{av: $elm$core$Maybe$Nothing, cv: false, bI: 0}),
					$elm$core$Platform$Cmd$none);
			case 78:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bW: true}),
					$elm$core$Platform$Cmd$none);
			case 79:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bW: false}),
					$elm$core$Platform$Cmd$none);
			case 80:
				var frameIndex = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cR: true,
							aw: $elm$core$Maybe$Just(frameIndex)
						}),
					$elm$core$Platform$Cmd$none);
			case 81:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cR: false}),
					$elm$core$Platform$Cmd$none);
			case 82:
				var urlPrefix = msg.a;
				var deviceId = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							H: function () {
								var _v23 = _Utils_Tuple2(model.H, model.a);
								_v23$2:
								while (true) {
									if (!_v23.a.$) {
										if (_v23.b.$ === 4) {
											var liveTemplate = _v23.a.a;
											var template = _v23.b.a;
											return $elm$core$Maybe$Just(
												A2(
													$author$project$Template$Core$goToFrame,
													$jschomay$elm_paginate$Paginate$currentPage(liveTemplate.G),
													$author$project$Template$Core$toLive(template)));
										} else {
											break _v23$2;
										}
									} else {
										if (_v23.b.$ === 4) {
											var _v24 = _v23.a;
											var template = _v23.b.a;
											return $elm$core$Maybe$Just(
												$author$project$Template$Core$toLive(template));
										} else {
											break _v23$2;
										}
									}
								}
								return $elm$core$Maybe$Nothing;
							}(),
							er: true
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								function () {
								var _v25 = model.a;
								if (_v25.$ === 4) {
									var template = _v25.a;
									return $elm$core$Platform$Cmd$batch(
										A2(
											$elm$core$List$map,
											function (a) {
												return A3($author$project$Entity$MenuItemList$loadList, urlPrefix, a, $author$project$Pages$CfgDevice$Design$LoadMenuItemList);
											},
											$author$project$Template$Widget$Core$getMenuItemListIds(template.n)));
								} else {
									return $elm$core$Platform$Cmd$none;
								}
							}(),
								$author$project$Utils$cmd($author$project$Pages$CfgDevice$Design$FillData),
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$CfgDevice$Design$SelectDate, $author$project$Reusable$DatePicker$init.b)
							])));
			case 83:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{er: false}),
					$elm$core$Platform$Cmd$none);
			case 88:
				var position = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bQ: _Utils_Tuple2(
								true,
								$elm$core$Maybe$Just(position))
						}),
					$elm$core$Platform$Cmd$none);
			case 89:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bQ: _Utils_Tuple2(false, $elm$core$Maybe$Nothing)
						}),
					$elm$core$Platform$Cmd$none);
			case 104:
				var direction = msg.a;
				var _v26 = $author$project$Template$Helpers$getLiveWidgets(model.H);
				if (!_v26.$) {
					var _v27 = _v26.a;
					var widgetIds = _v27.a;
					var widgets = _v27.b;
					return _Utils_Tuple2(
						model,
						A2(
							$andrewMacmurray$elm_delay$Delay$after,
							1,
							$author$project$Pages$CfgDevice$Design$RotatePage(direction)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 102:
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							b7: A2(
								$elm$core$Dict$map,
								F2(
									function (id, obj) {
										return A2(
											$elm$core$List$map,
											$mdgriffith$elm_style_animation$Animation$update(msg_),
											obj);
									}),
								model.b7)
						}),
					$elm$core$Platform$Cmd$none);
			case 103:
				var _v28 = $author$project$Template$Helpers$getLiveWidgets(model.H);
				if (!_v28.$) {
					var _v29 = _v28.a;
					var widgetIds = _v29.a;
					var widgets = _v29.b;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 105:
				if (!msg.a) {
					var _v30 = msg.a;
					var _v31 = model.H;
					if (!_v31.$) {
						var template = _v31.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									H: $elm$core$Maybe$Just(
										_Utils_update(
											template,
											{
												G: $author$project$Utils$rotatePageForward(template.G)
											}))
								}),
							$author$project$Utils$cmd($author$project$Pages$CfgDevice$Design$ShowFrame));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					var _v32 = msg.a;
					var _v33 = model.H;
					if (!_v33.$) {
						var template = _v33.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									H: $elm$core$Maybe$Just(
										_Utils_update(
											template,
											{
												G: $author$project$Utils$rotatePageBackward(template.G)
											}))
								}),
							$author$project$Utils$cmd($author$project$Pages$CfgDevice$Design$ShowFrame));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}
			case 94:
				var schd = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bb: $elm$core$Maybe$Just(schd)
						}),
					$elm$core$Platform$Cmd$none);
			case 95:
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (c) {
						return A2($elm$core$Platform$Cmd$map, $author$project$Pages$CfgDevice$Design$SelectDate, c);
					},
					A2(
						$elm$core$Tuple$mapFirst,
						function (m) {
							return _Utils_update(
								model,
								{a9: m});
						},
						A2($author$project$Reusable$DatePicker$update, msg_, model.a9)));
			case 96:
				var urlPrefix = msg.a;
				var deviceId = msg.b;
				var _v34 = _Utils_Tuple3(
					model.H,
					model.bb,
					$author$project$Reusable$DatePicker$selectedDate(model.a9));
				if (((!_v34.a.$) && (!_v34.b.$)) && (!_v34.c.$)) {
					var template = _v34.a.a;
					var schd = _v34.b.a;
					var date = _v34.c.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								g1: $elm$core$List$isEmpty(
									$author$project$Template$Widget$Core$getMenuItemListIds(template.n)) ? $author$project$DataState$ready($elm$core$Dict$empty) : $author$project$DataState$loading(''),
								aj: $author$project$DataState$loading('')
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3(
									$author$project$Entity$MenuPlanning$loadData,
									urlPrefix,
									{iB: deviceId, i8: schd.fp.i8, jQ: date, jR: schd.fp.jR},
									$author$project$Pages$CfgDevice$Design$MenuItems(urlPrefix)),
									$elm$core$Platform$Cmd$batch(
									A2(
										$elm$core$List$map,
										function (a) {
											return A3($author$project$Entity$MenuItemList$loadList, urlPrefix, a, $author$project$Pages$CfgDevice$Design$LoadMenuItemList);
										},
										$author$project$Template$Widget$Core$getMenuItemListIds(template.n)))
								])));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 101:
				if (!msg.a.$) {
					var menuItemList = msg.a.a;
					var _v35 = model.g1;
					if (_v35.$ === 4) {
						var lists = _v35.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									g1: $author$project$DataState$ready(
										A3($elm$core$Dict$insert, menuItemList.aF, menuItemList, lists))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									g1: $author$project$DataState$ready(
										$elm$core$Dict$fromList(
											_List_fromArray(
												[
													_Utils_Tuple2(menuItemList.aF, menuItemList)
												])))
								}),
							$elm$core$Platform$Cmd$none);
					}
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								g1: $author$project$DataState$ready($elm$core$Dict$empty)
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 99:
				if (!msg.d.$) {
					if (!msg.d.a.b.$) {
						var _v36 = msg.b;
						var key = _v36.a;
						var _v37 = msg.d.a;
						var img = _v37.b.a;
						var _v38 = model.aj;
						if (_v38.$ === 4) {
							var menuItems = _v38.a;
							return _Utils_Tuple2(
								function (mi) {
									return _Utils_update(
										model,
										{
											aj: $author$project$DataState$Ready(mi)
										});
								}(
									A3(
										$elm$core$Dict$update,
										key,
										function (maybeItem) {
											if (!maybeItem.$) {
												var item = maybeItem.a;
												return $elm$core$Maybe$Just(
													_Utils_update(
														item,
														{
															ly: $author$project$Entity$MenuPlanning$ImageReady(img)
														}));
											} else {
												return $elm$core$Maybe$Nothing;
											}
										},
										menuItems)),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					} else {
						var _v40 = msg.d.a;
						var id = _v40.a;
						var _v41 = _v40.b;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					var urlPrefix = msg.a;
					var menuItemId = msg.b;
					var maybeUrl = msg.c;
					return _Utils_Tuple2(
						model,
						A2(
							$andrewMacmurray$elm_delay$Delay$after,
							$andrewMacmurray$elm_delay$Delay$seconds(5),
							A3($author$project$Pages$CfgDevice$Design$RetryLoadImage, urlPrefix, menuItemId, maybeUrl)));
				}
			case 100:
				var urlPrefix = msg.a;
				var _v42 = msg.b;
				var key = _v42.a;
				var itemId = _v42.b;
				var maybeUrl = msg.c;
				return _Utils_Tuple2(
					model,
					A4(
						$author$project$Entity$MenuPlanning$loadImg,
						urlPrefix,
						itemId,
						maybeUrl,
						A3(
							$author$project$Pages$CfgDevice$Design$LoadImage,
							urlPrefix,
							_Utils_Tuple2(key, itemId),
							maybeUrl)));
			case 98:
				if (!msg.b.$) {
					var urlPrefix = msg.a;
					var items = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aj: $author$project$DataState$ready(
									$elm$core$Dict$fromList(
										A2(
											$elm$core$List$map,
											function (item) {
												return _Utils_Tuple2(item.aF, item);
											},
											items)))
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Utils$cmd($author$project$Pages$CfgDevice$Design$FillData),
									$elm$core$Platform$Cmd$batch(
									A2(
										$elm$core$List$map,
										function (item) {
											return A4(
												$author$project$Entity$MenuPlanning$loadImg,
												urlPrefix,
												item.mg,
												item.ly,
												A3(
													$author$project$Pages$CfgDevice$Design$LoadImage,
													urlPrefix,
													_Utils_Tuple2(item.aF, item.mg),
													item.ly));
										},
										items))
								])));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aj: $author$project$DataState$error('Error')
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 97:
				var _v43 = _Utils_Tuple2(model.H, model.aj);
				if ((!_v43.a.$) && (_v43.b.$ === 4)) {
					var template = _v43.a.a;
					var menuItems = _v43.b.a;
					var liveTemplate = function () {
						var _v44 = $author$project$Template$Core$toRaw(template);
						var currentPage = _v44.a;
						var rawTemplate = _v44.b;
						return A2(
							$author$project$Template$Core$goToFrame,
							currentPage,
							$author$project$Template$Core$toLive(
								A3(
									$author$project$Template$Helpers$fillMenuItemsInTemplate,
									$elm$core$Dict$values(menuItems),
									$author$project$Template$BuiltIn$createFrame(template.g8),
									rawTemplate)));
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(liveTemplate),
								b7: $author$project$Template$Widget$Core$initWithAppear(liveTemplate.n)
							}),
						$author$project$Utils$cmd($author$project$Pages$CfgDevice$Design$ShowFrame));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 106:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{g1: $author$project$DataState$init, aj: $author$project$DataState$init}),
					$elm$core$Platform$Cmd$none);
			case 107:
				var scale = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ei: scale}),
					$elm$core$Platform$Cmd$none);
			case 108:
				var template = msg.a;
				var slideNum = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							H: $elm$core$Maybe$Just(
								A2(
									$author$project$Template$Core$goToFrame,
									$elm$core$Basics$round(slideNum),
									template))
						}),
					$elm$core$Platform$Cmd$none);
			case 84:
				var val = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dE: true,
							ey: $elm$core$Maybe$Just(val)
						}),
					$elm$core$Platform$Cmd$none);
			case 93:
				var val = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fS: $elm$core$Maybe$Just(val),
							eI: true
						}),
					$elm$core$Platform$Cmd$none);
			case 92:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{fS: $elm$core$Maybe$Nothing, eI: false}),
					$elm$core$Platform$Cmd$none);
			case 85:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dE: false, ey: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 86:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dz: true}),
					$elm$core$Platform$Cmd$none);
			case 42:
				var str = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aV: $elm$core$Maybe$Just(str)
						}),
					$elm$core$Platform$Cmd$none);
			case 43:
				var template = msg.a;
				var position = msg.b;
				var widgetName = msg.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a: $author$project$DataState$Ready(
								A3($author$project$Template$Helpers$shareWidget, widgetName, position, template)),
							dz: false,
							aV: $elm$core$Maybe$Nothing
						}),
					$elm$core$Platform$Cmd$none);
			case 87:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dz: false, aV: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 90:
				var effect = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cn: _Utils_Tuple2(
								true,
								$elm$core$Maybe$Just(effect))
						}),
					$elm$core$Platform$Cmd$none);
			case 91:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cn: _Utils_Tuple2(false, $elm$core$Maybe$Nothing)
						}),
					$elm$core$Platform$Cmd$none);
			case 109:
				var val = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bJ: val}),
					$elm$core$Platform$Cmd$none);
			case 110:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ee: true}),
					$author$project$Interop$Browser$openMediaLibrary);
			case 112:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{eA: true}),
					$elm$core$Platform$Cmd$none);
			case 113:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{eA: false}),
					$elm$core$Platform$Cmd$none);
			case 114:
				var frameIndex = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dm: _Utils_Tuple2(true, frameIndex)
						}),
					$elm$core$Platform$Cmd$none);
			case 115:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dm: _Utils_Tuple2(false, 0)
						}),
					$elm$core$Platform$Cmd$none);
			case 111:
				var template = msg.a;
				var widgetPos = msg.b;
				var imgUrl = msg.c;
				var updateImageWidget = function (widget) {
					if (widget.$ === 2) {
						var config = widget.a;
						return $author$project$Template$Widget$Core$Image(
							_Utils_update(
								config,
								{ly: imgUrl}));
					} else {
						return widget;
					}
				};
				var maybeUpdatedTemplate = A2(
					$elm$core$Maybe$andThen,
					function (wid) {
						return $elm$core$Maybe$Just(
							_Utils_update(
								template,
								{
									n: A3($author$project$Template$Helpers$updateWidget, wid, updateImageWidget, template.n)
								}));
					},
					A2($author$project$Template$Helpers$getWidgetId, template, widgetPos));
				var _v45 = _Utils_Tuple2(model.ee, maybeUpdatedTemplate);
				if (_v45.a && (!_v45.b.$)) {
					var updated = _v45.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ee: false,
								a: $author$project$DataState$Ready(updated)
							}),
						$author$project$Pages$CfgDevice$Design$autoSave(updated));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 116:
				var config = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bu: 1}),
					$author$project$Pages$CfgDevice$Design$uploadDesignImage(config));
			case 117:
				var toastMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bu: 3}),
					$author$project$Interop$Browser$toast(toastMsg));
			case 118:
				var fileName = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ah: function () {
								var _v47 = model.ah;
								if (_v47.$ === 2) {
									var images = _v47.a;
									return $author$project$Pages$CfgDevice$Design$ImagesReady(
										A3(
											$elm$core$Dict$insert,
											fileName,
											A2($author$project$Pages$CfgDevice$Design$toImgUrl, updateDesignConfig.gM, fileName),
											images));
								} else {
									return model.ah;
								}
							}(),
							bu: 2
						}),
					$author$project$Interop$Browser$toast('Successfully uploaded the image'));
			default:
				if (!msg.a.$) {
					var images = msg.a.a;
					var imageUrls = $elm$core$Dict$fromList(
						A2(
							$elm$core$List$map,
							function (imageName) {
								return _Utils_Tuple2(
									imageName,
									A2($author$project$Pages$CfgDevice$Design$toImgUrl, updateDesignConfig.gM, imageName));
							},
							images));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ah: $author$project$Pages$CfgDevice$Design$ImagesReady(imageUrls)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ah: $author$project$Pages$CfgDevice$Design$ImagesError}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Pages$CfgDevice$Schedule$EditTemplate = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Schedule$EndTime = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Schedule$LoadedSchedules = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$CfgDevice$Schedule$ReqCurrentSchedule = {$: 15};
var $author$project$Pages$CfgDevice$Schedule$StartTime = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Schedule$ToCore = function (a) {
	return {$: 1, a: a};
};
var $ccapndave$elm_update_extra$Update$Extra$andThen = F3(
	function (update, msg, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var _v1 = A2(update, msg, model);
		var model_ = _v1.a;
		var cmd_ = _v1.b;
		return _Utils_Tuple2(
			model_,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, cmd_])));
	});
var $author$project$Entity$Schedule$Time$encode = function (time) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'hour',
				$elm$json$Json$Encode$int(time.c5)),
				_Utils_Tuple2(
				'minute',
				$elm$json$Json$Encode$int(time.dk))
			]));
};
var $author$project$Entity$Schedule$Core$endTime = function () {
	var set = F2(
		function (v, s) {
			return _Utils_update(
				s,
				{e2: v});
		});
	var get = function (s) {
		return s.e2;
	};
	return A2($arturopala$elm_monocle$Monocle$Lens$Lens, get, set);
}();
var $author$project$Entity$Schedule$Core$isEnabled = function () {
	var set = F2(
		function (v, s) {
			return _Utils_update(
				s,
				{fi: v});
		});
	var get = function (s) {
		return s.fi;
	};
	return A2($arturopala$elm_monocle$Monocle$Lens$Lens, get, set);
}();
var $wernerdegroot$listzipper$List$Zipper$current = function (_v0) {
	var x = _v0.b;
	return x;
};
var $wernerdegroot$listzipper$List$Zipper$Zipper = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $wernerdegroot$listzipper$List$Zipper$next = function (_v0) {
	var ls = _v0.a;
	var x = _v0.b;
	var rs = _v0.c;
	if (!rs.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var y = rs.a;
		var ys = rs.b;
		return $elm$core$Maybe$Just(
			A3(
				$wernerdegroot$listzipper$List$Zipper$Zipper,
				A2($elm$core$List$cons, x, ls),
				y,
				ys));
	}
};
var $wernerdegroot$listzipper$List$Zipper$find = F2(
	function (predicate, zipper) {
		find:
		while (true) {
			var ls = zipper.a;
			var x = zipper.b;
			var rs = zipper.c;
			if (predicate(x)) {
				return $elm$core$Maybe$Just(zipper);
			} else {
				var _v0 = $wernerdegroot$listzipper$List$Zipper$next(zipper);
				if (!_v0.$) {
					var nextZipper = _v0.a;
					var $temp$predicate = predicate,
						$temp$zipper = nextZipper;
					predicate = $temp$predicate;
					zipper = $temp$zipper;
					continue find;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $wernerdegroot$listzipper$List$Zipper$fromList = function (xs) {
	if (!xs.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var y = xs.a;
		var ys = xs.b;
		return $elm$core$Maybe$Just(
			A3($wernerdegroot$listzipper$List$Zipper$Zipper, _List_Nil, y, ys));
	}
};
var $author$project$Pages$CfgDevice$Schedule$zipperWithCurrSchedule = F2(
	function (key, schedules) {
		return A2(
			$elm$core$Maybe$andThen,
			$wernerdegroot$listzipper$List$Zipper$find(
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$first,
					$elm$core$Basics$eq(key))),
			$wernerdegroot$listzipper$List$Zipper$fromList(
				A2(
					$elm$core$List$sortBy,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$second,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.fI;
							},
							function ($) {
								return $.c5;
							})),
					$elm$core$Dict$toList(schedules))));
	});
var $author$project$Pages$CfgDevice$Schedule$isEndTimeValid = F3(
	function (currSchd, schedules, time) {
		var maybeNextSchd = A2(
			$elm$core$Maybe$andThen,
			A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $elm$core$Tuple$second),
			A2(
				$elm$core$Maybe$andThen,
				A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $wernerdegroot$listzipper$List$Zipper$current),
				A2(
					$elm$core$Maybe$andThen,
					$wernerdegroot$listzipper$List$Zipper$next,
					A2($author$project$Pages$CfgDevice$Schedule$zipperWithCurrSchedule, currSchd, schedules))));
		var _v0 = _Utils_Tuple2(
			maybeNextSchd,
			A2($elm$core$Dict$get, currSchd, schedules));
		_v0$2:
		while (true) {
			if (!_v0.a.$) {
				if (!_v0.b.$) {
					var nextSchd = _v0.a.a;
					var schdTime = _v0.b.a;
					return (!nextSchd.fi) ? true : (((_Utils_cmp(schdTime.fI.c5, time.c5) < 0) && (_Utils_cmp(time.c5, nextSchd.fI.c5) < 0)) ? true : (_Utils_eq(nextSchd.fI.c5, time.c5) ? (_Utils_cmp(nextSchd.e2.dk, time.dk) > -1) : (_Utils_eq(schdTime.fI.c5, time.c5) ? (_Utils_cmp(schdTime.fI.dk, time.dk) < 1) : false)));
				} else {
					break _v0$2;
				}
			} else {
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var schdTime = _v0.b.a;
					return (_Utils_cmp(time.c5, schdTime.fI.c5) > 0) ? true : (_Utils_eq(schdTime.fI.c5, time.c5) ? (_Utils_cmp(time.dk, schdTime.fI.dk) > -1) : false);
				} else {
					break _v0$2;
				}
			}
		}
		return false;
	});
var $author$project$Entity$Schedule$Time$isEqual = F2(
	function (time1, time2) {
		return _Utils_eq(time1.c5, time2.c5) && _Utils_eq(time1.dk, time2.dk);
	});
var $author$project$Pages$CfgDevice$Schedule$isOriginalTimings = function (_v0) {
	var schedules = _v0.mo;
	var _v1 = _Utils_Tuple3(
		A2($elm$core$Dict$get, 'breakfast', schedules),
		A2($elm$core$Dict$get, 'lunch', schedules),
		A2($elm$core$Dict$get, 'supper', schedules));
	if (((!_v1.a.$) && (!_v1.b.$)) && (!_v1.c.$)) {
		var bschd = _v1.a.a;
		var lschd = _v1.b.a;
		var sprhd = _v1.c.a;
		return $elm$core$Maybe$Just(
			A2($author$project$Entity$Schedule$Time$isEqual, bschd.fI, $author$project$Entity$Schedule$Defaults$breakfastStartTime) && (A2($author$project$Entity$Schedule$Time$isEqual, bschd.e2, $author$project$Entity$Schedule$Defaults$breakfastEndTime) && (A2($author$project$Entity$Schedule$Time$isEqual, lschd.fI, $author$project$Entity$Schedule$Defaults$lunchStartTime) && (A2($author$project$Entity$Schedule$Time$isEqual, lschd.e2, $author$project$Entity$Schedule$Defaults$lunchEndTime) && (A2($author$project$Entity$Schedule$Time$isEqual, sprhd.fI, $author$project$Entity$Schedule$Defaults$supperStartTime) && A2($author$project$Entity$Schedule$Time$isEqual, sprhd.e2, $author$project$Entity$Schedule$Defaults$supperEndTime))))));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $wernerdegroot$listzipper$List$Zipper$previous = function (_v0) {
	var ls = _v0.a;
	var x = _v0.b;
	var rs = _v0.c;
	if (!ls.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var y = ls.a;
		var ys = ls.b;
		return $elm$core$Maybe$Just(
			A3(
				$wernerdegroot$listzipper$List$Zipper$Zipper,
				ys,
				y,
				A2($elm$core$List$cons, x, rs)));
	}
};
var $author$project$Pages$CfgDevice$Schedule$isStartTimeValid = F3(
	function (currSchd, schedules, time) {
		var lastSchd = A2(
			$elm$core$Maybe$andThen,
			A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $elm$core$Tuple$second),
			A2(
				$elm$core$Maybe$andThen,
				A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $wernerdegroot$listzipper$List$Zipper$current),
				A2(
					$elm$core$Maybe$andThen,
					$wernerdegroot$listzipper$List$Zipper$previous,
					A2($author$project$Pages$CfgDevice$Schedule$zipperWithCurrSchedule, currSchd, schedules))));
		var _v0 = _Utils_Tuple2(
			lastSchd,
			A2($elm$core$Dict$get, currSchd, schedules));
		_v0$2:
		while (true) {
			if (!_v0.a.$) {
				if (!_v0.b.$) {
					var lastOne = _v0.a.a;
					var schdTime = _v0.b.a;
					return (!lastOne.fi) ? true : (((_Utils_cmp(lastOne.e2.c5, time.c5) < 0) && (_Utils_cmp(time.c5, schdTime.e2.c5) < 0)) ? true : (_Utils_eq(lastOne.e2.c5, time.c5) ? (_Utils_cmp(lastOne.e2.dk, time.dk) < 1) : (_Utils_eq(schdTime.e2.c5, time.c5) ? (_Utils_cmp(time.dk, schdTime.e2.dk) < 1) : false)));
				} else {
					break _v0$2;
				}
			} else {
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var schdTime = _v0.b.a;
					return (_Utils_cmp(time.c5, schdTime.e2.c5) < 0) ? true : (_Utils_eq(schdTime.e2.c5, time.c5) ? (_Utils_cmp(time.dk, schdTime.e2.dk) < 1) : false);
				} else {
					break _v0$2;
				}
			}
		}
		return false;
	});
var $author$project$Pages$CfgDevice$Schedule$scheduleInModel = function (key) {
	var set = F2(
		function (val, m) {
			return _Utils_update(
				m,
				{
					mo: A3($elm$core$Dict$insert, key, val, m.mo)
				});
		});
	var get = function (m) {
		return A2($elm$core$Dict$get, key, m.mo);
	};
	return A2($arturopala$elm_monocle$Monocle$Optional$Optional, get, set);
};
var $author$project$Pages$CfgDevice$Schedule$localRemote = F5(
	function (lens, _v0, _v1, encoder, _v2) {
		var schdKey = _v0.a;
		var val = _v0.b;
		var sockId = _v1.a;
		var eventName = _v1.b;
		var model = _v2.a;
		var cmd = _v2.b;
		var innerUpdate = A2(
			$arturopala$elm_monocle$Monocle$Optional$composeLens,
			$author$project$Pages$CfgDevice$Schedule$scheduleInModel(schdKey),
			lens);
		return _Utils_Tuple2(
			A2(innerUpdate.cm, val, model),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3(
						$author$project$Interop$Fabric$unicastMessage,
						sockId,
						eventName,
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'schdKey',
									$elm$json$Json$Encode$string(schdKey)),
									_Utils_Tuple2(
									'value',
									encoder(val))
								]))),
						cmd
					])));
	});
var $arturopala$elm_monocle$Monocle$Lens$compose = F2(
	function (outer, inner) {
		var set = F2(
			function (c, a) {
				return function (b) {
					return A2(outer.cm, b, a);
				}(
					A2(
						inner.cm,
						c,
						outer.gE(a)));
			});
		return A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			A2($elm$core$Basics$composeR, outer.gE, inner.gE),
			set);
	});
var $author$project$Entity$Schedule$Core$menuPlanning = function () {
	var set = F2(
		function (v, s) {
			return _Utils_update(
				s,
				{fp: v});
		});
	var get = function (s) {
		return s.fp;
	};
	return A2($arturopala$elm_monocle$Monocle$Lens$Lens, get, set);
}();
var $author$project$Entity$Schedule$MenuPlanning$servingLines = A2(
	$arturopala$elm_monocle$Monocle$Lens$Lens,
	function ($) {
		return $.jR;
	},
	F2(
		function (v, mp) {
			return _Utils_update(
				mp,
				{jR: v});
		}));
var $author$project$Entity$Schedule$Core$servingLinesOfMenuPlanning = A2($arturopala$elm_monocle$Monocle$Lens$compose, $author$project$Entity$Schedule$Core$menuPlanning, $author$project$Entity$Schedule$MenuPlanning$servingLines);
var $author$project$Entity$Schedule$Core$startTime = function () {
	var set = F2(
		function (v, s) {
			return _Utils_update(
				s,
				{fI: v});
		});
	var get = function (s) {
		return s.fI;
	};
	return A2($arturopala$elm_monocle$Monocle$Lens$Lens, get, set);
}();
var $author$project$Entity$Schedule$Core$template = function () {
	var set = F2(
		function (v, s) {
			return _Utils_update(
				s,
				{fN: v});
		});
	var get = function (s) {
		return s.fN;
	};
	return A2($arturopala$elm_monocle$Monocle$Lens$Lens, get, set);
}();
var $author$project$Pages$CfgDevice$Schedule$update = F4(
	function (devId, sockId, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var msg_ = msg.a;
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 2:
				var a = msg.a;
				var b = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{fQ: $author$project$Reusable$Tooltip$init}),
					$author$project$Utils$cmd(
						$author$project$Pages$CfgDevice$Schedule$ToCore(
							A2($author$project$Pages$CfgDevice$Schedule$EditTemplate, a, b))));
			case 5:
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fQ: A2($author$project$Reusable$Tooltip$update, msg_, model.fQ)
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var dict = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mo: dict}),
					$author$project$Utils$cmd(
						$author$project$Pages$CfgDevice$Schedule$ToCore(
							$author$project$Pages$CfgDevice$Schedule$LoadedSchedules(dict))));
			case 4:
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (m) {
						return _Utils_update(
							model,
							{r: m});
					},
					A2($author$project$Select$update, msg_, model.r));
			case 7:
				var schdName = msg.a;
				var name = msg.b.g8;
				return A5(
					$author$project$Pages$CfgDevice$Schedule$localRemote,
					$author$project$Entity$Schedule$Core$template,
					_Utils_Tuple2(schdName, name),
					_Utils_Tuple2(sockId, 'SELECT_TEMPLATE'),
					$elm$json$Json$Encode$string,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			case 6:
				var name = msg.a;
				var val = msg.b;
				var isSame = $author$project$Pages$CfgDevice$Schedule$isOriginalTimings(model);
				var _v1 = _Utils_Tuple2(isSame, val);
				if (!_v1.a.$) {
					if (_v1.a.a) {
						return A5(
							$author$project$Pages$CfgDevice$Schedule$localRemote,
							$author$project$Entity$Schedule$Core$isEnabled,
							_Utils_Tuple2(name, val),
							_Utils_Tuple2(sockId, 'SCHEDULE_ENABLE'),
							$elm$json$Json$Encode$bool,
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
					} else {
						if (!_v1.b) {
							return A5(
								$author$project$Pages$CfgDevice$Schedule$localRemote,
								$author$project$Entity$Schedule$Core$isEnabled,
								_Utils_Tuple2(name, val),
								_Utils_Tuple2(sockId, 'SCHEDULE_ENABLE'),
								$elm$json$Json$Encode$bool,
								_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
						} else {
							return A5(
								$author$project$Pages$CfgDevice$Schedule$localRemote,
								$author$project$Entity$Schedule$Core$isEnabled,
								_Utils_Tuple2(name, val),
								_Utils_Tuple2(sockId, 'SCHEDULE_ENABLE'),
								$elm$json$Json$Encode$bool,
								_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
						}
					}
				} else {
					var _v2 = _v1.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 8:
				if (msg.b.$ === 1) {
					var name = msg.a;
					var _v3 = msg.b;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var name = msg.a;
					var val = msg.b.a;
					return A3($author$project$Pages$CfgDevice$Schedule$isStartTimeValid, name, model.mo, val) ? A5(
						$author$project$Pages$CfgDevice$Schedule$localRemote,
						$author$project$Entity$Schedule$Core$startTime,
						_Utils_Tuple2(name, val),
						_Utils_Tuple2(sockId, 'START_TIME'),
						$author$project$Entity$Schedule$Time$encode,
						_Utils_Tuple2(
							model,
							A2(
								$andrewMacmurray$elm_delay$Delay$after,
								$andrewMacmurray$elm_delay$Delay$seconds(2),
								$author$project$Pages$CfgDevice$Schedule$ReqCurrentSchedule))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 15:
				return _Utils_Tuple2(
					model,
					A2($author$project$Pages$CfgDevice$Schedule$reqCurrentSchedule, devId, sockId));
			case 9:
				if (msg.b.$ === 1) {
					var name = msg.a;
					var _v4 = msg.b;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var name = msg.a;
					var val = msg.b.a;
					return A3($author$project$Pages$CfgDevice$Schedule$isEndTimeValid, name, model.mo, val) ? A5(
						$author$project$Pages$CfgDevice$Schedule$localRemote,
						$author$project$Entity$Schedule$Core$endTime,
						_Utils_Tuple2(name, val),
						_Utils_Tuple2(sockId, 'END_TIME'),
						$author$project$Entity$Schedule$Time$encode,
						_Utils_Tuple2(
							model,
							A2(
								$andrewMacmurray$elm_delay$Delay$after,
								$andrewMacmurray$elm_delay$Delay$seconds(2),
								$author$project$Pages$CfgDevice$Schedule$ReqCurrentSchedule))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 10:
				var isAfter = msg.a;
				var _v5 = A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					A2($author$project$Pages$CfgDevice$Schedule$update, devId, sockId),
					A2(
						$author$project$Pages$CfgDevice$Schedule$EndTime,
						'supper',
						$elm$core$Maybe$Just($author$project$Entity$Schedule$Defaults$supperEndTime)),
					A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						A2($author$project$Pages$CfgDevice$Schedule$update, devId, sockId),
						A2(
							$author$project$Pages$CfgDevice$Schedule$EndTime,
							'lunch',
							$elm$core$Maybe$Just($author$project$Entity$Schedule$Defaults$lunchEndTime)),
						A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							A2($author$project$Pages$CfgDevice$Schedule$update, devId, sockId),
							A2(
								$author$project$Pages$CfgDevice$Schedule$StartTime,
								'breakfast',
								$elm$core$Maybe$Just($author$project$Entity$Schedule$Defaults$breakfastStartTime)),
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none))));
				var model_ = _v5.a;
				var cmd_ = _v5.b;
				return isAfter ? A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					A2($author$project$Pages$CfgDevice$Schedule$update, devId, sockId),
					A2(
						$author$project$Pages$CfgDevice$Schedule$EndTime,
						'breakfast',
						$elm$core$Maybe$Just($author$project$Entity$Schedule$Defaults$breakfastEndTime)),
					A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						A2($author$project$Pages$CfgDevice$Schedule$update, devId, sockId),
						A2(
							$author$project$Pages$CfgDevice$Schedule$StartTime,
							'lunch',
							$elm$core$Maybe$Just($author$project$Entity$Schedule$Defaults$lunchStartTime)),
						_Utils_Tuple2(model_, cmd_))) : A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					A2($author$project$Pages$CfgDevice$Schedule$update, devId, sockId),
					A2(
						$author$project$Pages$CfgDevice$Schedule$StartTime,
						'lunch',
						$elm$core$Maybe$Just($author$project$Entity$Schedule$Defaults$lunchStartTime)),
					A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						A2($author$project$Pages$CfgDevice$Schedule$update, devId, sockId),
						A2(
							$author$project$Pages$CfgDevice$Schedule$EndTime,
							'breakfast',
							$elm$core$Maybe$Just($author$project$Entity$Schedule$Defaults$breakfastEndTime)),
						_Utils_Tuple2(model_, cmd_)));
			case 11:
				var name = msg.a;
				var val = msg.b;
				return A5(
					$author$project$Pages$CfgDevice$Schedule$localRemote,
					$author$project$Entity$Schedule$Core$servingLinesOfMenuPlanning,
					_Utils_Tuple2(name, val),
					_Utils_Tuple2(sockId, 'SERVING_LINE_CHANGE'),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map($elm$json$Json$Encode$string),
						$elm$json$Json$Encode$list($elm$core$Basics$identity)),
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			case 12:
				var data = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{al: data}),
					$elm$core$Platform$Cmd$none);
			case 13:
				if (!msg.a.$) {
					var list = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								eU: A2(
									$elm$core$List$map,
									function ($) {
										return $.g8;
									},
									list)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				if (!msg.a.$) {
					var list = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								jR: A2(
									$elm$core$List$map,
									function ($) {
										return $.g8;
									},
									list)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Pages$CfgDevice$Settings$ConfirmDeactivateDevice = {$: 15};
var $author$project$Pages$CfgDevice$Settings$ConfirmRestartDevice = {$: 16};
var $author$project$Pages$CfgDevice$Settings$RemoveDevice = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$CfgDevice$Settings$ServerDeactivatedDevice = F2(
	function (a, b) {
		return {$: 30, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Settings$ServerUpdatedName = F3(
	function (a, b, c) {
		return {$: 28, a: a, b: b, c: c};
	});
var $author$project$Pages$CfgDevice$Settings$ServerUpdatedSchool = F3(
	function (a, b, c) {
		return {$: 29, a: a, b: b, c: c};
	});
var $author$project$Pages$CfgDevice$Settings$UpdateName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$CfgDevice$Settings$UpdateSchool = function (a) {
	return {$: 0, a: a};
};
var $author$project$Entity$MealType$encode = function (meal) {
	return $elm$json$Json$Encode$string(
		$author$project$Entity$MealType$toString(meal));
};
var $author$project$Entity$Schedule$MenuPlanning$encode = function (data) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'mealType',
				$author$project$Entity$MealType$encode(data.i8)),
				_Utils_Tuple2(
				'servingLines',
				A2(
					$elm$json$Json$Encode$list,
					$elm$core$Basics$identity,
					A2($elm$core$List$map, $elm$json$Json$Encode$string, data.jR)))
			]));
};
var $author$project$Entity$Schedule$Core$encode = function (data) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(data.g8)),
				_Utils_Tuple2(
				'isEnabled',
				$elm$json$Json$Encode$bool(data.fi)),
				_Utils_Tuple2(
				'template',
				$elm$json$Json$Encode$string(data.fN)),
				_Utils_Tuple2(
				'startTime',
				$author$project$Entity$Schedule$Time$encode(data.fI)),
				_Utils_Tuple2(
				'endTime',
				$author$project$Entity$Schedule$Time$encode(data.e2)),
				_Utils_Tuple2(
				'menuPlanning',
				$author$project$Entity$Schedule$MenuPlanning$encode(data.fp))
			]));
};
var $author$project$Entity$School$encode = function (school) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'schoolId',
				$elm$json$Json$Encode$string(school.aF)),
				_Utils_Tuple2(
				'schoolName',
				$elm$json$Json$Encode$string(school.g8))
			]));
};
var $author$project$Entity$Screensaver$encode = function (option) {
	if (!option) {
		return $elm$json$Json$Encode$string('dark-background');
	} else {
		return $elm$json$Json$Encode$string('images');
	}
};
var $lukewestby$elm_http_builder$HttpBuilder$put = $lukewestby$elm_http_builder$HttpBuilder$requestWithMethodAndUrl('PUT');
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $lukewestby$elm_http_builder$HttpBuilder$withBody = F2(
	function (body, builder) {
		return _Utils_update(
			builder,
			{kG: body});
	});
var $lukewestby$elm_http_builder$HttpBuilder$withJsonBody = function (value) {
	return $lukewestby$elm_http_builder$HttpBuilder$withBody(
		$elm$http$Http$jsonBody(value));
};
var $author$project$Entity$Device$updateDevice = F6(
	function (urlPrefix, token, deviceId, name, schoolId, toMsg) {
		var url = A3(
			$elm$url$Url$Builder$crossOrigin,
			urlPrefix,
			_List_fromArray(
				['api', 'Device']),
			_List_Nil);
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				$elm$http$Http$expectString(toMsg),
				A2(
					$author$project$Utils$addAccessToken,
					token,
					A2(
						$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'Id',
									$elm$json$Json$Encode$string(deviceId)),
									_Utils_Tuple2(
									'Name',
									$elm$json$Json$Encode$string(name)),
									_Utils_Tuple2(
									'SchoolId',
									$elm$json$Json$Encode$string(schoolId))
								])),
						$lukewestby$elm_http_builder$HttpBuilder$put(url)))));
	});
var $author$project$Entity$StatusBarTheme$encode = function (theme) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'hideBar',
				$elm$json$Json$Encode$bool(theme.gK)),
				_Utils_Tuple2(
				'fontFamily',
				$elm$json$Json$Encode$string(theme.gy)),
				_Utils_Tuple2(
				'fontColor',
				$elm$json$Json$Encode$string(theme.gx)),
				_Utils_Tuple2(
				'fontSize',
				$elm$json$Json$Encode$float(theme.gz)),
				_Utils_Tuple2(
				'background',
				$elm$json$Json$Encode$string(theme.f6)),
				_Utils_Tuple2(
				'showLogo',
				$elm$json$Json$Encode$bool(theme.hH)),
				_Utils_Tuple2(
				'width',
				$elm$json$Json$Encode$float(theme.hY)),
				_Utils_Tuple2(
				'height',
				$elm$json$Json$Encode$float(theme.gH)),
				_Utils_Tuple2(
				'logoUrl',
				$elm$json$Json$Encode$string(theme.gZ)),
				_Utils_Tuple2(
				'permTextFontSize',
				$elm$json$Json$Encode$float(theme.hr)),
				_Utils_Tuple2(
				'permText',
				$elm$json$Json$Encode$string(theme.hq))
			]));
};
var $author$project$Pages$CfgDevice$Settings$updateDeviceTheme = F2(
	function (sockId, theme) {
		return A3(
			$author$project$Interop$Fabric$unicastMessage,
			sockId,
			'UPDATE_STATUS_BAR_THEME',
			$author$project$Entity$StatusBarTheme$encode(theme));
	});
var $author$project$Pages$CfgDevice$Settings$update = F4(
	function (key, sockId, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cO: false}),
					$elm$core$Platform$Cmd$none);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cP: false}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (m) {
						return _Utils_update(
							model,
							{r: m});
					},
					A2($author$project$Select$update, msg_, model.r));
			case 3:
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fQ: A2($author$project$Reusable$Tooltip$update, msg_, model.fQ)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aA: A2($author$project$ColorPicker$update, msg_, model.aA)
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (c) {
						return A2($elm$core$Platform$Cmd$map, $author$project$Pages$CfgDevice$Settings$DatePickerMsg, c);
					},
					A2(
						$elm$core$Tuple$mapFirst,
						function (m) {
							return _Utils_update(
								model,
								{b8: m});
						},
						A2($author$project$Reusable$DatePicker$update, msg_, model.b8)));
			case 8:
				var cmd = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dv: $elm$core$Maybe$Just(cmd)
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var cmd = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dv: $elm$core$Maybe$Nothing}),
					function () {
						switch (cmd) {
							case 0:
								return $author$project$Utils$cmd($author$project$Pages$CfgDevice$Settings$ConfirmRestartDevice);
							case 1:
								return $author$project$Utils$cmd($author$project$Pages$CfgDevice$Settings$ConfirmDeactivateDevice);
							case 4:
								return $elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A3($author$project$Interop$Fabric$unicastMessage, sockId, 'MOCK_DEVICE_DATA_DISASTER', $elm$json$Json$Encode$null),
											$author$project$Utils$cmd(
											$author$project$Pages$CfgDevice$Settings$ToCore(
												$author$project$Pages$CfgDevice$Settings$Toast('Request sent')))
										]));
							case 2:
								return $elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A3($author$project$Interop$Fabric$unicastMessage, sockId, 'SAVE_SERIAL_NUMBER', $elm$json$Json$Encode$null),
											$author$project$Utils$cmd(
											$author$project$Pages$CfgDevice$Settings$ToCore(
												$author$project$Pages$CfgDevice$Settings$Toast('Request sent')))
										]));
							case 3:
								return $elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A3($author$project$Interop$Fabric$unicastMessage, sockId, 'REQ_BACKUP_DEVICE', $elm$json$Json$Encode$null),
											$author$project$Utils$cmd(
											$author$project$Pages$CfgDevice$Settings$ToCore(
												$author$project$Pages$CfgDevice$Settings$Toast('Request sent')))
										]));
							case 5:
								return A3($author$project$Interop$Fabric$unicastMessage, sockId, 'TOGGLE_PLAY', $elm$json$Json$Encode$null);
							default:
								return $elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A3($author$project$Interop$Fabric$unicastMessage, sockId, 'RELOAD_CURRENT_MENU', $elm$json$Json$Encode$null),
											$author$project$Utils$cmd(
											$author$project$Pages$CfgDevice$Settings$ToCore(
												$author$project$Pages$CfgDevice$Settings$Toast('Request sent')))
										]));
						}
					}());
			case 10:
				var config = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cO: false}),
					A4(
						$author$project$Entity$Device$deleteDevice,
						config.an,
						config.nb,
						config.cV.aF,
						$author$project$Pages$CfgDevice$Settings$ServerDeactivatedDevice(config.cV)));
			case 11:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cP: false}),
					A3($author$project$Interop$Fabric$unicastMessage, sockId, 'RELOAD_DEVICE', $elm$json$Json$Encode$null));
			case 25:
				var theme = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gZ: theme.gZ,
							hq: theme.hq,
							bH: $elm$core$Maybe$Just(theme)
						}),
					$elm$core$Platform$Cmd$none);
			case 26:
				var opt = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eu: $elm$core$Maybe$Just(opt)
						}),
					A3(
						$author$project$Interop$Fabric$unicastMessage,
						sockId,
						'CHANGE_SCREENSAVER',
						$author$project$Entity$Screensaver$encode(opt)));
			case 27:
				var data = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mo: data}),
					$elm$core$Platform$Cmd$none);
			case 21:
				var str = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gZ: str}),
					$elm$core$Platform$Cmd$none);
			case 23:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hq: value}),
					$elm$core$Platform$Cmd$none);
			case 24:
				var theme = msg.a;
				var updatedTheme = _Utils_update(
					theme,
					{hq: model.hq});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bH: $elm$core$Maybe$Just(updatedTheme)
						}),
					A2($author$project$Pages$CfgDevice$Settings$updateDeviceTheme, sockId, updatedTheme));
			case 22:
				var theme = msg.a;
				var updatedTheme = _Utils_update(
					theme,
					{gZ: model.gZ});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bH: $elm$core$Maybe$Just(updatedTheme)
						}),
					A2($author$project$Pages$CfgDevice$Settings$updateDeviceTheme, sockId, updatedTheme));
			case 20:
				var theme = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aA: $author$project$ColorPicker$init,
							bH: $elm$core$Maybe$Just(theme)
						}),
					A2($author$project$Pages$CfgDevice$Settings$updateDeviceTheme, sockId, theme));
			case 32:
				var num = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jP: $elm$core$Maybe$Just(num)
						}),
					$elm$core$Platform$Cmd$none);
			case 33:
				var data = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dY: $elm$core$Maybe$Just(data)
						}),
					$elm$core$Platform$Cmd$none);
			case 34:
				var data = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							el: $elm$core$Maybe$Just(data)
						}),
					$elm$core$Platform$Cmd$none);
			case 35:
				return _Utils_Tuple2(
					model,
					$author$project$Utils$cmd(
						$author$project$Pages$CfgDevice$Settings$ToCore(
							$author$project$Pages$CfgDevice$Settings$Toast('Backup successful'))));
			case 36:
				var err = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Utils$cmd(
						$author$project$Pages$CfgDevice$Settings$ToCore(
							$author$project$Pages$CfgDevice$Settings$Toast('Backup failed'))));
			case 12:
				var deviceNames = msg.a;
				var name_ = msg.b;
				return A2($elm$core$Set$member, name_, deviceNames) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: $elm$core$Maybe$Just(
								_Utils_Tuple2(name_, name_ + ' already exists in this location'))
						}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: $elm$core$Maybe$Just(
								_Utils_Tuple2(name_, ''))
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var config = msg.a;
				var _v2 = model.bS;
				if (_v2.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var _v3 = _v2.a;
					var name = _v3.a;
					return $elm$core$String$isEmpty(name) ? _Utils_Tuple2(
						model,
						$author$project$Utils$cmd(
							$author$project$Pages$CfgDevice$Settings$ToCore(
								$author$project$Pages$CfgDevice$Settings$Toast('Device name cannot be empty')))) : _Utils_Tuple2(
						model,
						A6(
							$author$project$Entity$Device$updateDevice,
							config.an,
							config.nb,
							config.cV.aF,
							name,
							config.cV.du.aF,
							A2($author$project$Pages$CfgDevice$Settings$ServerUpdatedName, config.cV.aF, name)));
				}
			case 13:
				var config = msg.a;
				var school = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{r: $author$project$Select$init}),
					A6(
						$author$project$Entity$Device$updateDevice,
						config.an,
						config.nb,
						config.cV.aF,
						config.cV.g8,
						school.aF,
						A2($author$project$Pages$CfgDevice$Settings$ServerUpdatedSchool, config.cV.aF, school)));
			case 15:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cO: true}),
					$elm$core$Platform$Cmd$none);
			case 16:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cP: true}),
					$elm$core$Platform$Cmd$none);
			case 17:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dY: $elm$core$Maybe$Nothing, el: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3($author$project$Interop$Fabric$unicastMessage, sockId, 'REQ_CPU_INFO', $elm$json$Json$Encode$null),
								A3($author$project$Interop$Fabric$unicastMessage, sockId, 'REQ_MEM_INFO', $elm$json$Json$Encode$null)
							])));
			case 28:
				if (!msg.c.$) {
					var deviceId = msg.a;
					var name = msg.b;
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3(
									$author$project$Interop$Fabric$unicastMessage,
									sockId,
									'CHANGE_NAME',
									$elm$json$Json$Encode$string(name)),
									$author$project$Utils$cmd(
									$author$project$Pages$CfgDevice$Settings$ToCore(
										$author$project$Pages$CfgDevice$Settings$UpdateName(
											_Utils_Tuple2(deviceId, name))))
								])));
				} else {
					return _Utils_Tuple2(
						model,
						$author$project$Utils$cmd(
							$author$project$Pages$CfgDevice$Settings$ToCore(
								$author$project$Pages$CfgDevice$Settings$Toast('Failed to update device in server'))));
				}
			case 29:
				if (!msg.c.$) {
					var devId = msg.a;
					var school = msg.b;
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3(
									$author$project$Interop$Fabric$unicastMessage,
									sockId,
									'CHANGE_SCHOOL',
									$author$project$Entity$School$encode(school)),
									$author$project$Utils$cmd(
									$author$project$Pages$CfgDevice$Settings$ToCore(
										$author$project$Pages$CfgDevice$Settings$UpdateSchool(
											_Utils_Tuple2(devId, school))))
								])));
				} else {
					return _Utils_Tuple2(
						model,
						$author$project$Utils$cmd(
							$author$project$Pages$CfgDevice$Settings$ToCore(
								$author$project$Pages$CfgDevice$Settings$Toast('Unable to save device school'))));
				}
			case 30:
				if (!msg.b.$) {
					var device = msg.a;
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3($author$project$Interop$Fabric$unicastMessage, sockId, 'DEACTIVATE_DEVICE', $elm$json$Json$Encode$null),
									$author$project$Utils$cmd(
									$author$project$Pages$CfgDevice$Settings$ToCore(
										$author$project$Pages$CfgDevice$Settings$RemoveDevice(device.aF))),
									A2($author$project$Routing$navigateTo, key, $author$project$Routing$DashboardPage)
								])));
				} else {
					var device = msg.a;
					return _Utils_Tuple2(
						model,
						$author$project$Utils$cmd(
							$author$project$Pages$CfgDevice$Settings$ToCore(
								$author$project$Pages$CfgDevice$Settings$Toast('Unable to complete operation, Try later'))));
				}
			case 31:
				var data = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fl: $elm$core$Maybe$Just(data)
						}),
					$elm$core$Platform$Cmd$none);
			case 18:
				var schd = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cl: $elm$core$Maybe$Just(schd)
						}),
					$elm$core$Platform$Cmd$none);
			case 19:
				var schd = msg.a;
				var date = msg.b;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3(
								$author$project$Interop$Fabric$unicastMessage,
								sockId,
								'LOAD_CUSTOM_MENU',
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'schedule',
											$author$project$Entity$Schedule$Core$encode(schd)),
											_Utils_Tuple2(
											'date',
											$elm$json$Json$Encode$string(date))
										]))),
								$author$project$Utils$cmd(
								$author$project$Pages$CfgDevice$Settings$ToCore(
									$author$project$Pages$CfgDevice$Settings$Toast('Request sent')))
							])));
			case 37:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ee: true}),
					$author$project$Interop$Browser$openMediaLibrary);
			default:
				var imgUrl = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ee: false, gZ: imgUrl}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$CfgDevice$Core$update = F6(
	function (fabricUrl, accessToken, maybeDistrict, key, msg, model) {
		switch (msg.$) {
			case 2:
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fQ: A2($author$project$Reusable$Tooltip$update, msg_, model.fQ)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				if (!msg.c.$) {
					switch (msg.c.a) {
						case 0:
							var urlPrefix = msg.a;
							var device = msg.b;
							var _v1 = msg.c.a;
							var _v2 = $author$project$Entity$Device$getDeviceSocketId(device);
							if (_v2.$ === 1) {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							} else {
								var sId = _v2.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{ba: 0}),
									A2(
										$elm$core$Platform$Cmd$map,
										$author$project$Pages$CfgDevice$Core$ScheduleTabMsg,
										A4($author$project$Pages$CfgDevice$Schedule$loadData, urlPrefix, device.aF, device.du, sId)));
							}
						case 1:
							var urlPrefix = msg.a;
							var device = msg.b;
							var _v3 = msg.c.a;
							var _v4 = $author$project$Entity$Device$getDeviceSocketId(device);
							if (_v4.$ === 1) {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							} else {
								var sId = _v4.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{ba: 1}),
									A2(
										$elm$core$Platform$Cmd$map,
										$author$project$Pages$CfgDevice$Core$DesignTabMsg,
										A3($author$project$Pages$CfgDevice$Design$loadData, urlPrefix, device, sId)));
							}
						default:
							var device = msg.b;
							var _v5 = msg.c.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{ba: 2}),
								function () {
									var _v6 = $author$project$Entity$Device$getDeviceSocketId(device);
									if (!_v6.$) {
										var deviceSockId = _v6.a;
										return A2(
											$elm$core$Platform$Cmd$map,
											$author$project$Pages$CfgDevice$Core$SettingsTabMsg,
											$author$project$Pages$CfgDevice$Settings$loadData(deviceSockId));
									} else {
										return $elm$core$Platform$Cmd$none;
									}
								}());
					}
				} else {
					var _v7 = msg.c;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 5:
				if (!msg.a.$) {
					var tab = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bG: tab}),
						$elm$core$Platform$Cmd$none);
				} else {
					var _v8 = msg.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 6:
				var k = msg.a;
				return A2($elm$core$Set$member, k, model.ch) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ch: A2($elm$core$Set$remove, k, model.ch)
						}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ch: A2($elm$core$Set$insert, k, model.ch)
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				if (msg.a.$ === 1) {
					switch (msg.a.a.$) {
						case 1:
							var _v9 = msg.a.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{bG: 1}),
								$elm$core$Platform$Cmd$none);
						case 0:
							var _v10 = msg.a.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{bG: 2}),
								$elm$core$Platform$Cmd$none);
						case 2:
							var _v11 = msg.a.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{bG: 0}),
								$elm$core$Platform$Cmd$none);
						default:
							var message = msg.a.a.a;
							return A2(
								$author$project$Pages$CfgDevice$Core$toast,
								message,
								_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
					}
				} else {
					var msg_ = msg.a;
					return A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
						A2(
							$elm$core$Maybe$andThen,
							function (sId) {
								return $elm$core$Maybe$Just(
									A2(
										$elm$core$Tuple$mapSecond,
										function (c) {
											return A2($elm$core$Platform$Cmd$map, $author$project$Pages$CfgDevice$Core$DesignTabMsg, c);
										},
										A2(
											$elm$core$Tuple$mapFirst,
											function (m) {
												return _Utils_update(
													model,
													{P: m});
											},
											A4(
												$author$project$Pages$CfgDevice$Design$update,
												{
													h5: accessToken,
													gm: 'media-image-upload-button',
													gM: _Utils_Tuple2(fabricUrl, maybeDistrict)
												},
												sId,
												msg_,
												model.P))));
							},
							A2(
								$elm$core$Maybe$andThen,
								$author$project$Entity$Device$getDeviceSocketId,
								$author$project$Pages$CfgDevice$Core$getSelectedDevice(model))));
				}
			case 8:
				if (msg.a.$ === 1) {
					if (!msg.a.a.$) {
						var _v12 = msg.a.a;
						var urlPrefix = _v12.a;
						var templateName = _v12.b;
						var _v13 = $author$project$Pages$CfgDevice$Core$getSelectedDevice(model);
						if (!_v13.$) {
							var device = _v13.a;
							return _Utils_Tuple2(
								model,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Utils$cmd(
											A3(
												$author$project$Pages$CfgDevice$Core$SelectMainTab,
												urlPrefix,
												device,
												$elm$core$Maybe$Just(1))),
											A2(
											$elm$core$Platform$Cmd$map,
											$author$project$Pages$CfgDevice$Core$DesignTabMsg,
											$author$project$Pages$CfgDevice$Design$loadTemplate(templateName))
										])));
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					} else {
						var data = msg.a.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									P: A2($author$project$Pages$CfgDevice$Design$applyPreviewDefaults, data, model.P),
									aU: A2($author$project$Pages$CfgDevice$Settings$applyScheduleDefaults, data, model.aU)
								}),
							$elm$core$Platform$Cmd$none);
					}
				} else {
					var msg_ = msg.a;
					return A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
						A2(
							$elm$core$Maybe$andThen,
							function (device) {
								var _v14 = device.fJ;
								if (!_v14.$) {
									var sId = _v14.a;
									return $elm$core$Maybe$Just(
										A2(
											$elm$core$Tuple$mapSecond,
											function (c) {
												return A2($elm$core$Platform$Cmd$map, $author$project$Pages$CfgDevice$Core$ScheduleTabMsg, c);
											},
											A2(
												$elm$core$Tuple$mapFirst,
												function (m) {
													return _Utils_update(
														model,
														{a7: m});
												},
												A4($author$project$Pages$CfgDevice$Schedule$update, device.aF, sId, msg_, model.a7))));
								} else {
									return $elm$core$Maybe$Nothing;
								}
							},
							$author$project$Pages$CfgDevice$Core$getSelectedDevice(model)));
				}
			case 9:
				if (msg.a.$ === 1) {
					switch (msg.a.a.$) {
						case 0:
							var _v15 = msg.a.a.a;
							var devId = _v15.a;
							var school = _v15.b;
							return _Utils_Tuple2(
								A3(
									function ($) {
										return $.cm;
									},
									$author$project$Pages$CfgDevice$Core$deviceSchool(devId),
									school,
									model),
								$elm$core$Platform$Cmd$none);
						case 1:
							var _v16 = msg.a.a.a;
							var devId = _v16.a;
							var name = _v16.b;
							return _Utils_Tuple2(
								A3(
									function ($) {
										return $.cm;
									},
									$author$project$Pages$CfgDevice$Core$deviceName(devId),
									name,
									model),
								$elm$core$Platform$Cmd$none);
						case 2:
							var devId = msg.a.a.a;
							return A2(
								$author$project$Pages$CfgDevice$Core$toast,
								'Device deactivated',
								_Utils_Tuple2(
									A2(
										$author$project$Pages$CfgDevice$Core$removeDevice,
										devId,
										_Utils_update(
											model,
											{
												P: $author$project$Pages$CfgDevice$Design$init(model.P.jM),
												a7: $author$project$Pages$CfgDevice$Schedule$init,
												aU: $author$project$Pages$CfgDevice$Settings$init.a
											})),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$CfgDevice$Core$SettingsTabMsg, $author$project$Pages$CfgDevice$Settings$init.b)));
						default:
							var str = msg.a.a.a;
							return A2(
								$author$project$Pages$CfgDevice$Core$toast,
								str,
								_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
					}
				} else {
					var msg_ = msg.a;
					return A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
						A2(
							$elm$core$Maybe$andThen,
							function (sId) {
								return $elm$core$Maybe$Just(
									A2(
										$elm$core$Tuple$mapSecond,
										function (c) {
											return A2($elm$core$Platform$Cmd$map, $author$project$Pages$CfgDevice$Core$SettingsTabMsg, c);
										},
										A2(
											$elm$core$Tuple$mapFirst,
											function (m) {
												return _Utils_update(
													model,
													{aU: m});
											},
											A4($author$project$Pages$CfgDevice$Settings$update, key, sId, msg_, model.aU))));
							},
							A2(
								$elm$core$Maybe$andThen,
								$author$project$Entity$Device$getDeviceSocketId,
								$author$project$Pages$CfgDevice$Core$getSelectedDevice(model))));
				}
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var msg_ = msg.a;
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 3:
				var messageId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cp: A2($aforemny$material_components_web_elm$Material$Snackbar$close, messageId, model.cp)
						}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var urlPrefix = msg.a;
				var token = msg.b;
				var device = msg.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							kV: $elm$core$Maybe$Just(device.aF),
							P: $author$project$Pages$CfgDevice$Design$init(model.P.jM),
							a7: $author$project$Pages$CfgDevice$Schedule$init,
							ba: 0,
							aU: $author$project$Pages$CfgDevice$Settings$init.a
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Routing$navigateTo, key, $author$project$Routing$ConfigureDevicePage),
								$author$project$Local$Commands$Browser$scrollToTop,
								function () {
								var _v17 = $author$project$Entity$Device$getDeviceSocketId(device);
								if (_v17.$ === 1) {
									return $elm$core$Platform$Cmd$none;
								} else {
									var sId = _v17.a;
									return A2(
										$elm$core$Platform$Cmd$map,
										$author$project$Pages$CfgDevice$Core$ScheduleTabMsg,
										A4($author$project$Pages$CfgDevice$Schedule$loadData, urlPrefix, device.aF, device.du, sId));
								}
							}(),
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$CfgDevice$Core$SettingsTabMsg, $author$project$Pages$CfgDevice$Settings$init.b)
							])));
			case 11:
				var urlPrefix = msg.a;
				var token = msg.b;
				var device = msg.c;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A4(
								$author$project$Entity$Device$deleteDevice,
								urlPrefix,
								token,
								device.aF,
								$author$project$Pages$CfgDevice$Core$ForceDeleteResp(device)),
								function () {
								var _v18 = $author$project$Entity$Device$getDeviceSocketId(device);
								if (_v18.$ === 1) {
									return $elm$core$Platform$Cmd$none;
								} else {
									var sId = _v18.a;
									return A3($author$project$Interop$Fabric$unicastMessage, sId, 'DEACTIVATE_DEVICE', $elm$json$Json$Encode$null);
								}
							}()
							])));
			case 12:
				if (!msg.b.$) {
					var device = msg.a;
					return _Utils_Tuple2(
						A2($author$project$Pages$CfgDevice$Core$removeDevice, device.aF, model),
						function () {
							var _v19 = $author$project$Entity$Device$getDeviceSocketId(device);
							if (_v19.$ === 1) {
								return $elm$core$Platform$Cmd$none;
							} else {
								var sId = _v19.a;
								return A3($author$project$Interop$Fabric$unicastMessage, sId, 'DEACTIVATE_DEVICE', $elm$json$Json$Encode$null);
							}
						}());
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 13:
				if (!msg.a.$) {
					var data = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ao: $author$project$DataState$Ready(data)
							}),
						$elm$core$Platform$Cmd$batch(
							A2(
								$elm$core$List$map,
								function (d) {
									return $author$project$Pages$CfgDevice$Core$reqAdminConnect(d.aF);
								},
								$elm$core$Dict$values(data))));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ao: $author$project$DataState$Error('Failed to load')
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 14:
				if (msg.a.b.$ === 1) {
					var _v20 = msg.a;
					var devId = _v20.a;
					var _v21 = _v20.b;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var _v22 = msg.a;
					var devId = _v22.a;
					var schdName = _v22.b.a;
					var _v23 = model.ao;
					if (_v23.$ === 4) {
						var devices = _v23.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									ao: $author$project$DataState$Ready(
										A3(
											$elm$core$Dict$update,
											devId,
											function (maybeDev) {
												if (!maybeDev.$) {
													var dev = maybeDev.a;
													return $elm$core$Maybe$Just(
														_Utils_update(
															dev,
															{
																jd: $elm$core$Maybe$Just(schdName)
															}));
												} else {
													return $elm$core$Maybe$Nothing;
												}
											},
											devices))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}
			case 15:
				var devices = msg.a;
				var devices_ = $author$project$DataState$Ready(
					$elm$core$Dict$fromList(
						A2(
							$elm$core$List$map,
							function (dev) {
								return _Utils_Tuple2(
									dev.aF,
									_Utils_update(
										dev,
										{fJ: $author$project$Entity$Device$Offline}));
							},
							devices)));
				return _Utils_Tuple2(
					A2($author$project$Pages$CfgDevice$Core$devicesOfModel.cm, devices_, model),
					$elm$core$Platform$Cmd$none);
			case 16:
				var devices = msg.a;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$map,
							function (d) {
								return $author$project$Pages$CfgDevice$Core$reqAdminConnect(d.aF);
							},
							devices)));
			case 18:
				var devId = msg.a;
				var _v25 = A2(
					function ($) {
						return $.eb;
					},
					$author$project$Pages$CfgDevice$Core$deviceName(devId),
					model);
				if (_v25.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var name = _v25.a;
					return A2(
						$author$project$Pages$CfgDevice$Core$toast,
						'Device ' + (name + ' is Online'),
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				}
			case 19:
				var devId = msg.a;
				var sId = msg.b;
				return _Utils_Tuple2(
					A3(
						function ($) {
							return $.cm;
						},
						$author$project$Pages$CfgDevice$Core$deviceState(devId),
						$author$project$Entity$Device$Online(sId),
						model),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3($author$project$Interop$Fabric$unicastMessage, sId, 'REQ_DEVICE_INFO', $elm$json$Json$Encode$null),
								A2($author$project$Pages$CfgDevice$Schedule$reqCurrentSchedule, devId, sId)
							])));
			case 20:
				var devId = msg.a;
				var showMsg = msg.b;
				var _v26 = A2($author$project$Pages$CfgDevice$Core$nameAndSockId, devId, model);
				if (_v26.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var _v27 = _v26.a;
					var name = _v27.a;
					return A2(
						$author$project$Pages$CfgDevice$Core$toast,
						'Device ' + (name + ' is Offline'),
						_Utils_Tuple2(
							A3(
								function ($) {
									return $.cm;
								},
								$author$project$Pages$CfgDevice$Core$deviceState(devId),
								$author$project$Entity$Device$Offline,
								model),
							$elm$core$Platform$Cmd$none));
				}
			case 17:
				var devId = msg.a;
				var device = msg.b;
				return _Utils_Tuple2(
					A3(
						function ($) {
							return $.cm;
						},
						$author$project$Pages$CfgDevice$Core$deviceState(devId),
						device.fJ,
						model),
					$elm$core$Platform$Cmd$none);
			case 21:
				var _v28 = msg.a;
				var devId = _v28.a;
				var name = _v28.b;
				var school = _v28.c;
				return _Utils_Tuple2(
					A3(
						function ($) {
							return $.cm;
						},
						$author$project$Pages$CfgDevice$Core$deviceSchool(devId),
						school,
						model),
					$elm$core$Platform$Cmd$none);
			default:
				var _v29 = model.ao;
				if (_v29.$ === 4) {
					var devices = _v29.a;
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							A2(
								$elm$core$List$map,
								function (dev) {
									var _v30 = dev.fJ;
									if (!_v30.$) {
										var sId = _v30.a;
										return A2($author$project$Pages$CfgDevice$Schedule$reqCurrentSchedule, dev.aF, sId);
									} else {
										return $elm$core$Platform$Cmd$none;
									}
								},
								$elm$core$Dict$values(devices))));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Pages$Dashboard$ForceDeactivateDevice = $elm$core$Basics$identity;
var $author$project$Pages$Dashboard$ToMain = function (a) {
	return {$: 1, a: a};
};
var $author$project$Interop$Browser$closeSidebar = A2($author$project$Interop$Browser$postMessage, 'CLOSE_SIDEBAR', $elm$json$Json$Encode$null);
var $author$project$Entity$Device$isDeviceOnline = function (device) {
	var _v0 = device.fJ;
	if (!_v0.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$Dashboard$cmdToOnlineDevices = F2(
	function (eventName, devices) {
		return A2(
			$elm$core$List$map,
			function (maybeSockId) {
				if (!maybeSockId.$) {
					var sockId = maybeSockId.a;
					return A3($author$project$Interop$Fabric$unicastMessage, sockId, eventName, $elm$json$Json$Encode$null);
				} else {
					return $elm$core$Platform$Cmd$none;
				}
			},
			A2(
				$elm$core$List$map,
				$author$project$Entity$Device$getDeviceSocketId,
				A2($elm$core$List$filter, $author$project$Entity$Device$isDeviceOnline, devices)));
	});
var $author$project$Pages$Dashboard$resetFilter = {aF: '', g8: 'All Schools'};
var $author$project$Pages$Dashboard$addSnackbar = F2(
	function (message, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var newQueue = A2(
			$aforemny$material_components_web_elm$Material$Snackbar$addMessage,
			$aforemny$material_components_web_elm$Material$Snackbar$message(message),
			model.cp);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{cp: newQueue}),
			cmd);
	});
var $author$project$Pages$Dashboard$toast = F2(
	function (message, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return A2(
			$author$project$Pages$Dashboard$addSnackbar,
			message,
			_Utils_Tuple2(model, cmd));
	});
var $author$project$Pages$Dashboard$update = F3(
	function (key, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 8:
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fQ: A2($author$project$Reusable$Tooltip$update, msg_, model.fQ)
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var name = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bm: name}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var state = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bY: state}),
					$author$project$Interop$Browser$closeSidebar);
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bm: '', aE: $elm$core$Maybe$Nothing, bY: 0}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var school = msg.a;
				return _Utils_eq(school, $author$project$Pages$Dashboard$resetFilter) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{aE: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aE: $elm$core$Maybe$Just(school),
							r: $author$project$Select$init
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var link = msg.a;
				return _Utils_Tuple2(
					model,
					A2($elm$browser$Browser$Navigation$pushUrl, key, link));
			case 6:
				var messageId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cp: A2($aforemny$material_components_web_elm$Material$Snackbar$close, messageId, model.cp)
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (m) {
						return _Utils_update(
							model,
							{r: m});
					},
					A2($author$project$Select$update, msg_, model.r));
			case 10:
				var device = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cW: _Utils_Tuple2(
								true,
								$elm$core$Maybe$Just(device))
						}),
					$elm$core$Platform$Cmd$none);
			case 11:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cW: _Utils_Tuple2(false, $elm$core$Maybe$Nothing)
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var data = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a8: $elm$core$Maybe$Just(data)
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var devices = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cP: _Utils_Tuple2(true, devices)
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cP: _Utils_Tuple2(false, _List_Nil)
						}),
					$elm$core$Platform$Cmd$none);
			case 16:
				var devices = msg.a;
				return A2(
					$author$project$Pages$Dashboard$toast,
					'Sent request to restart online devices',
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								cP: _Utils_Tuple2(false, _List_Nil)
							}),
						$elm$core$Platform$Cmd$batch(
							A2($author$project$Pages$Dashboard$cmdToOnlineDevices, 'RELOAD_DEVICE', devices))));
			case 17:
				var device = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bj: _Utils_Tuple2(
								true,
								$elm$core$Maybe$Just(device)),
							fQ: $author$project$Reusable$Tooltip$init
						}),
					$elm$core$Platform$Cmd$none);
			case 18:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bj: _Utils_Tuple2(false, $elm$core$Maybe$Nothing)
						}),
					$elm$core$Platform$Cmd$none);
			case 19:
				var device = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bj: _Utils_Tuple2(false, $elm$core$Maybe$Nothing)
						}),
					$author$project$Utils$cmd(
						$author$project$Pages$Dashboard$ToMain(device)));
			case 13:
				switch (msg.a.$) {
					case 0:
						var devices = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									cP: _Utils_Tuple2(true, devices),
									a8: $elm$core$Maybe$Nothing
								}),
							$elm$core$Platform$Cmd$none);
					case 2:
						var devices = msg.a.a;
						return A2(
							$author$project$Pages$Dashboard$toast,
							'Requested devices to start backup process',
							_Utils_Tuple2(
								_Utils_update(
									model,
									{a8: $elm$core$Maybe$Nothing}),
								$elm$core$Platform$Cmd$batch(
									A2($author$project$Pages$Dashboard$cmdToOnlineDevices, 'REQ_BACKUP_DEVICE', devices))));
					case 3:
						var devices = msg.a.a;
						return A2(
							$author$project$Pages$Dashboard$toast,
							'Requested devices to reload menu',
							_Utils_Tuple2(
								_Utils_update(
									model,
									{a8: $elm$core$Maybe$Nothing}),
								$elm$core$Platform$Cmd$batch(
									A2($author$project$Pages$Dashboard$cmdToOnlineDevices, 'RELOAD_CURRENT_MENU', devices))));
					default:
						var devices = msg.a.a;
						return A2(
							$author$project$Pages$Dashboard$toast,
							'Sent request to all online devices',
							_Utils_Tuple2(
								_Utils_update(
									model,
									{a8: $elm$core$Maybe$Nothing}),
								$elm$core$Platform$Cmd$batch(
									A2($author$project$Pages$Dashboard$cmdToOnlineDevices, 'SAVE_SERIAL_NUMBER', devices))));
				}
			default:
				return _Utils_Tuple2(model, $author$project$Interop$Browser$openMediaLibrary);
		}
	});
var $author$project$Pages$Faq$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var input = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							d7: $elm$core$Maybe$Just(input)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{d_: true}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{d_: false}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Faqs$update = F2(
	function (msg, model) {
		var input = msg;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					d7: $elm$core$Maybe$Just(input)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Entity$Device$AttemptFailed = {$: 3};
var $author$project$Entity$Device$AttemptingConnect = {$: 2};
var $author$project$Pages$LinkNewDevice$Categories = function (a) {
	return {$: 31, a: a};
};
var $author$project$Pages$LinkNewDevice$DeviceConnect = {$: 12};
var $author$project$Pages$LinkNewDevice$EnterActivationCode = 1;
var $author$project$Pages$LinkNewDevice$NewDeviceActivated = function (a) {
	return {$: 32, a: a};
};
var $author$project$Pages$LinkNewDevice$SelectSchool = 2;
var $author$project$Pages$LinkNewDevice$ServingLines = function (a) {
	return {$: 30, a: a};
};
var $author$project$Pages$LinkNewDevice$addSnackbar = F2(
	function (message, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var newQueue = A2(
			$aforemny$material_components_web_elm$Material$Snackbar$addMessage,
			$aforemny$material_components_web_elm$Material$Snackbar$message(message),
			model.cp);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{cp: newQueue}),
			cmd);
	});
var $author$project$Entity$Device$devicesInSchool = F2(
	function (school, devices) {
		return A2(
			$elm$core$Dict$filter,
			F2(
				function (_v0, device) {
					return _Utils_eq(device.du.aF, school.aF);
				}),
			devices);
	});
var $author$project$Pages$LinkNewDevice$FocusResult = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$LinkNewDevice$domFocus = function (domId) {
	return A2(
		$elm$core$Task$attempt,
		$author$project$Pages$LinkNewDevice$FocusResult,
		$elm$browser$Browser$Dom$focus(domId));
};
var $author$project$Entity$ServingLine$filterLines = function (list) {
	var _v0 = _Utils_Tuple2(
		A2($elm$core$List$member, $author$project$Entity$ServingLine$allServingLinesOption.g8, list),
		$elm$core$List$length(list));
	_v0$0:
	while (true) {
		if (_v0.a) {
			switch (_v0.b) {
				case 0:
					break _v0$0;
				case 1:
					return _List_fromArray(
						[$author$project$Entity$ServingLine$allServingLinesOption.g8]);
				case 2:
					var isFirst = A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$andThen,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$Maybe$Just,
								$elm$core$Basics$eq($author$project$Entity$ServingLine$allServingLinesOption.g8)),
							$elm$core$List$head(list)));
					return (!isFirst) ? A2(
						$elm$core$List$filter,
						function (i) {
							return !_Utils_eq(i, $author$project$Entity$ServingLine$allServingLinesOption.g8);
						},
						list) : _List_fromArray(
						[$author$project$Entity$ServingLine$allServingLinesOption.g8]);
				default:
					return _List_fromArray(
						[$author$project$Entity$ServingLine$allServingLinesOption.g8]);
			}
		} else {
			if (!_v0.b) {
				break _v0$0;
			} else {
				return list;
			}
		}
	}
	return _List_fromArray(
		[$author$project$Entity$ServingLine$allServingLinesOption.g8]);
};
var $author$project$Entity$Device$ActivationPayload = F7(
	function (id, name, school, breakfastCategories, lunchCategories, supperCategories, schedules) {
		return {kP: breakfastCategories, aF: id, lT: lunchCategories, g8: name, mo: schedules, du: school, mO: supperCategories};
	});
var $author$project$Pages$LinkNewDevice$visibleCategories = F2(
	function (hiddenList, orig) {
		return A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeL,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Basics$not,
					function (a) {
						return A2($elm$core$List$member, a, hiddenList);
					}),
				function ($) {
					return $.g8;
				}),
			orig);
	});
var $author$project$Pages$LinkNewDevice$getActivationPayload = function (model) {
	var _v0 = _Utils_Tuple2(
		_Utils_Tuple2(model.iB, model.aC),
		_Utils_Tuple2(model.du, model.eU));
	if ((((!_v0.a.a.$) && (!_v0.a.b.$)) && (!_v0.b.a.$)) && (_v0.b.b.$ === 4)) {
		var _v1 = _v0.a;
		var a = _v1.a.a;
		var b = _v1.b.a;
		var _v2 = _v0.b;
		var c = _v2.a.a;
		var categories = _v2.b.a;
		return A3(
			$elm$core$Basics$composeL,
			$elm$core$Maybe$Just,
			A6(
				$author$project$Entity$Device$ActivationPayload,
				a,
				b.a,
				c,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.g8;
					},
					A2($author$project$Pages$LinkNewDevice$visibleCategories, model.bs, categories)),
				A2(
					$elm$core$List$map,
					function ($) {
						return $.g8;
					},
					A2($author$project$Pages$LinkNewDevice$visibleCategories, model.a3, categories)),
				A2(
					$elm$core$List$map,
					function ($) {
						return $.g8;
					},
					A2($author$project$Pages$LinkNewDevice$visibleCategories, model.bt, categories))),
			$elm$core$Dict$fromList(
				_List_fromArray(
					[
						_Utils_Tuple2('breakfast', model.bR),
						_Utils_Tuple2('lunch', model.b9),
						_Utils_Tuple2('supper', model.ct)
					])));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$LinkNewDevice$inProgress = function (model) {
	return _Utils_update(
		model,
		{aH: true, en: false});
};
var $author$project$Entity$Device$initDevice = F2(
	function (payload, sockId) {
		return {
			aF: payload.aF,
			g8: payload.g8,
			jd: $elm$core$Maybe$Nothing,
			du: payload.du,
			jP: $elm$core$Maybe$Nothing,
			fJ: $author$project$Entity$Device$Online(sockId)
		};
	});
var $author$project$Pages$LinkNewDevice$toIntStep = function (step) {
	switch (step) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 5:
			return 4;
		case 4:
			return 5;
		case 3:
			return 6;
		case 6:
			return 7;
		default:
			return 8;
	}
};
var $author$project$Pages$LinkNewDevice$ActivationStatus = 7;
var $author$project$Pages$LinkNewDevice$NameYourDevice = 5;
var $author$project$Pages$LinkNewDevice$Review = 6;
var $author$project$Pages$LinkNewDevice$SelectCategories = 3;
var $author$project$Pages$LinkNewDevice$SelectServingLines = 4;
var $author$project$Pages$LinkNewDevice$toStepInt = function (step) {
	switch (step) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 5;
		case 5:
			return 4;
		case 6:
			return 3;
		case 7:
			return 6;
		case 8:
			return 7;
		default:
			return 0;
	}
};
var $author$project$Pages$LinkNewDevice$nextStep = function (currentStep) {
	return $author$project$Pages$LinkNewDevice$toStepInt(
		1 + $author$project$Pages$LinkNewDevice$toIntStep(currentStep));
};
var $author$project$Pages$LinkNewDevice$ActivationDone = F2(
	function (a, b) {
		return {$: 29, a: a, b: b};
	});
var $author$project$Pages$LinkNewDevice$postDevice = F3(
	function (urlPrefix, token, payload) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				$elm$http$Http$expectString(
					$author$project$Pages$LinkNewDevice$ActivationDone(payload)),
				A2(
					$author$project$Utils$addAccessToken,
					token,
					A2(
						$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'Id',
									$elm$json$Json$Encode$string(payload.aF)),
									_Utils_Tuple2(
									'Name',
									$elm$json$Json$Encode$string(payload.g8)),
									_Utils_Tuple2(
									'SchoolId',
									$elm$json$Json$Encode$string(payload.du.aF))
								])),
						$lukewestby$elm_http_builder$HttpBuilder$put(urlPrefix + '/api/Device')))));
	});
var $author$project$Pages$LinkNewDevice$prevStep = function (currentStep) {
	return $author$project$Pages$LinkNewDevice$toStepInt(
		function (a) {
			return a - 1;
		}(
			$author$project$Pages$LinkNewDevice$toIntStep(currentStep)));
};
var $author$project$Pages$LinkNewDevice$sendActivationPayload = F3(
	function (model, sockId, payload) {
		return A3(
			$author$project$Interop$Fabric$unicastMessage,
			sockId,
			'ACTIVATE_DEVICE',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(payload.g8)),
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$string(payload.aF)),
						_Utils_Tuple2(
						'school',
						$author$project$Entity$School$encode(payload.du)),
						_Utils_Tuple2(
						'schedules',
						$elm$json$Json$Encode$object(
							A2(
								$elm$core$List$map,
								function (_v0) {
									var k = _v0.a;
									var v = _v0.b;
									return _Utils_Tuple2(
										k,
										$author$project$Entity$Schedule$Core$encode(v));
								},
								$elm$core$Dict$toList(payload.mo)))),
						_Utils_Tuple2(
						'breakfastCategories',
						A2(
							$elm$json$Json$Encode$list,
							$elm$core$Basics$identity,
							A2($elm$core$List$map, $elm$json$Json$Encode$string, payload.kP))),
						_Utils_Tuple2(
						'lunchCategories',
						A2(
							$elm$json$Json$Encode$list,
							$elm$core$Basics$identity,
							A2($elm$core$List$map, $elm$json$Json$Encode$string, payload.lT))),
						_Utils_Tuple2(
						'supperCategories',
						A2(
							$elm$json$Json$Encode$list,
							$elm$core$Basics$identity,
							A2($elm$core$List$map, $elm$json$Json$Encode$string, payload.mO)))
					])));
	});
var $author$project$Pages$LinkNewDevice$takeFirstChar = function (str) {
	return $elm$core$List$head(
		$elm$core$String$toList(
			$elm$core$String$toUpper(str)));
};
var $author$project$Pages$LinkNewDevice$toStringChar = function (maybeChar) {
	if (maybeChar.$ === 1) {
		return '';
	} else {
		var _char = maybeChar.a;
		return $elm$core$String$fromChar(_char);
	}
};
var $author$project$Pages$LinkNewDevice$toStringCode = function (actCode) {
	return _Utils_ap(
		$author$project$Pages$LinkNewDevice$toStringChar(actCode.bZ),
		_Utils_ap(
			$author$project$Pages$LinkNewDevice$toStringChar(actCode.ck),
			_Utils_ap(
				$author$project$Pages$LinkNewDevice$toStringChar(actCode.cy),
				$author$project$Pages$LinkNewDevice$toStringChar(actCode.b_))));
};
var $author$project$Pages$LinkNewDevice$update = F3(
	function (msg, userState, model) {
		switch (msg.$) {
			case 0:
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (m) {
						return _Utils_update(
							model,
							{r: m});
					},
					A2($author$project$Select$update, msg_, model.r));
			case 1:
				var messageId = msg.a;
				var newQueue = A2($aforemny$material_components_web_elm$Material$Snackbar$close, messageId, model.cp);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cp: newQueue}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 3:
				switch (msg.a) {
					case 0:
						var _v1 = msg.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									w: $author$project$Pages$LinkNewDevice$nextStep(model.w)
								}),
							$elm$core$Platform$Cmd$none);
					case 2:
						var _v2 = msg.a;
						return _Utils_Tuple2(
							$author$project$Pages$LinkNewDevice$inProgress(model),
							function () {
								var _v3 = _Utils_Tuple2(model.du, model.A);
								if ((!_v3.a.$) && (!_v3.b.$)) {
									var school = _v3.a.a;
									var sockId = _v3.b.a;
									return A3(
										$author$project$Interop$Fabric$unicastMessage,
										sockId,
										'ACT_SELECT_SCHOOL',
										$author$project$Entity$School$encode(school));
								} else {
									return $elm$core$Platform$Cmd$none;
								}
							}());
					case 3:
						var _v4 = msg.a;
						return _Utils_Tuple2(
							$author$project$Pages$LinkNewDevice$inProgress(model),
							function () {
								var _v5 = _Utils_Tuple2(model.du, model.A);
								if ((!_v5.a.$) && (!_v5.b.$)) {
									var school = _v5.a.a;
									var sockId = _v5.b.a;
									return A3(
										$author$project$Interop$Fabric$unicastMessage,
										sockId,
										'ACT_SELECT_CATEGORIES',
										A2(
											$elm$json$Json$Encode$list,
											$elm$core$Basics$identity,
											A2($elm$core$List$map, $elm$json$Json$Encode$string, model.a3)));
								} else {
									return $elm$core$Platform$Cmd$none;
								}
							}());
					case 4:
						var _v6 = msg.a;
						return _Utils_Tuple2(
							$author$project$Pages$LinkNewDevice$inProgress(model),
							function () {
								var _v7 = model.A;
								if (!_v7.$) {
									var sockId = _v7.a;
									return A3($author$project$Interop$Fabric$unicastMessage, sockId, 'ACT_SELECT_SERVING_LINES', $elm$json$Json$Encode$null);
								} else {
									return $elm$core$Platform$Cmd$none;
								}
							}());
					case 5:
						var _v8 = msg.a;
						return _Utils_Tuple2(
							$author$project$Pages$LinkNewDevice$inProgress(model),
							function () {
								var _v9 = _Utils_Tuple2(model.aC, model.A);
								if ((!_v9.a.$) && (!_v9.b.$)) {
									var sockId = _v9.b.a;
									return A3($author$project$Interop$Fabric$unicastMessage, sockId, 'ACT_SELECT_NAME', $elm$json$Json$Encode$null);
								} else {
									return $elm$core$Platform$Cmd$none;
								}
							}());
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 18:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							w: $author$project$Pages$LinkNewDevice$nextStep(model.w),
							aH: false,
							en: true
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							w: $author$project$Pages$LinkNewDevice$prevStep(model.w)
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var _v10 = model.A;
				if (!_v10.$) {
					var sockId = _v10.a;
					return _Utils_Tuple2(
						$author$project$Pages$LinkNewDevice$init,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3($author$project$Interop$Fabric$unicastMessage, sockId, 'CANCEL_ACTIVATION', $elm$json$Json$Encode$null),
									$author$project$Pages$LinkNewDevice$domFocus('first-act-code')
								])));
				} else {
					return A2(
						$author$project$Pages$LinkNewDevice$addSnackbar,
						'Not connected to any device',
						_Utils_Tuple2(
							$author$project$Pages$LinkNewDevice$init,
							$author$project$Pages$LinkNewDevice$domFocus('first-act-code')));
				}
			case 6:
				var code = msg.a;
				return _Utils_Tuple2(
					function (m) {
						return _Utils_update(
							model,
							{u: m});
					}(
						function (c) {
							return _Utils_update(
								c,
								{
									bZ: $author$project$Pages$LinkNewDevice$takeFirstChar(code)
								});
						}(model.u)),
					$elm$core$String$isEmpty(code) ? $elm$core$Platform$Cmd$none : $author$project$Pages$LinkNewDevice$domFocus('second-act-code'));
			case 7:
				var code = msg.a;
				return _Utils_Tuple2(
					function (m) {
						return _Utils_update(
							model,
							{u: m});
					}(
						function (c) {
							return _Utils_update(
								c,
								{
									ck: $author$project$Pages$LinkNewDevice$takeFirstChar(code)
								});
						}(model.u)),
					$elm$core$String$isEmpty(code) ? $elm$core$Platform$Cmd$none : $author$project$Pages$LinkNewDevice$domFocus('third-act-code'));
			case 8:
				var code = msg.a;
				return _Utils_Tuple2(
					function (m) {
						return _Utils_update(
							model,
							{u: m});
					}(
						function (c) {
							return _Utils_update(
								c,
								{
									cy: $author$project$Pages$LinkNewDevice$takeFirstChar(code)
								});
						}(model.u)),
					$elm$core$String$isEmpty(code) ? $elm$core$Platform$Cmd$none : $author$project$Pages$LinkNewDevice$domFocus('fourth-act-code'));
			case 9:
				var code = msg.a;
				return _Utils_Tuple2(
					function (m) {
						return _Utils_update(
							model,
							{u: m});
					}(
						function (c) {
							return _Utils_update(
								c,
								{
									b_: $author$project$Pages$LinkNewDevice$takeFirstChar(code)
								});
						}(model.u)),
					$author$project$Utils$cmd($author$project$Pages$LinkNewDevice$DeviceConnect));
			case 10:
				switch (msg.a) {
					case 'second-act-code':
						return _Utils_Tuple2(
							model,
							$author$project$Pages$LinkNewDevice$domFocus('first-act-code'));
					case 'third-act-code':
						return _Utils_Tuple2(
							model,
							$author$project$Pages$LinkNewDevice$domFocus('second-act-code'));
					case 'fourth-act-code':
						return _Utils_Tuple2(
							model,
							$author$project$Pages$LinkNewDevice$domFocus('third-act-code'));
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 11:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{u: $author$project$Pages$LinkNewDevice$initActivationCode}),
					$author$project$Pages$LinkNewDevice$domFocus('first-act-code'));
			case 12:
				return ($elm$core$String$length(
					$author$project$Pages$LinkNewDevice$toStringCode(model.u)) !== 4) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{A: $author$project$Entity$Device$AttemptingConnect}),
					A2(
						$author$project$Interop$Fabric$postMessage,
						'REQ_DEVICE_ID',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'activationCode',
									$elm$json$Json$Encode$string(
										$author$project$Pages$LinkNewDevice$toStringCode(model.u))),
									_Utils_Tuple2(
									'adminName',
									A2(
										$elm_community$json_extra$Json$Encode$Extra$maybe,
										$elm$json$Json$Encode$string,
										A2(
											$author$project$Pages$User$get,
											function ($) {
												return $.li;
											},
											userState)))
								]))));
			case 13:
				var deviceId = msg.a;
				var sockId = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							w: 2,
							iB: $elm$core$Maybe$Just(deviceId),
							A: $author$project$Entity$Device$Online(sockId)
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				return A2(
					$author$project$Pages$LinkNewDevice$addSnackbar,
					'Unable to connect with the code provided.',
					_Utils_Tuple2(
						_Utils_update(
							model,
							{A: $author$project$Entity$Device$AttemptFailed}),
						$elm$core$Platform$Cmd$none));
			case 15:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 16:
				if (msg.a.$ === 1) {
					return A2(
						$author$project$Pages$LinkNewDevice$addSnackbar,
						'Failed to connect with the device.',
						_Utils_Tuple2(
							_Utils_update(
								model,
								{iB: $elm$core$Maybe$Nothing, A: $author$project$Entity$Device$AttemptFailed}),
							$elm$core$Platform$Cmd$none));
				} else {
					var _v11 = msg.a.a;
					var sockId = _v11.b;
					if (userState.$ === 4) {
						var user = userState.a;
						return A2(
							$author$project$Pages$LinkNewDevice$addSnackbar,
							'Successfully connected with the device.',
							_Utils_Tuple2(
								_Utils_update(
									model,
									{u: $author$project$Pages$LinkNewDevice$initActivationCode, w: 2}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[$author$project$Local$Commands$Browser$scrollToTop]))));
					} else {
						return A2(
							$author$project$Pages$LinkNewDevice$addSnackbar,
							'User is not logged in.',
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
					}
				}
			case 17:
				return A2(
					$author$project$Pages$LinkNewDevice$addSnackbar,
					'Device just unexpectedly went offline',
					_Utils_Tuple2(
						_Utils_update(
							model,
							{u: $author$project$Pages$LinkNewDevice$initActivationCode, w: 1, A: $author$project$Entity$Device$Offline, aH: false}),
						$author$project$Pages$LinkNewDevice$domFocus('first-act-code')));
			case 19:
				var urlPrefix = msg.a;
				var school = msg.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bR: A2(
								$author$project$Entity$Schedule$Defaults$initBreakfast,
								_List_fromArray(
									[$author$project$Entity$ServingLine$allServingLinesOption.g8]),
								_List_Nil),
							eU: $author$project$DataState$Loading(''),
							bs: _List_Nil,
							a3: _List_Nil,
							bt: _List_Nil,
							b9: A2(
								$author$project$Entity$Schedule$Defaults$initLunch,
								_List_fromArray(
									[$author$project$Entity$ServingLine$allServingLinesOption.g8]),
								_List_Nil),
							du: $elm$core$Maybe$Just(school),
							jR: $author$project$DataState$Loading(''),
							ct: A2(
								$author$project$Entity$Schedule$Defaults$initSupper,
								_List_fromArray(
									[$author$project$Entity$ServingLine$allServingLinesOption.g8]),
								_List_Nil)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3($author$project$Entity$ServingLine$loadData, urlPrefix, school, $author$project$Pages$LinkNewDevice$ServingLines),
								A3($author$project$Entity$MealCategory$loadData, urlPrefix, school, $author$project$Pages$LinkNewDevice$Categories)
							])));
			case 20:
				var servingLines = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bR: function (a) {
								return A2($author$project$Entity$Schedule$Defaults$initBreakfast, a, _List_Nil);
							}(
								$author$project$Entity$ServingLine$filterLines(servingLines))
						}),
					$elm$core$Platform$Cmd$none);
			case 21:
				var servingLines = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							b9: function (a) {
								return A2($author$project$Entity$Schedule$Defaults$initLunch, a, _List_Nil);
							}(
								$author$project$Entity$ServingLine$filterLines(servingLines))
						}),
					$elm$core$Platform$Cmd$none);
			case 22:
				var servingLines = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ct: function (a) {
								return A2($author$project$Entity$Schedule$Defaults$initSupper, a, _List_Nil);
							}(
								$author$project$Entity$ServingLine$filterLines(servingLines))
						}),
					$elm$core$Platform$Cmd$none);
			case 23:
				var list = msg.a;
				var category = msg.b;
				return A2($elm$core$List$member, category.g8, list) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bs: A2(
								$elm$core$List$filter,
								function (i) {
									return !_Utils_eq(category.g8, i);
								},
								list)
						}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bs: A2($elm$core$List$cons, category.g8, list)
						}),
					$elm$core$Platform$Cmd$none);
			case 24:
				var list = msg.a;
				var category = msg.b;
				return A2($elm$core$List$member, category.g8, list) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a3: A2(
								$elm$core$List$filter,
								function (i) {
									return !_Utils_eq(category.g8, i);
								},
								list)
						}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a3: A2($elm$core$List$cons, category.g8, list)
						}),
					$elm$core$Platform$Cmd$none);
			case 25:
				var list = msg.a;
				var category = msg.b;
				return A2($elm$core$List$member, category.g8, list) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bt: A2(
								$elm$core$List$filter,
								function (i) {
									return !_Utils_eq(category.g8, i);
								},
								list)
						}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bt: A2($elm$core$List$cons, category.g8, list)
						}),
					$elm$core$Platform$Cmd$none);
			case 26:
				if (!msg.a.$) {
					var school = msg.a.a;
					var devices = msg.b;
					var name = msg.c;
					var deviceNames = $elm$core$Set$fromList(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.g8;
							},
							$elm$core$Dict$values(
								A2($author$project$Entity$Device$devicesInSchool, school, devices))));
					return A2($elm$core$Set$member, name, deviceNames) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aC: $elm$core$Maybe$Just(
									_Utils_Tuple2(name, name + ' already exists in this location'))
							}),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aC: $elm$core$Maybe$Just(
									_Utils_Tuple2(name, ''))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var _v13 = msg.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 27:
				var maybePayload = msg.a;
				var _v14 = _Utils_Tuple2(maybePayload, model.A);
				_v14$3:
				while (true) {
					if (!_v14.a.$) {
						if (!_v14.b.$) {
							var payload = _v14.a.a;
							var sockId = _v14.b.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{aH: true}),
								A3($author$project$Pages$LinkNewDevice$sendActivationPayload, model, sockId, payload));
						} else {
							break _v14$3;
						}
					} else {
						switch (_v14.b.$) {
							case 0:
								var _v15 = _v14.a;
								var sockId = _v14.b.a;
								return A2(
									$author$project$Pages$LinkNewDevice$addSnackbar,
									'Insufficient data to make a request',
									_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
							case 1:
								var _v16 = _v14.a;
								var _v17 = _v14.b;
								return A2(
									$author$project$Pages$LinkNewDevice$addSnackbar,
									'Device is offline',
									_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
							default:
								break _v14$3;
						}
					}
				}
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 28:
				var flags = msg.a;
				var token = msg.b;
				var _v18 = $author$project$Pages$LinkNewDevice$getActivationPayload(model);
				if (_v18.$ === 1) {
					return A2(
						$author$project$Pages$LinkNewDevice$addSnackbar,
						'Invalid payload',
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				} else {
					var payload = _v18.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aH: true}),
						A3($author$project$Pages$LinkNewDevice$postDevice, flags.an, token, payload));
				}
			case 29:
				if (!msg.b.$) {
					var payload = msg.a;
					var _v19 = model.A;
					switch (_v19.$) {
						case 1:
							return A2(
								$author$project$Pages$LinkNewDevice$addSnackbar,
								'Device is Offline',
								_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
						case 0:
							var sockId = _v19.a;
							return _Utils_Tuple2(
								$author$project$Pages$LinkNewDevice$init,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Utils$cmd(
											$author$project$Pages$LinkNewDevice$NewDeviceActivated(
												A2($author$project$Entity$Device$initDevice, payload, sockId))),
											A3($author$project$Interop$Fabric$unicastMessage, sockId, 'SAVE_SERIAL_NUMBER', $elm$json$Json$Encode$null),
											A3($author$project$Interop$Fabric$unicastMessage, sockId, 'REQ_BACKUP_DEVICE', $elm$json$Json$Encode$null)
										])));
						default:
							return A2(
								$author$project$Pages$LinkNewDevice$addSnackbar,
								'Device not ready',
								_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
					}
				} else {
					var payload = msg.a;
					return A2(
						$author$project$Pages$LinkNewDevice$addSnackbar,
						'Failed to Activate, Try again',
						_Utils_Tuple2(
							_Utils_update(
								model,
								{aH: false}),
							$elm$core$Platform$Cmd$none));
				}
			case 32:
				var device = msg.a;
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 30:
				if (!msg.a.$) {
					var list = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								jR: $author$project$DataState$Ready(list)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								jR: $author$project$DataState$Error('Unable to load list')
							}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				if (!msg.a.$) {
					var list = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								eU: $author$project$DataState$Ready(list)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								eU: $author$project$DataState$Error('Unable to load list')
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Pages$MenuItemList$AddNewItem = F4(
	function (a, b, c, d) {
		return {$: 30, a: a, b: b, c: c, d: d};
	});
var $author$project$Pages$MenuItemList$RefreshMenuItemList = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$MenuItemList$RespAddNewList = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$MenuItemList$RespConfirmItem = F2(
	function (a, b) {
		return {$: 39, a: a, b: b};
	});
var $author$project$Pages$MenuItemList$RespConfirmListName = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Pages$MenuItemList$RespDelMenuItem = F2(
	function (a, b) {
		return {$: 37, a: a, b: b};
	});
var $author$project$Pages$MenuItemList$RespDelMenuItemList = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Pages$MenuItemList$RespDupList = F3(
	function (a, b, c) {
		return {$: 17, a: a, b: b, c: c};
	});
var $author$project$Pages$MenuItemList$RespNewItem = F2(
	function (a, b) {
		return {$: 31, a: a, b: b};
	});
var $author$project$Pages$MenuItemList$StoreMenuItemList = function (a) {
	return {$: 24, a: a};
};
var $elm$http$Http$stringBody = _Http_pair;
var $lukewestby$elm_http_builder$HttpBuilder$withStringBody = F2(
	function (contentType, value) {
		return $lukewestby$elm_http_builder$HttpBuilder$withBody(
			A2($elm$http$Http$stringBody, contentType, value));
	});
var $lukewestby$elm_http_builder$HttpBuilder$withUrlEncodedBody = function (parts) {
	var encoded = $elm$url$Url$Builder$toQuery(
		A2(
			$elm$core$List$map,
			function (_v0) {
				var l = _v0.a;
				var r = _v0.b;
				return A2($elm$url$Url$Builder$string, l, r);
			},
			parts));
	var trimmedQuestionMark = A2($elm$core$String$startsWith, '?', encoded) ? A2($elm$core$String$dropLeft, 1, encoded) : encoded;
	return A2($lukewestby$elm_http_builder$HttpBuilder$withStringBody, 'application/x-www-form-urlencoded', trimmedQuestionMark);
};
var $author$project$Entity$MenuItemList$deleteMenuItem = F4(
	function (urlPrefix, token, menuItem, toMsg) {
		var url = A3(
			$elm$url$Url$Builder$crossOrigin,
			urlPrefix,
			_List_fromArray(
				['api', 'DeleteMenuItem']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'MenuItemId', menuItem.aF)
				]));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				$elm$http$Http$expectString(toMsg),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withUrlEncodedBody,
					_List_Nil,
					A2(
						$author$project$Utils$addAccessToken,
						token,
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $author$project$Entity$MenuItemList$deleteMenuItemList = F4(
	function (urlPrefix, token, listId, toMsg) {
		var url = A3(
			$elm$url$Url$Builder$crossOrigin,
			urlPrefix,
			_List_fromArray(
				['api', 'DeleteMenuItemList']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'MenuItemListId', listId)
				]));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				$elm$http$Http$expectString(toMsg),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withUrlEncodedBody,
					_List_Nil,
					A2(
						$author$project$Utils$addAccessToken,
						token,
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $author$project$Pages$MenuItemList$getMenuItem = function (model) {
	var _v0 = _Utils_Tuple3(model.B, model.bF, model.g1);
	if (((!_v0.a.$) && (!_v0.b.$)) && (_v0.c.$ === 4)) {
		var listId = _v0.a.a;
		var itemId = _v0.b.a;
		var data = _v0.c.a;
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.lM;
				},
				$elm$core$Dict$get(itemId)),
			A2($elm$core$Dict$get, listId, data));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$MenuItemList$getMenuItemList = function (model) {
	var _v0 = _Utils_Tuple2(model.B, model.g1);
	if ((!_v0.a.$) && (_v0.b.$ === 4)) {
		var listId = _v0.a.a;
		var data = _v0.b.a;
		return A2($elm$core$Dict$get, listId, data);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$String$toLower = _String_toLower;
var $elm$core$String$trim = _String_trim;
var $author$project$Pages$MenuItemList$uniqFunc = A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$toLower);
var $author$project$Pages$MenuItemList$isItemNameUnique = F2(
	function (newName, model) {
		var _v0 = _Utils_Tuple2(model.B, model.g1);
		if ((!_v0.a.$) && (_v0.b.$ === 4)) {
			var listId = _v0.a.a;
			var data = _v0.b.a;
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$andThen,
					function (list) {
						return $elm$core$Maybe$Just(
							!A2(
								$elm$core$List$any,
								function (item) {
									return _Utils_eq(
										$author$project$Pages$MenuItemList$uniqFunc(item.g8),
										$author$project$Pages$MenuItemList$uniqFunc(newName));
								},
								A2(
									$elm$core$List$filter,
									function (item) {
										var _v1 = model.bF;
										if (!_v1.$) {
											var itemId = _v1.a;
											return !_Utils_eq(item.aF, itemId);
										} else {
											return true;
										}
									},
									$elm$core$Dict$values(list.lM))));
					},
					A2($elm$core$Dict$get, listId, data)));
		} else {
			return false;
		}
	});
var $author$project$Pages$MenuItemList$isListNameUnique = F2(
	function (newName, model) {
		var _v0 = model.g1;
		if (_v0.$ === 4) {
			var itemLists = _v0.a;
			return !A2(
				$elm$core$List$any,
				function (list) {
					return _Utils_eq(
						$author$project$Pages$MenuItemList$uniqFunc(list.g8),
						$author$project$Pages$MenuItemList$uniqFunc(newName));
				},
				A2(
					$elm$core$List$filter,
					function (list) {
						var _v1 = model.B;
						if (!_v1.$) {
							var listId = _v1.a;
							return !_Utils_eq(list.aF, listId);
						} else {
							return true;
						}
					},
					$elm$core$Dict$values(itemLists)));
		} else {
			return false;
		}
	});
var $author$project$Entity$MenuItemList$postMenuItem = F4(
	function (urlPrefix, token, menuItem, toMsg) {
		var url = A3(
			$elm$url$Url$Builder$crossOrigin,
			urlPrefix,
			_List_fromArray(
				['api', 'MenuItemList', 'MenuItem']),
			_List_Nil);
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				$elm$http$Http$expectString(toMsg),
				A2(
					$author$project$Utils$addAccessToken,
					token,
					A2(
						$lukewestby$elm_http_builder$HttpBuilder$withUrlEncodedBody,
						_List_fromArray(
							[
								_Utils_Tuple2('menuItemListId', menuItem.i7),
								_Utils_Tuple2('menuItemId', menuItem.aF),
								_Utils_Tuple2('menuItemName', menuItem.g8),
								_Utils_Tuple2(
								'price',
								$elm$core$String$fromFloat(menuItem.ju)),
								_Utils_Tuple2(
								'index',
								$elm$core$String$fromInt(menuItem.iX))
							]),
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $author$project$Entity$MenuItemList$postMenuItemList = F4(
	function (urlPrefix, accessToken, list, toMsg) {
		var url = A3(
			$elm$url$Url$Builder$crossOrigin,
			urlPrefix,
			_List_fromArray(
				['api', 'MenuItemList']),
			_List_Nil);
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				$elm$http$Http$expectString(toMsg),
				A2(
					$author$project$Utils$addAccessToken,
					accessToken,
					A2(
						$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'MenuItemListId',
									$elm$json$Json$Encode$string(list.aF)),
									_Utils_Tuple2(
									'MenuItemListName',
									$elm$json$Json$Encode$string(list.g8))
								])),
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (c !== '0') && (c !== '.');
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (head === '9') {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 1) {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				'0',
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $elm$core$String$reverse = _String_reverse;
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3($elm$core$String$padRight, e + 1, '0', total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var signed = fl < 0;
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					'0',
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3($elm$core$String$padRight, s, '0', after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 1) {
				return false;
			} else {
				if ('5' === _v0.a.a) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $author$project$Pages$MenuItemList$update = F3(
	function (urlPrefix, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 2:
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (m) {
						return _Utils_update(
							model,
							{r: m});
					},
					A2($author$project$Select$update, msg_, model.r));
			case 3:
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fQ: A2($author$project$Reusable$Tooltip$update, msg_, model.fQ)
						}),
					$elm$core$Platform$Cmd$none);
			case 22:
				var itemList = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							B: $elm$core$Maybe$Just(itemList.aF)
						}),
					A3($author$project$Entity$MenuItemList$loadList, urlPrefix, itemList.aF, $author$project$Pages$MenuItemList$StoreMenuItemList));
			case 6:
				var accessToken = msg.a;
				var name = msg.b;
				var _v1 = A2($elm$random$Random$step, $danyx23$elm_uuid$Uuid$uuidGenerator, model.jM);
				var uuid = _v1.a;
				var newSeed = _v1.b;
				var newMenuItemList = {
					aF: $danyx23$elm_uuid$Uuid$toString(uuid),
					lM: $elm$core$Dict$empty,
					g8: name
				};
				var _v2 = model.g1;
				if (_v2.$ === 4) {
					var data = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bN: false,
								g1: $author$project$DataState$Ready(
									A3(
										$elm$core$Dict$insert,
										$danyx23$elm_uuid$Uuid$toString(uuid),
										newMenuItemList,
										data)),
								jM: newSeed
							}),
						A4(
							$author$project$Entity$MenuItemList$postMenuItemList,
							urlPrefix,
							accessToken,
							newMenuItemList,
							$author$project$Pages$MenuItemList$RespAddNewList(
								$danyx23$elm_uuid$Uuid$toString(uuid))));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 7:
				if (!msg.b.$) {
					var listId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bN: false,
								E: _Utils_Tuple2('', $elm$core$Maybe$Nothing),
								B: $elm$core$Maybe$Just(listId)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var listId = msg.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 8:
				var name = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cZ: true,
							E: _Utils_Tuple2(name, $elm$core$Maybe$Nothing)
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cZ: false,
							E: _Utils_Tuple2('', $elm$core$Maybe$Nothing)
						}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var name = msg.a;
				var currentListName = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.g8;
							},
							$elm$core$Maybe$Just),
						$author$project$Pages$MenuItemList$getMenuItemList(model)));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: $elm$core$String$isEmpty(name) ? _Utils_Tuple2(
								name,
								$elm$core$Maybe$Just('Name cannot be empty')) : (_Utils_eq(currentListName, name) ? _Utils_Tuple2(
								name,
								$elm$core$Maybe$Just('This is the current name')) : ((!A2($author$project$Pages$MenuItemList$isListNameUnique, name, model)) ? _Utils_Tuple2(
								name,
								$elm$core$Maybe$Just(name + ' is not available')) : _Utils_Tuple2(name, $elm$core$Maybe$Nothing)))
						}),
					$elm$core$Platform$Cmd$none);
			case 11:
				if (!msg.b.$) {
					var token = msg.a;
					var menuItemList = msg.b.a;
					return _Utils_Tuple2(
						model,
						A4(
							$author$project$Entity$MenuItemList$postMenuItemList,
							urlPrefix,
							token,
							_Utils_update(
								menuItemList,
								{g8: model.E.a}),
							$author$project$Pages$MenuItemList$RespConfirmListName(menuItemList.aF)));
				} else {
					var token = msg.a;
					var _v3 = msg.b;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 12:
				if (!msg.b.$) {
					var listId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cZ: false,
								E: _Utils_Tuple2('', $elm$core$Maybe$Nothing)
							}),
						$author$project$Utils$cmd(
							$author$project$Pages$MenuItemList$RefreshMenuItemList(listId)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 26:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cE: true,
							V: _Utils_Tuple2('', $elm$core$Maybe$Nothing),
							at: _Utils_Tuple2('0.00', $elm$core$Maybe$Nothing)
						}),
					$elm$core$Platform$Cmd$none);
			case 27:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cE: false,
							V: _Utils_Tuple2('', $elm$core$Maybe$Nothing),
							at: _Utils_Tuple2('0.00', $elm$core$Maybe$Nothing)
						}),
					$elm$core$Platform$Cmd$none);
			case 30:
				var token = msg.a;
				var listId = msg.b;
				var index = msg.c;
				var _v4 = msg.d;
				var name = _v4.a;
				var price = _v4.b;
				var _v5 = A2($elm$random$Random$step, $danyx23$elm_uuid$Uuid$uuidGenerator, model.jM);
				var uuid = _v5.a;
				var newSeed = _v5.b;
				var menuItem = {
					aF: $danyx23$elm_uuid$Uuid$toString(uuid),
					iX: index,
					i7: listId,
					g8: name,
					ju: price
				};
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cE: false, jM: newSeed}),
					A4(
						$author$project$Entity$MenuItemList$postMenuItem,
						urlPrefix,
						token,
						menuItem,
						$author$project$Pages$MenuItemList$RespNewItem(listId)));
			case 31:
				if (!msg.b.$) {
					var listId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								V: _Utils_Tuple2('', $elm$core$Maybe$Nothing),
								at: _Utils_Tuple2('0.00', $elm$core$Maybe$Nothing)
							}),
						$author$project$Utils$cmd(
							$author$project$Pages$MenuItemList$RefreshMenuItemList(listId)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 35:
				var itemId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cS: true,
							bF: $elm$core$Maybe$Just(itemId)
						}),
					$elm$core$Platform$Cmd$none);
			case 36:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cS: false, bF: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 38:
				var token = msg.a;
				var menuItem = msg.b;
				return _Utils_Tuple2(
					model,
					A4(
						$author$project$Entity$MenuItemList$deleteMenuItem,
						urlPrefix,
						token,
						menuItem,
						$author$project$Pages$MenuItemList$RespDelMenuItem(menuItem.i7)));
			case 37:
				if (!msg.b.$) {
					var listId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cS: false}),
						$author$project$Utils$cmd(
							$author$project$Pages$MenuItemList$RefreshMenuItemList(listId)));
				} else {
					var listId = msg.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 28:
				var itemName = msg.a;
				var currentItemName = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.g8;
							},
							$elm$core$Maybe$Just),
						$author$project$Pages$MenuItemList$getMenuItem(model)));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							V: $elm$core$String$isEmpty(itemName) ? _Utils_Tuple2(
								itemName,
								$elm$core$Maybe$Just('Name cannot be empty')) : (_Utils_eq(currentItemName, itemName) ? _Utils_Tuple2(
								itemName,
								$elm$core$Maybe$Just('This is the current item name')) : ((!A2($author$project$Pages$MenuItemList$isItemNameUnique, itemName, model)) ? _Utils_Tuple2(
								itemName,
								$elm$core$Maybe$Just(itemName + ' is already in the list')) : _Utils_Tuple2(itemName, $elm$core$Maybe$Nothing)))
						}),
					$elm$core$Platform$Cmd$none);
			case 32:
				var item = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: true,
							V: _Utils_Tuple2(item.g8, $elm$core$Maybe$Nothing),
							at: _Utils_Tuple2(
								A2($myrho$elm_round$Round$round, 2, item.ju),
								$elm$core$Maybe$Nothing),
							bF: $elm$core$Maybe$Just(item.aF)
						}),
					$elm$core$Platform$Cmd$none);
			case 33:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: false,
							V: _Utils_Tuple2('', $elm$core$Maybe$Nothing),
							at: _Utils_Tuple2('0.00', $elm$core$Maybe$Nothing),
							bF: $elm$core$Maybe$Nothing
						}),
					$elm$core$Platform$Cmd$none);
			case 34:
				var token = msg.a;
				var menuItem = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: false}),
					A4(
						$author$project$Entity$MenuItemList$postMenuItem,
						urlPrefix,
						token,
						menuItem,
						$author$project$Pages$MenuItemList$RespConfirmItem(menuItem.i7)));
			case 39:
				if (!msg.b.$) {
					var listId = msg.a;
					return _Utils_Tuple2(
						model,
						$author$project$Utils$cmd(
							$author$project$Pages$MenuItemList$RefreshMenuItemList(listId)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 29:
				var price = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							at: function () {
								var _v6 = $elm$core$String$toFloat(price);
								if (!_v6.$) {
									var val = _v6.a;
									return (val <= 0) ? _Utils_Tuple2(
										price,
										$elm$core$Maybe$Just('Price cannot be 0 or negative')) : _Utils_Tuple2(price, $elm$core$Maybe$Nothing);
								} else {
									return _Utils_Tuple2(
										price,
										$elm$core$Maybe$Just('Invalid price'));
								}
							}()
						}),
					$elm$core$Platform$Cmd$none);
			case 23:
				var listId = msg.a;
				return _Utils_Tuple2(
					model,
					A3($author$project$Entity$MenuItemList$loadList, urlPrefix, listId, $author$project$Pages$MenuItemList$StoreMenuItemList));
			case 24:
				if (!msg.a.$) {
					var itemList = msg.a.a;
					var _v7 = model.g1;
					if (_v7.$ === 4) {
						var data = _v7.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									g1: $author$project$DataState$Ready(
										A3($elm$core$Dict$insert, itemList.aF, itemList, data))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 13:
				var devices = msg.a;
				var listId = msg.b;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$map,
							function (maybeSockId) {
								if (!maybeSockId.$) {
									var sockId = maybeSockId.a;
									return A3(
										$author$project$Interop$Fabric$unicastMessage,
										sockId,
										'RELOAD_MENU_ITEM_LIST',
										$elm$json$Json$Encode$string(listId));
								} else {
									return $elm$core$Platform$Cmd$none;
								}
							},
							A2($elm$core$List$map, $author$project$Entity$Device$getDeviceSocketId, devices))));
			case 14:
				var itemList = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cX: true,
							E: _Utils_Tuple2(itemList.g8 + '- Duplicate', $elm$core$Maybe$Nothing)
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cX: false,
							E: _Utils_Tuple2('', $elm$core$Maybe$Nothing)
						}),
					$elm$core$Platform$Cmd$none);
			case 16:
				var accessToken = msg.a;
				var itemList = msg.b;
				var _v9 = A2($elm$random$Random$step, $danyx23$elm_uuid$Uuid$uuidGenerator, model.jM);
				var uuid = _v9.a;
				var newSeed = _v9.b;
				var newItemList = _Utils_update(
					itemList,
					{
						aF: $danyx23$elm_uuid$Uuid$toString(uuid)
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cX: false, jM: newSeed}),
					A4(
						$author$project$Entity$MenuItemList$postMenuItemList,
						urlPrefix,
						accessToken,
						newItemList,
						A2($author$project$Pages$MenuItemList$RespDupList, accessToken, newItemList)));
			case 17:
				if (!msg.c.$) {
					var token = msg.a;
					var itemList = msg.b;
					var newItemsCmd = $elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$map,
							function (_v11) {
								var item = _v11.b;
								return $author$project$Utils$cmd(
									A4(
										$author$project$Pages$MenuItemList$AddNewItem,
										token,
										itemList.aF,
										0,
										_Utils_Tuple2(item.g8, item.ju)));
							},
							$elm$core$Dict$toList(itemList.lM)));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								g1: function () {
									var _v10 = model.g1;
									if (_v10.$ === 4) {
										var data = _v10.a;
										return $author$project$DataState$Ready(
											A3($elm$core$Dict$insert, itemList.aF, itemList, data));
									} else {
										return model.g1;
									}
								}(),
								B: $elm$core$Maybe$Just(itemList.aF)
							}),
						newItemsCmd);
				} else {
					var token = msg.a;
					var itemList = msg.b;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bN: true}),
					$elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bN: false,
							E: _Utils_Tuple2('', $elm$core$Maybe$Nothing)
						}),
					$elm$core$Platform$Cmd$none);
			case 18:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cT: true}),
					$elm$core$Platform$Cmd$none);
			case 21:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cT: false}),
					$elm$core$Platform$Cmd$none);
			case 19:
				var token = msg.a;
				var listId = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{B: $elm$core$Maybe$Nothing}),
					A4(
						$author$project$Entity$MenuItemList$deleteMenuItemList,
						urlPrefix,
						token,
						listId,
						$author$project$Pages$MenuItemList$RespDelMenuItemList(listId)));
			case 20:
				if (!msg.b.$) {
					var listId = msg.a;
					var _v12 = model.g1;
					if (_v12.$ === 4) {
						var data = _v12.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									cT: false,
									g1: $author$project$DataState$Ready(
										A2($elm$core$Dict$remove, listId, data))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					var listId = msg.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				if (!msg.a.$) {
					var data = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								g1: $author$project$DataState$Ready(data)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								g1: $author$project$DataState$Error('Server Error')
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Local$Commands$Browser$closeSidebar = A2($author$project$Interop$Browser$postMessage, 'CLOSE_SIDEBAR', $elm$json$Json$Encode$null);
var $author$project$Pages$SyncDevices$isDeviceOnline = function (device) {
	var _v0 = device.fJ;
	if (!_v0.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$SyncDevices$getTargets = F2(
	function (model, devices) {
		var modelIds = A2(
			$elm$core$List$map,
			function ($) {
				return $.aF;
			},
			model.X);
		return A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			A2(
				$elm$core$List$map,
				function (dev) {
					var _v0 = dev.fJ;
					if (!_v0.$) {
						var sockId = _v0.a;
						return sockId;
					} else {
						return '';
					}
				},
				A2(
					$elm$core$List$filter,
					$author$project$Pages$SyncDevices$isDeviceOnline,
					A2(
						$elm$core$List$filter,
						function (dev) {
							return A2($elm$core$List$member, dev.aF, modelIds);
						},
						$elm$core$Dict$values(devices)))));
	});
var $author$project$Pages$SyncDevices$initStatus = function (model) {
	return {
		e1: model.bc ? $author$project$DataState$init : $author$project$DataState$loading(''),
		fH: model.bd ? $author$project$DataState$init : $author$project$DataState$loading(''),
		fK: model.be ? $author$project$DataState$init : $author$project$DataState$loading('')
	};
};
var $author$project$Pages$SyncDevices$update = F4(
	function (key, devices, msg, model) {
		switch (msg.$) {
			case 1:
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (m) {
						return _Utils_update(
							model,
							{r: m});
					},
					A2($author$project$Select$update, msg_, model.r));
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 2:
				var school = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							X: _List_Nil,
							ar: $elm$core$Maybe$Nothing,
							dw: $elm$core$Maybe$Just(school),
							ak: $elm$core$Dict$empty
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var device = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							X: _List_Nil,
							ar: $elm$core$Maybe$Just(device),
							dw: $elm$core$Maybe$Just(device.du),
							ak: $elm$core$Dict$empty
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Routing$navigateTo, key, $author$project$Routing$SyncDevicesPage),
								$author$project$Local$Commands$Browser$scrollToTop,
								$author$project$Local$Commands$Browser$closeSidebar
							])));
			case 4:
				var device = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							X: _List_Nil,
							ar: $elm$core$Maybe$Just(device)
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var exportTo = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{X: exportTo}),
					$elm$core$Platform$Cmd$none);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bc: !model.bc}),
					$elm$core$Platform$Cmd$none);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bd: !model.bd}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{be: !model.be}),
					$elm$core$Platform$Cmd$none);
			case 9:
				if (!msg.a.$) {
					var device = msg.a.a;
					var _v1 = device.fJ;
					if (!_v1.$) {
						var sockId = _v1.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									bk: _Utils_Tuple2(false, $elm$core$Maybe$Nothing),
									ar: $elm$core$Maybe$Just(device),
									ak: $elm$core$Dict$fromList(
										A2(
											$elm$core$List$map,
											function (dev) {
												return _Utils_Tuple2(
													A2(
														$elm$core$Maybe$withDefault,
														'',
														$author$project$Entity$Device$getDeviceSocketId(dev)),
													_Utils_Tuple2(
														dev.g8,
														$author$project$Pages$SyncDevices$initStatus(model)));
											},
											model.X))
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										model.bc ? A3($author$project$Interop$Fabric$unicastMessage, sockId, 'IMPORT_TEMPLATES', $elm$json$Json$Encode$null) : $elm$core$Platform$Cmd$none,
										model.bd ? A3($author$project$Interop$Fabric$unicastMessage, sockId, 'IMPORT_SCHEDULES', $elm$json$Json$Encode$null) : $elm$core$Platform$Cmd$none,
										model.be ? A3($author$project$Interop$Fabric$unicastMessage, sockId, 'IMPORT_STATUS_BAR_THEME', $elm$json$Json$Encode$null) : $elm$core$Platform$Cmd$none
									])));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					var _v2 = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bk: _Utils_Tuple2(false, $elm$core$Maybe$Nothing)
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 10:
				var templates = msg.a;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$map,
							function (sockId) {
								return A3(
									$author$project$Interop$Fabric$unicastMessage,
									sockId,
									'SYNC_TEMPLATES',
									A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Template$Core$encode, templates));
							},
							A2($author$project$Pages$SyncDevices$getTargets, model, devices))));
			case 12:
				var theme = msg.a;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$map,
							function (sockId) {
								return A3(
									$author$project$Interop$Fabric$unicastMessage,
									sockId,
									'SYNC_STATUS_BAR_THEME',
									$author$project$Entity$StatusBarTheme$encode(theme));
							},
							A2($author$project$Pages$SyncDevices$getTargets, model, devices))));
			case 11:
				var schedules = msg.a;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$map,
							function (sockId) {
								return A3(
									$author$project$Interop$Fabric$unicastMessage,
									sockId,
									'SYNC_SCHEDULES',
									A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Entity$Schedule$Core$encode, schedules));
							},
							A2($author$project$Pages$SyncDevices$getTargets, model, devices))));
			case 13:
				var sockId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ak: A3(
								$elm$core$Dict$update,
								sockId,
								function (maybeV) {
									if (!maybeV.$) {
										var _v4 = maybeV.a;
										var name = _v4.a;
										var status = _v4.b;
										return $elm$core$Maybe$Just(
											_Utils_Tuple2(
												name,
												_Utils_update(
													status,
													{
														e1: $author$project$DataState$ready(true)
													})));
									} else {
										return $elm$core$Maybe$Nothing;
									}
								},
								model.ak)
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var sockId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ak: A3(
								$elm$core$Dict$update,
								sockId,
								function (maybeV) {
									if (!maybeV.$) {
										var _v6 = maybeV.a;
										var name = _v6.a;
										var status = _v6.b;
										return $elm$core$Maybe$Just(
											_Utils_Tuple2(
												name,
												_Utils_update(
													status,
													{
														fH: $author$project$DataState$ready(true)
													})));
									} else {
										return $elm$core$Maybe$Nothing;
									}
								},
								model.ak)
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var sockId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ak: A3(
								$elm$core$Dict$update,
								sockId,
								function (maybeV) {
									if (!maybeV.$) {
										var _v8 = maybeV.a;
										var name = _v8.a;
										var status = _v8.b;
										return $elm$core$Maybe$Just(
											_Utils_Tuple2(
												name,
												_Utils_update(
													status,
													{
														fK: $author$project$DataState$ready(true)
													})));
									} else {
										return $elm$core$Maybe$Nothing;
									}
								},
								model.ak)
						}),
					$elm$core$Platform$Cmd$none);
			case 16:
				return _Utils_Tuple2($author$project$Pages$SyncDevices$init, $elm$core$Platform$Cmd$none);
			case 17:
				var maybeDev = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bk: _Utils_Tuple2(true, maybeDev)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bk: _Utils_Tuple2(false, $elm$core$Maybe$Nothing)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$User$ClearUserData = {$: 1};
var $author$project$Pages$User$LoadUserData = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$User$LoadedDistricts = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$User$LoginUserDone = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$User$SuperSelectDistrict = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$User$ToMain = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$User$ValidateExpiryTime = F3(
	function (a, b, c) {
		return {$: 12, a: a, b: b, c: c};
	});
var $author$project$Pages$User$VerifyUserAccess = function (a) {
	return {$: 8, a: a};
};
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $author$project$Pages$User$expectUser = function (responseStr) {
	switch (responseStr.$) {
		case 0:
			var url = responseStr.a;
			return $elm$core$Result$Err(
				$elm$http$Http$BadUrl(url));
		case 1:
			return $elm$core$Result$Err($elm$http$Http$Timeout);
		case 2:
			return $elm$core$Result$Err($elm$http$Http$NetworkError);
		case 3:
			var metadata = responseStr.a;
			var body = responseStr.b;
			var _v1 = A2(
				$elm$json$Json$Decode$decodeString,
				A2($elm$json$Json$Decode$field, 'error_description', $elm$json$Json$Decode$string),
				body);
			if (!_v1.$) {
				var errString = _v1.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadBody(errString));
			} else {
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.mJ));
			}
		default:
			var metadata = responseStr.a;
			var body = responseStr.b;
			var _v2 = A2($elm$json$Json$Decode$decodeString, $author$project$Pages$User$userDecoder, body);
			if (!_v2.$) {
				var user = _v2.a;
				return $elm$core$Result$Ok(user);
			} else {
				var err = _v2.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadBody(
						$elm$json$Json$Decode$errorToString(err)));
			}
	}
};
var $author$project$Pages$User$authorizeUser = F3(
	function (urlPrefix, userName, password) {
		var url = A3(
			$elm$url$Url$Builder$crossOrigin,
			urlPrefix,
			_List_fromArray(
				['token']),
			_List_Nil);
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectStringResponse, $author$project$Pages$User$VerifyUserAccess, $author$project$Pages$User$expectUser),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withUrlEncodedBody,
					_List_fromArray(
						[
							_Utils_Tuple2(
							'username',
							A2($elm$core$Maybe$withDefault, '', userName)),
							_Utils_Tuple2(
							'password',
							A2($elm$core$Maybe$withDefault, '', password)),
							_Utils_Tuple2('grant_type', 'password')
						]),
					$lukewestby$elm_http_builder$HttpBuilder$post(url))));
	});
var $author$project$Pages$User$accessLevelEncoder = function (accessLevel) {
	switch (accessLevel) {
		case 3:
			return $elm$json$Json$Encode$string('4');
		case 2:
			return $elm$json$Json$Encode$string('3');
		case 0:
			return $elm$json$Json$Encode$string('1');
		case 1:
			return $elm$json$Json$Encode$string('2');
		default:
			return $elm$json$Json$Encode$string('100');
	}
};
var $author$project$Pages$User$setUserState = function (payload) {
	return A2($author$project$Interop$Browser$postMessage, 'SET_USER_STATE', payload);
};
var $author$project$Pages$User$cacheUser = function (user) {
	return $author$project$Pages$User$setUserState(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'UserId',
					function () {
						var _v0 = user.j8;
						if (!_v0.$) {
							var id = _v0.a;
							return $elm$json$Json$Encode$string(
								$elm$core$String$fromInt(id));
						} else {
							return $elm$json$Json$Encode$null;
						}
					}()),
					_Utils_Tuple2(
					'userName',
					$elm$json$Json$Encode$string(user.ax)),
					_Utils_Tuple2(
					'FirstName',
					$elm$json$Json$Encode$string(user.li)),
					_Utils_Tuple2(
					'AccessLevel',
					$author$project$Pages$User$accessLevelEncoder(user.h4)),
					_Utils_Tuple2(
					'access_token',
					$elm$json$Json$Encode$string(user.h5)),
					_Utils_Tuple2(
					'.issued',
					$elm$json$Json$Encode$string(user.i0)),
					_Utils_Tuple2(
					'.expires',
					$elm$json$Json$Encode$string(user.e4)),
					_Utils_Tuple2(
					'ISDId',
					$elm$json$Json$Encode$string(user.iC.aF)),
					_Utils_Tuple2(
					'DistrictName',
					$elm$json$Json$Encode$string(user.iC.g8)),
					_Utils_Tuple2(
					'Email',
					$elm$json$Json$Encode$string(user.iD))
				])));
};
var $justinmimbs$date$Date$compare = F2(
	function (_v0, _v1) {
		var a = _v0;
		var b = _v1;
		return A2($elm$core$Basics$compare, a, b);
	});
var $justinmimbs$time_extra$Time$Extra$Second = 14;
var $justinmimbs$time_extra$Time$Extra$Day = 11;
var $justinmimbs$time_extra$Time$Extra$Millisecond = 15;
var $justinmimbs$time_extra$Time$Extra$Month = 2;
var $justinmimbs$time_extra$Time$Extra$Week = 3;
var $justinmimbs$date$Date$Day = 11;
var $justinmimbs$date$Date$Friday = 8;
var $justinmimbs$date$Date$Monday = 4;
var $justinmimbs$date$Date$Month = 2;
var $justinmimbs$date$Date$Quarter = 1;
var $justinmimbs$date$Date$Saturday = 9;
var $justinmimbs$date$Date$Sunday = 10;
var $justinmimbs$date$Date$Thursday = 7;
var $justinmimbs$date$Date$Tuesday = 5;
var $justinmimbs$date$Date$Wednesday = 6;
var $justinmimbs$date$Date$Week = 3;
var $justinmimbs$date$Date$Year = 0;
var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(
	function (wd, date) {
		return A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
	});
var $justinmimbs$date$Date$firstOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + 1;
	});
var $justinmimbs$date$Date$quarterToMonth = function (q) {
	return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
};
var $justinmimbs$date$Date$floor = F2(
	function (interval, date) {
		var rd = date;
		switch (interval) {
			case 0:
				return $justinmimbs$date$Date$firstOfYear(
					$justinmimbs$date$Date$year(date));
			case 1:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$quarterToMonth(
						$justinmimbs$date$Date$quarter(date)));
			case 2:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$month(date));
			case 3:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 4:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 5:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 1, date);
			case 6:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 2, date);
			case 7:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 3, date);
			case 8:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 4, date);
			case 9:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 5, date);
			case 10:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 6, date);
			default:
				return date;
		}
	});
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
	var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
	return daysSinceEpoch * 86400000;
};
var $justinmimbs$time_extra$Time$Extra$timeFromClock = F4(
	function (hour, minute, second, millisecond) {
		return (((hour * 3600000) + (minute * 60000)) + (second * 1000)) + millisecond;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2(
	function (zone, posix) {
		return A4(
			$justinmimbs$time_extra$Time$Extra$timeFromClock,
			A2($elm$time$Time$toHour, zone, posix),
			A2($elm$time$Time$toMinute, zone, posix),
			A2($elm$time$Time$toSecond, zone, posix),
			A2($elm$time$Time$toMillis, zone, posix));
	});
var $justinmimbs$time_extra$Time$Extra$toOffset = F2(
	function (zone, posix) {
		var millis = $elm$time$Time$posixToMillis(posix);
		var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix);
		return ((localMillis - millis) / 60000) | 0;
	});
var $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3(
	function (zone, date, time) {
		var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
		var offset0 = A2(
			$justinmimbs$time_extra$Time$Extra$toOffset,
			zone,
			$elm$time$Time$millisToPosix(millis));
		var posix1 = $elm$time$Time$millisToPosix(millis - (offset0 * 60000));
		var offset1 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix1);
		if (_Utils_eq(offset0, offset1)) {
			return posix1;
		} else {
			var posix2 = $elm$time$Time$millisToPosix(millis - (offset1 * 60000));
			var offset2 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix2);
			return _Utils_eq(offset1, offset2) ? posix2 : posix1;
		}
	});
var $justinmimbs$time_extra$Time$Extra$floorDate = F3(
	function (dateInterval, zone, posix) {
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A2(
				$justinmimbs$date$Date$floor,
				dateInterval,
				A2($justinmimbs$date$Date$fromPosix, zone, posix)),
			0);
	});
var $justinmimbs$time_extra$Time$Extra$floor = F3(
	function (interval, zone, posix) {
		switch (interval) {
			case 15:
				return posix;
			case 14:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						A2($elm$time$Time$toSecond, zone, posix),
						0));
			case 13:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						0,
						0));
			case 12:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						0,
						0,
						0));
			case 11:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 11, zone, posix);
			case 2:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 2, zone, posix);
			case 0:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 0, zone, posix);
			case 1:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 1, zone, posix);
			case 3:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 3, zone, posix);
			case 4:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 4, zone, posix);
			case 5:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 5, zone, posix);
			case 6:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 6, zone, posix);
			case 7:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 7, zone, posix);
			case 8:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 8, zone, posix);
			case 9:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 9, zone, posix);
			default:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 10, zone, posix);
		}
	});
var $justinmimbs$time_extra$Time$Extra$toFractionalDay = F2(
	function (zone, posix) {
		return A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix) / 86400000;
	});
var $justinmimbs$time_extra$Time$Extra$toMonths = F2(
	function (zone, posix) {
		var wholeMonths = (12 * (A2($elm$time$Time$toYear, zone, posix) - 1)) + ($justinmimbs$date$Date$monthToNumber(
			A2($elm$time$Time$toMonth, zone, posix)) - 1);
		var fractionalMonth = (A2($elm$time$Time$toDay, zone, posix) + A2($justinmimbs$time_extra$Time$Extra$toFractionalDay, zone, posix)) / 100;
		return wholeMonths + fractionalMonth;
	});
var $justinmimbs$time_extra$Time$Extra$toRataDieMoment = F2(
	function (zone, posix) {
		return $justinmimbs$date$Date$toRataDie(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$toFractionalDay, zone, posix);
	});
var $justinmimbs$time_extra$Time$Extra$diff = F4(
	function (interval, zone, posix1, posix2) {
		diff:
		while (true) {
			switch (interval) {
				case 15:
					return $elm$time$Time$posixToMillis(posix2) - $elm$time$Time$posixToMillis(posix1);
				case 14:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 15, zone, posix1, posix2) / 1000) | 0;
				case 13:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 15, zone, posix1, posix2) / 60000) | 0;
				case 12:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 15, zone, posix1, posix2) / 3600000) | 0;
				case 11:
					return (A2($justinmimbs$time_extra$Time$Extra$toRataDieMoment, zone, posix2) - A2($justinmimbs$time_extra$Time$Extra$toRataDieMoment, zone, posix1)) | 0;
				case 2:
					return (A2($justinmimbs$time_extra$Time$Extra$toMonths, zone, posix2) - A2($justinmimbs$time_extra$Time$Extra$toMonths, zone, posix1)) | 0;
				case 0:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 2, zone, posix1, posix2) / 12) | 0;
				case 1:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 2, zone, posix1, posix2) / 3) | 0;
				case 3:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 11, zone, posix1, posix2) / 7) | 0;
				default:
					var weekday = interval;
					var $temp$interval = 3,
						$temp$zone = zone,
						$temp$posix1 = A3($justinmimbs$time_extra$Time$Extra$floor, weekday, zone, posix1),
						$temp$posix2 = A3($justinmimbs$time_extra$Time$Extra$floor, weekday, zone, posix2);
					interval = $temp$interval;
					zone = $temp$zone;
					posix1 = $temp$posix1;
					posix2 = $temp$posix2;
					continue diff;
			}
		}
	});
var $author$project$Pages$User$computeExpiryInterval = F2(
	function (now, exp) {
		return A4($justinmimbs$time_extra$Time$Extra$diff, 14, $elm$time$Time$utc, now, exp);
	});
var $author$project$Entity$District$districtDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'Value',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'Text',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Entity$District$District)));
var $author$project$Entity$District$getDistricts = F3(
	function (urlPrefix, accessToken, toMsg) {
		var url = A3(
			$elm$url$Url$Builder$crossOrigin,
			urlPrefix,
			_List_fromArray(
				['api', 'GetAllDistictList']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'onlyActive', 'true')
				]));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2(
					$elm$http$Http$expectJson,
					toMsg,
					$elm$json$Json$Decode$list($author$project$Entity$District$districtDecoder)),
				A2(
					$author$project$Utils$addAccessToken,
					accessToken,
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Pages$User$toExpiryDate = function (user) {
	var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(user.e4);
	if (!_v0.$) {
		var time = _v0.a;
		return $elm$core$Result$Ok(
			_Utils_Tuple2(user, time));
	} else {
		return $elm$core$Result$Err('Unable to parse expiry time');
	}
};
var $author$project$Pages$User$toUser = function (model) {
	var _v0 = model.eK;
	if (_v0.$ === 4) {
		var user = _v0.a;
		return $elm$core$Result$Ok(user);
	} else {
		return $elm$core$Result$Err('User not ready');
	}
};
var $author$project$Pages$User$getExpiryTime = function (model) {
	return A2(
		$elm$core$Result$andThen,
		$author$project$Pages$User$toExpiryDate,
		$author$project$Pages$User$toUser(model));
};
var $author$project$Pages$User$resetConnection = A2($author$project$Interop$Browser$postMessage, 'RESET_CONNECTION', $elm$json$Json$Encode$null);
var $author$project$Pages$User$updateAfterLoginFail = F2(
	function (error, model) {
		var err = function () {
			switch (error.$) {
				case 3:
					var code = error.a;
					return 'Authorization failed, with code:' + $elm$core$String$fromInt(code);
				case 2:
					return 'Network Unavailable';
				case 1:
					return 'Request timed out, try again';
				case 4:
					var msg = error.a;
					return msg;
				default:
					var url = error.a;
					return 'URL does not exist';
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					eK: $author$project$DataState$Error(err)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Entity$Font$availableFonts = _List_fromArray(
	['Abel', 'Alex Brush', 'Allan', 'Annie Use Your Telescope', 'Architects Daughter', 'Armata', 'Barrio', 'Bungee Hairline', 'Bungee Inline', 'Bungee Shade', 'Cabin', 'Cabin Condensed', 'Cabin Sketch', 'Caesar Dressing', 'Carme', 'Chewy', 'Clicker Script', 'Comfortaa', 'Crafty Girls', 'Cuprum', 'Delius Unicase', 'Dancing Script', 'Didact Gothic', 'Economica', 'Ewert', 'Exo', 'Exo 2', 'Fascinate', 'Fascinate Inline', 'Faster One', 'Finger Paint', 'Fjalla One', 'Fredericka the Great', 'Geostar Fill', 'Geostar', 'Geo', 'EB Garamond', 'Give You Glory', 'Gloria Hallelujah', 'Griffy', 'Gruppo', 'Hanalei', 'Inconsolata', 'Indie Flower', 'Josefin Sans', 'Josefin Slab', 'Julius Sans One', 'Jura', 'Kalam', 'Karla', 'La Belle Aurore', 'Lemonada', 'Lilita One', 'Medula One', 'Megrim', 'Monofett', 'Monoton', 'Montez', 'Montserrat', 'Nova Mono', 'Nova Flat', 'Nova Slim', 'Nova Round', 'Oregano', 'Poiret One', 'Righteous', 'Roboto', 'Roboto Condensed', 'Roboto Slab', 'Roboto Mono', 'Seaweed Script', 'Sigmar One', 'Slackey', 'Special Elite', 'Squada One', 'Tenali Ramakrishna', 'Unica One', 'Quicksand', 'Yanone Kaffeesatz', 'Teko', 'Catamaran', 'Orbitron', 'Monda', 'Passero One']);
var $author$project$Entity$Font$webfontPayload = A2(
	$elm$json$Json$Encode$list,
	$elm$core$Basics$identity,
	A2(
		$elm$core$List$map,
		$elm$json$Json$Encode$string,
		A2(
			$elm$core$List$map,
			function (a) {
				return a + ':100,400,700';
			},
			$author$project$Entity$Font$availableFonts)));
var $author$project$Pages$User$update = F4(
	function (key, urlPrefix, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (m) {
						return _Utils_update(
							model,
							{r: m});
					},
					A2($author$project$Select$update, msg_, model.r));
			case 2:
				var msg_ = msg.a;
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 3:
				var name = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ax: $elm$core$Maybe$Just(name)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var pass = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dr: $elm$core$Maybe$Just(pass)
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dt: !model.dt}),
					$elm$core$Platform$Cmd$none);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{co: !model.co}),
					$elm$core$Platform$Cmd$none);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eK: $author$project$DataState$Loading('')
						}),
					A3($author$project$Pages$User$authorizeUser, urlPrefix, model.ax, model.dr));
			case 8:
				if (!msg.a.$) {
					var user = msg.a.a;
					return A2(
						$elm$core$List$member,
						user.h4,
						_List_fromArray(
							[2, 3])) ? _Utils_Tuple2(
						model,
						$author$project$Utils$cmd(
							$author$project$Pages$User$LoginUserDone(user))) : _Utils_Tuple2(
						_Utils_update(
							model,
							{
								eK: $author$project$DataState$Error('Unauthorized')
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return A2($author$project$Pages$User$updateAfterLoginFail, err, model);
				}
			case 9:
				var user = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cG: $author$project$DataState$loading('Started loading'),
							dr: $elm$core$Maybe$Nothing,
							co: false,
							ax: $elm$core$Maybe$Just(user.ax),
							eK: $author$project$DataState$Ready(user)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								model.dt ? $author$project$Pages$User$cacheUser(user) : $elm$core$Platform$Cmd$none,
								$author$project$Pages$User$resetConnection,
								A2($author$project$Interop$Browser$postMessage, 'LOAD_FONTS', $author$project$Entity$Font$webfontPayload),
								A2($author$project$Interop$Browser$postMessage, 'INIT_WATCHDOG', $elm$json$Json$Encode$null),
								$author$project$Utils$cmd(
								$author$project$Pages$User$ToMain(
									$author$project$Pages$User$LoadUserData(user))),
								(user.h4 === 3) ? $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3($author$project$Entity$District$getDistricts, urlPrefix, user.h5, $author$project$Pages$User$LoadedDistricts),
										$author$project$Utils$cmd(
										$author$project$Pages$User$ToMain(
											A2(
												$author$project$Pages$User$SuperSelectDistrict,
												user,
												{aF: '1599', g8: 'SCHOOLCAFE TEST'})))
									])) : $elm$core$Platform$Cmd$none
							])));
			case 10:
				var user = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eK: $author$project$DataState$Ready(user)
						}),
					A2(
						$author$project$Interop$Browser$postMessage,
						'PARSE_EXPIRY_DATE',
						$elm$json$Json$Encode$string(user.e4)));
			case 11:
				var isoDate = msg.a;
				return _Utils_Tuple2(
					model,
					function () {
						var _v1 = model.eK;
						if (_v1.$ === 4) {
							var user = _v1.a;
							return A2(
								$elm$core$Result$withDefault,
								$elm$core$Platform$Cmd$none,
								A2(
									$elm$core$Result$andThen,
									function (a) {
										return $elm$core$Result$Ok(
											A2($elm$core$Task$perform, a, $elm$time$Time$now));
									},
									A2(
										$elm$core$Result$andThen,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Pages$User$ValidateExpiryTime(user),
											$elm$core$Result$Ok),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(isoDate))));
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 12:
				var user = msg.a;
				var expTime = msg.b;
				var now = msg.c;
				var nowDate = A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, now);
				var expDate = A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, expTime);
				var _v2 = A2($justinmimbs$date$Date$compare, expDate, nowDate);
				if (_v2 === 2) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								e3: $elm$core$Maybe$Just(
									A2($author$project$Pages$User$computeExpiryInterval, now, expTime))
							}),
						$author$project$Utils$cmd(
							$author$project$Pages$User$VerifyUserAccess(
								$elm$core$Result$Ok(user))));
				} else {
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$perform,
							$elm$core$Basics$identity,
							$elm$core$Task$succeed($author$project$Pages$User$LogoutUser)));
				}
			case 13:
				return _Utils_Tuple2(
					model,
					function () {
						var _v3 = $author$project$Pages$User$getExpiryTime(model);
						if (!_v3.$) {
							var _v4 = _v3.a;
							var user = _v4.a;
							var expTime = _v4.b;
							return function (a) {
								return A2($elm$core$Task$perform, a, $elm$time$Time$now);
							}(
								A2($author$project$Pages$User$ValidateExpiryTime, user, expTime));
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 15:
				return _Utils_Tuple2(
					$author$project$Pages$User$init,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Interop$Browser$postMessage, 'LOGOUT_USER', $elm$json$Json$Encode$null),
								A2($author$project$Routing$navigateTo, key, $author$project$Routing$DashboardPage),
								$author$project$Utils$cmd(
								$author$project$Pages$User$ToMain($author$project$Pages$User$ClearUserData))
							])));
			case 14:
				return _Utils_Tuple2(
					model,
					A2($author$project$Routing$navigateTo, key, $author$project$Routing$UserPage));
			case 16:
				if (!msg.a.$) {
					var allDistricts = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cG: $author$project$DataState$ready(allDistricts)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cG: $author$project$DataState$error('Unable to load')
							}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				var user = msg.a;
				var district = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ew: $elm$core$Maybe$Just(district)
						}),
					$author$project$Utils$cmd(
						$author$project$Pages$User$ToMain(
							A2($author$project$Pages$User$SuperSelectDistrict, user, district))));
		}
	});
var $author$project$Routing$update = F2(
	function (msg, model) {
		if (msg.$ === 1) {
			var urlRequest = msg.a;
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var url = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dq: $author$project$Routing$parseUrl(url),
						nj: url
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (c) {
						return A2($elm$core$Platform$Cmd$map, $author$project$Main$RouteMsg, c);
					},
					A2(
						$elm$core$Tuple$mapFirst,
						function (m) {
							return _Utils_update(
								model,
								{I: m});
						},
						A2($author$project$Routing$update, msg_, model.I)));
			case 2:
				var page = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aB: $author$project$Pages$Dashboard$refreshDashboard(model.aB),
							as: (model.W === 2) ? true : false
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$browser$Browser$Navigation$pushUrl,
								model.I.b4,
								$author$project$Routing$reversePage(page)),
								$author$project$Local$Commands$Browser$scrollToTop
							])));
			case 7:
				var msg_ = msg.a;
				var _v1 = A2($author$project$Pages$Faq$update, msg_, model.d5);
				var updatedFaq = _v1.a;
				var faqCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{d5: updatedFaq, $7: true}),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$FaqMsg, faqCmd));
			case 8:
				var msg_ = msg.a;
				var _v2 = A2($author$project$Pages$Faqs$update, msg_, model.d6);
				var updatedFaq = _v2.a;
				var faqsCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{d6: updatedFaq}),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$FaqsMsg, faqsCmd));
			case 3:
				var viewport = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							as: function () {
								if (viewport === 2) {
									return true;
								} else {
									return false;
								}
							}(),
							W: viewport
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b3: !model.b3}),
					$elm$core$Platform$Cmd$none);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{as: !model.as}),
					$elm$core$Platform$Cmd$none);
			case 9:
				if (msg.a.$ === 2) {
					switch (msg.a.a.$) {
						case 0:
							var user = msg.a.a.a;
							return _Utils_Tuple2(
								model,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Local$Commands$Browser$scrollToTop,
											A4($author$project$Entity$School$getSchools, model.k.an, user.h5, user.iC, $author$project$Main$SchoolsData),
											A4($author$project$Pages$CfgDevice$Core$loadDevices, model.k.an, user.h5, $elm$core$Maybe$Nothing, $author$project$Main$CfgDeviceMsg),
											A2(
											$elm$core$Platform$Cmd$map,
											$author$project$Main$MenuItemListMsg,
											A2($author$project$Pages$MenuItemList$loadData, model.k.an, user.h5)),
											_Utils_eq(model.I.dq, $author$project$Routing$LoginPage) ? A2($author$project$Routing$navigateTo, model.I.b4, $author$project$Routing$DashboardPage) : $elm$core$Platform$Cmd$none,
											$author$project$Dialogs$ReleaseNotes$getStoredVersion
										])));
						case 2:
							var _v4 = msg.a.a;
							var user = _v4.a;
							var district = _v4.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										K: $author$project$Pages$CfgDevice$Core$setLoadingDevices(model.K)
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A4($author$project$Entity$School$getSchools, model.k.an, user.h5, district, $author$project$Main$SchoolsData),
											A4(
											$author$project$Pages$CfgDevice$Core$loadDevices,
											model.k.an,
											user.h5,
											$elm$core$Maybe$Just(district),
											$author$project$Main$CfgDeviceMsg),
											A2(
											$elm$core$Platform$Cmd$map,
											$author$project$Main$MenuItemListMsg,
											A2($author$project$Pages$MenuItemList$loadData, model.k.an, user.h5))
										])));
						default:
							var _v5 = msg.a.a;
							return A3($author$project$Main$initModel, model.k, model.I.nj, model.I.b4);
					}
				} else {
					var msg_ = msg.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						function (c) {
							return A2($elm$core$Platform$Cmd$map, $author$project$Main$UserMsg, c);
						},
						A2(
							$elm$core$Tuple$mapFirst,
							function (m) {
								return _Utils_update(
									model,
									{j7: m});
							},
							A4($author$project$Pages$User$update, model.I.b4, model.k.an, msg_, model.j7)));
				}
			case 10:
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aD: A2($author$project$FabricStatus$update, msg_, model.aD)
						}),
					$elm$core$Platform$Cmd$none);
			case 11:
				if (msg.a.$ === 1) {
					var dev = msg.a.a;
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$LiveCaptureMsg,
							$author$project$Dialogs$LiveCapture$startLiveCapture(dev)));
				} else {
					var msg_ = msg.a;
					var _v6 = $author$project$Pages$User$getDistrictId(model.j7);
					if (!_v6.$) {
						var districtId = _v6.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							function (c) {
								return A2($elm$core$Platform$Cmd$map, $author$project$Main$CfgDeviceMsg, c);
							},
							A2(
								$elm$core$Tuple$mapFirst,
								function (m) {
									return _Utils_update(
										model,
										{
											K: m,
											aB: $author$project$Pages$Dashboard$refreshDashboard(model.aB)
										});
								},
								A6($author$project$Pages$CfgDevice$Core$update, model.k.fT, '', districtId, model.I.b4, msg_, model.K)));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}
			case 13:
				if (msg.a.$ === 32) {
					var device = msg.a.a;
					var _v7 = A2(
						$author$project$Pages$User$get,
						function ($) {
							return $.h5;
						},
						model.j7.eK);
					if (!_v7.$) {
						var token = _v7.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									K: A2($author$project$Pages$CfgDevice$Core$addDevice, device, model.K)
								}),
							$author$project$Utils$cmd(
								$author$project$Main$CfgDeviceMsg(
									A3($author$project$Pages$CfgDevice$Core$ConfigureDevice, model.k.an, token, device))));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					var msg_ = msg.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						function (c) {
							return A2($elm$core$Platform$Cmd$map, $author$project$Main$LinkNewDeviceMsg, c);
						},
						A2(
							$elm$core$Tuple$mapFirst,
							function (m) {
								return _Utils_update(
									model,
									{ce: m});
							},
							A3($author$project$Pages$LinkNewDevice$update, msg_, model.j7.eK, model.ce)));
				}
			case 14:
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (cmd_) {
						return A2($elm$core$Platform$Cmd$map, $author$project$Main$MenuItemListMsg, cmd_);
					},
					A2(
						$elm$core$Tuple$mapFirst,
						function (u) {
							return _Utils_update(
								model,
								{cb: u});
						},
						A3($author$project$Pages$MenuItemList$update, model.k.an, msg_, model.cb)));
			case 15:
				var msg_ = msg.a;
				var _v8 = model.K.ao;
				if (_v8.$ === 4) {
					var devices = _v8.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						function (cmd_) {
							return A2($elm$core$Platform$Cmd$map, $author$project$Main$SyncDevicesMsg, cmd_);
						},
						A2(
							$elm$core$Tuple$mapFirst,
							function (u) {
								return _Utils_update(
									model,
									{cu: u});
							},
							A4($author$project$Pages$SyncDevices$update, model.I.b4, devices, msg_, model.cu)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 12:
				if (msg.a.$ === 1) {
					var device = msg.a.a;
					return _Utils_Tuple2(
						model,
						function () {
							var _v9 = $author$project$Pages$User$getAccessToken(model.j7);
							if (!_v9.$) {
								var token = _v9.a;
								return $author$project$Utils$cmd(
									$author$project$Main$CfgDeviceMsg(
										A3($author$project$Pages$CfgDevice$Core$ForceDeleteDevice, model.k.an, token, device)));
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}());
				} else {
					var msg_ = msg.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						function (cmd_) {
							return A2($elm$core$Platform$Cmd$map, $author$project$Main$DashboardMsg, cmd_);
						},
						A2(
							$elm$core$Tuple$mapFirst,
							function (u) {
								return _Utils_update(
									model,
									{aB: u});
							},
							A3($author$project$Pages$Dashboard$update, model.I.b4, msg_, model.aB)));
				}
			case 17:
				if (!msg.a.$) {
					var data = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aQ: $author$project$DataState$Ready(data)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aQ: $author$project$DataState$Error('Unable to load')
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 18:
				var msg_ = msg.a;
				var _v10 = A2($author$project$Dialogs$LiveCapture$update, msg_, model.de);
				var model_ = _v10.a;
				var cmd_ = _v10.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{de: model_}),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$LiveCaptureMsg, cmd_));
			case 16:
				return _Utils_Tuple2(
					model,
					A2($elm$core$Platform$Cmd$map, $author$project$Main$ReleaseNotesMsg, $author$project$Dialogs$ReleaseNotes$openReleaseNotes));
			case 19:
				var msg_ = msg.a;
				var _v11 = A3($author$project$Dialogs$ReleaseNotes$update, model.k, msg_, model.ds);
				var model_ = _v11.a;
				var cmd_ = _v11.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{$7: true, ds: model_}),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$ReleaseNotesMsg, cmd_));
			case 20:
				var msg_ = msg.a;
				var _v12 = $author$project$Pages$User$getDistrictId(model.j7);
				if (!_v12.$) {
					var districtId = _v12.a;
					var _v13 = A3(
						$author$project$Dialogs$Gallery$update,
						_Utils_Tuple2(model.k.fT, districtId),
						msg_,
						model.c3);
					var model_ = _v13.a;
					var cmd_ = _v13.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{c3: model_}),
						A2($elm$core$Platform$Cmd$map, $author$project$Main$GalleryMsg, cmd_));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 21:
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dT: A2($author$project$Dialogs$ContactUs$update, msg_, model.dT),
							$7: true
						}),
					$elm$core$Platform$Cmd$none);
			case 22:
				var messageId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cp: A2($aforemny$material_components_web_elm$Material$Snackbar$close, messageId, model.cp)
						}),
					$elm$core$Platform$Cmd$none);
			case 23:
				var message = msg.a;
				return A2(
					$author$project$Main$toast,
					message,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			default:
				var width = msg.a;
				var height = msg.b;
				var _v14 = A2(
					$author$project$Main$getViewport,
					model.W,
					{gH: height, hY: width});
				if (!_v14.$) {
					var newViewport = _v14.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{as: newViewport === 2, W: newViewport}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Main$ContactUsMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Dialogs$ContactUs$OpenDialog = 0;
var $author$project$Pages$Faq$OpenDialog = {$: 1};
var $author$project$Main$SnackbarClosed = function (a) {
	return {$: 22, a: a};
};
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $aforemny$material_components_web_elm$Material$Snackbar$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Snackbar$config = function (_v0) {
	var onClosed = _v0.l1;
	return {fZ: _List_Nil, ga: false, l1: onClosed};
};
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$Main$sideSectionWrapper = function (node) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('side-section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('side-section-items')
					]),
				_List_fromArray(
					[node]))
			]));
};
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $aforemny$material_components_web_elm$Material$Snackbar$closeOnEscapeProp = function (_v0) {
	var closeOnEscape = _v0.ga;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'closeOnEscape',
			$elm$json$Json$Encode$bool(closeOnEscape)));
};
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $aforemny$material_components_web_elm$Material$Snackbar$closedHandler = F2(
	function (messageId, _v0) {
		var onClosed = _v0.l1;
		return $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$Events$on,
				'MDCSnackbar:closed',
				$elm$json$Json$Decode$succeed(
					onClosed(messageId))));
	});
var $aforemny$material_components_web_elm$Material$Snackbar$leadingCs = function (message_) {
	return A2(
		$elm$core$Maybe$andThen,
		function (_v0) {
			var leading = _v0.gX;
			return leading ? $elm$core$Maybe$Just(
				$elm$html$Html$Attributes$class('mdc-snackbar--leading')) : $elm$core$Maybe$Nothing;
		},
		message_);
};
var $aforemny$material_components_web_elm$Material$Snackbar$messageIdProp = function (_v0) {
	var messageId = _v0;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'messageId',
			$elm$json$Json$Encode$int(messageId)));
};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $aforemny$material_components_web_elm$Material$Snackbar$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-snackbar'));
var $aforemny$material_components_web_elm$Material$Snackbar$stackedCs = function (message_) {
	return A2(
		$elm$core$Maybe$andThen,
		function (_v0) {
			var stacked = _v0.hI;
			return stacked ? $elm$core$Maybe$Just(
				$elm$html$Html$Attributes$class('mdc-snackbar--stacked')) : $elm$core$Maybe$Nothing;
		},
		message_);
};
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $aforemny$material_components_web_elm$Material$Snackbar$actionButtonClickHandler = F2(
	function (messageId, _v0) {
		var onActionButtonClick = _v0.hc;
		return A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$html$Html$Events$onClick,
				$elm$core$Basics$apR(messageId)),
			onActionButtonClick);
	});
var $aforemny$material_components_web_elm$Material$Snackbar$actionButtonCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-button mdc-snackbar__action'));
var $elm$html$Html$button = _VirtualDom_node('button');
var $aforemny$material_components_web_elm$Material$Snackbar$actionButtonElt = F2(
	function (messageId, message_) {
		var actionButton = message_.fW;
		return A2(
			$elm$core$Maybe$map,
			function (actionButtonLabel) {
				return A2(
					$elm$html$Html$button,
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$aforemny$material_components_web_elm$Material$Snackbar$actionButtonCs,
								A2($aforemny$material_components_web_elm$Material$Snackbar$actionButtonClickHandler, messageId, message_)
							])),
					_List_fromArray(
						[
							$elm$html$Html$text(actionButtonLabel)
						]));
			},
			actionButton);
	});
var $aforemny$material_components_web_elm$Material$Snackbar$actionIconClickHandler = F2(
	function (messageId, _v0) {
		var onActionIconClick = _v0.hd;
		return A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$html$Html$Events$onClick,
				$elm$core$Basics$apR(messageId)),
			onActionIconClick);
	});
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $aforemny$material_components_web_elm$Material$Snackbar$actionIconElt = F2(
	function (messageId, message_) {
		var actionIcon = message_.fX;
		if (!actionIcon.$) {
			if (!actionIcon.a.$) {
				var node = actionIcon.a.a.aJ;
				var attributes = actionIcon.a.a.eP;
				var nodes = actionIcon.a.a.ft;
				return $elm$core$Maybe$Just(
					A2(
						node,
						_Utils_ap(
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										$elm$core$Maybe$Just(
										$elm$html$Html$Attributes$class('mdc-icon-button')),
										$elm$core$Maybe$Just(
										$elm$html$Html$Attributes$class('mdc-snackbar__dismiss')),
										A2($aforemny$material_components_web_elm$Material$Snackbar$actionIconClickHandler, messageId, message_)
									])),
							attributes),
						nodes));
			} else {
				var node = actionIcon.a.a.aJ;
				var attributes = actionIcon.a.a.eP;
				var nodes = actionIcon.a.a.ft;
				return $elm$core$Maybe$Just(
					A2(
						node,
						_Utils_ap(
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										$elm$core$Maybe$Just(
										$elm$svg$Svg$Attributes$class('mdc-icon-button')),
										$elm$core$Maybe$Just(
										$elm$svg$Svg$Attributes$class('mdc-snackbar__dismiss')),
										A2($aforemny$material_components_web_elm$Material$Snackbar$actionIconClickHandler, messageId, message_)
									])),
							attributes),
						nodes));
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $aforemny$material_components_web_elm$Material$Snackbar$actionsElt = F2(
	function (messageId, message_) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mdc-snackbar__actions')
				]),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2($aforemny$material_components_web_elm$Material$Snackbar$actionButtonElt, messageId, message_),
						A2($aforemny$material_components_web_elm$Material$Snackbar$actionIconElt, messageId, message_)
					])));
	});
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $aforemny$material_components_web_elm$Material$Snackbar$ariaPoliteLiveAttr = A2($elm$html$Html$Attributes$attribute, 'aria-live', 'polite');
var $aforemny$material_components_web_elm$Material$Snackbar$ariaStatusRoleAttr = A2($elm$html$Html$Attributes$attribute, 'aria-role', 'status');
var $aforemny$material_components_web_elm$Material$Snackbar$labelElt = function (_v0) {
	var label = _v0.c9;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mdc-snackbar__label'),
				$aforemny$material_components_web_elm$Material$Snackbar$ariaStatusRoleAttr,
				$aforemny$material_components_web_elm$Material$Snackbar$ariaPoliteLiveAttr
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $aforemny$material_components_web_elm$Material$Snackbar$surfaceElt = F2(
	function (messageId, message_) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mdc-snackbar__surface')
				]),
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$Snackbar$labelElt(message_),
					A2($aforemny$material_components_web_elm$Material$Snackbar$actionsElt, messageId, message_)
				]));
	});
var $aforemny$material_components_web_elm$Material$Snackbar$timeoutMsProp = function (message_) {
	var indefiniteTimeout = -1;
	var normalizedTimeoutMs = A2(
		$elm$core$Maybe$withDefault,
		indefiniteTimeout,
		A2(
			$elm$core$Maybe$andThen,
			function (_v0) {
				var timeoutMs = _v0.hQ;
				return A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$clamp, 4000, 10000),
					timeoutMs);
			},
			message_));
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'timeoutMs',
			$elm$json$Json$Encode$int(normalizedTimeoutMs)));
};
var $aforemny$material_components_web_elm$Material$Snackbar$snackbar = F2(
	function (config_, queue) {
		var additionalAttributes = config_.fZ;
		var messages = queue.cc;
		var nextMessageId = queue.em;
		var _v0 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(-1, $elm$core$Maybe$Nothing),
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$mapSecond($elm$core$Maybe$Just),
				$elm$core$List$head(messages)));
		var currentMessageId = _v0.a;
		var currentMessage = _v0.b;
		return A3(
			$elm$html$Html$node,
			'mdc-snackbar',
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$Snackbar$rootCs,
							$aforemny$material_components_web_elm$Material$Snackbar$closeOnEscapeProp(config_),
							$aforemny$material_components_web_elm$Material$Snackbar$leadingCs(currentMessage),
							$aforemny$material_components_web_elm$Material$Snackbar$stackedCs(currentMessage),
							$aforemny$material_components_web_elm$Material$Snackbar$messageIdProp(currentMessageId),
							$aforemny$material_components_web_elm$Material$Snackbar$timeoutMsProp(currentMessage),
							A2($aforemny$material_components_web_elm$Material$Snackbar$closedHandler, currentMessageId, config_)
						])),
				additionalAttributes),
			_List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$Snackbar$surfaceElt,
					currentMessageId,
					A2(
						$elm$core$Maybe$withDefault,
						$aforemny$material_components_web_elm$Material$Snackbar$message(''),
						currentMessage))
				]));
	});
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Dialogs$ContactUs$CloseDialog = 1;
var $aforemny$material_components_web_elm$Material$Button$Internal$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Button$config = {fZ: _List_Nil, gk: false, d$: false, ed: $elm$core$Maybe$Nothing, iU: $elm$core$Maybe$Nothing, g0: $elm$core$Maybe$Nothing, he: $elm$core$Maybe$Nothing, hN: $elm$core$Maybe$Nothing, eE: true, fR: false};
var $aforemny$material_components_web_elm$Material$Dialog$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Dialog$config = {fZ: _List_Nil, hf: $elm$core$Maybe$Nothing, a6: false};
var $aforemny$material_components_web_elm$Material$Dialog$closeHandler = function (_v0) {
	var onClose = _v0.hf;
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$html$Html$Events$on('MDCDialog:close'),
			$elm$json$Json$Decode$succeed),
		onClose);
};
var $aforemny$material_components_web_elm$Material$Dialog$actionsElt = function (_v0) {
	var actions = _v0.kk;
	return $elm$core$List$isEmpty(actions) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mdc-dialog__actions')
				]),
			actions));
};
var $aforemny$material_components_web_elm$Material$Dialog$alertDialogRoleAttr = A2($elm$html$Html$Attributes$attribute, 'role', 'alertdialog');
var $aforemny$material_components_web_elm$Material$Dialog$ariaModalAttr = A2($elm$html$Html$Attributes$attribute, 'aria-modal', 'true');
var $aforemny$material_components_web_elm$Material$Dialog$contentElt = function (_v0) {
	var content = _v0.k_;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mdc-dialog__content')
				]),
			content));
};
var $aforemny$material_components_web_elm$Material$Dialog$dialogSurfaceCs = $elm$html$Html$Attributes$class('mdc-dialog__surface');
var $aforemny$material_components_web_elm$Material$Dialog$titleElt = function (_v0) {
	var title = _v0.na;
	if (!title.$) {
		var title_ = title.a;
		return $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mdc-dialog__title')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(title_)
					])));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $aforemny$material_components_web_elm$Material$Dialog$surfaceElt = function (content) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[$aforemny$material_components_web_elm$Material$Dialog$dialogSurfaceCs, $aforemny$material_components_web_elm$Material$Dialog$alertDialogRoleAttr, $aforemny$material_components_web_elm$Material$Dialog$ariaModalAttr]),
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$Dialog$titleElt(content),
					$aforemny$material_components_web_elm$Material$Dialog$contentElt(content),
					$aforemny$material_components_web_elm$Material$Dialog$actionsElt(content)
				])));
};
var $aforemny$material_components_web_elm$Material$Dialog$containerElt = function (content) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mdc-dialog__container')
			]),
		_List_fromArray(
			[
				$aforemny$material_components_web_elm$Material$Dialog$surfaceElt(content)
			]));
};
var $aforemny$material_components_web_elm$Material$Dialog$openProp = function (_v0) {
	var open = _v0.a6;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'open',
			$elm$json$Json$Encode$bool(open)));
};
var $aforemny$material_components_web_elm$Material$Dialog$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-dialog'));
var $aforemny$material_components_web_elm$Material$Dialog$scrimElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-dialog__scrim')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$Dialog$dialog = F2(
	function (config_, content) {
		var additionalAttributes = config_.fZ;
		return A3(
			$elm$html$Html$node,
			'mdc-dialog',
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$Dialog$rootCs,
							$aforemny$material_components_web_elm$Material$Dialog$openProp(config_),
							$aforemny$material_components_web_elm$Material$Dialog$closeHandler(config_)
						])),
				additionalAttributes),
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$Dialog$containerElt(content),
					$aforemny$material_components_web_elm$Material$Dialog$scrimElt
				]));
	});
var $aforemny$material_components_web_elm$Material$Button$Outlined = 3;
var $elm$html$Html$a = _VirtualDom_node('a');
var $aforemny$material_components_web_elm$Material$Button$clickHandler = function (_v0) {
	var onClick = _v0.he;
	return A2($elm$core$Maybe$map, $elm$html$Html$Events$onClick, onClick);
};
var $aforemny$material_components_web_elm$Material$Button$denseCs = function (_v0) {
	var dense = _v0.gk;
	return dense ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-button--dense')) : $elm$core$Maybe$Nothing;
};
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $aforemny$material_components_web_elm$Material$Button$disabledAttr = function (_v0) {
	var disabled = _v0.d$;
	return $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$disabled(disabled));
};
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $aforemny$material_components_web_elm$Material$Button$hrefAttr = function (_v0) {
	var href = _v0.ed;
	return A2($elm$core$Maybe$map, $elm$html$Html$Attributes$href, href);
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $aforemny$material_components_web_elm$Material$Button$labelElt = function (label) {
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mdc-button__label')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				])));
};
var $aforemny$material_components_web_elm$Material$Button$iconElt = function (_v0) {
	var config_ = _v0;
	return A2(
		$elm$core$Maybe$map,
		$elm$html$Html$map($elm$core$Basics$never),
		function () {
			var _v1 = config_.iU;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var node = _v1.a.a.aJ;
					var attributes = _v1.a.a.eP;
					var nodes = _v1.a.a.ft;
					return $elm$core$Maybe$Just(
						A2(
							node,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('mdc-button__icon'),
								A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'),
									attributes)),
							nodes));
				} else {
					var node = _v1.a.a.aJ;
					var attributes = _v1.a.a.eP;
					var nodes = _v1.a.a.ft;
					return $elm$core$Maybe$Just(
						A2(
							node,
							A2(
								$elm$core$List$cons,
								$elm$svg$Svg$Attributes$class('mdc-button__icon'),
								A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'),
									attributes)),
							nodes));
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}());
};
var $aforemny$material_components_web_elm$Material$Button$leadingIconElt = function (config_) {
	var trailingIcon = config_.fR;
	return (!trailingIcon) ? $aforemny$material_components_web_elm$Material$Button$iconElt(config_) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$Menu$closeHandler = function (_v0) {
	var onClose = _v0.hf;
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$html$Html$Events$on('MDCMenuSurface:close'),
			$elm$json$Json$Decode$succeed),
		onClose);
};
var $aforemny$material_components_web_elm$Material$Menu$openProp = function (_v0) {
	var open = _v0.a6;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'open',
			$elm$json$Json$Encode$bool(open)));
};
var $aforemny$material_components_web_elm$Material$Menu$quickOpenProp = function (_v0) {
	var quickOpen = _v0.hy;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'quickOpen',
			$elm$json$Json$Encode$bool(quickOpen)));
};
var $aforemny$material_components_web_elm$Material$Menu$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-menu mdc-menu-surface'));
var $aforemny$material_components_web_elm$Material$Menu$menu = F2(
	function (config_, nodes) {
		var additionalAttributes = config_.fZ;
		return A3(
			$elm$html$Html$node,
			'mdc-menu',
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$Menu$rootCs,
							$aforemny$material_components_web_elm$Material$Menu$openProp(config_),
							$aforemny$material_components_web_elm$Material$Menu$quickOpenProp(config_),
							$aforemny$material_components_web_elm$Material$Menu$closeHandler(config_)
						])),
				additionalAttributes),
			nodes);
	});
var $aforemny$material_components_web_elm$Material$Button$rippleElt = $elm$core$Maybe$Just(
	A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mdc-button__ripple')
			]),
		_List_Nil));
var $aforemny$material_components_web_elm$Material$Button$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-button'));
var $aforemny$material_components_web_elm$Material$Button$tabIndexProp = function (_v0) {
	var disabled = _v0.d$;
	return disabled ? $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'tabIndex',
			$elm$json$Json$Encode$int(-1))) : $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'tabIndex',
			$elm$json$Json$Encode$int(0)));
};
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $aforemny$material_components_web_elm$Material$Button$targetAttr = function (_v0) {
	var href = _v0.ed;
	var target = _v0.hN;
	return (!_Utils_eq(href, $elm$core$Maybe$Nothing)) ? A2($elm$core$Maybe$map, $elm$html$Html$Attributes$target, target) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$Button$touchCs = function (_v0) {
	var touch = _v0.eE;
	return touch ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-button--touch')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$Button$touchElt = function (_v0) {
	var touch = _v0.eE;
	return touch ? $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mdc-button__touch')
				]),
			_List_Nil)) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$Button$trailingIconElt = function (config_) {
	var trailingIcon = config_.fR;
	return trailingIcon ? $aforemny$material_components_web_elm$Material$Button$iconElt(config_) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$Button$variantCs = function (variant) {
	switch (variant) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Just(
				$elm$html$Html$Attributes$class('mdc-button--raised'));
		case 2:
			return $elm$core$Maybe$Just(
				$elm$html$Html$Attributes$class('mdc-button--unelevated'));
		default:
			return $elm$core$Maybe$Just(
				$elm$html$Html$Attributes$class('mdc-button--outlined'));
	}
};
var $aforemny$material_components_web_elm$Material$Button$button = F3(
	function (variant, config_, label) {
		var innerConfig = config_;
		var additionalAttributes = innerConfig.fZ;
		var touch = innerConfig.eE;
		var href = innerConfig.ed;
		var disabled = innerConfig.d$;
		var wrapTouch = function (node) {
			return touch ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mdc-touch-target-wrapper')
					]),
				_List_fromArray(
					[node])) : node;
		};
		var wrapMenu = function (node) {
			var _v0 = innerConfig.g0;
			if (_v0.$ === 1) {
				return node;
			} else {
				var _v1 = _v0.a;
				var menuConfig = _v1.a;
				var menuNodes = _v1.b;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mdc-menu-surface--anchor')
						]),
					_List_fromArray(
						[
							node,
							A2($aforemny$material_components_web_elm$Material$Menu$menu, menuConfig, menuNodes)
						]));
			}
		};
		return wrapMenu(
			wrapTouch(
				A3(
					$elm$html$Html$node,
					'mdc-button',
					_List_Nil,
					_List_fromArray(
						[
							A2(
							((!_Utils_eq(href, $elm$core$Maybe$Nothing)) && (!disabled)) ? $elm$html$Html$a : $elm$html$Html$button,
							_Utils_ap(
								A2(
									$elm$core$List$filterMap,
									$elm$core$Basics$identity,
									_List_fromArray(
										[
											$aforemny$material_components_web_elm$Material$Button$rootCs,
											$aforemny$material_components_web_elm$Material$Button$variantCs(variant),
											$aforemny$material_components_web_elm$Material$Button$denseCs(config_),
											$aforemny$material_components_web_elm$Material$Button$touchCs(config_),
											$aforemny$material_components_web_elm$Material$Button$disabledAttr(config_),
											$aforemny$material_components_web_elm$Material$Button$tabIndexProp(config_),
											$aforemny$material_components_web_elm$Material$Button$hrefAttr(config_),
											$aforemny$material_components_web_elm$Material$Button$targetAttr(config_),
											$aforemny$material_components_web_elm$Material$Button$clickHandler(config_)
										])),
								additionalAttributes),
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										$aforemny$material_components_web_elm$Material$Button$rippleElt,
										$aforemny$material_components_web_elm$Material$Button$leadingIconElt(config_),
										$aforemny$material_components_web_elm$Material$Button$labelElt(label),
										$aforemny$material_components_web_elm$Material$Button$trailingIconElt(config_),
										$aforemny$material_components_web_elm$Material$Button$touchElt(config_)
									])))
						]))));
	});
var $aforemny$material_components_web_elm$Material$Button$outlined = F2(
	function (config_, label) {
		return A3($aforemny$material_components_web_elm$Material$Button$button, 3, config_, label);
	});
var $aforemny$material_components_web_elm$Material$Button$setOnClick = F2(
	function (onClick, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{
				he: $elm$core$Maybe$Just(onClick)
			});
	});
var $aforemny$material_components_web_elm$Material$Dialog$setOnClose = F2(
	function (onClose, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{
				hf: $elm$core$Maybe$Just(onClose)
			});
	});
var $aforemny$material_components_web_elm$Material$Dialog$setOpen = F2(
	function (open, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{a6: open});
	});
var $author$project$Reusable$Label$viewDesc = function (desc) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'font-size', '16px'),
				A2($elm$html$Html$Attributes$style, 'font-weight', '400')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(desc)
			]));
};
var $author$project$Reusable$Label$viewLabel = function (label) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'font-weight', '600'),
				A2($elm$html$Html$Attributes$style, 'font-size', '16px'),
				A2($elm$html$Html$Attributes$style, 'line-height', '1.3em')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $author$project$Reusable$Label$view = F2(
	function (label, desc) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'margin-bottom', '12px'),
					A2($elm$html$Html$Attributes$style, 'width', '100%')
				]),
			_List_fromArray(
				[
					$author$project$Reusable$Label$viewLabel(label),
					$author$project$Reusable$Label$viewDesc(desc)
				]));
	});
var $author$project$Dialogs$ContactUs$view = function (model) {
	return A2(
		$aforemny$material_components_web_elm$Material$Dialog$dialog,
		A2(
			$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
			1,
			A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.d_, $aforemny$material_components_web_elm$Material$Dialog$config)),
		{
			kk: _List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$Button$outlined,
					A2($aforemny$material_components_web_elm$Material$Button$setOnClick, 1, $aforemny$material_components_web_elm$Material$Button$config),
					'Close')
				]),
			k_: _List_fromArray(
				[
					A2($author$project$Reusable$Label$view, 'Phone Number', '855-PAY-2EAT / 855-729-2328'),
					A2($author$project$Reusable$Label$view, 'Hours', 'Monday - Friday, 6AM - 6PM CST')
				]),
			na: $elm$core$Maybe$Just('SchoolCafé TV Technical Support')
		});
};
var $author$project$Dialogs$Gallery$CloseDialog = {$: 2};
var $rtfeldman$elm_css$Css$Structure$Compatible = 0;
var $rtfeldman$elm_css$Css$auto = {kt: 0, d: 0, c$: 0, fg: 0, lN: 0, db: 0, bw: 0, a4: 0, dp: 0, aP: 0, fM: 0, dI: 0, am: 0, eL: 'auto'};
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $avh4$elm_color$Color$toRgba = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	return {f3: a, f8: b, gF: g, hz: r};
};
var $danmarcab$material_icons$Material$Icons$Internal$toRgbaString = function (color) {
	var _v0 = $avh4$elm_color$Color$toRgba(color);
	var red = _v0.hz;
	var green = _v0.gF;
	var blue = _v0.f8;
	var alpha = _v0.f3;
	return 'rgba(' + ($elm$core$String$fromInt(
		$elm$core$Basics$round(255 * red)) + (',' + ($elm$core$String$fromInt(
		$elm$core$Basics$round(255 * green)) + (',' + ($elm$core$String$fromInt(
		$elm$core$Basics$round(255 * blue)) + (',' + ($elm$core$String$fromFloat(alpha) + ')')))))));
};
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $danmarcab$material_icons$Material$Icons$Internal$icon = F4(
	function (viewBox, children, color, size) {
		var stringSize = $elm$core$String$fromInt(size);
		var stringColor = $danmarcab$material_icons$Material$Icons$Internal$toRgbaString(color);
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width(stringSize),
					$elm$svg$Svg$Attributes$height(stringSize),
					$elm$svg$Svg$Attributes$viewBox(viewBox)
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill(stringColor)
						]),
					children)
				]));
	});
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $danmarcab$material_icons$Material$Icons$Action$check_circle = A2(
	$danmarcab$material_icons$Material$Icons$Internal$icon,
	'0 0 48 48',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M24 4C12.95 4 4 12.95 4 24c0 11.04 8.95 20 20 20 11.04 0 20-8.96 20-20 0-11.05-8.96-20-20-20zm-4 30L10 24l2.83-2.83L20 28.34l15.17-15.17L38 16 20 34z')
				]),
			_List_Nil)
		]));
var $aforemny$material_components_web_elm$Material$CircularProgress$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$CircularProgress$Large = 0;
var $aforemny$material_components_web_elm$Material$CircularProgress$config = {fZ: _List_Nil, gb: false, gC: false, c9: $elm$core$Maybe$Nothing, dB: 0};
var $rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Css$Structure$compactHelp = F2(
	function (declaration, _v0) {
		var keyframesByName = _v0.a;
		var declarations = _v0.b;
		switch (declaration.$) {
			case 0:
				var _v2 = declaration.a;
				var properties = _v2.c;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 1:
				var styleBlocks = declaration.b;
				return A2(
					$elm$core$List$all,
					function (_v3) {
						var properties = _v3.c;
						return $elm$core$List$isEmpty(properties);
					},
					styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 2:
				var otherDeclarations = declaration.b;
				return $elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 3:
				return _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 4:
				var properties = declaration.b;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 5:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 6:
				var record = declaration.a;
				return $elm$core$String$isEmpty(record.k6) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					A3($elm$core$Dict$insert, record.g8, record.k6, keyframesByName),
					declarations);
			case 7:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 8:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			default:
				var tuples = declaration.a;
				return A2(
					$elm$core$List$all,
					function (_v4) {
						var properties = _v4.b;
						return $elm$core$List$isEmpty(properties);
					},
					tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
		}
	});
var $rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
	function (keyframesByName, compactedDeclarations) {
		return A2(
			$elm$core$List$append,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var name = _v0.a;
					var decl = _v0.b;
					return $rtfeldman$elm_css$Css$Structure$Keyframes(
						{k6: decl, g8: name});
				},
				$elm$core$Dict$toList(keyframesByName)),
			compactedDeclarations);
	});
var $rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_v0) {
	var charset = _v0.is;
	var imports = _v0.iW;
	var namespaces = _v0.jb;
	var declarations = _v0.k7;
	var _v1 = A3(
		$elm$core$List$foldr,
		$rtfeldman$elm_css$Css$Structure$compactHelp,
		_Utils_Tuple2($elm$core$Dict$empty, _List_Nil),
		declarations);
	var keyframesByName = _v1.a;
	var compactedDeclarations = _v1.b;
	var finalDeclarations = A2($rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
	return {is: charset, k7: finalDeclarations, iW: imports, jb: namespaces};
};
var $rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (str) {
				return '@charset \"' + (str + '\"');
			},
			charset));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
	return '(' + (expression.iH + (A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append(': '),
			expression.eL)) + ')'));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
	switch (mediaType) {
		case 0:
			return 'print';
		case 1:
			return 'screen';
		default:
			return 'speech';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
	var prefixWith = F3(
		function (str, mediaType, expressions) {
			return str + (' ' + A2(
				$elm$core$String$join,
				' and ',
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
		});
	switch (mediaQuery.$) {
		case 0:
			var expressions = mediaQuery.a;
			return A2(
				$elm$core$String$join,
				' and ',
				A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions));
		case 1:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'only', mediaType, expressions);
		case 2:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'not', mediaType, expressions);
		default:
			var str = mediaQuery.a;
			return str;
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
	function (name, mediaQuery) {
		return '@import \"' + (name + ($rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
	});
var $rtfeldman$elm_css$Css$Structure$Output$importToString = function (_v0) {
	var name = _v0.a;
	var mediaQueries = _v0.b;
	return A2(
		$elm$core$String$join,
		'\n',
		A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
			mediaQueries));
};
var $rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_v0) {
	var prefix = _v0.a;
	var str = _v0.b;
	return '@namespace ' + (prefix + ('\"' + (str + '\"')));
};
var $rtfeldman$elm_css$Css$Structure$Output$spaceIndent = '    ';
var $rtfeldman$elm_css$Css$Structure$Output$indent = function (str) {
	return _Utils_ap($rtfeldman$elm_css$Css$Structure$Output$spaceIndent, str);
};
var $rtfeldman$elm_css$Css$Structure$Output$noIndent = '';
var $rtfeldman$elm_css$Css$Structure$Output$emitProperty = function (str) {
	return str + ';';
};
var $rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
	return A2(
		$elm$core$String$join,
		'\n',
		A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeL, $rtfeldman$elm_css$Css$Structure$Output$indent, $rtfeldman$elm_css$Css$Structure$Output$emitProperty),
			properties));
};
var $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_v0) {
	var str = _v0;
	return '::' + str;
};
var $rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
	switch (combinator) {
		case 0:
			return '+';
		case 1:
			return '~';
		case 2:
			return '>';
		default:
			return '';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
	switch (repeatableSimpleSelector.$) {
		case 0:
			var str = repeatableSimpleSelector.a;
			return '.' + str;
		case 1:
			var str = repeatableSimpleSelector.a;
			return '#' + str;
		case 2:
			var str = repeatableSimpleSelector.a;
			return ':' + str;
		default:
			var str = repeatableSimpleSelector.a;
			return '[' + (str + ']');
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
	switch (simpleSelectorSequence.$) {
		case 0:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$cons,
					str,
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
		case 1:
			var repeatableSimpleSelectors = simpleSelectorSequence.a;
			return $elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A2(
				$elm$core$String$join,
				'',
				A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors));
		default:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$cons,
					str,
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_v0) {
	var combinator = _v0.a;
	var sequence = _v0.b;
	return A2(
		$elm$core$String$join,
		' ',
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator),
				$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence)
			]));
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_v0) {
	var simpleSelectorSequence = _v0.a;
	var chain = _v0.b;
	var pseudoElement = _v0.c;
	var segments = A2(
		$elm$core$List$cons,
		$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
	var pseudoElementsString = A2(
		$elm$core$String$join,
		'',
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement))
			]));
	return A2(
		$elm$core$String$append,
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
				segments)),
		pseudoElementsString);
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = F2(
	function (indentLevel, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		var selectorStr = A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Structure$Output$selectorToString,
				A2($elm$core$List$cons, firstSelector, otherSelectors)));
		return A2(
			$elm$core$String$join,
			'',
			_List_fromArray(
				[
					selectorStr,
					' {\n',
					indentLevel,
					$rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties),
					'\n',
					indentLevel,
					'}'
				]));
	});
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
	switch (decl.$) {
		case 0:
			var styleBlock = decl.a;
			return A2($rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, $rtfeldman$elm_css$Css$Structure$Output$noIndent, styleBlock);
		case 1:
			var mediaQueries = decl.a;
			var styleBlocks = decl.b;
			var query = A2(
				$elm$core$String$join,
				',\n',
				A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, mediaQueries));
			var blocks = A2(
				$elm$core$String$join,
				'\n\n',
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeL,
						$rtfeldman$elm_css$Css$Structure$Output$indent,
						$rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock($rtfeldman$elm_css$Css$Structure$Output$spaceIndent)),
					styleBlocks));
			return '@media ' + (query + (' {\n' + (blocks + '\n}')));
		case 2:
			return 'TODO';
		case 3:
			return 'TODO';
		case 4:
			return 'TODO';
		case 5:
			return 'TODO';
		case 6:
			var name = decl.a.g8;
			var declaration = decl.a.k6;
			return '@keyframes ' + (name + (' {\n' + (declaration + '\n}')));
		case 7:
			return 'TODO';
		case 8:
			return 'TODO';
		default:
			return 'TODO';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_v0) {
	var charset = _v0.is;
	var imports = _v0.iW;
	var namespaces = _v0.jb;
	var declarations = _v0.k7;
	return A2(
		$elm$core$String$join,
		'\n\n',
		A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset),
					A2(
					$elm$core$String$join,
					'\n',
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$importToString, imports)),
					A2(
					$elm$core$String$join,
					'\n',
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$namespaceToString, namespaces)),
					A2(
					$elm$core$String$join,
					'\n\n',
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, declarations))
				])));
};
var $rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
	return {$: 8, a: a};
};
var $rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$Structure$PageRule = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Selector = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
	return {$: 7, a: a};
};
var $rtfeldman$elm_css$Css$Structure$MediaRule = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$mapLast = F2(
	function (update, list) {
		if (!list.b) {
			return list;
		} else {
			if (!list.b.b) {
				var only = list.a;
				return _List_fromArray(
					[
						update(only)
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
	function (property, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		return A3(
			$rtfeldman$elm_css$Css$Structure$StyleBlock,
			firstSelector,
			otherSelectors,
			_Utils_ap(
				properties,
				_List_fromArray(
					[property])));
	});
var $rtfeldman$elm_css$Css$Structure$appendProperty = F2(
	function (property, declarations) {
		if (!declarations.b) {
			return declarations;
		} else {
			if (!declarations.b.b) {
				switch (declarations.a.$) {
					case 0:
						var styleBlock = declarations.a.a;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
								A2($rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
							]);
					case 1:
						var _v1 = declarations.a;
						var mediaQueries = _v1.a;
						var styleBlocks = _v1.b;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Structure$MediaRule,
								mediaQueries,
								A2(
									$rtfeldman$elm_css$Css$Structure$mapLast,
									$rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
									styleBlocks))
							]);
					default:
						return declarations;
				}
			} else {
				var first = declarations.a;
				var rest = declarations.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
	function (f, styleBlock) {
		if (!styleBlock.b.b) {
			var only = styleBlock.a;
			var properties = styleBlock.c;
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
					A3(
					$rtfeldman$elm_css$Css$Structure$StyleBlock,
					f(only),
					_List_Nil,
					_List_Nil)
				]);
		} else {
			var first = styleBlock.a;
			var rest = styleBlock.b;
			var properties = styleBlock.c;
			var newRest = A2($elm$core$List$map, f, rest);
			var newFirst = f(first);
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
				]);
		}
	});
var $rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
	function (pseudo, _v0) {
		var sequence = _v0.a;
		var selectors = _v0.b;
		return A3(
			$rtfeldman$elm_css$Css$Structure$Selector,
			sequence,
			selectors,
			$elm$core$Maybe$Just(pseudo));
	});
var $rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
	function (pseudo, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
	function (selector, sequence) {
		switch (sequence.$) {
			case 0:
				var typeSelector = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
					typeSelector,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			case 1:
				var list = sequence.a;
				return $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			default:
				var str = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$CustomSelector,
					str,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
	function (selector, list) {
		if (!list.b) {
			return _List_Nil;
		} else {
			if (!list.b.b) {
				var _v1 = list.a;
				var combinator = _v1.a;
				var sequence = _v1.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						combinator,
						A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
	function (repeatableSimpleSelector, selector) {
		if (!selector.b.b) {
			var sequence = selector.a;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
				_List_Nil,
				pseudoElement);
		} else {
			var firstSelector = selector.a;
			var tuples = selector.b;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				firstSelector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
				pseudoElement);
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
	function (selector, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
	collectSelectors:
	while (true) {
		if (!declarations.b) {
			return _List_Nil;
		} else {
			if (!declarations.a.$) {
				var _v1 = declarations.a.a;
				var firstSelector = _v1.a;
				var otherSelectors = _v1.b;
				var rest = declarations.b;
				return _Utils_ap(
					A2($elm$core$List$cons, firstSelector, otherSelectors),
					$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
			} else {
				var rest = declarations.b;
				var $temp$declarations = rest;
				declarations = $temp$declarations;
				continue collectSelectors;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
	function (a, b, c, d, e) {
		return {$: 3, a: a, b: b, c: c, d: d, e: e};
	});
var $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
	function (update, declarations) {
		_v0$12:
		while (true) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 0:
							var styleBlock = declarations.a.a;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
								update(styleBlock));
						case 1:
							if (declarations.a.b.b) {
								if (!declarations.a.b.b.b) {
									var _v1 = declarations.a;
									var mediaQueries = _v1.a;
									var _v2 = _v1.b;
									var styleBlock = _v2.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Css$Structure$MediaRule,
											mediaQueries,
											update(styleBlock))
										]);
								} else {
									var _v3 = declarations.a;
									var mediaQueries = _v3.a;
									var _v4 = _v3.b;
									var first = _v4.a;
									var rest = _v4.b;
									var _v5 = A2(
										$rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
										update,
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
											]));
									if ((_v5.b && (_v5.a.$ === 1)) && (!_v5.b.b)) {
										var _v6 = _v5.a;
										var newMediaQueries = _v6.a;
										var newStyleBlocks = _v6.b;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Css$Structure$MediaRule,
												newMediaQueries,
												A2($elm$core$List$cons, first, newStyleBlocks))
											]);
									} else {
										var newDeclarations = _v5;
										return newDeclarations;
									}
								}
							} else {
								break _v0$12;
							}
						case 2:
							var _v7 = declarations.a;
							var str = _v7.a;
							var nestedDeclarations = _v7.b;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$Structure$SupportsRule,
									str,
									A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
								]);
						case 3:
							var _v8 = declarations.a;
							var str1 = _v8.a;
							var str2 = _v8.b;
							var str3 = _v8.c;
							var str4 = _v8.d;
							var styleBlock = _v8.e;
							return A2(
								$elm$core$List$map,
								A4($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
								update(styleBlock));
						case 4:
							var _v9 = declarations.a;
							return declarations;
						case 5:
							return declarations;
						case 6:
							return declarations;
						case 7:
							return declarations;
						case 8:
							return declarations;
						default:
							return declarations;
					}
				} else {
					break _v0$12;
				}
			}
		}
		var first = declarations.a;
		var rest = declarations.b;
		return A2(
			$elm$core$List$cons,
			first,
			A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {cL: charsProcessed, c4: hash, jM: seed, dA: shift};
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$c1 = 3432918353;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$c2 = 461845907;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize = function (data) {
	var acc = (!(!data.c4)) ? (data.jM ^ A2(
		$rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
		$rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
		A2(
			$rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
			15,
			A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, $rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, data.c4)))) : data.jM;
	var h0 = acc ^ data.cL;
	var h1 = A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $elm$core$String$foldl = _String_foldl;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$mix = F2(
	function (h1, k1) {
		return A2(
			$rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
			5,
			A2(
				$rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
				13,
				h1 ^ A2(
					$rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
					$rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
					A2(
						$rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
						15,
						A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, $rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, k1))))) + 3864292196;
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.c4 | ((255 & $elm$core$Char$toCode(c)) << data.dA);
		var _v0 = data.dA;
		if (_v0 === 24) {
			return {
				cL: data.cL + 1,
				c4: 0,
				jM: A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$mix, data.jM, res),
				dA: 0
			};
		} else {
			return {cL: data.cL + 1, c4: res, jM: data.jM, dA: data.dA + 8};
		}
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString = F2(
	function (seed, str) {
		return $rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize(
			A3(
				$elm$core$String$foldl,
				$rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold,
				A4($rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});
var $rtfeldman$elm_css$Hash$murmurSeed = 15739;
var $rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
	unsafeToDigit:
	while (true) {
		switch (num) {
			case 0:
				return '0';
			case 1:
				return '1';
			case 2:
				return '2';
			case 3:
				return '3';
			case 4:
				return '4';
			case 5:
				return '5';
			case 6:
				return '6';
			case 7:
				return '7';
			case 8:
				return '8';
			case 9:
				return '9';
			case 10:
				return 'a';
			case 11:
				return 'b';
			case 12:
				return 'c';
			case 13:
				return 'd';
			case 14:
				return 'e';
			case 15:
				return 'f';
			default:
				var $temp$num = num;
				num = $temp$num;
				continue unsafeToDigit;
		}
	}
};
var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
	function (digits, num) {
		unsafePositiveToDigits:
		while (true) {
			if (num < 16) {
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(num),
					digits);
			} else {
				var $temp$digits = A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(
						A2($elm$core$Basics$modBy, 16, num)),
					digits),
					$temp$num = (num / 16) | 0;
				digits = $temp$digits;
				num = $temp$num;
				continue unsafePositiveToDigits;
			}
		}
	});
var $rtfeldman$elm_hex$Hex$toString = function (num) {
	return $elm$core$String$fromList(
		(num < 0) ? A2(
			$elm$core$List$cons,
			'-',
			A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
};
var $rtfeldman$elm_css$Hash$fromString = function (str) {
	return A2(
		$elm$core$String$cons,
		'_',
		$rtfeldman$elm_hex$Hex$toString(
			A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString, $rtfeldman$elm_css$Hash$murmurSeed, str)));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
	last:
	while (true) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!list.b.b) {
				var singleton = list.a;
				return $elm$core$Maybe$Just(singleton);
			} else {
				var rest = list.b;
				var $temp$list = rest;
				list = $temp$list;
				continue last;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
	lastDeclaration:
	while (true) {
		if (!declarations.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!declarations.b.b) {
				var x = declarations.a;
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[x]));
			} else {
				var xs = declarations.b;
				var $temp$declarations = xs;
				declarations = $temp$declarations;
				continue lastDeclaration;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
	oneOf:
	while (true) {
		if (!maybes.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var maybe = maybes.a;
			var rest = maybes.b;
			if (maybe.$ === 1) {
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue oneOf;
			} else {
				return maybe;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
	return {$: 9, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
	var expandTuples = function (tuplesToExpand) {
		if (!tuplesToExpand.b) {
			return _List_Nil;
		} else {
			var properties = tuplesToExpand.a;
			var rest = tuplesToExpand.b;
			return A2(
				$elm$core$List$cons,
				properties,
				expandTuples(rest));
		}
	};
	var newTuples = expandTuples(tuples);
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
		]);
};
var $rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
	function (mediaQueries, declaration) {
		if (!declaration.$) {
			var styleBlock = declaration.a;
			return A2(
				$rtfeldman$elm_css$Css$Structure$MediaRule,
				mediaQueries,
				_List_fromArray(
					[styleBlock]));
		} else {
			return declaration;
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
	function (str1, str2, str3, str4, declaration) {
		if (!declaration.$) {
			var structureStyleBlock = declaration.a;
			return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
	function (mediaQueries, declaration) {
		switch (declaration.$) {
			case 0:
				var structureStyleBlock = declaration.a;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[structureStyleBlock]));
			case 1:
				var newMediaQueries = declaration.a;
				var structureStyleBlocks = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					_Utils_ap(mediaQueries, newMediaQueries),
					structureStyleBlocks);
			case 2:
				var str = declaration.a;
				var declarations = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$SupportsRule,
					str,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
						declarations));
			case 3:
				var str1 = declaration.a;
				var str2 = declaration.b;
				var str3 = declaration.c;
				var str4 = declaration.d;
				var structureStyleBlock = declaration.e;
				return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			case 4:
				return declaration;
			case 5:
				return declaration;
			case 6:
				return declaration;
			case 7:
				return declaration;
			case 8:
				return declaration;
			default:
				return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_v0) {
	var declarations = _v0;
	return declarations;
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
	function (nestedStyles, rest, f, declarations) {
		var withoutParent = function (decls) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$elm$core$List$tail(decls));
		};
		var nextResult = A2(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			rest,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		var newDeclarations = function () {
			var _v14 = _Utils_Tuple2(
				$elm$core$List$head(nextResult),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
			if ((!_v14.a.$) && (!_v14.b.$)) {
				var nextResultParent = _v14.a.a;
				var originalParent = _v14.b.a;
				return _Utils_ap(
					A2(
						$elm$core$List$take,
						$elm$core$List$length(declarations) - 1,
						declarations),
					_List_fromArray(
						[
							(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
						]));
			} else {
				return declarations;
			}
		}();
		var insertStylesToNestedDecl = function (lastDecl) {
			return $elm$core$List$concat(
				A2(
					$rtfeldman$elm_css$Css$Structure$mapLast,
					$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
					A2(
						$elm$core$List$map,
						$elm$core$List$singleton,
						A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
		};
		var initialResult = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				insertStylesToNestedDecl,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		return _Utils_ap(
			newDeclarations,
			_Utils_ap(
				withoutParent(initialResult),
				withoutParent(nextResult)));
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
	function (styles, declarations) {
		if (!styles.b) {
			return declarations;
		} else {
			switch (styles.a.$) {
				case 0:
					var property = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
				case 1:
					var _v4 = styles.a;
					var selector = _v4.a;
					var nestedStyles = _v4.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
						declarations);
				case 2:
					var _v5 = styles.a;
					var selectorCombinator = _v5.a;
					var snippets = _v5.b;
					var rest = styles.b;
					var chain = F2(
						function (_v9, _v10) {
							var originalSequence = _v9.a;
							var originalTuples = _v9.b;
							var originalPseudoElement = _v9.c;
							var newSequence = _v10.a;
							var newTuples = _v10.b;
							var newPseudoElement = _v10.c;
							return A3(
								$rtfeldman$elm_css$Css$Structure$Selector,
								originalSequence,
								_Utils_ap(
									originalTuples,
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(selectorCombinator, newSequence),
										newTuples)),
								$rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
									_List_fromArray(
										[newPseudoElement, originalPseudoElement])));
						});
					var expandDeclaration = function (declaration) {
						switch (declaration.$) {
							case 0:
								var _v7 = declaration.a;
								var firstSelector = _v7.a;
								var otherSelectors = _v7.b;
								var nestedStyles = _v7.c;
								var newSelectors = A2(
									$elm$core$List$concatMap,
									function (originalSelector) {
										return A2(
											$elm$core$List$map,
											chain(originalSelector),
											A2($elm$core$List$cons, firstSelector, otherSelectors));
									},
									$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
								var newDeclarations = function () {
									if (!newSelectors.b) {
										return _List_Nil;
									} else {
										var first = newSelectors.a;
										var remainder = newSelectors.b;
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
											]);
									}
								}();
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
							case 1:
								var mediaQueries = declaration.a;
								var styleBlocks = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
							case 2:
								var str = declaration.a;
								var otherSnippets = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
							case 3:
								var str1 = declaration.a;
								var str2 = declaration.b;
								var str3 = declaration.c;
								var str4 = declaration.d;
								var styleBlock = declaration.e;
								return A2(
									$elm$core$List$map,
									A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
									$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
							case 4:
								var str = declaration.a;
								var properties = declaration.b;
								return _List_fromArray(
									[
										A2($rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
									]);
							case 5:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$FontFace(properties)
									]);
							case 6:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$Viewport(properties)
									]);
							case 7:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
									]);
							default:
								var tuples = declaration.a;
								return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
						}
					};
					return $elm$core$List$concat(
						_Utils_ap(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
								]),
							A2(
								$elm$core$List$map,
								expandDeclaration,
								A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
				case 3:
					var _v11 = styles.a;
					var pseudoElement = _v11.a;
					var nestedStyles = _v11.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
						declarations);
				case 5:
					var str = styles.a.a;
					var rest = styles.b;
					var name = $rtfeldman$elm_css$Hash$fromString(str);
					var newProperty = 'animation-name:' + name;
					var newDeclarations = A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
					return A2(
						$elm$core$List$append,
						newDeclarations,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$Keyframes(
								{k6: str, g8: name})
							]));
				case 4:
					var _v12 = styles.a;
					var mediaQueries = _v12.a;
					var nestedStyles = _v12.b;
					var rest = styles.b;
					var extraDeclarations = function () {
						var _v13 = $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
						if (!_v13.b) {
							return _List_Nil;
						} else {
							var firstSelector = _v13.a;
							var otherSelectors = _v13.b;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
								A2(
									$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
									nestedStyles,
									$elm$core$List$singleton(
										$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
											A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
						}
					}();
					return _Utils_ap(
						A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
						extraDeclarations);
				default:
					var otherStyles = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						_Utils_ap(otherStyles, rest),
						declarations);
			}
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_v2) {
	var firstSelector = _v2.a;
	var otherSelectors = _v2.b;
	var styles = _v2.c;
	return A2(
		$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
		styles,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
			]));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
	if (!snippetDeclarations.b) {
		return _List_Nil;
	} else {
		var first = snippetDeclarations.a;
		var rest = snippetDeclarations.b;
		return _Utils_ap(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
			$rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
	function (mediaQueries, styleBlocks) {
		var handleStyleBlock = function (styleBlock) {
			return A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		};
		return A2($elm$core$List$concatMap, handleStyleBlock, styleBlocks);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
	function (str, snippets) {
		var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return _List_fromArray(
			[
				A2($rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
	switch (snippetDeclaration.$) {
		case 0:
			var styleBlock = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
		case 1:
			var mediaQueries = snippetDeclaration.a;
			var styleBlocks = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
		case 2:
			var str = snippetDeclaration.a;
			var snippets = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
		case 3:
			var str1 = snippetDeclaration.a;
			var str2 = snippetDeclaration.b;
			var str3 = snippetDeclaration.c;
			var str4 = snippetDeclaration.d;
			var styleBlock = snippetDeclaration.e;
			return A2(
				$elm$core$List$map,
				A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		case 4:
			var str = snippetDeclaration.a;
			var properties = snippetDeclaration.b;
			return _List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
				]);
		case 5:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$FontFace(properties)
				]);
		case 6:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Viewport(properties)
				]);
		case 7:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
				]);
		default:
			var tuples = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_v0) {
	var charset = _v0.is;
	var imports = _v0.iW;
	var namespaces = _v0.jb;
	var snippets = _v0.jS;
	var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
		A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
	return {is: charset, k7: declarations, iW: imports, jb: namespaces};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp = function (sheet) {
	return $rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
		$rtfeldman$elm_css$Css$Structure$compactStylesheet(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (styles) {
	return A2(
		$elm$core$String$join,
		'\n\n',
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp, styles));
};
var $rtfeldman$elm_css$Css$Preprocess$Snippet = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
	function (styles, sequence) {
		var selector = A3($rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, $elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
			]);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$murmurSeed = 15739;
var $rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
	return {is: $elm$core$Maybe$Nothing, iW: _List_Nil, jb: _List_Nil, jS: snippets};
};
var $rtfeldman$elm_css$VirtualDom$Styled$getClassname = function (styles) {
	return $elm$core$List$isEmpty(styles) ? 'unstyled' : A2(
		$elm$core$String$cons,
		'_',
		$rtfeldman$elm_hex$Hex$toString(
			A2(
				$rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString,
				$rtfeldman$elm_css$VirtualDom$Styled$murmurSeed,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
					$elm$core$List$singleton(
						$rtfeldman$elm_css$Css$Preprocess$stylesheet(
							$elm$core$List$singleton(
								A2(
									$rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
									styles,
									$rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_List_Nil)))))))));
};
var $rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
	var classname = $rtfeldman$elm_css$VirtualDom$Styled$getClassname(styles);
	var classProperty = A2(
		$elm$virtual_dom$VirtualDom$property,
		'className',
		$elm$json$Json$Encode$string(classname));
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, styles, classname);
};
var $rtfeldman$elm_css$Html$Styled$Attributes$css = $rtfeldman$elm_css$Html$Styled$Internal$css;
var $rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$displayFlex = A2($rtfeldman$elm_css$Css$property, 'display', 'flex');
var $rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$Node;
var $rtfeldman$elm_css$Html$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$node;
var $rtfeldman$elm_css$Html$Styled$div = $rtfeldman$elm_css$Html$Styled$node('div');
var $danmarcab$material_icons$Material$Icons$Alert$error = A2(
	$danmarcab$material_icons$Material$Icons$Internal$icon,
	'0 0 48 48',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M24 4C12.96 4 4 12.95 4 24s8.96 20 20 20 20-8.95 20-20S35.04 4 24 4zm2 30h-4v-4h4v4zm0-8h-4V14h4v12z')
				]),
			_List_Nil)
		]));
var $rtfeldman$elm_css$Css$prop1 = F2(
	function (key, arg) {
		return A2($rtfeldman$elm_css$Css$property, key, arg.eL);
	});
var $rtfeldman$elm_css$Css$flexWrap = $rtfeldman$elm_css$Css$prop1('flex-wrap');
var $rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
	return {$: 4, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode = $rtfeldman$elm_css$VirtualDom$Styled$Unstyled;
var $rtfeldman$elm_css$Html$Styled$fromUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode;
var $aforemny$material_components_web_elm$Material$CircularProgress$ariaLabelAttr = function (_v0) {
	var label = _v0.c9;
	return A2(
		$elm$core$Maybe$map,
		$elm$html$Html$Attributes$attribute('aria-label'),
		label);
};
var $aforemny$material_components_web_elm$Material$CircularProgress$ariaValueMaxAttr = $elm$core$Maybe$Just(
	A2($elm$html$Html$Attributes$attribute, 'aria-value-max', '1'));
var $aforemny$material_components_web_elm$Material$CircularProgress$ariaValueMinAttr = $elm$core$Maybe$Just(
	A2($elm$html$Html$Attributes$attribute, 'aria-value-min', '0'));
var $aforemny$material_components_web_elm$Material$CircularProgress$ariaValueNowAttr = function (progress) {
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$elm$html$Html$Attributes$attribute('aria-value-now'),
				$elm$core$String$fromFloat),
			function ($) {
				return $.hx;
			}),
		progress);
};
var $aforemny$material_components_web_elm$Material$CircularProgress$closedProp = function (_v0) {
	var closed = _v0.gb;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'closed',
			$elm$json$Json$Encode$bool(closed)));
};
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $aforemny$material_components_web_elm$Material$CircularProgress$circleCs = function (progress) {
	return $elm$svg$Svg$Attributes$class(
		(!_Utils_eq(progress, $elm$core$Maybe$Nothing)) ? 'mdc-circular-progress__determinate-circle' : 'mdc-circular-progress__indeterminate-circle');
};
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $elm$svg$Svg$Attributes$strokeDasharray = _VirtualDom_attribute('stroke-dasharray');
var $aforemny$material_components_web_elm$Material$CircularProgress$strokeDasharrayAttr = function (_v0) {
	var size = _v0.dB;
	return A3(
		$elm$core$Basics$composeL,
		$elm$svg$Svg$Attributes$strokeDasharray,
		$elm$core$String$fromFloat,
		function () {
			switch (size) {
				case 0:
					return 113.097;
				case 1:
					return 78.54;
				default:
					return 54.978;
			}
		}());
};
var $elm$svg$Svg$Attributes$strokeDashoffset = _VirtualDom_attribute('stroke-dashoffset');
var $aforemny$material_components_web_elm$Material$CircularProgress$strokeDashoffsetAttr = F2(
	function (progress, _v0) {
		var size = _v0.dB;
		return A3(
			$elm$core$Basics$composeL,
			$elm$svg$Svg$Attributes$strokeDashoffset,
			$elm$core$String$fromFloat,
			function () {
				var _v1 = _Utils_Tuple2(progress, size);
				if (!_v1.a.$) {
					switch (_v1.b) {
						case 0:
							var _v2 = _v1.b;
							return 113.097;
						case 1:
							var _v5 = _v1.b;
							return 78.54;
						default:
							var _v8 = _v1.b;
							return 54.978;
					}
				} else {
					switch (_v1.b) {
						case 0:
							var _v3 = _v1.a;
							var _v4 = _v1.b;
							return 56.549;
						case 1:
							var _v6 = _v1.a;
							var _v7 = _v1.b;
							return 39.27;
						default:
							var _v9 = _v1.a;
							var _v10 = _v1.b;
							return 27.489;
					}
				}
			}());
	});
var $aforemny$material_components_web_elm$Material$CircularProgress$circleElt = F2(
	function (progress, config_) {
		return A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$CircularProgress$circleCs(progress),
					$elm$svg$Svg$Attributes$cx('24'),
					$elm$svg$Svg$Attributes$cy('24'),
					$elm$svg$Svg$Attributes$r('18'),
					$aforemny$material_components_web_elm$Material$CircularProgress$strokeDasharrayAttr(config_),
					A2($aforemny$material_components_web_elm$Material$CircularProgress$strokeDashoffsetAttr, progress, config_)
				]),
			_List_Nil);
	});
var $aforemny$material_components_web_elm$Material$CircularProgress$determinateCircleGraphicElt = F2(
	function (progress, config_) {
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('mdc-circular-progress__determinate-circle-graphic'),
					$elm$svg$Svg$Attributes$viewBox('0 0 48 48')
				]),
			_List_fromArray(
				[
					A2($aforemny$material_components_web_elm$Material$CircularProgress$circleElt, progress, config_)
				]));
	});
var $aforemny$material_components_web_elm$Material$CircularProgress$determinateContainerElt = F2(
	function (progress, config_) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mdc-circular-progress__determinate-container')
				]),
			_List_fromArray(
				[
					A2($aforemny$material_components_web_elm$Material$CircularProgress$determinateCircleGraphicElt, progress, config_)
				]));
	});
var $aforemny$material_components_web_elm$Material$CircularProgress$determinateProp = function (progress) {
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'determinate',
			$elm$json$Json$Encode$bool(
				!_Utils_eq(progress, $elm$core$Maybe$Nothing))));
};
var $aforemny$material_components_web_elm$Material$CircularProgress$indeterminateCircleGraphicElt = function (config_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class('mdc-circular-progress__indeterminate-circle-graphic'),
				$elm$svg$Svg$Attributes$viewBox('0 0 48 48')
			]),
		_List_fromArray(
			[
				A2($aforemny$material_components_web_elm$Material$CircularProgress$circleElt, $elm$core$Maybe$Nothing, config_)
			]));
};
var $aforemny$material_components_web_elm$Material$CircularProgress$spinnerLayerElt = F2(
	function (config_, additionalAttributes) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('mdc-circular-progress__spinner-layer'),
				additionalAttributes),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mdc-circular-progress__circle-clipper'),
							$elm$html$Html$Attributes$class('mdc-circular-progress__circle-left')
						]),
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$CircularProgress$indeterminateCircleGraphicElt(config_)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mdc-circular-progress__gap-patch')
						]),
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$CircularProgress$indeterminateCircleGraphicElt(config_)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mdc-circular-progress__circle-clipper'),
							$elm$html$Html$Attributes$class('mdc-circular-progress__circle-right')
						]),
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$CircularProgress$indeterminateCircleGraphicElt(config_)
						]))
				]));
	});
var $aforemny$material_components_web_elm$Material$CircularProgress$indeterminateContainerElt = function (config_) {
	var fourColored = config_.gC;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mdc-circular-progress__indeterminate-container')
			]),
		fourColored ? _List_fromArray(
			[
				A2(
				$aforemny$material_components_web_elm$Material$CircularProgress$spinnerLayerElt,
				config_,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mdc-circular-progress__color-1')
					])),
				A2(
				$aforemny$material_components_web_elm$Material$CircularProgress$spinnerLayerElt,
				config_,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mdc-circular-progress__color-2')
					])),
				A2(
				$aforemny$material_components_web_elm$Material$CircularProgress$spinnerLayerElt,
				config_,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mdc-circular-progress__color-3')
					])),
				A2(
				$aforemny$material_components_web_elm$Material$CircularProgress$spinnerLayerElt,
				config_,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mdc-circular-progress__color-4')
					]))
			]) : _List_fromArray(
			[
				A2($aforemny$material_components_web_elm$Material$CircularProgress$spinnerLayerElt, config_, _List_Nil)
			]));
};
var $aforemny$material_components_web_elm$Material$CircularProgress$indeterminateCs = function (progress) {
	return (!_Utils_eq(progress, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-circular-progress--indeterminate'));
};
var $aforemny$material_components_web_elm$Material$CircularProgress$progressProp = function (progress) {
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$elm$html$Html$Attributes$property('progress'),
				$elm$json$Json$Encode$float),
			function ($) {
				return $.hx;
			}),
		progress);
};
var $aforemny$material_components_web_elm$Material$CircularProgress$progressbarRole = $elm$core$Maybe$Just(
	A2($elm$html$Html$Attributes$attribute, 'role', 'progressbar'));
var $aforemny$material_components_web_elm$Material$CircularProgress$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-circular-progress'));
var $aforemny$material_components_web_elm$Material$CircularProgress$sizeCs = function (_v0) {
	var size = _v0.dB;
	return A3(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$Just,
		$elm$html$Html$Attributes$class,
		function () {
			switch (size) {
				case 0:
					return 'mdc-circular-progress--large';
				case 1:
					return 'mdc-circular-progress--medium';
				default:
					return 'mdc-circular-progress--small';
			}
		}());
};
var $aforemny$material_components_web_elm$Material$CircularProgress$circularProgress = F2(
	function (progress, config_) {
		var additionalAttributes = config_.fZ;
		return A3(
			$elm$html$Html$node,
			'mdc-circular-progress',
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$CircularProgress$rootCs,
							$aforemny$material_components_web_elm$Material$CircularProgress$indeterminateCs(progress),
							$aforemny$material_components_web_elm$Material$CircularProgress$sizeCs(config_),
							$aforemny$material_components_web_elm$Material$CircularProgress$progressbarRole,
							$aforemny$material_components_web_elm$Material$CircularProgress$ariaLabelAttr(config_),
							$aforemny$material_components_web_elm$Material$CircularProgress$ariaValueMinAttr,
							$aforemny$material_components_web_elm$Material$CircularProgress$ariaValueMaxAttr,
							$aforemny$material_components_web_elm$Material$CircularProgress$ariaValueNowAttr(progress),
							$aforemny$material_components_web_elm$Material$CircularProgress$determinateProp(progress),
							$aforemny$material_components_web_elm$Material$CircularProgress$progressProp(progress),
							$aforemny$material_components_web_elm$Material$CircularProgress$closedProp(config_)
						])),
				additionalAttributes),
			_List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$CircularProgress$determinateContainerElt,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Maybe$Just(
							{hx: 0}),
						A2($elm$core$Maybe$map, $elm$core$Maybe$Just, progress)),
					config_),
					$aforemny$material_components_web_elm$Material$CircularProgress$indeterminateContainerElt(config_)
				]));
	});
var $aforemny$material_components_web_elm$Material$CircularProgress$indeterminate = function (config_) {
	return A2($aforemny$material_components_web_elm$Material$CircularProgress$circularProgress, $elm$core$Maybe$Nothing, config_);
};
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $rtfeldman$elm_css$Css$maxHeight = $rtfeldman$elm_css$Css$prop1('max-height');
var $rtfeldman$elm_css$Css$maxWidth = $rtfeldman$elm_css$Css$prop1('max-width');
var $rtfeldman$elm_css$Css$minHeight = $rtfeldman$elm_css$Css$prop1('min-height');
var $rtfeldman$elm_css$Css$minWidth = $rtfeldman$elm_css$Css$prop1('min-width');
var $rtfeldman$elm_css$Css$overflowY = $rtfeldman$elm_css$Css$prop1('overflow-y');
var $rtfeldman$elm_css$Css$prop2 = F3(
	function (key, argA, argB) {
		return A2(
			$rtfeldman$elm_css$Css$property,
			key,
			A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[argA.eL, argB.eL])));
	});
var $rtfeldman$elm_css$Css$padding2 = $rtfeldman$elm_css$Css$prop2('padding');
var $rtfeldman$elm_css$Css$PxUnits = 0;
var $rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
	function (units, unitLabel, numericValue) {
		return {
			h3: 0,
			$9: 0,
			c$: 0,
			gz: 0,
			g: 0,
			db: 0,
			bw: 0,
			dc: 0,
			dd: 0,
			b5: 0,
			b6: 0,
			a4: 0,
			bA: numericValue,
			dH: 0,
			dJ: unitLabel,
			eH: units,
			eL: _Utils_ap(
				$elm$core$String$fromFloat(numericValue),
				unitLabel)
		};
	});
var $rtfeldman$elm_css$Css$px = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'px');
var $avh4$elm_color$Color$RgbaSpace = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $avh4$elm_color$Color$rgb = F3(
	function (r, g, b) {
		return A4($avh4$elm_color$Color$RgbaSpace, r, g, b, 1.0);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
	return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
		$elm$virtual_dom$VirtualDom$text(str));
};
var $rtfeldman$elm_css$Html$Styled$text = $rtfeldman$elm_css$VirtualDom$Styled$text;
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
	function (_v0, styles) {
		var newStyles = _v0.b;
		var classname = _v0.c;
		return $elm$core$List$isEmpty(newStyles) ? styles : A3($elm$core$Dict$insert, classname, newStyles, styles);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = function (_v0) {
	var val = _v0.a;
	return val;
};
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_keyedNodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
	return _VirtualDom_nodeNS(
		_VirtualDom_noScript(tag));
};
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
	function (_v6, _v7) {
		var key = _v6.a;
		var html = _v6.b;
		var pairs = _v7.a;
		var styles = _v7.b;
		switch (html.$) {
			case 4:
				var vdom = html.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v9 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v9.a;
				var finalStyles = _v9.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v10 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v10.a;
				var finalStyles = _v10.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v11 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v11.a;
				var finalStyles = _v11.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v12 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v12.a;
				var finalStyles = _v12.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
	function (html, _v0) {
		var nodes = _v0.a;
		var styles = _v0.b;
		switch (html.$) {
			case 4:
				var vdomNode = html.a;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v2 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v2.a;
				var finalStyles = _v2.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v3 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v3.a;
				var finalStyles = _v3.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v4 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v4.a;
				var finalStyles = _v4.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v5 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v5.a;
				var finalStyles = _v5.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
		}
	});
var $elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp = F2(
	function (candidate, properties) {
		stylesFromPropertiesHelp:
		while (true) {
			if (!properties.b) {
				return candidate;
			} else {
				var _v1 = properties.a;
				var styles = _v1.b;
				var classname = _v1.c;
				var rest = properties.b;
				if ($elm$core$String$isEmpty(classname)) {
					var $temp$candidate = candidate,
						$temp$properties = rest;
					candidate = $temp$candidate;
					properties = $temp$properties;
					continue stylesFromPropertiesHelp;
				} else {
					var $temp$candidate = $elm$core$Maybe$Just(
						_Utils_Tuple2(classname, styles)),
						$temp$properties = rest;
					candidate = $temp$candidate;
					properties = $temp$properties;
					continue stylesFromPropertiesHelp;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties = function (properties) {
	var _v0 = A2($rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp, $elm$core$Maybe$Nothing, properties);
	if (_v0.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var _v1 = _v0.a;
		var classname = _v1.a;
		var styles = _v1.b;
		return A2($elm$core$Dict$singleton, classname, styles);
	}
};
var $rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair = function (_v0) {
	var classname = _v0.a;
	var styles = _v0.b;
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
		styles,
		$rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$ClassSelector(classname)
				])));
};
var $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
	return $rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
		$elm$core$List$singleton(
			$rtfeldman$elm_css$Css$Preprocess$stylesheet(
				A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair,
					$elm$core$Dict$toList(dict)))));
};
var $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = function (styles) {
	return A3(
		$elm$virtual_dom$VirtualDom$node,
		'style',
		_List_Nil,
		$elm$core$List$singleton(
			$elm$virtual_dom$VirtualDom$text(
				$rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))));
};
var $rtfeldman$elm_css$VirtualDom$Styled$unstyle = F3(
	function (elemType, properties, children) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
	function (key, pairs) {
		containsKey:
		while (true) {
			if (!pairs.b) {
				return false;
			} else {
				var _v1 = pairs.a;
				var str = _v1.a;
				var rest = pairs.b;
				if (_Utils_eq(key, str)) {
					return true;
				} else {
					var $temp$key = key,
						$temp$pairs = rest;
					key = $temp$key;
					pairs = $temp$pairs;
					continue containsKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
	function (_default, pairs) {
		getUnusedKey:
		while (true) {
			if (!pairs.b) {
				return _default;
			} else {
				var _v1 = pairs.a;
				var firstKey = _v1.a;
				var rest = pairs.b;
				var newKey = '_' + firstKey;
				if (A2($rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
					var $temp$default = newKey,
						$temp$pairs = rest;
					_default = $temp$default;
					pairs = $temp$pairs;
					continue getUnusedKey;
				} else {
					return newKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F2(
	function (allStyles, keyedChildNodes) {
		var styleNodeKey = A2($rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
		var finalNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(allStyles);
		return _Utils_Tuple2(styleNodeKey, finalNode);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F3(
	function (elemType, properties, keyedChildren) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
		return A3(
			$elm$virtual_dom$VirtualDom$keyedNode,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F4(
	function (ns, elemType, properties, keyedChildren) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
		return A4(
			$elm$virtual_dom$VirtualDom$keyedNodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F4(
	function (ns, elemType, properties, children) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
		return A4(
			$elm$virtual_dom$VirtualDom$nodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
	switch (vdom.$) {
		case 4:
			var plainNode = vdom.a;
			return plainNode;
		case 0:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A3($rtfeldman$elm_css$VirtualDom$Styled$unstyle, elemType, properties, children);
		case 1:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, ns, elemType, properties, children);
		case 2:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A3($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, elemType, properties, children);
		default:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, ns, elemType, properties, children);
	}
};
var $rtfeldman$elm_css$Html$Styled$toUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
var $rtfeldman$elm_css$Css$VhUnits = 0;
var $rtfeldman$elm_css$Css$vh = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'vh');
var $author$project$Dialogs$Gallery$CloseConfirmDelete = {$: 10};
var $author$project$Dialogs$Gallery$DeleteImage = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Dialogs$Gallery$viewDeleteButton = F2(
	function (config, model) {
		var onClick = A2($author$project$Dialogs$Gallery$DeleteImage, config.gM, model.bU.b);
		return A2(
			$aforemny$material_components_web_elm$Material$Button$outlined,
			A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config),
			'Delete');
	});
var $author$project$Dialogs$Gallery$viewConfirmDeleteDialog = F2(
	function (config, model) {
		return A2(
			$aforemny$material_components_web_elm$Material$Dialog$dialog,
			A2(
				$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
				$author$project$Dialogs$Gallery$CloseConfirmDelete,
				A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.bU.a, $aforemny$material_components_web_elm$Material$Dialog$config)),
			{
				kk: _List_fromArray(
					[
						A2($author$project$Dialogs$Gallery$viewDeleteButton, config, model),
						A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Dialogs$Gallery$CloseConfirmDelete, $aforemny$material_components_web_elm$Material$Button$config),
						'Close')
					]),
				k_: _List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$toUnstyled(
						$rtfeldman$elm_css$Html$Styled$text('Are you sure you want to delete the image ?'))
					]),
				na: $elm$core$Maybe$Just('Confirm Delete')
			});
	});
var $rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$Internal$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
	function (functionName, desiredKey, style) {
		getOverloadedProperty:
		while (true) {
			switch (style.$) {
				case 0:
					var str = style.a;
					var key = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2($elm$core$String$split, ':', str)));
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
				case 1:
					var selector = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
				case 2:
					var combinator = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
				case 3:
					var pseudoElement = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
				case 4:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
				case 5:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
				default:
					if (!style.a.b) {
						return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
					} else {
						if (!style.a.b.b) {
							var _v1 = style.a;
							var only = _v1.a;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = only;
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						} else {
							var _v2 = style.a;
							var first = _v2.a;
							var rest = _v2.b;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						}
					}
			}
		}
	});
var $rtfeldman$elm_css$Css$Internal$IncompatibleUnits = 0;
var $rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '', 0);
var $rtfeldman$elm_css$Css$alignItems = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'alignItems',
		'align-items',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$VirtualDom$Styled$property = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$property, key, value),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$alt = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('alt');
var $rtfeldman$elm_css$VirtualDom$Styled$attribute = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$attribute, key, value),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$attribute = $rtfeldman$elm_css$VirtualDom$Styled$attribute;
var $rtfeldman$elm_css$Html$Styled$button = $rtfeldman$elm_css$Html$Styled$node('button');
var $rtfeldman$elm_css$Css$center = $rtfeldman$elm_css$Css$prop1('center');
var $rtfeldman$elm_css$Html$Styled$Attributes$class = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('className');
var $rtfeldman$elm_css$Css$row = {gw: 0, d9: 0, eL: 'row'};
var $rtfeldman$elm_css$Css$column = _Utils_update(
	$rtfeldman$elm_css$Css$row,
	{eL: 'column'});
var $rtfeldman$elm_css$Css$cursor = $rtfeldman$elm_css$Css$prop1('cursor');
var $author$project$Mdl$Elevation$e2 = $elm$html$Html$Attributes$class('mdl-shadow--2dp');
var $rtfeldman$elm_css$Css$flexDirection = $rtfeldman$elm_css$Css$prop1('flex-direction');
var $rtfeldman$elm_css$VirtualDom$Styled$unstyledAttribute = function (prop) {
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, prop, _List_Nil, '');
};
var $rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$unstyledAttribute;
var $rtfeldman$elm_css$Css$height = $rtfeldman$elm_css$Css$prop1('height');
var $rtfeldman$elm_css$Html$Styled$img = $rtfeldman$elm_css$Html$Styled$node('img');
var $rtfeldman$elm_css$Css$margin = $rtfeldman$elm_css$Css$prop1('margin');
var $rtfeldman$elm_css$Css$marginBottom = $rtfeldman$elm_css$Css$prop1('margin-bottom');
var $rtfeldman$elm_css$Css$padding = $rtfeldman$elm_css$Css$prop1('padding');
var $rtfeldman$elm_css$Css$PercentageUnits = 0;
var $rtfeldman$elm_css$Css$pct = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '%');
var $rtfeldman$elm_css$Css$pointer = {d: 0, eL: 'pointer'};
var $rtfeldman$elm_css$Html$Styled$Attributes$src = function (url) {
	return A2($rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'src', url);
};
var $author$project$Dialogs$Gallery$OpenConfirmDelete = function (a) {
	return {$: 7, a: a};
};
var $aforemny$material_components_web_elm$Material$IconButton$Internal$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$IconButton$config = {fZ: _List_Nil, d$: false, ed: $elm$core$Maybe$Nothing, c9: $elm$core$Maybe$Nothing, g0: $elm$core$Maybe$Nothing, he: $elm$core$Maybe$Nothing, hN: $elm$core$Maybe$Nothing};
var $aforemny$material_components_web_elm$Material$IconButton$Internal$Icon = function (a) {
	return {$: 0, a: a};
};
var $aforemny$material_components_web_elm$Material$IconButton$customIcon = F3(
	function (node, attributes, nodes) {
		return $aforemny$material_components_web_elm$Material$IconButton$Internal$Icon(
			{eP: attributes, aJ: node, ft: nodes});
	});
var $elm$html$Html$i = _VirtualDom_node('i');
var $aforemny$material_components_web_elm$Material$IconButton$icon = function (iconName) {
	return A3(
		$aforemny$material_components_web_elm$Material$IconButton$customIcon,
		$elm$html$Html$i,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('material-icons')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(iconName)
			]));
};
var $aforemny$material_components_web_elm$Material$IconButton$clickHandler = function (_v0) {
	var onClick = _v0.he;
	return A2($elm$core$Maybe$map, $elm$html$Html$Events$onClick, onClick);
};
var $aforemny$material_components_web_elm$Material$IconButton$disabledAttr = function (_v0) {
	var disabled = _v0.d$;
	return $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$disabled(disabled));
};
var $aforemny$material_components_web_elm$Material$IconButton$hrefAttr = function (_v0) {
	var href = _v0.ed;
	return A2($elm$core$Maybe$map, $elm$html$Html$Attributes$href, href);
};
var $aforemny$material_components_web_elm$Material$IconButton$iconButtonCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-icon-button'));
var $aforemny$material_components_web_elm$Material$Menu$surfaceAnchor = $elm$html$Html$Attributes$class('mdc-menu-surface--anchor');
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $aforemny$material_components_web_elm$Material$IconButton$tabIndexProp = $elm$html$Html$Attributes$tabindex(0);
var $aforemny$material_components_web_elm$Material$IconButton$targetAttr = function (_v0) {
	var href = _v0.ed;
	var target = _v0.hN;
	return (!_Utils_eq(href, $elm$core$Maybe$Nothing)) ? A2($elm$core$Maybe$map, $elm$html$Html$Attributes$target, target) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$IconButton$iconButton = F2(
	function (config_, icon_) {
		var innerConfig = config_;
		var additionalAttributes = innerConfig.fZ;
		var href = innerConfig.ed;
		var disabled = innerConfig.d$;
		var wrapMenu = function (node) {
			var _v1 = innerConfig.g0;
			if (_v1.$ === 1) {
				return node;
			} else {
				var _v2 = _v1.a;
				var menuConfig = _v2.a;
				var menuNodes = _v2.b;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[$aforemny$material_components_web_elm$Material$Menu$surfaceAnchor]),
					_List_fromArray(
						[
							node,
							A2($aforemny$material_components_web_elm$Material$Menu$menu, menuConfig, menuNodes)
						]));
			}
		};
		return wrapMenu(
			A3(
				$elm$html$Html$node,
				'mdc-icon-button',
				_List_fromArray(
					[$aforemny$material_components_web_elm$Material$IconButton$tabIndexProp]),
				_List_fromArray(
					[
						A2(
						((!_Utils_eq(href, $elm$core$Maybe$Nothing)) && (!disabled)) ? $elm$html$Html$a : $elm$html$Html$button,
						_Utils_ap(
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										$aforemny$material_components_web_elm$Material$IconButton$iconButtonCs,
										$aforemny$material_components_web_elm$Material$IconButton$hrefAttr(config_),
										$aforemny$material_components_web_elm$Material$IconButton$targetAttr(config_),
										$aforemny$material_components_web_elm$Material$IconButton$disabledAttr(config_),
										$aforemny$material_components_web_elm$Material$IconButton$clickHandler(config_)
									])),
							additionalAttributes),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								function () {
									if (!icon_.$) {
										var node = icon_.a.aJ;
										var attributes = icon_.a.eP;
										var nodes = icon_.a.ft;
										return A2(
											node,
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Attributes$class('mdc-icon-button__icon'),
												attributes),
											nodes);
									} else {
										var node = icon_.a.aJ;
										var attributes = icon_.a.eP;
										var nodes = icon_.a.ft;
										return A2(
											node,
											A2(
												$elm$core$List$cons,
												$elm$svg$Svg$Attributes$class('mdc-icon-button__icon'),
												attributes),
											nodes);
									}
								}())
							]))
					])));
	});
var $aforemny$material_components_web_elm$Material$IconButton$setAttributes = F2(
	function (additionalAttributes, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{fZ: additionalAttributes});
	});
var $aforemny$material_components_web_elm$Material$IconButton$setOnClick = F2(
	function (onClick, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{
				he: $elm$core$Maybe$Just(onClick)
			});
	});
var $author$project$Dialogs$Gallery$viewImageDeleteButton = function (imageName) {
	var onClick = $author$project$Dialogs$Gallery$OpenConfirmDelete(imageName);
	return $rtfeldman$elm_css$Html$Styled$fromUnstyled(
		A2(
			$aforemny$material_components_web_elm$Material$IconButton$iconButton,
			A2(
				$aforemny$material_components_web_elm$Material$IconButton$setAttributes,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'border-radius', '8px')
					]),
				A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, onClick, $aforemny$material_components_web_elm$Material$IconButton$config)),
			$aforemny$material_components_web_elm$Material$IconButton$icon('delete')));
};
var $rtfeldman$elm_css$Css$width = $rtfeldman$elm_css$Css$prop1('width');
var $author$project$Dialogs$Gallery$viewImage = F2(
	function (model, _v0) {
		var imageName = _v0.a;
		var imgUrl = _v0.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled($author$project$Mdl$Elevation$e2),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$margin(
							$rtfeldman$elm_css$Css$px(4)),
							$rtfeldman$elm_css$Css$padding(
							$rtfeldman$elm_css$Css$px(8)),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$padding(
									$rtfeldman$elm_css$Css$px(0)),
									$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$px(205)),
									$rtfeldman$elm_css$Css$height(
									$rtfeldman$elm_css$Css$px(154)),
									$rtfeldman$elm_css$Css$marginBottom(
									$rtfeldman$elm_css$Css$px(8))
								])),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('cpy-img-btn'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-clipboard-text', imgUrl)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src(imgUrl),
									$rtfeldman$elm_css$Html$Styled$Attributes$alt('Media Library Image'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$maxWidth(
											$rtfeldman$elm_css$Css$pct(100)),
											$rtfeldman$elm_css$Css$maxHeight(
											$rtfeldman$elm_css$Css$pct(100))
										]))
								]),
							_List_Nil)
						])),
					$author$project$Dialogs$Gallery$viewImageDeleteButton(imageName)
				]));
	});
var $author$project$Dialogs$Gallery$UploadImage = function (a) {
	return {$: 3, a: a};
};
var $rtfeldman$elm_css$Css$absolute = {x: 0, eL: 'absolute'};
var $rtfeldman$elm_css$Css$block = {D: 0, eL: 'block'};
var $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$disabled = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('disabled');
var $rtfeldman$elm_css$Css$display = $rtfeldman$elm_css$Css$prop1('display');
var $rtfeldman$elm_css$Css$fontSize = $rtfeldman$elm_css$Css$prop1('font-size');
var $rtfeldman$elm_css$Css$hidden = {aa: 0, dp: 0, eL: 'hidden', eM: 0};
var $rtfeldman$elm_css$Html$Styled$Attributes$id = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('id');
var $rtfeldman$elm_css$Css$initial = {h8: 0, f2: 0, dP: 0, ig: 0, cH: 0, ih: 0, cI: 0, bh: 0, aa: 0, eR: 0, gc: 0, d: 0, D: 0, c$: 0, gw: 0, d9: 0, e6: 0, gy: 0, gz: 0, c0: 0, q: 0, bp: 0, fg: 0, i2: 0, gU: 0, g: 0, db: 0, bw: 0, dc: 0, dd: 0, b5: 0, b6: 0, a4: 0, fk: 0, i: 0, f: 0, ha: 0, l$: 0, bA: 0, fA: 0, dp: 0, aP: 0, fM: 0, dF: 0, cw: 0, dH: 0, dI: 0, cx: 0, am: 0, dJ: '', eH: 0, eL: 'initial', eM: 0, bM: 0};
var $rtfeldman$elm_css$Css$inherit = _Utils_update(
	$rtfeldman$elm_css$Css$initial,
	{eL: 'inherit'});
var $rtfeldman$elm_css$Html$Styled$input = $rtfeldman$elm_css$Html$Styled$node('input');
var $rtfeldman$elm_css$Html$Styled$label = $rtfeldman$elm_css$Html$Styled$node('label');
var $rtfeldman$elm_css$Css$UnitlessFloat = 0;
var $rtfeldman$elm_css$Css$num = function (val) {
	return {
		b6: 0,
		a4: 0,
		l$: 0,
		fu: 0,
		bA: val,
		dJ: '',
		eH: 0,
		eL: $elm$core$String$fromFloat(val)
	};
};
var $rtfeldman$elm_css$VirtualDom$Styled$on = F2(
	function (eventName, handler) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$on, eventName, handler),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Events$on = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $rtfeldman$elm_css$Css$opacity = $rtfeldman$elm_css$Css$prop1('opacity');
var $rtfeldman$elm_css$Css$overflow = $rtfeldman$elm_css$Css$prop1('overflow');
var $rtfeldman$elm_css$Css$position = $rtfeldman$elm_css$Css$prop1('position');
var $rtfeldman$elm_css$Css$relative = {x: 0, eL: 'relative'};
var $rtfeldman$elm_css$Css$right = $rtfeldman$elm_css$Css$prop1('right');
var $rtfeldman$elm_css$Css$textAlign = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'textAlign',
		'text-align',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$top = $rtfeldman$elm_css$Css$prop1('top');
var $rtfeldman$elm_css$Html$Styled$Attributes$type_ = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('type');
var $author$project$Dialogs$Gallery$viewUploadButton = F2(
	function (config, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
							$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
							$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							function () {
							var _v0 = _Utils_Tuple2(model.ah, model.bu);
							if (_v0.b === 1) {
								var _v1 = _v0.b;
								return $rtfeldman$elm_css$Html$Styled$Attributes$class('mdl-button mdl-button--disabled');
							} else {
								if (_v0.a.$ === 1) {
									var _v2 = _v0.a;
									return $rtfeldman$elm_css$Html$Styled$Attributes$class('mdl-button mdl-button--disabled');
								} else {
									return $rtfeldman$elm_css$Html$Styled$Attributes$class('mdl-button mdl-button--raised mdl-button--colored');
								}
							}
						}()
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Upload')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('file'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(config.gm),
							(model.bu === 1) ? $rtfeldman$elm_css$Html$Styled$Attributes$disabled(true) : $rtfeldman$elm_css$Html$Styled$Attributes$disabled(false),
							A2(
							$rtfeldman$elm_css$Html$Styled$Events$on,
							'change',
							$elm$json$Json$Decode$succeed(
								$author$project$Dialogs$Gallery$UploadImage(config))),
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$inherit),
									$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
									$rtfeldman$elm_css$Css$fontSize(
									$rtfeldman$elm_css$Css$px(999)),
									A2($rtfeldman$elm_css$Css$property, 'filter', 'aplha(opacity=0)'),
									$rtfeldman$elm_css$Css$minHeight(
									$rtfeldman$elm_css$Css$pct(100)),
									$rtfeldman$elm_css$Css$minWidth(
									$rtfeldman$elm_css$Css$pct(100)),
									$rtfeldman$elm_css$Css$opacity(
									$rtfeldman$elm_css$Css$num(0)),
									$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
									$rtfeldman$elm_css$Css$right(
									$rtfeldman$elm_css$Css$px(0)),
									$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right),
									$rtfeldman$elm_css$Css$top(
									$rtfeldman$elm_css$Css$px(0))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Upload')
						]))
				]));
	});
var $rtfeldman$elm_css$Css$VwUnits = 0;
var $rtfeldman$elm_css$Css$vw = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'vw');
var $rtfeldman$elm_css$Css$wrap = {d9: 0, e6: 0, eL: 'wrap'};
var $author$project$Dialogs$Gallery$view = F2(
	function (config, model) {
		return A2(
			$aforemny$material_components_web_elm$Material$Dialog$dialog,
			A2(
				$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
				$author$project$Dialogs$Gallery$CloseDialog,
				A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.bX, $aforemny$material_components_web_elm$Material$Dialog$config)),
			{
				kk: _List_fromArray(
					[
						A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Dialogs$Gallery$CloseDialog, $aforemny$material_components_web_elm$Material$Button$config),
						'Close'),
						$rtfeldman$elm_css$Html$Styled$toUnstyled(
						A2($author$project$Dialogs$Gallery$viewUploadButton, config, model)),
						function () {
						var _v0 = model.bu;
						switch (_v0) {
							case 1:
								return $aforemny$material_components_web_elm$Material$CircularProgress$indeterminate($aforemny$material_components_web_elm$Material$CircularProgress$config);
							case 2:
								return A2(
									$danmarcab$material_icons$Material$Icons$Action$check_circle,
									A3($avh4$elm_color$Color$rgb, 0, 0, 0),
									24);
							case 0:
								return $rtfeldman$elm_css$Html$Styled$toUnstyled(
									$rtfeldman$elm_css$Html$Styled$text(''));
							default:
								return A2(
									$danmarcab$material_icons$Material$Icons$Alert$error,
									A3($avh4$elm_color$Color$rgb, 255, 0, 0),
									24);
						}
					}()
					]),
				k_: _List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$toUnstyled(
						A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$minWidth(
											$rtfeldman$elm_css$Css$vw(54)),
											$rtfeldman$elm_css$Css$maxWidth(
											$rtfeldman$elm_css$Css$px(850)),
											$rtfeldman$elm_css$Css$minHeight(
											$rtfeldman$elm_css$Css$vh(60)),
											$rtfeldman$elm_css$Css$maxHeight(
											$rtfeldman$elm_css$Css$px(600)),
											$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$auto),
											A2(
											$rtfeldman$elm_css$Css$padding2,
											$rtfeldman$elm_css$Css$px(0),
											$rtfeldman$elm_css$Css$px(12)),
											$rtfeldman$elm_css$Css$displayFlex,
											$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
											A2($rtfeldman$elm_css$Css$property, 'align-content', 'flex-start')
										]))
								]),
							function () {
								var _v1 = model.ah;
								switch (_v1.$) {
									case 0:
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Images are loading...')
											]);
									case 1:
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$fromUnstyled(
												A2(
													$danmarcab$material_icons$Material$Icons$Alert$error,
													A3($avh4$elm_color$Color$rgb, 255, 0, 0),
													24)),
												$rtfeldman$elm_css$Html$Styled$text('Unable to load images at this time')
											]);
									default:
										var images = _v1.a;
										return $elm$core$Dict$isEmpty(images) ? _List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('No Images in your library or images are loading')
											]) : A2(
											$elm$core$List$map,
											$author$project$Dialogs$Gallery$viewImage(model),
											$elm$core$Dict$toList(images));
								}
							}())),
						A2($author$project$Dialogs$Gallery$viewConfirmDeleteDialog, config, model)
					]),
				na: $elm$core$Maybe$Just('Image Library')
			});
	});
var $author$project$Dialogs$LiveCapture$HideDialog = {$: 5};
var $elm$html$Html$img = _VirtualDom_node('img');
var $aforemny$material_components_web_elm$Material$Button$Raised = 1;
var $aforemny$material_components_web_elm$Material$Button$raised = F2(
	function (config_, label) {
		return A3($aforemny$material_components_web_elm$Material$Button$button, 1, config_, label);
	});
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$Dialogs$LiveCapture$view = function (model) {
	return A2(
		$aforemny$material_components_web_elm$Material$Dialog$dialog,
		A2(
			$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
			$author$project$Dialogs$LiveCapture$HideDialog,
			A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.c8, $aforemny$material_components_web_elm$Material$Dialog$config)),
		{
			kk: _List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$Button$raised,
					A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Dialogs$LiveCapture$HideDialog, $aforemny$material_components_web_elm$Material$Button$config),
					'Close')
				]),
			k_: _List_fromArray(
				[
					function () {
					var _v0 = model.cV;
					if (!_v0.$) {
						var name = _v0.a.g8;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'padding-bottom', '16px'),
									A2($elm$html$Html$Attributes$style, 'text-align', 'center'),
									A2($elm$html$Html$Attributes$style, 'width', '100%'),
									A2($elm$html$Html$Attributes$style, 'font-size', '18px')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(name)
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}(),
					function () {
					var _v1 = model.c6;
					if (_v1.$ === 1) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'width', '100%'),
									A2($elm$html$Html$Attributes$style, 'height', '100%'),
									A2($elm$html$Html$Attributes$style, 'display', 'flex'),
									A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
									A2($elm$html$Html$Attributes$style, 'align-items', 'center')
								]),
							_List_fromArray(
								[
									$aforemny$material_components_web_elm$Material$CircularProgress$indeterminate($aforemny$material_components_web_elm$Material$CircularProgress$config)
								]));
					} else {
						var imgUrl = _v1.a;
						return A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'width', '100%'),
									A2($elm$html$Html$Attributes$style, 'height', '100%'),
									$elm$html$Html$Attributes$src(imgUrl)
								]),
							_List_Nil);
					}
				}()
				]),
			na: $elm$core$Maybe$Just('Live Capture')
		});
};
var $author$project$Dialogs$ReleaseNotes$CloseDialog = {$: 2};
var $author$project$Dialogs$ReleaseNotes$releaseNotes = '\r\n#### v2.7.7.21\r\n  * UI updates, supper section added, and fixed defects\r\n\r\n#### v2.7.7.20\r\n  * User can now set a banner text to be displayed in the status bar using the device settings page\r\n  \r\n#### v2.7.7.18\r\n  * Background image transition animation is removed\r\n  * Template playback stop/start command is removed\r\n  \r\n#### v2.7.7.17\r\n  * User can now hide the entire status bar using a checkbox in device settings\r\n\r\n#### v2.7.7.16\r\n  * Fixed an issue with the visibility of location in menu planning widget\r\n  * Templates with no menu planning widgets are displayed on TV irrespective of the status of the menu items\r\n\r\n#### v2.7.7.0\r\nGeneral Bug fixes with following new features\r\n  * User can now upload, manage and use image files with the image library feature\r\n  * User will be logged out after 60 minutes if no activity is detected\r\n  * The website will be reloaded from server on logout to fetch new updates\r\n  * Temporary menu is displayed for atleast 6 minutes\r\n\r\n#### v2.7.6\r\nInternal upgrades to make the application more robust\r\n\r\n#### v2.7.5\r\n  * View the current playing schedule on the dashboard & schedule configuration page\r\n  * User can now use the Reset button to reset schedule timings\r\n  * Release notes are automatically displayed if the website is updated\r\n  * Devices in the Sync Devices page are now grouped using the School Name\r\n\r\n#### v2.7.4\r\nInternal upgrades to make the application more robust\r\n\r\n#### v2.7.3\r\nGeneral Bug fixes and improvements with the following new features\r\n\r\n  * Release notes can be viewed by clicking \'What\'s New\' in the navigation menu\r\n  * User can now start live capture for any online device directly from the dashboard\r\n\r\n#### v2.7.2\r\nGeneral Bug fixes and improvements\r\n  \r\n#### v2.7.1\r\n\r\n  * Re-designed menu item list page to make creating/editing menu item lists easier\r\n  * Users can now duplicate menu item lists by clicking a single button\r\n  * Device is automatically backed up before every update\r\n\r\n\r\n#### v2.6.4\r\n\r\n  * Image size is now a part of Widget Configuration tab\r\n  * Slide interval can now be set to as low as 5 seconds\r\n  * Users can now set the width and height of a menu planning widget\r\n  * Text boxes now use all space available to the widget\r\n  * Text boxes can now span multiple lines\r\n\r\n#### v2.6.3\r\n\r\n\r\n  * Template selection bar is now frozen to the top of the page while scrolling\r\n  * The Preview Template pop-up will now remember the last slide the user was viewing if it is closed and re-opened\r\n  * Users can now view only online devices by using the quick action Dashboard button\r\n  * The width and height of the logo can now be set independently\r\n  * Users can now perform template cleanup by selecting the option from the dropdown menu\r\n  * Users can now go to any slide by using the input field in the dialog\r\n  * Users can now sync data between devices from different schools\r\n\r\n#### v2.6.0\r\n\r\n  * Fabric Server and device status now display in red to indicate a connection loss\r\n  * Menu items and the menu item list widget now sort items alphabetically\r\n  * A button to view/hide typed password has been added to the Login section\r\n  * Three buttons are now available to control the size of column (Small, Regular and Large)\r\n  * Selecting the school name on the Dashboard will now automatically apply a filter with the selected school\r\n  * Selecting the device name will now open the device configuration page\r\n  * The Reload Menus command is now available in both the Dashboard and device settings pages\r\n  * Users can now set a marketing name for a menu planning widget. (Note: This will replace the category title for the widget)\r\n  * The background image editor preview window will now show settings for brightness and blur effects\r\n  * User can now deactivate a device directly from the Dashboard\r\n  * User can now select a scale factor to fit more menu items in small spaces\r\n\r\n#### v2.5.48\r\nGeneral Bug fixes and improvements\r\n  \r\n#### v2.5.46\r\n\r\n  * For menu planning widgets, the Location style is now independent of the Title style\r\n\r\n#### v2.5.45\r\nGeneral Bug fixes and improvements\r\n  \r\n  \r\n  * A loading symbol is now displayed when a template is being synced to the device\r\n  * A device will now keep reloading its menu until a valid menu is returned\r\n  * Date and Schedule are pre-selected for the template preview window\r\n  \r\n';
var $pablohirafuji$elm_markdown$Markdown$Block$BlockQuote = function (a) {
	return {$: 5, a: a};
};
var $pablohirafuji$elm_markdown$Markdown$Block$List = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $pablohirafuji$elm_markdown$Markdown$Block$Paragraph = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $pablohirafuji$elm_markdown$Markdown$Block$formatParagraphLine = function (rawParagraph) {
	return (A2($elm$core$String$right, 2, rawParagraph) === '  ') ? ($elm$core$String$trim(rawParagraph) + '  ') : $elm$core$String$trim(rawParagraph);
};
var $pablohirafuji$elm_markdown$Markdown$Block$addToParagraph = F2(
	function (paragraph, rawLine) {
		return A2(
			$pablohirafuji$elm_markdown$Markdown$Block$Paragraph,
			paragraph + ('\n' + $pablohirafuji$elm_markdown$Markdown$Block$formatParagraphLine(rawLine)),
			_List_Nil);
	});
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {iX: index, lU: match, l$: number, mM: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{kU: false, lZ: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $pablohirafuji$elm_markdown$Markdown$Block$blockQuoteLineRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^ {0,3}(?:>[ ]?)(.*)$'));
var $pablohirafuji$elm_markdown$Markdown$Block$blankLineRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\\s*$'));
var $elm$regex$Regex$contains = _Regex_contains;
var $pablohirafuji$elm_markdown$Markdown$Block$calcListIndentLength = function (_v0) {
	var listBlock = _v0.a;
	var indentSpace = _v0.b;
	var rawLine = _v0.c;
	var indentSpaceLength = $elm$core$String$length(indentSpace);
	var isIndentedCode = indentSpaceLength >= 4;
	var updtRawLine = isIndentedCode ? _Utils_ap(indentSpace, rawLine) : rawLine;
	var indentLength = (isIndentedCode || A2($elm$regex$Regex$contains, $pablohirafuji$elm_markdown$Markdown$Block$blankLineRegex, rawLine)) ? (listBlock.T - indentSpaceLength) : listBlock.T;
	return _Utils_Tuple2(
		_Utils_update(
			listBlock,
			{T: indentLength}),
		updtRawLine);
};
var $pablohirafuji$elm_markdown$Markdown$Block$atxHeadingLineRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^ {0,3}(#{1,6})' + ('(?:[ \\t]+[ \\t#]+$|[ \\t]+|$)' + '(.*?)(?:\\s+[ \\t#]*)?$')));
var $pablohirafuji$elm_markdown$Markdown$Block$Heading = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $pablohirafuji$elm_markdown$Markdown$Block$extractATXHeadingRM = function (match) {
	var _v0 = match.mM;
	if ((_v0.b && (!_v0.a.$)) && _v0.b.b) {
		var lvl = _v0.a.a;
		var _v1 = _v0.b;
		var maybeHeading = _v1.a;
		return $elm$core$Maybe$Just(
			A3(
				$pablohirafuji$elm_markdown$Markdown$Block$Heading,
				A2($elm$core$Maybe$withDefault, '', maybeHeading),
				$elm$core$String$length(lvl),
				_List_Nil));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$regex$Regex$findAtMost = _Regex_findAtMost;
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Block$checkATXHeadingLine = function (_v0) {
	var rawLine = _v0.a;
	var ast = _v0.b;
	return A2(
		$elm$core$Result$fromMaybe,
		_Utils_Tuple2(rawLine, ast),
		A2(
			$elm$core$Maybe$map,
			function (a) {
				return A2($elm$core$List$cons, a, ast);
			},
			A2(
				$elm$core$Maybe$andThen,
				$pablohirafuji$elm_markdown$Markdown$Block$extractATXHeadingRM,
				$elm$core$List$head(
					A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$Block$atxHeadingLineRegex, rawLine)))));
};
var $pablohirafuji$elm_markdown$Markdown$Block$BlankLine = function (a) {
	return {$: 0, a: a};
};
var $pablohirafuji$elm_markdown$Markdown$Block$CodeBlock = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $pablohirafuji$elm_markdown$Markdown$Block$Fenced = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $pablohirafuji$elm_markdown$Markdown$Block$addBlankLineToListBlock = F2(
	function (match, asts) {
		if (!asts.b) {
			return _List_fromArray(
				[
					_List_fromArray(
					[
						$pablohirafuji$elm_markdown$Markdown$Block$BlankLine(match.lU)
					])
				]);
		} else {
			var ast = asts.a;
			var astsTail = asts.b;
			return A2(
				$elm$core$List$cons,
				A2($pablohirafuji$elm_markdown$Markdown$Block$parseBlankLine, ast, match),
				astsTail);
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Block$parseBlankLine = F2(
	function (ast, match) {
		_v0$2:
		while (true) {
			if (ast.b) {
				switch (ast.a.$) {
					case 3:
						if ((ast.a.a.$ === 1) && ast.a.a.a) {
							var _v1 = ast.a;
							var _v2 = _v1.a;
							var fence = _v2.b;
							var code = _v1.b;
							var astTail = ast.b;
							return function (a) {
								return A2($elm$core$List$cons, a, astTail);
							}(
								A2(
									$pablohirafuji$elm_markdown$Markdown$Block$CodeBlock,
									A2($pablohirafuji$elm_markdown$Markdown$Block$Fenced, true, fence),
									code + '\n'));
						} else {
							break _v0$2;
						}
					case 6:
						var _v3 = ast.a;
						var model = _v3.a;
						var items = _v3.b;
						var astTail = ast.b;
						return A2(
							$elm$core$List$cons,
							A2(
								$pablohirafuji$elm_markdown$Markdown$Block$List,
								model,
								A2($pablohirafuji$elm_markdown$Markdown$Block$addBlankLineToListBlock, match, items)),
							astTail);
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return A2(
			$elm$core$List$cons,
			$pablohirafuji$elm_markdown$Markdown$Block$BlankLine(match.lU),
			ast);
	});
var $pablohirafuji$elm_markdown$Markdown$Block$checkBlankLine = function (_v0) {
	var rawLine = _v0.a;
	var ast = _v0.b;
	return A2(
		$elm$core$Result$fromMaybe,
		_Utils_Tuple2(rawLine, ast),
		A2(
			$elm$core$Maybe$map,
			$pablohirafuji$elm_markdown$Markdown$Block$parseBlankLine(ast),
			$elm$core$List$head(
				A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$Block$blankLineRegex, rawLine))));
};
var $pablohirafuji$elm_markdown$Markdown$Block$indentedCodeLineRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^(?: {4,4}| {0,3}\\t)(.*)$'));
var $pablohirafuji$elm_markdown$Markdown$Block$Indented = {$: 0};
var $pablohirafuji$elm_markdown$Markdown$Block$blocksAfterBlankLines = F2(
	function (ast, blankLines) {
		blocksAfterBlankLines:
		while (true) {
			if (ast.b && (!ast.a.$)) {
				var blankStr = ast.a.a;
				var astTail = ast.b;
				var $temp$ast = astTail,
					$temp$blankLines = A2($elm$core$List$cons, blankStr, blankLines);
				ast = $temp$ast;
				blankLines = $temp$blankLines;
				continue blocksAfterBlankLines;
			} else {
				return _Utils_Tuple2(ast, blankLines);
			}
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Block$maybeContinueParagraph = F2(
	function (rawLine, ast) {
		_v0$3:
		while (true) {
			if (ast.b) {
				switch (ast.a.$) {
					case 4:
						var _v1 = ast.a;
						var paragraph = _v1.a;
						var astTail = ast.b;
						return $elm$core$Maybe$Just(
							A2(
								$elm$core$List$cons,
								A2($pablohirafuji$elm_markdown$Markdown$Block$addToParagraph, paragraph, rawLine),
								astTail));
					case 5:
						var bqAST = ast.a.a;
						var astTail = ast.b;
						return A2(
							$elm$core$Maybe$map,
							function (updtBqAST) {
								return A2(
									$elm$core$List$cons,
									$pablohirafuji$elm_markdown$Markdown$Block$BlockQuote(updtBqAST),
									astTail);
							},
							A2($pablohirafuji$elm_markdown$Markdown$Block$maybeContinueParagraph, rawLine, bqAST));
					case 6:
						var _v2 = ast.a;
						var model = _v2.a;
						var items = _v2.b;
						var astTail = ast.b;
						if (items.b) {
							var itemAST = items.a;
							var itemASTTail = items.b;
							return A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function (a) {
										return A2($elm$core$List$cons, a, itemASTTail);
									},
									A2(
										$elm$core$Basics$composeR,
										$pablohirafuji$elm_markdown$Markdown$Block$List(model),
										function (a) {
											return A2($elm$core$List$cons, a, astTail);
										})),
								A2($pablohirafuji$elm_markdown$Markdown$Block$maybeContinueParagraph, rawLine, itemAST));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					default:
						break _v0$3;
				}
			} else {
				break _v0$3;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $elm$regex$Regex$replaceAtMost = _Regex_replaceAtMost;
var $pablohirafuji$elm_markdown$Markdown$Helpers$tabRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('\\t'));
var $pablohirafuji$elm_markdown$Markdown$Helpers$indentLine = function (indentLength_) {
	return A2(
		$elm$core$Basics$composeR,
		A2(
			$elm$regex$Regex$replace,
			$pablohirafuji$elm_markdown$Markdown$Helpers$tabRegex,
			function (_v0) {
				return '    ';
			}),
		A3(
			$elm$regex$Regex$replaceAtMost,
			1,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString(
					'^ {0,' + ($elm$core$String$fromInt(indentLength_) + '}'))),
			function (_v1) {
				return '';
			}));
};
var $pablohirafuji$elm_markdown$Markdown$Block$resumeIndentedCodeBlock = F2(
	function (codeLine, _v0) {
		var remainBlocks = _v0.a;
		var blankLines = _v0.b;
		if ((remainBlocks.b && (remainBlocks.a.$ === 3)) && (!remainBlocks.a.a.$)) {
			var _v2 = remainBlocks.a;
			var _v3 = _v2.a;
			var codeStr = _v2.b;
			var remainBlocksTail = remainBlocks.b;
			return $elm$core$Maybe$Just(
				function (a) {
					return A2($elm$core$List$cons, a, remainBlocksTail);
				}(
					A2(
						$pablohirafuji$elm_markdown$Markdown$Block$CodeBlock,
						$pablohirafuji$elm_markdown$Markdown$Block$Indented,
						function (a) {
							return a + (codeLine + '\n');
						}(
							_Utils_ap(
								codeStr,
								$elm$core$String$concat(
									A2(
										$elm$core$List$map,
										function (bl) {
											return A2($pablohirafuji$elm_markdown$Markdown$Helpers$indentLine, 4, bl) + '\n';
										},
										blankLines)))))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Block$parseIndentedCodeLine = F2(
	function (ast, codeLine) {
		_v0$2:
		while (true) {
			if (ast.b) {
				switch (ast.a.$) {
					case 3:
						if (!ast.a.a.$) {
							var _v1 = ast.a;
							var _v2 = _v1.a;
							var codeStr = _v1.b;
							var astTail = ast.b;
							return function (a) {
								return A2($elm$core$List$cons, a, astTail);
							}(
								A2($pablohirafuji$elm_markdown$Markdown$Block$CodeBlock, $pablohirafuji$elm_markdown$Markdown$Block$Indented, codeStr + (codeLine + '\n')));
						} else {
							break _v0$2;
						}
					case 0:
						var blankStr = ast.a.a;
						var astTail = ast.b;
						return A2(
							$elm$core$Maybe$withDefault,
							function (a) {
								return A2($elm$core$List$cons, a, ast);
							}(
								A2($pablohirafuji$elm_markdown$Markdown$Block$CodeBlock, $pablohirafuji$elm_markdown$Markdown$Block$Indented, codeLine + '\n')),
							A2(
								$pablohirafuji$elm_markdown$Markdown$Block$resumeIndentedCodeBlock,
								codeLine,
								A2(
									$pablohirafuji$elm_markdown$Markdown$Block$blocksAfterBlankLines,
									astTail,
									_List_fromArray(
										[blankStr]))));
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return A2(
			$elm$core$Maybe$withDefault,
			function (a) {
				return A2($elm$core$List$cons, a, ast);
			}(
				A2($pablohirafuji$elm_markdown$Markdown$Block$CodeBlock, $pablohirafuji$elm_markdown$Markdown$Block$Indented, codeLine + '\n')),
			A2($pablohirafuji$elm_markdown$Markdown$Block$maybeContinueParagraph, codeLine, ast));
	});
var $pablohirafuji$elm_markdown$Markdown$Block$checkIndentedCode = function (_v0) {
	var rawLine = _v0.a;
	var ast = _v0.b;
	return A2(
		$elm$core$Result$fromMaybe,
		_Utils_Tuple2(rawLine, ast),
		A2(
			$elm$core$Maybe$map,
			$pablohirafuji$elm_markdown$Markdown$Block$parseIndentedCodeLine(ast),
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Maybe$Nothing,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.mM;
							},
							$elm$core$List$head),
						$elm$core$List$head(
							A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$Block$indentedCodeLineRegex, rawLine)))))));
};
var $pablohirafuji$elm_markdown$Markdown$Entity$decimalRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&#([0-9]{1,8});'));
var $pablohirafuji$elm_markdown$Markdown$Entity$isBadEndUnicode = function (_int) {
	var remain_ = A2($elm$core$Basics$modBy, 16, _int);
	var remain = A2($elm$core$Basics$modBy, 131070, _int);
	return (_int >= 131070) && ((((0 <= remain) && (remain <= 15)) || ((65536 <= remain) && (remain <= 65551))) && ((remain_ === 14) || (remain_ === 15)));
};
var $pablohirafuji$elm_markdown$Markdown$Entity$isValidUnicode = function (_int) {
	return (_int === 9) || ((_int === 10) || ((_int === 13) || ((_int === 133) || (((32 <= _int) && (_int <= 126)) || (((160 <= _int) && (_int <= 55295)) || (((57344 <= _int) && (_int <= 64975)) || (((65008 <= _int) && (_int <= 65533)) || ((65536 <= _int) && (_int <= 1114109)))))))));
};
var $pablohirafuji$elm_markdown$Markdown$Entity$validUnicode = function (_int) {
	return ($pablohirafuji$elm_markdown$Markdown$Entity$isValidUnicode(_int) && (!$pablohirafuji$elm_markdown$Markdown$Entity$isBadEndUnicode(_int))) ? $elm$core$String$fromChar(
		$elm$core$Char$fromCode(_int)) : $elm$core$String$fromChar(
		$elm$core$Char$fromCode(65533));
};
var $pablohirafuji$elm_markdown$Markdown$Entity$replaceDecimal = function (match) {
	return A2(
		$elm$core$Maybe$withDefault,
		match.lU,
		A2(
			$elm$core$Maybe$map,
			$pablohirafuji$elm_markdown$Markdown$Entity$validUnicode,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					$elm$core$List$head(match.mM)))));
};
var $pablohirafuji$elm_markdown$Markdown$Entity$replaceDecimals = A2($elm$regex$Regex$replace, $pablohirafuji$elm_markdown$Markdown$Entity$decimalRegex, $pablohirafuji$elm_markdown$Markdown$Entity$replaceDecimal);
var $pablohirafuji$elm_markdown$Markdown$Entity$entitiesRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&([0-9a-zA-Z]+);'));
var $pablohirafuji$elm_markdown$Markdown$Entity$entities = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('quot', 34),
			_Utils_Tuple2('amp', 38),
			_Utils_Tuple2('apos', 39),
			_Utils_Tuple2('lt', 60),
			_Utils_Tuple2('gt', 62),
			_Utils_Tuple2('nbsp', 160),
			_Utils_Tuple2('iexcl', 161),
			_Utils_Tuple2('cent', 162),
			_Utils_Tuple2('pound', 163),
			_Utils_Tuple2('curren', 164),
			_Utils_Tuple2('yen', 165),
			_Utils_Tuple2('brvbar', 166),
			_Utils_Tuple2('sect', 167),
			_Utils_Tuple2('uml', 168),
			_Utils_Tuple2('copy', 169),
			_Utils_Tuple2('ordf', 170),
			_Utils_Tuple2('laquo', 171),
			_Utils_Tuple2('not', 172),
			_Utils_Tuple2('shy', 173),
			_Utils_Tuple2('reg', 174),
			_Utils_Tuple2('macr', 175),
			_Utils_Tuple2('deg', 176),
			_Utils_Tuple2('plusmn', 177),
			_Utils_Tuple2('sup2', 178),
			_Utils_Tuple2('sup3', 179),
			_Utils_Tuple2('acute', 180),
			_Utils_Tuple2('micro', 181),
			_Utils_Tuple2('para', 182),
			_Utils_Tuple2('middot', 183),
			_Utils_Tuple2('cedil', 184),
			_Utils_Tuple2('sup1', 185),
			_Utils_Tuple2('ordm', 186),
			_Utils_Tuple2('raquo', 187),
			_Utils_Tuple2('frac14', 188),
			_Utils_Tuple2('frac12', 189),
			_Utils_Tuple2('frac34', 190),
			_Utils_Tuple2('iquest', 191),
			_Utils_Tuple2('Agrave', 192),
			_Utils_Tuple2('Aacute', 193),
			_Utils_Tuple2('Acirc', 194),
			_Utils_Tuple2('Atilde', 195),
			_Utils_Tuple2('Auml', 196),
			_Utils_Tuple2('Aring', 197),
			_Utils_Tuple2('AElig', 198),
			_Utils_Tuple2('Ccedil', 199),
			_Utils_Tuple2('Egrave', 200),
			_Utils_Tuple2('Eacute', 201),
			_Utils_Tuple2('Ecirc', 202),
			_Utils_Tuple2('Euml', 203),
			_Utils_Tuple2('Igrave', 204),
			_Utils_Tuple2('Iacute', 205),
			_Utils_Tuple2('Icirc', 206),
			_Utils_Tuple2('Iuml', 207),
			_Utils_Tuple2('ETH', 208),
			_Utils_Tuple2('Ntilde', 209),
			_Utils_Tuple2('Ograve', 210),
			_Utils_Tuple2('Oacute', 211),
			_Utils_Tuple2('Ocirc', 212),
			_Utils_Tuple2('Otilde', 213),
			_Utils_Tuple2('Ouml', 214),
			_Utils_Tuple2('times', 215),
			_Utils_Tuple2('Oslash', 216),
			_Utils_Tuple2('Ugrave', 217),
			_Utils_Tuple2('Uacute', 218),
			_Utils_Tuple2('Ucirc', 219),
			_Utils_Tuple2('Uuml', 220),
			_Utils_Tuple2('Yacute', 221),
			_Utils_Tuple2('THORN', 222),
			_Utils_Tuple2('szlig', 223),
			_Utils_Tuple2('agrave', 224),
			_Utils_Tuple2('aacute', 225),
			_Utils_Tuple2('acirc', 226),
			_Utils_Tuple2('atilde', 227),
			_Utils_Tuple2('auml', 228),
			_Utils_Tuple2('aring', 229),
			_Utils_Tuple2('aelig', 230),
			_Utils_Tuple2('ccedil', 231),
			_Utils_Tuple2('egrave', 232),
			_Utils_Tuple2('eacute', 233),
			_Utils_Tuple2('ecirc', 234),
			_Utils_Tuple2('euml', 235),
			_Utils_Tuple2('igrave', 236),
			_Utils_Tuple2('iacute', 237),
			_Utils_Tuple2('icirc', 238),
			_Utils_Tuple2('iuml', 239),
			_Utils_Tuple2('eth', 240),
			_Utils_Tuple2('ntilde', 241),
			_Utils_Tuple2('ograve', 242),
			_Utils_Tuple2('oacute', 243),
			_Utils_Tuple2('ocirc', 244),
			_Utils_Tuple2('otilde', 245),
			_Utils_Tuple2('ouml', 246),
			_Utils_Tuple2('divide', 247),
			_Utils_Tuple2('oslash', 248),
			_Utils_Tuple2('ugrave', 249),
			_Utils_Tuple2('uacute', 250),
			_Utils_Tuple2('ucirc', 251),
			_Utils_Tuple2('uuml', 252),
			_Utils_Tuple2('yacute', 253),
			_Utils_Tuple2('thorn', 254),
			_Utils_Tuple2('yuml', 255),
			_Utils_Tuple2('OElig', 338),
			_Utils_Tuple2('oelig', 339),
			_Utils_Tuple2('Scaron', 352),
			_Utils_Tuple2('scaron', 353),
			_Utils_Tuple2('Yuml', 376),
			_Utils_Tuple2('fnof', 402),
			_Utils_Tuple2('circ', 710),
			_Utils_Tuple2('tilde', 732),
			_Utils_Tuple2('Alpha', 913),
			_Utils_Tuple2('Beta', 914),
			_Utils_Tuple2('Gamma', 915),
			_Utils_Tuple2('Delta', 916),
			_Utils_Tuple2('Epsilon', 917),
			_Utils_Tuple2('Zeta', 918),
			_Utils_Tuple2('Eta', 919),
			_Utils_Tuple2('Theta', 920),
			_Utils_Tuple2('Iota', 921),
			_Utils_Tuple2('Kappa', 922),
			_Utils_Tuple2('Lambda', 923),
			_Utils_Tuple2('Mu', 924),
			_Utils_Tuple2('Nu', 925),
			_Utils_Tuple2('Xi', 926),
			_Utils_Tuple2('Omicron', 927),
			_Utils_Tuple2('Pi', 928),
			_Utils_Tuple2('Rho', 929),
			_Utils_Tuple2('Sigma', 931),
			_Utils_Tuple2('Tau', 932),
			_Utils_Tuple2('Upsilon', 933),
			_Utils_Tuple2('Phi', 934),
			_Utils_Tuple2('Chi', 935),
			_Utils_Tuple2('Psi', 936),
			_Utils_Tuple2('Omega', 937),
			_Utils_Tuple2('alpha', 945),
			_Utils_Tuple2('beta', 946),
			_Utils_Tuple2('gamma', 947),
			_Utils_Tuple2('delta', 948),
			_Utils_Tuple2('epsilon', 949),
			_Utils_Tuple2('zeta', 950),
			_Utils_Tuple2('eta', 951),
			_Utils_Tuple2('theta', 952),
			_Utils_Tuple2('iota', 953),
			_Utils_Tuple2('kappa', 954),
			_Utils_Tuple2('lambda', 955),
			_Utils_Tuple2('mu', 956),
			_Utils_Tuple2('nu', 957),
			_Utils_Tuple2('xi', 958),
			_Utils_Tuple2('omicron', 959),
			_Utils_Tuple2('pi', 960),
			_Utils_Tuple2('rho', 961),
			_Utils_Tuple2('sigmaf', 962),
			_Utils_Tuple2('sigma', 963),
			_Utils_Tuple2('tau', 964),
			_Utils_Tuple2('upsilon', 965),
			_Utils_Tuple2('phi', 966),
			_Utils_Tuple2('chi', 967),
			_Utils_Tuple2('psi', 968),
			_Utils_Tuple2('omega', 969),
			_Utils_Tuple2('thetasym', 977),
			_Utils_Tuple2('upsih', 978),
			_Utils_Tuple2('piv', 982),
			_Utils_Tuple2('ensp', 8194),
			_Utils_Tuple2('emsp', 8195),
			_Utils_Tuple2('thinsp', 8201),
			_Utils_Tuple2('zwnj', 8204),
			_Utils_Tuple2('zwj', 8205),
			_Utils_Tuple2('lrm', 8206),
			_Utils_Tuple2('rlm', 8207),
			_Utils_Tuple2('ndash', 8211),
			_Utils_Tuple2('mdash', 8212),
			_Utils_Tuple2('lsquo', 8216),
			_Utils_Tuple2('rsquo', 8217),
			_Utils_Tuple2('sbquo', 8218),
			_Utils_Tuple2('ldquo', 8220),
			_Utils_Tuple2('rdquo', 8221),
			_Utils_Tuple2('bdquo', 8222),
			_Utils_Tuple2('dagger', 8224),
			_Utils_Tuple2('Dagger', 8225),
			_Utils_Tuple2('bull', 8226),
			_Utils_Tuple2('hellip', 8230),
			_Utils_Tuple2('permil', 8240),
			_Utils_Tuple2('prime', 8242),
			_Utils_Tuple2('Prime', 8243),
			_Utils_Tuple2('lsaquo', 8249),
			_Utils_Tuple2('rsaquo', 8250),
			_Utils_Tuple2('oline', 8254),
			_Utils_Tuple2('frasl', 8260),
			_Utils_Tuple2('euro', 8364),
			_Utils_Tuple2('image', 8465),
			_Utils_Tuple2('weierp', 8472),
			_Utils_Tuple2('real', 8476),
			_Utils_Tuple2('trade', 8482),
			_Utils_Tuple2('alefsym', 8501),
			_Utils_Tuple2('larr', 8592),
			_Utils_Tuple2('uarr', 8593),
			_Utils_Tuple2('rarr', 8594),
			_Utils_Tuple2('darr', 8595),
			_Utils_Tuple2('harr', 8596),
			_Utils_Tuple2('crarr', 8629),
			_Utils_Tuple2('lArr', 8656),
			_Utils_Tuple2('uArr', 8657),
			_Utils_Tuple2('rArr', 8658),
			_Utils_Tuple2('dArr', 8659),
			_Utils_Tuple2('hArr', 8660),
			_Utils_Tuple2('forall', 8704),
			_Utils_Tuple2('part', 8706),
			_Utils_Tuple2('exist', 8707),
			_Utils_Tuple2('empty', 8709),
			_Utils_Tuple2('nabla', 8711),
			_Utils_Tuple2('isin', 8712),
			_Utils_Tuple2('notin', 8713),
			_Utils_Tuple2('ni', 8715),
			_Utils_Tuple2('prod', 8719),
			_Utils_Tuple2('sum', 8721),
			_Utils_Tuple2('minus', 8722),
			_Utils_Tuple2('lowast', 8727),
			_Utils_Tuple2('radic', 8730),
			_Utils_Tuple2('prop', 8733),
			_Utils_Tuple2('infin', 8734),
			_Utils_Tuple2('ang', 8736),
			_Utils_Tuple2('and', 8743),
			_Utils_Tuple2('or', 8744),
			_Utils_Tuple2('cap', 8745),
			_Utils_Tuple2('cup', 8746),
			_Utils_Tuple2('int', 8747),
			_Utils_Tuple2('there4', 8756),
			_Utils_Tuple2('sim', 8764),
			_Utils_Tuple2('cong', 8773),
			_Utils_Tuple2('asymp', 8776),
			_Utils_Tuple2('ne', 8800),
			_Utils_Tuple2('equiv', 8801),
			_Utils_Tuple2('le', 8804),
			_Utils_Tuple2('ge', 8805),
			_Utils_Tuple2('sub', 8834),
			_Utils_Tuple2('sup', 8835),
			_Utils_Tuple2('nsub', 8836),
			_Utils_Tuple2('sube', 8838),
			_Utils_Tuple2('supe', 8839),
			_Utils_Tuple2('oplus', 8853),
			_Utils_Tuple2('otimes', 8855),
			_Utils_Tuple2('perp', 8869),
			_Utils_Tuple2('sdot', 8901),
			_Utils_Tuple2('lceil', 8968),
			_Utils_Tuple2('rceil', 8969),
			_Utils_Tuple2('lfloor', 8970),
			_Utils_Tuple2('rfloor', 8971),
			_Utils_Tuple2('lang', 9001),
			_Utils_Tuple2('rang', 9002),
			_Utils_Tuple2('loz', 9674),
			_Utils_Tuple2('spades', 9824),
			_Utils_Tuple2('clubs', 9827),
			_Utils_Tuple2('hearts', 9829),
			_Utils_Tuple2('diams', 9830)
		]));
var $pablohirafuji$elm_markdown$Markdown$Entity$replaceEntity = function (match) {
	return A2(
		$elm$core$Maybe$withDefault,
		match.lU,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar),
			A2(
				$elm$core$Maybe$andThen,
				function (a) {
					return A2($elm$core$Dict$get, a, $pablohirafuji$elm_markdown$Markdown$Entity$entities);
				},
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					$elm$core$List$head(match.mM)))));
};
var $pablohirafuji$elm_markdown$Markdown$Entity$replaceEntities = A2($elm$regex$Regex$replace, $pablohirafuji$elm_markdown$Markdown$Entity$entitiesRegex, $pablohirafuji$elm_markdown$Markdown$Entity$replaceEntity);
var $pablohirafuji$elm_markdown$Markdown$Helpers$escapableRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\+)([!\"#$%&\\\'()*+,./:;<=>?@[\\\\\\]^_`{|}~-])'));
var $pablohirafuji$elm_markdown$Markdown$Helpers$replaceEscapable = A2(
	$elm$regex$Regex$replace,
	$pablohirafuji$elm_markdown$Markdown$Helpers$escapableRegex,
	function (regexMatch) {
		var _v0 = regexMatch.mM;
		if (((_v0.b && (!_v0.a.$)) && _v0.b.b) && (!_v0.b.a.$)) {
			var backslashes = _v0.a.a;
			var _v1 = _v0.b;
			var escapedStr = _v1.a.a;
			return _Utils_ap(
				A2(
					$elm$core$String$repeat,
					($elm$core$String$length(backslashes) / 2) | 0,
					'\\'),
				escapedStr);
		} else {
			return regexMatch.lU;
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Entity$hexadecimalRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&#[Xx]([0-9a-fA-F]{1,8});'));
var $pablohirafuji$elm_markdown$Markdown$Entity$hexToInt = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$toLower,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$toList,
		A2(
			$elm$core$List$foldl,
			F2(
				function (hexDigit, _int) {
					return ((_int * 16) + A2(
						$elm$core$Basics$modBy,
						39,
						$elm$core$Char$toCode(hexDigit))) - 9;
				}),
			0)));
var $pablohirafuji$elm_markdown$Markdown$Entity$replaceHexadecimal = function (match) {
	return A2(
		$elm$core$Maybe$withDefault,
		match.lU,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $pablohirafuji$elm_markdown$Markdown$Entity$hexToInt, $pablohirafuji$elm_markdown$Markdown$Entity$validUnicode),
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Maybe$Nothing,
				$elm$core$List$head(match.mM))));
};
var $pablohirafuji$elm_markdown$Markdown$Entity$replaceHexadecimals = A2($elm$regex$Regex$replace, $pablohirafuji$elm_markdown$Markdown$Entity$hexadecimalRegex, $pablohirafuji$elm_markdown$Markdown$Entity$replaceHexadecimal);
var $pablohirafuji$elm_markdown$Markdown$Helpers$formatStr = function (str) {
	return $pablohirafuji$elm_markdown$Markdown$Entity$replaceHexadecimals(
		$pablohirafuji$elm_markdown$Markdown$Entity$replaceDecimals(
			$pablohirafuji$elm_markdown$Markdown$Entity$replaceEntities(
				$pablohirafuji$elm_markdown$Markdown$Helpers$replaceEscapable(str))));
};
var $elm$core$String$words = _String_words;
var $pablohirafuji$elm_markdown$Markdown$Block$extractOpenCodeFenceRM = function (match) {
	var _v0 = match.mM;
	if (((_v0.b && _v0.b.b) && (!_v0.b.a.$)) && _v0.b.b.b) {
		var maybeIndent = _v0.a;
		var _v1 = _v0.b;
		var fence = _v1.a.a;
		var _v2 = _v1.b;
		var maybeLanguage = _v2.a;
		return $elm$core$Maybe$Just(
			A2(
				$pablohirafuji$elm_markdown$Markdown$Block$Fenced,
				true,
				{
					gt: A2($elm$core$String$left, 1, fence),
					gu: $elm$core$String$length(fence),
					T: A2(
						$elm$core$Maybe$withDefault,
						0,
						A2($elm$core$Maybe$map, $elm$core$String$length, maybeIndent)),
					gW: A2(
						$elm$core$Maybe$map,
						$pablohirafuji$elm_markdown$Markdown$Helpers$formatStr,
						A2(
							$elm$core$Maybe$andThen,
							function (lang) {
								return (lang === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(lang);
							},
							$elm$core$List$head(
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2($elm$core$Maybe$map, $elm$core$String$words, maybeLanguage)))))
				}));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pablohirafuji$elm_markdown$Markdown$Block$openCodeFenceLineRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^( {0,3})(`{3,}(?!.*`)|~{3,}(?!.*~))(.*)$'));
var $pablohirafuji$elm_markdown$Markdown$Block$checkOpenCodeFenceLine = function (_v0) {
	var rawLine = _v0.a;
	var ast = _v0.b;
	return A2(
		$elm$core$Result$fromMaybe,
		_Utils_Tuple2(rawLine, ast),
		A2(
			$elm$core$Maybe$map,
			function (a) {
				return A2($elm$core$List$cons, a, ast);
			},
			A2(
				$elm$core$Maybe$map,
				function (f) {
					return A2($pablohirafuji$elm_markdown$Markdown$Block$CodeBlock, f, '');
				},
				A2(
					$elm$core$Maybe$andThen,
					$pablohirafuji$elm_markdown$Markdown$Block$extractOpenCodeFenceRM,
					$elm$core$List$head(
						A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$Block$openCodeFenceLineRegex, rawLine))))));
};
var $pablohirafuji$elm_markdown$Markdown$Block$Ordered = function (a) {
	return {$: 1, a: a};
};
var $pablohirafuji$elm_markdown$Markdown$Block$Unordered = {$: 0};
var $pablohirafuji$elm_markdown$Markdown$Block$extractOrderedListRM = function (match) {
	var _v0 = match.mM;
	if (((((((_v0.b && (!_v0.a.$)) && _v0.b.b) && (!_v0.b.a.$)) && _v0.b.b.b) && (!_v0.b.b.a.$)) && _v0.b.b.b.b) && _v0.b.b.b.b.b) {
		var indentString = _v0.a.a;
		var _v1 = _v0.b;
		var start = _v1.a.a;
		var _v2 = _v1.b;
		var delimiter = _v2.a.a;
		var _v3 = _v2.b;
		var maybeIndentSpace = _v3.a;
		var _v4 = _v3.b;
		var maybeRawLine = _v4.a;
		return $elm$core$Maybe$Just(
			_Utils_Tuple3(
				{
					dZ: delimiter,
					T: $elm$core$String$length(indentString) + 1,
					bv: false,
					hT: A2(
						$elm$core$Maybe$withDefault,
						$pablohirafuji$elm_markdown$Markdown$Block$Unordered,
						A2(
							$elm$core$Maybe$map,
							$pablohirafuji$elm_markdown$Markdown$Block$Ordered,
							$elm$core$String$toInt(start)))
				},
				A2($elm$core$Maybe$withDefault, '', maybeIndentSpace),
				A2($elm$core$Maybe$withDefault, '', maybeRawLine)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pablohirafuji$elm_markdown$Markdown$Block$orderedListLineRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^( *(\\d{1,9})([.)])( {0,4}))(?:[ \\t](.*))?$'));
var $pablohirafuji$elm_markdown$Markdown$Block$checkOrderedListLine = function (rawLine) {
	return A2(
		$elm$core$Result$fromMaybe,
		rawLine,
		A2(
			$elm$core$Maybe$andThen,
			$pablohirafuji$elm_markdown$Markdown$Block$extractOrderedListRM,
			$elm$core$List$head(
				A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$Block$orderedListLineRegex, rawLine))));
};
var $pablohirafuji$elm_markdown$Markdown$Block$extractSetextHeadingRM = function (match) {
	var _v0 = match.mM;
	if (_v0.b && (!_v0.a.$)) {
		var delimiter = _v0.a.a;
		return A2($elm$core$String$startsWith, '=', delimiter) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(1, delimiter)) : $elm$core$Maybe$Just(
			_Utils_Tuple2(2, delimiter));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pablohirafuji$elm_markdown$Markdown$Block$parseSetextHeadingLine = F3(
	function (rawLine, ast, _v0) {
		var lvl = _v0.a;
		var delimiter = _v0.b;
		if (ast.b && (ast.a.$ === 4)) {
			var _v2 = ast.a;
			var rawText = _v2.a;
			var astTail = ast.b;
			return $elm$core$Maybe$Just(
				A2(
					$elm$core$List$cons,
					A3($pablohirafuji$elm_markdown$Markdown$Block$Heading, rawText, lvl, _List_Nil),
					astTail));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Block$setextHeadingLineRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^ {0,3}(=+|-+)[ \\t]*$'));
var $pablohirafuji$elm_markdown$Markdown$Block$checkSetextHeadingLine = function (_v0) {
	var rawLine = _v0.a;
	var ast = _v0.b;
	return A2(
		$elm$core$Result$fromMaybe,
		_Utils_Tuple2(rawLine, ast),
		A2(
			$elm$core$Maybe$andThen,
			A2($pablohirafuji$elm_markdown$Markdown$Block$parseSetextHeadingLine, rawLine, ast),
			A2(
				$elm$core$Maybe$andThen,
				$pablohirafuji$elm_markdown$Markdown$Block$extractSetextHeadingRM,
				$elm$core$List$head(
					A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$Block$setextHeadingLineRegex, rawLine)))));
};
var $pablohirafuji$elm_markdown$Markdown$Block$ThematicBreak = {$: 1};
var $pablohirafuji$elm_markdown$Markdown$Block$thematicBreakLineRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^ {0,3}(?:' + ('(?:\\*[ \\t]*){3,}' + ('|(?:_[ \\t]*){3,}' + '|(?:-[ \\t]*){3,})[ \\t]*$'))));
var $pablohirafuji$elm_markdown$Markdown$Block$checkThematicBreakLine = function (_v0) {
	var rawLine = _v0.a;
	var ast = _v0.b;
	return A2(
		$elm$core$Result$fromMaybe,
		_Utils_Tuple2(rawLine, ast),
		A2(
			$elm$core$Maybe$map,
			function (_v1) {
				return A2($elm$core$List$cons, $pablohirafuji$elm_markdown$Markdown$Block$ThematicBreak, ast);
			},
			$elm$core$List$head(
				A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$Block$thematicBreakLineRegex, rawLine))));
};
var $pablohirafuji$elm_markdown$Markdown$Block$extractUnorderedListRM = function (match) {
	var _v0 = match.mM;
	if ((((((_v0.b && (!_v0.a.$)) && _v0.b.b) && (!_v0.b.a.$)) && _v0.b.b.b) && _v0.b.b.b.b) && (!_v0.b.b.b.b.b)) {
		var indentString = _v0.a.a;
		var _v1 = _v0.b;
		var delimiter = _v1.a.a;
		var _v2 = _v1.b;
		var maybeIndentSpace = _v2.a;
		var _v3 = _v2.b;
		var maybeRawLine = _v3.a;
		return $elm$core$Maybe$Just(
			_Utils_Tuple3(
				{
					dZ: delimiter,
					T: $elm$core$String$length(indentString) + 1,
					bv: false,
					hT: $pablohirafuji$elm_markdown$Markdown$Block$Unordered
				},
				A2($elm$core$Maybe$withDefault, '', maybeIndentSpace),
				A2($elm$core$Maybe$withDefault, '', maybeRawLine)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pablohirafuji$elm_markdown$Markdown$Block$unorderedListLineRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^( *([\\*\\-\\+])( {0,4}))(?:[ \\t](.*))?$'));
var $pablohirafuji$elm_markdown$Markdown$Block$checkUnorderedListLine = function (rawLine) {
	return A2(
		$elm$core$Result$fromMaybe,
		rawLine,
		A2(
			$elm$core$Maybe$andThen,
			$pablohirafuji$elm_markdown$Markdown$Block$extractUnorderedListRM,
			$elm$core$List$head(
				A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$Block$unorderedListLineRegex, rawLine))));
};
var $pablohirafuji$elm_markdown$Markdown$Block$closeCodeFenceLineRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^ {0,3}(`{3,}|~{3,})\\s*$'));
var $pablohirafuji$elm_markdown$Markdown$Block$isCloseFenceLineHelp = F2(
	function (fence, match) {
		var _v0 = match.mM;
		if (_v0.b && (!_v0.a.$)) {
			var fenceStr = _v0.a.a;
			return (_Utils_cmp(
				$elm$core$String$length(fenceStr),
				fence.gu) > -1) && _Utils_eq(
				A2($elm$core$String$left, 1, fenceStr),
				fence.gt);
		} else {
			return false;
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Block$isCloseFenceLine = function (fence) {
	return A2(
		$elm$core$Basics$composeR,
		A2($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$Block$closeCodeFenceLineRegex),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map(
					$pablohirafuji$elm_markdown$Markdown$Block$isCloseFenceLineHelp(fence)),
				$elm$core$Maybe$withDefault(false))));
};
var $pablohirafuji$elm_markdown$Markdown$Block$continueOrCloseCodeFence = F3(
	function (fence, previousCode, rawLine) {
		return A2($pablohirafuji$elm_markdown$Markdown$Block$isCloseFenceLine, fence, rawLine) ? A2(
			$pablohirafuji$elm_markdown$Markdown$Block$CodeBlock,
			A2($pablohirafuji$elm_markdown$Markdown$Block$Fenced, false, fence),
			previousCode) : A2(
			$pablohirafuji$elm_markdown$Markdown$Block$CodeBlock,
			A2($pablohirafuji$elm_markdown$Markdown$Block$Fenced, true, fence),
			previousCode + (A2($pablohirafuji$elm_markdown$Markdown$Helpers$indentLine, fence.T, rawLine) + '\n'));
	});
var $pablohirafuji$elm_markdown$Markdown$Helpers$ifError = F2(
	function (_function, result) {
		if (!result.$) {
			return result;
		} else {
			var err = result.a;
			return _function(err);
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Helpers$initSpacesRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^ +'));
var $pablohirafuji$elm_markdown$Markdown$Helpers$indentLength = A2(
	$elm$core$Basics$composeR,
	A2(
		$elm$regex$Regex$replace,
		$pablohirafuji$elm_markdown$Markdown$Helpers$tabRegex,
		function (_v0) {
			return '    ';
		}),
	A2(
		$elm$core$Basics$composeR,
		A2($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$Helpers$initSpacesRegex),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map(
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.lU;
						},
						$elm$core$String$length)),
				$elm$core$Maybe$withDefault(0)))));
var $pablohirafuji$elm_markdown$Markdown$Block$isBlankLineLast = function (items) {
	isBlankLineLast:
	while (true) {
		if (!items.b) {
			return false;
		} else {
			var item = items.a;
			var itemsTail = items.b;
			_v1$3:
			while (true) {
				if (item.b) {
					switch (item.a.$) {
						case 0:
							if (!item.b.b) {
								return false;
							} else {
								return true;
							}
						case 6:
							var _v2 = item.a;
							var items_ = _v2.b;
							var $temp$items = items_;
							items = $temp$items;
							continue isBlankLineLast;
						default:
							break _v1$3;
					}
				} else {
					break _v1$3;
				}
			}
			return false;
		}
	}
};
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Block$parseTextLine = F2(
	function (rawLine, ast) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2(
				$elm$core$List$cons,
				A2(
					$pablohirafuji$elm_markdown$Markdown$Block$Paragraph,
					$pablohirafuji$elm_markdown$Markdown$Block$formatParagraphLine(rawLine),
					_List_Nil),
				ast),
			A2($pablohirafuji$elm_markdown$Markdown$Block$maybeContinueParagraph, rawLine, ast));
	});
var $pablohirafuji$elm_markdown$Markdown$Block$checkBlockQuote = function (_v16) {
	var rawLine = _v16.a;
	var ast = _v16.b;
	return A2(
		$elm$core$Result$fromMaybe,
		_Utils_Tuple2(rawLine, ast),
		A2(
			$elm$core$Maybe$map,
			$pablohirafuji$elm_markdown$Markdown$Block$parseBlockQuoteLine(ast),
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.mM;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$head,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$withDefault($elm$core$Maybe$Nothing),
							$elm$core$Maybe$withDefault('')))),
				$elm$core$List$head(
					A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$Block$blockQuoteLineRegex, rawLine)))));
};
var $pablohirafuji$elm_markdown$Markdown$Block$checkListLine = function (_v15) {
	var rawLine = _v15.a;
	var ast = _v15.b;
	return A2(
		$elm$core$Result$mapError,
		function (e) {
			return _Utils_Tuple2(e, ast);
		},
		A2(
			$elm$core$Result$map,
			A2($pablohirafuji$elm_markdown$Markdown$Block$parseListLine, rawLine, ast),
			A2(
				$elm$core$Result$map,
				$pablohirafuji$elm_markdown$Markdown$Block$calcListIndentLength,
				A2(
					$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
					$pablohirafuji$elm_markdown$Markdown$Block$checkUnorderedListLine,
					$pablohirafuji$elm_markdown$Markdown$Block$checkOrderedListLine(rawLine)))));
};
var $pablohirafuji$elm_markdown$Markdown$Block$incorporateLine = F2(
	function (rawLine, ast) {
		_v11$2:
		while (true) {
			if (ast.b) {
				switch (ast.a.$) {
					case 3:
						if ((ast.a.a.$ === 1) && ast.a.a.a) {
							var _v12 = ast.a;
							var _v13 = _v12.a;
							var fence = _v13.b;
							var code = _v12.b;
							var astTail = ast.b;
							return function (a) {
								return A2($elm$core$List$cons, a, astTail);
							}(
								A3($pablohirafuji$elm_markdown$Markdown$Block$continueOrCloseCodeFence, fence, code, rawLine));
						} else {
							break _v11$2;
						}
					case 6:
						var _v14 = ast.a;
						var model = _v14.a;
						var items = _v14.b;
						var astTail = ast.b;
						return (_Utils_cmp(
							$pablohirafuji$elm_markdown$Markdown$Helpers$indentLength(rawLine),
							model.T) > -1) ? A5($pablohirafuji$elm_markdown$Markdown$Block$parseIndentedListLine, rawLine, model, items, ast, astTail) : A2(
							$elm$core$Result$withDefault,
							A2($pablohirafuji$elm_markdown$Markdown$Block$parseTextLine, rawLine, ast),
							A2(
								$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
								$pablohirafuji$elm_markdown$Markdown$Block$checkBlockQuote,
								A2(
									$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
									$pablohirafuji$elm_markdown$Markdown$Block$checkATXHeadingLine,
									A2(
										$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
										$pablohirafuji$elm_markdown$Markdown$Block$checkSetextHeadingLine,
										A2(
											$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
											$pablohirafuji$elm_markdown$Markdown$Block$checkOpenCodeFenceLine,
											A2(
												$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
												$pablohirafuji$elm_markdown$Markdown$Block$checkIndentedCode,
												A2(
													$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
													$pablohirafuji$elm_markdown$Markdown$Block$checkBlankLine,
													A2(
														$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
														$pablohirafuji$elm_markdown$Markdown$Block$checkListLine,
														$pablohirafuji$elm_markdown$Markdown$Block$checkThematicBreakLine(
															_Utils_Tuple2(rawLine, ast))))))))));
					default:
						break _v11$2;
				}
			} else {
				break _v11$2;
			}
		}
		return A2($pablohirafuji$elm_markdown$Markdown$Block$parseRawLine, rawLine, ast);
	});
var $pablohirafuji$elm_markdown$Markdown$Block$parseBlockQuoteLine = F2(
	function (ast, rawLine) {
		if (ast.b && (ast.a.$ === 5)) {
			var bqAST = ast.a.a;
			var astTail = ast.b;
			return function (a) {
				return A2($elm$core$List$cons, a, astTail);
			}(
				$pablohirafuji$elm_markdown$Markdown$Block$BlockQuote(
					A2($pablohirafuji$elm_markdown$Markdown$Block$incorporateLine, rawLine, bqAST)));
		} else {
			return function (a) {
				return A2($elm$core$List$cons, a, ast);
			}(
				$pablohirafuji$elm_markdown$Markdown$Block$BlockQuote(
					A2($pablohirafuji$elm_markdown$Markdown$Block$incorporateLine, rawLine, _List_Nil)));
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Block$parseIndentedListLine = F5(
	function (rawLine, model, items, ast, astTail) {
		if (!items.b) {
			return function (a) {
				return A2($elm$core$List$cons, a, astTail);
			}(
				A2(
					$pablohirafuji$elm_markdown$Markdown$Block$List,
					model,
					function (a) {
						return A2($elm$core$List$cons, a, _List_Nil);
					}(
						function (a) {
							return A2($pablohirafuji$elm_markdown$Markdown$Block$incorporateLine, a, _List_Nil);
						}(
							A2($pablohirafuji$elm_markdown$Markdown$Helpers$indentLine, model.T, rawLine)))));
		} else {
			var item = items.a;
			var itemsTail = items.b;
			var indentedRawLine = A2($pablohirafuji$elm_markdown$Markdown$Helpers$indentLine, model.T, rawLine);
			var updateList = function (model_) {
				return function (a) {
					return A2($elm$core$List$cons, a, astTail);
				}(
					A2(
						$pablohirafuji$elm_markdown$Markdown$Block$List,
						model_,
						function (a) {
							return A2($elm$core$List$cons, a, itemsTail);
						}(
							A2($pablohirafuji$elm_markdown$Markdown$Block$incorporateLine, indentedRawLine, item))));
			};
			_v7$3:
			while (true) {
				if (item.b) {
					switch (item.a.$) {
						case 0:
							if (!item.b.b) {
								return updateList(model);
							} else {
								var itemTail = item.b;
								return A2(
									$elm$core$List$all,
									function (block) {
										if (!block.$) {
											return true;
										} else {
											return false;
										}
									},
									itemTail) ? A2($pablohirafuji$elm_markdown$Markdown$Block$parseRawLine, rawLine, ast) : updateList(
									_Utils_update(
										model,
										{bv: true}));
							}
						case 6:
							var _v9 = item.a;
							var model_ = _v9.a;
							var items_ = _v9.b;
							var itemTail = item.b;
							return (_Utils_cmp(
								$pablohirafuji$elm_markdown$Markdown$Helpers$indentLength(indentedRawLine),
								model_.T) > -1) ? updateList(model) : ($pablohirafuji$elm_markdown$Markdown$Block$isBlankLineLast(items_) ? updateList(
								_Utils_update(
									model,
									{bv: true})) : updateList(model));
						default:
							break _v7$3;
					}
				} else {
					break _v7$3;
				}
			}
			return updateList(model);
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Block$parseListLine = F3(
	function (rawLine, ast, _v0) {
		var listBlock = _v0.a;
		var listRawLine = _v0.b;
		var parsedRawLine = A2($pablohirafuji$elm_markdown$Markdown$Block$incorporateLine, listRawLine, _List_Nil);
		var newList = A2(
			$elm$core$List$cons,
			A2(
				$pablohirafuji$elm_markdown$Markdown$Block$List,
				listBlock,
				_List_fromArray(
					[parsedRawLine])),
			ast);
		_v1$2:
		while (true) {
			if (ast.b) {
				switch (ast.a.$) {
					case 6:
						var _v2 = ast.a;
						var model = _v2.a;
						var items = _v2.b;
						var astTail = ast.b;
						return _Utils_eq(listBlock.dZ, model.dZ) ? function (a) {
							return A2($elm$core$List$cons, a, astTail);
						}(
							A2(
								$pablohirafuji$elm_markdown$Markdown$Block$List,
								_Utils_update(
									model,
									{
										T: listBlock.T,
										bv: model.bv || $pablohirafuji$elm_markdown$Markdown$Block$isBlankLineLast(items)
									}),
								A2($elm$core$List$cons, parsedRawLine, items))) : newList;
					case 4:
						var _v3 = ast.a;
						var rawText = _v3.a;
						var inlines = _v3.b;
						var astTail = ast.b;
						if ((parsedRawLine.b && (!parsedRawLine.a.$)) && (!parsedRawLine.b.b)) {
							return A2(
								$elm$core$List$cons,
								A2($pablohirafuji$elm_markdown$Markdown$Block$addToParagraph, rawText, rawLine),
								astTail);
						} else {
							var _v5 = listBlock.hT;
							if (_v5.$ === 1) {
								if (_v5.a === 1) {
									return newList;
								} else {
									var _int = _v5.a;
									return A2(
										$elm$core$List$cons,
										A2($pablohirafuji$elm_markdown$Markdown$Block$addToParagraph, rawText, rawLine),
										astTail);
								}
							} else {
								return newList;
							}
						}
					default:
						break _v1$2;
				}
			} else {
				break _v1$2;
			}
		}
		return newList;
	});
var $pablohirafuji$elm_markdown$Markdown$Block$parseRawLine = F2(
	function (rawLine, ast) {
		return A2(
			$elm$core$Result$withDefault,
			A2($pablohirafuji$elm_markdown$Markdown$Block$parseTextLine, rawLine, ast),
			A2(
				$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
				$pablohirafuji$elm_markdown$Markdown$Block$checkListLine,
				A2(
					$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
					$pablohirafuji$elm_markdown$Markdown$Block$checkThematicBreakLine,
					A2(
						$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
						$pablohirafuji$elm_markdown$Markdown$Block$checkBlockQuote,
						A2(
							$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
							$pablohirafuji$elm_markdown$Markdown$Block$checkATXHeadingLine,
							A2(
								$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
								$pablohirafuji$elm_markdown$Markdown$Block$checkSetextHeadingLine,
								A2(
									$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
									$pablohirafuji$elm_markdown$Markdown$Block$checkOpenCodeFenceLine,
									A2(
										$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
										$pablohirafuji$elm_markdown$Markdown$Block$checkIndentedCode,
										$pablohirafuji$elm_markdown$Markdown$Block$checkBlankLine(
											_Utils_Tuple2(rawLine, ast))))))))));
	});
var $pablohirafuji$elm_markdown$Markdown$Block$incorporateLines = F2(
	function (rawLines, ast) {
		if (!rawLines.b) {
			return ast;
		} else {
			var rawLine = rawLines.a;
			var rawLinesTail = rawLines.b;
			return A2(
				$pablohirafuji$elm_markdown$Markdown$Block$incorporateLines,
				rawLinesTail,
				A2($pablohirafuji$elm_markdown$Markdown$Block$incorporateLine, rawLine, ast));
		}
	});
var $elm$core$String$lines = _String_lines;
var $pablohirafuji$elm_markdown$Markdown$Block$Custom = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $pablohirafuji$elm_markdown$Markdown$Block$PlainInlines = function (a) {
	return {$: 7, a: a};
};
var $pablohirafuji$elm_markdown$Markdown$Config$Sanitize = function (a) {
	return {$: 1, a: a};
};
var $pablohirafuji$elm_markdown$Markdown$Config$defaultAllowedHtmlAttributes = _List_fromArray(
	['name', 'class']);
var $pablohirafuji$elm_markdown$Markdown$Config$defaultAllowedHtmlElements = _List_fromArray(
	['address', 'article', 'aside', 'b', 'blockquote', 'br', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'dd', 'details', 'div', 'dl', 'dt', 'figcaption', 'figure', 'footer', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr', 'i', 'legend', 'li', 'menu', 'menuitem', 'nav', 'ol', 'optgroup', 'option', 'p', 'pre', 'section', 'strike', 'summary', 'small', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr', 'ul']);
var $pablohirafuji$elm_markdown$Markdown$Config$defaultSanitizeOptions = {ib: $pablohirafuji$elm_markdown$Markdown$Config$defaultAllowedHtmlAttributes, ic: $pablohirafuji$elm_markdown$Markdown$Config$defaultAllowedHtmlElements};
var $pablohirafuji$elm_markdown$Markdown$Config$defaultOptions = {
	jB: $pablohirafuji$elm_markdown$Markdown$Config$Sanitize($pablohirafuji$elm_markdown$Markdown$Config$defaultSanitizeOptions),
	jU: false
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$initParser = F3(
	function (options, refs, rawText) {
		return {e: _List_Nil, jm: options, Z: rawText, hA: refs, p: _List_Nil};
	});
var $pablohirafuji$elm_markdown$Markdown$Inline$CodeInline = function (a) {
	return {$: 2, a: a};
};
var $pablohirafuji$elm_markdown$Markdown$Inline$Emphasis = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $pablohirafuji$elm_markdown$Markdown$Inline$HardLineBreak = {$: 1};
var $pablohirafuji$elm_markdown$Markdown$Inline$HtmlInline = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $pablohirafuji$elm_markdown$Markdown$Inline$Image = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $pablohirafuji$elm_markdown$Markdown$Inline$Link = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $pablohirafuji$elm_markdown$Markdown$Inline$Text = function (a) {
	return {$: 0, a: a};
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$matchToInline = function (_v0) {
	var match = _v0;
	var _v1 = match.hT;
	switch (_v1.$) {
		case 0:
			return $pablohirafuji$elm_markdown$Markdown$Inline$Text(match.hO);
		case 1:
			return $pablohirafuji$elm_markdown$Markdown$Inline$HardLineBreak;
		case 2:
			return $pablohirafuji$elm_markdown$Markdown$Inline$CodeInline(match.hO);
		case 3:
			var _v2 = _v1.a;
			var text = _v2.a;
			var url = _v2.b;
			return A3(
				$pablohirafuji$elm_markdown$Markdown$Inline$Link,
				url,
				$elm$core$Maybe$Nothing,
				_List_fromArray(
					[
						$pablohirafuji$elm_markdown$Markdown$Inline$Text(text)
					]));
		case 4:
			var _v3 = _v1.a;
			var url = _v3.a;
			var maybeTitle = _v3.b;
			return A3(
				$pablohirafuji$elm_markdown$Markdown$Inline$Link,
				url,
				maybeTitle,
				$pablohirafuji$elm_markdown$Markdown$InlineParser$matchesToInlines(match.e));
		case 5:
			var _v4 = _v1.a;
			var url = _v4.a;
			var maybeTitle = _v4.b;
			return A3(
				$pablohirafuji$elm_markdown$Markdown$Inline$Image,
				url,
				maybeTitle,
				$pablohirafuji$elm_markdown$Markdown$InlineParser$matchesToInlines(match.e));
		case 6:
			var model = _v1.a;
			return A3(
				$pablohirafuji$elm_markdown$Markdown$Inline$HtmlInline,
				model.ez,
				model.eP,
				$pablohirafuji$elm_markdown$Markdown$InlineParser$matchesToInlines(match.e));
		default:
			var length = _v1.a;
			return A2(
				$pablohirafuji$elm_markdown$Markdown$Inline$Emphasis,
				length,
				$pablohirafuji$elm_markdown$Markdown$InlineParser$matchesToInlines(match.e));
	}
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$matchesToInlines = function (matches) {
	return A2($elm$core$List$map, $pablohirafuji$elm_markdown$Markdown$InlineParser$matchToInline, matches);
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$Match = $elm$core$Basics$identity;
var $pablohirafuji$elm_markdown$Markdown$InlineParser$prepareChildMatch = F2(
	function (parentMatch, childMatch) {
		return _Utils_update(
			childMatch,
			{iE: childMatch.iE - parentMatch.aY, hJ: childMatch.hJ - parentMatch.aY, dG: childMatch.dG - parentMatch.aY, aY: childMatch.aY - parentMatch.aY});
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$addChild = F2(
	function (parentMatch, childMatch) {
		return _Utils_update(
			parentMatch,
			{
				e: A2(
					$elm$core$List$cons,
					A2($pablohirafuji$elm_markdown$Markdown$InlineParser$prepareChildMatch, parentMatch, childMatch),
					parentMatch.e)
			});
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$organizeMatch = F2(
	function (_v0, matches) {
		var match = _v0;
		if (!matches.b) {
			return _List_fromArray(
				[match]);
		} else {
			var prevMatch = matches.a;
			var matchesTail = matches.b;
			return (_Utils_cmp(prevMatch.iE, match.hJ) < 1) ? A2($elm$core$List$cons, match, matches) : (((_Utils_cmp(prevMatch.hJ, match.hJ) < 0) && (_Utils_cmp(prevMatch.iE, match.iE) > 0)) ? A2(
				$elm$core$List$cons,
				A2($pablohirafuji$elm_markdown$Markdown$InlineParser$addChild, prevMatch, match),
				matchesTail) : matches);
		}
	});
function $pablohirafuji$elm_markdown$Markdown$InlineParser$cyclic$organizeMatches() {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$sortBy(
			function (_v0) {
				var match = _v0;
				return match.hJ;
			}),
		A2(
			$elm$core$Basics$composeR,
			A2($elm$core$List$foldl, $pablohirafuji$elm_markdown$Markdown$InlineParser$organizeMatch, _List_Nil),
			$elm$core$List$map(
				function (_v1) {
					var match = _v1;
					return _Utils_update(
						match,
						{
							e: $pablohirafuji$elm_markdown$Markdown$InlineParser$cyclic$organizeMatches()(match.e)
						});
				})));
}
var $pablohirafuji$elm_markdown$Markdown$InlineParser$organizeMatches = $pablohirafuji$elm_markdown$Markdown$InlineParser$cyclic$organizeMatches();
$pablohirafuji$elm_markdown$Markdown$InlineParser$cyclic$organizeMatches = function () {
	return $pablohirafuji$elm_markdown$Markdown$InlineParser$organizeMatches;
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$organizeParserMatches = function (model) {
	return _Utils_update(
		model,
		{
			e: $pablohirafuji$elm_markdown$Markdown$InlineParser$organizeMatches(model.e)
		});
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$NormalType = {$: 0};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$normalMatch = function (text) {
	return {
		iE: 0,
		e: _List_Nil,
		hJ: 0,
		hO: $pablohirafuji$elm_markdown$Markdown$Helpers$formatStr(text),
		dG: 0,
		aY: 0,
		hT: $pablohirafuji$elm_markdown$Markdown$InlineParser$NormalType
	};
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$parseTextMatch = F3(
	function (rawText, _v2, parsedMatches) {
		var matchModel = _v2;
		var updtMatch = _Utils_update(
			matchModel,
			{
				e: A3($pablohirafuji$elm_markdown$Markdown$InlineParser$parseTextMatches, matchModel.hO, _List_Nil, matchModel.e)
			});
		if (!parsedMatches.b) {
			var finalStr = A2($elm$core$String$dropLeft, matchModel.iE, rawText);
			return $elm$core$String$isEmpty(finalStr) ? _List_fromArray(
				[updtMatch]) : _List_fromArray(
				[
					updtMatch,
					$pablohirafuji$elm_markdown$Markdown$InlineParser$normalMatch(finalStr)
				]);
		} else {
			var matchHead = parsedMatches.a;
			var matchesTail = parsedMatches.b;
			return _Utils_eq(matchHead.hT, $pablohirafuji$elm_markdown$Markdown$InlineParser$NormalType) ? A2($elm$core$List$cons, updtMatch, parsedMatches) : (_Utils_eq(matchModel.iE, matchHead.hJ) ? A2($elm$core$List$cons, updtMatch, parsedMatches) : ((_Utils_cmp(matchModel.iE, matchHead.hJ) < 0) ? A2(
				$elm$core$List$cons,
				updtMatch,
				A2(
					$elm$core$List$cons,
					$pablohirafuji$elm_markdown$Markdown$InlineParser$normalMatch(
						A3($elm$core$String$slice, matchModel.iE, matchHead.hJ, rawText)),
					parsedMatches)) : parsedMatches));
		}
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$parseTextMatches = F3(
	function (rawText, parsedMatches, matches) {
		parseTextMatches:
		while (true) {
			if (!matches.b) {
				if (!parsedMatches.b) {
					return $elm$core$String$isEmpty(rawText) ? _List_Nil : _List_fromArray(
						[
							$pablohirafuji$elm_markdown$Markdown$InlineParser$normalMatch(rawText)
						]);
				} else {
					var matchModel = parsedMatches.a;
					return (matchModel.hJ > 0) ? A2(
						$elm$core$List$cons,
						$pablohirafuji$elm_markdown$Markdown$InlineParser$normalMatch(
							A2($elm$core$String$left, matchModel.hJ, rawText)),
						parsedMatches) : parsedMatches;
				}
			} else {
				var match = matches.a;
				var matchesTail = matches.b;
				var $temp$rawText = rawText,
					$temp$parsedMatches = A3($pablohirafuji$elm_markdown$Markdown$InlineParser$parseTextMatch, rawText, match, parsedMatches),
					$temp$matches = matchesTail;
				rawText = $temp$rawText;
				parsedMatches = $temp$parsedMatches;
				matches = $temp$matches;
				continue parseTextMatches;
			}
		}
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$parseText = function (model) {
	return _Utils_update(
		model,
		{
			e: A3($pablohirafuji$elm_markdown$Markdown$InlineParser$parseTextMatches, model.Z, _List_Nil, model.e)
		});
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$angleBracketLTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\<)'));
var $elm$regex$Regex$find = _Regex_findAtMost(_Regex_infinity);
var $pablohirafuji$elm_markdown$Markdown$InlineParser$CharToken = function (a) {
	return {$: 3, a: a};
};
var $pablohirafuji$elm_markdown$Markdown$Helpers$isEven = function (_int) {
	return !A2($elm$core$Basics$modBy, 2, _int);
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketLToken = function (regMatch) {
	var _v0 = regMatch.mM;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var delimiter = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $pablohirafuji$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
			{
				iX: regMatch.iX + backslashesLength,
				g: 1,
				m: $pablohirafuji$elm_markdown$Markdown$InlineParser$CharToken('<')
			}) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$findAngleBracketLTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketLToken,
		A2($elm$regex$Regex$find, $pablohirafuji$elm_markdown$Markdown$InlineParser$angleBracketLTokenRegex, str));
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$angleBracketRTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\>)'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$RightAngleBracket = function (a) {
	return {$: 4, a: a};
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketRToken = function (regMatch) {
	var _v0 = regMatch.mM;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $elm$core$Maybe$Just(
			{
				iX: regMatch.iX + backslashesLength,
				g: 1,
				m: $pablohirafuji$elm_markdown$Markdown$InlineParser$RightAngleBracket(
					!$pablohirafuji$elm_markdown$Markdown$Helpers$isEven(backslashesLength))
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$findAngleBracketRTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketRToken,
		A2($elm$regex$Regex$find, $pablohirafuji$elm_markdown$Markdown$InlineParser$angleBracketRTokenRegex, str));
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$asteriskEmphasisTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)([^*])?(\\*+)([^*])?'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$EmphasisToken = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$punctuationRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('[!-#%-\\*,-/:;\\?@\\[-\\]_\\{\\}]'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$containPunctuation = $elm$regex$Regex$contains($pablohirafuji$elm_markdown$Markdown$InlineParser$punctuationRegex);
var $pablohirafuji$elm_markdown$Markdown$InlineParser$spaceRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('\\s'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$containSpace = $elm$regex$Regex$contains($pablohirafuji$elm_markdown$Markdown$InlineParser$spaceRegex);
var $pablohirafuji$elm_markdown$Markdown$InlineParser$charFringeRank = function (_char) {
	var string = $elm$core$String$fromChar(_char);
	return $pablohirafuji$elm_markdown$Markdown$InlineParser$containSpace(string) ? 0 : ($pablohirafuji$elm_markdown$Markdown$InlineParser$containPunctuation(string) ? 1 : 2);
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$maybeCharFringeRank = function (maybeChar) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2($elm$core$Maybe$map, $pablohirafuji$elm_markdown$Markdown$InlineParser$charFringeRank, maybeChar));
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$getFringeRank = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$uncons,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($elm$core$Tuple$first),
				$pablohirafuji$elm_markdown$Markdown$InlineParser$maybeCharFringeRank))),
	$elm$core$Maybe$withDefault(0));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken = F3(
	function (_char, rawText, regMatch) {
		var _v0 = regMatch.mM;
		if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.a.$)) && _v0.b.b.b.b) {
			var maybeBackslashes = _v0.a;
			var _v1 = _v0.b;
			var maybeLeftFringe = _v1.a;
			var _v2 = _v1.b;
			var delimiter = _v2.a.a;
			var _v3 = _v2.b;
			var maybeRightFringe = _v3.a;
			var leftFringeLength = A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($elm$core$Maybe$map, $elm$core$String$length, maybeLeftFringe));
			var mLeftFringe = ((!(!regMatch.iX)) && (!leftFringeLength)) ? $elm$core$Maybe$Just(
				A3($elm$core$String$slice, regMatch.iX - 1, regMatch.iX, rawText)) : maybeLeftFringe;
			var backslashesLength = A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
			var isEscaped = ((!$pablohirafuji$elm_markdown$Markdown$Helpers$isEven(backslashesLength)) && (!leftFringeLength)) || _Utils_eq(
				mLeftFringe,
				$elm$core$Maybe$Just('\\'));
			var delimiterLength = isEscaped ? ($elm$core$String$length(delimiter) - 1) : $elm$core$String$length(delimiter);
			var fringeRank = _Utils_Tuple2(
				isEscaped ? 1 : $pablohirafuji$elm_markdown$Markdown$InlineParser$getFringeRank(mLeftFringe),
				$pablohirafuji$elm_markdown$Markdown$InlineParser$getFringeRank(maybeRightFringe));
			var index = ((regMatch.iX + backslashesLength) + leftFringeLength) + (isEscaped ? 1 : 0);
			return ((delimiterLength <= 0) || ((_char === '_') && _Utils_eq(
				fringeRank,
				_Utils_Tuple2(2, 2)))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				{
					iX: index,
					g: delimiterLength,
					m: A2($pablohirafuji$elm_markdown$Markdown$InlineParser$EmphasisToken, _char, fringeRank)
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$findAsteriskEmphasisTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		A2($pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken, '*', str),
		A2($elm$regex$Regex$find, $pablohirafuji$elm_markdown$Markdown$InlineParser$asteriskEmphasisTokenRegex, str));
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$codeTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\`+)'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$CodeToken = function (a) {
	return {$: 0, a: a};
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToCodeToken = function (regMatch) {
	var _v0 = regMatch.mM;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backtick = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $elm$core$Maybe$Just(
			{
				iX: regMatch.iX + backslashesLength,
				g: $elm$core$String$length(backtick),
				m: $pablohirafuji$elm_markdown$Markdown$InlineParser$CodeToken(
					!$pablohirafuji$elm_markdown$Markdown$Helpers$isEven(backslashesLength))
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$findCodeTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToCodeToken,
		A2($elm$regex$Regex$find, $pablohirafuji$elm_markdown$Markdown$InlineParser$codeTokenRegex, str));
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$hardBreakTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(?:(\\\\+)|( {2,}))\\n'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$HardLineBreakToken = {$: 8};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToHardBreakToken = function (regMatch) {
	var _v0 = regMatch.mM;
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (!_v0.a.$) {
				var backslashes = _v0.a.a;
				var backslashesLength = $elm$core$String$length(backslashes);
				return (!$pablohirafuji$elm_markdown$Markdown$Helpers$isEven(backslashesLength)) ? $elm$core$Maybe$Just(
					{iX: (regMatch.iX + backslashesLength) - 1, g: 2, m: $pablohirafuji$elm_markdown$Markdown$InlineParser$HardLineBreakToken}) : $elm$core$Maybe$Nothing;
			} else {
				if (_v0.b.b && (!_v0.b.a.$)) {
					var _v1 = _v0.b;
					return $elm$core$Maybe$Just(
						{
							iX: regMatch.iX,
							g: $elm$core$String$length(regMatch.lU),
							m: $pablohirafuji$elm_markdown$Markdown$InlineParser$HardLineBreakToken
						});
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToSoftHardBreakToken = function (regMatch) {
	var _v0 = regMatch.mM;
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (!_v0.a.$) {
				var backslashes = _v0.a.a;
				var backslashesLength = $elm$core$String$length(backslashes);
				return $pablohirafuji$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
					{iX: regMatch.iX + backslashesLength, g: 1, m: $pablohirafuji$elm_markdown$Markdown$InlineParser$HardLineBreakToken}) : $elm$core$Maybe$Just(
					{iX: (regMatch.iX + backslashesLength) - 1, g: 2, m: $pablohirafuji$elm_markdown$Markdown$InlineParser$HardLineBreakToken});
			} else {
				if (_v0.b.b) {
					var _v1 = _v0.b;
					var maybeSpaces = _v1.a;
					return $elm$core$Maybe$Just(
						{
							iX: regMatch.iX,
							g: $elm$core$String$length(regMatch.lU),
							m: $pablohirafuji$elm_markdown$Markdown$InlineParser$HardLineBreakToken
						});
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$softAsHardLineBreakTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(?:(\\\\+)|( *))\\n'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$findHardBreakTokens = F2(
	function (softAsHardLineBreak, str) {
		return softAsHardLineBreak ? A2(
			$elm$core$List$filterMap,
			$pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToSoftHardBreakToken,
			A2($elm$regex$Regex$find, $pablohirafuji$elm_markdown$Markdown$InlineParser$softAsHardLineBreakTokenRegex, str)) : A2(
			$elm$core$List$filterMap,
			$pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToHardBreakToken,
			A2($elm$regex$Regex$find, $pablohirafuji$elm_markdown$Markdown$InlineParser$hardBreakTokenRegex, str));
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$linkImageCloseTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\])'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToLinkImageCloseToken = function (regMatch) {
	var _v0 = regMatch.mM;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var delimiter = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $pablohirafuji$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
			{
				iX: regMatch.iX + backslashesLength,
				g: 1,
				m: $pablohirafuji$elm_markdown$Markdown$InlineParser$CharToken(']')
			}) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$findLinkImageCloseTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToLinkImageCloseToken,
		A2($elm$regex$Regex$find, $pablohirafuji$elm_markdown$Markdown$InlineParser$linkImageCloseTokenRegex, str));
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$linkImageOpenTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\!)?(\\[)'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$ImageOpenToken = {$: 2};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$LinkOpenToken = function (a) {
	return {$: 1, a: a};
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToLinkImageOpenToken = function (regMatch) {
	var _v0 = regMatch.mM;
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var maybeImageOpen = _v1.a;
		var _v2 = _v1.b;
		var delimiter = _v2.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		var isEscaped = !$pablohirafuji$elm_markdown$Markdown$Helpers$isEven(backslashesLength);
		var index = (regMatch.iX + backslashesLength) + ((isEscaped && _Utils_eq(
			maybeImageOpen,
			$elm$core$Maybe$Just('!'))) ? 1 : 0);
		var meaning = isEscaped ? A2(
			$elm$core$Maybe$map,
			function (_v3) {
				return $pablohirafuji$elm_markdown$Markdown$InlineParser$LinkOpenToken(true);
			},
			maybeImageOpen) : $elm$core$Maybe$Just(
			A2(
				$elm$core$Maybe$withDefault,
				$pablohirafuji$elm_markdown$Markdown$InlineParser$LinkOpenToken(true),
				A2(
					$elm$core$Maybe$map,
					function (_v4) {
						return $pablohirafuji$elm_markdown$Markdown$InlineParser$ImageOpenToken;
					},
					maybeImageOpen)));
		var length = _Utils_eq(
			meaning,
			$elm$core$Maybe$Just($pablohirafuji$elm_markdown$Markdown$InlineParser$ImageOpenToken)) ? 2 : 1;
		var toModel = function (m) {
			return {iX: index, g: length, m: m};
		};
		return A2($elm$core$Maybe$map, toModel, meaning);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$findLinkImageOpenTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToLinkImageOpenToken,
		A2($elm$regex$Regex$find, $pablohirafuji$elm_markdown$Markdown$InlineParser$linkImageOpenTokenRegex, str));
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$underlineEmphasisTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)([^_])?(\\_+)([^_])?'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$findUnderlineEmphasisTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		A2($pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken, '_', str),
		A2($elm$regex$Regex$find, $pablohirafuji$elm_markdown$Markdown$InlineParser$underlineEmphasisTokenRegex, str));
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$tokenize = function (model) {
	return _Utils_update(
		model,
		{
			p: A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.iX;
				},
				_Utils_ap(
					$pablohirafuji$elm_markdown$Markdown$InlineParser$findAngleBracketRTokens(model.Z),
					_Utils_ap(
						$pablohirafuji$elm_markdown$Markdown$InlineParser$findAngleBracketLTokens(model.Z),
						_Utils_ap(
							A2($pablohirafuji$elm_markdown$Markdown$InlineParser$findHardBreakTokens, model.jm.jU, model.Z),
							_Utils_ap(
								$pablohirafuji$elm_markdown$Markdown$InlineParser$findLinkImageCloseTokens(model.Z),
								_Utils_ap(
									$pablohirafuji$elm_markdown$Markdown$InlineParser$findLinkImageOpenTokens(model.Z),
									_Utils_ap(
										$pablohirafuji$elm_markdown$Markdown$InlineParser$findUnderlineEmphasisTokens(model.Z),
										_Utils_ap(
											$pablohirafuji$elm_markdown$Markdown$InlineParser$findAsteriskEmphasisTokens(model.Z),
											$pablohirafuji$elm_markdown$Markdown$InlineParser$findCodeTokens(model.Z)))))))))
		});
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$CodeType = {$: 2};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$EmphasisType = function (a) {
	return {$: 7, a: a};
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$HtmlType = function (a) {
	return {$: 6, a: a};
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$ImageType = function (a) {
	return {$: 5, a: a};
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$LinkType = function (a) {
	return {$: 4, a: a};
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$addMatch = F2(
	function (model, match) {
		return _Utils_update(
			model,
			{
				e: A2($elm$core$List$cons, match, model.e)
			});
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$addToken = F2(
	function (model, token) {
		return _Utils_update(
			model,
			{
				p: A2($elm$core$List$cons, token, model.p)
			});
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$applyTTM = F2(
	function (finderFunction, model) {
		return finderFunction(
			_Utils_Tuple2(
				model.p,
				_Utils_update(
					model,
					{p: _List_Nil})));
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$AutolinkType = function (a) {
	return {$: 3, a: a};
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$decodeUrlRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('%(?:3B|2C|2F|3F|3A|40|26|3D|2B|24|23|25)'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$encodeUrl = A2(
	$elm$core$Basics$composeR,
	$elm$url$Url$percentEncode,
	A2(
		$elm$regex$Regex$replace,
		$pablohirafuji$elm_markdown$Markdown$InlineParser$decodeUrlRegex,
		function (match) {
			return A2(
				$elm$core$Maybe$withDefault,
				match.lU,
				$elm$url$Url$percentDecode(match.lU));
		}));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$urlRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^([A-Za-z][A-Za-z0-9.+\\-]{1,31}:[^<>\\x00-\\x20]*)$'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$autolinkToMatch = function (_v0) {
	var match = _v0;
	return A2($elm$regex$Regex$contains, $pablohirafuji$elm_markdown$Markdown$InlineParser$urlRegex, match.hO) ? $elm$core$Result$Ok(
		_Utils_update(
			match,
			{
				hT: $pablohirafuji$elm_markdown$Markdown$InlineParser$AutolinkType(
					_Utils_Tuple2(
						match.hO,
						$pablohirafuji$elm_markdown$Markdown$InlineParser$encodeUrl(match.hO)))
			})) : $elm$core$Result$Err(match);
};
var $pablohirafuji$elm_markdown$Markdown$Helpers$whiteSpaceChars = ' \\t\\f\\v\\r\\n';
var $pablohirafuji$elm_markdown$Markdown$InlineParser$hrefRegex = '(?:<([^<>' + ($pablohirafuji$elm_markdown$Markdown$Helpers$whiteSpaceChars + (']*)>|([^' + ($pablohirafuji$elm_markdown$Markdown$Helpers$whiteSpaceChars + ('\\(\\)\\\\]*(?:\\\\.[^' + ($pablohirafuji$elm_markdown$Markdown$Helpers$whiteSpaceChars + '\\(\\)\\\\]*)*))')))));
var $pablohirafuji$elm_markdown$Markdown$Helpers$titleRegex = '(?:[' + ($pablohirafuji$elm_markdown$Markdown$Helpers$whiteSpaceChars + (']+' + ('(?:\'([^\'\\\\]*(?:\\\\.[^\'\\\\]*)*)\'|' + ('\"([^\"\\\\]*(?:\\\\.[^\"\\\\]*)*)\"|' + '\\(([^\\)\\\\]*(?:\\\\.[^\\)\\\\]*)*)\\)))?'))));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\\(\\s*' + ($pablohirafuji$elm_markdown$Markdown$InlineParser$hrefRegex + ($pablohirafuji$elm_markdown$Markdown$Helpers$titleRegex + '\\s*\\)'))));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle = function (_v0) {
	var rawUrl = _v0.a;
	var maybeTitle = _v0.b;
	return _Utils_Tuple2(
		$pablohirafuji$elm_markdown$Markdown$InlineParser$encodeUrl(
			$pablohirafuji$elm_markdown$Markdown$Helpers$formatStr(rawUrl)),
		A2($elm$core$Maybe$map, $pablohirafuji$elm_markdown$Markdown$Helpers$formatStr, maybeTitle));
};
var $pablohirafuji$elm_markdown$Markdown$Helpers$returnFirstJust = function (maybes) {
	var process = F2(
		function (a, maybeFound) {
			if (!maybeFound.$) {
				var found = maybeFound.a;
				return $elm$core$Maybe$Just(found);
			} else {
				return a;
			}
		});
	return A3($elm$core$List$foldl, process, $elm$core$Maybe$Nothing, maybes);
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch = F3(
	function (matchModel, model, regexMatch) {
		var _v0 = regexMatch.mM;
		if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && _v0.b.b.b.b) && _v0.b.b.b.b.b) {
			var maybeRawUrlAngleBrackets = _v0.a;
			var _v1 = _v0.b;
			var maybeRawUrlWithoutBrackets = _v1.a;
			var _v2 = _v1.b;
			var maybeTitleSingleQuotes = _v2.a;
			var _v3 = _v2.b;
			var maybeTitleDoubleQuotes = _v3.a;
			var _v4 = _v3.b;
			var maybeTitleParenthesis = _v4.a;
			var maybeTitle = $pablohirafuji$elm_markdown$Markdown$Helpers$returnFirstJust(
				_List_fromArray(
					[maybeTitleSingleQuotes, maybeTitleDoubleQuotes, maybeTitleParenthesis]));
			var toMatch = function (rawUrl) {
				return _Utils_update(
					matchModel,
					{
						iE: matchModel.iE + $elm$core$String$length(regexMatch.lU),
						hT: function () {
							var _v5 = matchModel.hT;
							if (_v5.$ === 5) {
								return $pablohirafuji$elm_markdown$Markdown$InlineParser$ImageType;
							} else {
								return $pablohirafuji$elm_markdown$Markdown$InlineParser$LinkType;
							}
						}()(
							$pablohirafuji$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle(
								_Utils_Tuple2(rawUrl, maybeTitle)))
					});
			};
			var maybeRawUrl = $pablohirafuji$elm_markdown$Markdown$Helpers$returnFirstJust(
				_List_fromArray(
					[maybeRawUrlAngleBrackets, maybeRawUrlWithoutBrackets]));
			return $elm$core$Maybe$Just(
				toMatch(
					A2($elm$core$Maybe$withDefault, '', maybeRawUrl)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType = function (_v0) {
	var remainText = _v0.a;
	var tempMatch = _v0.b;
	var model = _v0.c;
	return A2(
		$elm$core$Result$fromMaybe,
		_Utils_Tuple3(remainText, tempMatch, model),
		A2(
			$elm$core$Maybe$map,
			$pablohirafuji$elm_markdown$Markdown$InlineParser$addMatch(model),
			A2(
				$elm$core$Maybe$andThen,
				A2($pablohirafuji$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch, tempMatch, model),
				$elm$core$List$head(
					A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegex, remainText)))));
};
var $pablohirafuji$elm_markdown$Markdown$Helpers$insideSquareBracketRegex = '[^\\[\\]\\\\]*(?:\\\\.[^\\[\\]\\\\]*)*';
var $pablohirafuji$elm_markdown$Markdown$InlineParser$refLabelRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\\[\\s*(' + ($pablohirafuji$elm_markdown$Markdown$Helpers$insideSquareBracketRegex + ')\\s*\\]')));
var $pablohirafuji$elm_markdown$Markdown$Helpers$whitespacesRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('[' + ($pablohirafuji$elm_markdown$Markdown$Helpers$whiteSpaceChars + ']+')));
var $pablohirafuji$elm_markdown$Markdown$Helpers$cleanWhitespaces = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$trim,
	A2(
		$elm$regex$Regex$replace,
		$pablohirafuji$elm_markdown$Markdown$Helpers$whitespacesRegex,
		function (_v0) {
			return ' ';
		}));
var $pablohirafuji$elm_markdown$Markdown$Helpers$prepareRefLabel = A2($elm$core$Basics$composeR, $pablohirafuji$elm_markdown$Markdown$Helpers$cleanWhitespaces, $elm$core$String$toLower);
var $pablohirafuji$elm_markdown$Markdown$InlineParser$refRegexToMatch = F3(
	function (matchModel, model, maybeRegexMatch) {
		var regexMatchLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.lU;
					},
					$elm$core$String$length),
				maybeRegexMatch));
		var toMatch = function (urlTitle) {
			return _Utils_update(
				matchModel,
				{
					iE: matchModel.iE + regexMatchLength,
					hT: function () {
						var _v0 = matchModel.hT;
						if (_v0.$ === 5) {
							return $pablohirafuji$elm_markdown$Markdown$InlineParser$ImageType;
						} else {
							return $pablohirafuji$elm_markdown$Markdown$InlineParser$LinkType;
						}
					}()(
						$pablohirafuji$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle(urlTitle))
				});
		};
		var refLabel = function (str) {
			return $elm$core$String$isEmpty(str) ? matchModel.hO : str;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				matchModel.hO,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Maybe$Nothing,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.mM;
								},
								$elm$core$List$head),
							maybeRegexMatch)))));
		var maybeRefItem = A2(
			$elm$core$Dict$get,
			$pablohirafuji$elm_markdown$Markdown$Helpers$prepareRefLabel(refLabel),
			model.hA);
		return A2($elm$core$Maybe$map, toMatch, maybeRefItem);
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$checkForRefLinkTypeOrImageType = function (_v0) {
	var remainText = _v0.a;
	var tempMatch = _v0.b;
	var model = _v0.c;
	return A2(
		$elm$core$Result$fromMaybe,
		_Utils_Tuple3(remainText, tempMatch, model),
		A2(
			$elm$core$Maybe$map,
			$pablohirafuji$elm_markdown$Markdown$InlineParser$addMatch(model),
			A3(
				$pablohirafuji$elm_markdown$Markdown$InlineParser$refRegexToMatch,
				tempMatch,
				model,
				$elm$core$List$head(
					A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$InlineParser$refLabelRegex, remainText)))));
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping = function (parser) {
	var _v0 = parser.e;
	if (!_v0.b) {
		return $elm$core$Result$Err(0);
	} else {
		var match = _v0.a;
		var remainMatches = _v0.b;
		var overlappingMatches = A2(
			$elm$core$List$filter,
			function (_v1) {
				var testMatch = _v1;
				return (_Utils_cmp(match.iE, testMatch.hJ) > 0) && (_Utils_cmp(match.iE, testMatch.iE) < 0);
			},
			remainMatches);
		return ($elm$core$List$isEmpty(remainMatches) || $elm$core$List$isEmpty(overlappingMatches)) ? $elm$core$Result$Ok(parser) : $elm$core$Result$Err(0);
	}
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$emailRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^([a-zA-Z0-9.!#$%&\'*+\\/=?^_`{|}~\\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?)*)$'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$emailAutolinkTypeToMatch = function (_v0) {
	var match = _v0;
	return A2($elm$regex$Regex$contains, $pablohirafuji$elm_markdown$Markdown$InlineParser$emailRegex, match.hO) ? $elm$core$Result$Ok(
		_Utils_update(
			match,
			{
				hT: $pablohirafuji$elm_markdown$Markdown$InlineParser$AutolinkType(
					_Utils_Tuple2(
						match.hO,
						'mailto:' + $pablohirafuji$elm_markdown$Markdown$InlineParser$encodeUrl(match.hO)))
			})) : $elm$core$Result$Err(match);
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$filterTokens = F2(
	function (filter, model) {
		return _Utils_update(
			model,
			{
				p: A2($elm$core$List$filter, filter, model.p)
			});
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$findToken = F2(
	function (isToken, tokens) {
		var search = F2(
			function (token, _v2) {
				var maybeToken = _v2.a;
				var innerTokens = _v2.b;
				var remainTokens = _v2.c;
				if (maybeToken.$ === 1) {
					return isToken(token) ? _Utils_Tuple3(
						$elm$core$Maybe$Just(token),
						innerTokens,
						_List_Nil) : _Utils_Tuple3(
						$elm$core$Maybe$Nothing,
						A2($elm$core$List$cons, token, innerTokens),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						maybeToken,
						innerTokens,
						A2($elm$core$List$cons, token, remainTokens));
				}
			});
		var _return = function (_v0) {
			var maybeToken = _v0.a;
			var innerTokens = _v0.b;
			var remainTokens = _v0.c;
			return A2(
				$elm$core$Maybe$map,
				function (token) {
					return _Utils_Tuple3(
						token,
						$elm$core$List$reverse(innerTokens),
						$elm$core$List$reverse(remainTokens));
				},
				maybeToken);
		};
		return _return(
			A3(
				$elm$core$List$foldl,
				search,
				_Utils_Tuple3($elm$core$Maybe$Nothing, _List_Nil, _List_Nil),
				tokens));
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$HtmlModel = F2(
	function (tag, attributes) {
		return {eP: attributes, ez: tag};
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$HtmlToken = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$attributesFromRegex = function (regexMatch) {
	var _v0 = regexMatch.mM;
	_v0$2:
	while (true) {
		if (_v0.b && (!_v0.a.$)) {
			if (_v0.a.a === '') {
				return $elm$core$Maybe$Nothing;
			} else {
				if ((_v0.b.b && _v0.b.b.b) && _v0.b.b.b.b) {
					var name = _v0.a.a;
					var _v1 = _v0.b;
					var maybeDoubleQuotes = _v1.a;
					var _v2 = _v1.b;
					var maybeSingleQuotes = _v2.a;
					var _v3 = _v2.b;
					var maybeUnquoted = _v3.a;
					var maybeValue = $pablohirafuji$elm_markdown$Markdown$Helpers$returnFirstJust(
						_List_fromArray(
							[maybeDoubleQuotes, maybeSingleQuotes, maybeUnquoted]));
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(name, maybeValue));
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$htmlAttributesRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('([a-zA-Z:_][a-zA-Z0-9\\-_.:]*)(?: ?= ?(?:\"([^\"]*)\"|\'([^\']*)\'|([^\\s\"\'=<>`]*)))?'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$applyAttributesRegex = A2(
	$elm$core$Basics$composeR,
	$elm$regex$Regex$find($pablohirafuji$elm_markdown$Markdown$InlineParser$htmlAttributesRegex),
	$elm$core$List$filterMap($pablohirafuji$elm_markdown$Markdown$InlineParser$attributesFromRegex));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$htmlFromRegex = F3(
	function (model, match, regexMatch) {
		var _v0 = regexMatch.mM;
		if ((((_v0.b && _v0.b.b) && (!_v0.b.a.$)) && _v0.b.b.b) && _v0.b.b.b.b) {
			var maybeClose = _v0.a;
			var _v1 = _v0.b;
			var tag = _v1.a.a;
			var _v2 = _v1.b;
			var maybeAttributes = _v2.a;
			var _v3 = _v2.b;
			var maybeSelfClosing = _v3.a;
			var updateModel = function (attrs) {
				return A2(
					$pablohirafuji$elm_markdown$Markdown$InlineParser$addToken,
					model,
					{
						iX: match.hJ,
						g: match.iE - match.hJ,
						m: A2(
							$pablohirafuji$elm_markdown$Markdown$InlineParser$HtmlToken,
							_Utils_eq(maybeClose, $elm$core$Maybe$Nothing) && _Utils_eq(maybeSelfClosing, $elm$core$Maybe$Nothing),
							A2($pablohirafuji$elm_markdown$Markdown$InlineParser$HtmlModel, tag, attrs))
					});
			};
			var filterAttributes = F2(
				function (attrs, allowed) {
					return A2(
						$elm$core$List$filter,
						function (attr) {
							return A2($elm$core$List$member, attr.a, allowed);
						},
						attrs);
				});
			var attributes = A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $pablohirafuji$elm_markdown$Markdown$InlineParser$applyAttributesRegex, maybeAttributes));
			var noAttributesInCloseTag = _Utils_eq(maybeClose, $elm$core$Maybe$Nothing) || ((!_Utils_eq(maybeClose, $elm$core$Maybe$Nothing)) && _Utils_eq(attributes, _List_Nil));
			var _v4 = model.jm.jB;
			switch (_v4.$) {
				case 0:
					return noAttributesInCloseTag ? $elm$core$Maybe$Just(
						updateModel(attributes)) : $elm$core$Maybe$Nothing;
				case 1:
					var allowedHtmlElements = _v4.a.ic;
					var allowedHtmlAttributes = _v4.a.ib;
					return (A2($elm$core$List$member, tag, allowedHtmlElements) && noAttributesInCloseTag) ? $elm$core$Maybe$Just(
						updateModel(
							A2(filterAttributes, attributes, allowedHtmlAttributes))) : $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$htmlRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^(\\/)?([a-zA-Z][a-zA-Z0-9\\-]*)(?:\\s+([^<>]*?))?(\\/)?$'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$htmlToToken = F2(
	function (model, _v0) {
		var match = _v0;
		var _v1 = model.jm.jB;
		if (_v1.$ === 2) {
			return $elm$core$Maybe$Nothing;
		} else {
			return A2(
				$elm$core$Maybe$andThen,
				A2($pablohirafuji$elm_markdown$Markdown$InlineParser$htmlFromRegex, model, match),
				$elm$core$List$head(
					A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$InlineParser$htmlRegex, match.hO)));
		}
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$isCloseToken = F2(
	function (htmlModel, token) {
		var _v0 = token.m;
		if ((_v0.$ === 5) && (!_v0.a)) {
			var htmlModel_ = _v0.b;
			return _Utils_eq(htmlModel.ez, htmlModel_.ez);
		} else {
			return false;
		}
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$isCodeTokenPair = F2(
	function (closeToken, openToken) {
		var _v0 = openToken.m;
		if (!_v0.$) {
			var isEscaped = _v0.a;
			return isEscaped ? _Utils_eq(openToken.g - 1, closeToken.g) : _Utils_eq(openToken.g, closeToken.g);
		} else {
			return false;
		}
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$isLinkTypeOrImageOpenToken = function (token) {
	var _v0 = token.m;
	switch (_v0.$) {
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken = F2(
	function (closeToken, openToken) {
		var _v0 = openToken.m;
		if (_v0.$ === 6) {
			var openChar = _v0.a;
			var _v1 = _v0.b;
			var openLR = _v1.a;
			var openRR = _v1.b;
			var _v2 = closeToken.m;
			if (_v2.$ === 6) {
				var closeChar = _v2.a;
				var _v3 = _v2.b;
				var closeLR = _v3.a;
				var closeRR = _v3.b;
				return _Utils_eq(openChar, closeChar) ? ((_Utils_eq(openLR, openRR) || _Utils_eq(closeLR, closeRR)) ? (!(!A2($elm$core$Basics$modBy, 3, closeToken.g + openToken.g))) : true) : false;
			} else {
				return false;
			}
		} else {
			return false;
		}
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$voidHtmlTags = _List_fromArray(
	['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'meta', 'param', 'source', 'track', 'wbr']);
var $pablohirafuji$elm_markdown$Markdown$InlineParser$isVoidTag = function (htmlModel) {
	return A2($elm$core$List$member, htmlModel.ez, $pablohirafuji$elm_markdown$Markdown$InlineParser$voidHtmlTags);
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$HardLineBreakType = {$: 1};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$SoftLineBreakToken = {$: 7};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$reverseTokens = function (model) {
	return _Utils_update(
		model,
		{
			p: $elm$core$List$reverse(model.p)
		});
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$tokenToMatch = F2(
	function (token, type_) {
		return {iE: token.iX + token.g, e: _List_Nil, hJ: token.iX, hO: '', dG: 0, aY: 0, hT: type_};
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$lineBreakTTM = function (_v0) {
	lineBreakTTM:
	while (true) {
		var tokens = _v0.a;
		var model = _v0.b;
		if (!tokens.b) {
			return $pablohirafuji$elm_markdown$Markdown$InlineParser$reverseTokens(model);
		} else {
			var token = tokens.a;
			var tokensTail = tokens.b;
			if (_Utils_eq(token.m, $pablohirafuji$elm_markdown$Markdown$InlineParser$HardLineBreakToken) || (_Utils_eq(token.m, $pablohirafuji$elm_markdown$Markdown$InlineParser$SoftLineBreakToken) && model.jm.jU)) {
				return $pablohirafuji$elm_markdown$Markdown$InlineParser$lineBreakTTM(
					function (b) {
						return _Utils_Tuple2(tokensTail, b);
					}(
						_Utils_update(
							model,
							{
								e: A2(
									$elm$core$List$cons,
									A2($pablohirafuji$elm_markdown$Markdown$InlineParser$tokenToMatch, token, $pablohirafuji$elm_markdown$Markdown$InlineParser$HardLineBreakType),
									model.e)
							})));
			} else {
				var $temp$_v0 = _Utils_Tuple2(
					tokensTail,
					A2($pablohirafuji$elm_markdown$Markdown$InlineParser$addToken, model, token));
				_v0 = $temp$_v0;
				continue lineBreakTTM;
			}
		}
	}
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens = F2(
	function (tokensTail, parser) {
		var _v0 = parser.e;
		if (!_v0.b) {
			return _Utils_Tuple2(tokensTail, parser);
		} else {
			var match = _v0.a;
			return _Utils_Tuple2(
				A2(
					$elm$core$List$filter,
					function (token) {
						return _Utils_cmp(token.iX, match.iE) > -1;
					},
					tokensTail),
				parser);
		}
	});
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$angleBracketsToMatch = F4(
	function (closeToken, isEscaped, model, _v24) {
		var openToken = _v24.a;
		var remainTokens = _v24.c;
		return function (result) {
			if (result.$ === 1) {
				var tempMatch = result.a;
				return (!isEscaped) ? A2(
					$pablohirafuji$elm_markdown$Markdown$InlineParser$htmlToToken,
					_Utils_update(
						model,
						{p: remainTokens}),
					tempMatch) : $elm$core$Result$toMaybe(result);
			} else {
				return $elm$core$Result$toMaybe(result);
			}
		}(
			A2(
				$elm$core$Result$map,
				function (newMatch) {
					return _Utils_update(
						model,
						{
							e: A2($elm$core$List$cons, newMatch, model.e),
							p: remainTokens
						});
				},
				A2(
					$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
					$pablohirafuji$elm_markdown$Markdown$InlineParser$emailAutolinkTypeToMatch,
					$pablohirafuji$elm_markdown$Markdown$InlineParser$autolinkToMatch(
						A6(
							$pablohirafuji$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
							model,
							function (s) {
								return s;
							},
							$pablohirafuji$elm_markdown$Markdown$InlineParser$CodeType,
							openToken,
							closeToken,
							_List_Nil)))));
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM = function (_v21) {
	codeAutolinkTypeHtmlTagTTM:
	while (true) {
		var tokens = _v21.a;
		var model = _v21.b;
		if (!tokens.b) {
			return $pablohirafuji$elm_markdown$Markdown$InlineParser$reverseTokens(model);
		} else {
			var token = tokens.a;
			var tokensTail = tokens.b;
			var _v23 = token.m;
			switch (_v23.$) {
				case 0:
					var isEscaped = _v23.a;
					return $pablohirafuji$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM(
						function (b) {
							return _Utils_Tuple2(tokensTail, b);
						}(
							A2(
								$elm$core$Maybe$withDefault,
								A2($pablohirafuji$elm_markdown$Markdown$InlineParser$addToken, model, token),
								A2(
									$elm$core$Maybe$map,
									A2($pablohirafuji$elm_markdown$Markdown$InlineParser$codeToMatch, token, model),
									A2(
										$pablohirafuji$elm_markdown$Markdown$InlineParser$findToken,
										$pablohirafuji$elm_markdown$Markdown$InlineParser$isCodeTokenPair(token),
										model.p)))));
				case 4:
					var isEscaped = _v23.a;
					return $pablohirafuji$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM(
						function (b) {
							return _Utils_Tuple2(tokensTail, b);
						}(
							A2(
								$pablohirafuji$elm_markdown$Markdown$InlineParser$filterTokens,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.m;
									},
									$elm$core$Basics$neq(
										$pablohirafuji$elm_markdown$Markdown$InlineParser$CharToken('<'))),
								A2(
									$elm$core$Maybe$withDefault,
									model,
									A2(
										$elm$core$Maybe$andThen,
										A3($pablohirafuji$elm_markdown$Markdown$InlineParser$angleBracketsToMatch, token, isEscaped, model),
										A2(
											$pablohirafuji$elm_markdown$Markdown$InlineParser$findToken,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.m;
												},
												$elm$core$Basics$eq(
													$pablohirafuji$elm_markdown$Markdown$InlineParser$CharToken('<'))),
											model.p))))));
				default:
					var $temp$_v21 = _Utils_Tuple2(
						tokensTail,
						A2($pablohirafuji$elm_markdown$Markdown$InlineParser$addToken, model, token));
					_v21 = $temp$_v21;
					continue codeAutolinkTypeHtmlTagTTM;
			}
		}
	}
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$codeToMatch = F3(
	function (closeToken, model, _v20) {
		var openToken = _v20.a;
		var remainTokens = _v20.c;
		var updtOpenToken = _Utils_eq(
			openToken.m,
			$pablohirafuji$elm_markdown$Markdown$InlineParser$CodeToken(true)) ? _Utils_update(
			openToken,
			{iX: openToken.iX + 1, g: openToken.g - 1}) : openToken;
		return _Utils_update(
			model,
			{
				e: A2(
					$elm$core$List$cons,
					A6($pablohirafuji$elm_markdown$Markdown$InlineParser$tokenPairToMatch, model, $pablohirafuji$elm_markdown$Markdown$Helpers$cleanWhitespaces, $pablohirafuji$elm_markdown$Markdown$InlineParser$CodeType, updtOpenToken, closeToken, _List_Nil),
					model.e),
				p: remainTokens
			});
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$emphasisTTM = function (_v16) {
	emphasisTTM:
	while (true) {
		var tokens = _v16.a;
		var model = _v16.b;
		if (!tokens.b) {
			return $pablohirafuji$elm_markdown$Markdown$InlineParser$reverseTokens(model);
		} else {
			var token = tokens.a;
			var tokensTail = tokens.b;
			var _v18 = token.m;
			if (_v18.$ === 6) {
				var _char = _v18.a;
				var _v19 = _v18.b;
				var leftRank = _v19.a;
				var rightRank = _v19.b;
				if (_Utils_eq(leftRank, rightRank)) {
					if ((!(!rightRank)) && ((_char !== '_') || (rightRank === 1))) {
						return $pablohirafuji$elm_markdown$Markdown$InlineParser$emphasisTTM(
							A2(
								$elm$core$Maybe$withDefault,
								_Utils_Tuple2(
									tokensTail,
									A2($pablohirafuji$elm_markdown$Markdown$InlineParser$addToken, model, token)),
								A2(
									$elm$core$Maybe$map,
									A3($pablohirafuji$elm_markdown$Markdown$InlineParser$emphasisToMatch, token, tokensTail, model),
									A2(
										$pablohirafuji$elm_markdown$Markdown$InlineParser$findToken,
										$pablohirafuji$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken(token),
										model.p))));
					} else {
						var $temp$_v16 = _Utils_Tuple2(tokensTail, model);
						_v16 = $temp$_v16;
						continue emphasisTTM;
					}
				} else {
					if (_Utils_cmp(leftRank, rightRank) < 0) {
						var $temp$_v16 = _Utils_Tuple2(
							tokensTail,
							A2($pablohirafuji$elm_markdown$Markdown$InlineParser$addToken, model, token));
						_v16 = $temp$_v16;
						continue emphasisTTM;
					} else {
						return $pablohirafuji$elm_markdown$Markdown$InlineParser$emphasisTTM(
							A2(
								$elm$core$Maybe$withDefault,
								_Utils_Tuple2(tokensTail, model),
								A2(
									$elm$core$Maybe$map,
									A3($pablohirafuji$elm_markdown$Markdown$InlineParser$emphasisToMatch, token, tokensTail, model),
									A2(
										$pablohirafuji$elm_markdown$Markdown$InlineParser$findToken,
										$pablohirafuji$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken(token),
										model.p))));
					}
				}
			} else {
				var $temp$_v16 = _Utils_Tuple2(
					tokensTail,
					A2($pablohirafuji$elm_markdown$Markdown$InlineParser$addToken, model, token));
				_v16 = $temp$_v16;
				continue emphasisTTM;
			}
		}
	}
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$emphasisToMatch = F4(
	function (closeToken, tokensTail, model, _v15) {
		var openToken = _v15.a;
		var innerTokens = _v15.b;
		var remainTokens = _v15.c;
		var remainLength = openToken.g - closeToken.g;
		var updt = (!remainLength) ? {eW: closeToken, eo: openToken, fB: remainTokens, fP: tokensTail} : ((remainLength > 0) ? {
			eW: closeToken,
			eo: _Utils_update(
				openToken,
				{iX: openToken.iX + remainLength, g: closeToken.g}),
			fB: A2(
				$elm$core$List$cons,
				_Utils_update(
					openToken,
					{g: remainLength}),
				remainTokens),
			fP: tokensTail
		} : {
			eW: _Utils_update(
				closeToken,
				{g: openToken.g}),
			eo: openToken,
			fB: remainTokens,
			fP: A2(
				$elm$core$List$cons,
				_Utils_update(
					closeToken,
					{iX: closeToken.iX + openToken.g, g: -remainLength}),
				tokensTail)
		});
		var match = A6(
			$pablohirafuji$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
			model,
			function (s) {
				return s;
			},
			$pablohirafuji$elm_markdown$Markdown$InlineParser$EmphasisType(updt.eo.g),
			updt.eo,
			updt.eW,
			$elm$core$List$reverse(innerTokens));
		return _Utils_Tuple2(
			updt.fP,
			_Utils_update(
				model,
				{
					e: A2($elm$core$List$cons, match, model.e),
					p: updt.fB
				}));
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$htmlElementTTM = function (_v12) {
	htmlElementTTM:
	while (true) {
		var tokens = _v12.a;
		var model = _v12.b;
		if (!tokens.b) {
			return $pablohirafuji$elm_markdown$Markdown$InlineParser$reverseTokens(model);
		} else {
			var token = tokens.a;
			var tokensTail = tokens.b;
			var _v14 = token.m;
			if (_v14.$ === 5) {
				var isOpen = _v14.a;
				var htmlModel = _v14.b;
				return ($pablohirafuji$elm_markdown$Markdown$InlineParser$isVoidTag(htmlModel) || (!isOpen)) ? $pablohirafuji$elm_markdown$Markdown$InlineParser$htmlElementTTM(
					function (b) {
						return _Utils_Tuple2(tokensTail, b);
					}(
						A2(
							$pablohirafuji$elm_markdown$Markdown$InlineParser$addMatch,
							model,
							A2(
								$pablohirafuji$elm_markdown$Markdown$InlineParser$tokenToMatch,
								token,
								$pablohirafuji$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel))))) : $pablohirafuji$elm_markdown$Markdown$InlineParser$htmlElementTTM(
					A2(
						$elm$core$Maybe$withDefault,
						function (b) {
							return _Utils_Tuple2(tokensTail, b);
						}(
							A2(
								$pablohirafuji$elm_markdown$Markdown$InlineParser$addMatch,
								model,
								A2(
									$pablohirafuji$elm_markdown$Markdown$InlineParser$tokenToMatch,
									token,
									$pablohirafuji$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel)))),
						A2(
							$elm$core$Maybe$map,
							A3($pablohirafuji$elm_markdown$Markdown$InlineParser$htmlElementToMatch, token, model, htmlModel),
							A2(
								$pablohirafuji$elm_markdown$Markdown$InlineParser$findToken,
								$pablohirafuji$elm_markdown$Markdown$InlineParser$isCloseToken(htmlModel),
								tokensTail))));
			} else {
				var $temp$_v12 = _Utils_Tuple2(
					tokensTail,
					A2($pablohirafuji$elm_markdown$Markdown$InlineParser$addToken, model, token));
				_v12 = $temp$_v12;
				continue htmlElementTTM;
			}
		}
	}
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$htmlElementToMatch = F4(
	function (openToken, model, htmlModel, _v11) {
		var closeToken = _v11.a;
		var innerTokens = _v11.b;
		var remainTokens = _v11.c;
		return _Utils_Tuple2(
			remainTokens,
			_Utils_update(
				model,
				{
					e: A2(
						$elm$core$List$cons,
						A6(
							$pablohirafuji$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
							model,
							function (s) {
								return s;
							},
							$pablohirafuji$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel),
							openToken,
							closeToken,
							innerTokens),
						model.e)
				}));
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$linkImageTypeTTM = function (_v8) {
	linkImageTypeTTM:
	while (true) {
		var tokens = _v8.a;
		var model = _v8.b;
		if (!tokens.b) {
			return $pablohirafuji$elm_markdown$Markdown$InlineParser$reverseTokens(model);
		} else {
			var token = tokens.a;
			var tokensTail = tokens.b;
			var _v10 = token.m;
			if ((_v10.$ === 3) && (']' === _v10.a)) {
				return $pablohirafuji$elm_markdown$Markdown$InlineParser$linkImageTypeTTM(
					A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(tokensTail, model),
						A2(
							$elm$core$Maybe$andThen,
							A3($pablohirafuji$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch, token, tokensTail, model),
							A2($pablohirafuji$elm_markdown$Markdown$InlineParser$findToken, $pablohirafuji$elm_markdown$Markdown$InlineParser$isLinkTypeOrImageOpenToken, model.p))));
			} else {
				var $temp$_v8 = _Utils_Tuple2(
					tokensTail,
					A2($pablohirafuji$elm_markdown$Markdown$InlineParser$addToken, model, token));
				_v8 = $temp$_v8;
				continue linkImageTypeTTM;
			}
		}
	}
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch = F4(
	function (closeToken, tokensTail, model, _v1) {
		var openToken = _v1.a;
		var innerTokens = _v1.b;
		var remainTokens = _v1.c;
		var tempMatch = function (isLinkType) {
			return A6(
				$pablohirafuji$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
				model,
				function (s) {
					return s;
				},
				isLinkType ? $pablohirafuji$elm_markdown$Markdown$InlineParser$LinkType(
					_Utils_Tuple2('', $elm$core$Maybe$Nothing)) : $pablohirafuji$elm_markdown$Markdown$InlineParser$ImageType(
					_Utils_Tuple2('', $elm$core$Maybe$Nothing)),
				openToken,
				closeToken,
				$elm$core$List$reverse(innerTokens));
		};
		var removeOpenToken = _Utils_Tuple2(
			tokensTail,
			_Utils_update(
				model,
				{
					p: _Utils_ap(innerTokens, remainTokens)
				}));
		var remainText = A2($elm$core$String$dropLeft, closeToken.iX + 1, model.Z);
		var linkOpenTokenToInactive = function (model_) {
			var process = function (token) {
				var _v7 = token.m;
				if (_v7.$ === 1) {
					return _Utils_update(
						token,
						{
							m: $pablohirafuji$elm_markdown$Markdown$InlineParser$LinkOpenToken(false)
						});
				} else {
					return token;
				}
			};
			return _Utils_update(
				model_,
				{
					p: A2($elm$core$List$map, process, model_.p)
				});
		};
		var args = function (isLinkType) {
			return _Utils_Tuple3(
				remainText,
				tempMatch(isLinkType),
				_Utils_update(
					model,
					{p: remainTokens}));
		};
		var _v2 = openToken.m;
		switch (_v2.$) {
			case 2:
				return $elm$core$Result$toMaybe(
					A2(
						$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
						function (_v4) {
							return $elm$core$Result$Ok(removeOpenToken);
						},
						A2(
							$elm$core$Result$map,
							$pablohirafuji$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens(tokensTail),
							A2(
								$elm$core$Result$andThen,
								$pablohirafuji$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping,
								A2(
									$elm$core$Result$mapError,
									function (_v3) {
										return 0;
									},
									A2(
										$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
										$pablohirafuji$elm_markdown$Markdown$InlineParser$checkForRefLinkTypeOrImageType,
										$pablohirafuji$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType(
											args(false))))))));
			case 1:
				if (_v2.a) {
					return $elm$core$Result$toMaybe(
						A2(
							$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
							function (_v6) {
								return $elm$core$Result$Ok(removeOpenToken);
							},
							A2(
								$elm$core$Result$map,
								$pablohirafuji$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens(tokensTail),
								A2(
									$elm$core$Result$map,
									linkOpenTokenToInactive,
									A2(
										$elm$core$Result$andThen,
										$pablohirafuji$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping,
										A2(
											$elm$core$Result$mapError,
											function (_v5) {
												return 0;
											},
											A2(
												$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
												$pablohirafuji$elm_markdown$Markdown$InlineParser$checkForRefLinkTypeOrImageType,
												$pablohirafuji$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType(
													args(true)))))))));
				} else {
					return $elm$core$Maybe$Just(removeOpenToken);
				}
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$tokenPairToMatch = F6(
	function (model, processText, type_, openToken, closeToken, innerTokens) {
		var textStart = openToken.iX + openToken.g;
		var textEnd = closeToken.iX;
		var start = openToken.iX;
		var end = closeToken.iX + closeToken.g;
		var match = {
			iE: end,
			e: _List_Nil,
			hJ: start,
			hO: processText(
				A3($elm$core$String$slice, textStart, textEnd, model.Z)),
			dG: textEnd,
			aY: textStart,
			hT: type_
		};
		var matches = A2(
			$elm$core$List$map,
			function (_v0) {
				var matchModel = _v0;
				return A2($pablohirafuji$elm_markdown$Markdown$InlineParser$prepareChildMatch, match, matchModel);
			},
			$pablohirafuji$elm_markdown$Markdown$InlineParser$cyclic$tokensToMatches()(
				_Utils_update(
					model,
					{e: _List_Nil, p: innerTokens})).e);
		return _Utils_update(
			match,
			{e: matches});
	});
function $pablohirafuji$elm_markdown$Markdown$InlineParser$cyclic$tokensToMatches() {
	return A2(
		$elm$core$Basics$composeR,
		$pablohirafuji$elm_markdown$Markdown$InlineParser$applyTTM($pablohirafuji$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM),
		A2(
			$elm$core$Basics$composeR,
			$pablohirafuji$elm_markdown$Markdown$InlineParser$applyTTM($pablohirafuji$elm_markdown$Markdown$InlineParser$htmlElementTTM),
			A2(
				$elm$core$Basics$composeR,
				$pablohirafuji$elm_markdown$Markdown$InlineParser$applyTTM($pablohirafuji$elm_markdown$Markdown$InlineParser$linkImageTypeTTM),
				A2(
					$elm$core$Basics$composeR,
					$pablohirafuji$elm_markdown$Markdown$InlineParser$applyTTM($pablohirafuji$elm_markdown$Markdown$InlineParser$emphasisTTM),
					$pablohirafuji$elm_markdown$Markdown$InlineParser$applyTTM($pablohirafuji$elm_markdown$Markdown$InlineParser$lineBreakTTM)))));
}
var $pablohirafuji$elm_markdown$Markdown$InlineParser$tokensToMatches = $pablohirafuji$elm_markdown$Markdown$InlineParser$cyclic$tokensToMatches();
$pablohirafuji$elm_markdown$Markdown$InlineParser$cyclic$tokensToMatches = function () {
	return $pablohirafuji$elm_markdown$Markdown$InlineParser$tokensToMatches;
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$parse = F3(
	function (options, refs, rawText) {
		return $pablohirafuji$elm_markdown$Markdown$InlineParser$matchesToInlines(
			$pablohirafuji$elm_markdown$Markdown$InlineParser$parseText(
				$pablohirafuji$elm_markdown$Markdown$InlineParser$organizeParserMatches(
					$pablohirafuji$elm_markdown$Markdown$InlineParser$tokensToMatches(
						$pablohirafuji$elm_markdown$Markdown$InlineParser$tokenize(
							A3(
								$pablohirafuji$elm_markdown$Markdown$InlineParser$initParser,
								options,
								refs,
								$elm$core$String$trim(rawText)))))).e);
	});
var $pablohirafuji$elm_markdown$Markdown$Block$parseInline = F4(
	function (maybeOptions, textAsParagraph, refs, block) {
		var options = A2($elm$core$Maybe$withDefault, $pablohirafuji$elm_markdown$Markdown$Config$defaultOptions, maybeOptions);
		switch (block.$) {
			case 2:
				var rawText = block.a;
				var lvl = block.b;
				return A3(
					$pablohirafuji$elm_markdown$Markdown$Block$Heading,
					rawText,
					lvl,
					A3($pablohirafuji$elm_markdown$Markdown$InlineParser$parse, options, refs, rawText));
			case 4:
				var rawText = block.a;
				var inlines = A3($pablohirafuji$elm_markdown$Markdown$InlineParser$parse, options, refs, rawText);
				if ((inlines.b && (inlines.a.$ === 5)) && (!inlines.b.b)) {
					var _v3 = inlines.a;
					return $pablohirafuji$elm_markdown$Markdown$Block$PlainInlines(inlines);
				} else {
					return textAsParagraph ? A2($pablohirafuji$elm_markdown$Markdown$Block$Paragraph, rawText, inlines) : $pablohirafuji$elm_markdown$Markdown$Block$PlainInlines(inlines);
				}
			case 5:
				var blocks = block.a;
				return $pablohirafuji$elm_markdown$Markdown$Block$BlockQuote(
					A3(
						$pablohirafuji$elm_markdown$Markdown$Block$parseInlines,
						maybeOptions,
						true,
						_Utils_Tuple2(refs, blocks)));
			case 6:
				var model = block.a;
				var items = block.b;
				return A2(
					$pablohirafuji$elm_markdown$Markdown$Block$List,
					model,
					function (a) {
						return A2($elm$core$List$map, a, items);
					}(
						A2(
							$elm$core$Basics$composeL,
							A2($pablohirafuji$elm_markdown$Markdown$Block$parseInlines, maybeOptions, model.bv),
							function (b) {
								return _Utils_Tuple2(refs, b);
							})));
			case 8:
				var customBlock = block.a;
				var blocks = block.b;
				return A2(
					$pablohirafuji$elm_markdown$Markdown$Block$Custom,
					customBlock,
					A3(
						$pablohirafuji$elm_markdown$Markdown$Block$parseInlines,
						maybeOptions,
						true,
						_Utils_Tuple2(refs, blocks)));
			default:
				return block;
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Block$parseInlines = F3(
	function (maybeOptions, textAsParagraph, _v0) {
		var refs = _v0.a;
		var blocks = _v0.b;
		return A2(
			$elm$core$List$map,
			A3($pablohirafuji$elm_markdown$Markdown$Block$parseInline, maybeOptions, textAsParagraph, refs),
			blocks);
	});
var $pablohirafuji$elm_markdown$Markdown$Block$dropRefString = F2(
	function (rawText, inlineMatch) {
		var strippedText = A2($elm$core$String$dropLeft, inlineMatch.g_, rawText);
		return A2($elm$regex$Regex$contains, $pablohirafuji$elm_markdown$Markdown$Block$blankLineRegex, strippedText) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(strippedText);
	});
var $pablohirafuji$elm_markdown$Markdown$Block$insertLinkMatch = F2(
	function (refs, linkMatch) {
		return A2($elm$core$Dict$member, linkMatch.b2, refs) ? refs : A3(
			$elm$core$Dict$insert,
			linkMatch.b2,
			_Utils_Tuple2(linkMatch.nj, linkMatch.g$),
			refs);
	});
var $pablohirafuji$elm_markdown$Markdown$Block$extractUrlTitleRegex = function (regexMatch) {
	var _v0 = regexMatch.mM;
	if ((((((_v0.b && (!_v0.a.$)) && _v0.b.b) && _v0.b.b.b) && _v0.b.b.b.b) && _v0.b.b.b.b.b) && _v0.b.b.b.b.b.b) {
		var rawText = _v0.a.a;
		var _v1 = _v0.b;
		var maybeRawUrlAngleBrackets = _v1.a;
		var _v2 = _v1.b;
		var maybeRawUrlWithoutBrackets = _v2.a;
		var _v3 = _v2.b;
		var maybeTitleSingleQuotes = _v3.a;
		var _v4 = _v3.b;
		var maybeTitleDoubleQuotes = _v4.a;
		var _v5 = _v4.b;
		var maybeTitleParenthesis = _v5.a;
		var toReturn = function (rawUrl) {
			return {
				b2: rawText,
				g_: $elm$core$String$length(regexMatch.lU),
				g$: $pablohirafuji$elm_markdown$Markdown$Helpers$returnFirstJust(
					_List_fromArray(
						[maybeTitleSingleQuotes, maybeTitleDoubleQuotes, maybeTitleParenthesis])),
				nj: rawUrl
			};
		};
		var maybeRawUrl = $pablohirafuji$elm_markdown$Markdown$Helpers$returnFirstJust(
			_List_fromArray(
				[maybeRawUrlAngleBrackets, maybeRawUrlWithoutBrackets]));
		return A2($elm$core$Maybe$map, toReturn, maybeRawUrl);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pablohirafuji$elm_markdown$Markdown$Block$hrefRegex = '\\s*(?:<([^<>\\s]*)>|([^\\s]*))';
var $pablohirafuji$elm_markdown$Markdown$Block$refRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\\s*\\[(' + ($pablohirafuji$elm_markdown$Markdown$Helpers$insideSquareBracketRegex + (')\\]:' + ($pablohirafuji$elm_markdown$Markdown$Block$hrefRegex + ($pablohirafuji$elm_markdown$Markdown$Helpers$titleRegex + '\\s*(?![^\\n])'))))));
var $pablohirafuji$elm_markdown$Markdown$Block$maybeLinkMatch = function (rawText) {
	return A2(
		$elm$core$Maybe$andThen,
		function (linkMatch) {
			return ((linkMatch.nj === '') || (linkMatch.b2 === '')) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(linkMatch);
		},
		A2(
			$elm$core$Maybe$map,
			function (linkMatch) {
				return _Utils_update(
					linkMatch,
					{
						b2: $pablohirafuji$elm_markdown$Markdown$Helpers$prepareRefLabel(linkMatch.b2)
					});
			},
			A2(
				$elm$core$Maybe$andThen,
				$pablohirafuji$elm_markdown$Markdown$Block$extractUrlTitleRegex,
				$elm$core$List$head(
					A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$Block$refRegex, rawText)))));
};
var $pablohirafuji$elm_markdown$Markdown$Block$parseReference = F2(
	function (refs, rawText) {
		parseReference:
		while (true) {
			var _v0 = $pablohirafuji$elm_markdown$Markdown$Block$maybeLinkMatch(rawText);
			if (!_v0.$) {
				var linkMatch = _v0.a;
				var updtRefs = A2($pablohirafuji$elm_markdown$Markdown$Block$insertLinkMatch, refs, linkMatch);
				var maybeStrippedText = A2($pablohirafuji$elm_markdown$Markdown$Block$dropRefString, rawText, linkMatch);
				if (!maybeStrippedText.$) {
					var strippedText = maybeStrippedText.a;
					var $temp$refs = updtRefs,
						$temp$rawText = strippedText;
					refs = $temp$refs;
					rawText = $temp$rawText;
					continue parseReference;
				} else {
					return _Utils_Tuple2(updtRefs, $elm$core$Maybe$Nothing);
				}
			} else {
				return _Utils_Tuple2(
					refs,
					$elm$core$Maybe$Just(rawText));
			}
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Block$parseReferences = function (refs) {
	return A2(
		$elm$core$List$foldl,
		$pablohirafuji$elm_markdown$Markdown$Block$parseReferencesHelp,
		_Utils_Tuple2(refs, _List_Nil));
};
var $pablohirafuji$elm_markdown$Markdown$Block$parseReferencesHelp = F2(
	function (block, _v0) {
		var refs = _v0.a;
		var parsedAST = _v0.b;
		switch (block.$) {
			case 4:
				var rawText = block.a;
				var _v2 = A2($pablohirafuji$elm_markdown$Markdown$Block$parseReference, $elm$core$Dict$empty, rawText);
				var paragraphRefs = _v2.a;
				var maybeUpdtText = _v2.b;
				var updtRefs = A2($elm$core$Dict$union, paragraphRefs, refs);
				if (!maybeUpdtText.$) {
					var updtText = maybeUpdtText.a;
					return _Utils_Tuple2(
						updtRefs,
						A2(
							$elm$core$List$cons,
							A2($pablohirafuji$elm_markdown$Markdown$Block$Paragraph, updtText, _List_Nil),
							parsedAST));
				} else {
					return _Utils_Tuple2(updtRefs, parsedAST);
				}
			case 6:
				var model = block.a;
				var items = block.b;
				var _v4 = A3(
					$elm$core$List$foldl,
					F2(
						function (item, _v5) {
							var refs__ = _v5.a;
							var parsedItems = _v5.b;
							return A2(
								$elm$core$Tuple$mapSecond,
								function (a) {
									return A2($elm$core$List$cons, a, parsedItems);
								},
								A2($pablohirafuji$elm_markdown$Markdown$Block$parseReferences, refs__, item));
						}),
					_Utils_Tuple2(refs, _List_Nil),
					items);
				var updtRefs = _v4.a;
				var updtItems = _v4.b;
				return _Utils_Tuple2(
					updtRefs,
					A2(
						$elm$core$List$cons,
						A2($pablohirafuji$elm_markdown$Markdown$Block$List, model, updtItems),
						parsedAST));
			case 5:
				var blocks = block.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (a) {
						return A2($elm$core$List$cons, a, parsedAST);
					},
					A2(
						$elm$core$Tuple$mapSecond,
						$pablohirafuji$elm_markdown$Markdown$Block$BlockQuote,
						A2($pablohirafuji$elm_markdown$Markdown$Block$parseReferences, refs, blocks)));
			case 8:
				var customBlock = block.a;
				var blocks = block.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (a) {
						return A2($elm$core$List$cons, a, parsedAST);
					},
					A2(
						$elm$core$Tuple$mapSecond,
						$pablohirafuji$elm_markdown$Markdown$Block$Custom(customBlock),
						A2($pablohirafuji$elm_markdown$Markdown$Block$parseReferences, refs, blocks)));
			default:
				return _Utils_Tuple2(
					refs,
					A2($elm$core$List$cons, block, parsedAST));
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Block$parse = function (maybeOptions) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$String$lines,
		A2(
			$elm$core$Basics$composeR,
			function (a) {
				return A2($pablohirafuji$elm_markdown$Markdown$Block$incorporateLines, a, _List_Nil);
			},
			A2(
				$elm$core$Basics$composeR,
				$pablohirafuji$elm_markdown$Markdown$Block$parseReferences($elm$core$Dict$empty),
				A2($pablohirafuji$elm_markdown$Markdown$Block$parseInlines, maybeOptions, true))));
};
var $elm$html$Html$blockquote = _VirtualDom_node('blockquote');
var $elm$html$Html$code = _VirtualDom_node('code');
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $elm$html$Html$h6 = _VirtualDom_node('h6');
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$html$Html$ol = _VirtualDom_node('ol');
var $elm$html$Html$p = _VirtualDom_node('p');
var $elm$html$Html$pre = _VirtualDom_node('pre');
var $elm$html$Html$Attributes$start = function (n) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'start',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $pablohirafuji$elm_markdown$Markdown$Inline$attributeToAttribute = function (_v0) {
	var name = _v0.a;
	var maybeValue = _v0.b;
	return A2(
		$elm$html$Html$Attributes$attribute,
		name,
		A2($elm$core$Maybe$withDefault, name, maybeValue));
};
var $pablohirafuji$elm_markdown$Markdown$Inline$attributesToHtmlAttributes = $elm$core$List$map($pablohirafuji$elm_markdown$Markdown$Inline$attributeToAttribute);
var $elm$html$Html$br = _VirtualDom_node('br');
var $elm$html$Html$em = _VirtualDom_node('em');
var $pablohirafuji$elm_markdown$Markdown$Inline$extractText = function (inlines) {
	return A3($elm$core$List$foldl, $pablohirafuji$elm_markdown$Markdown$Inline$extractTextHelp, '', inlines);
};
var $pablohirafuji$elm_markdown$Markdown$Inline$extractTextHelp = F2(
	function (inline, text) {
		switch (inline.$) {
			case 0:
				var str = inline.a;
				return _Utils_ap(text, str);
			case 1:
				return text + ' ';
			case 2:
				var str = inline.a;
				return _Utils_ap(text, str);
			case 3:
				var inlines = inline.c;
				return _Utils_ap(
					text,
					$pablohirafuji$elm_markdown$Markdown$Inline$extractText(inlines));
			case 4:
				var inlines = inline.c;
				return _Utils_ap(
					text,
					$pablohirafuji$elm_markdown$Markdown$Inline$extractText(inlines));
			case 5:
				var inlines = inline.c;
				return _Utils_ap(
					text,
					$pablohirafuji$elm_markdown$Markdown$Inline$extractText(inlines));
			case 6:
				var inlines = inline.b;
				return _Utils_ap(
					text,
					$pablohirafuji$elm_markdown$Markdown$Inline$extractText(inlines));
			default:
				var inlines = inline.b;
				return _Utils_ap(
					text,
					$pablohirafuji$elm_markdown$Markdown$Inline$extractText(inlines));
		}
	});
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $pablohirafuji$elm_markdown$Markdown$Inline$defaultHtml = F2(
	function (customTransformer, inline) {
		var transformer = A2(
			$elm$core$Maybe$withDefault,
			$pablohirafuji$elm_markdown$Markdown$Inline$defaultHtml($elm$core$Maybe$Nothing),
			customTransformer);
		switch (inline.$) {
			case 0:
				var str = inline.a;
				return $elm$html$Html$text(str);
			case 1:
				return A2($elm$html$Html$br, _List_Nil, _List_Nil);
			case 2:
				var codeStr = inline.a;
				return A2(
					$elm$html$Html$code,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(codeStr)
						]));
			case 3:
				var url = inline.a;
				var maybeTitle = inline.b;
				var inlines = inline.c;
				if (!maybeTitle.$) {
					var title_ = maybeTitle.a;
					return A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(url),
								$elm$html$Html$Attributes$title(title_)
							]),
						A2($elm$core$List$map, transformer, inlines));
				} else {
					return A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(url)
							]),
						A2($elm$core$List$map, transformer, inlines));
				}
			case 4:
				var url = inline.a;
				var maybeTitle = inline.b;
				var inlines = inline.c;
				if (!maybeTitle.$) {
					var title_ = maybeTitle.a;
					return A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$alt(
								$pablohirafuji$elm_markdown$Markdown$Inline$extractText(inlines)),
								$elm$html$Html$Attributes$src(url),
								$elm$html$Html$Attributes$title(title_)
							]),
						_List_Nil);
				} else {
					return A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$alt(
								$pablohirafuji$elm_markdown$Markdown$Inline$extractText(inlines)),
								$elm$html$Html$Attributes$src(url)
							]),
						_List_Nil);
				}
			case 5:
				var tag = inline.a;
				var attrs = inline.b;
				var inlines = inline.c;
				return A3(
					$elm$html$Html$node,
					tag,
					$pablohirafuji$elm_markdown$Markdown$Inline$attributesToHtmlAttributes(attrs),
					A2($elm$core$List$map, transformer, inlines));
			case 6:
				var length = inline.a;
				var inlines = inline.b;
				switch (length) {
					case 1:
						return A2(
							$elm$html$Html$em,
							_List_Nil,
							A2($elm$core$List$map, transformer, inlines));
					case 2:
						return A2(
							$elm$html$Html$strong,
							_List_Nil,
							A2($elm$core$List$map, transformer, inlines));
					default:
						return ((length - 2) > 0) ? A2(
							$elm$html$Html$strong,
							_List_Nil,
							function (a) {
								return A2($elm$core$List$cons, a, _List_Nil);
							}(
								transformer(
									A2($pablohirafuji$elm_markdown$Markdown$Inline$Emphasis, length - 2, inlines)))) : A2(
							$elm$html$Html$em,
							_List_Nil,
							A2($elm$core$List$map, transformer, inlines));
				}
			default:
				var inlines = inline.b;
				return $elm$html$Html$text('');
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Inline$toHtml = $pablohirafuji$elm_markdown$Markdown$Inline$defaultHtml($elm$core$Maybe$Nothing);
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $pablohirafuji$elm_markdown$Markdown$Block$defaultHtml = F3(
	function (customHtml, customInlineHtml, block) {
		var inlineToHtml = A2($elm$core$Maybe$withDefault, $pablohirafuji$elm_markdown$Markdown$Inline$toHtml, customInlineHtml);
		var blockToHtml = A2(
			$elm$core$Maybe$withDefault,
			A2($pablohirafuji$elm_markdown$Markdown$Block$defaultHtml, $elm$core$Maybe$Nothing, customInlineHtml),
			customHtml);
		switch (block.$) {
			case 0:
				return _List_Nil;
			case 2:
				var level = block.b;
				var inlines = block.c;
				var hElement = function () {
					switch (level) {
						case 1:
							return $elm$html$Html$h1(_List_Nil);
						case 2:
							return $elm$html$Html$h2(_List_Nil);
						case 3:
							return $elm$html$Html$h3(_List_Nil);
						case 4:
							return $elm$html$Html$h4(_List_Nil);
						case 5:
							return $elm$html$Html$h5(_List_Nil);
						default:
							return $elm$html$Html$h6(_List_Nil);
					}
				}();
				return _List_fromArray(
					[
						hElement(
						A2($elm$core$List$map, inlineToHtml, inlines))
					]);
			case 1:
				return _List_fromArray(
					[
						A2($elm$html$Html$hr, _List_Nil, _List_Nil)
					]);
			case 4:
				var inlines = block.b;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						A2($elm$core$List$map, inlineToHtml, inlines))
					]);
			case 3:
				if (block.a.$ === 1) {
					var _v2 = block.a;
					var model = _v2.b;
					var codeStr = block.b;
					var basicView = function (attrs) {
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$pre,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$code,
										attrs,
										_List_fromArray(
											[
												$elm$html$Html$text(codeStr)
											]))
									]))
							]);
					};
					var _v3 = model.gW;
					if (!_v3.$) {
						var language = _v3.a;
						return basicView(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('language-' + language)
								]));
					} else {
						return basicView(_List_Nil);
					}
				} else {
					var _v4 = block.a;
					var codeStr = block.b;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$pre,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$code,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(codeStr)
										]))
								]))
						]);
				}
			case 5:
				var blocks = block.a;
				return function (a) {
					return A2($elm$core$List$cons, a, _List_Nil);
				}(
					A2(
						$elm$html$Html$blockquote,
						_List_Nil,
						$elm$core$List$concat(
							A2($elm$core$List$map, blockToHtml, blocks))));
			case 6:
				var model = block.a;
				var items = block.b;
				return function (a) {
					return A2($elm$core$List$cons, a, _List_Nil);
				}(
					function () {
						var _v5 = model.hT;
						if (_v5.$ === 1) {
							var startInt = _v5.a;
							return (startInt === 1) ? $elm$html$Html$ol(_List_Nil) : $elm$html$Html$ol(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$start(startInt)
									]));
						} else {
							return $elm$html$Html$ul(_List_Nil);
						}
					}()(
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$map(blockToHtml),
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$concat,
									$elm$html$Html$li(_List_Nil))),
							items)));
			case 7:
				var inlines = block.a;
				return A2($elm$core$List$map, inlineToHtml, inlines);
			default:
				var customBlock = block.a;
				var blocks = block.b;
				return function (a) {
					return A2($elm$core$List$cons, a, _List_Nil);
				}(
					A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$text('Unhandled custom block.'),
							$elm$core$List$concat(
								A2($elm$core$List$map, blockToHtml, blocks)))));
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Block$toHtml = A2($pablohirafuji$elm_markdown$Markdown$Block$defaultHtml, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
var $pablohirafuji$elm_markdown$Markdown$toHtml = F2(
	function (maybeOptions, rawText) {
		return $elm$core$List$concat(
			A2(
				$elm$core$List$map,
				$pablohirafuji$elm_markdown$Markdown$Block$toHtml,
				A2($pablohirafuji$elm_markdown$Markdown$Block$parse, maybeOptions, rawText)));
	});
var $author$project$Dialogs$ReleaseNotes$view = function (model) {
	return A2(
		$aforemny$material_components_web_elm$Material$Dialog$dialog,
		A2(
			$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
			$author$project$Dialogs$ReleaseNotes$CloseDialog,
			A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.bX, $aforemny$material_components_web_elm$Material$Dialog$config)),
		{
			kk: _List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$Button$outlined,
					A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Dialogs$ReleaseNotes$CloseDialog, $aforemny$material_components_web_elm$Material$Button$config),
					'Close')
				]),
			k_: _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'min-width', '40vw'),
							A2($elm$html$Html$Attributes$style, 'max-width', '960px'),
							A2($elm$html$Html$Attributes$style, 'min-height', '500px'),
							A2($elm$html$Html$Attributes$style, 'max-height', '60vh'),
							A2($elm$html$Html$Attributes$style, 'overflow-y', 'scroll'),
							A2($elm$html$Html$Attributes$style, 'padding', '0px 12px')
						]),
					A2($pablohirafuji$elm_markdown$Markdown$toHtml, $elm$core$Maybe$Nothing, $author$project$Dialogs$ReleaseNotes$releaseNotes))
				]),
			na: $elm$core$Maybe$Just('What\'s New ?')
		});
};
var $author$project$Footer$copyrightYear = function (currYear) {
	return 'Copyright© 2016-' + currYear;
};
var $author$project$Mdl$Elevation$e4 = $elm$html$Html$Attributes$class('mdl-shadow--4dp');
var $author$project$Reusable$Separator$viewDot = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'padding', '0px 8px')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('•')
		]));
var $author$project$Footer$view = F2(
	function (flags, config) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Mdl$Elevation$e4,
					$elm$html$Html$Attributes$id('footer'),
					A2($elm$html$Html$Attributes$style, 'flex-wrap', 'wrap')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Footer$copyrightYear(flags.nr)),
					$elm$html$Html$text(' Cybersoft Technologies, Inc. All rights reserved.'),
					$author$project$Reusable$Separator$viewDot,
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(config.jj),
							A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
							A2($elm$html$Html$Attributes$style, 'padding-left', '4px')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Contact us')
						])),
					$author$project$Reusable$Separator$viewDot,
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(config.jk),
							A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('FAQ')
						])),
					$author$project$Reusable$Separator$viewDot,
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(config.jl),
							A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('v' + flags.hW)
						]))
				]));
	});
var $author$project$Pages$Faq$CloseDialog = {$: 2};
var $NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$isJust = function (maybeThing) {
	if (!maybeThing.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$String$filter = _String_filter;
var $NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$root = function (string) {
	return A2(
		$elm$core$String$filter,
		function (c) {
			return $elm$core$Char$isLower(c) || $elm$core$Char$isDigit(c);
		},
		$elm$core$String$toLower(string));
};
var $NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$searchHelper = F2(
	function (letter, restOfWord) {
		if (!restOfWord.$) {
			var string = restOfWord.a;
			var _v1 = A2(
				$elm$core$String$indexes,
				$elm$core$String$fromChar(letter),
				string);
			if (!_v1.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var found = _v1.a;
				return $elm$core$Maybe$Just(
					A2($elm$core$String$dropLeft, found + 1, string));
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$match = F2(
	function (needle, haystack) {
		return $NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$isJust(
			A3(
				$elm$core$String$foldl,
				$NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$searchHelper,
				$elm$core$Maybe$Just(
					$NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$root(haystack)),
				$NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$root(needle)));
	});
var $NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$filter = F3(
	function (map, needle, records) {
		return A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeL,
				$NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$match(needle),
				map),
			records);
	});
var $author$project$Pages$Faq$filterStuff = F2(
	function (inp, list) {
		return A3(
			$NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$filter,
			function ($) {
				return $.Y;
			},
			inp,
			list);
	});
var $author$project$Pages$Faq$viewEmpty = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$author$project$Mdl$Elevation$e4,
			A2($elm$html$Html$Attributes$style, 'padding', '16px'),
			A2($elm$html$Html$Attributes$style, 'margin-bottom', '12px'),
			A2($elm$html$Html$Attributes$style, 'width', '96%')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('None found')
		]));
var $aforemny$material_components_web_elm$Material$Typography$body1 = $elm$html$Html$Attributes$class('mdc-typography--body1');
var $author$project$Pages$Faq$viewFaqStep = function (step) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(step)
			]));
};
var $author$project$Pages$Faq$viewFaqCardDesc = function (answer) {
	if (!answer.$) {
		var strAnswer = answer.a;
		return A2(
			$elm$html$Html$p,
			_List_fromArray(
				[$aforemny$material_components_web_elm$Material$Typography$body1]),
			_List_fromArray(
				[
					$elm$html$Html$text(strAnswer)
				]));
	} else {
		var desc = answer.a;
		var steps = answer.b;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($elm$core$Maybe$withDefault, '', desc)),
					A2(
					$elm$html$Html$ol,
					_List_Nil,
					A2($elm$core$List$map, $author$project$Pages$Faq$viewFaqStep, steps))
				]));
	}
};
var $aforemny$material_components_web_elm$Material$Typography$headline4 = $elm$html$Html$Attributes$class('mdc-typography--headline4');
var $author$project$Pages$Faq$viewFaqCardTitle = function (title) {
	return A2(
		$elm$html$Html$h4,
		_List_fromArray(
			[$aforemny$material_components_web_elm$Material$Typography$headline4]),
		_List_fromArray(
			[
				$elm$html$Html$text(title)
			]));
};
var $author$project$Pages$Faq$viewFaqCard = function (faq) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Mdl$Elevation$e2,
				A2($elm$html$Html$Attributes$style, 'padding', '16px'),
				A2($elm$html$Html$Attributes$style, 'margin-bottom', '12px'),
				A2($elm$html$Html$Attributes$style, 'width', '96%')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Faq$viewFaqCardTitle(faq.Y),
				$author$project$Pages$Faq$viewFaqCardDesc(faq._)
			]));
};
var $author$project$Pages$Faq$OnInput = function (a) {
	return {$: 0, a: a};
};
var $aforemny$material_components_web_elm$Material$TextField$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$TextField$config = {fZ: _List_Nil, d$: false, gp: false, ea: false, c9: $elm$core$Maybe$Nothing, i4: $elm$core$Maybe$Nothing, fn: $elm$core$Maybe$Nothing, fo: $elm$core$Maybe$Nothing, fq: $elm$core$Maybe$Nothing, fr: $elm$core$Maybe$Nothing, fx: $elm$core$Maybe$Nothing, hg: $elm$core$Maybe$Nothing, hp: $elm$core$Maybe$Nothing, ht: $elm$core$Maybe$Nothing, hu: $elm$core$Maybe$Nothing, hB: false, fL: $elm$core$Maybe$Nothing, hM: $elm$core$Maybe$Nothing, fR: $elm$core$Maybe$Nothing, hT: $elm$core$Maybe$Nothing, hU: true, eL: $elm$core$Maybe$Nothing};
var $aforemny$material_components_web_elm$Material$TextField$Icon$Internal$Icon = function (a) {
	return {$: 0, a: a};
};
var $aforemny$material_components_web_elm$Material$TextField$Icon$customIcon = F3(
	function (node, attributes, nodes) {
		return $aforemny$material_components_web_elm$Material$TextField$Icon$Internal$Icon(
			{eP: attributes, d$: false, aJ: node, ft: nodes, ji: $elm$core$Maybe$Nothing});
	});
var $aforemny$material_components_web_elm$Material$TextField$Icon$icon = function (iconName) {
	return A3(
		$aforemny$material_components_web_elm$Material$TextField$Icon$customIcon,
		$elm$html$Html$i,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('material-icons')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(iconName)
			]));
};
var $aforemny$material_components_web_elm$Material$TextField$disabledCs = function (_v0) {
	var disabled = _v0.d$;
	return disabled ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--disabled')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextField$disabledProp = function (_v0) {
	var disabled = _v0.d$;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'disabled',
			$elm$json$Json$Encode$bool(disabled)));
};
var $aforemny$material_components_web_elm$Material$TextField$endAlignedCs = function (_v0) {
	var endAligned = _v0.gp;
	return endAligned ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--end-aligned')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextField$filledCs = function (outlined_) {
	return (!outlined_) ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--filled')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextField$foucClassNamesProp = $elm$core$Maybe$Just(
	A2(
		$elm$html$Html$Attributes$property,
		'foucClassNames',
		A2(
			$elm$json$Json$Encode$list,
			$elm$json$Json$Encode$string,
			_List_fromArray(
				['mdc-text-field--label-floating']))));
var $aforemny$material_components_web_elm$Material$TextField$fullwidthCs = function (_v0) {
	var fullwidth = _v0.ea;
	return fullwidth ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--fullwidth')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextField$ariaLabelAttr = function (_v0) {
	var fullwidth = _v0.ea;
	var placeholder = _v0.ht;
	var label = _v0.c9;
	return fullwidth ? A2(
		$elm$core$Maybe$map,
		$elm$html$Html$Attributes$attribute('aria-label'),
		label) : $elm$core$Maybe$Nothing;
};
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $aforemny$material_components_web_elm$Material$TextField$changeHandler = function (_v0) {
	var onChange = _v0.fx;
	return A2(
		$elm$core$Maybe$map,
		function (f) {
			return A2(
				$elm$html$Html$Events$on,
				'change',
				A2($elm$json$Json$Decode$map, f, $elm$html$Html$Events$targetValue));
		},
		onChange);
};
var $elm$html$Html$input = _VirtualDom_node('input');
var $aforemny$material_components_web_elm$Material$TextField$inputCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-text-field__input'));
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $aforemny$material_components_web_elm$Material$TextField$inputHandler = function (_v0) {
	var onInput = _v0.hg;
	return A2($elm$core$Maybe$map, $elm$html$Html$Events$onInput, onInput);
};
var $aforemny$material_components_web_elm$Material$TextField$maxLengthAttr = function (_v0) {
	var maxLength = _v0.fo;
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$html$Html$Attributes$attribute('maxLength'),
			$elm$core$String$fromInt),
		maxLength);
};
var $aforemny$material_components_web_elm$Material$TextField$minLengthAttr = function (_v0) {
	var minLength = _v0.fr;
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$html$Html$Attributes$attribute('minLength'),
			$elm$core$String$fromInt),
		minLength);
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $aforemny$material_components_web_elm$Material$TextField$placeholderAttr = function (_v0) {
	var placeholder = _v0.ht;
	return A2($elm$core$Maybe$map, $elm$html$Html$Attributes$placeholder, placeholder);
};
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $aforemny$material_components_web_elm$Material$TextField$typeAttr = function (_v0) {
	var type_ = _v0.hT;
	return A2($elm$core$Maybe$map, $elm$html$Html$Attributes$type_, type_);
};
var $aforemny$material_components_web_elm$Material$TextField$inputElt = function (config_) {
	return A2(
		$elm$html$Html$input,
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$TextField$inputCs,
					$aforemny$material_components_web_elm$Material$TextField$typeAttr(config_),
					$aforemny$material_components_web_elm$Material$TextField$ariaLabelAttr(config_),
					$aforemny$material_components_web_elm$Material$TextField$placeholderAttr(config_),
					$aforemny$material_components_web_elm$Material$TextField$inputHandler(config_),
					$aforemny$material_components_web_elm$Material$TextField$changeHandler(config_),
					$aforemny$material_components_web_elm$Material$TextField$minLengthAttr(config_),
					$aforemny$material_components_web_elm$Material$TextField$maxLengthAttr(config_)
				])),
		_List_Nil);
};
var $aforemny$material_components_web_elm$Material$TextField$labelElt = function (_v0) {
	var label = _v0.c9;
	var value = _v0.eL;
	var fullwidth = _v0.ea;
	var floatingLabelFloatAboveCs = 'mdc-floating-label--float-above';
	var floatingLabelCs = 'mdc-floating-label';
	var _v1 = _Utils_Tuple2(fullwidth, label);
	if ((!_v1.a) && (!_v1.b.$)) {
		var str = _v1.b.a;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					(A2($elm$core$Maybe$withDefault, '', value) !== '') ? $elm$html$Html$Attributes$class(floatingLabelCs + (' ' + floatingLabelFloatAboveCs)) : $elm$html$Html$Attributes$class(floatingLabelCs),
					A2(
					$elm$html$Html$Attributes$property,
					'foucClassNames',
					A2(
						$elm$json$Json$Encode$list,
						$elm$json$Json$Encode$string,
						_List_fromArray(
							[floatingLabelFloatAboveCs])))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(str)
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $aforemny$material_components_web_elm$Material$TextField$labelFloatingCs = function (_v0) {
	var label = _v0.c9;
	var value = _v0.eL;
	var fullwidth = _v0.ea;
	return ((!fullwidth) && ((!_Utils_eq(label, $elm$core$Maybe$Nothing)) && (A2($elm$core$Maybe$withDefault, '', value) !== ''))) ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--label-floating')) : $elm$core$Maybe$Nothing;
};
var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $aforemny$material_components_web_elm$Material$TextField$iconElt = F2(
	function (modifierCs, icon_) {
		if (icon_.$ === 1) {
			return $elm$html$Html$text('');
		} else {
			if (!icon_.a.$) {
				var node = icon_.a.a.aJ;
				var attributes = icon_.a.a.eP;
				var nodes = icon_.a.a.ft;
				var onInteraction = icon_.a.a.ji;
				var disabled = icon_.a.a.d$;
				return A2(
					node,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('mdc-text-field__icon'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class(modifierCs),
							function () {
								if (!onInteraction.$) {
									var msg = onInteraction.a;
									return (!disabled) ? A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$tabindex(0),
										A2(
											$elm$core$List$cons,
											A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Events$onClick(msg),
												A2(
													$elm$core$List$cons,
													A2(
														$elm$html$Html$Events$on,
														'keydown',
														A2(
															$elm$json$Json$Decode$andThen,
															function (keyCode) {
																return (keyCode === 13) ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('');
															},
															$elm$html$Html$Events$keyCode)),
													attributes)))) : A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$tabindex(-1),
										A2(
											$elm$core$List$cons,
											A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
											attributes));
								} else {
									return attributes;
								}
							}())),
					nodes);
			} else {
				var node = icon_.a.a.aJ;
				var attributes = icon_.a.a.eP;
				var nodes = icon_.a.a.ft;
				var onInteraction = icon_.a.a.ji;
				var disabled = icon_.a.a.d$;
				return A2(
					node,
					A2(
						$elm$core$List$cons,
						$elm$svg$Svg$Attributes$class('mdc-text-field__icon'),
						A2(
							$elm$core$List$cons,
							$elm$svg$Svg$Attributes$class(modifierCs),
							function () {
								if (!onInteraction.$) {
									var msg = onInteraction.a;
									return (!disabled) ? A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$tabindex(0),
										A2(
											$elm$core$List$cons,
											A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Events$onClick(msg),
												A2(
													$elm$core$List$cons,
													A2(
														$elm$html$Html$Events$on,
														'keydown',
														A2(
															$elm$json$Json$Decode$andThen,
															function (keyCode) {
																return (keyCode === 13) ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('');
															},
															$elm$html$Html$Events$keyCode)),
													attributes)))) : A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$tabindex(-1),
										A2(
											$elm$core$List$cons,
											A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
											attributes));
								} else {
									return attributes;
								}
							}())),
					nodes);
			}
		}
	});
var $aforemny$material_components_web_elm$Material$TextField$leadingIconElt = function (_v0) {
	var leadingIcon = _v0.i4;
	return A2($aforemny$material_components_web_elm$Material$TextField$iconElt, 'mdc-text-field__icon--leading', leadingIcon);
};
var $aforemny$material_components_web_elm$Material$TextField$lineRippleElt = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-line-ripple')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$TextField$maxLengthProp = function (_v0) {
	var maxLength = _v0.fo;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'maxLength',
			$elm$json$Json$Encode$int(
				A2($elm$core$Maybe$withDefault, -1, maxLength))));
};
var $aforemny$material_components_web_elm$Material$TextField$maxProp = function (_v0) {
	var max = _v0.fn;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'max',
			$elm$json$Json$Encode$string(
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Maybe$map, $elm$core$String$fromInt, max)))));
};
var $aforemny$material_components_web_elm$Material$TextField$minLengthProp = function (_v0) {
	var minLength = _v0.fr;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'minLength',
			$elm$json$Json$Encode$int(
				A2($elm$core$Maybe$withDefault, -1, minLength))));
};
var $aforemny$material_components_web_elm$Material$TextField$minProp = function (_v0) {
	var min = _v0.fq;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'min',
			$elm$json$Json$Encode$string(
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Maybe$map, $elm$core$String$fromInt, min)))));
};
var $aforemny$material_components_web_elm$Material$TextField$noLabelCs = function (_v0) {
	var label = _v0.c9;
	return _Utils_eq(label, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--no-label')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextField$notchedOutlineLeadingElt = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-notched-outline__leading')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$TextField$notchedOutlineNotchElt = function (config_) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mdc-notched-outline__notch')
			]),
		_List_fromArray(
			[
				$aforemny$material_components_web_elm$Material$TextField$labelElt(config_)
			]));
};
var $aforemny$material_components_web_elm$Material$TextField$notchedOutlineTrailingElt = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-notched-outline__trailing')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$TextField$notchedOutlineElt = function (config_) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mdc-notched-outline')
			]),
		_List_fromArray(
			[
				$aforemny$material_components_web_elm$Material$TextField$notchedOutlineLeadingElt,
				$aforemny$material_components_web_elm$Material$TextField$notchedOutlineNotchElt(config_),
				$aforemny$material_components_web_elm$Material$TextField$notchedOutlineTrailingElt
			]));
};
var $aforemny$material_components_web_elm$Material$TextField$outlinedCs = function (outlined_) {
	return outlined_ ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--outlined')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextField$patternProp = function (_v0) {
	var pattern = _v0.hp;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'pattern',
			A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Encode$null,
				A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, pattern))));
};
var $aforemny$material_components_web_elm$Material$TextField$prefixCs = $elm$html$Html$Attributes$class('mdc-text-field__affix mdc-text-field__affix--prefix');
var $aforemny$material_components_web_elm$Material$TextField$prefixElt = function (_v0) {
	var prefix = _v0.hu;
	if (!prefix.$) {
		var prefixStr = prefix.a;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[$aforemny$material_components_web_elm$Material$TextField$prefixCs]),
			_List_fromArray(
				[
					$elm$html$Html$text(prefixStr)
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $aforemny$material_components_web_elm$Material$TextField$requiredProp = function (_v0) {
	var required = _v0.hB;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'required',
			$elm$json$Json$Encode$bool(required)));
};
var $aforemny$material_components_web_elm$Material$TextField$rippleElt = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-text-field__ripple')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$TextField$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-text-field'));
var $aforemny$material_components_web_elm$Material$TextField$stepProp = function (_v0) {
	var step = _v0.fL;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'step',
			$elm$json$Json$Encode$string(
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Maybe$map, $elm$core$String$fromInt, step)))));
};
var $aforemny$material_components_web_elm$Material$TextField$suffixCs = $elm$html$Html$Attributes$class('mdc-text-field__affix mdc-text-field__affix--suffix');
var $aforemny$material_components_web_elm$Material$TextField$suffixElt = function (_v0) {
	var suffix = _v0.hM;
	if (!suffix.$) {
		var suffixStr = suffix.a;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[$aforemny$material_components_web_elm$Material$TextField$suffixCs]),
			_List_fromArray(
				[
					$elm$html$Html$text(suffixStr)
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $aforemny$material_components_web_elm$Material$TextField$trailingIconElt = function (_v0) {
	var trailingIcon = _v0.fR;
	return A2($aforemny$material_components_web_elm$Material$TextField$iconElt, 'mdc-text-field__icon--trailing', trailingIcon);
};
var $aforemny$material_components_web_elm$Material$TextField$validProp = function (_v0) {
	var valid = _v0.hU;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'valid',
			$elm$json$Json$Encode$bool(valid)));
};
var $aforemny$material_components_web_elm$Material$TextField$valueProp = function (_v0) {
	var value = _v0.eL;
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$html$Html$Attributes$property('value'),
			$elm$json$Json$Encode$string),
		value);
};
var $aforemny$material_components_web_elm$Material$TextField$withLeadingIconCs = function (_v0) {
	var leadingIcon = _v0.i4;
	return (!_Utils_eq(leadingIcon, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--with-leading-icon')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextField$withTrailingIconCs = function (_v0) {
	var trailingIcon = _v0.fR;
	return (!_Utils_eq(trailingIcon, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--with-trailing-icon')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextField$textField = F2(
	function (outlined_, config_) {
		var additionalAttributes = config_.fZ;
		var fullwidth = config_.ea;
		return A3(
			$elm$html$Html$node,
			'mdc-text-field',
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$TextField$rootCs,
							$aforemny$material_components_web_elm$Material$TextField$noLabelCs(config_),
							$aforemny$material_components_web_elm$Material$TextField$filledCs(outlined_),
							$aforemny$material_components_web_elm$Material$TextField$outlinedCs(outlined_),
							$aforemny$material_components_web_elm$Material$TextField$fullwidthCs(config_),
							$aforemny$material_components_web_elm$Material$TextField$labelFloatingCs(config_),
							$aforemny$material_components_web_elm$Material$TextField$foucClassNamesProp,
							$aforemny$material_components_web_elm$Material$TextField$disabledCs(config_),
							$aforemny$material_components_web_elm$Material$TextField$withLeadingIconCs(config_),
							$aforemny$material_components_web_elm$Material$TextField$withTrailingIconCs(config_),
							$aforemny$material_components_web_elm$Material$TextField$endAlignedCs(config_),
							$aforemny$material_components_web_elm$Material$TextField$valueProp(config_),
							$aforemny$material_components_web_elm$Material$TextField$disabledProp(config_),
							$aforemny$material_components_web_elm$Material$TextField$requiredProp(config_),
							$aforemny$material_components_web_elm$Material$TextField$validProp(config_),
							$aforemny$material_components_web_elm$Material$TextField$patternProp(config_),
							$aforemny$material_components_web_elm$Material$TextField$minLengthProp(config_),
							$aforemny$material_components_web_elm$Material$TextField$maxLengthProp(config_),
							$aforemny$material_components_web_elm$Material$TextField$minProp(config_),
							$aforemny$material_components_web_elm$Material$TextField$maxProp(config_),
							$aforemny$material_components_web_elm$Material$TextField$stepProp(config_)
						])),
				additionalAttributes),
			outlined_ ? _List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$TextField$leadingIconElt(config_),
					$aforemny$material_components_web_elm$Material$TextField$prefixElt(config_),
					$aforemny$material_components_web_elm$Material$TextField$inputElt(config_),
					$aforemny$material_components_web_elm$Material$TextField$suffixElt(config_),
					$aforemny$material_components_web_elm$Material$TextField$notchedOutlineElt(config_),
					$aforemny$material_components_web_elm$Material$TextField$trailingIconElt(config_)
				]) : _List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$TextField$rippleElt,
					$aforemny$material_components_web_elm$Material$TextField$leadingIconElt(config_),
					$aforemny$material_components_web_elm$Material$TextField$prefixElt(config_),
					$aforemny$material_components_web_elm$Material$TextField$inputElt(config_),
					$aforemny$material_components_web_elm$Material$TextField$suffixElt(config_),
					$aforemny$material_components_web_elm$Material$TextField$labelElt(config_),
					$aforemny$material_components_web_elm$Material$TextField$lineRippleElt,
					$aforemny$material_components_web_elm$Material$TextField$trailingIconElt(config_)
				]));
	});
var $aforemny$material_components_web_elm$Material$TextField$outlined = function (config_) {
	return A2($aforemny$material_components_web_elm$Material$TextField$textField, true, config_);
};
var $aforemny$material_components_web_elm$Material$TextField$setAttributes = F2(
	function (additionalAttributes, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{fZ: additionalAttributes});
	});
var $aforemny$material_components_web_elm$Material$TextField$setLabel = F2(
	function (label, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{c9: label});
	});
var $aforemny$material_components_web_elm$Material$TextField$setLeadingIcon = F2(
	function (leadingIcon, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{i4: leadingIcon});
	});
var $aforemny$material_components_web_elm$Material$TextField$setOnInput = F2(
	function (onInput, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{
				hg: $elm$core$Maybe$Just(onInput)
			});
	});
var $aforemny$material_components_web_elm$Material$TextField$setValue = F2(
	function (value, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{eL: value});
	});
var $author$project$Pages$Faq$viewSearchBar = function (model) {
	return $aforemny$material_components_web_elm$Material$TextField$outlined(
		A2(
			$aforemny$material_components_web_elm$Material$TextField$setLeadingIcon,
			$elm$core$Maybe$Just(
				$aforemny$material_components_web_elm$Material$TextField$Icon$icon('search')),
			A2(
				$aforemny$material_components_web_elm$Material$TextField$setAttributes,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', '100%'),
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '12px'),
						A2($elm$html$Html$Attributes$style, 'margin-top', '12px')
					]),
				A2(
					$aforemny$material_components_web_elm$Material$TextField$setOnInput,
					$author$project$Pages$Faq$OnInput,
					A2(
						$aforemny$material_components_web_elm$Material$TextField$setValue,
						model.d7,
						A2(
							$aforemny$material_components_web_elm$Material$TextField$setLabel,
							$elm$core$Maybe$Just('Search FAQs'),
							$aforemny$material_components_web_elm$Material$TextField$config))))));
};
var $author$project$Reusable$Flex$viewVertical = function (nodes) {
	return $rtfeldman$elm_css$Html$Styled$toUnstyled(
		A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$pct(100)),
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
						]))
				]),
			A2($elm$core$List$map, $rtfeldman$elm_css$Html$Styled$fromUnstyled, nodes)));
};
var $author$project$Pages$Faq$view = function (model) {
	return A2(
		$aforemny$material_components_web_elm$Material$Dialog$dialog,
		A2(
			$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
			$author$project$Pages$Faq$CloseDialog,
			A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.d_, $aforemny$material_components_web_elm$Material$Dialog$config)),
		{
			kk: _List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$Button$outlined,
					A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$Faq$CloseDialog, $aforemny$material_components_web_elm$Material$Button$config),
					'Close')
				]),
			k_: _List_fromArray(
				[
					function () {
					var filteredQuestions = A2(
						$author$project$Pages$Faq$filterStuff,
						A2($elm$core$Maybe$withDefault, '', model.d7),
						model.f2);
					return $elm$core$List$isEmpty(filteredQuestions) ? $author$project$Reusable$Flex$viewVertical(
						_List_fromArray(
							[
								$author$project$Pages$Faq$viewSearchBar(model),
								$author$project$Pages$Faq$viewEmpty
							])) : $author$project$Reusable$Flex$viewVertical(
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Pages$Faq$viewSearchBar(model)
								]),
							A2($elm$core$List$map, $author$project$Pages$Faq$viewFaqCard, filteredQuestions)));
				}()
				]),
			na: $elm$core$Maybe$Just('Frequenty Asked Questions')
		});
};
var $author$project$Mdl$Elevation$e6 = $elm$html$Html$Attributes$class('mdl-shadow--6dp');
var $author$project$Main$ToggleNavbar = {$: 6};
var $author$project$Reusable$Header$pageHeader = function (str) {
	return A2(
		$elm$html$Html$h4,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'letter-spacing', '0px'),
				A2($elm$html$Html$Attributes$style, 'font-size', '22px'),
				A2($elm$html$Html$Attributes$style, 'font-weight', '400'),
				A2($elm$html$Html$Attributes$style, 'color', 'rgb(255, 255, 255)'),
				A2($elm$html$Html$Attributes$style, 'line-height', '64px'),
				A2($elm$html$Html$Attributes$style, 'height', '64px'),
				A2($elm$html$Html$Attributes$style, 'margin', '0px'),
				A2($elm$html$Html$Attributes$style, 'padding-left', '24px')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $author$project$Routing$toStringPage = function (page) {
	switch (page.$) {
		case 0:
			return 'Login';
		case 1:
			return 'User Profile';
		case 2:
			return 'Dashboard';
		case 3:
			return 'Link New Device';
		case 5:
			return 'Sync Devices';
		case 6:
			return 'Configure Device';
		case 4:
			return 'Menu Item Lists';
		case 7:
			return 'Contact Us';
		case 8:
			return 'FAQs';
		default:
			return 'Not Found';
	}
};
var $author$project$Main$viewMenuButton = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
				A2($elm$html$Html$Attributes$style, 'padding-left', '12px')
			]),
		_List_fromArray(
			[
				A2(
				$aforemny$material_components_web_elm$Material$IconButton$iconButton,
				A2(
					$aforemny$material_components_web_elm$Material$IconButton$setAttributes,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'color', 'white')
						]),
					A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, $author$project$Main$ToggleNavbar, $aforemny$material_components_web_elm$Material$IconButton$config)),
				$aforemny$material_components_web_elm$Material$IconButton$icon('menu')),
				function () {
				var _v0 = model.W;
				if (_v0 === 2) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$Attributes$style,
								'margin-left',
								model.as ? '300px' : '0px')
							]),
						_List_fromArray(
							[
								$author$project$Reusable$Header$pageHeader(
								$author$project$Routing$toStringPage(model.I.dq))
							]));
				} else {
					var other = _v0;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$aforemny$material_components_web_elm$Material$Typography$headline4,
								A2($elm$html$Html$Attributes$style, 'padding-left', '12px'),
								A2($elm$html$Html$Attributes$style, 'color', 'white')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Routing$toStringPage(model.I.dq))
							]));
				}
			}()
			]));
};
var $author$project$Main$viewTitleSection = function (model) {
	return $author$project$Main$viewMenuButton(model);
};
var $author$project$Main$viewUserActionButton = function (model) {
	var _v0 = model.W;
	if (!_v0) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
					A2($elm$html$Html$Attributes$style, 'padding-top', '24px'),
					A2($elm$html$Html$Attributes$style, 'transform', 'rotate(90deg)')
				]),
			_List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$IconButton$iconButton,
					A2(
						$aforemny$material_components_web_elm$Material$IconButton$setAttributes,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'color', 'white')
							]),
						A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, $author$project$Main$ToggleSidebar, $aforemny$material_components_web_elm$Material$IconButton$config)),
					$aforemny$material_components_web_elm$Material$IconButton$icon('expand_more'))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Main$viewAppBar = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Mdl$Elevation$e6,
				$elm$html$Html$Attributes$class('app-bar'),
				A2($elm$html$Html$Attributes$style, 'padding-top', '12px')
			]),
		_List_fromArray(
			[
				$author$project$Main$viewTitleSection(model),
				$author$project$Main$viewUserActionButton(model)
			]));
};
var $author$project$Pages$User$getAccessLevel = function (model) {
	var _v0 = model.eK;
	if (_v0.$ === 4) {
		var user = _v0.a;
		return $elm$core$Maybe$Just(user.h4);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$User$OpenUserPage = {$: 14};
var $author$project$Pages$User$Select = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$User$SelectDistrict = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $aforemny$material_components_web_elm$Material$Icon$icon = F2(
	function (additionalAttributes, iconName) {
		return A2(
			$elm$html$Html$i,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('material-icons'),
				additionalAttributes),
			_List_fromArray(
				[
					$elm$html$Html$text(iconName)
				]));
	});
var $author$project$Select$Label = function (a) {
	return {$: 0, a: a};
};
var $author$project$Select$label = function (str) {
	return $author$project$Select$Label(str);
};
var $author$project$Select$OnSelect = function (a) {
	return {$: 12, a: a};
};
var $author$project$Select$onSelect = function (func) {
	return $author$project$Select$OnSelect(func);
};
var $author$project$Select$Items = function (a) {
	return {$: 4, a: a};
};
var $author$project$Select$options = function (list) {
	return $author$project$Select$Items(list);
};
var $author$project$Select$Style = function (a) {
	return {$: 9, a: a};
};
var $author$project$Select$rootStyle = function (style) {
	return $author$project$Select$Style(style);
};
var $author$project$Select$Searchable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Select$searchable = $author$project$Select$Searchable(true);
var $author$project$Select$Value = function (a) {
	return {$: 11, a: a};
};
var $author$project$Select$value = function (val) {
	return $author$project$Select$Value(val);
};
var $rtfeldman$elm_css$Css$border = $rtfeldman$elm_css$Css$prop1('border');
var $author$project$Select$toProp = F2(
	function (prop, config) {
		switch (prop.$) {
			case 0:
				var val = prop.a;
				return _Utils_update(
					config,
					{
						c9: $elm$core$Maybe$Just(val)
					});
			case 1:
				var index = prop.a;
				return _Utils_update(
					config,
					{iX: index});
			case 2:
				var val = prop.a;
				return _Utils_update(
					config,
					{ev: val});
			case 3:
				var val = prop.a;
				return _Utils_update(
					config,
					{aI: val});
			case 4:
				var items = prop.a;
				return $elm$core$List$isEmpty(items) ? _Utils_update(
					config,
					{
						d$: true,
						ec: $elm$core$Maybe$Just('No options available')
					}) : _Utils_update(
					config,
					{lM: items});
			case 5:
				var val = prop.a;
				return _Utils_update(
					config,
					{ec: val});
			case 6:
				var val = prop.a;
				return _Utils_update(
					config,
					{fa: val});
			case 7:
				var val = prop.a;
				return _Utils_update(
					config,
					{d$: val});
			case 10:
				var func = prop.a;
				return _Utils_update(
					config,
					{cz: func});
			case 11:
				var val = prop.a;
				return _Utils_update(
					config,
					{eL: val});
			case 12:
				var func = prop.a;
				return _Utils_update(
					config,
					{fy: func});
			case 13:
				var val = prop.a;
				return _Utils_update(
					config,
					{au: val});
			case 14:
				var func = prop.a;
				return _Utils_update(
					config,
					{bB: func});
			case 8:
				var func = prop.a;
				return _Utils_update(
					config,
					{bP: func});
			case 9:
				var style = prop.a;
				return _Utils_update(
					config,
					{cs: style});
			default:
				var a = prop.a;
				return _Utils_update(
					config,
					{br: a});
		}
	});
var $author$project$Select$collect = F2(
	function (attrs, config) {
		return A3($elm$core$List$foldl, $author$project$Select$toProp, config, attrs);
	});
var $rtfeldman$elm_css$Html$Styled$fieldset = $rtfeldman$elm_css$Html$Styled$node('fieldset');
var $rtfeldman$elm_css$Css$stringsToValue = function (list) {
	return $elm$core$List$isEmpty(list) ? {eL: 'none'} : {
		eL: A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				function (s) {
					return s;
				},
				list))
	};
};
var $rtfeldman$elm_css$Css$fontFamilies = A2(
	$elm$core$Basics$composeL,
	$rtfeldman$elm_css$Css$prop1('font-family'),
	$rtfeldman$elm_css$Css$stringsToValue);
var $author$project$Select$NoOp = {$: 0};
var $author$project$Select$initConfig = F2(
	function (toMsg, index) {
		return {
			bP: $elm$core$Basics$always(_List_Nil),
			d$: false,
			br: $elm$core$Maybe$Nothing,
			ec: $elm$core$Maybe$Nothing,
			fa: A3($avh4$elm_color$Color$rgb, 201, 73, 4),
			iX: index,
			lM: _List_Nil,
			c9: $elm$core$Maybe$Nothing,
			aI: false,
			au: _List_Nil,
			bB: $elm$core$Basics$always(
				toMsg($author$project$Select$NoOp)),
			fy: $elm$core$Basics$always(
				toMsg($author$project$Select$NoOp)),
			ev: false,
			cs: _List_Nil,
			cz: toMsg,
			eL: $elm$core$Maybe$Nothing
		};
	});
var $rtfeldman$elm_css$Css$outline = $rtfeldman$elm_css$Css$prop1('outline');
var $rtfeldman$elm_css$VirtualDom$Styled$style = F2(
	function (key, val) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$style, key, val),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$style = $rtfeldman$elm_css$VirtualDom$Styled$style;
var $rtfeldman$elm_css$Html$Styled$Attributes$tabindex = function (n) {
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $author$project$Select$CloseOptions = function (a) {
	return {$: 4, a: a};
};
var $rtfeldman$elm_css$Css$backgroundColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'background-color', c.eL);
};
var $rtfeldman$elm_css$Css$Transitions$BackgroundColor = 1;
var $rtfeldman$elm_css$Css$Transitions$Transition = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Transitions$durationTransition = F2(
	function (animation, duration) {
		return {ky: animation, e0: $elm$core$Maybe$Nothing, gn: duration, j$: $elm$core$Maybe$Nothing};
	});
var $rtfeldman$elm_css$Css$Transitions$backgroundColor = $rtfeldman$elm_css$Css$Transitions$durationTransition(1);
var $rtfeldman$elm_css$Css$fixed = {dP: 0, x: 0, fM: 0, eL: 'fixed'};
var $rtfeldman$elm_css$Css$UnitlessInteger = 0;
var $rtfeldman$elm_css$Css$int = function (val) {
	return {
		bp: 0,
		fg: 0,
		b6: 0,
		a4: 0,
		l$: 0,
		fu: 0,
		bA: val,
		dJ: '',
		eH: 0,
		eL: $elm$core$String$fromInt(val)
	};
};
var $rtfeldman$elm_css$Css$left = $rtfeldman$elm_css$Css$prop1('left');
var $rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $rtfeldman$elm_css$Css$Transitions$propToString = function (prop) {
	switch (prop) {
		case 0:
			return 'background';
		case 1:
			return 'background-color';
		case 2:
			return 'background-position';
		case 3:
			return 'background-size';
		case 4:
			return 'border';
		case 5:
			return 'border-bottom';
		case 6:
			return 'border-bottom-color';
		case 7:
			return 'border-bottom-left-radius';
		case 8:
			return 'border-bottom-right-radius';
		case 9:
			return 'border-bottom-width';
		case 10:
			return 'border-color';
		case 11:
			return 'border-left';
		case 12:
			return 'border-left-color';
		case 13:
			return 'border-left-width';
		case 14:
			return 'border-radius';
		case 15:
			return 'border-right';
		case 16:
			return 'border-right-color';
		case 17:
			return 'border-right-width';
		case 18:
			return 'border-top';
		case 19:
			return 'border-top-color';
		case 20:
			return 'border-top-left-radius';
		case 21:
			return 'border-top-right-radius';
		case 22:
			return 'border-top-width';
		case 23:
			return 'border-width';
		case 24:
			return 'bottom';
		case 25:
			return 'box-shadow';
		case 26:
			return 'caret-color';
		case 27:
			return 'clip';
		case 28:
			return 'clip-path';
		case 29:
			return 'color';
		case 30:
			return 'column-count';
		case 31:
			return 'column-gap';
		case 32:
			return 'column-rule';
		case 33:
			return 'column-rule-color';
		case 34:
			return 'column-rule-width';
		case 35:
			return 'column-width';
		case 36:
			return 'columns';
		case 37:
			return 'filter';
		case 38:
			return 'flex';
		case 39:
			return 'flex-basis';
		case 40:
			return 'flex-grow';
		case 41:
			return 'flex-shrink';
		case 42:
			return 'font';
		case 43:
			return 'font-size';
		case 44:
			return 'font-size-adjust';
		case 45:
			return 'font-stretch';
		case 46:
			return 'font-variation-settings';
		case 47:
			return 'font-weight';
		case 48:
			return 'grid-column-gap';
		case 49:
			return 'grid-gap';
		case 50:
			return 'grid-row-gap';
		case 51:
			return 'height';
		case 52:
			return 'left';
		case 53:
			return 'letter-spacing';
		case 54:
			return 'line-height';
		case 55:
			return 'margin';
		case 56:
			return 'margin-bottom';
		case 57:
			return 'margin-left';
		case 58:
			return 'margin-right';
		case 59:
			return 'margin-top';
		case 60:
			return 'mask';
		case 61:
			return 'mask-position';
		case 62:
			return 'mask-size';
		case 63:
			return 'max-height';
		case 64:
			return 'max-width';
		case 65:
			return 'min-height';
		case 66:
			return 'min-width';
		case 67:
			return 'object-position';
		case 68:
			return 'offset';
		case 69:
			return 'offset-anchor';
		case 70:
			return 'offset-distance';
		case 71:
			return 'offset-path';
		case 72:
			return 'offset-rotate';
		case 73:
			return 'opacity';
		case 74:
			return 'order';
		case 75:
			return 'outline';
		case 76:
			return 'outline-color';
		case 77:
			return 'outline-offset';
		case 78:
			return 'outline-width';
		case 79:
			return 'padding';
		case 80:
			return 'padding-bottom';
		case 81:
			return 'padding-left';
		case 82:
			return 'padding-right';
		case 83:
			return 'padding-top';
		case 84:
			return 'right';
		case 85:
			return 'tab-size';
		case 86:
			return 'text-indent';
		case 87:
			return 'text-shadow';
		case 88:
			return 'top';
		case 89:
			return 'transform';
		case 90:
			return 'transform-origin';
		case 91:
			return 'vertical-align';
		case 92:
			return 'visibility';
		case 93:
			return 'width';
		case 94:
			return 'word-spacing';
		default:
			return 'z-index';
	}
};
var $rtfeldman$elm_css$Css$Transitions$timeToString = function (time) {
	return $elm$core$String$fromFloat(time) + 'ms';
};
var $rtfeldman$elm_css$Css$Transitions$timingFunctionToString = function (tf) {
	switch (tf.$) {
		case 0:
			return 'ease';
		case 1:
			return 'linear';
		case 2:
			return 'ease-in';
		case 3:
			return 'ease-out';
		case 4:
			return 'ease-in-out';
		case 5:
			return 'step-start';
		case 6:
			return 'step-end';
		default:
			var _float = tf.a;
			var float2 = tf.b;
			var float3 = tf.c;
			var float4 = tf.d;
			return 'cubic-bezier(' + ($elm$core$String$fromFloat(_float) + (' , ' + ($elm$core$String$fromFloat(float2) + (' , ' + ($elm$core$String$fromFloat(float3) + (' , ' + ($elm$core$String$fromFloat(float4) + ')')))))));
	}
};
var $rtfeldman$elm_css$Css$Transitions$transition = function (options) {
	var v = A3(
		$elm$core$String$slice,
		0,
		-1,
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, s) {
					var animation = _v0.ky;
					var duration = _v0.gn;
					var delay = _v0.e0;
					var timing = _v0.j$;
					return s + (A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Transitions$propToString(animation),
								$rtfeldman$elm_css$Css$Transitions$timeToString(duration),
								A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Transitions$timeToString, delay)),
								A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Transitions$timingFunctionToString, timing))
							])) + ',');
				}),
			'',
			options));
	return A2($rtfeldman$elm_css$Css$property, 'transition', v);
};
var $rtfeldman$elm_css$Css$transparent = {gc: 0, eL: 'transparent'};
var $rtfeldman$elm_css$Css$visibility = $rtfeldman$elm_css$Css$prop1('visibility');
var $rtfeldman$elm_css$Css$visible = {dp: 0, aP: 0, eL: 'visible', eM: 0};
var $rtfeldman$elm_css$Css$zIndex = $rtfeldman$elm_css$Css$prop1('z-index');
var $rtfeldman$elm_css$Css$zero = {g: 0, db: 0, bw: 0, dc: 0, dd: 0, b5: 0, b6: 0, l$: 0, bA: 0, fA: 0, dJ: '', eH: 0, eL: '0'};
var $author$project$Select$viewCancelOverlay = F2(
	function (config, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$vw(100)),
							$rtfeldman$elm_css$Css$height(
							$rtfeldman$elm_css$Css$vh(100)),
							$rtfeldman$elm_css$Css$top(
							$rtfeldman$elm_css$Css$px(0)),
							$rtfeldman$elm_css$Css$left(
							$rtfeldman$elm_css$Css$px(0)),
							$rtfeldman$elm_css$Css$zIndex(
							$rtfeldman$elm_css$Css$int(1)),
							$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
							$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
							(!model.fJ) ? $rtfeldman$elm_css$Css$visibility($rtfeldman$elm_css$Css$visible) : $rtfeldman$elm_css$Css$visibility($rtfeldman$elm_css$Css$hidden),
							$rtfeldman$elm_css$Css$Transitions$transition(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$Transitions$backgroundColor(0.5)
								]))
						])),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					config.cz(
						$author$project$Select$CloseOptions(config.iX)))
				]),
			_List_Nil);
	});
var $rtfeldman$elm_css$Css$color = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'color', c.eL);
};
var $rtfeldman$elm_css$Css$lineHeight = $rtfeldman$elm_css$Css$prop1('line-height');
var $rtfeldman$elm_css$Css$marginTop = $rtfeldman$elm_css$Css$prop1('margin-top');
var $rtfeldman$elm_css$Css$cssFunction = F2(
	function (funcName, args) {
		return funcName + ('(' + (A2($elm$core$String$join, ', ', args) + ')'));
	});
var $rtfeldman$elm_css$Css$rgba = F4(
	function (r, g, b, alpha) {
		return {
			f3: alpha,
			f8: b,
			gc: 0,
			gF: g,
			hz: r,
			eL: A2(
				$rtfeldman$elm_css$Css$cssFunction,
				'rgba',
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$elm$core$String$fromInt,
						_List_fromArray(
							[r, g, b])),
					_List_fromArray(
						[
							$elm$core$String$fromFloat(alpha)
						])))
		};
	});
var $rtfeldman$elm_css$Html$Styled$span = $rtfeldman$elm_css$Html$Styled$node('span');
var $author$project$Select$viewHelpText = function (config) {
	var _v0 = config.ec;
	if (_v0.$ === 1) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$height(
							$rtfeldman$elm_css$Css$px(12)),
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$pct(100))
						]))
				]),
			_List_Nil);
	} else {
		var text_ = _v0.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$fontFamilies(
							_List_fromArray(
								['Roboto'])),
							$rtfeldman$elm_css$Css$fontSize(
							$rtfeldman$elm_css$Css$px(12)),
							function (data) {
							return $rtfeldman$elm_css$Css$color(
								A4($rtfeldman$elm_css$Css$rgba, data.hz, data.gF, data.f8, data.f3));
						}(
							function (val) {
								return {
									f3: val.f3,
									f8: $elm$core$Basics$round(val.f8),
									gF: $elm$core$Basics$round(val.gF),
									hz: $elm$core$Basics$round(val.hz)
								};
							}(
								$avh4$elm_color$Color$toRgba(config.fa))),
							$rtfeldman$elm_css$Css$lineHeight(
							$rtfeldman$elm_css$Css$px(16)),
							$rtfeldman$elm_css$Css$marginTop(
							$rtfeldman$elm_css$Css$px(5))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(text_)
				]));
	}
};
var $author$project$Select$viewLabel = function (config) {
	var _v0 = config.c9;
	if (!_v0.$) {
		var labelText = _v0.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$fontFamilies(
							_List_fromArray(
								['Roboto'])),
							$rtfeldman$elm_css$Css$fontSize(
							$rtfeldman$elm_css$Css$px(12)),
							$rtfeldman$elm_css$Css$color(
							A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.54)),
							$rtfeldman$elm_css$Css$lineHeight(
							$rtfeldman$elm_css$Css$px(16))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(labelText)
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $rtfeldman$elm_css$Css$Transitions$CubicBezier = F4(
	function (a, b, c, d) {
		return {$: 7, a: a, b: b, c: c, d: d};
	});
var $rtfeldman$elm_css$Css$Transitions$cubicBezier = F4(
	function (f1, f2, f3, f4) {
		return A4($rtfeldman$elm_css$Css$Transitions$CubicBezier, f1, f2, f3, f4);
	});
var $author$project$Select$filter = F3(
	function (filterWith, query, list) {
		return A3($NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$filter, filterWith, query, list);
	});
var $rtfeldman$elm_css$Css$fontWeight = function (_v0) {
	var value = _v0.eL;
	return A2($rtfeldman$elm_css$Css$property, 'font-weight', value);
};
var $rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
	return A2($elm$core$String$startsWith, '#', str) ? str : A2($elm$core$String$cons, '#', str);
};
var $rtfeldman$elm_css$Css$erroneousHex = function (str) {
	return {
		f3: 1,
		f8: 0,
		gc: 0,
		gF: 0,
		hz: 0,
		eL: $rtfeldman$elm_css$Css$withPrecedingHash(str)
	};
};
var $elm$core$Basics$pow = _Basics_pow;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $rtfeldman$elm_css$Css$validHex = F5(
	function (str, _v0, _v1, _v2, _v3) {
		var r1 = _v0.a;
		var r2 = _v0.b;
		var g1 = _v1.a;
		var g2 = _v1.b;
		var b1 = _v2.a;
		var b2 = _v2.b;
		var a1 = _v3.a;
		var a2 = _v3.b;
		var toResult = A2(
			$elm$core$Basics$composeR,
			$elm$core$String$fromList,
			A2($elm$core$Basics$composeR, $elm$core$String$toLower, $rtfeldman$elm_hex$Hex$fromString));
		var results = _Utils_Tuple2(
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[r1, r2])),
				toResult(
					_List_fromArray(
						[g1, g2]))),
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[b1, b2])),
				toResult(
					_List_fromArray(
						[a1, a2]))));
		if ((((!results.a.a.$) && (!results.a.b.$)) && (!results.b.a.$)) && (!results.b.b.$)) {
			var _v5 = results.a;
			var red = _v5.a.a;
			var green = _v5.b.a;
			var _v6 = results.b;
			var blue = _v6.a.a;
			var alpha = _v6.b.a;
			return {
				f3: alpha / 255,
				f8: blue,
				gc: 0,
				gF: green,
				hz: red,
				eL: $rtfeldman$elm_css$Css$withPrecedingHash(str)
			};
		} else {
			return $rtfeldman$elm_css$Css$erroneousHex(str);
		}
	});
var $rtfeldman$elm_css$Css$hex = function (str) {
	var withoutHash = A2($elm$core$String$startsWith, '#', str) ? A2($elm$core$String$dropLeft, 1, str) : str;
	var _v0 = $elm$core$String$toList(withoutHash);
	_v0$4:
	while (true) {
		if ((_v0.b && _v0.b.b) && _v0.b.b.b) {
			if (!_v0.b.b.b.b) {
				var r = _v0.a;
				var _v1 = _v0.b;
				var g = _v1.a;
				var _v2 = _v1.b;
				var b = _v2.a;
				return A5(
					$rtfeldman$elm_css$Css$validHex,
					str,
					_Utils_Tuple2(r, r),
					_Utils_Tuple2(g, g),
					_Utils_Tuple2(b, b),
					_Utils_Tuple2('f', 'f'));
			} else {
				if (!_v0.b.b.b.b.b) {
					var r = _v0.a;
					var _v3 = _v0.b;
					var g = _v3.a;
					var _v4 = _v3.b;
					var b = _v4.a;
					var _v5 = _v4.b;
					var a = _v5.a;
					return A5(
						$rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(a, a));
				} else {
					if (_v0.b.b.b.b.b.b) {
						if (!_v0.b.b.b.b.b.b.b) {
							var r1 = _v0.a;
							var _v6 = _v0.b;
							var r2 = _v6.a;
							var _v7 = _v6.b;
							var g1 = _v7.a;
							var _v8 = _v7.b;
							var g2 = _v8.a;
							var _v9 = _v8.b;
							var b1 = _v9.a;
							var _v10 = _v9.b;
							var b2 = _v10.a;
							return A5(
								$rtfeldman$elm_css$Css$validHex,
								str,
								_Utils_Tuple2(r1, r2),
								_Utils_Tuple2(g1, g2),
								_Utils_Tuple2(b1, b2),
								_Utils_Tuple2('f', 'f'));
						} else {
							if (_v0.b.b.b.b.b.b.b.b && (!_v0.b.b.b.b.b.b.b.b.b)) {
								var r1 = _v0.a;
								var _v11 = _v0.b;
								var r2 = _v11.a;
								var _v12 = _v11.b;
								var g1 = _v12.a;
								var _v13 = _v12.b;
								var g2 = _v13.a;
								var _v14 = _v13.b;
								var b1 = _v14.a;
								var _v15 = _v14.b;
								var b2 = _v15.a;
								var _v16 = _v15.b;
								var a1 = _v16.a;
								var _v17 = _v16.b;
								var a2 = _v17.a;
								return A5(
									$rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(a1, a2));
							} else {
								break _v0$4;
							}
						}
					} else {
						break _v0$4;
					}
				}
			}
		} else {
			break _v0$4;
		}
	}
	return $rtfeldman$elm_css$Css$erroneousHex(str);
};
var $rtfeldman$elm_css$Css$Transitions$Opacity = 73;
var $rtfeldman$elm_css$Css$Transitions$fullTransition = F4(
	function (animation, duration, delay, timing) {
		return {
			ky: animation,
			e0: $elm$core$Maybe$Just(delay),
			gn: duration,
			j$: $elm$core$Maybe$Just(timing)
		};
	});
var $rtfeldman$elm_css$Css$Transitions$opacity3 = $rtfeldman$elm_css$Css$Transitions$fullTransition(73);
var $rtfeldman$elm_css$Html$Styled$p = $rtfeldman$elm_css$Html$Styled$node('p');
var $rtfeldman$elm_css$Css$paddingLeft = $rtfeldman$elm_css$Css$prop1('padding-left');
var $rtfeldman$elm_css$Css$scroll = {dP: 0, ik: 0, iZ: 0, dp: 0, mq: 0, eL: 'scroll'};
var $author$project$Select$viewContainer = function (config) {
	return $rtfeldman$elm_css$Html$Styled$div(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
						$rtfeldman$elm_css$Css$marginTop(
						$rtfeldman$elm_css$Css$px(4)),
						$rtfeldman$elm_css$Css$paddingLeft($rtfeldman$elm_css$Css$zero),
						$rtfeldman$elm_css$Css$maxHeight(
						$rtfeldman$elm_css$Css$px(208)),
						$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$scroll),
						$rtfeldman$elm_css$Css$backgroundColor(
						$rtfeldman$elm_css$Css$hex('#FFFFFF'))
					]))
			]));
};
var $danmarcab$material_icons$Material$Icons$Content$clear = A2(
	$danmarcab$material_icons$Material$Icons$Internal$icon,
	'0 0 48 48',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M38 12.83L35.17 10 24 21.17 12.83 10 10 12.83 21.17 24 10 35.17 12.83 38 24 26.83 35.17 38 38 35.17 26.83 24z')
				]),
			_List_Nil)
		]));
var $rtfeldman$elm_css$Svg$Styled$fromUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode;
var $author$project$Select$viewGroupName = F2(
	function (config, groupName) {
		var selectedGroupItems = function () {
			var _v2 = config.br;
			if (!_v2.$) {
				var groupByName = _v2.a;
				return A2(
					$elm$core$List$filter,
					function (item) {
						return _Utils_eq(
							groupByName(item),
							groupName) ? true : false;
					},
					config.au);
			} else {
				return _List_Nil;
			}
		}();
		var itemsWithGroupSelected = function () {
			var _v1 = config.br;
			if (!_v1.$) {
				var groupByName = _v1.a;
				return A2(
					$elm$core$List$filter,
					function (item) {
						return (_Utils_eq(
							groupByName(item),
							groupName) || A2($elm$core$List$member, item, config.au)) ? true : false;
					},
					config.lM);
			} else {
				return _List_Nil;
			}
		}();
		var itemsWithGroupDeselected = function () {
			var _v0 = config.br;
			if (!_v0.$) {
				var groupByName = _v0.a;
				return A2(
					$elm$core$List$filter,
					function (item) {
						return _Utils_eq(
							groupByName(item),
							groupName) ? false : true;
					},
					itemsWithGroupSelected);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$fontFamilies(
									_List_fromArray(
										['Roboto'])),
									$rtfeldman$elm_css$Css$fontSize(
									$rtfeldman$elm_css$Css$px(12)),
									$rtfeldman$elm_css$Css$color(
									A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.64)),
									$rtfeldman$elm_css$Css$lineHeight(
									$rtfeldman$elm_css$Css$px(32)),
									$rtfeldman$elm_css$Css$paddingLeft(
									$rtfeldman$elm_css$Css$px(8)),
									$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$zero),
									$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
									$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$left),
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$pct(100)),
									$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
								])),
							config.aI ? $rtfeldman$elm_css$Html$Styled$Events$onClick(
							config.bB(itemsWithGroupSelected)) : $rtfeldman$elm_css$Html$Styled$Events$onClick(
							config.cz($author$project$Select$NoOp))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(groupName)
						])),
					(config.aI && ($elm$core$List$length(selectedGroupItems) > 0)) ? A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$zero),
									$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
									$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
								])),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							config.bB(itemsWithGroupDeselected))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$fromUnstyled(
							A2(
								$danmarcab$material_icons$Material$Icons$Content$clear,
								A3($avh4$elm_color$Color$rgb, 0, 0, 0),
								16))
						])) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $danmarcab$material_icons$Material$Icons$Navigation$check = A2(
	$danmarcab$material_icons$Material$Icons$Internal$icon,
	'0 0 48 48',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M18 32.34L9.66 24l-2.83 2.83L18 38l24-24-2.83-2.83z')
				]),
			_List_Nil)
		]));
var $rtfeldman$elm_css$Css$marginLeft = $rtfeldman$elm_css$Css$prop1('margin-left');
var $author$project$Select$viewMultiSelectOption = F4(
	function (field, config, optionConfig, item) {
		var isSelected = A2($elm$core$List$member, item, config.au);
		var customStyles = A2(
			$elm$core$List$map,
			function (_v0) {
				var a = _v0.a;
				var b = _v0.b;
				return A2($rtfeldman$elm_css$Html$Styled$Attributes$style, a, b);
			},
			config.bP(item));
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$pct(100)),
							$rtfeldman$elm_css$Css$fontSize(
							$rtfeldman$elm_css$Css$px(15)),
							$rtfeldman$elm_css$Css$minHeight(
							$rtfeldman$elm_css$Css$px(32)),
							$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$zero),
							isSelected ? $rtfeldman$elm_css$Css$backgroundColor(
							A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.12)) : $rtfeldman$elm_css$Css$backgroundColor(
							A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0))
						])),
					$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(0),
					(!isSelected) ? $rtfeldman$elm_css$Html$Styled$Events$onClick(
					config.bB(
						A2($elm$core$List$cons, item, config.au))) : $rtfeldman$elm_css$Html$Styled$Events$onClick(
					config.bB(
						A2(
							$elm$core$List$filter,
							function (a) {
								return A2($elm$core$List$member, a, config.lM);
							},
							A2(
								$elm$core$List$filter,
								function (d) {
									return !_Utils_eq(d, item);
								},
								config.au))))
				]),
			_List_fromArray(
				[
					isSelected ? $rtfeldman$elm_css$Svg$Styled$fromUnstyled(
					A2(
						$danmarcab$material_icons$Material$Icons$Navigation$check,
						A3($avh4$elm_color$Color$rgb, 0, 0, 0),
						24)) : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$px(24)),
									$rtfeldman$elm_css$Css$height(
									$rtfeldman$elm_css$Css$px(24))
								]))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$marginLeft(
										$rtfeldman$elm_css$Css$px(6))
									]))
							]),
						customStyles),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							optionConfig.ep(item))
						]))
				]));
	});
var $author$project$Select$SelectedOption = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Preprocess$ExtendSelector = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$PseudoClassSelector = function (a) {
	return {$: 2, a: a};
};
var $rtfeldman$elm_css$Css$pseudoClass = function (_class) {
	return $rtfeldman$elm_css$Css$Preprocess$ExtendSelector(
		$rtfeldman$elm_css$Css$Structure$PseudoClassSelector(_class));
};
var $rtfeldman$elm_css$Css$hover = $rtfeldman$elm_css$Css$pseudoClass('hover');
var $rtfeldman$elm_css$Css$prop4 = F5(
	function (key, argA, argB, argC, argD) {
		return A2(
			$rtfeldman$elm_css$Css$property,
			key,
			A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[argA.eL, argB.eL, argC.eL, argD.eL])));
	});
var $rtfeldman$elm_css$Css$padding4 = $rtfeldman$elm_css$Css$prop4('padding');
var $author$project$Select$viewOption = F3(
	function (config, optionConfig, item) {
		var isSelected = function () {
			var _v2 = config.eL;
			if (_v2.$ === 1) {
				return false;
			} else {
				var selectedItem = _v2.a;
				return A2(optionConfig.dS, item, selectedItem);
			}
		}();
		var isGrouped = function () {
			var _v1 = config.br;
			if (_v1.$ === 1) {
				return false;
			} else {
				return true;
			}
		}();
		var customStyles = A2(
			$elm$core$List$map,
			function (_v0) {
				var a = _v0.a;
				var b = _v0.b;
				return A2($rtfeldman$elm_css$Html$Styled$Attributes$style, a, b);
			},
			config.bP(item));
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
									$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
									$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$zero),
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$pct(100)),
									$rtfeldman$elm_css$Css$fontSize(
									$rtfeldman$elm_css$Css$px(15)),
									$rtfeldman$elm_css$Css$minHeight(
									$rtfeldman$elm_css$Css$px(32)),
									$rtfeldman$elm_css$Css$fontFamilies(
									_List_fromArray(
										['Roboto'])),
									$rtfeldman$elm_css$Css$backgroundColor(
									A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0)),
									$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$left),
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
									isGrouped ? A4(
									$rtfeldman$elm_css$Css$padding4,
									$rtfeldman$elm_css$Css$px(4),
									$rtfeldman$elm_css$Css$px(4),
									$rtfeldman$elm_css$Css$px(4),
									$rtfeldman$elm_css$Css$px(12)) : A4(
									$rtfeldman$elm_css$Css$padding4,
									$rtfeldman$elm_css$Css$px(4),
									$rtfeldman$elm_css$Css$px(4),
									$rtfeldman$elm_css$Css$px(4),
									$rtfeldman$elm_css$Css$px(8)),
									$rtfeldman$elm_css$Css$hover(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$backgroundColor(
											A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.12))
										])),
									$rtfeldman$elm_css$Css$Transitions$transition(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$Transitions$backgroundColor(500)
										]))
								]),
							isSelected ? _List_fromArray(
								[
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(700)),
									$rtfeldman$elm_css$Css$color(
									$rtfeldman$elm_css$Css$hex('#3F51B5'))
								]) : _List_Nil)),
						$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(0),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						config.cz(
							A2(
								$author$project$Select$SelectedOption,
								config.iX,
								config.fy(item))))
					]),
				customStyles),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					optionConfig.ep(item))
				]));
	});
var $author$project$Select$viewGroups = F4(
	function (config, optionConfig, field, groups) {
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var key = _v0.a;
				var items = _v0.b;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_Utils_ap(
						_List_fromArray(
							[
								A2($author$project$Select$viewGroupName, config, key)
							]),
						A2(
							$elm$core$List$map,
							config.aI ? A3($author$project$Select$viewMultiSelectOption, field, config, optionConfig) : A2($author$project$Select$viewOption, config, optionConfig),
							items)));
			},
			$elm$core$Dict$toList(groups));
	});
var $author$project$Select$UpdateQuery = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$prop3 = F4(
	function (key, argA, argB, argC) {
		return A2(
			$rtfeldman$elm_css$Css$property,
			key,
			A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[argA.eL, argB.eL, argC.eL])));
	});
var $rtfeldman$elm_css$Css$borderBottom3 = $rtfeldman$elm_css$Css$prop3('border-bottom');
var $rtfeldman$elm_css$Css$justifyContent = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'justifyContent',
		'justify-content',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$none = {cH: 0, ik: 0, aa: 0, d: 0, D: 0, lv: 0, iZ: 0, gU: 0, dd: 0, b5: 0, a4: 0, i: 0, f: 0, ha: 0, fA: 0, mc: 0, aP: 0, fC: 0, mp: 0, dF: 0, cx: 0, am: 0, s: 0, ni: 0, eL: 'none'};
var $rtfeldman$elm_css$Html$Styled$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $rtfeldman$elm_css$Html$Styled$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $rtfeldman$elm_css$Html$Styled$Events$onInput = function (tagger) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$rtfeldman$elm_css$Html$Styled$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $rtfeldman$elm_css$Html$Styled$Events$targetValue)));
};
var $rtfeldman$elm_css$Html$Styled$Attributes$placeholder = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('placeholder');
var $danmarcab$material_icons$Material$Icons$Action$search = A2(
	$danmarcab$material_icons$Material$Icons$Internal$icon,
	'0 0 48 48',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M31 28h-1.59l-.55-.55C30.82 25.18 32 22.23 32 19c0-7.18-5.82-13-13-13S6 11.82 6 19s5.82 13 13 13c3.23 0 6.18-1.18 8.45-3.13l.55.55V31l10 9.98L40.98 38 31 28zm-12 0c-4.97 0-9-4.03-9-9s4.03-9 9-9 9 4.03 9 9-4.03 9-9 9z')
				]),
			_List_Nil)
		]));
var $rtfeldman$elm_css$Css$solid = {aa: 0, cw: 0, eL: 'solid'};
var $rtfeldman$elm_css$Html$Styled$Attributes$value = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('value');
var $author$project$Select$viewSearchInput = F3(
	function (model, config, field) {
		var _v0 = config.ev;
		if (_v0) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none),
								A3(
								$rtfeldman$elm_css$Css$borderBottom3,
								$rtfeldman$elm_css$Css$px(1),
								$rtfeldman$elm_css$Css$solid,
								A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.1)),
								$rtfeldman$elm_css$Css$padding(
								$rtfeldman$elm_css$Css$px(12))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$fromUnstyled(
						A2(
							$danmarcab$material_icons$Material$Icons$Action$search,
							A3($avh4$elm_color$Color$rgb, 0, 0, 0),
							24)),
						A2(
						$rtfeldman$elm_css$Html$Styled$input,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id(
								A2(
									$elm$core$String$join,
									'-',
									A2($elm$core$List$map, $elm$core$String$fromInt, config.iX))),
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$fontSize(
										$rtfeldman$elm_css$Css$px(16)),
										$rtfeldman$elm_css$Css$marginLeft(
										$rtfeldman$elm_css$Css$px(4)),
										$rtfeldman$elm_css$Css$width(
										$rtfeldman$elm_css$Css$pct(100)),
										$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
										$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none)
									])),
								$rtfeldman$elm_css$Html$Styled$Attributes$placeholder('Type to search...'),
								$rtfeldman$elm_css$Html$Styled$Attributes$value(
								A2($elm$core$Maybe$withDefault, '', field.es)),
								$rtfeldman$elm_css$Html$Styled$Events$onInput(
								function (val) {
									return config.cz(
										A2($author$project$Select$UpdateQuery, config.iX, val));
								})
							]),
						_List_Nil)
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $rtfeldman$elm_css$Css$Transitions$Visibility = 92;
var $rtfeldman$elm_css$Css$Transitions$visibility3 = $rtfeldman$elm_css$Css$Transitions$fullTransition(92);
var $author$project$Select$viewOptions = F4(
	function (model, config, optionConfig, field) {
		var mergeItem = F2(
			function (toKey, item) {
				return A2(
					$elm$core$Dict$update,
					toKey(item),
					function (maybeV) {
						if (maybeV.$ === 1) {
							return $elm$core$Maybe$Just(
								_List_fromArray(
									[item]));
						} else {
							var items = maybeV.a;
							return $elm$core$Maybe$Just(
								_Utils_ap(
									items,
									_List_fromArray(
										[item])));
						}
					});
			});
		var itemList = function () {
			var _v2 = config.ev;
			if (_v2) {
				return A3(
					$author$project$Select$filter,
					optionConfig.d8,
					A2($elm$core$Maybe$withDefault, '', field.es),
					config.lM);
			} else {
				return config.lM;
			}
		}();
		var groups = function () {
			var _v1 = config.br;
			if (!_v1.$) {
				var toKey = _v1.a;
				return A3(
					$elm$core$List$foldl,
					mergeItem(toKey),
					$elm$core$Dict$empty,
					itemList);
			} else {
				return $elm$core$Dict$empty;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$pct(100)),
							$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$zIndex(
							$rtfeldman$elm_css$Css$int(2)),
							$rtfeldman$elm_css$Css$backgroundColor(
							$rtfeldman$elm_css$Css$hex('#FFFFFF')),
							$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
							$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$px(28)),
							A2(
							$rtfeldman$elm_css$Css$property,
							'box-shadow',
							A2(
								$elm$core$String$join,
								',',
								_List_fromArray(
									['0 8px 10px 1px rgba(0,0,0,.14)', '0 3px 14px 2px rgba(0,0,0,.12)', '0 5px 5px -3px rgba(0,0,0,.2)']))),
							$rtfeldman$elm_css$Css$Transitions$transition(
							_List_fromArray(
								[
									A3(
									$rtfeldman$elm_css$Css$Transitions$opacity3,
									450,
									50,
									A4($rtfeldman$elm_css$Css$Transitions$cubicBezier, 0.23, 1, 0.32, 1)),
									A3(
									$rtfeldman$elm_css$Css$Transitions$visibility3,
									450,
									50,
									A4($rtfeldman$elm_css$Css$Transitions$cubicBezier, 0.23, 1, 0.32, 1))
								]))
						])),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					(!field.fJ) ? _List_fromArray(
						[
							$rtfeldman$elm_css$Css$opacity(
							$rtfeldman$elm_css$Css$int(1)),
							$rtfeldman$elm_css$Css$visibility($rtfeldman$elm_css$Css$visible)
						]) : _List_fromArray(
						[
							$rtfeldman$elm_css$Css$opacity(
							$rtfeldman$elm_css$Css$int(0)),
							$rtfeldman$elm_css$Css$visibility($rtfeldman$elm_css$Css$hidden)
						]))
				]),
			_List_fromArray(
				[
					A3($author$project$Select$viewSearchInput, model, config, field),
					function () {
					var _v0 = _Utils_Tuple2(
						!(!$elm$core$List$length(itemList)),
						config.aI);
					if (!_v0.a) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$fontSize(
											$rtfeldman$elm_css$Css$px(16)),
											$rtfeldman$elm_css$Css$fontFamilies(
											_List_fromArray(
												['Roboto'])),
											$rtfeldman$elm_css$Css$fontWeight(
											$rtfeldman$elm_css$Css$int(400)),
											$rtfeldman$elm_css$Css$padding(
											$rtfeldman$elm_css$Css$px(12))
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('We couldn\'t find or match the item.')
								]));
					} else {
						if (!_v0.b) {
							return $elm$core$Dict$isEmpty(groups) ? A2(
								$author$project$Select$viewContainer,
								config,
								A2(
									$elm$core$List$map,
									A2($author$project$Select$viewOption, config, optionConfig),
									itemList)) : A2(
								$author$project$Select$viewContainer,
								config,
								A4($author$project$Select$viewGroups, config, optionConfig, field, groups));
						} else {
							return $elm$core$Dict$isEmpty(groups) ? A2(
								$author$project$Select$viewContainer,
								config,
								A2(
									$elm$core$List$map,
									A3($author$project$Select$viewMultiSelectOption, field, config, optionConfig),
									itemList)) : A2(
								$author$project$Select$viewContainer,
								config,
								A4($author$project$Select$viewGroups, config, optionConfig, field, groups));
						}
					}
				}()
				]));
	});
var $rtfeldman$elm_css$Css$dashed = {aa: 0, cw: 0, eL: 'dashed'};
var $author$project$Select$viewUnderline = function (config) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(100)),
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$px(1)),
						A3(
						$rtfeldman$elm_css$Css$borderBottom3,
						$rtfeldman$elm_css$Css$px(1),
						$rtfeldman$elm_css$Css$solid,
						A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.42))
					])),
				config.d$ ? $rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
						A3(
						$rtfeldman$elm_css$Css$borderBottom3,
						$rtfeldman$elm_css$Css$px(1),
						$rtfeldman$elm_css$Css$dashed,
						A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.42))
					])) : $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
			]),
		_List_Nil);
};
var $author$project$Select$OpenOptions = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $danmarcab$material_icons$Material$Icons$Navigation$arrow_drop_down = A2(
	$danmarcab$material_icons$Material$Icons$Internal$icon,
	'0 0 48 48',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M14 20l10 10 10-10z')
				]),
			_List_Nil)
		]));
var $rtfeldman$elm_css$Css$borderRadius = $rtfeldman$elm_css$Css$prop1('border-radius');
var $rtfeldman$elm_css$Css$notAllowed = {d: 0, eL: 'not-allowed'};
var $rtfeldman$elm_css$Css$spaceBetween = $rtfeldman$elm_css$Css$prop1('space-between');
var $danmarcab$material_icons$Material$Icons$Navigation$cancel = A2(
	$danmarcab$material_icons$Material$Icons$Internal$icon,
	'0 0 48 48',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm10 27.17L31.17 34 24 26.83 16.83 34 14 31.17 21.17 24 14 16.83 16.83 14 24 21.17 31.17 14 34 16.83 26.83 24 34 31.17z')
				]),
			_List_Nil)
		]));
var $rtfeldman$elm_css$Css$margin4 = $rtfeldman$elm_css$Css$prop4('margin');
var $avh4$elm_color$Color$rgba = F4(
	function (r, g, b, a) {
		return A4($avh4$elm_color$Color$RgbaSpace, r, g, b, a);
	});
var $rtfeldman$elm_css$Css$spaceAround = $rtfeldman$elm_css$Css$prop1('space-around');
var $author$project$Select$viewChip = F3(
	function (config, optionConfig, item) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$borderRadius(
							$rtfeldman$elm_css$Css$px(100)),
							$rtfeldman$elm_css$Css$backgroundColor(
							A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.12)),
							A2(
							$rtfeldman$elm_css$Css$padding2,
							$rtfeldman$elm_css$Css$px(4),
							$rtfeldman$elm_css$Css$px(8)),
							A4(
							$rtfeldman$elm_css$Css$margin4,
							$rtfeldman$elm_css$Css$px(0),
							$rtfeldman$elm_css$Css$px(8),
							$rtfeldman$elm_css$Css$px(8),
							$rtfeldman$elm_css$Css$px(0)),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$fontSize(
									$rtfeldman$elm_css$Css$px(14)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(500))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							optionConfig.ep(item))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$zero),
									$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
									$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
									$rtfeldman$elm_css$Css$marginLeft(
									$rtfeldman$elm_css$Css$px(6)),
									$rtfeldman$elm_css$Css$borderRadius(
									$rtfeldman$elm_css$Css$pct(50)),
									$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
									$rtfeldman$elm_css$Css$padding(
									$rtfeldman$elm_css$Css$px(0))
								])),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							config.bB(
								A2(
									$elm$core$List$filter,
									function (d) {
										return !_Utils_eq(d, item);
									},
									config.au)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$fromUnstyled(
							A2(
								$danmarcab$material_icons$Material$Icons$Navigation$cancel,
								A4($avh4$elm_color$Color$rgba, 0, 0, 0, 0.6),
								24))
						]))
				]));
	});
var $author$project$Select$viewMultiValue = F2(
	function (config, optionConfig) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
							$rtfeldman$elm_css$Css$marginTop(
							$rtfeldman$elm_css$Css$px(8)),
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$pct(100))
						]))
				]),
			function () {
				var _v0 = $elm$core$List$isEmpty(config.au);
				if (!_v0) {
					return A2(
						$elm$core$List$map,
						A2($author$project$Select$viewChip, config, optionConfig),
						A2(
							$elm$core$List$filter,
							function (a) {
								return A2($elm$core$List$member, a, config.lM);
							},
							config.au));
				} else {
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
											$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$zero),
											$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
											$rtfeldman$elm_css$Css$fontSize(
											$rtfeldman$elm_css$Css$px(16)),
											$rtfeldman$elm_css$Css$padding(
											$rtfeldman$elm_css$Css$px(0)),
											$rtfeldman$elm_css$Css$marginBottom(
											$rtfeldman$elm_css$Css$px(4)),
											$rtfeldman$elm_css$Css$width(
											$rtfeldman$elm_css$Css$pct(100)),
											$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$left),
											$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
										])),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									config.d$ ? config.cz($author$project$Select$NoOp) : config.cz(
										A2($author$project$Select$OpenOptions, config.iX, config.cz)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('None Selected')
								]))
						]);
				}
			}());
	});
var $author$project$Select$viewSingleValue = F2(
	function (config, optionConfig) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
								$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$zero),
								$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
								$rtfeldman$elm_css$Css$padding(
								$rtfeldman$elm_css$Css$px(0)),
								$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$px(16)),
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$pct(100)),
								$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$left),
								$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
							])),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						config.d$ ? config.cz($author$project$Select$NoOp) : config.cz(
							A2($author$project$Select$OpenOptions, config.iX, config.cz)))
					]),
				function () {
					var _v0 = config.eL;
					if (!_v0.$) {
						var val = _v0.a;
						return A2(
							$elm$core$List$map,
							function (_v1) {
								var a = _v1.a;
								var b = _v1.b;
								return A2($rtfeldman$elm_css$Html$Styled$Attributes$style, a, b);
							},
							config.bP(val));
					} else {
						return _List_Nil;
					}
				}()),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2(
						$elm$core$Maybe$withDefault,
						'Click to Select',
						A2(
							$elm$core$Maybe$andThen,
							function (opt) {
								return A2(
									$elm$core$List$member,
									opt,
									A2($elm$core$List$map, optionConfig.ep, config.lM)) ? $elm$core$Maybe$Just(opt) : $elm$core$Maybe$Nothing;
							},
							A2(
								$elm$core$Maybe$andThen,
								A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, optionConfig.ep),
								config.eL))))
				]));
	});
var $author$project$Select$viewValue = F2(
	function (config, optionConfig) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$pct(100)),
							$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
							A4(
							$rtfeldman$elm_css$Css$padding4,
							$rtfeldman$elm_css$Css$px(0),
							$rtfeldman$elm_css$Css$px(0),
							$rtfeldman$elm_css$Css$px(2),
							$rtfeldman$elm_css$Css$px(0))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$fontFamilies(
										_List_fromArray(
											['Roboto'])),
										$rtfeldman$elm_css$Css$fontSize(
										$rtfeldman$elm_css$Css$px(16)),
										$rtfeldman$elm_css$Css$color(
										A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 1)),
										$rtfeldman$elm_css$Css$lineHeight(
										$rtfeldman$elm_css$Css$px(24)),
										$rtfeldman$elm_css$Css$displayFlex,
										$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$left),
										$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
										$rtfeldman$elm_css$Css$width(
										$rtfeldman$elm_css$Css$pct(100))
									])),
								config.d$ ? $rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$color(
										A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.42)),
										$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$notAllowed)
									])) : $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
							]),
						function () {
							var _v0 = config.eL;
							if (!_v0.$) {
								var val = _v0.a;
								return A2(
									$elm$core$List$map,
									function (_v1) {
										var a = _v1.a;
										var b = _v1.b;
										return A2($rtfeldman$elm_css$Html$Styled$Attributes$style, a, b);
									},
									config.bP(val));
							} else {
								return _List_Nil;
							}
						}()),
					_List_fromArray(
						[
							function () {
							var _v2 = config.aI;
							if (_v2) {
								return A2($author$project$Select$viewMultiValue, config, optionConfig);
							} else {
								return A2($author$project$Select$viewSingleValue, config, optionConfig);
							}
						}()
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$zero),
									$rtfeldman$elm_css$Css$padding(
									$rtfeldman$elm_css$Css$px(0)),
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$px(26)),
									$rtfeldman$elm_css$Css$height(
									$rtfeldman$elm_css$Css$px(26)),
									$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
									$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
								])),
							config.aI ? $rtfeldman$elm_css$Html$Styled$Attributes$class('mdl-shadow--2dp') : $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil),
							config.aI ? $rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$border(
									$rtfeldman$elm_css$Css$px(0)),
									$rtfeldman$elm_css$Css$borderRadius(
									$rtfeldman$elm_css$Css$pct(50)),
									$rtfeldman$elm_css$Css$backgroundColor(
									A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.12))
								])) : $rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
									$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent)
								])),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							config.d$ ? config.cz($author$project$Select$NoOp) : config.cz(
								A2($author$project$Select$OpenOptions, config.iX, config.cz)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$fromUnstyled(
							A2(
								$danmarcab$material_icons$Material$Icons$Navigation$arrow_drop_down,
								A3($avh4$elm_color$Color$rgb, 0, 0, 0),
								24))
						]))
				]));
	});
var $author$project$Select$view = F5(
	function (toMsg, index, model, optionConfig, attrs) {
		var selectField = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Select$initSelectField(1),
			A2($elm$core$Dict$get, index, model));
		var config = A2(
			$author$project$Select$collect,
			attrs,
			A2($author$project$Select$initConfig, toMsg, index));
		var customStyles = A2(
			$elm$core$List$map,
			function (_v0) {
				var a = _v0.a;
				var b = _v0.b;
				return A2($rtfeldman$elm_css$Html$Styled$Attributes$style, a, b);
			},
			config.cs);
		return $rtfeldman$elm_css$Html$Styled$toUnstyled(
			A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_Utils_ap(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(0),
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
									$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$zero),
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$pct(100)),
									$rtfeldman$elm_css$Css$minHeight(
									$rtfeldman$elm_css$Css$px(40)),
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
									$rtfeldman$elm_css$Css$fontFamilies(
									_List_fromArray(
										['Roboto'])),
									$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
								]))
						]),
					customStyles),
				_List_fromArray(
					[
						$author$project$Select$viewLabel(config),
						A2($author$project$Select$viewValue, config, optionConfig),
						$author$project$Select$viewUnderline(config),
						A2($author$project$Select$viewCancelOverlay, config, selectField),
						A4($author$project$Select$viewOptions, model, config, optionConfig, selectField),
						$author$project$Select$viewHelpText(config)
					])));
	});
var $author$project$Pages$User$viewAccountInfo = F2(
	function (model, user) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'padding', '12px 0px 12px 24px'),
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
					A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
					(user.h4 === 3) ? $elm$html$Html$Attributes$id('super-admin-id') : $elm$html$Html$Events$onClick($author$project$Pages$User$OpenUserPage)
				]),
			_List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$Icon$icon,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'font-size', '72px'),
							A2($elm$html$Html$Attributes$style, 'margin-left', '-8px')
						]),
					'account_box'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'flex-direction', 'column')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'font-size', '22px'),
									A2($elm$html$Html$Attributes$style, 'line-height', '28px'),
									A2($elm$html$Html$Attributes$style, 'color', '#212121'),
									A2($elm$html$Html$Attributes$style, 'font-weight', 'bold')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(user.li)
								])),
							(user.h4 === 3) ? A5(
							$author$project$Select$view,
							$author$project$Pages$User$Select,
							_List_fromArray(
								[0]),
							model.r,
							{
								dS: F2(
									function (a, b) {
										return _Utils_eq(a.aF, b.aF);
									}),
								d8: function ($) {
									return $.g8;
								},
								ep: function ($) {
									return $.g8;
								}
							},
							_List_fromArray(
								[
									$author$project$Select$label('Select District'),
									$author$project$Select$searchable,
									$author$project$Select$options(
									function () {
										var _v0 = model.cG;
										if (_v0.$ === 4) {
											var data = _v0.a;
											return data;
										} else {
											return _List_Nil;
										}
									}()),
									$author$project$Select$onSelect(
									$author$project$Pages$User$SelectDistrict(user)),
									$author$project$Select$value(model.ew),
									$author$project$Select$rootStyle(
									_List_fromArray(
										[
											_Utils_Tuple2('margin-top', '8px')
										]))
								])) : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'font-size', '14px'),
									A2($elm$html$Html$Attributes$style, 'line-height', '14px'),
									A2($elm$html$Html$Attributes$style, 'max-width', '300px'),
									A2($elm$html$Html$Attributes$style, 'color', '#757575'),
									A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis'),
									A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
									A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(user.iC.g8)
								]))
						]))
				]));
	});
var $author$project$Reusable$Separator$viewHorizontal = A2(
	$elm$html$Html$hr,
	_List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'height', '1px'),
			A2($elm$html$Html$Attributes$style, 'width', '100%'),
			A2($elm$html$Html$Attributes$style, 'border', 'none'),
			A2($elm$html$Html$Attributes$style, 'margin', '8px 0px'),
			A2($elm$html$Html$Attributes$style, 'background-color', 'rgb(224, 224, 224)')
		]),
	_List_Nil);
var $author$project$Pages$User$isUserOnline = function (model) {
	var _v0 = model.eK;
	if (_v0.$ === 4) {
		return true;
	} else {
		return false;
	}
};
var $aforemny$material_components_web_elm$Material$Button$setAttributes = F2(
	function (additionalAttributes, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{fZ: additionalAttributes});
	});
var $author$project$Pages$User$viewLogoutButton = function (model) {
	return $author$project$Pages$User$isUserOnline(model) ? A2(
		$aforemny$material_components_web_elm$Material$Button$outlined,
		A2(
			$aforemny$material_components_web_elm$Material$Button$setAttributes,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '125px')
				]),
			A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$User$LogoutUser, $aforemny$material_components_web_elm$Material$Button$config)),
		'Logout') : $elm$html$Html$text('');
};
var $author$project$Main$NavigateTo = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $author$project$Utils$keyDecoder = F2(
	function (kCode, msg) {
		var decoder = A2(
			$elm$json$Json$Decode$andThen,
			function (code) {
				return _Utils_eq(code, kCode) ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('Not enter Key');
			},
			$elm$html$Html$Events$keyCode);
		return A2($elm$html$Html$Events$on, 'keydown', decoder);
	});
var $author$project$Utils$onEnter = function (msg) {
	return A2($author$project$Utils$keyDecoder, 13, msg);
};
var $author$project$Main$viewNavItem = F2(
	function (model, page) {
		var isActive = function () {
			var _v0 = _Utils_Tuple2(model.I.dq, page);
			if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
				return true;
			} else {
				return _Utils_eq(model.I.dq, page);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('nav-bar-item', true),
							_Utils_Tuple2('nav-bar-item-selected', isActive)
						])),
					$elm$html$Html$Events$onClick(
					$author$project$Main$NavigateTo(page)),
					$author$project$Utils$onEnter(
					$author$project$Main$NavigateTo(page)),
					$elm$html$Html$Attributes$tabindex(0)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Routing$toStringPage(page))
				]));
	});
var $author$project$Reusable$Drawer$viewBackground = F3(
	function (isOpen, isDesktop, msg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('common-cancel-field', !isDesktop),
							_Utils_Tuple2('common-hidden', !isOpen)
						])),
					$elm$html$Html$Events$onClick(msg),
					$elm$html$Html$Attributes$disabled(!isOpen)
				]),
			_List_Nil);
	});
var $author$project$Reusable$Drawer$viewPrimary = F4(
	function (isOpen, isDesktop, msg, inner) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3($author$project$Reusable$Drawer$viewBackground, isOpen, isDesktop, msg),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('mdl-shadow--4dp', true)
								])),
							A2($elm$html$Html$Attributes$style, 'position', 'fixed'),
							A2($elm$html$Html$Attributes$style, 'top', '0'),
							A2($elm$html$Html$Attributes$style, 'left', '0'),
							A2($elm$html$Html$Attributes$style, 'width', '300px'),
							A2($elm$html$Html$Attributes$style, 'max-width', '100vw'),
							A2($elm$html$Html$Attributes$style, 'height', '100vh'),
							A2($elm$html$Html$Attributes$style, 'overflow', 'auto'),
							A2($elm$html$Html$Attributes$style, 'background', '#fafafa'),
							A2($elm$html$Html$Attributes$style, 'border-right', '1px solid #e0e0e0'),
							A2($elm$html$Html$Attributes$style, 'z-index', '10'),
							A2($elm$html$Html$Attributes$style, 'box-sizing', 'border-box'),
							A2($elm$html$Html$Attributes$style, 'transition', 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)'),
							A2(
							$elm$html$Html$Attributes$style,
							'transform',
							isOpen ? 'translateX(0)' : 'translateX(-310px)'),
							A2(
							$elm$html$Html$Attributes$style,
							'visibility',
							isOpen ? 'visible' : 'hidden'),
							A2(
							$elm$html$Html$Attributes$style,
							'pointer-events',
							isOpen ? 'auto' : 'none')
						]),
					inner)
				]));
	});
var $author$project$Main$OpenReleaseNotes = {$: 16};
var $author$project$Main$viewReleaseNotesLink = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
				A2($elm$html$Html$Attributes$style, 'margin-left', '24px'),
				A2($elm$html$Html$Attributes$style, 'color', 'rgb(63,81,181)')
			]),
		_List_fromArray(
			[
				A2($aforemny$material_components_web_elm$Material$Icon$icon, _List_Nil, 'new_releases'),
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'color', 'rgba(0,0,0,0.78)'),
						A2($elm$html$Html$Attributes$style, 'font-size', '12px'),
						A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
						A2($elm$html$Html$Attributes$style, 'margin-left', '8px'),
						A2($elm$html$Html$Attributes$style, 'color', 'rgb(63,81,181)'),
						$elm$html$Html$Events$onClick($author$project$Main$OpenReleaseNotes)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(' What\'s New (' + ('v' + ('2.7.7.21' + ')')))
					]))
			]));
};
var $author$project$Main$viewNavBar = function (model) {
	var items = function () {
		var _v1 = $author$project$Pages$User$getAccessToken(model.j7);
		if (!_v1.$) {
			return _Utils_eq(
				$author$project$Pages$User$getAccessLevel(model.j7),
				$elm$core$Maybe$Just(3)) ? _List_fromArray(
				[$author$project$Routing$DashboardPage, $author$project$Routing$SyncDevicesPage, $author$project$Routing$MenuItemListPage]) : _List_fromArray(
				[
					$author$project$Routing$DashboardPage,
					$author$project$Routing$LinkNewDevicePage(1),
					$author$project$Routing$SyncDevicesPage,
					$author$project$Routing$MenuItemListPage,
					$author$project$Routing$ContactUsPage,
					$author$project$Routing$FaqPage
				]);
		} else {
			return _List_fromArray(
				[$author$project$Routing$LoginPage, $author$project$Routing$ContactUsPage, $author$project$Routing$FaqPage]);
		}
	}();
	var _v0 = model.j7.eK;
	if (_v0.$ === 4) {
		var user = _v0.a;
		return A4(
			$author$project$Reusable$Drawer$viewPrimary,
			model.as,
			model.W === 2,
			$author$project$Main$ToggleNavbar,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'height', '64px'),
							A2($elm$html$Html$Attributes$style, 'background', '#007F38'),
							A2($elm$html$Html$Attributes$style, 'padding-left', '25px'),
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
							A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
							A2($elm$html$Html$Attributes$style, 'padding-top', '12px')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'width', '145px'),
									$elm$html$Html$Attributes$src(model.k.hE)
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Main$UserMsg,
					A2($author$project$Pages$User$viewAccountInfo, model.j7, user)),
					$author$project$Reusable$Separator$viewHorizontal,
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Main$viewNavItem(model),
						items)),
					$author$project$Reusable$Separator$viewHorizontal,
					$author$project$Main$viewReleaseNotesLink(model),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-left', '25px')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Main$UserMsg,
							$author$project$Pages$User$viewLogoutButton(model.j7))
						]))
				]));
	} else {
		return A4(
			$author$project$Reusable$Drawer$viewPrimary,
			model.as,
			model.W === 2,
			$author$project$Main$ToggleNavbar,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'height', '64px'),
							A2($elm$html$Html$Attributes$style, 'background', '#007F38'),
							A2($elm$html$Html$Attributes$style, 'padding-left', '25px'),
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
							A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
							A2($elm$html$Html$Attributes$style, 'padding-top', '12px')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'width', '145px'),
									$elm$html$Html$Attributes$src(model.k.hE)
								]),
							_List_Nil)
						])),
					$author$project$Reusable$Separator$viewHorizontal,
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Main$viewNavItem(model),
						items)),
					$author$project$Reusable$Separator$viewHorizontal,
					$author$project$Main$viewReleaseNotesLink(model),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-left', '25px')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Main$UserMsg,
							$author$project$Pages$User$viewLogoutButton(model.j7))
						]))
				]));
	}
};
var $author$project$Pages$SyncDevices$SelectImportDevice = function (a) {
	return {$: 3, a: a};
};
var $author$project$Main$findDeviceById = F2(
	function (deviceId, devices) {
		if (devices.$ === 4) {
			var dict = devices.a;
			return A2($elm$core$Dict$get, deviceId, dict);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Pages$MenuItemList$getData = function (data) {
	return A2(
		$elm$core$List$map,
		function (a) {
			return _Utils_Tuple2(a.aF, a.g8);
		},
		$elm$core$Dict$values(data));
};
var $author$project$Mdl$Elevation$e1 = $elm$html$Html$Attributes$class('mdl-shadow--1dp');
var $author$project$Reusable$Card$view = function (nodes) {
	return $rtfeldman$elm_css$Html$Styled$toUnstyled(
		A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled($author$project$Mdl$Elevation$e1),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$pct(100)),
							A2(
							$rtfeldman$elm_css$Css$padding2,
							$rtfeldman$elm_css$Css$px(12),
							$rtfeldman$elm_css$Css$px(12)),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$px(6))
						]))
				]),
			A2($elm$core$List$map, $rtfeldman$elm_css$Html$Styled$fromUnstyled, nodes)));
};
var $rtfeldman$elm_css$Css$EmUnits = 0;
var $rtfeldman$elm_css$Css$em = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'em');
var $rtfeldman$elm_css$Css$letterSpacing = $rtfeldman$elm_css$Css$prop1('letter-spacing');
var $rtfeldman$elm_css$Css$paddingBottom = $rtfeldman$elm_css$Css$prop1('padding-bottom');
var $author$project$Reusable$Card$viewTitle = function (title) {
	return $rtfeldman$elm_css$Html$Styled$toUnstyled(
		A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'font-family', 'Roboto'),
							$rtfeldman$elm_css$Css$fontSize(
							$rtfeldman$elm_css$Css$px(20)),
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(500)),
							$rtfeldman$elm_css$Css$lineHeight(
							$rtfeldman$elm_css$Css$int(1)),
							$rtfeldman$elm_css$Css$letterSpacing(
							$rtfeldman$elm_css$Css$em(0.02)),
							$rtfeldman$elm_css$Css$opacity(
							$rtfeldman$elm_css$Css$num(0.87)),
							$rtfeldman$elm_css$Css$paddingBottom(
							$rtfeldman$elm_css$Css$px(16))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(title)
				])));
};
var $author$project$Pages$ContactUs$view = $author$project$Reusable$Card$view(
	_List_fromArray(
		[
			$author$project$Reusable$Card$viewTitle('SchoolCafé TV Technical Support:'),
			A2($author$project$Reusable$Label$view, 'Phone Number', '855-PAY-2EAT / 855-729-2328'),
			A2($author$project$Reusable$Label$view, 'Hours', 'Monday - Friday, 6AM - 6PM CST')
		]));
var $author$project$Pages$Error404$view = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('view404')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Invalid route')
		]));
var $author$project$Pages$Faqs$filterStuff = F2(
	function (inp, list) {
		return A3(
			$NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$filter,
			function ($) {
				return $.Y;
			},
			inp,
			list);
	});
var $author$project$Pages$Faqs$viewEmpty = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$author$project$Mdl$Elevation$e4,
			A2($elm$html$Html$Attributes$style, 'padding', '16px'),
			A2($elm$html$Html$Attributes$style, 'margin-bottom', '12px'),
			A2($elm$html$Html$Attributes$style, 'width', '96%')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('None found')
		]));
var $author$project$Pages$Faqs$viewFaqStep = function (step) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(step)
			]));
};
var $author$project$Pages$Faqs$viewFaqCardDesc = function (answer) {
	if (!answer.$) {
		var strAnswer = answer.a;
		return A2(
			$elm$html$Html$p,
			_List_fromArray(
				[$aforemny$material_components_web_elm$Material$Typography$body1]),
			_List_fromArray(
				[
					$elm$html$Html$text(strAnswer)
				]));
	} else {
		var desc = answer.a;
		var steps = answer.b;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($elm$core$Maybe$withDefault, '', desc)),
					A2(
					$elm$html$Html$ol,
					_List_Nil,
					A2($elm$core$List$map, $author$project$Pages$Faqs$viewFaqStep, steps))
				]));
	}
};
var $author$project$Pages$Faqs$viewFaqCardTitle = function (title) {
	return A2(
		$elm$html$Html$h4,
		_List_fromArray(
			[$aforemny$material_components_web_elm$Material$Typography$headline4]),
		_List_fromArray(
			[
				$elm$html$Html$text(title)
			]));
};
var $author$project$Pages$Faqs$viewFaqCard = function (faq) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Mdl$Elevation$e2,
				A2($elm$html$Html$Attributes$style, 'padding', '16px'),
				A2($elm$html$Html$Attributes$style, 'margin-bottom', '12px'),
				A2($elm$html$Html$Attributes$style, 'width', '96%')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Faqs$viewFaqCardTitle(faq.Y),
				$author$project$Pages$Faqs$viewFaqCardDesc(faq._)
			]));
};
var $author$project$Pages$Faqs$OnInput = $elm$core$Basics$identity;
var $author$project$Pages$Faqs$viewSearchBar = function (model) {
	return $aforemny$material_components_web_elm$Material$TextField$outlined(
		A2(
			$aforemny$material_components_web_elm$Material$TextField$setLeadingIcon,
			$elm$core$Maybe$Just(
				$aforemny$material_components_web_elm$Material$TextField$Icon$icon('search')),
			A2(
				$aforemny$material_components_web_elm$Material$TextField$setAttributes,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', '100%'),
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '12px'),
						A2($elm$html$Html$Attributes$style, 'margin-top', '12px')
					]),
				A2(
					$aforemny$material_components_web_elm$Material$TextField$setOnInput,
					$elm$core$Basics$identity,
					A2(
						$aforemny$material_components_web_elm$Material$TextField$setValue,
						model.d7,
						A2(
							$aforemny$material_components_web_elm$Material$TextField$setLabel,
							$elm$core$Maybe$Just('Search FAQs'),
							$aforemny$material_components_web_elm$Material$TextField$config))))));
};
var $author$project$Pages$Faqs$view = function (model) {
	return $author$project$Reusable$Card$view(
		_List_fromArray(
			[
				function () {
				var filteredQuestions = A2(
					$author$project$Pages$Faqs$filterStuff,
					A2($elm$core$Maybe$withDefault, '', model.d7),
					model.f2);
				return $elm$core$List$isEmpty(filteredQuestions) ? $author$project$Reusable$Flex$viewVertical(
					_List_fromArray(
						[
							$author$project$Pages$Faqs$viewSearchBar(model),
							$author$project$Pages$Faqs$viewEmpty
						])) : $author$project$Reusable$Flex$viewVertical(
					_Utils_ap(
						_List_fromArray(
							[
								$author$project$Pages$Faqs$viewSearchBar(model)
							]),
						A2($elm$core$List$map, $author$project$Pages$Faqs$viewFaqCard, filteredQuestions)));
			}()
			]));
};
var $author$project$Main$viewErrorLoadingScreen = function (msg) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
				A2($elm$html$Html$Attributes$style, 'align-items', 'center')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(msg)
			]));
};
var $author$project$Main$viewLoadingScreen = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'height', '350px'),
			A2($elm$html$Html$Attributes$style, 'display', 'flex'),
			A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
			A2($elm$html$Html$Attributes$style, 'align-items', 'center')
		]),
	_List_fromArray(
		[
			$aforemny$material_components_web_elm$Material$CircularProgress$indeterminate($aforemny$material_components_web_elm$Material$CircularProgress$config)
		]));
var $author$project$Pages$User$invalidPasswordError = 'Username/Password is not correct.';
var $author$project$Pages$User$invalidUserError = 'User is not registered.';
var $author$project$Pages$User$userStateErrString = function (state) {
	if (state.$ === 2) {
		var str = state.a;
		return $elm$core$Maybe$Just(str);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$User$viewErrorText = function (state) {
	var _v0 = $author$project$Pages$User$userStateErrString(state);
	if (_v0.$ === 1) {
		return $elm$html$Html$text('');
	} else {
		var str = _v0.a;
		return (_Utils_eq(str, $author$project$Pages$User$invalidUserError) || _Utils_eq(str, $author$project$Pages$User$invalidPasswordError)) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'margin-top', '12px'),
					$aforemny$material_components_web_elm$Material$Typography$body1
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(str)
				]));
	}
};
var $author$project$Pages$User$viewForgotPasswordLink = A2(
	$elm$html$Html$a,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$target('blank_'),
			$elm$html$Html$Attributes$href('https://www.schoolcafe.com/forgot-username'),
			A2($elm$html$Html$Attributes$style, 'margin-top', '12px')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Having Trouble ?')
		]));
var $author$project$Pages$User$LoginUser = {$: 7};
var $author$project$Pages$User$viewLoginButton = function (model) {
	var _v0 = model.eK;
	switch (_v0.$) {
		case 1:
			return $aforemny$material_components_web_elm$Material$CircularProgress$indeterminate($aforemny$material_components_web_elm$Material$CircularProgress$config);
		case 0:
			var attrs = _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '300px'),
					$elm$html$Html$Attributes$class('button')
				]);
			return A2(
				$aforemny$material_components_web_elm$Material$Button$outlined,
				A2(
					$aforemny$material_components_web_elm$Material$Button$setAttributes,
					attrs,
					A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$User$LoginUser, $aforemny$material_components_web_elm$Material$Button$config)),
				'Login');
		case 4:
			var user = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Logged in as : ' + user.ax)
					]));
		case 3:
			return $elm$html$Html$text('empty');
		default:
			var attrs = _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '100%'),
					$elm$html$Html$Attributes$class('button')
				]);
			return A2(
				$aforemny$material_components_web_elm$Material$Button$outlined,
				A2(
					$aforemny$material_components_web_elm$Material$Button$setAttributes,
					attrs,
					A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$User$LoginUser, $aforemny$material_components_web_elm$Material$Button$config)),
				'Login');
	}
};
var $author$project$Pages$User$FlipShowPassword = {$: 6};
var $author$project$Pages$User$SetPassword = function (a) {
	return {$: 4, a: a};
};
var $aforemny$material_components_web_elm$Material$TextField$Icon$Internal$SvgIcon = function (a) {
	return {$: 1, a: a};
};
var $aforemny$material_components_web_elm$Material$TextField$Icon$setOnInteraction = F2(
	function (onInteraction, icon_) {
		if (!icon_.$) {
			var data = icon_.a;
			return $aforemny$material_components_web_elm$Material$TextField$Icon$Internal$Icon(
				_Utils_update(
					data,
					{
						ji: $elm$core$Maybe$Just(onInteraction)
					}));
		} else {
			var data = icon_.a;
			return $aforemny$material_components_web_elm$Material$TextField$Icon$Internal$SvgIcon(
				_Utils_update(
					data,
					{
						ji: $elm$core$Maybe$Just(onInteraction)
					}));
		}
	});
var $aforemny$material_components_web_elm$Material$TextField$setTrailingIcon = F2(
	function (trailingIcon, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{fR: trailingIcon});
	});
var $aforemny$material_components_web_elm$Material$TextField$setType = F2(
	function (type_, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{hT: type_});
	});
var $aforemny$material_components_web_elm$Material$TextField$setValid = F2(
	function (valid, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{hU: valid});
	});
var $aforemny$material_components_web_elm$Material$HelperText$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$HelperText$config = {fZ: _List_Nil, hs: false, hV: true};
var $aforemny$material_components_web_elm$Material$HelperText$ariaHiddenAttr = $elm$core$Maybe$Just(
	A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'));
var $aforemny$material_components_web_elm$Material$HelperText$helperTextCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-text-field-helper-text'));
var $aforemny$material_components_web_elm$Material$HelperText$persistentCs = function (_v0) {
	var config_ = _v0;
	return config_.hs ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field-helper-text--persistent')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$HelperText$validationCs = function (_v0) {
	var config_ = _v0;
	return config_.hV ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field-helper-text--validation-msg')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$HelperText$helperText = F2(
	function (config_, string) {
		var additionalAttributes = config_.fZ;
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$HelperText$helperTextCs,
							$aforemny$material_components_web_elm$Material$HelperText$persistentCs(config_),
							$aforemny$material_components_web_elm$Material$HelperText$validationCs(config_),
							$aforemny$material_components_web_elm$Material$HelperText$ariaHiddenAttr
						])),
				additionalAttributes),
			_List_fromArray(
				[
					$elm$html$Html$text(string)
				]));
	});
var $aforemny$material_components_web_elm$Material$HelperText$setAttributes = F2(
	function (additionalAttributes, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{fZ: additionalAttributes});
	});
var $aforemny$material_components_web_elm$Material$HelperText$setPersistent = F2(
	function (persistent, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{hs: persistent});
	});
var $aforemny$material_components_web_elm$Material$HelperText$setValidation = F2(
	function (validation, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{hV: validation});
	});
var $author$project$Material$Local$errText = function (errMsg) {
	return A2(
		$aforemny$material_components_web_elm$Material$HelperText$helperText,
		A2(
			$aforemny$material_components_web_elm$Material$HelperText$setAttributes,
			$elm$core$String$isEmpty(errMsg) ? _List_Nil : _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'margin-bottom', '12px')
				]),
			A2(
				$aforemny$material_components_web_elm$Material$HelperText$setValidation,
				true,
				A2($aforemny$material_components_web_elm$Material$HelperText$setPersistent, true, $aforemny$material_components_web_elm$Material$HelperText$config))),
		errMsg);
};
var $author$project$Material$Local$textFieldWithErr = F2(
	function (errMsg, textField) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '100%'),
					A2($elm$html$Html$Attributes$style, 'margin-top', '8px')
				]),
			_List_fromArray(
				[
					textField,
					$author$project$Material$Local$errText(errMsg)
				]));
	});
var $author$project$Pages$User$workaroundAutofillException = F2(
	function (model, msg) {
		var _v0 = model.eK;
		switch (_v0.$) {
			case 4:
				return $elm$html$Html$Attributes$classList(_List_Nil);
			case 0:
				return $elm$html$Html$Events$onInput(msg);
			case 1:
				return $elm$html$Html$Attributes$classList(_List_Nil);
			case 3:
				return $elm$html$Html$Attributes$classList(_List_Nil);
			default:
				return $elm$html$Html$Events$onInput(msg);
		}
	});
var $author$project$Pages$User$viewPasswordField = function (model) {
	var icon = model.co ? A2(
		$aforemny$material_components_web_elm$Material$TextField$Icon$setOnInteraction,
		$author$project$Pages$User$FlipShowPassword,
		$aforemny$material_components_web_elm$Material$TextField$Icon$icon('visibility')) : A2(
		$aforemny$material_components_web_elm$Material$TextField$Icon$setOnInteraction,
		$author$project$Pages$User$FlipShowPassword,
		$aforemny$material_components_web_elm$Material$TextField$Icon$icon('visibility_off'));
	var fieldType = model.co ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('password');
	var errText = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$andThen,
			function (str) {
				return _Utils_eq(str, $author$project$Pages$User$invalidPasswordError) ? $elm$core$Maybe$Just(str) : $elm$core$Maybe$Nothing;
			},
			$author$project$Pages$User$userStateErrString(model.eK)));
	return A2(
		$author$project$Material$Local$textFieldWithErr,
		errText,
		$aforemny$material_components_web_elm$Material$TextField$outlined(
			A2(
				$aforemny$material_components_web_elm$Material$TextField$setAttributes,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', '100%'),
						$author$project$Utils$onEnter($author$project$Pages$User$LoginUser),
						A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'current-password'),
						A2($author$project$Pages$User$workaroundAutofillException, model, $author$project$Pages$User$SetPassword)
					]),
				A2(
					$aforemny$material_components_web_elm$Material$TextField$setValid,
					$elm$core$String$isEmpty(errText),
					A2(
						$aforemny$material_components_web_elm$Material$TextField$setTrailingIcon,
						$elm$core$Maybe$Just(icon),
						A2(
							$aforemny$material_components_web_elm$Material$TextField$setOnInput,
							$author$project$Pages$User$SetPassword,
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setValue,
								model.dr,
								A2(
									$aforemny$material_components_web_elm$Material$TextField$setLabel,
									$elm$core$Maybe$Just('Password'),
									A2($aforemny$material_components_web_elm$Material$TextField$setType, fieldType, $aforemny$material_components_web_elm$Material$TextField$config)))))))));
};
var $author$project$Pages$User$RememberMe = {$: 5};
var $aforemny$material_components_web_elm$Material$Checkbox$backgroundElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-checkbox__background')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('mdc-checkbox__checkmark'),
					$elm$svg$Svg$Attributes$viewBox('0 0 24 24')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('mdc-checkbox__checkmark-path'),
							$elm$svg$Svg$Attributes$fill('none'),
							$elm$svg$Svg$Attributes$d('M1.73,12.91 8.1,19.28 22.79,4.59')
						]),
					_List_Nil)
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mdc-checkbox__mixedmark')
				]),
			_List_Nil)
		]));
var $aforemny$material_components_web_elm$Material$Checkbox$Internal$Checked = 1;
var $aforemny$material_components_web_elm$Material$Checkbox$checkedProp = function (_v0) {
	var state = _v0.fJ;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'checked',
			$elm$json$Json$Encode$bool(
				_Utils_eq(
					state,
					$elm$core$Maybe$Just(1)))));
};
var $aforemny$material_components_web_elm$Material$Checkbox$disabledProp = function (_v0) {
	var disabled = _v0.d$;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'disabled',
			$elm$json$Json$Encode$bool(disabled)));
};
var $aforemny$material_components_web_elm$Material$Checkbox$Internal$Indeterminate = 2;
var $aforemny$material_components_web_elm$Material$Checkbox$indeterminateProp = function (_v0) {
	var state = _v0.fJ;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'indeterminate',
			$elm$json$Json$Encode$bool(
				_Utils_eq(
					state,
					$elm$core$Maybe$Just(2)))));
};
var $aforemny$material_components_web_elm$Material$Checkbox$changeHandler = function (_v0) {
	var onChange = _v0.fx;
	return A2(
		$elm$core$Maybe$map,
		function (msg) {
			return A2(
				$elm$html$Html$Events$on,
				'change',
				$elm$json$Json$Decode$succeed(msg));
		},
		onChange);
};
var $aforemny$material_components_web_elm$Material$Checkbox$nativeControlElt = function (config_) {
	return A2(
		$elm$html$Html$input,
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					$elm$html$Html$Attributes$type_('checkbox')),
					$elm$core$Maybe$Just(
					$elm$html$Html$Attributes$class('mdc-checkbox__native-control')),
					$aforemny$material_components_web_elm$Material$Checkbox$checkedProp(config_),
					$aforemny$material_components_web_elm$Material$Checkbox$indeterminateProp(config_),
					$aforemny$material_components_web_elm$Material$Checkbox$changeHandler(config_)
				])),
		_List_Nil);
};
var $aforemny$material_components_web_elm$Material$Checkbox$rippleElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-checkbox__ripple')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$Checkbox$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-checkbox'));
var $aforemny$material_components_web_elm$Material$Checkbox$touchCs = function (_v0) {
	var touch = _v0.eE;
	return touch ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-checkbox--touch')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$Checkbox$checkbox = function (config_) {
	var touch = config_.eE;
	var additionalAttributes = config_.fZ;
	var wrapTouch = function (node) {
		return touch ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mdc-touch-target-wrapper')
				]),
			_List_fromArray(
				[node])) : node;
	};
	return wrapTouch(
		A3(
			$elm$html$Html$node,
			'mdc-checkbox',
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$Checkbox$rootCs,
							$aforemny$material_components_web_elm$Material$Checkbox$touchCs(config_),
							$aforemny$material_components_web_elm$Material$Checkbox$checkedProp(config_),
							$aforemny$material_components_web_elm$Material$Checkbox$indeterminateProp(config_),
							$aforemny$material_components_web_elm$Material$Checkbox$disabledProp(config_)
						])),
				additionalAttributes),
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$Checkbox$nativeControlElt(config_),
					$aforemny$material_components_web_elm$Material$Checkbox$backgroundElt,
					$aforemny$material_components_web_elm$Material$Checkbox$rippleElt
				])));
};
var $aforemny$material_components_web_elm$Material$Checkbox$checked = 1;
var $aforemny$material_components_web_elm$Material$Checkbox$Internal$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Checkbox$config = {fZ: _List_Nil, d$: false, fx: $elm$core$Maybe$Nothing, fJ: $elm$core$Maybe$Nothing, eE: true};
var $aforemny$material_components_web_elm$Material$FormField$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$FormField$config = {fZ: _List_Nil, f$: false, gB: $elm$core$Maybe$Nothing, c9: $elm$core$Maybe$Nothing, he: $elm$core$Maybe$Nothing};
var $aforemny$material_components_web_elm$Material$FormField$alignEndCs = function (_v0) {
	var alignEnd = _v0.f$;
	return alignEnd ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-form-field--align-end')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$FormField$clickHandler = function (_v0) {
	var onClick = _v0.he;
	return A2($elm$core$Maybe$map, $elm$html$Html$Events$onClick, onClick);
};
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $aforemny$material_components_web_elm$Material$FormField$forAttr = function (_v0) {
	var _for = _v0.gB;
	return A2($elm$core$Maybe$map, $elm$html$Html$Attributes$for, _for);
};
var $elm$html$Html$label = _VirtualDom_node('label');
var $aforemny$material_components_web_elm$Material$FormField$labelElt = function (config_) {
	var label = config_.c9;
	return A2(
		$elm$html$Html$label,
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$FormField$forAttr(config_),
					$aforemny$material_components_web_elm$Material$FormField$clickHandler(config_)
				])),
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2($elm$core$Maybe$withDefault, '', label))
			]));
};
var $aforemny$material_components_web_elm$Material$FormField$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-form-field'));
var $aforemny$material_components_web_elm$Material$FormField$formField = F2(
	function (config_, nodes) {
		var additionalAttributes = config_.fZ;
		return A3(
			$elm$html$Html$node,
			'mdc-form-field',
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$FormField$rootCs,
							$aforemny$material_components_web_elm$Material$FormField$alignEndCs(config_)
						])),
				additionalAttributes),
			_Utils_ap(
				nodes,
				_List_fromArray(
					[
						$aforemny$material_components_web_elm$Material$FormField$labelElt(config_)
					])));
	});
var $aforemny$material_components_web_elm$Material$FormField$setAttributes = F2(
	function (additionalAttributes, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{fZ: additionalAttributes});
	});
var $aforemny$material_components_web_elm$Material$FormField$setLabel = F2(
	function (label, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{c9: label});
	});
var $aforemny$material_components_web_elm$Material$Checkbox$setOnChange = F2(
	function (onChange, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{
				fx: $elm$core$Maybe$Just(onChange)
			});
	});
var $aforemny$material_components_web_elm$Material$Checkbox$setState = F2(
	function (state, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{fJ: state});
	});
var $aforemny$material_components_web_elm$Material$Checkbox$Internal$Unchecked = 0;
var $aforemny$material_components_web_elm$Material$Checkbox$unchecked = 0;
var $author$project$Pages$User$viewRememberMeCheckbox = function (model) {
	var state = model.dt ? $aforemny$material_components_web_elm$Material$Checkbox$checked : $aforemny$material_components_web_elm$Material$Checkbox$unchecked;
	return A2(
		$aforemny$material_components_web_elm$Material$FormField$formField,
		A2(
			$aforemny$material_components_web_elm$Material$FormField$setAttributes,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'align-self', 'flex-end')
				]),
			A2(
				$aforemny$material_components_web_elm$Material$FormField$setLabel,
				$elm$core$Maybe$Just('Remember Me'),
				$aforemny$material_components_web_elm$Material$FormField$config)),
		_List_fromArray(
			[
				$aforemny$material_components_web_elm$Material$Checkbox$checkbox(
				A2(
					$aforemny$material_components_web_elm$Material$Checkbox$setOnChange,
					$author$project$Pages$User$RememberMe,
					A2(
						$aforemny$material_components_web_elm$Material$Checkbox$setState,
						$elm$core$Maybe$Just(state),
						$aforemny$material_components_web_elm$Material$Checkbox$config)))
			]));
};
var $author$project$Pages$User$SetUserName = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$User$viewUsernameField = function (model) {
	var errText = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$andThen,
			function (str) {
				return _Utils_eq(str, $author$project$Pages$User$invalidUserError) ? $elm$core$Maybe$Just(str) : $elm$core$Maybe$Nothing;
			},
			$author$project$Pages$User$userStateErrString(model.eK)));
	return A2(
		$author$project$Material$Local$textFieldWithErr,
		errText,
		$aforemny$material_components_web_elm$Material$TextField$outlined(
			A2(
				$aforemny$material_components_web_elm$Material$TextField$setAttributes,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'username'),
						A2($elm$html$Html$Attributes$style, 'width', '100%'),
						A2($author$project$Pages$User$workaroundAutofillException, model, $author$project$Pages$User$SetUserName),
						$author$project$Utils$onEnter($author$project$Pages$User$LoginUser)
					]),
				A2(
					$aforemny$material_components_web_elm$Material$TextField$setValid,
					$elm$core$String$isEmpty(errText),
					A2(
						$aforemny$material_components_web_elm$Material$TextField$setOnInput,
						$author$project$Pages$User$SetUserName,
						A2(
							$aforemny$material_components_web_elm$Material$TextField$setValue,
							model.ax,
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setLabel,
								$elm$core$Maybe$Just('Username'),
								$aforemny$material_components_web_elm$Material$TextField$config)))))));
};
var $author$project$Pages$User$viewLoginPage = F2(
	function (flags, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('login-box-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Mdl$Elevation$e4,
							$elm$html$Html$Attributes$class('login-box'),
							A2($elm$html$Html$Attributes$style, 'margin-top', '64px'),
							A2($elm$html$Html$Attributes$style, 'width', '300px'),
							A2($elm$html$Html$Attributes$style, 'border-radius', '8px')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(flags.lR),
									A2($elm$html$Html$Attributes$style, 'max-width', '100%'),
									A2($elm$html$Html$Attributes$style, 'margin-bottom', '8px')
								]),
							_List_Nil),
							$author$project$Pages$User$viewUsernameField(model),
							$author$project$Pages$User$viewPasswordField(model),
							$author$project$Pages$User$viewErrorText(model.eK),
							$author$project$Pages$User$viewRememberMeCheckbox(model),
							$author$project$Reusable$Separator$viewHorizontal,
							$author$project$Pages$User$viewLoginButton(model),
							$author$project$Pages$User$viewForgotPasswordLink
						]))
				]));
	});
var $author$project$Pages$CfgDevice$Core$SnackbarClosed = function (a) {
	return {$: 3, a: a};
};
var $aforemny$material_components_web_elm$Material$Button$setHref = F2(
	function (href, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{ed: href});
	});
var $aforemny$material_components_web_elm$Material$Typography$subtitle1 = $elm$html$Html$Attributes$class('mdc-typography--subtitle1');
var $aforemny$material_components_web_elm$Material$TabBar$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$TabBar$config = {fZ: _List_Nil, f_: $elm$core$Maybe$Nothing, fd: false, g4: false, hI: false};
var $aforemny$material_components_web_elm$Material$TabBar$setAttributes = F2(
	function (additionalAttributes, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{fZ: additionalAttributes});
	});
var $aforemny$material_components_web_elm$Material$TabBar$activeTabIndexProp = function (tabs) {
	var activeTabIndex = A2(
		$elm$core$Maybe$map,
		$elm$core$Tuple$first,
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var active = _v0.b.h6;
					return active;
				},
				A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, tabs))));
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$html$Html$Attributes$property('activeTabIndex'),
			$elm$json$Json$Encode$int),
		activeTabIndex);
};
var $aforemny$material_components_web_elm$Material$TabBar$anyActive = function (tabs) {
	if (!tabs.b) {
		return false;
	} else {
		var active = tabs.a.h6;
		var remainingTabs = tabs.b;
		return active || $aforemny$material_components_web_elm$Material$TabBar$anyActive(remainingTabs);
	}
};
var $aforemny$material_components_web_elm$Material$Tab$Internal$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Tab$Internal$Tab = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$TabBar$setActive = F2(
	function (active, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{h6: active});
	});
var $aforemny$material_components_web_elm$Material$TabBar$enforceActiveHelper = function (tabs) {
	if (!tabs.b) {
		return _List_Nil;
	} else {
		var tab = tabs.a;
		var active = tab.h6;
		var remainingTabs = tabs.b;
		return (!active) ? A2(
			$elm$core$List$cons,
			tab,
			$aforemny$material_components_web_elm$Material$TabBar$enforceActiveHelper(remainingTabs)) : A2(
			$elm$core$List$cons,
			tab,
			A2(
				$elm$core$List$map,
				$aforemny$material_components_web_elm$Material$TabBar$setActive(false),
				remainingTabs));
	}
};
var $aforemny$material_components_web_elm$Material$TabBar$enforceActive = F2(
	function (firstTab, otherTabs) {
		var config_ = firstTab;
		return (!$aforemny$material_components_web_elm$Material$TabBar$anyActive(
			A2($elm$core$List$cons, firstTab, otherTabs))) ? A2(
			$elm$core$List$cons,
			A2($aforemny$material_components_web_elm$Material$TabBar$setActive, true, firstTab),
			otherTabs) : $aforemny$material_components_web_elm$Material$TabBar$enforceActiveHelper(
			A2($elm$core$List$cons, firstTab, otherTabs));
	});
var $aforemny$material_components_web_elm$Material$TabBar$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-tab-bar'));
var $aforemny$material_components_web_elm$Material$TabBar$tabScrollerAlignCs = function (align) {
	if (!align.$) {
		switch (align.a) {
			case 0:
				var _v1 = align.a;
				return $elm$core$Maybe$Just(
					$elm$html$Html$Attributes$class('mdc-tab-scroller--align-start'));
			case 1:
				var _v2 = align.a;
				return $elm$core$Maybe$Just(
					$elm$html$Html$Attributes$class('mdc-tab-scroller--align-end'));
			default:
				var _v3 = align.a;
				return $elm$core$Maybe$Just(
					$elm$html$Html$Attributes$class('mdc-tab-scroller--align-center'));
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $aforemny$material_components_web_elm$Material$TabBar$tabScrollerCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-tab-scroller'));
var $aforemny$material_components_web_elm$Material$TabBar$tabClickHandler = function (_v0) {
	var onClick = _v0.he;
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$html$Html$Events$on('MDCTab:interacted'),
			$elm$json$Json$Decode$succeed),
		onClick);
};
var $aforemny$material_components_web_elm$Material$TabBar$tabIconElt = function (_v0) {
	var icon = _v0.iU;
	return A2(
		$elm$core$Maybe$map,
		$elm$html$Html$map($elm$core$Basics$never),
		function () {
			if (!icon.$) {
				if (!icon.a.$) {
					var node = icon.a.a.aJ;
					var attributes = icon.a.a.eP;
					var nodes = icon.a.a.ft;
					return $elm$core$Maybe$Just(
						A2(
							node,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('mdc-tab__icon'),
								attributes),
							nodes));
				} else {
					var node = icon.a.a.aJ;
					var attributes = icon.a.a.eP;
					var nodes = icon.a.a.ft;
					return $elm$core$Maybe$Just(
						A2(
							node,
							A2(
								$elm$core$List$cons,
								$elm$svg$Svg$Attributes$class('mdc-tab__icon'),
								attributes),
							nodes));
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}());
};
var $aforemny$material_components_web_elm$Material$TabBar$tabIndicatorContentElt = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-tab-indicator__content'),
			$elm$html$Html$Attributes$class('mdc-tab-indicator__content--underline')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$TabBar$tabIndicatorElt = function (config_) {
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mdc-tab-indicator')
				]),
			_List_fromArray(
				[$aforemny$material_components_web_elm$Material$TabBar$tabIndicatorContentElt])));
};
var $aforemny$material_components_web_elm$Material$TabBar$tabTextLabelElt = function (_v0) {
	var label = _v0.c9;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mdc-tab__text-label')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				])));
};
var $aforemny$material_components_web_elm$Material$TabBar$tabContentElt = F3(
	function (barConfig, config_, content) {
		var indicatorSpansContent = barConfig.fd;
		return $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mdc-tab__content')
					]),
				indicatorSpansContent ? A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$TabBar$tabIconElt(content),
							$aforemny$material_components_web_elm$Material$TabBar$tabTextLabelElt(content),
							$aforemny$material_components_web_elm$Material$TabBar$tabIndicatorElt(config_)
						])) : A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$TabBar$tabIconElt(content),
							$aforemny$material_components_web_elm$Material$TabBar$tabTextLabelElt(content)
						]))));
	});
var $aforemny$material_components_web_elm$Material$TabBar$tabCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-tab'));
var $aforemny$material_components_web_elm$Material$TabBar$tabMinWidthCs = function (_v0) {
	var minWidth = _v0.g4;
	return minWidth ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-tab--min-width')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TabBar$tabRippleElt = $elm$core$Maybe$Just(
	A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mdc-tab__ripple')
			]),
		_List_Nil));
var $aforemny$material_components_web_elm$Material$TabBar$tabRoleAttr = $elm$core$Maybe$Just(
	A2($elm$html$Html$Attributes$attribute, 'role', 'tab'));
var $aforemny$material_components_web_elm$Material$TabBar$tabStackedCs = function (_v0) {
	var stacked = _v0.hI;
	return stacked ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-tab--stacked')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TabBar$viewTab = F2(
	function (barConfig, tab) {
		var indicatorSpansContent = barConfig.fd;
		var tabConfig = tab;
		var additionalAttributes = tabConfig.fZ;
		var content = tabConfig.k_;
		return A3(
			$elm$html$Html$node,
			'mdc-tab',
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$TabBar$tabCs,
							$aforemny$material_components_web_elm$Material$TabBar$tabRoleAttr,
							$aforemny$material_components_web_elm$Material$TabBar$tabStackedCs(barConfig),
							$aforemny$material_components_web_elm$Material$TabBar$tabMinWidthCs(barConfig),
							$aforemny$material_components_web_elm$Material$TabBar$tabClickHandler(tabConfig)
						])),
				additionalAttributes),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				indicatorSpansContent ? _List_fromArray(
					[
						A3($aforemny$material_components_web_elm$Material$TabBar$tabContentElt, barConfig, tabConfig, content),
						$aforemny$material_components_web_elm$Material$TabBar$tabRippleElt
					]) : _List_fromArray(
					[
						A3($aforemny$material_components_web_elm$Material$TabBar$tabContentElt, barConfig, tabConfig, content),
						$aforemny$material_components_web_elm$Material$TabBar$tabIndicatorElt(tabConfig),
						$aforemny$material_components_web_elm$Material$TabBar$tabRippleElt
					])));
	});
var $aforemny$material_components_web_elm$Material$TabBar$tabScrollerScrollContentElt = F2(
	function (barConfig, tabs) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mdc-tab-scroller__scroll-content')
				]),
			A2(
				$elm$core$List$map,
				$aforemny$material_components_web_elm$Material$TabBar$viewTab(barConfig),
				tabs));
	});
var $aforemny$material_components_web_elm$Material$TabBar$tabScrollerScrollAreaElt = F2(
	function (barConfig, tabs) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mdc-tab-scroller__scroll-area')
				]),
			_List_fromArray(
				[
					A2($aforemny$material_components_web_elm$Material$TabBar$tabScrollerScrollContentElt, barConfig, tabs)
				]));
	});
var $aforemny$material_components_web_elm$Material$TabBar$tabScroller = F3(
	function (config_, align, tabs) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$aforemny$material_components_web_elm$Material$TabBar$tabScrollerCs,
						$aforemny$material_components_web_elm$Material$TabBar$tabScrollerAlignCs(align)
					])),
			_List_fromArray(
				[
					A2($aforemny$material_components_web_elm$Material$TabBar$tabScrollerScrollAreaElt, config_, tabs)
				]));
	});
var $aforemny$material_components_web_elm$Material$TabBar$tablistRoleAttr = $elm$core$Maybe$Just(
	A2($elm$html$Html$Attributes$attribute, 'role', 'tablist'));
var $aforemny$material_components_web_elm$Material$TabBar$tabBar = F3(
	function (config_, tab_, tabs_) {
		var additionalAttributes = config_.fZ;
		var align = config_.f_;
		var tabs = A2($aforemny$material_components_web_elm$Material$TabBar$enforceActive, tab_, tabs_);
		return A3(
			$elm$html$Html$node,
			'mdc-tab-bar',
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$TabBar$rootCs,
							$aforemny$material_components_web_elm$Material$TabBar$tablistRoleAttr,
							$aforemny$material_components_web_elm$Material$TabBar$activeTabIndexProp(tabs)
						])),
				additionalAttributes),
			_List_fromArray(
				[
					A3($aforemny$material_components_web_elm$Material$TabBar$tabScroller, config_, align, tabs)
				]));
	});
var $author$project$Pages$CfgDevice$Design$OpenTemplateDialog = function (a) {
	return {$: 76, a: a};
};
var $author$project$Reusable$Header$sectionHeader = function (str) {
	return A2(
		$elm$html$Html$h4,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'box-sizing', 'border-box'),
				A2($elm$html$Html$Attributes$style, 'color', 'rgb(0,0,0,0.54)'),
				A2($elm$html$Html$Attributes$style, 'font-size', '14px'),
				A2($elm$html$Html$Attributes$style, 'font-weight', '500'),
				A2($elm$html$Html$Attributes$style, 'padding-left', '16px'),
				A2($elm$html$Html$Attributes$style, 'padding-top', '12px'),
				A2($elm$html$Html$Attributes$style, 'margin', '0px'),
				A2($elm$html$Html$Attributes$style, 'width', '100%')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $author$project$Pages$CfgDevice$Design$BindStyle = F2(
	function (a, b) {
		return {$: 36, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Design$CloseBindStyleDialog = {$: 89};
var $aforemny$material_components_web_elm$Material$Button$setDisabled = F2(
	function (disabled, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{d$: disabled});
	});
var $author$project$Pages$CfgDevice$Design$viewBindStyleDialog = function (model) {
	return A2(
		$aforemny$material_components_web_elm$Material$Dialog$dialog,
		A2(
			$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
			$author$project$Pages$CfgDevice$Design$CloseBindStyleDialog,
			A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.bQ.a, $aforemny$material_components_web_elm$Material$Dialog$config)),
		{
			kk: _List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$Button$outlined,
					A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$CfgDevice$Design$CloseBindStyleDialog, $aforemny$material_components_web_elm$Material$Button$config),
					'Close'),
					function () {
					var onClick = function () {
						var _v0 = model.bQ.b;
						if (!_v0.$) {
							var position = _v0.a;
							return A2(
								$author$project$Pages$CfgDevice$Design$BindStyle,
								$author$project$DataState$toMaybe(model.a),
								position);
						} else {
							return $author$project$Pages$CfgDevice$Design$NoOp;
						}
					}();
					return A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2(
							$aforemny$material_components_web_elm$Material$Button$setDisabled,
							_Utils_eq(onClick, $author$project$Pages$CfgDevice$Design$NoOp),
							A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config)),
						'Bind Style');
				}()
				]),
			k_: _List_fromArray(
				[
					$elm$html$Html$text('Are you sure you want to locally copy the style? Any changes to the shared style will no longer apply to this section.')
				]),
			na: $elm$core$Maybe$Just('Bind Style')
		});
};
var $author$project$Pages$CfgDevice$Design$CloseDelColumnDialog = {$: 73};
var $author$project$Pages$CfgDevice$Design$DelColumn = F2(
	function (a, b) {
		return {$: 21, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Design$viewDelColumnDialog = function (model) {
	return A2(
		$aforemny$material_components_web_elm$Material$Dialog$dialog,
		A2(
			$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
			$author$project$Pages$CfgDevice$Design$CloseDelColumnDialog,
			A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.cQ, $aforemny$material_components_web_elm$Material$Dialog$config)),
		{
			kk: _List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$Button$outlined,
					A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$CfgDevice$Design$CloseDelColumnDialog, $aforemny$material_components_web_elm$Material$Button$config),
					'Close'),
					function () {
					var onClick = function () {
						var _v0 = _Utils_Tuple2(model.a, model.h);
						if ((_v0.a.$ === 4) && (!_v0.b.$)) {
							var template = _v0.a.a;
							var position = _v0.b.a;
							return A2($author$project$Pages$CfgDevice$Design$DelColumn, template, position);
						} else {
							return $author$project$Pages$CfgDevice$Design$NoOp;
						}
					}();
					return A2(
						$aforemny$material_components_web_elm$Material$Button$raised,
						A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config),
						'Drop Column');
				}()
				]),
			k_: _List_fromArray(
				[
					$elm$html$Html$text('Are you really sure you want to drop the column? This will clear the widgets in the column.')
				]),
			na: $elm$core$Maybe$Just('Drop Column')
		});
};
var $author$project$Pages$CfgDevice$Design$CloseDelFrameDialog = {$: 81};
var $author$project$Pages$CfgDevice$Design$DeleteFrame = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Design$dialogStyle = _List_Nil;
var $aforemny$material_components_web_elm$Material$Dialog$setAttributes = F2(
	function (additionalAttributes, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{fZ: additionalAttributes});
	});
var $author$project$Pages$CfgDevice$Design$viewDelFrameDialog = function (model) {
	return A2(
		$aforemny$material_components_web_elm$Material$Dialog$dialog,
		A2(
			$aforemny$material_components_web_elm$Material$Dialog$setAttributes,
			$author$project$Pages$CfgDevice$Design$dialogStyle,
			A2(
				$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
				$author$project$Pages$CfgDevice$Design$CloseDelFrameDialog,
				A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.cR, $aforemny$material_components_web_elm$Material$Dialog$config))),
		{
			kk: _List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$Button$outlined,
					A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$CfgDevice$Design$CloseDelFrameDialog, $aforemny$material_components_web_elm$Material$Button$config),
					'Close'),
					function () {
					var onClick = function () {
						var _v0 = _Utils_Tuple2(model.a, model.aw);
						if ((_v0.a.$ === 4) && (!_v0.b.$)) {
							var template = _v0.a.a;
							var frameIndex = _v0.b.a;
							return A2($author$project$Pages$CfgDevice$Design$DeleteFrame, frameIndex, template);
						} else {
							return $author$project$Pages$CfgDevice$Design$NoOp;
						}
					}();
					return A2(
						$aforemny$material_components_web_elm$Material$Button$raised,
						A2(
							$aforemny$material_components_web_elm$Material$Button$setDisabled,
							_Utils_eq(onClick, $author$project$Pages$CfgDevice$Design$NoOp),
							A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config)),
						'Drop Slide');
				}()
				]),
			k_: _List_fromArray(
				[
					$elm$html$Html$text('Are you sure you want to drop the slide ?')
				]),
			na: $elm$core$Maybe$Just('Drop Slide')
		});
};
var $author$project$Pages$CfgDevice$Design$CloseDelSectionDialog = {$: 79};
var $author$project$Pages$CfgDevice$Design$DelRow = F2(
	function (a, b) {
		return {$: 22, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Design$isSingletonRow = F2(
	function (template, _v0) {
		var frameIndex = _v0.ap;
		var columnIndex = _v0.C;
		var rowIndex = _v0.y;
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						A2(
							$elm$core$Basics$composeL,
							$elm$core$Maybe$Just,
							$elm$core$Basics$eq(1)),
						$elm$core$List$length),
					function ($) {
						return $.jJ;
					}),
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeL,
						$elm_community$list_extra$List$Extra$getAt(columnIndex),
						function ($) {
							return $.da;
						}),
					A2($elm_community$list_extra$List$Extra$getAt, frameIndex, template.G))));
	});
var $author$project$Pages$CfgDevice$Design$viewDelSectionDialog = function (model) {
	return A2(
		$aforemny$material_components_web_elm$Material$Dialog$dialog,
		A2(
			$aforemny$material_components_web_elm$Material$Dialog$setAttributes,
			$author$project$Pages$CfgDevice$Design$dialogStyle,
			A2(
				$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
				$author$project$Pages$CfgDevice$Design$CloseDelSectionDialog,
				A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.bW, $aforemny$material_components_web_elm$Material$Dialog$config))),
		{
			kk: _List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$Button$outlined,
					A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$CfgDevice$Design$CloseDelSectionDialog, $aforemny$material_components_web_elm$Material$Button$config),
					'Close'),
					function () {
					var onClick = function () {
						var _v0 = _Utils_Tuple2(model.a, model.h);
						if ((_v0.a.$ === 4) && (!_v0.b.$)) {
							var template = _v0.a.a;
							var position = _v0.b.a;
							var _v1 = A2($author$project$Pages$CfgDevice$Design$isSingletonRow, template, position);
							if (!_v1) {
								return A2($author$project$Pages$CfgDevice$Design$DelRow, template, position);
							} else {
								return A2($author$project$Pages$CfgDevice$Design$DelColumn, template, position);
							}
						} else {
							return $author$project$Pages$CfgDevice$Design$NoOp;
						}
					}();
					return A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config),
						'Drop Section');
				}()
				]),
			k_: _List_fromArray(
				[
					$elm$html$Html$text('Are you sure you want to drop the section')
				]),
			na: $elm$core$Maybe$Just('Drop Section')
		});
};
var $author$project$Pages$CfgDevice$Design$CloseDelTemplateDialog = {$: 71};
var $author$project$Pages$CfgDevice$Design$viewDelTemplateDialog = function (model) {
	return A2(
		$aforemny$material_components_web_elm$Material$Dialog$dialog,
		A2(
			$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
			$author$project$Pages$CfgDevice$Design$CloseDelTemplateDialog,
			A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.cU, $aforemny$material_components_web_elm$Material$Dialog$config)),
		{
			kk: _List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$Button$outlined,
					A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$CfgDevice$Design$CloseDelTemplateDialog, $aforemny$material_components_web_elm$Material$Button$config),
					'Close'),
					function () {
					var onClick = function () {
						var _v0 = model.a;
						if (_v0.$ === 4) {
							var template = _v0.a;
							return A2($author$project$Pages$CfgDevice$Design$TemplateDelete, template.g8, true);
						} else {
							return $author$project$Pages$CfgDevice$Design$NoOp;
						}
					}();
					return A2(
						$aforemny$material_components_web_elm$Material$Button$raised,
						A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config),
						'Delete');
				}()
				]),
			k_: _List_fromArray(
				[
					function () {
					var _v1 = model.a;
					if (_v1.$ === 4) {
						var template = _v1.a;
						return $elm$html$Html$text('Are you really sure you want to delete ' + (template.g8 + '?'));
					} else {
						return $elm$html$Html$text('Something went wrong');
					}
				}()
				]),
			na: $elm$core$Maybe$Just('Delete')
		});
};
var $author$project$Pages$CfgDevice$Design$ClosePlayTemplateDialog = {$: 83};
var $author$project$Pages$CfgDevice$Design$GoBackward = 1;
var $author$project$Pages$CfgDevice$Design$GoForward = 0;
var $author$project$Pages$CfgDevice$Design$GoToSlide = F2(
	function (a, b) {
		return {$: 108, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Design$HideFrame = function (a) {
	return {$: 104, a: a};
};
var $author$project$Pages$CfgDevice$Design$LiveTemplateScale = function (a) {
	return {$: 107, a: a};
};
var $author$project$Pages$CfgDevice$Design$ResetSettings = {$: 106};
var $author$project$Reusable$Slider$Label = function (a) {
	return {$: 5, a: a};
};
var $author$project$Reusable$Slider$label = function (lb) {
	return $author$project$Reusable$Slider$Label(lb);
};
var $elm$virtual_dom$VirtualDom$lazy3 = _VirtualDom_lazy3;
var $elm$html$Html$Lazy$lazy3 = $elm$virtual_dom$VirtualDom$lazy3;
var $author$project$Pages$CfgDevice$Design$liveTemplateViewport = function (nodes) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'position', 'relative'),
				A2($elm$html$Html$Attributes$style, 'height', '45vh'),
				A2($elm$html$Html$Attributes$style, 'width', '71vw'),
				A2($elm$html$Html$Attributes$style, 'overflow', 'auto')
			]),
		nodes);
};
var $author$project$Reusable$Slider$Max = function (a) {
	return {$: 1, a: a};
};
var $author$project$Reusable$Slider$max = function (val) {
	return $author$project$Reusable$Slider$Max(val);
};
var $author$project$Reusable$Slider$Min = function (a) {
	return {$: 0, a: a};
};
var $author$project$Reusable$Slider$min = function (val) {
	return $author$project$Reusable$Slider$Min(val);
};
var $author$project$Reusable$Input$collect = F2(
	function (attrs, config) {
		var toCfg = F2(
			function (attr, cfg) {
				switch (attr.$) {
					case 0:
						var val = attr.a;
						return _Utils_update(
							cfg,
							{fn: val});
					case 1:
						var val = attr.a;
						return _Utils_update(
							cfg,
							{fq: val});
					case 3:
						var val = attr.a;
						return _Utils_update(
							cfg,
							{ek: val});
					case 4:
						var sty = attr.a;
						return _Utils_update(
							cfg,
							{cs: sty});
					default:
						var val = attr.a;
						return _Utils_update(
							cfg,
							{eL: val});
				}
			});
		return A3($elm$core$List$foldl, toCfg, config, attrs);
	});
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$Attributes$maxlength = function (n) {
	return A2(
		_VirtualDom_attribute,
		'maxlength',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $elm$html$Html$Attributes$size = function (n) {
	return A2(
		_VirtualDom_attribute,
		'size',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Reusable$Input$number = F2(
	function (onInput, attrs) {
		var config = A2(
			$author$project$Reusable$Input$collect,
			attrs,
			{
				fn: 100,
				ek: 3,
				fq: 0,
				cs: _List_fromArray(
					[
						_Utils_Tuple2('width', '40px'),
						_Utils_Tuple2('font-size', '14px')
					]),
				eL: 1
			});
		var customStyles = A2(
			$elm$core$List$map,
			function (_v1) {
				var a = _v1.a;
				var b = _v1.b;
				return A2($elm$html$Html$Attributes$style, a, b);
			},
			config.cs);
		return A2(
			$elm$html$Html$input,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$value(
						$elm$core$String$fromFloat(config.eL)),
						$elm$html$Html$Attributes$type_('number'),
						$elm$html$Html$Attributes$min(
						$elm$core$String$fromFloat(config.fq)),
						$elm$html$Html$Attributes$max(
						$elm$core$String$fromFloat(config.fn)),
						$elm$html$Html$Attributes$size(config.ek),
						$elm$html$Html$Attributes$maxlength(config.ek),
						$elm$html$Html$Events$onInput(
						function (a) {
							var _v0 = $elm$core$String$toFloat(a);
							if (!_v0.$) {
								var val = _v0.a;
								return onInput(val);
							} else {
								return onInput(config.eL);
							}
						})
					]),
				customStyles),
			_List_Nil);
	});
var $author$project$Reusable$DatePicker$selectedIsoDate = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $justinmimbs$date$Date$toIsoString),
		model.a0);
};
var $aforemny$material_components_web_elm$Material$IconButton$setDisabled = F2(
	function (disabled, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{d$: disabled});
	});
var $author$project$Reusable$Slider$Step = function (a) {
	return {$: 2, a: a};
};
var $author$project$Reusable$Slider$step = function (val) {
	return $author$project$Reusable$Slider$Step(val);
};
var $author$project$Reusable$Slider$Style = function (a) {
	return {$: 6, a: a};
};
var $author$project$Reusable$Slider$style = function (st) {
	return $author$project$Reusable$Slider$Style(st);
};
var $author$project$Reusable$Input$Value = function (a) {
	return {$: 2, a: a};
};
var $author$project$Reusable$Input$value = function (val) {
	return $author$project$Reusable$Input$Value(val);
};
var $author$project$Reusable$Slider$Value = function (a) {
	return {$: 3, a: a};
};
var $author$project$Reusable$Slider$value = function (val) {
	return $author$project$Reusable$Slider$Value(val);
};
var $author$project$Reusable$Slider$collect = F2(
	function (attrs, config) {
		var toConfig = F2(
			function (attr, cfg) {
				switch (attr.$) {
					case 0:
						var val = attr.a;
						return _Utils_update(
							cfg,
							{fq: val});
					case 1:
						var val = attr.a;
						return _Utils_update(
							cfg,
							{fn: val});
					case 2:
						var val = attr.a;
						return _Utils_update(
							cfg,
							{fL: val});
					case 3:
						var val = attr.a;
						return _Utils_update(
							cfg,
							{eL: val});
					case 4:
						var val = attr.a;
						return _Utils_update(
							cfg,
							{d$: val});
					case 5:
						var lb = attr.a;
						return _Utils_update(
							cfg,
							{
								c9: $elm$core$Maybe$Just(lb)
							});
					default:
						var a = attr.a;
						return _Utils_update(
							cfg,
							{cs: a});
				}
			});
		return A3($elm$core$List$foldl, toConfig, config, attrs);
	});
var $author$project$Reusable$Slider$initConfig = function (onChange) {
	return {
		d$: false,
		c9: $elm$core$Maybe$Nothing,
		fn: 100,
		fq: 0,
		fx: onChange,
		fL: 1,
		cs: _List_fromArray(
			[
				_Utils_Tuple2('width', '100%')
			]),
		eL: 0
	};
};
var $rtfeldman$elm_css$Css$backgroundImage = $rtfeldman$elm_css$Css$prop1('background-image');
var $rtfeldman$elm_css$Css$backgroundRepeat = $rtfeldman$elm_css$Css$prop1('background-repeat');
var $rtfeldman$elm_css$Css$Transitions$BackgroundSize = 3;
var $rtfeldman$elm_css$Css$Transitions$backgroundSize = $rtfeldman$elm_css$Css$Transitions$durationTransition(3);
var $rtfeldman$elm_css$Css$backgroundSize2 = $rtfeldman$elm_css$Css$prop2('background-size');
var $rtfeldman$elm_css$Css$collectStops = $elm$core$List$map(
	function (_v0) {
		var c = _v0.a;
		var len = _v0.b;
		return A2(
			$elm$core$String$append,
			c.eL,
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$String$cons(' '),
						function ($) {
							return $.eL;
						}),
					len)));
	});
var $rtfeldman$elm_css$Css$linearGradient2 = F4(
	function (direction, firstStop, secondStop, otherStops) {
		return {
			cH: 0,
			f: 0,
			eL: A2(
				$rtfeldman$elm_css$Css$cssFunction,
				'linear-gradient',
				A2(
					$elm$core$List$cons,
					direction.eL,
					$rtfeldman$elm_css$Css$collectStops(
						_Utils_ap(
							_List_fromArray(
								[firstStop, secondStop]),
							otherStops))))
		};
	});
var $rtfeldman$elm_css$Css$margin2 = $rtfeldman$elm_css$Css$prop2('margin');
var $rtfeldman$elm_css$Html$Styled$Attributes$max = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('max');
var $rtfeldman$elm_css$Html$Styled$Attributes$min = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('min');
var $rtfeldman$elm_css$Css$Transitions$opacity = $rtfeldman$elm_css$Css$Transitions$durationTransition(73);
var $rtfeldman$elm_css$Css$repeatY = {bh: 0, eL: 'repeat-y'};
var $rtfeldman$elm_css$Html$Styled$Attributes$step = function (n) {
	return A2($rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'step', n);
};
var $rtfeldman$elm_css$Css$stop2 = F2(
	function (c, len) {
		return _Utils_Tuple2(
			c,
			$elm$core$Maybe$Just(len));
	});
var $rtfeldman$elm_css$Css$RemUnits = 0;
var $rtfeldman$elm_css$Css$rem = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'rem');
var $rtfeldman$elm_css$Css$scale = function (x) {
	return {
		s: 0,
		eL: A2(
			$rtfeldman$elm_css$Css$cssFunction,
			'scale',
			_List_fromArray(
				[
					$elm$core$String$fromFloat(x)
				]))
	};
};
var $rtfeldman$elm_css$Css$valuesOrNone = function (list) {
	return $elm$core$List$isEmpty(list) ? {eL: 'none'} : {
		eL: A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				function ($) {
					return $.eL;
				},
				list))
	};
};
var $rtfeldman$elm_css$Css$transforms = A2(
	$elm$core$Basics$composeL,
	$rtfeldman$elm_css$Css$prop1('transform'),
	$rtfeldman$elm_css$Css$valuesOrNone);
var $rtfeldman$elm_css$Css$transform = function (only) {
	return $rtfeldman$elm_css$Css$transforms(
		_List_fromArray(
			[only]));
};
var $rtfeldman$elm_css$Css$Transitions$Transform = 89;
var $rtfeldman$elm_css$Css$Transitions$transform = $rtfeldman$elm_css$Css$Transitions$durationTransition(89);
var $author$project$Reusable$Slider$thumbStyle = _List_fromArray(
	[
		A2($rtfeldman$elm_css$Css$property, '-webkit-appearance', 'none'),
		A2($rtfeldman$elm_css$Css$property, 'appearance', 'none'),
		A2($rtfeldman$elm_css$Css$property, '-ms-appearance', 'none'),
		$rtfeldman$elm_css$Css$width(
		$rtfeldman$elm_css$Css$rem(1)),
		$rtfeldman$elm_css$Css$height(
		$rtfeldman$elm_css$Css$rem(1)),
		$rtfeldman$elm_css$Css$hover(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$transform(
				$rtfeldman$elm_css$Css$scale(1.4))
			])),
		$rtfeldman$elm_css$Css$borderRadius(
		$rtfeldman$elm_css$Css$pct(50)),
		A2($rtfeldman$elm_css$Css$property, 'background', '#007F38'),
		$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
		$rtfeldman$elm_css$Css$Transitions$transition(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Transitions$transform(500)
			]))
	]);
var $rtfeldman$elm_css$Css$toRight = {aZ: 0, eL: 'to right'};
var $author$project$Reusable$Slider$viewInput = function (config) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$input,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Css$property, '-webkit-appearance', 'none'),
						A2($rtfeldman$elm_css$Css$property, 'appearance', 'none'),
						$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(100)),
						$rtfeldman$elm_css$Css$borderRadius(
						$rtfeldman$elm_css$Css$px(12)),
						A2(
						$rtfeldman$elm_css$Css$margin2,
						$rtfeldman$elm_css$Css$px(12),
						$rtfeldman$elm_css$Css$px(0)),
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$px(3)),
						$rtfeldman$elm_css$Css$backgroundColor(
						$rtfeldman$elm_css$Css$hex('#D3D3D3')),
						$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none),
						$rtfeldman$elm_css$Css$opacity(
						$rtfeldman$elm_css$Css$num(0.8)),
						A2($rtfeldman$elm_css$Css$property, '-webkit-transition', 'opacity 0.2s'),
						$rtfeldman$elm_css$Css$Transitions$transition(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Transitions$opacity(400),
								$rtfeldman$elm_css$Css$Transitions$backgroundSize(400)
							])),
						$rtfeldman$elm_css$Css$backgroundImage(
						A4(
							$rtfeldman$elm_css$Css$linearGradient2,
							$rtfeldman$elm_css$Css$toRight,
							A2(
								$rtfeldman$elm_css$Css$stop2,
								$rtfeldman$elm_css$Css$hex('#007F3B'),
								$rtfeldman$elm_css$Css$pct(100)),
							A2(
								$rtfeldman$elm_css$Css$stop2,
								$rtfeldman$elm_css$Css$hex('#D3D3D3'),
								$rtfeldman$elm_css$Css$pct(100)),
							_List_Nil)),
						A2(
						$rtfeldman$elm_css$Css$backgroundSize2,
						$rtfeldman$elm_css$Css$pct(
							100 * function (a) {
								return a / (config.fn - config.fq);
							}(config.eL - config.fq)),
						$rtfeldman$elm_css$Css$auto),
						$rtfeldman$elm_css$Css$backgroundRepeat($rtfeldman$elm_css$Css$repeatY),
						$rtfeldman$elm_css$Css$hover(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$opacity(
								$rtfeldman$elm_css$Css$num(1))
							])),
						A2($rtfeldman$elm_css$Css$pseudoClass, ':-webkit-slider-thumb', $author$project$Reusable$Slider$thumbStyle),
						A2($rtfeldman$elm_css$Css$pseudoClass, ':-moz-range-thumb', $author$project$Reusable$Slider$thumbStyle),
						A2($rtfeldman$elm_css$Css$pseudoClass, ':-ms-thumb', $author$project$Reusable$Slider$thumbStyle)
					])),
				$rtfeldman$elm_css$Html$Styled$Attributes$type_('range'),
				$rtfeldman$elm_css$Html$Styled$Attributes$min(
				$elm$core$String$fromFloat(config.fq)),
				$rtfeldman$elm_css$Html$Styled$Attributes$max(
				$elm$core$String$fromFloat(config.fn)),
				$rtfeldman$elm_css$Html$Styled$Attributes$step(
				$elm$core$String$fromFloat(config.fL)),
				$rtfeldman$elm_css$Html$Styled$Attributes$value(
				$elm$core$String$fromFloat(config.eL)),
				$rtfeldman$elm_css$Html$Styled$Attributes$disabled(config.d$),
				$rtfeldman$elm_css$Html$Styled$Events$onInput(
				function (a) {
					var _v0 = $elm$core$String$toFloat(a);
					if (!_v0.$) {
						var val = _v0.a;
						return config.fx(val);
					} else {
						return config.fx(config.eL);
					}
				})
			]),
		_List_Nil);
};
var $author$project$Reusable$Slider$viewLabel = function (config) {
	var _v0 = config.c9;
	if (!_v0.$) {
		var str = _v0.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$fontFamilies(
							_List_fromArray(
								['Roboto'])),
							$rtfeldman$elm_css$Css$fontSize(
							$rtfeldman$elm_css$Css$px(12)),
							$rtfeldman$elm_css$Css$lineHeight(
							$rtfeldman$elm_css$Css$px(16))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(str)
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Reusable$Slider$view = F2(
	function (onChange, attrs) {
		var config = A2(
			$author$project$Reusable$Slider$collect,
			attrs,
			$author$project$Reusable$Slider$initConfig(onChange));
		var customStyles = A2(
			$elm$core$List$map,
			function (_v0) {
				var a = _v0.a;
				var b = _v0.b;
				return A2($rtfeldman$elm_css$Html$Styled$Attributes$style, a, b);
			},
			config.cs);
		return $rtfeldman$elm_css$Html$Styled$toUnstyled(
			A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_Utils_ap(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
									$rtfeldman$elm_css$Css$color(
									A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.54)),
									$rtfeldman$elm_css$Css$hover(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$color(
											A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 1))
										]))
								]))
						]),
					customStyles),
				_List_fromArray(
					[
						$author$project$Reusable$Slider$viewLabel(config),
						$author$project$Reusable$Slider$viewInput(config)
					])));
	});
var $author$project$Pages$CfgDevice$Design$LoadData = F2(
	function (a, b) {
		return {$: 96, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Design$Select = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$CfgDevice$Design$SelectSchedule = function (a) {
	return {$: 94, a: a};
};
var $author$project$Reusable$DatePicker$isEmpty = function (model) {
	return _Utils_eq(model.a0, $elm$core$Maybe$Nothing);
};
var $author$project$Reusable$DatePicker$ClosePicker = {$: 1};
var $author$project$Reusable$DatePicker$OpenPicker = {$: 0};
var $author$project$Reusable$DatePicker$color = '#00BCD4';
var $CurrySoftware$elm_datepicker$DatePicker$SubmitText = {$: 4};
var $CurrySoftware$elm_datepicker$DatePicker$Text = function (a) {
	return {$: 3, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$ChangeFocus = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$date$Date$Months = 1;
var $CurrySoftware$elm_datepicker$DatePicker$MouseDown = {$: 7};
var $CurrySoftware$elm_datepicker$DatePicker$MouseUp = {$: 8};
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.nr - 1)) + ($justinmimbs$date$Date$monthToNumber(date.ja) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.iA,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$Date$changeYear = F2(
	function (current, newYear) {
		var _v0 = $elm$core$String$toInt(newYear);
		if (!_v0.$) {
			var year = _v0.a;
			return A3(
				$justinmimbs$date$Date$fromCalendarDate,
				year,
				$justinmimbs$date$Date$month(current),
				$justinmimbs$date$Date$day(current));
		} else {
			return current;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$groupDates = function (dates) {
	var go = F4(
		function (i, xs, racc, acc) {
			go:
			while (true) {
				if (!xs.b) {
					return $elm$core$List$reverse(acc);
				} else {
					var x = xs.a;
					var xxs = xs.b;
					if (i === 6) {
						var $temp$i = 0,
							$temp$xs = xxs,
							$temp$racc = _List_Nil,
							$temp$acc = A2(
							$elm$core$List$cons,
							$elm$core$List$reverse(
								A2($elm$core$List$cons, x, racc)),
							acc);
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					} else {
						var $temp$i = i + 1,
							$temp$xs = xxs,
							$temp$racc = A2($elm$core$List$cons, x, racc),
							$temp$acc = acc;
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					}
				}
			}
		});
	return A4(go, 0, dates, _List_Nil, _List_Nil);
};
var $CurrySoftware$elm_datepicker$DatePicker$maybeOr = F2(
	function (lhs, rhs) {
		if (!rhs.$) {
			return rhs;
		} else {
			return lhs;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$mkClass = F2(
	function (_v0, c) {
		var classNamespace = _v0.cM;
		return $elm$html$Html$Attributes$class(
			_Utils_ap(classNamespace, c));
	});
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $elm$html$Html$option = _VirtualDom_node('option');
var $justinmimbs$date$Date$Days = 3;
var $justinmimbs$date$Date$Weeks = 2;
var $justinmimbs$date$Date$Years = 0;
var $justinmimbs$date$Date$intervalToUnits = function (interval) {
	switch (interval) {
		case 0:
			return _Utils_Tuple2(1, 0);
		case 1:
			return _Utils_Tuple2(3, 1);
		case 2:
			return _Utils_Tuple2(1, 1);
		case 11:
			return _Utils_Tuple2(1, 3);
		default:
			var week = interval;
			return _Utils_Tuple2(1, 2);
	}
};
var $justinmimbs$date$Date$ceiling = F2(
	function (interval, date) {
		var floored = A2($justinmimbs$date$Date$floor, interval, date);
		if (_Utils_eq(date, floored)) {
			return date;
		} else {
			var _v0 = $justinmimbs$date$Date$intervalToUnits(interval);
			var n = _v0.a;
			var unit = _v0.b;
			return A3($justinmimbs$date$Date$add, unit, n, floored);
		}
	});
var $justinmimbs$date$Date$rangeHelp = F5(
	function (unit, step, until, revList, current) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(current, until) < 0) {
				var _v0 = A3($justinmimbs$date$Date$add, unit, step, current);
				var next = _v0;
				var $temp$unit = unit,
					$temp$step = step,
					$temp$until = until,
					$temp$revList = A2($elm$core$List$cons, current, revList),
					$temp$current = next;
				unit = $temp$unit;
				step = $temp$step;
				until = $temp$until;
				revList = $temp$revList;
				current = $temp$current;
				continue rangeHelp;
			} else {
				return $elm$core$List$reverse(revList);
			}
		}
	});
var $justinmimbs$date$Date$range = F4(
	function (interval, step, _v0, _v1) {
		var start = _v0;
		var until = _v1;
		var _v2 = $justinmimbs$date$Date$intervalToUnits(interval);
		var n = _v2.a;
		var unit = _v2.b;
		var _v3 = A2($justinmimbs$date$Date$ceiling, interval, start);
		var first = _v3;
		return (_Utils_cmp(first, until) < 0) ? A5(
			$justinmimbs$date$Date$rangeHelp,
			unit,
			A2($elm$core$Basics$max, 1, step) * n,
			until,
			_List_Nil,
			first) : _List_Nil;
	});
var $CurrySoftware$elm_datepicker$DatePicker$Date$weekdayToInterval = function (weekday) {
	switch (weekday) {
		case 0:
			return 4;
		case 1:
			return 5;
		case 2:
			return 6;
		case 3:
			return 7;
		case 4:
			return 8;
		case 5:
			return 9;
		default:
			return 10;
	}
};
var $CurrySoftware$elm_datepicker$DatePicker$prepareDates = F2(
	function (date, firstDayOfWeek) {
		var weekdayAsInterval = $CurrySoftware$elm_datepicker$DatePicker$Date$weekdayToInterval(firstDayOfWeek);
		var start = A2(
			$justinmimbs$date$Date$floor,
			weekdayAsInterval,
			A3(
				$justinmimbs$date$Date$fromCalendarDate,
				$justinmimbs$date$Date$year(date),
				$justinmimbs$date$Date$month(date),
				1));
		var firstOfMonth = A3(
			$justinmimbs$date$Date$fromCalendarDate,
			$justinmimbs$date$Date$year(date),
			$justinmimbs$date$Date$month(date),
			1);
		var end = A2(
			$justinmimbs$date$Date$ceiling,
			weekdayAsInterval,
			A3($justinmimbs$date$Date$add, 1, 1, firstOfMonth));
		return {
			iy: A4($justinmimbs$date$Date$range, 11, 1, start, end),
			gg: date
		};
	});
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $CurrySoftware$elm_datepicker$DatePicker$Pick = function (a) {
	return {$: 2, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$mkClassList = F2(
	function (_v0, cs) {
		var classNamespace = _v0.cM;
		return $elm$html$Html$Attributes$classList(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var c = _v1.a;
					var b = _v1.b;
					return _Utils_Tuple2(
						_Utils_ap(classNamespace, c),
						b);
				},
				cs));
	});
var $CurrySoftware$elm_datepicker$DatePicker$viewDay = F5(
	function (settings, picked, isOtherMonth, isToday, d) {
		var disabled = settings.fh(d);
		var props = (!disabled) ? _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$CurrySoftware$elm_datepicker$DatePicker$Pick(d))
			]) : _List_Nil;
		var classList = $CurrySoftware$elm_datepicker$DatePicker$mkClassList(settings);
		return A2(
			$elm$html$Html$td,
			_Utils_ap(
				_List_fromArray(
					[
						classList(
						_List_fromArray(
							[
								_Utils_Tuple2('day', true),
								_Utils_Tuple2('disabled', disabled),
								_Utils_Tuple2(
								'picked',
								picked(d)),
								_Utils_Tuple2(
								'today',
								isToday(d)),
								_Utils_Tuple2(
								'other-month',
								isOtherMonth(d))
							]))
					]),
				props),
			_List_fromArray(
				[
					settings.f9(
					$elm$core$String$fromInt(
						$justinmimbs$date$Date$day(d)))
				]));
	});
var $CurrySoftware$elm_datepicker$DatePicker$Date$yearRange = F2(
	function (_v0, range) {
		var currentMonth = _v0.gg;
		var today = _v0.bK;
		switch (range.$) {
			case 1:
				var num = range.a;
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(currentMonth) - num,
					$justinmimbs$date$Date$year(currentMonth) + num);
			case 2:
				var start = range.a;
				var end = range.b;
				return A2($elm$core$List$range, start, end);
			case 3:
				var year_ = range.a;
				return A2(
					$elm$core$List$range,
					year_,
					$justinmimbs$date$Date$year(today));
			case 4:
				var year_ = range.a;
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(today),
					year_);
			default:
				return _List_Nil;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$yearRangeActive = function (yearRange) {
	return !_Utils_eq(yearRange, $CurrySoftware$elm_datepicker$DatePicker$Date$Off);
};
var $CurrySoftware$elm_datepicker$DatePicker$datePicker = F3(
	function (pickedDate, settings, model) {
		var focused = model.af;
		var today = model.bK;
		var picked = function (d) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (pdate) {
						return _Utils_eq(
							$justinmimbs$date$Date$toRataDie(pdate),
							$justinmimbs$date$Date$toRataDie(d));
					},
					pickedDate));
		};
		var onChange = function (handler) {
			return A2(
				$elm$html$Html$Events$on,
				'change',
				A2($elm$json$Json$Decode$map, handler, $elm$html$Html$Events$targetValue));
		};
		var isToday = function (d) {
			return _Utils_eq(
				$justinmimbs$date$Date$toRataDie(d),
				$justinmimbs$date$Date$toRataDie(today));
		};
		var firstDayOffset = $justinmimbs$date$Date$weekdayToNumber(settings.e5) - 1;
		var dpClass = $CurrySoftware$elm_datepicker$DatePicker$mkClass(settings);
		var currentDate = A2(
			$elm$core$Maybe$withDefault,
			today,
			A2($CurrySoftware$elm_datepicker$DatePicker$maybeOr, pickedDate, focused));
		var isOtherMonth = function (d) {
			return !_Utils_eq(
				$justinmimbs$date$Date$month(currentDate),
				$justinmimbs$date$Date$month(d));
		};
		var arrow = F2(
			function (className, message) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							dpClass(className),
							$elm$html$Html$Events$onClick(message),
							$elm$html$Html$Attributes$tabindex(-1),
							$elm$html$Html$Attributes$type_('button')
						]),
					_List_Nil);
			});
		var _v0 = A2($CurrySoftware$elm_datepicker$DatePicker$prepareDates, currentDate, settings.e5);
		var currentMonth = _v0.gg;
		var currentDates = _v0.iy;
		var dayList = A2(
			$elm$core$List$map,
			function (rowDays) {
				return A2(
					$elm$html$Html$tr,
					_List_fromArray(
						[
							dpClass('row')
						]),
					A2(
						$elm$core$List$map,
						A4($CurrySoftware$elm_datepicker$DatePicker$viewDay, settings, picked, isOtherMonth, isToday),
						rowDays));
			},
			$CurrySoftware$elm_datepicker$DatePicker$groupDates(currentDates));
		var isCurrentYear = function (selectedYear) {
			return _Utils_eq(
				$justinmimbs$date$Date$year(currentMonth),
				selectedYear);
		};
		var yearOption = F2(
			function (index, selectedYear) {
				return _Utils_Tuple2(
					$elm$core$String$fromInt(index),
					A2(
						$elm$html$Html$option,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$value(
								$elm$core$String$fromInt(selectedYear)),
								$elm$html$Html$Attributes$selected(
								isCurrentYear(selectedYear))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(selectedYear))
							])));
			});
		var _v1 = function () {
			var front = function (to_) {
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(currentMonth),
					to_);
			};
			var back = function (from_) {
				return A2(
					$elm$core$List$range,
					from_,
					$justinmimbs$date$Date$year(currentMonth));
			};
			var _v2 = settings.dQ;
			switch (_v2.$) {
				case 3:
					var from_ = _v2.a;
					return _Utils_Tuple2(
						front(from_ - 1),
						back(
							$justinmimbs$date$Date$year(today) + 1));
				case 4:
					var to_ = _v2.a;
					return _Utils_Tuple2(
						front(
							$justinmimbs$date$Date$year(today) - 1),
						back(to_ + 1));
				case 2:
					var from_ = _v2.a;
					var to_ = _v2.b;
					return _Utils_Tuple2(
						front(from_ - 1),
						back(to_ + 1));
				case 1:
					var y = _v2.a;
					return _Utils_Tuple2(_List_Nil, _List_Nil);
				default:
					return _Utils_Tuple2(_List_Nil, _List_Nil);
			}
		}();
		var addedYearsFront = _v1.a;
		var addedYearsBack = _v1.b;
		var dropdownYear = A3(
			$elm$html$Html$Keyed$node,
			'select',
			_List_fromArray(
				[
					onChange(
					A2(
						$elm$core$Basics$composeR,
						$CurrySoftware$elm_datepicker$DatePicker$Date$changeYear(currentDate),
						$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus)),
					dpClass('year-menu')
				]),
			A2(
				$elm$core$List$indexedMap,
				yearOption,
				$elm$core$List$concat(
					_List_fromArray(
						[
							addedYearsFront,
							A2(
							$CurrySoftware$elm_datepicker$DatePicker$Date$yearRange,
							{gg: currentMonth, bK: today},
							settings.dQ),
							addedYearsBack
						]))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					dpClass('picker'),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'mousedown',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($CurrySoftware$elm_datepicker$DatePicker$MouseDown, true))),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'mouseup',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($CurrySoftware$elm_datepicker$DatePicker$MouseUp, true)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							dpClass('picker-header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('prev-container')
								]),
							_List_fromArray(
								[
									A2(
									arrow,
									'prev',
									$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus(
										A3($justinmimbs$date$Date$add, 1, -1, currentDate)))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('month-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											dpClass('month')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											settings.g6(
												$justinmimbs$date$Date$month(currentMonth)))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											dpClass('year')
										]),
									_List_fromArray(
										[
											(!$CurrySoftware$elm_datepicker$DatePicker$yearRangeActive(settings.dQ)) ? $elm$html$Html$text(
											settings.h2(
												$justinmimbs$date$Date$year(currentMonth))) : A3(
											$elm$html$Html$Keyed$node,
											'span',
											_List_Nil,
											_List_fromArray(
												[
													_Utils_Tuple2(
													$elm$core$String$fromInt(
														$justinmimbs$date$Date$year(currentMonth)),
													dropdownYear)
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('next-container')
								]),
							_List_fromArray(
								[
									A2(
									arrow,
									'next',
									$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus(
										A3($justinmimbs$date$Date$add, 1, 1, currentDate)))
								]))
						])),
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							dpClass('table')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_fromArray(
								[
									dpClass('weekdays')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (d) {
											return A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														dpClass('dow')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														settings.gi(d))
													]));
										},
										A2(
											$elm$core$List$take,
											7,
											A2(
												$elm$core$List$drop,
												firstDayOffset,
												$elm$core$List$concat(
													A2(
														$elm$core$List$repeat,
														2,
														_List_fromArray(
															[0, 1, 2, 3, 4, 5, 6])))))))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_fromArray(
								[
									dpClass('days')
								]),
							dayList)
						]))
				]));
	});
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onFocus = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $CurrySoftware$elm_datepicker$DatePicker$view = F3(
	function (pickedDate, settings, _v0) {
		var datepicker = _v0;
		var model = datepicker;
		var potentialInputId = A3(
			$elm$core$Basics$composeR,
			$elm$core$List$singleton,
			$elm$core$List$filterMap($elm$core$Basics$identity),
			A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, settings.gQ));
		var inputClasses = _Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(settings.cM + 'input', true)
				]),
			settings.gP);
		var inputCommon = function (xs) {
			return A2(
				$elm$html$Html$input,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(inputClasses),
							$elm$html$Html$Attributes$name(
							A2($elm$core$Maybe$withDefault, '', settings.gR)),
							$elm$html$Html$Attributes$type_('text'),
							A2(
							$elm$html$Html$Events$on,
							'change',
							$elm$json$Json$Decode$succeed($CurrySoftware$elm_datepicker$DatePicker$SubmitText)),
							$elm$html$Html$Events$onInput($CurrySoftware$elm_datepicker$DatePicker$Text),
							$elm$html$Html$Events$onBlur($CurrySoftware$elm_datepicker$DatePicker$Blur),
							$elm$html$Html$Events$onClick($CurrySoftware$elm_datepicker$DatePicker$Focus),
							$elm$html$Html$Events$onFocus($CurrySoftware$elm_datepicker$DatePicker$Focus)
						]),
					_Utils_ap(
						settings.gO,
						_Utils_ap(potentialInputId, xs))),
				_List_Nil);
		};
		var dateInput = inputCommon(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$placeholder(settings.ht),
					$elm$html$Html$Attributes$value(
					A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, settings.gh, pickedDate)),
						model.aG))
				]));
		var containerClassList = A2(
			$elm$core$List$cons,
			_Utils_Tuple2(settings.cM + 'container', true),
			settings.gf);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(containerClassList)
				]),
			_List_fromArray(
				[
					dateInput,
					model.a6 ? A3($CurrySoftware$elm_datepicker$DatePicker$datePicker, pickedDate, settings, model) : $elm$html$Html$text('')
				]));
	});
var $author$project$Reusable$DatePicker$view = function (model) {
	var value = function () {
		var _v0 = model.a0;
		if (_v0.$ === 1) {
			return 'Click to select';
		} else {
			var date = _v0.a;
			return A2($justinmimbs$date$Date$format, 'EE, MMM d y', date);
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('picker-value-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('picker-label')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Date')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$Reusable$DatePicker$OpenPicker),
						A2($elm$html$Html$Attributes$style, 'display', 'flex'),
						A2($elm$html$Html$Attributes$style, 'justify-content', 'space-between'),
						$elm$html$Html$Attributes$class('picker-value')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(value),
						A2($aforemny$material_components_web_elm$Material$Icon$icon, _List_Nil, 'arrow_drop_down')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('picker-underline')
					]),
				_List_Nil),
				A2(
				$aforemny$material_components_web_elm$Material$Dialog$dialog,
				A2(
					$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
					$author$project$Reusable$DatePicker$ClosePicker,
					A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.c8, $aforemny$material_components_web_elm$Material$Dialog$config)),
				{
					kk: _List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'background-color', $author$project$Reusable$DatePicker$color),
									A2($elm$html$Html$Attributes$style, 'color', 'white'),
									A2($elm$html$Html$Attributes$style, 'border', 'none'),
									A2($elm$html$Html$Attributes$style, 'padding', '8px 16px'),
									A2($elm$html$Html$Attributes$style, 'font-family', 'Roboto, sans-serif'),
									A2($elm$html$Html$Attributes$style, 'font-size', '14px'),
									A2($elm$html$Html$Attributes$style, 'font-weight', '500'),
									A2($elm$html$Html$Attributes$style, 'letter-spacing', '0.5px'),
									A2($elm$html$Html$Attributes$style, 'text-transform', 'uppercase'),
									A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
									A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
									A2($elm$html$Html$Attributes$style, 'box-shadow', '0 2px 4px rgba(0,0,0,0.24)'),
									$elm$html$Html$Events$onClick($author$project$Reusable$DatePicker$ClosePicker)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('OK')
								]))
						]),
					k_: _List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Reusable$DatePicker$DatePickerMsg,
							A3($CurrySoftware$elm_datepicker$DatePicker$view, model.a0, $CurrySoftware$elm_datepicker$DatePicker$defaultSettings, model.a1))
						]),
					na: $elm$core$Maybe$Just('Select Date')
				})
			]));
};
var $author$project$Pages$CfgDevice$Design$viewGatherData = F2(
	function (config, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
					A2($elm$html$Html$Attributes$style, 'width', 'inherit'),
					A2($elm$html$Html$Attributes$style, 'height', '70vh')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'block'),
							A2($elm$html$Html$Attributes$style, 'width', '100%'),
							A2($elm$html$Html$Attributes$style, 'max-width', '300px')
						]),
					_List_fromArray(
						[
							A5(
							$author$project$Select$view,
							$author$project$Pages$CfgDevice$Design$Select,
							_List_fromArray(
								[1289]),
							model.r,
							{
								dS: F2(
									function (a, b) {
										return _Utils_eq(a.g8, b.g8);
									}),
								d8: function ($) {
									return $.g8;
								},
								ep: function ($) {
									return $.g8;
								}
							},
							_List_fromArray(
								[
									$author$project$Select$label('Select Schedule'),
									$author$project$Select$options(config.mo),
									$author$project$Select$value(model.bb),
									$author$project$Select$onSelect($author$project$Pages$CfgDevice$Design$SelectSchedule)
								])),
							A2(
							$elm$html$Html$map,
							$author$project$Pages$CfgDevice$Design$SelectDate,
							$author$project$Reusable$DatePicker$view(model.a9)),
							function () {
							var onClick = A2($author$project$Pages$CfgDevice$Design$LoadData, config.an, config.iB);
							var isDisabled = _Utils_eq(model.bb, $elm$core$Maybe$Nothing) || $author$project$Reusable$DatePicker$isEmpty(model.a9);
							var attrs = _List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'width', '100%'),
									A2($elm$html$Html$Attributes$style, 'margin-top', '12px')
								]);
							return A2(
								$aforemny$material_components_web_elm$Material$Button$outlined,
								A2(
									$aforemny$material_components_web_elm$Material$Button$setDisabled,
									isDisabled,
									A2(
										$aforemny$material_components_web_elm$Material$Button$setAttributes,
										attrs,
										A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config))),
								'Load Data');
						}()
						]))
				]));
	});
var $author$project$Template$Viewport$Widescreen = function (a) {
	return {$: 2, a: a};
};
var $author$project$Template$Frame$isSameSize = function (frame) {
	return 1 === $elm$core$List$length(
		$elm_community$list_extra$List$Extra$unique(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.ae;
				},
				frame.da)));
};
var $mdgriffith$elm_style_animation$Animation$Render$iePrefix = '-ms-';
var $mdgriffith$elm_style_animation$Animation$Render$webkitPrefix = '-webkit-';
var $mdgriffith$elm_style_animation$Animation$Render$prefix = function (stylePair) {
	var propValue = stylePair.b;
	var propName = stylePair.a;
	switch (propName) {
		case 'transform':
			return _List_fromArray(
				[
					stylePair,
					_Utils_Tuple2(
					_Utils_ap($mdgriffith$elm_style_animation$Animation$Render$iePrefix, propName),
					propValue),
					_Utils_Tuple2(
					_Utils_ap($mdgriffith$elm_style_animation$Animation$Render$webkitPrefix, propName),
					propValue)
				]);
		case 'transform-origin':
			return _List_fromArray(
				[
					stylePair,
					_Utils_Tuple2(
					_Utils_ap($mdgriffith$elm_style_animation$Animation$Render$iePrefix, propName),
					propValue),
					_Utils_Tuple2(
					_Utils_ap($mdgriffith$elm_style_animation$Animation$Render$webkitPrefix, propName),
					propValue)
				]);
		case 'filter':
			return _List_fromArray(
				[
					stylePair,
					_Utils_Tuple2(
					_Utils_ap($mdgriffith$elm_style_animation$Animation$Render$iePrefix, propName),
					propValue),
					_Utils_Tuple2(
					_Utils_ap($mdgriffith$elm_style_animation$Animation$Render$webkitPrefix, propName),
					propValue)
				]);
		default:
			return _List_fromArray(
				[stylePair]);
	}
};
var $elm$svg$Svg$Attributes$offset = _VirtualDom_attribute('offset');
var $elm$svg$Svg$Attributes$points = _VirtualDom_attribute('points');
var $elm$core$Basics$cos = _Basics_cos;
var $elm$core$Basics$degrees = function (angleInDegrees) {
	return (angleInDegrees * $elm$core$Basics$pi) / 180;
};
var $elm$core$Basics$sin = _Basics_sin;
var $mdgriffith$elm_style_animation$Animation$Render$pathCmdValue = function (cmd) {
	var renderPoints = function (coords) {
		return A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				function (_v11) {
					var x = _v11.a;
					var y = _v11.b;
					return $elm$core$String$fromFloat(x.x) + (',' + $elm$core$String$fromFloat(y.x));
				},
				coords));
	};
	switch (cmd.$) {
		case 0:
			var x = cmd.a;
			var y = cmd.b;
			return 'm ' + ($elm$core$String$fromFloat(x.x) + (',' + $elm$core$String$fromFloat(y.x)));
		case 1:
			var x = cmd.a;
			var y = cmd.b;
			return 'M ' + ($elm$core$String$fromFloat(x.x) + (',' + $elm$core$String$fromFloat(y.x)));
		case 2:
			var x = cmd.a;
			var y = cmd.b;
			return 'l ' + ($elm$core$String$fromFloat(x.x) + (',' + $elm$core$String$fromFloat(y.x)));
		case 3:
			var x = cmd.a;
			var y = cmd.b;
			return 'L ' + ($elm$core$String$fromFloat(x.x) + (',' + $elm$core$String$fromFloat(y.x)));
		case 4:
			var a = cmd.a;
			return 'h ' + $elm$core$String$fromFloat(a.x);
		case 5:
			var a = cmd.a;
			return 'H ' + $elm$core$String$fromFloat(a.x);
		case 6:
			var a = cmd.a;
			return 'v ' + $elm$core$String$fromFloat(a.x);
		case 7:
			var a = cmd.a;
			return 'V ' + $elm$core$String$fromFloat(a.x);
		case 8:
			var control1 = cmd.a.dW;
			var control2 = cmd.a.dX;
			var point = cmd.a.aO;
			var _v1 = point;
			var p1x = _v1.a;
			var p1y = _v1.b;
			var _v2 = control2;
			var c2x = _v2.a;
			var c2y = _v2.b;
			var _v3 = control1;
			var c1x = _v3.a;
			var c1y = _v3.b;
			return 'c ' + ($elm$core$String$fromFloat(c1x.x) + (' ' + ($elm$core$String$fromFloat(c1y.x) + (', ' + ($elm$core$String$fromFloat(c2x.x) + (' ' + ($elm$core$String$fromFloat(c2y.x) + (', ' + ($elm$core$String$fromFloat(p1x.x) + (' ' + $elm$core$String$fromFloat(p1y.x)))))))))));
		case 9:
			var control1 = cmd.a.dW;
			var control2 = cmd.a.dX;
			var point = cmd.a.aO;
			var _v4 = point;
			var p1x = _v4.a;
			var p1y = _v4.b;
			var _v5 = control2;
			var c2x = _v5.a;
			var c2y = _v5.b;
			var _v6 = control1;
			var c1x = _v6.a;
			var c1y = _v6.b;
			return 'C ' + ($elm$core$String$fromFloat(c1x.x) + (' ' + ($elm$core$String$fromFloat(c1y.x) + (', ' + ($elm$core$String$fromFloat(c2x.x) + (' ' + ($elm$core$String$fromFloat(c2y.x) + (', ' + ($elm$core$String$fromFloat(p1x.x) + (' ' + $elm$core$String$fromFloat(p1y.x)))))))))));
		case 10:
			var control = cmd.a.dV;
			var point = cmd.a.aO;
			var _v7 = point;
			var p1x = _v7.a;
			var p1y = _v7.b;
			var _v8 = control;
			var c1x = _v8.a;
			var c1y = _v8.b;
			return 'q ' + ($elm$core$String$fromFloat(c1x.x) + (' ' + ($elm$core$String$fromFloat(c1y.x) + (', ' + ($elm$core$String$fromFloat(p1x.x) + (' ' + $elm$core$String$fromFloat(p1y.x)))))));
		case 11:
			var control = cmd.a.dV;
			var point = cmd.a.aO;
			var _v9 = point;
			var p1x = _v9.a;
			var p1y = _v9.b;
			var _v10 = control;
			var c1x = _v10.a;
			var c1y = _v10.b;
			return 'Q ' + ($elm$core$String$fromFloat(c1x.x) + (' ' + ($elm$core$String$fromFloat(c1y.x) + (', ' + ($elm$core$String$fromFloat(p1x.x) + (' ' + $elm$core$String$fromFloat(p1y.x)))))));
		case 12:
			var points = cmd.a;
			return 't ' + renderPoints(points);
		case 13:
			var points = cmd.a;
			return 'T ' + renderPoints(points);
		case 14:
			var points = cmd.a;
			return 's ' + renderPoints(points);
		case 15:
			var points = cmd.a;
			return 'S ' + renderPoints(points);
		case 16:
			var arc = cmd.a;
			var deltaAngle = arc.d3.x - arc.ex.x;
			if (_Utils_cmp(deltaAngle, 360 - 1.0e-6) > 0) {
				var dy = arc.et.x * $elm$core$Basics$sin(
					$elm$core$Basics$degrees(arc.ex.x));
				var dx = arc.et.x * $elm$core$Basics$cos(
					$elm$core$Basics$degrees(arc.ex.x));
				return 'A ' + ($elm$core$String$fromFloat(arc.et.x) + (',' + ($elm$core$String$fromFloat(arc.et.x) + (',0,1,1,' + ($elm$core$String$fromFloat(arc.kg.x - dx) + (',' + ($elm$core$String$fromFloat(arc.kh.x - dy) + (' A ' + ($elm$core$String$fromFloat(arc.et.x) + (',' + ($elm$core$String$fromFloat(arc.et.x) + (',0,1,1,' + ($elm$core$String$fromFloat(arc.kg.x + dx) + (',' + $elm$core$String$fromFloat(arc.kh.x + dy)))))))))))))));
			} else {
				return 'A ' + ($elm$core$String$fromFloat(arc.et.x) + (',' + ($elm$core$String$fromFloat(arc.et.x) + (' 0 ' + (((deltaAngle >= 180) ? '1' : '0') + (' ' + ('1' + (' ' + ($elm$core$String$fromFloat(
					arc.kg.x + (arc.et.x * $elm$core$Basics$cos(
						$elm$core$Basics$degrees(arc.d3.x)))) + (',' + $elm$core$String$fromFloat(
					arc.kh.x + (arc.et.x * $elm$core$Basics$sin(
						$elm$core$Basics$degrees(arc.d3.x))))))))))))));
			}
		case 17:
			var arc = cmd.a;
			var deltaAngle = arc.d3.x - arc.ex.x;
			if (_Utils_cmp(deltaAngle, 360 - 1.0e-6) > 0) {
				var dy = arc.et.x * $elm$core$Basics$sin(
					$elm$core$Basics$degrees(arc.ex.x));
				var dx = arc.et.x * $elm$core$Basics$cos(
					$elm$core$Basics$degrees(arc.ex.x));
				return 'A ' + ($elm$core$String$fromFloat(arc.et.x) + (',' + ($elm$core$String$fromFloat(arc.et.x) + (',0,1,0,' + ($elm$core$String$fromFloat(arc.kg.x - dx) + (',' + ($elm$core$String$fromFloat(arc.kh.x - dy) + (' A ' + ($elm$core$String$fromFloat(arc.et.x) + (',' + ($elm$core$String$fromFloat(arc.et.x) + (',0,1,1,' + ($elm$core$String$fromFloat(arc.kg.x + dx) + (',' + $elm$core$String$fromFloat(arc.kh.x + dy)))))))))))))));
			} else {
				return 'A ' + ($elm$core$String$fromFloat(arc.et.x) + (',' + ($elm$core$String$fromFloat(arc.et.x) + (' 0 ' + ((((arc.ex.x - arc.d3.x) >= 180) ? '1' : '0') + (' ' + ('0' + (' ' + ($elm$core$String$fromFloat(
					arc.kg.x + (arc.et.x * $elm$core$Basics$cos(arc.d3.x))) + (',' + $elm$core$String$fromFloat(
					arc.kh.x + (arc.et.x * $elm$core$Basics$sin(arc.d3.x)))))))))))));
			}
		default:
			return 'z';
	}
};
var $mdgriffith$elm_style_animation$Animation$Render$propertyValue = F2(
	function (prop, delim) {
		switch (prop.$) {
			case 0:
				var value = prop.b;
				return value;
			case 1:
				var r = prop.b;
				var g = prop.c;
				var b = prop.d;
				var a = prop.e;
				return 'rgba(' + ($elm$core$String$fromInt(
					$elm$core$Basics$round(r.x)) + (',' + ($elm$core$String$fromInt(
					$elm$core$Basics$round(g.x)) + (',' + ($elm$core$String$fromInt(
					$elm$core$Basics$round(b.x)) + (',' + ($elm$core$String$fromFloat(a.x) + ')')))))));
			case 2:
				var name = prop.a;
				var inset = prop.b;
				var shadow = prop.c;
				return (inset ? 'inset ' : '') + ($elm$core$String$fromFloat(shadow.aL.x) + ('px' + (' ' + ($elm$core$String$fromFloat(shadow.aM.x) + ('px' + (' ' + ($elm$core$String$fromFloat(shadow.az.x) + ('px' + (' ' + ((((name === 'text-shadow') || (name === 'drop-shadow')) ? '' : ($elm$core$String$fromFloat(shadow.dB.x) + ('px' + ' '))) + ('rgba(' + ($elm$core$String$fromInt(
					$elm$core$Basics$round(shadow.hz.x)) + (', ' + ($elm$core$String$fromInt(
					$elm$core$Basics$round(shadow.gF.x)) + (', ' + ($elm$core$String$fromInt(
					$elm$core$Basics$round(shadow.f8.x)) + (', ' + ($elm$core$String$fromFloat(shadow.f3.x) + ')'))))))))))))))))));
			case 3:
				var x = prop.b;
				return _Utils_ap(
					$elm$core$String$fromFloat(x.x),
					x.ng);
			case 4:
				var x = prop.b;
				var y = prop.c;
				return _Utils_ap(
					$elm$core$String$fromFloat(x.x),
					_Utils_ap(
						x.ng,
						_Utils_ap(
							delim,
							_Utils_ap(
								$elm$core$String$fromFloat(y.x),
								y.ng))));
			case 5:
				var x = prop.b;
				var y = prop.c;
				var z = prop.d;
				return _Utils_ap(
					$elm$core$String$fromFloat(x.x),
					_Utils_ap(
						x.ng,
						_Utils_ap(
							delim,
							_Utils_ap(
								$elm$core$String$fromFloat(y.x),
								_Utils_ap(
									y.ng,
									_Utils_ap(
										delim,
										_Utils_ap(
											$elm$core$String$fromFloat(z.x),
											z.ng)))))));
			case 6:
				var w = prop.b;
				var x = prop.c;
				var y = prop.d;
				var z = prop.e;
				return _Utils_ap(
					$elm$core$String$fromFloat(w.x),
					_Utils_ap(
						w.ng,
						_Utils_ap(
							delim,
							_Utils_ap(
								$elm$core$String$fromFloat(x.x),
								_Utils_ap(
									x.ng,
									_Utils_ap(
										delim,
										_Utils_ap(
											$elm$core$String$fromFloat(y.x),
											_Utils_ap(
												y.ng,
												_Utils_ap(
													delim,
													_Utils_ap(
														$elm$core$String$fromFloat(z.x),
														z.ng))))))))));
			case 7:
				var x = prop.b;
				return _Utils_ap(
					$elm$core$String$fromFloat(x.x),
					x.ng);
			case 8:
				var coords = prop.a;
				return A2(
					$elm$core$String$join,
					' ',
					A2(
						$elm$core$List$map,
						function (_v1) {
							var x = _v1.a;
							var y = _v1.b;
							return $elm$core$String$fromFloat(x.x) + (',' + $elm$core$String$fromFloat(y.x));
						},
						coords));
			default:
				var cmds = prop.a;
				return A2(
					$elm$core$String$join,
					' ',
					A2($elm$core$List$map, $mdgriffith$elm_style_animation$Animation$Render$pathCmdValue, cmds));
		}
	});
var $elm$svg$Svg$Attributes$rx = _VirtualDom_attribute('rx');
var $elm$svg$Svg$Attributes$ry = _VirtualDom_attribute('ry');
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $mdgriffith$elm_style_animation$Animation$Render$renderAttrs = function (prop) {
	if (A2(
		$elm$core$String$startsWith,
		'attr:',
		$mdgriffith$elm_style_animation$Animation$Model$propertyName(prop))) {
		return $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$Attributes$attribute,
				A2(
					$elm$core$String$dropLeft,
					5,
					$mdgriffith$elm_style_animation$Animation$Model$propertyName(prop)),
				A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' ')));
	} else {
		switch (prop.$) {
			case 8:
				var pts = prop.a;
				return $elm$core$Maybe$Just(
					$elm$svg$Svg$Attributes$points(
						A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' ')));
			case 9:
				var cmds = prop.a;
				return $elm$core$Maybe$Just(
					$elm$svg$Svg$Attributes$d(
						A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' ')));
			case 3:
				var name = prop.a;
				var m1 = prop.b;
				switch (name) {
					case 'x':
						return $elm$core$Maybe$Just(
							$elm$svg$Svg$Attributes$x(
								A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' ')));
					case 'y':
						return $elm$core$Maybe$Just(
							$elm$svg$Svg$Attributes$y(
								A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' ')));
					case 'cx':
						return $elm$core$Maybe$Just(
							$elm$svg$Svg$Attributes$cx(
								A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' ')));
					case 'cy':
						return $elm$core$Maybe$Just(
							$elm$svg$Svg$Attributes$cy(
								A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' ')));
					case 'rx':
						return $elm$core$Maybe$Just(
							$elm$svg$Svg$Attributes$rx(
								A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' ')));
					case 'ry':
						return $elm$core$Maybe$Just(
							$elm$svg$Svg$Attributes$ry(
								A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' ')));
					case 'r':
						return $elm$core$Maybe$Just(
							$elm$svg$Svg$Attributes$r(
								A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' ')));
					case 'offset':
						return $elm$core$Maybe$Just(
							$elm$svg$Svg$Attributes$offset(
								A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' ')));
					default:
						return $elm$core$Maybe$Nothing;
				}
			case 6:
				var name = prop.a;
				var m1 = prop.b;
				var m2 = prop.c;
				var m3 = prop.d;
				var m4 = prop.e;
				return (name === 'viewBox') ? $elm$core$Maybe$Just(
					$elm$svg$Svg$Attributes$viewBox(
						A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' '))) : $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	}
};
var $mdgriffith$elm_style_animation$Animation$Render$isAttr = function (prop) {
	return A2(
		$elm$core$String$startsWith,
		'attr:',
		$mdgriffith$elm_style_animation$Animation$Model$propertyName(prop)) || function () {
		switch (prop.$) {
			case 8:
				return true;
			case 9:
				return true;
			case 3:
				var name = prop.a;
				return (name === 'cx') || ((name === 'cy') || ((name === 'x') || ((name === 'y') || ((name === 'rx') || ((name === 'ry') || ((name === 'r') || (name === 'offset')))))));
			case 6:
				var name = prop.a;
				return name === 'viewBox';
			default:
				return false;
		}
	}();
};
var $mdgriffith$elm_style_animation$Animation$Render$isFilter = function (prop) {
	return A2(
		$elm$core$List$member,
		$mdgriffith$elm_style_animation$Animation$Model$propertyName(prop),
		_List_fromArray(
			['filter-url', 'blur', 'brightness', 'contrast', 'grayscale', 'hue-rotate', 'invert', 'saturate', 'sepia', 'drop-shadow']));
};
var $mdgriffith$elm_style_animation$Animation$Render$render3dRotation = function (prop) {
	if (prop.$ === 5) {
		var x = prop.b;
		var y = prop.c;
		var z = prop.d;
		return 'rotateX(' + ($elm$core$String$fromFloat(x.x) + (x.ng + (') rotateY(' + ($elm$core$String$fromFloat(y.x) + (y.ng + (') rotateZ(' + ($elm$core$String$fromFloat(z.x) + (z.ng + ')'))))))));
	} else {
		return '';
	}
};
var $mdgriffith$elm_style_animation$Animation$Render$renderValues = function (_v0) {
	var model = _v0;
	var _v1 = A2($elm$core$List$partition, $mdgriffith$elm_style_animation$Animation$Render$isAttr, model.cs);
	var attrProps = _v1.a;
	var styleProps = _v1.b;
	var _v2 = A3(
		$elm$core$List$foldl,
		F2(
			function (prop, _v3) {
				var myStyle = _v3.a;
				var myTransforms = _v3.b;
				var myFilters = _v3.c;
				return $mdgriffith$elm_style_animation$Animation$Render$isTransformation(prop) ? _Utils_Tuple3(
					myStyle,
					_Utils_ap(
						myTransforms,
						_List_fromArray(
							[prop])),
					myFilters) : ($mdgriffith$elm_style_animation$Animation$Render$isFilter(prop) ? _Utils_Tuple3(
					myStyle,
					myTransforms,
					_Utils_ap(
						myFilters,
						_List_fromArray(
							[prop]))) : _Utils_Tuple3(
					_Utils_ap(
						myStyle,
						_List_fromArray(
							[prop])),
					myTransforms,
					myFilters));
			}),
		_Utils_Tuple3(_List_Nil, _List_Nil, _List_Nil),
		styleProps);
	var style = _v2.a;
	var transforms = _v2.b;
	var filters = _v2.c;
	var renderedFilters = $elm$core$List$isEmpty(filters) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(
			'filter',
			A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$map,
					function (prop) {
						var name = $mdgriffith$elm_style_animation$Animation$Model$propertyName(prop);
						return (name === 'filter-url') ? ('url(\"' + (A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ', ') + '\")')) : ($mdgriffith$elm_style_animation$Animation$Model$propertyName(prop) + ('(' + (A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ', ') + ')')));
					},
					filters)))
		]);
	var renderedStyle = A2(
		$elm$core$List$map,
		function (prop) {
			return _Utils_Tuple2(
				$mdgriffith$elm_style_animation$Animation$Model$propertyName(prop),
				A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' '));
		},
		style);
	var renderedTransforms = $elm$core$List$isEmpty(transforms) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(
			'transform',
			A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$map,
					function (prop) {
						return ($mdgriffith$elm_style_animation$Animation$Model$propertyName(prop) === 'rotate3d') ? $mdgriffith$elm_style_animation$Animation$Render$render3dRotation(prop) : ($mdgriffith$elm_style_animation$Animation$Model$propertyName(prop) + ('(' + (A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ', ') + ')')));
					},
					transforms)))
		]);
	return _Utils_Tuple2(
		_Utils_ap(
			renderedTransforms,
			_Utils_ap(renderedFilters, renderedStyle)),
		attrProps);
};
var $mdgriffith$elm_style_animation$Animation$Render$render = function (animation) {
	var _v0 = $mdgriffith$elm_style_animation$Animation$Render$renderValues(animation);
	var style = _v0.a;
	var attrProps = _v0.b;
	var otherAttrs = A2($elm$core$List$filterMap, $mdgriffith$elm_style_animation$Animation$Render$renderAttrs, attrProps);
	var styleAttr = A2(
		$elm$core$List$map,
		function (_v1) {
			var prop = _v1.a;
			var val = _v1.b;
			return A2($elm$html$Html$Attributes$style, prop, val);
		},
		A2($elm$core$List$concatMap, $mdgriffith$elm_style_animation$Animation$Render$prefix, style));
	return _Utils_ap(styleAttr, otherAttrs);
};
var $mdgriffith$elm_style_animation$Animation$render = $mdgriffith$elm_style_animation$Animation$Render$render;
var $author$project$Template$Widget$Background$viewBackgroundColor = F2(
	function (anim, color) {
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', '100%'),
						A2($elm$html$Html$Attributes$style, 'height', '100%'),
						A2($elm$html$Html$Attributes$style, 'background', color)
					]),
				$mdgriffith$elm_style_animation$Animation$render(anim)),
			_List_Nil);
	});
var $author$project$Template$Widget$Background$viewBackgroundImage = F4(
	function (anim, imgUrl, brightness, blur) {
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', '100%'),
						A2($elm$html$Html$Attributes$style, 'height', '100%'),
						A2($elm$html$Html$Attributes$style, 'background-size', 'cover'),
						A2($elm$html$Html$Attributes$style, 'background-image', 'url(\"' + (imgUrl + '\")')),
						A2(
						$elm$html$Html$Attributes$style,
						'filter',
						'blur(' + ($elm$core$String$fromFloat(blur) + ('px) brightness(' + ($elm$core$String$fromFloat(brightness) + '%)'))))
					]),
				$mdgriffith$elm_style_animation$Animation$render(anim)),
			_List_Nil);
	});
var $author$project$Template$Widget$Background$view = F3(
	function (viewport, anim, bgType) {
		switch (bgType.$) {
			case 0:
				var colorValue = bgType.a;
				return A2($author$project$Template$Widget$Background$viewBackgroundColor, anim, colorValue);
			case 1:
				var imgUrl = bgType.a;
				var brightness = bgType.b;
				var blur = bgType.c;
				return A4($author$project$Template$Widget$Background$viewBackgroundImage, anim, imgUrl, brightness, blur);
			default:
				var imgUrl = bgType.a;
				var localUrl = bgType.b;
				var brightness = bgType.c;
				var blur = bgType.d;
				if (viewport.$ === 2) {
					return A4($author$project$Template$Widget$Background$viewBackgroundImage, anim, imgUrl, brightness, blur);
				} else {
					return A4($author$project$Template$Widget$Background$viewBackgroundImage, anim, imgUrl, brightness, blur);
				}
		}
	});
var $author$project$Entity$Style$getAttr = F3(
	function (collection, attr, style) {
		if (!style.$) {
			var id = style.a;
			return A3(
				$elm$core$Basics$composeR,
				function ($) {
					return $.a$;
				},
				$elm$core$Dict$get(attr),
				A2(
					$elm$core$Maybe$withDefault,
					$author$project$Entity$Style$empty,
					A2($elm$core$Dict$get, id, collection)));
		} else {
			var css = style.a;
			return A3(
				$elm$core$Basics$composeR,
				function ($) {
					return $.a$;
				},
				$elm$core$Dict$get(attr),
				css);
		}
	});
var $author$project$Entity$Style$getCssValue = function (str) {
	var regex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('\\d+'));
	return A2(
		$elm$core$Maybe$andThen,
		$elm$core$String$toFloat,
		$elm$core$List$head(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.lU;
				},
				A3($elm$regex$Regex$findAtMost, 1, regex, str))));
};
var $author$project$Entity$Style$toList = F2(
	function (collection, style) {
		if (!style.$) {
			var id = style.a;
			return A2(
				$elm$core$List$map,
				function (_v1) {
					var a = _v1.a;
					var b = _v1.b;
					return A2($elm$html$Html$Attributes$style, a, b);
				},
				A3(
					$elm$core$Basics$composeR,
					function ($) {
						return $.a$;
					},
					$elm$core$Dict$toList,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Entity$Style$empty,
						A2($elm$core$Dict$get, id, collection))));
		} else {
			var css = style.a;
			return A2(
				$elm$core$List$map,
				function (_v2) {
					var a = _v2.a;
					var b = _v2.b;
					return A2($elm$html$Html$Attributes$style, a, b);
				},
				$elm$core$Dict$toList(css.a$));
		}
	});
var $author$project$Entity$Style$getIntf = function (sharedStyles) {
	return {
		e7: $author$project$Entity$Style$getAttr(sharedStyles),
		iO: F2(
			function (str, style) {
				return A2(
					$elm$core$Maybe$andThen,
					$author$project$Entity$Style$getCssValue,
					A3($author$project$Entity$Style$getAttr, sharedStyles, str, style));
			}),
		j0: $author$project$Entity$Style$toList(sharedStyles)
	};
};
var $rtfeldman$elm_css$Css$backgroundPosition = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'backgroundPosition',
		'background-position',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $author$project$Entity$Style$isVisible = F2(
	function (intf, style) {
		var _v0 = _Utils_Tuple2(
			A2(intf.e7, 'visibility', style),
			A2(intf.e7, 'display', style));
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var visibility = _v0.a.a;
				var display = _v0.b.a;
				return (visibility !== 'hidden') && (display !== 'none');
			} else {
				var visibility = _v0.a.a;
				var _v1 = _v0.b;
				return visibility !== 'hidden';
			}
		} else {
			if (!_v0.b.$) {
				var _v2 = _v0.a;
				var display = _v0.b.a;
				return display !== 'none';
			} else {
				return true;
			}
		}
	});
var $rtfeldman$elm_css$Css$noRepeat = {cI: 0, bh: 0, eL: 'no-repeat'};
var $rtfeldman$elm_css$Css$url = function (urlValue) {
	return {cH: 0, eL: 'url(' + (urlValue + ')')};
};
var $author$project$Template$Widget$Image$view = F3(
	function (config, intf, anims) {
		var anim = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$andThen,
					A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $mdgriffith$elm_style_animation$Animation$render),
					A2($elm_community$list_extra$List$Extra$getAt, 0, anims))));
		return $rtfeldman$elm_css$Html$Styled$toUnstyled(
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_Utils_ap(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$margin(
									$rtfeldman$elm_css$Css$px(12)),
									$rtfeldman$elm_css$Css$borderRadius(
									$rtfeldman$elm_css$Css$px(8)),
									$rtfeldman$elm_css$Css$zIndex(
									$rtfeldman$elm_css$Css$int(0)),
									$rtfeldman$elm_css$Css$backgroundImage(
									$rtfeldman$elm_css$Css$url('\"' + (config.ly + '\"'))),
									A2($rtfeldman$elm_css$Css$property, 'background-size', config.dB),
									$rtfeldman$elm_css$Css$backgroundRepeat($rtfeldman$elm_css$Css$noRepeat),
									$rtfeldman$elm_css$Css$backgroundPosition($rtfeldman$elm_css$Css$center),
									$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
									A2($author$project$Entity$Style$isVisible, intf, config.cs) ? $rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$initial) : $rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none),
									$rtfeldman$elm_css$Css$maxWidth(
									$rtfeldman$elm_css$Css$pct(100)),
									$rtfeldman$elm_css$Css$maxHeight(
									$rtfeldman$elm_css$Css$pct(100)),
									$rtfeldman$elm_css$Css$height(
									$rtfeldman$elm_css$Css$pct(
										A2(
											$elm$core$Maybe$withDefault,
											98,
											A2(intf.iO, 'height', config.cs)))),
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$pct(
										A2(
											$elm$core$Maybe$withDefault,
											98,
											A2(intf.iO, 'width', config.cs))))
								]))
						]),
					anim),
				_List_Nil));
	});
var $author$project$Template$Widget$MenuItemList$viewName = F3(
	function (config, intf, menuItem) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($author$project$Entity$Style$isVisible, intf, config.na) ? $rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$initial) : $rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none),
							$rtfeldman$elm_css$Css$lineHeight(
							$rtfeldman$elm_css$Css$em(1.3)),
							A2(
							$rtfeldman$elm_css$Css$property,
							'font-family',
							A2(
								$elm$core$Maybe$withDefault,
								'Economica',
								A2(intf.e7, 'font-family', config.k9))),
							$rtfeldman$elm_css$Css$fontSize(
							$rtfeldman$elm_css$Css$px(
								A2(
									$elm$core$Maybe$withDefault,
									32,
									A2(intf.iO, 'font-size', config.k9)))),
							A2(
							$rtfeldman$elm_css$Css$property,
							'color',
							A2(
								$elm$core$Maybe$withDefault,
								'white',
								A2(intf.e7, 'color', config.k9))),
							A2(
							$rtfeldman$elm_css$Css$property,
							'background',
							A2(
								$elm$core$Maybe$withDefault,
								'transparent',
								A2(intf.e7, 'background', config.k9)))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(menuItem.g8)
				]));
	});
var $rtfeldman$elm_css$Css$paddingRight = $rtfeldman$elm_css$Css$prop1('padding-right');
var $author$project$Template$Widget$MenuItemList$viewPricing = F3(
	function (config, intf, menuItem) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							A2(
							$rtfeldman$elm_css$Css$property,
							'font-family',
							A2(
								$elm$core$Maybe$withDefault,
								'Economica',
								A2(intf.e7, 'font-family', config.hw))),
							$rtfeldman$elm_css$Css$fontSize(
							$rtfeldman$elm_css$Css$px(
								A2(
									$elm$core$Maybe$withDefault,
									32,
									A2(intf.iO, 'font-size', config.hw)))),
							A2(
							$rtfeldman$elm_css$Css$property,
							'color',
							A2(
								$elm$core$Maybe$withDefault,
								'white',
								A2(intf.e7, 'color', config.hw))),
							A2(
							$rtfeldman$elm_css$Css$property,
							'background',
							A2(
								$elm$core$Maybe$withDefault,
								'transparent',
								A2(intf.e7, 'background', config.hw)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$paddingRight(
									$rtfeldman$elm_css$Css$px(12))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('$')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($myrho$elm_round$Round$round, 2, menuItem.ju))
						]))
				]));
	});
var $author$project$Template$Widget$MenuItemList$viewMenuItem = F3(
	function (config, intf, menuItem) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$borderRadius(
							$rtfeldman$elm_css$Css$px(8)),
							A2(
							$rtfeldman$elm_css$Css$property,
							'background',
							A2(
								$elm$core$Maybe$withDefault,
								'transparent',
								A2(intf.e7, 'background', config.k9)))
						]))
				]),
			_List_fromArray(
				[
					A3($author$project$Template$Widget$MenuItemList$viewName, config, intf, menuItem),
					A3($author$project$Template$Widget$MenuItemList$viewPricing, config, intf, menuItem)
				]));
	});
var $rtfeldman$elm_css$Css$ellipsis = {j_: 0, eL: 'ellipsis'};
var $rtfeldman$elm_css$Css$noWrap = {d9: 0, e6: 0, eL: 'nowrap', bM: 0};
var $rtfeldman$elm_css$Css$textOverflow = $rtfeldman$elm_css$Css$prop1('text-overflow');
var $rtfeldman$elm_css$Css$whiteSpace = $rtfeldman$elm_css$Css$prop1('white-space');
var $author$project$Template$Widget$MenuItemList$viewTitle = F3(
	function (config, intf, name) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($author$project$Entity$Style$isVisible, intf, config.na) ? $rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$initial) : $rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none),
							A2(
							$rtfeldman$elm_css$Css$property,
							'font-family',
							A2(
								$elm$core$Maybe$withDefault,
								'Economica',
								A2(intf.e7, 'font-family', config.na))),
							$rtfeldman$elm_css$Css$fontSize(
							$rtfeldman$elm_css$Css$px(
								A2(
									$elm$core$Maybe$withDefault,
									48,
									A2(intf.iO, 'font-size', config.na)))),
							A2(
							$rtfeldman$elm_css$Css$property,
							'color',
							A2(
								$elm$core$Maybe$withDefault,
								'white',
								A2(intf.e7, 'color', config.na))),
							A2(
							$rtfeldman$elm_css$Css$property,
							'background',
							A2(
								$elm$core$Maybe$withDefault,
								'transparent',
								A2(intf.e7, 'background', config.na))),
							$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
							$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
							$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$pct(100)),
							$rtfeldman$elm_css$Css$lineHeight(
							$rtfeldman$elm_css$Css$em(1.6)),
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(name)
				]));
	});
var $author$project$Template$Widget$MenuItemList$view = F4(
	function (config, intf, anims, data) {
		var anim = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$andThen,
					A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $mdgriffith$elm_style_animation$Animation$render),
					$elm$core$List$head(anims))));
		return $rtfeldman$elm_css$Html$Styled$toUnstyled(
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_Utils_ap(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$pct(90)),
									$rtfeldman$elm_css$Css$zIndex(
									$rtfeldman$elm_css$Css$int(0)),
									$rtfeldman$elm_css$Css$marginTop(
									$rtfeldman$elm_css$Css$px(16)),
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
									$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
								]))
						]),
					anim),
				function () {
					var _v0 = A2($elm$core$Dict$get, config.i7, data);
					if (!_v0.$) {
						var menuItemList = _v0.a;
						return _List_fromArray(
							[
								A3($author$project$Template$Widget$MenuItemList$viewTitle, config, intf, menuItemList.g8),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$displayFlex,
												$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
												$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
												$rtfeldman$elm_css$Css$width(
												$rtfeldman$elm_css$Css$pct(100))
											]))
									]),
								A2(
									$elm$core$List$map,
									A2($author$project$Template$Widget$MenuItemList$viewMenuItem, config, intf),
									A2(
										$elm$core$List$sortBy,
										function ($) {
											return $.g8;
										},
										$elm$core$Dict$values(menuItemList.lM))))
							]);
					} else {
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('')
							]);
					}
				}()));
	});
var $author$project$Template$Widget$MenuPlanning$horizontalLayoutStyle = F2(
	function (orientation, config) {
		var transformOriginValueFor05 = function () {
			var _v0 = _Utils_Tuple2(config.ej >= 2, orientation);
			if (!_v0.b) {
				if (_v0.a) {
					var _v1 = _v0.b;
					return 'left top';
				} else {
					return 'left center';
				}
			} else {
				var _v2 = _v0.b;
				return 'left top';
			}
		}();
		var transformOriginValueFor03 = (config.ej > 2) ? 'left top' : 'left center';
		return _Utils_ap(
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'flex-direction', 'row'),
					A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
					A2($elm$html$Html$Attributes$style, 'height', '100%')
				]),
			($elm$core$Basics$abs(config.hD - 0.5) < 0.001) ? _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'transform', 'scale(0.5)'),
					A2($elm$html$Html$Attributes$style, 'transform-origin', transformOriginValueFor05),
					A2($elm$html$Html$Attributes$style, 'width', '195%'),
					A2($elm$html$Html$Attributes$style, 'flex-wrap', 'wrap')
				]) : (($elm$core$Basics$abs(config.hD - 0.3) < 0.001) ? _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'transform', 'scale(0.3)'),
					A2($elm$html$Html$Attributes$style, 'transform-origin', transformOriginValueFor03),
					A2($elm$html$Html$Attributes$style, 'width', '330%'),
					A2($elm$html$Html$Attributes$style, 'flex-wrap', 'wrap')
				]) : _List_Nil));
	});
var $elm_community$maybe_extra$Maybe$Extra$cons = F2(
	function (item, list) {
		if (!item.$) {
			var v = item.a;
			return A2($elm$core$List$cons, v, list);
		} else {
			return list;
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$values = A2($elm$core$List$foldr, $elm_community$maybe_extra$Maybe$Extra$cons, _List_Nil);
var $author$project$Template$Widget$MenuPlanning$isEqual = F2(
	function (actual, expected) {
		return $elm$core$Basics$abs(actual - expected) < 0.001;
	});
var $author$project$Template$Widget$MenuPlanning$isHorizontal = function (value) {
	return !value;
};
var $author$project$Template$Widget$MenuPlanning$isVertical = function (value) {
	return value === 1;
};
var $author$project$Template$Widget$MenuPlanning$verticalLayoutStyle = F2(
	function (orientation, config) {
		return _Utils_ap(
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
					A2($elm$html$Html$Attributes$style, 'height', '100%')
				]),
			(A2($author$project$Template$Widget$MenuPlanning$isEqual, config.hD, 0.5) && $author$project$Template$Widget$MenuPlanning$isHorizontal(orientation)) ? _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'transform', 'scale(0.5)'),
					A2($elm$html$Html$Attributes$style, 'transform-origin', 'left top'),
					A2($elm$html$Html$Attributes$style, 'width', '200%')
				]) : ((A2($author$project$Template$Widget$MenuPlanning$isEqual, config.hD, 0.3) && $author$project$Template$Widget$MenuPlanning$isHorizontal(orientation)) ? _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'transform', 'scale(0.3)'),
					A2($elm$html$Html$Attributes$style, 'transform-origin', 'left top'),
					A2($elm$html$Html$Attributes$style, 'width', '330%')
				]) : ((A2($author$project$Template$Widget$MenuPlanning$isEqual, config.hD, 0.5) && $author$project$Template$Widget$MenuPlanning$isVertical(orientation)) ? _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'transform', 'scale(0.5)'),
					A2($elm$html$Html$Attributes$style, 'transform-origin', 'left top'),
					A2($elm$html$Html$Attributes$style, 'width', '200%'),
					A2($elm$html$Html$Attributes$style, 'min-height', '150%'),
					A2($elm$html$Html$Attributes$style, 'align-content', 'center'),
					A2($elm$html$Html$Attributes$style, 'flex-wrap', 'wrap')
				]) : ((A2($author$project$Template$Widget$MenuPlanning$isEqual, config.hD, 0.3) && $author$project$Template$Widget$MenuPlanning$isVertical(orientation)) ? _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'transform', 'scale(0.3)'),
					A2($elm$html$Html$Attributes$style, 'transform-origin', 'left top'),
					A2($elm$html$Html$Attributes$style, 'width', '330%'),
					A2($elm$html$Html$Attributes$style, 'min-height', '285%'),
					A2($elm$html$Html$Attributes$style, 'align-content', 'center'),
					A2($elm$html$Html$Attributes$style, 'flex-wrap', 'wrap')
				]) : ($author$project$Template$Widget$MenuPlanning$isVertical(orientation) ? _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'flex-wrap', 'wrap')
				]) : _List_Nil)))));
	});
var $author$project$Template$Widget$MenuPlanning$viewCategory = F3(
	function (config, styleIntf, anims) {
		var marginStyles = (A2($author$project$Entity$Style$isVisible, styleIntf, config.gY) && (!_Utils_eq(config.mz, $elm$core$Maybe$Nothing))) ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'margin', '0px 0px 0px 0px')
			]) : _List_Nil;
		var customStyles = styleIntf.j0(config.na);
		var baseStyles = _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'z-index', '0'),
				A2($elm$html$Html$Attributes$style, 'align-self', 'center'),
				A2($elm$html$Html$Attributes$style, 'text-align', 'center'),
				A2($elm$html$Html$Attributes$style, 'border-radius', '8px'),
				A2($elm$html$Html$Attributes$style, 'line-height', '1.2em'),
				A2($elm$html$Html$Attributes$style, 'padding', '12px 6px 0px 6px')
			]);
		var animationStyles = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$andThen,
				A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $mdgriffith$elm_style_animation$Animation$render),
				A2($elm_community$list_extra$List$Extra$getAt, 0, anims)));
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				baseStyles,
				_Utils_ap(marginStyles, customStyles)),
			_List_fromArray(
				[
					function () {
					var _v0 = config.ai;
					if (!_v0.$) {
						var marketingName = _v0.a;
						return $elm$html$Html$text(marketingName);
					} else {
						return $elm$html$Html$text(
							A2($elm$core$Maybe$withDefault, 'Select Category', config.iq));
					}
				}()
				]));
	});
var $author$project$Template$Widget$MenuPlanning$viewEmpty = function (anims) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
				A2($elm$html$Html$Attributes$style, 'width', '100%'),
				A2($elm$html$Html$Attributes$style, 'margin-top', '48px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_Utils_ap(
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '200px'),
							A2($elm$html$Html$Attributes$style, 'height', '1.4em'),
							A2($elm$html$Html$Attributes$style, 'padding', '24px'),
							A2($elm$html$Html$Attributes$style, 'font-family', 'Roboto'),
							A2($elm$html$Html$Attributes$style, 'font-size', '24px'),
							A2($elm$html$Html$Attributes$style, 'border-radius', '10px'),
							A2($elm$html$Html$Attributes$style, 'background', '#FFFFFF'),
							A2($elm$html$Html$Attributes$style, 'text-align', 'center')
						]),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$andThen,
							A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $mdgriffith$elm_style_animation$Animation$render),
							A2($elm_community$list_extra$List$Extra$getAt, 0, anims)))),
				_List_fromArray(
					[
						$elm$html$Html$text('Empty')
					]))
			]));
};
var $author$project$Template$Widget$MenuPlanning$viewLocation = F3(
	function (config, styleIntf, anims) {
		var customStyles = styleIntf.j0(config.gY);
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'line-height', '1.6em'),
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '4px'),
						A2($elm$html$Html$Attributes$style, 'font-size', '42px'),
						A2($elm$html$Html$Attributes$style, 'text-align', 'center'),
						A2($elm$html$Html$Attributes$style, 'font-weight', '400'),
						A2($elm$html$Html$Attributes$style, 'font-family', 'Fjalla One'),
						A2($elm$html$Html$Attributes$style, 'color', 'white'),
						A2($elm$html$Html$Attributes$style, 'align-self', 'center'),
						A2($elm$html$Html$Attributes$style, 'padding', '0px 8px')
					]),
				_Utils_ap(
					customStyles,
					_Utils_ap(
						_List_fromArray(
							[
								A2($author$project$Entity$Style$isVisible, styleIntf, config.gY) ? A2($elm$html$Html$Attributes$style, 'display', 'block') : A2($elm$html$Html$Attributes$style, 'display', 'none')
							]),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$andThen,
								A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $mdgriffith$elm_style_animation$Animation$render),
								A2($elm_community$list_extra$List$Extra$getAt, 0, anims)))))),
			_List_fromArray(
				[
					function () {
					var _v0 = config.mz;
					if (!_v0.$) {
						var srvLine = _v0.a;
						return $elm$html$Html$text('Location : ' + srvLine);
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$Template$Widget$MenuPlanning$viewBaseCalories = F3(
	function (config, styleIntf, item) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'text-align', 'center'),
					A2($elm$html$Html$Attributes$style, 'font-family', 'inherit'),
					A2(
					$elm$html$Html$Attributes$style,
					'color',
					A2(
						$elm$core$Maybe$withDefault,
						'black',
						A2(styleIntf.e7, 'color', config.kR))),
					A2(
					$elm$html$Html$Attributes$style,
					'background',
					A2(
						$elm$core$Maybe$withDefault,
						'transparent',
						A2(styleIntf.e7, 'background', config.kR))),
					A2($elm$html$Html$Attributes$style, 'border-radius', '8px')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'font-family', 'inherit'),
							A2($elm$html$Html$Attributes$style, 'font-weight', 'inherit')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromFloat(item.kR))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-left', '8px'),
							A2($elm$html$Html$Attributes$style, 'font-size', '55%'),
							A2($elm$html$Html$Attributes$style, 'font-weight', '400'),
							A2($elm$html$Html$Attributes$style, 'font-family', 'inherit')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('CAL')
						]))
				]));
	});
var $author$project$Template$Widget$MenuPlanning$viewOverlayCalories = F3(
	function (config, styleIntf, item) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
					A2($elm$html$Html$Attributes$style, 'top', '15px'),
					A2($elm$html$Html$Attributes$style, 'right', '15px'),
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
					A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
					A2($elm$html$Html$Attributes$style, 'padding', '12px'),
					A2($elm$html$Html$Attributes$style, 'min-width', '70px'),
					A2($elm$html$Html$Attributes$style, 'min-height', '70px'),
					A2($elm$html$Html$Attributes$style, 'border-radius', '50%'),
					A2(
					$elm$html$Html$Attributes$style,
					'color',
					A2(
						$elm$core$Maybe$withDefault,
						'white',
						A2(styleIntf.e7, 'color', config.kR))),
					A2(
					$elm$html$Html$Attributes$style,
					'background',
					A2(
						$elm$core$Maybe$withDefault,
						'rgba(0,0,0,0.7)',
						A2(styleIntf.e7, 'background', config.kR)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'font-family', 'inherit'),
							A2($elm$html$Html$Attributes$style, 'line-height', '1em')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromFloat(item.kR))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'font-size', '55%'),
							A2($elm$html$Html$Attributes$style, 'font-family', 'inherit')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('CAL')
						]))
				]));
	});
var $author$project$Template$Widget$MenuPlanning$viewSmallCalories = F3(
	function (config, styleIntf, item) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
					A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
					A2($elm$html$Html$Attributes$style, 'font-family', 'inherit')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'font-family', 'inherit'),
							A2($elm$html$Html$Attributes$style, 'line-height', '1.1em')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromFloat(item.kR))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'font-size', '55%'),
							A2($elm$html$Html$Attributes$style, 'font-family', 'inherit')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('CAL')
						]))
				]));
	});
var $author$project$Template$Widget$MenuPlanning$viewCalories = F3(
	function (config, styleIntf, item) {
		var customStyles = styleIntf.j0(config.kR);
		var baseStyles = _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'border-radius', '8px'),
				A2($elm$html$Html$Attributes$style, 'padding', '4px')
			]);
		return A2(
			$elm$html$Html$div,
			_Utils_ap(customStyles, baseStyles),
			_List_fromArray(
				[
					function () {
					var _v0 = config.ip;
					switch (_v0) {
						case 0:
							return A3($author$project$Template$Widget$MenuPlanning$viewOverlayCalories, config, styleIntf, item);
						case 2:
							return A3($author$project$Template$Widget$MenuPlanning$viewSmallCalories, config, styleIntf, item);
						default:
							return A3($author$project$Template$Widget$MenuPlanning$viewBaseCalories, config, styleIntf, item);
					}
				}()
				]));
	});
var $author$project$Entity$Style$textLineClamp = function (numLines) {
	return _List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'display', '-webkit-box'),
			A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
			A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis'),
			A2($elm$html$Html$Attributes$style, 'line-height', '1.3em'),
			A2($elm$html$Html$Attributes$style, '-webkit-box-align', 'center'),
			A2(
			$elm$html$Html$Attributes$style,
			'-webkit-line-clamp',
			$elm$core$String$fromFloat(numLines)),
			A2($elm$html$Html$Attributes$style, '-webkit-box-orient', 'vertical'),
			A2($elm$html$Html$Attributes$style, '-webkit-align-content', 'center'),
			A2(
			$elm$html$Html$Attributes$style,
			'height',
			$elm$core$String$fromFloat(numLines * 1.3) + 'em')
		]);
};
var $author$project$Template$Widget$MenuPlanning$viewBigImgDescription = F3(
	function (item, isImgVisible, customStyles) {
		var lineStyle = isImgVisible ? $author$project$Entity$Style$textLineClamp(4) : $author$project$Entity$Style$textLineClamp(2);
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', '95%'),
						A2($elm$html$Html$Attributes$style, 'text-align', 'center'),
						A2($elm$html$Html$Attributes$style, 'margin', '8px')
					]),
				_Utils_ap(lineStyle, customStyles)),
			_List_fromArray(
				[
					$elm$html$Html$text(item.k9)
				]));
	});
var $author$project$Entity$Style$textEllipsis = _List_fromArray(
	[
		A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
		A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
		A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis'),
		A2($elm$html$Html$Attributes$style, 'line-height', 'normal')
	]);
var $author$project$Template$Widget$MenuPlanning$viewCompactImgDescription = F2(
	function (item, customStyles) {
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', '98%'),
						A2($elm$html$Html$Attributes$style, 'height', '1.4em'),
						A2($elm$html$Html$Attributes$style, 'margin', '0px'),
						A2($elm$html$Html$Attributes$style, 'text-align', 'left')
					]),
				_Utils_ap($author$project$Entity$Style$textEllipsis, customStyles)),
			_List_fromArray(
				[
					$elm$html$Html$text(item.k9)
				]));
	});
var $author$project$Template$Widget$MenuPlanning$viewOverlayImgDescription = F3(
	function (item, isImgVisible, customStyles) {
		var lineStyle = isImgVisible ? $author$project$Entity$Style$textLineClamp(4) : $author$project$Entity$Style$textLineClamp(2);
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', '100%'),
						A2($elm$html$Html$Attributes$style, 'text-align', 'center'),
						A2($elm$html$Html$Attributes$style, 'margin', '0px'),
						A2($elm$html$Html$Attributes$style, 'border-radius', '0px 0px 8px 8px')
					]),
				_Utils_ap(lineStyle, customStyles)),
			_List_fromArray(
				[
					$elm$html$Html$text(item.k9)
				]));
	});
var $author$project$Template$Widget$MenuPlanning$viewSmallImgDescription = F2(
	function (item, customStyles) {
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'max-width', '100%'),
						A2($elm$html$Html$Attributes$style, 'margin', '0px')
					]),
				_Utils_ap($author$project$Entity$Style$textEllipsis, customStyles)),
			_List_fromArray(
				[
					$elm$html$Html$text(item.k9)
				]));
	});
var $author$project$Template$Widget$MenuPlanning$viewDescription = F3(
	function (config, styleIntf, item) {
		var isImgVisible = A2($author$project$Entity$Style$isVisible, styleIntf, config.gL);
		var customStyles = styleIntf.j0(config.k9);
		var _v0 = config.ip;
		switch (_v0) {
			case 0:
				return A3($author$project$Template$Widget$MenuPlanning$viewOverlayImgDescription, item, isImgVisible, customStyles);
			case 1:
				return A3($author$project$Template$Widget$MenuPlanning$viewBigImgDescription, item, isImgVisible, customStyles);
			case 2:
				return A2($author$project$Template$Widget$MenuPlanning$viewSmallImgDescription, item, customStyles);
			default:
				return A2($author$project$Template$Widget$MenuPlanning$viewCompactImgDescription, item, customStyles);
		}
	});
var $noahzgordon$elm_color_extra$Color$Convert$cssColorString = F2(
	function (kind, values) {
		return kind + ('(' + (A2($elm$core$String$join, ', ', values) + ')'));
	});
var $noahzgordon$elm_color_extra$Color$Convert$colorToCssRgba = function (cl) {
	var _v0 = $avh4$elm_color$Color$toRgba(cl);
	var red = _v0.hz;
	var green = _v0.gF;
	var blue = _v0.f8;
	var alpha = _v0.f3;
	return A2(
		$noahzgordon$elm_color_extra$Color$Convert$cssColorString,
		'rgba',
		_List_fromArray(
			[
				$elm$core$String$fromFloat(red * 255),
				$elm$core$String$fromFloat(green * 255),
				$elm$core$String$fromFloat(blue * 255),
				$elm$core$String$fromFloat(alpha)
			]));
};
var $author$project$Template$Widget$MenuPlanning$viewFoodComponent = F3(
	function (config, _char, color) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '42px'),
					A2($elm$html$Html$Attributes$style, 'height', '42px'),
					A2($elm$html$Html$Attributes$style, 'line-height', '42px'),
					A2($elm$html$Html$Attributes$style, 'font-size', '30px'),
					A2($elm$html$Html$Attributes$style, 'padding', '1px'),
					A2($elm$html$Html$Attributes$style, 'font-family', 'roboto'),
					A2($elm$html$Html$Attributes$style, 'color', 'white'),
					A2($elm$html$Html$Attributes$style, 'border-radius', '50%'),
					A2($elm$html$Html$Attributes$style, 'text-align', 'center'),
					A2($elm$html$Html$Attributes$style, 'margin', '3px'),
					A2(
					$elm$html$Html$Attributes$style,
					'background',
					$noahzgordon$elm_color_extra$Color$Convert$colorToCssRgba(color))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$fromChar(_char))
				]));
	});
var $author$project$Template$Widget$MenuPlanning$viewFoodComponents = F3(
	function (config, styleIntf, item) {
		return A2(
			$elm$html$Html$div,
			styleIntf.j0(config.gA),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'align-items', 'flex-start'),
							function () {
							var _v0 = config.ip;
							if (_v0 === 1) {
								return (!A2($author$project$Entity$Style$isVisible, styleIntf, config.gL)) ? A2($elm$html$Html$Attributes$style, 'margin', '8px 0px 0px 0px') : A2($elm$html$Html$Attributes$style, '', '');
							} else {
								return A2($elm$html$Html$Attributes$style, '', '');
							}
						}()
						]),
					_List_fromArray(
						[
							item.lq ? A3(
							$author$project$Template$Widget$MenuPlanning$viewFoodComponent,
							config,
							'P',
							A4($avh4$elm_color$Color$rgba, 106, 27, 154, 1)) : $elm$html$Html$text(''),
							item.lr ? A3(
							$author$project$Template$Widget$MenuPlanning$viewFoodComponent,
							config,
							'V',
							A4($avh4$elm_color$Color$rgba, 0, 127, 56, 1)) : $elm$html$Html$text(''),
							item.lo ? A3(
							$author$project$Template$Widget$MenuPlanning$viewFoodComponent,
							config,
							'G',
							A4($avh4$elm_color$Color$rgba, 216, 64, 21, 1)) : $elm$html$Html$text(''),
							item.ln ? A3(
							$author$project$Template$Widget$MenuPlanning$viewFoodComponent,
							config,
							'F',
							A4($avh4$elm_color$Color$rgba, 299, 0, 0, 1)) : $elm$html$Html$text(''),
							item.lp ? A3(
							$author$project$Template$Widget$MenuPlanning$viewFoodComponent,
							config,
							'M',
							A4($avh4$elm_color$Color$rgba, 25, 118, 210, 1)) : $elm$html$Html$text('')
						]))
				]));
	});
var $author$project$Template$Widget$MenuPlanning$imgSizeStyle = function (config) {
	var _v0 = config.ip;
	switch (_v0) {
		case 0:
			return _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
					A2($elm$html$Html$Attributes$style, 'top', '0px'),
					A2($elm$html$Html$Attributes$style, 'left', '0px'),
					A2($elm$html$Html$Attributes$style, 'width', '100%'),
					A2($elm$html$Html$Attributes$style, 'height', '100%'),
					A2($elm$html$Html$Attributes$style, 'border-radius', '8px'),
					A2($elm$html$Html$Attributes$style, 'background-color', '#FFFFFF')
				]);
		case 1:
			return _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'min-width', '100%'),
					A2($elm$html$Html$Attributes$style, 'min-height', '58%'),
					A2($elm$html$Html$Attributes$style, 'max-width', '100%'),
					A2($elm$html$Html$Attributes$style, 'max-height', '100%'),
					A2($elm$html$Html$Attributes$style, 'border-radius', '8px 8px 0px 0px')
				]);
		case 2:
			return _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '12.5%'),
					A2($elm$html$Html$Attributes$style, 'max-width', '106px'),
					A2($elm$html$Html$Attributes$style, 'min-height', '106px'),
					A2($elm$html$Html$Attributes$style, 'border-radius', '8px')
				]);
		default:
			return _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'max-width', '98px'),
					A2($elm$html$Html$Attributes$style, 'width', '12%'),
					A2($elm$html$Html$Attributes$style, 'min-height', '96px'),
					A2($elm$html$Html$Attributes$style, 'border-radius', '8px')
				]);
	}
};
var $author$project$Utils$toImgUrl = function (dataUrl) {
	return 'url(\'' + (dataUrl + '\')');
};
var $author$project$Template$Widget$MenuPlanning$imgStateStyle = F3(
	function (config, styleIntf, imgState) {
		if (imgState.$ === 2) {
			var url = imgState.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$style,
					'background-image',
					$author$project$Utils$toImgUrl(url)),
					A2($elm$html$Html$Attributes$style, 'background-size', 'cover'),
					A2($elm$html$Html$Attributes$style, 'background-repeat', 'no-repeat'),
					A2($elm$html$Html$Attributes$style, 'background-position', 'center'),
					A2($author$project$Entity$Style$isVisible, styleIntf, config.gL) ? A2($elm$html$Html$Attributes$style, 'display', 'initial') : A2($elm$html$Html$Attributes$style, 'display', 'none')
				]);
		} else {
			return _List_fromArray(
				[
					A2($author$project$Entity$Style$isVisible, styleIntf, config.gL) ? A2($elm$html$Html$Attributes$style, 'display', 'flex') : A2($elm$html$Html$Attributes$style, 'display', 'none'),
					A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'center')
				]);
		}
	});
var $avh4$elm_color$Color$black = A4($avh4$elm_color$Color$RgbaSpace, 0 / 255, 0 / 255, 0 / 255, 1.0);
var $danmarcab$material_icons$Material$Icons$Maps$restaurant = A2(
	$danmarcab$material_icons$Material$Icons$Internal$icon,
	'0 0 48 48',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M22 18h-4V4h-4v14h-4V4H6v14c0 4.25 3.32 7.69 7.5 7.95V44h5V25.95c4.18-.26 7.5-3.7 7.5-7.95V4h-4v14zm10-6v16h5v16h5V4c-5.52 0-10 4.48-10 8z')
				]),
			_List_Nil)
		]));
var $author$project$Template$Widget$MenuPlanning$viewEmptyImg = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'background', 'white'),
			A2($elm$html$Html$Attributes$style, 'border-radius', '8px')
		]),
	_List_fromArray(
		[
			A2($danmarcab$material_icons$Material$Icons$Maps$restaurant, $avh4$elm_color$Color$black, 72)
		]));
var $author$project$Template$Widget$MenuPlanning$viewRedirectedImg = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'background', 'white'),
			A2($elm$html$Html$Attributes$style, 'border-radius', '8px')
		]),
	_List_fromArray(
		[
			A2($danmarcab$material_icons$Material$Icons$Maps$restaurant, $avh4$elm_color$Color$black, 72)
		]));
var $author$project$Template$Widget$MenuPlanning$viewImage = F3(
	function (config, styleIntf, imgState) {
		var stateStyle = A3($author$project$Template$Widget$MenuPlanning$imgStateStyle, config, styleIntf, imgState);
		var sizeStyle = $author$project$Template$Widget$MenuPlanning$imgSizeStyle(config);
		return A2(
			$elm$html$Html$div,
			_Utils_ap(sizeStyle, stateStyle),
			_List_fromArray(
				[
					function () {
					switch (imgState.$) {
						case 0:
							return $author$project$Template$Widget$MenuPlanning$viewEmptyImg;
						case 1:
							return $author$project$Template$Widget$MenuPlanning$viewRedirectedImg;
						default:
							return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $fredcy$elm_parseint$ParseInt$InvalidRadix = function (a) {
	return {$: 2, a: a};
};
var $fredcy$elm_parseint$ParseInt$InvalidChar = function (a) {
	return {$: 0, a: a};
};
var $fredcy$elm_parseint$ParseInt$OutOfRange = function (a) {
	return {$: 1, a: a};
};
var $fredcy$elm_parseint$ParseInt$charOffset = F2(
	function (basis, c) {
		return $elm$core$Char$toCode(c) - $elm$core$Char$toCode(basis);
	});
var $fredcy$elm_parseint$ParseInt$isBetween = F3(
	function (lower, upper, c) {
		var ci = $elm$core$Char$toCode(c);
		return (_Utils_cmp(
			$elm$core$Char$toCode(lower),
			ci) < 1) && (_Utils_cmp(
			ci,
			$elm$core$Char$toCode(upper)) < 1);
	});
var $fredcy$elm_parseint$ParseInt$intFromChar = F2(
	function (radix, c) {
		var validInt = function (i) {
			return (_Utils_cmp(i, radix) < 0) ? $elm$core$Result$Ok(i) : $elm$core$Result$Err(
				$fredcy$elm_parseint$ParseInt$OutOfRange(c));
		};
		var toInt = A3($fredcy$elm_parseint$ParseInt$isBetween, '0', '9', c) ? $elm$core$Result$Ok(
			A2($fredcy$elm_parseint$ParseInt$charOffset, '0', c)) : (A3($fredcy$elm_parseint$ParseInt$isBetween, 'a', 'z', c) ? $elm$core$Result$Ok(
			10 + A2($fredcy$elm_parseint$ParseInt$charOffset, 'a', c)) : (A3($fredcy$elm_parseint$ParseInt$isBetween, 'A', 'Z', c) ? $elm$core$Result$Ok(
			10 + A2($fredcy$elm_parseint$ParseInt$charOffset, 'A', c)) : $elm$core$Result$Err(
			$fredcy$elm_parseint$ParseInt$InvalidChar(c))));
		return A2($elm$core$Result$andThen, validInt, toInt);
	});
var $fredcy$elm_parseint$ParseInt$parseIntR = F2(
	function (radix, rstring) {
		var _v0 = $elm$core$String$uncons(rstring);
		if (_v0.$ === 1) {
			return $elm$core$Result$Ok(0);
		} else {
			var _v1 = _v0.a;
			var c = _v1.a;
			var rest = _v1.b;
			return A2(
				$elm$core$Result$andThen,
				function (ci) {
					return A2(
						$elm$core$Result$andThen,
						function (ri) {
							return $elm$core$Result$Ok(ci + (ri * radix));
						},
						A2($fredcy$elm_parseint$ParseInt$parseIntR, radix, rest));
				},
				A2($fredcy$elm_parseint$ParseInt$intFromChar, radix, c));
		}
	});
var $fredcy$elm_parseint$ParseInt$parseIntRadix = F2(
	function (radix, string) {
		return ((2 <= radix) && (radix <= 36)) ? A2(
			$fredcy$elm_parseint$ParseInt$parseIntR,
			radix,
			$elm$core$String$reverse(string)) : $elm$core$Result$Err(
			$fredcy$elm_parseint$ParseInt$InvalidRadix(radix));
	});
var $fredcy$elm_parseint$ParseInt$parseIntHex = $fredcy$elm_parseint$ParseInt$parseIntRadix(16);
var $noahzgordon$elm_color_extra$Color$Convert$roundToPlaces = F2(
	function (places, number) {
		var multiplier = A2($elm$core$Basics$pow, 10, places);
		return $elm$core$Basics$round(number * multiplier) / multiplier;
	});
var $noahzgordon$elm_color_extra$Color$Convert$hexToColor = function () {
	var pattern = '' + ('^' + ('#?' + ('(?:' + ('(?:([a-f\\d]{2})([a-f\\d]{2})([a-f\\d]{2}))' + ('|' + ('(?:([a-f\\d])([a-f\\d])([a-f\\d]))' + ('|' + ('(?:([a-f\\d]{2})([a-f\\d]{2})([a-f\\d]{2})([a-f\\d]{2}))' + ('|' + ('(?:([a-f\\d])([a-f\\d])([a-f\\d])([a-f\\d]))' + (')' + '$')))))))))));
	var extend = function (token) {
		var _v6 = $elm$core$String$toList(token);
		if (_v6.b && (!_v6.b.b)) {
			var token_ = _v6.a;
			return $elm$core$String$fromList(
				_List_fromArray(
					[token_, token_]));
		} else {
			return token;
		}
	};
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$String$toLower,
		A2(
			$elm$core$Basics$composeR,
			function (str) {
				return A2(
					$elm$core$Maybe$map,
					function (regex) {
						return A3($elm$regex$Regex$findAtMost, 1, regex, str);
					},
					$elm$regex$Regex$fromString(pattern));
			},
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$andThen($elm$core$List$head),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$map(
						function ($) {
							return $.mM;
						}),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map(
							$elm$core$List$filterMap($elm$core$Basics$identity)),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Result$fromMaybe('Parsing hex regex failed'),
							$elm$core$Result$andThen(
								function (colors) {
									var _v0 = A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											extend,
											A2(
												$elm$core$Basics$composeR,
												$fredcy$elm_parseint$ParseInt$parseIntHex,
												$elm$core$Result$map($elm$core$Basics$toFloat))),
										colors);
									_v0$2:
									while (true) {
										if (((((_v0.b && (!_v0.a.$)) && _v0.b.b) && (!_v0.b.a.$)) && _v0.b.b.b) && (!_v0.b.b.a.$)) {
											if (_v0.b.b.b.b) {
												if ((!_v0.b.b.b.a.$) && (!_v0.b.b.b.b.b)) {
													var r = _v0.a.a;
													var _v1 = _v0.b;
													var g = _v1.a.a;
													var _v2 = _v1.b;
													var b = _v2.a.a;
													var _v3 = _v2.b;
													var a = _v3.a.a;
													return $elm$core$Result$Ok(
														A4(
															$avh4$elm_color$Color$rgba,
															r / 255,
															g / 255,
															b / 255,
															A2($noahzgordon$elm_color_extra$Color$Convert$roundToPlaces, 2, a / 255)));
												} else {
													break _v0$2;
												}
											} else {
												var r = _v0.a.a;
												var _v4 = _v0.b;
												var g = _v4.a.a;
												var _v5 = _v4.b;
												var b = _v5.a.a;
												return $elm$core$Result$Ok(
													A3($avh4$elm_color$Color$rgb, r / 255, g / 255, b / 255));
											}
										} else {
											break _v0$2;
										}
									}
									return $elm$core$Result$Err('Parsing ints from hex failed');
								})))))));
}();
var $danmarcab$material_icons$Material$Icons$Toggle$star = A2(
	$danmarcab$material_icons$Material$Icons$Internal$icon,
	'0 0 24 24',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z')
				]),
			_List_Nil)
		]));
var $author$project$Template$Widget$MenuPlanning$viewRating = F3(
	function (color, size, num) {
		return (num > 4) ? A2($danmarcab$material_icons$Material$Icons$Toggle$star, color, 48) : $elm$html$Html$text('');
	});
var $author$project$Template$Widget$MenuPlanning$viewRatings = F3(
	function (config, styleIntf, item) {
		var customStyles = styleIntf.j0(config.mf);
		var color = A2(
			$elm$core$Maybe$withDefault,
			A3($avh4$elm_color$Color$rgb, 204, 172, 0),
			A2(
				$elm$core$Maybe$andThen,
				A2($elm$core$Basics$composeL, $elm$core$Result$toMaybe, $noahzgordon$elm_color_extra$Color$Convert$hexToColor),
				A2(styleIntf.e7, 'color', config.mf)));
		var _v0 = config.ip;
		switch (_v0) {
			case 0:
				return (item.mf > 4) ? A2(
					$elm$html$Html$div,
					_Utils_ap(
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
								A2($elm$html$Html$Attributes$style, 'top', '18px'),
								A2($elm$html$Html$Attributes$style, 'left', '18px'),
								A2($elm$html$Html$Attributes$style, 'background', 'rgba(0,0,0,0.6)'),
								A2($elm$html$Html$Attributes$style, 'border-radius', '50%')
							]),
						customStyles),
					_List_fromArray(
						[
							A2(
							$danmarcab$material_icons$Material$Icons$Toggle$star,
							A3($avh4$elm_color$Color$rgb, 255, 215, 0),
							52)
						])) : $elm$html$Html$text('');
			case 1:
				return (item.mf > 4) ? A2(
					$elm$html$Html$div,
					_Utils_ap(
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
								A2($elm$html$Html$Attributes$style, 'top', '0px'),
								A2($elm$html$Html$Attributes$style, 'right', '12px'),
								A2($elm$html$Html$Attributes$style, 'padding', '4px'),
								A2($elm$html$Html$Attributes$style, 'background', 'rgb(0,0,0)'),
								A2($elm$html$Html$Attributes$style, 'border-radius', '0% 0% 50% 50%'),
								$elm$html$Html$Attributes$class('elevation-e2')
							]),
						customStyles),
					_List_fromArray(
						[
							A2(
							$danmarcab$material_icons$Material$Icons$Toggle$star,
							A3($avh4$elm_color$Color$rgb, 255, 215, 0),
							48)
						])) : $elm$html$Html$text('');
			default:
				return A2(
					$elm$html$Html$div,
					customStyles,
					_List_fromArray(
						[
							A3(
							$author$project$Template$Widget$MenuPlanning$viewRating,
							color,
							36,
							$elm$core$Basics$round(item.mf))
						]));
		}
	});
var $author$project$Template$Widget$MenuPlanning$viewBigItem = F5(
	function (_v0, config, styleIntf, anim, item) {
		var viewport = _v0.a;
		var orientation = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '100%'),
					A2(
					$elm$html$Html$Attributes$style,
					'height',
					A2($author$project$Template$Widget$MenuPlanning$isEqual, config.hD, 0.5) ? '185%' : (A2($author$project$Template$Widget$MenuPlanning$isEqual, config.hD, 0.3) ? '282%' : '94%')),
					A2(
					$elm$html$Html$Attributes$style,
					'max-width',
					function () {
						if (viewport.$ === 2) {
							return '441px';
						} else {
							return '23vw';
						}
					}()),
					A2(
					$elm$html$Html$Attributes$style,
					'max-height',
					function () {
						var _v2 = _Utils_Tuple2(
							A2($author$project$Entity$Style$isVisible, styleIntf, config.gY),
							viewport);
						if (!_v2.a) {
							if (_v2.b.$ === 2) {
								return '784px';
							} else {
								return '71vh';
							}
						} else {
							if (_v2.b.$ === 2) {
								return '752px';
							} else {
								return '68vh';
							}
						}
					}()),
					A2($elm$html$Html$Attributes$style, 'border-radius', '10px'),
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
					A2($elm$html$Html$Attributes$style, 'justify-content', 'space-between'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
					A2($elm$html$Html$Attributes$style, 'margin', '8px'),
					A2($elm$html$Html$Attributes$style, 'backface-visibility', 'hidden'),
					A2($elm$html$Html$Attributes$style, 'position', 'relative'),
					A2(
					$elm$html$Html$Attributes$style,
					'background',
					A2(
						$elm$core$Maybe$withDefault,
						'#FFFFFF',
						A2(styleIntf.e7, 'background', config.k9))),
					$elm$html$Html$Attributes$class('elevation-2')
				]),
			_List_fromArray(
				[
					A3($author$project$Template$Widget$MenuPlanning$viewImage, config, styleIntf, item.ly),
					A3($author$project$Template$Widget$MenuPlanning$viewFoodComponents, config, styleIntf, item),
					A3($author$project$Template$Widget$MenuPlanning$viewDescription, config, styleIntf, item),
					A3($author$project$Template$Widget$MenuPlanning$viewRatings, config, styleIntf, item),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '100%'),
							A2($elm$html$Html$Attributes$style, 'margin', '8px 0px 16px 0px'),
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
							A2($elm$html$Html$Attributes$style, 'justify-content', 'center')
						]),
					_List_fromArray(
						[
							A3($author$project$Template$Widget$MenuPlanning$viewCalories, config, styleIntf, item)
						]))
				]));
	});
var $author$project$Template$Widget$MenuPlanning$isFoodComponentPresent = function (item) {
	return item.lr || (item.lq || (item.lo || (item.ln || item.lp)));
};
var $author$project$Template$Widget$MenuPlanning$viewSeparator = function (conditions) {
	return A2($elm$core$List$all, $elm$core$Basics$identity, conditions) ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'width', '10px'),
				A2($elm$html$Html$Attributes$style, 'height', '10px'),
				A2($elm$html$Html$Attributes$style, 'border-radius', '50%'),
				A2($elm$html$Html$Attributes$style, 'background', 'rgba(0,0,0,0.6)'),
				A2($elm$html$Html$Attributes$style, 'margin', '0px 16px')
			]),
		_List_Nil) : $elm$html$Html$text('');
};
var $author$project$Template$Widget$MenuPlanning$viewCompactItem = F5(
	function (_v0, config, styleIntf, anim, item) {
		var viewport = _v0.a;
		var orientation = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'flex-start'),
					A2(
					$elm$html$Html$Attributes$style,
					'max-width',
					function () {
						if (viewport.$ === 2) {
							return '1000px';
						} else {
							return '50vw';
						}
					}()),
					A2($elm$html$Html$Attributes$style, 'border-radius', '10px'),
					A2($elm$html$Html$Attributes$style, 'perspective-origin', 'left top'),
					A2($elm$html$Html$Attributes$style, 'perspective', '100vh'),
					A2($elm$html$Html$Attributes$style, 'margin', '0px 0px 8px 0px'),
					A2($elm$html$Html$Attributes$style, 'width', '94%'),
					A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
					A2(
					$elm$html$Html$Attributes$style,
					'background',
					A2(
						$elm$core$Maybe$withDefault,
						'none',
						A2(styleIntf.e7, 'background', config.k9))),
					A2(
					$elm$html$Html$Attributes$style,
					'min-height',
					A3(
						$elm$core$Basics$composeR,
						$elm$core$String$fromFloat,
						function (a) {
							return a + 'em';
						},
						0.154 * A2(
							$elm$core$Maybe$withDefault,
							36,
							A2(styleIntf.iO, 'font-size', config.k9))))
				]),
			_List_fromArray(
				[
					A3($author$project$Template$Widget$MenuPlanning$viewImage, config, styleIntf, item.ly),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
							A2($elm$html$Html$Attributes$style, 'align-items', 'flex-start'),
							A2($elm$html$Html$Attributes$style, 'margin-left', '12px'),
							A2($elm$html$Html$Attributes$style, 'width', '88%'),
							A2($elm$html$Html$Attributes$style, 'padding-top', '4px')
						]),
					_List_fromArray(
						[
							A3($author$project$Template$Widget$MenuPlanning$viewDescription, config, styleIntf, item),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'display', 'flex'),
									A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
									A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
									A2($elm$html$Html$Attributes$style, 'height', '3em'),
									A2($elm$html$Html$Attributes$style, 'transform', 'scale(0.6)'),
									A2($elm$html$Html$Attributes$style, 'transform-origin', 'top left')
								]),
							_List_fromArray(
								[
									A3($author$project$Template$Widget$MenuPlanning$viewRatings, config, styleIntf, item),
									$author$project$Template$Widget$MenuPlanning$viewSeparator(
									_List_fromArray(
										[
											A2($author$project$Entity$Style$isVisible, styleIntf, config.mf),
											A2($author$project$Entity$Style$isVisible, styleIntf, config.gA),
											item.mf > 4,
											$author$project$Template$Widget$MenuPlanning$isFoodComponentPresent(item)
										])),
									A3($author$project$Template$Widget$MenuPlanning$viewFoodComponents, config, styleIntf, item),
									$author$project$Template$Widget$MenuPlanning$viewSeparator(
									_List_fromArray(
										[
											A2($author$project$Entity$Style$isVisible, styleIntf, config.mf) || A2($author$project$Entity$Style$isVisible, styleIntf, config.gA),
											A2($author$project$Entity$Style$isVisible, styleIntf, config.kR),
											(item.mf > 4) || (A2($author$project$Entity$Style$isVisible, styleIntf, config.gA) && $author$project$Template$Widget$MenuPlanning$isFoodComponentPresent(item))
										])),
									A3($author$project$Template$Widget$MenuPlanning$viewCalories, config, styleIntf, item)
								]))
						]))
				]));
	});
var $author$project$Template$Widget$MenuPlanning$viewOverlayImageItem = F5(
	function (_v0, config, styleIntf, anim, item) {
		var viewport = _v0.a;
		var orientation = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '100%'),
					A2(
					$elm$html$Html$Attributes$style,
					'height',
					A2($author$project$Template$Widget$MenuPlanning$isEqual, config.hD, 0.5) ? '190%' : (A2($author$project$Template$Widget$MenuPlanning$isEqual, config.hD, 0.3) ? '282%' : '94%')),
					A2($elm$html$Html$Attributes$style, 'backface-visibility', 'hidden'),
					A2(
					$elm$html$Html$Attributes$style,
					'max-width',
					function () {
						if (viewport.$ === 2) {
							return '441px';
						} else {
							return '23vw';
						}
					}()),
					A2(
					$elm$html$Html$Attributes$style,
					'max-height',
					function () {
						var _v2 = _Utils_Tuple2(
							A2($author$project$Entity$Style$isVisible, styleIntf, config.gY),
							viewport);
						if (!_v2.a) {
							if (_v2.b.$ === 2) {
								return '784px';
							} else {
								return '71vh';
							}
						} else {
							if (_v2.b.$ === 2) {
								return '752px';
							} else {
								return '68vh';
							}
						}
					}()),
					A2($elm$html$Html$Attributes$style, 'margin', '0px 6px 6px 6px'),
					A2($elm$html$Html$Attributes$style, 'border-radius', '8px'),
					A2($elm$html$Html$Attributes$style, 'position', 'relative')
				]),
			_List_fromArray(
				[
					A3($author$project$Template$Widget$MenuPlanning$viewImage, config, styleIntf, item.ly),
					A3($author$project$Template$Widget$MenuPlanning$viewRatings, config, styleIntf, item),
					A3($author$project$Template$Widget$MenuPlanning$viewCalories, config, styleIntf, item),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('elevation-2'),
							A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
							A2(
							$elm$html$Html$Attributes$style,
							'bottom',
							A3(
								$elm$core$Basics$composeR,
								$elm$core$String$fromFloat,
								function (a) {
									return a + 'px';
								},
								3.5 * A2(
									$elm$core$Maybe$withDefault,
									36,
									A2(styleIntf.iO, 'font-size', config.k9)))),
							A2($elm$html$Html$Attributes$style, 'left', '2%'),
							A2($elm$html$Html$Attributes$style, 'padding', '5px'),
							A2($elm$html$Html$Attributes$style, 'background', 'rgba(255,255,255)'),
							A2($elm$html$Html$Attributes$style, 'border-radius', '20px')
						]),
					_List_fromArray(
						[
							A3($author$project$Template$Widget$MenuPlanning$viewFoodComponents, config, styleIntf, item)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
							A2($elm$html$Html$Attributes$style, 'bottom', '0px'),
							A2($elm$html$Html$Attributes$style, 'margin', '0px'),
							A2($elm$html$Html$Attributes$style, 'width', '100%'),
							A2($elm$html$Html$Attributes$style, 'padding', '12px 0px'),
							A2($elm$html$Html$Attributes$style, 'border-radius', '0px 0px 8px 8px'),
							A2($elm$html$Html$Attributes$style, 'background', 'white')
						]),
					_List_fromArray(
						[
							A3($author$project$Template$Widget$MenuPlanning$viewDescription, config, styleIntf, item)
						]))
				]));
	});
var $author$project$Template$Widget$MenuPlanning$viewSmallItem = F5(
	function (_v0, config, styleIntf, anim, item) {
		var viewport = _v0.a;
		var orientation = _v0.b;
		var contentStyles = _Utils_ap(
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'flex-start'),
					A2($elm$html$Html$Attributes$style, 'margin-left', '1%')
				]),
			A2($author$project$Entity$Style$isVisible, styleIntf, config.gL) ? _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '76%')
				]) : _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '85%')
				]));
		var baseStyles = _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
				A2($elm$html$Html$Attributes$style, 'justify-content', 'space-between'),
				A2($elm$html$Html$Attributes$style, 'padding', '4px 0px'),
				A2($elm$html$Html$Attributes$style, 'margin', '0px 6px 8px 6px'),
				A2($elm$html$Html$Attributes$style, 'border-radius', '10px'),
				A2($elm$html$Html$Attributes$style, 'perspective-origin', 'left top'),
				A2($elm$html$Html$Attributes$style, 'perspective', '100vh'),
				A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
				A2($elm$html$Html$Attributes$style, 'min-height', '94px'),
				A2($elm$html$Html$Attributes$style, 'max-height', '104px'),
				A2(
				$elm$html$Html$Attributes$style,
				'width',
				function () {
					if (viewport.$ === 2) {
						return '95%';
					} else {
						return '95%';
					}
				}()),
				A2(
				$elm$html$Html$Attributes$style,
				'max-width',
				function () {
					if (viewport.$ === 2) {
						return '1000px';
					} else {
						return '50vw';
					}
				}()),
				A2(
				$elm$html$Html$Attributes$style,
				'background',
				A2(
					$elm$core$Maybe$withDefault,
					'none',
					A2(styleIntf.e7, 'background', config.k9)))
			]);
		return A2(
			$elm$html$Html$div,
			baseStyles,
			_List_fromArray(
				[
					A3($author$project$Template$Widget$MenuPlanning$viewImage, config, styleIntf, item.ly),
					A2(
					$elm$html$Html$div,
					contentStyles,
					_List_fromArray(
						[
							A3($author$project$Template$Widget$MenuPlanning$viewDescription, config, styleIntf, item),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'display', 'flex'),
									A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
									A2($elm$html$Html$Attributes$style, 'transform', 'scale(0.7)'),
									A2($elm$html$Html$Attributes$style, 'transform-origin', 'left center')
								]),
							_List_fromArray(
								[
									A3($author$project$Template$Widget$MenuPlanning$viewRatings, config, styleIntf, item),
									$author$project$Template$Widget$MenuPlanning$viewSeparator(
									_List_fromArray(
										[
											A2($author$project$Entity$Style$isVisible, styleIntf, config.gA),
											A2($author$project$Entity$Style$isVisible, styleIntf, config.mf),
											item.mf > 4,
											$author$project$Template$Widget$MenuPlanning$isFoodComponentPresent(item)
										])),
									A3($author$project$Template$Widget$MenuPlanning$viewFoodComponents, config, styleIntf, item)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
							A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
							A2($elm$html$Html$Attributes$style, 'width', '10%')
						]),
					_List_fromArray(
						[
							A3($author$project$Template$Widget$MenuPlanning$viewCalories, config, styleIntf, item)
						]))
				]));
	});
var $author$project$Template$Widget$MenuPlanning$viewMenuItem = F5(
	function (frameData, config, styleIntf, anim, item) {
		var _v0 = config.ip;
		switch (_v0) {
			case 0:
				return A5($author$project$Template$Widget$MenuPlanning$viewOverlayImageItem, frameData, config, styleIntf, anim, item);
			case 1:
				return A5($author$project$Template$Widget$MenuPlanning$viewBigItem, frameData, config, styleIntf, anim, item);
			case 2:
				return A5($author$project$Template$Widget$MenuPlanning$viewSmallItem, frameData, config, styleIntf, anim, item);
			default:
				return A5($author$project$Template$Widget$MenuPlanning$viewCompactItem, frameData, config, styleIntf, anim, item);
		}
	});
var $author$project$Template$Widget$MenuPlanning$viewWidget = F3(
	function (_v0, _v1, menuItems) {
		var viewport = _v0.a;
		var orientation = _v0.b;
		var config = _v1.a;
		var styleIntf = _v1.b;
		var anims = _v1.c;
		var mItems = A2(
			$elm_community$list_extra$List$Extra$uniqueBy,
			function ($) {
				return $.mg;
			},
			A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.k9;
				},
				$elm_community$maybe_extra$Maybe$Extra$values(
					A2(
						$elm$core$List$map,
						function (itemId) {
							return A2($elm$core$Dict$get, itemId, menuItems);
						},
						config.aj))));
		var customStyles = styleIntf.j0(config.da);
		var baseStyles = _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'margin', '8px'),
				A2($elm$html$Html$Attributes$style, 'perspective', '100vw'),
				A2(
				$elm$html$Html$Attributes$style,
				'display',
				A2(
					$elm$core$Maybe$withDefault,
					'flex',
					A2(
						$elm$core$Maybe$andThen,
						function (disp) {
							return (disp === 'hidden') ? $elm$core$Maybe$Just('hidden') : $elm$core$Maybe$Just('flex');
						},
						A2(styleIntf.e7, 'display', config.da)))),
				A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
				A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
				A2(
				$elm$html$Html$Attributes$style,
				'width',
				A2(
					$elm$core$Maybe$withDefault,
					'98%',
					A2(styleIntf.e7, 'width', config.da))),
				A2(
				$elm$html$Html$Attributes$style,
				'height',
				A2(
					$elm$core$Maybe$withDefault,
					'98%',
					A2(styleIntf.e7, 'height', config.da)))
			]);
		var animationStyles = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$andThen,
				A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $mdgriffith$elm_style_animation$Animation$render),
				A2($elm_community$list_extra$List$Extra$getAt, 0, anims)));
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				baseStyles,
				_Utils_ap(customStyles, animationStyles)),
			_List_fromArray(
				[
					A3($author$project$Template$Widget$MenuPlanning$viewCategory, config, styleIntf, anims),
					A2($author$project$Entity$Style$isVisible, styleIntf, config.na) ? $elm$html$Html$text('') : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin', '6px 0px'),
							A2($elm$html$Html$Attributes$style, 'width', '100%')
						]),
					_List_Nil),
					A3($author$project$Template$Widget$MenuPlanning$viewLocation, config, styleIntf, anims),
					$elm$core$List$isEmpty(config.aj) ? $author$project$Template$Widget$MenuPlanning$viewEmpty(anims) : A2(
					$elm$html$Html$div,
					function () {
						var _v2 = config.ip;
						switch (_v2) {
							case 0:
								return A2($author$project$Template$Widget$MenuPlanning$horizontalLayoutStyle, orientation, config);
							case 1:
								return A2($author$project$Template$Widget$MenuPlanning$horizontalLayoutStyle, orientation, config);
							case 2:
								return A2($author$project$Template$Widget$MenuPlanning$verticalLayoutStyle, orientation, config);
							default:
								return A2($author$project$Template$Widget$MenuPlanning$verticalLayoutStyle, orientation, config);
						}
					}(),
					A3(
						$elm$core$List$map2,
						A3(
							$author$project$Template$Widget$MenuPlanning$viewMenuItem,
							_Utils_Tuple2(viewport, orientation),
							config,
							styleIntf),
						anims,
						mItems))
				]));
	});
var $author$project$Template$Widget$MenuPlanning$view = F3(
	function (_v0, _v1, menuItems) {
		var viewport = _v0.a;
		var orientation = _v0.b;
		var config = _v1.a;
		var styleIntf = _v1.b;
		var anims = _v1.c;
		var _v2 = _Utils_Tuple2(
			viewport,
			$elm$core$List$length(config.aj));
		if (!_v2.b) {
			if (_v2.a.$ === 2) {
				return A3(
					$author$project$Template$Widget$MenuPlanning$viewWidget,
					_Utils_Tuple2(viewport, orientation),
					_Utils_Tuple3(config, styleIntf, anims),
					menuItems);
			} else {
				return $elm$html$Html$text('');
			}
		} else {
			return A3(
				$author$project$Template$Widget$MenuPlanning$viewWidget,
				_Utils_Tuple2(viewport, orientation),
				_Utils_Tuple3(config, styleIntf, anims),
				menuItems);
		}
	});
var $rtfeldman$elm_css$Css$preWrap = {eL: 'pre-wrap', bM: 0};
var $author$project$Template$Widget$TextBox$view = F3(
	function (config, styleIntf, animation) {
		var anim = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$andThen,
					A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $mdgriffith$elm_style_animation$Animation$render),
					A2($elm_community$list_extra$List$Extra$getAt, 0, animation))));
		return $rtfeldman$elm_css$Html$Styled$toUnstyled(
			A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_Utils_ap(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$borderRadius(
									$rtfeldman$elm_css$Css$px(8)),
									A2($author$project$Entity$Style$isVisible, styleIntf, config.cs) ? $rtfeldman$elm_css$Css$displayFlex : $rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none),
									$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
									$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
									$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$preWrap),
									$rtfeldman$elm_css$Css$lineHeight(
									$rtfeldman$elm_css$Css$em(1.2)),
									$rtfeldman$elm_css$Css$height(
									$rtfeldman$elm_css$Css$pct(
										A2(
											$elm$core$Maybe$withDefault,
											98,
											A2(styleIntf.iO, 'height', config.dB)))),
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$pct(
										A2(
											$elm$core$Maybe$withDefault,
											98,
											A2(styleIntf.iO, 'width', config.dB)))),
									A2(
									$rtfeldman$elm_css$Css$property,
									'font-family',
									A2(
										$elm$core$Maybe$withDefault,
										'Fjalla One',
										A2(styleIntf.e7, 'font-family', config.cs))),
									$rtfeldman$elm_css$Css$fontSize(
									$rtfeldman$elm_css$Css$px(
										A2(
											$elm$core$Maybe$withDefault,
											34,
											A2(styleIntf.iO, 'font-size', config.cs)))),
									A2(
									$rtfeldman$elm_css$Css$property,
									'color',
									A2(
										$elm$core$Maybe$withDefault,
										'white',
										A2(styleIntf.e7, 'color', config.cs))),
									A2(
									$rtfeldman$elm_css$Css$property,
									'background',
									A2(
										$elm$core$Maybe$withDefault,
										'transparent',
										A2(styleIntf.e7, 'background', config.cs)))
								]))
						]),
					anim),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(config.hO)
					])));
	});
var $rtfeldman$elm_css$Css$batch = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles;
var $author$project$Template$Widget$Youtube$elSizeStyle = function (config) {
	return $rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$marginTop(
				$rtfeldman$elm_css$Css$px(12)),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(config.hY)),
				$rtfeldman$elm_css$Css$minHeight(
				$rtfeldman$elm_css$Css$px(config.gH)),
				$rtfeldman$elm_css$Css$zIndex(
				$rtfeldman$elm_css$Css$int(0))
			]));
};
var $rtfeldman$elm_css$Html$Styled$Attributes$height = function (n) {
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$attribute,
		'height',
		$elm$core$String$fromInt(n));
};
var $rtfeldman$elm_css$Html$Styled$iframe = $rtfeldman$elm_css$Html$Styled$node('iframe');
var $rtfeldman$elm_css$Html$Styled$Attributes$width = function (n) {
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$attribute,
		'width',
		$elm$core$String$fromInt(n));
};
var $author$project$Template$Widget$Youtube$viewLocalYoutube = function (config) {
	return $rtfeldman$elm_css$Html$Styled$toUnstyled(
		A2(
			$rtfeldman$elm_css$Html$Styled$iframe,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id('youtube-video-app'),
					$rtfeldman$elm_css$Html$Styled$Attributes$width(
					$elm$core$Basics$round(config.hY)),
					$rtfeldman$elm_css$Html$Styled$Attributes$height(
					$elm$core$Basics$round(config.gH)),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$author$project$Template$Widget$Youtube$elSizeStyle(config)
						])),
					$rtfeldman$elm_css$Html$Styled$Attributes$src(
					'/youtube.html' + ('?' + A2(
						$elm$core$String$join,
						'&',
						_List_fromArray(
							[
								'width=' + $elm$core$String$fromFloat(config.hY),
								'height=' + $elm$core$String$fromFloat(config.gH),
								function () {
								var _v0 = config.ka;
								if (!_v0.$) {
									var id = _v0.a;
									return 'videoId=' + id;
								} else {
									return 'videoId=null';
								}
							}(),
								function () {
								var _v1 = config.ka;
								if (!_v1.$) {
									return 'playlistId=null';
								} else {
									var id = _v1.a;
									return 'playlistId=' + id;
								}
							}()
							])))),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'frameborder', '0')
				]),
			_List_Nil));
};
var $author$project$Template$Widget$Youtube$viewYoutubeIframe = function (config) {
	return $rtfeldman$elm_css$Html$Styled$toUnstyled(
		A2(
			$rtfeldman$elm_css$Html$Styled$iframe,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$src(
					'https://www.youtube.com/embed/' + (function () {
						var _v0 = config.ka;
						if (!_v0.$) {
							var id = _v0.a;
							return id;
						} else {
							var id = _v0.a;
							return 'videoseries?list=' + id;
						}
					}() + '?rel=0&amp;controls=0&amp;showinfo=0')),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'frameborder', '0'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'allow', 'autoplay; encrypted-media'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'allowfullscreen', ''),
					$rtfeldman$elm_css$Html$Styled$Attributes$width(
					$elm$core$Basics$round(config.hY)),
					$rtfeldman$elm_css$Html$Styled$Attributes$height(
					$elm$core$Basics$round(config.gH)),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$author$project$Template$Widget$Youtube$elSizeStyle(config)
						]))
				]),
			_List_Nil));
};
var $author$project$Template$Widget$Youtube$view = F2(
	function (viewport, config) {
		if (viewport.$ === 2) {
			return $author$project$Template$Widget$Youtube$viewYoutubeIframe(config);
		} else {
			return $author$project$Template$Widget$Youtube$viewLocalYoutube(config);
		}
	});
var $author$project$Template$Widget$Core$view = F3(
	function (_v0, viewConfig, section) {
		var viewport = _v0.a;
		var orientation = _v0.b;
		var widget = function () {
			switch (section.$) {
				case 0:
					var id = section.a;
					return A2(
						$elm$core$Maybe$withDefault,
						$author$project$Template$Widget$Core$Empty,
						A2($elm$core$Dict$get, id, viewConfig.n));
				case 1:
					var id = section.a;
					return A2(
						$elm$core$Maybe$withDefault,
						$author$project$Template$Widget$Core$Empty,
						A2($elm$core$Dict$get, id, viewConfig.n));
				default:
					return $author$project$Template$Widget$Core$Empty;
			}
		}();
		var styleIntf = $author$project$Entity$Style$getIntf(viewConfig.mC);
		var animation = function () {
			switch (section.$) {
				case 0:
					var id = section.a;
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Dict$get, id, viewConfig.ky));
				case 1:
					var id = section.a;
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Dict$get, id, viewConfig.ky));
				default:
					return _List_Nil;
			}
		}();
		switch (widget.$) {
			case 0:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '25px'),
							A2($elm$html$Html$Attributes$style, 'height', '25px')
						]),
					_List_Nil);
			case 1:
				var conf = widget.a;
				return A3($author$project$Template$Widget$TextBox$view, conf, styleIntf, animation);
			case 2:
				var conf = widget.a;
				return A3($author$project$Template$Widget$Image$view, conf, styleIntf, animation);
			case 3:
				var conf = widget.a;
				return A2($author$project$Template$Widget$Youtube$view, viewport, conf);
			case 4:
				var widgetConf = widget.a;
				return A4(
					$elm$html$Html$Lazy$lazy3,
					$author$project$Template$Widget$MenuPlanning$view,
					_Utils_Tuple2(viewport, orientation),
					_Utils_Tuple3(widgetConf, styleIntf, animation),
					viewConfig.aj);
			default:
				var widgetConf = widget.a;
				return A4($author$project$Template$Widget$MenuItemList$view, widgetConf, styleIntf, animation, viewConfig.cb);
		}
	});
var $author$project$Template$Frame$viewColumn = F7(
	function (viewport, config, orientationVal, grade, _v0, index, _v1) {
		var numColumnsVal = _v0.a;
		var isSameSizeVal = _v0.b;
		var flexGrow = _v1.ae;
		var rows = _v1.jJ;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$style,
					'min-width',
					function () {
						var _v2 = _Utils_Tuple2(numColumnsVal, orientationVal);
						if (!_v2.b) {
							if (_v2.a === 1) {
								var _v3 = _v2.b;
								return '100%';
							} else {
								var _v4 = _v2.b;
								return isSameSizeVal ? function (a) {
									return a + '%';
								}(
									$elm$core$String$fromFloat(100 / numColumnsVal)) : '23%';
							}
						} else {
							var _v5 = _v2.b;
							return '100%';
						}
					}()),
					A2(
					$elm$html$Html$Attributes$style,
					'max-width',
					function () {
						switch (flexGrow) {
							case 0:
								return '25%';
							case 1:
								return '';
							case 5:
								return '75%';
							default:
								return '';
						}
					}()),
					A2(
					$elm$html$Html$Attributes$style,
					'height',
					function () {
						var _v7 = _Utils_Tuple2(numColumnsVal, orientationVal);
						if (_v7.b === 1) {
							if (_v7.a === 1) {
								var _v8 = _v7.b;
								return '100%';
							} else {
								var _v9 = _v7.b;
								return isSameSizeVal ? function (a) {
									return a + '%';
								}(
									$elm$core$String$fromFloat(100 / numColumnsVal)) : '23%';
							}
						} else {
							var _v10 = _v7.b;
							return '100%';
						}
					}()),
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2(
					$elm$html$Html$Attributes$style,
					'flex-direction',
					function () {
						if (!orientationVal) {
							return 'column';
						} else {
							return 'row';
						}
					}()),
					A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
					A2(
					$elm$html$Html$Attributes$style,
					'justify-content',
					function () {
						if (!orientationVal) {
							return 'flex-start';
						} else {
							return 'flex-start';
						}
					}()),
					A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
					function (_v13) {
					var a = _v13.a;
					var b = _v13.b;
					return A2($elm$html$Html$Attributes$style, a, b);
				}(
					grade ? _Utils_Tuple2(
						'background',
						'rgba(0,0,0,0.' + ($elm$core$String$fromInt(index) + ')')) : _Utils_Tuple2('background', 'none')),
					A2(
					$elm$html$Html$Attributes$style,
					'flex-grow',
					$elm$core$String$fromInt(flexGrow))
				]),
			A2(
				$elm$core$List$map,
				A2(
					$author$project$Template$Widget$Core$view,
					_Utils_Tuple2(viewport, orientationVal),
					config),
				rows));
	});
var $author$project$Template$Frame$view = F5(
	function (viewportType, config, fullContent, anim, frame) {
		return A2(
			$elm$html$Html$div,
			function () {
				if (viewportType.$ === 2) {
					var scale = viewportType.a;
					return _List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'top', '0px'),
							A2($elm$html$Html$Attributes$style, 'left', '0px'),
							A2($elm$html$Html$Attributes$style, 'width', '1920px'),
							A2($elm$html$Html$Attributes$style, 'height', '1080px'),
							A2(
							$elm$html$Html$Attributes$style,
							'transform',
							'scale(' + ($elm$core$String$fromFloat(scale) + ')')),
							A2($elm$html$Html$Attributes$style, 'transform-origin', '0% 0%'),
							A2($elm$html$Html$Attributes$style, 'border', '5px black')
						]);
				} else {
					return _List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'position', 'relative'),
							A2($elm$html$Html$Attributes$style, 'width', '100vw'),
							A2($elm$html$Html$Attributes$style, 'height', '100vh'),
							A2($elm$html$Html$Attributes$style, 'overflow', 'hidden')
						]);
				}
			}(),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', 'inherit'),
							A2($elm$html$Html$Attributes$style, 'height', 'inherit'),
							A2($elm$html$Html$Attributes$style, 'background', 'rgb(0,0,0)'),
							A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
							A2($elm$html$Html$Attributes$style, 'top', '0px'),
							A2($elm$html$Html$Attributes$style, 'left', '0px'),
							A2($elm$html$Html$Attributes$style, 'z-index', '0'),
							A2($elm$html$Html$Attributes$style, 'background-size', 'cover')
						]),
					_List_fromArray(
						[
							A3($author$project$Template$Widget$Background$view, viewportType, anim, frame.f6)
						])),
					A2(
					$elm$html$Html$div,
					_Utils_ap(
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
								A2($elm$html$Html$Attributes$style, 'top', '0px'),
								A2($elm$html$Html$Attributes$style, 'left', '0px'),
								A2($elm$html$Html$Attributes$style, 'width', 'inherit'),
								A2($elm$html$Html$Attributes$style, 'display', 'flex'),
								A2(
								$elm$html$Html$Attributes$style,
								'flex-direction',
								function () {
									var _v1 = frame.fz;
									if (!_v1) {
										return 'row';
									} else {
										return 'column';
									}
								}())
							]),
						function () {
							if (viewportType.$ === 2) {
								var scale = viewportType.a;
								return _List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'height', '950px'),
										A2($elm$html$Html$Attributes$style, 'transition', 'transform 0.4s')
									]);
							} else {
								return _List_fromArray(
									[
										fullContent ? A2($elm$html$Html$Attributes$style, 'height', '100%') : A2($elm$html$Html$Attributes$style, 'height', '88%')
									]);
							}
						}()),
					A2(
						$elm$core$List$indexedMap,
						A5(
							$author$project$Template$Frame$viewColumn,
							viewportType,
							config,
							frame.fz,
							frame.ag,
							_Utils_Tuple2(
								$elm$core$List$length(frame.da),
								$author$project$Template$Frame$isSameSize(frame))),
						frame.da))
				]));
	});
var $author$project$Pages$CfgDevice$Design$viewLiveTemplate = F3(
	function (scale, template, viewConfig) {
		return $author$project$Pages$CfgDevice$Design$liveTemplateViewport(
			A2(
				$elm$core$List$map,
				A4(
					$author$project$Template$Frame$view,
					$author$project$Template$Viewport$Widescreen(scale),
					viewConfig,
					true,
					$mdgriffith$elm_style_animation$Animation$style(
						_List_fromArray(
							[
								$mdgriffith$elm_style_animation$Animation$opacity(1)
							]))),
				$jschomay$elm_paginate$Paginate$page(template.G)));
	});
var $author$project$Reusable$Separator$viewVertical = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'width', '1px'),
			A2($elm$html$Html$Attributes$style, 'height', '28px'),
			A2($elm$html$Html$Attributes$style, 'margin', '0px 16px'),
			A2($elm$html$Html$Attributes$style, 'background-color', 'rgb(224, 224, 224)')
		]),
	_List_Nil);
var $author$project$Pages$CfgDevice$Design$viewPlayTemplate = F2(
	function (config, model) {
		var styles = _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'min-width', '100%'),
				A2($elm$html$Html$Attributes$style, 'min-height', '100%'),
				A2($elm$html$Html$Attributes$style, 'max-width', '1920px'),
				A2($elm$html$Html$Attributes$style, 'max-height', '1080px'),
				A2($elm$html$Html$Attributes$style, 'padding', '0px')
			]);
		var isReady = function () {
			var _v7 = _Utils_Tuple3(
				model.bb,
				$author$project$Reusable$DatePicker$selectedIsoDate(model.a9),
				_Utils_Tuple2(model.aj, model.g1));
			_v7$1:
			while (true) {
				_v7$3:
				while (true) {
					if ((!_v7.a.$) && (!_v7.b.$)) {
						switch (_v7.c.a.$) {
							case 1:
								var _v8 = _v7.c;
								return true;
							case 4:
								switch (_v7.c.b.$) {
									case 1:
										break _v7$1;
									case 4:
										var _v10 = _v7.c;
										return true;
									default:
										break _v7$3;
								}
							default:
								if (_v7.c.b.$ === 1) {
									break _v7$1;
								} else {
									break _v7$3;
								}
						}
					} else {
						break _v7$3;
					}
				}
				return false;
			}
			var _v9 = _v7.c;
			return true;
		}();
		return A2(
			$aforemny$material_components_web_elm$Material$Dialog$dialog,
			A2(
				$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
				$author$project$Pages$CfgDevice$Design$ClosePlayTemplateDialog,
				A2(
					$aforemny$material_components_web_elm$Material$Dialog$setOpen,
					model.er,
					A2($aforemny$material_components_web_elm$Material$Dialog$setAttributes, styles, $aforemny$material_components_web_elm$Material$Dialog$config))),
			{
				kk: (!isReady) ? _List_fromArray(
					[
						function () {
						var attrs = _List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'background', 'red')
							]);
						return A2(
							$aforemny$material_components_web_elm$Material$Button$raised,
							A2(
								$aforemny$material_components_web_elm$Material$Button$setAttributes,
								attrs,
								A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$CfgDevice$Design$ClosePlayTemplateDialog, $aforemny$material_components_web_elm$Material$Button$config)),
							'Close');
					}()
					]) : _List_fromArray(
					[
						function () {
						var attrs = _List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'margin-right', '16px')
							]);
						return A2(
							$aforemny$material_components_web_elm$Material$Button$outlined,
							A2(
								$aforemny$material_components_web_elm$Material$Button$setAttributes,
								attrs,
								A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$CfgDevice$Design$ClosePlayTemplateDialog, $aforemny$material_components_web_elm$Material$Button$config)),
							'Close');
					}(),
						A2(
						$aforemny$material_components_web_elm$Material$Button$raised,
						A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$CfgDevice$Design$ResetSettings, $aforemny$material_components_web_elm$Material$Button$config),
						'Reset'),
						$author$project$Reusable$Separator$viewVertical,
						function () {
						var _v0 = model.H;
						if (!_v0.$) {
							var template = _v0.a;
							return A2(
								$author$project$Reusable$Input$number,
								$author$project$Pages$CfgDevice$Design$GoToSlide(template),
								_List_fromArray(
									[
										$author$project$Reusable$Input$value(
										$jschomay$elm_paginate$Paginate$currentPage(template.G))
									]));
						} else {
							return $elm$html$Html$text('');
						}
					}(),
						function () {
						var isDisabled = function () {
							var _v1 = model.H;
							if (!_v1.$) {
								var template = _v1.a;
								return $jschomay$elm_paginate$Paginate$isFirst(template.G);
							} else {
								return true;
							}
						}();
						return A2(
							$aforemny$material_components_web_elm$Material$IconButton$iconButton,
							A2(
								$aforemny$material_components_web_elm$Material$IconButton$setDisabled,
								isDisabled,
								A2(
									$aforemny$material_components_web_elm$Material$IconButton$setOnClick,
									$author$project$Pages$CfgDevice$Design$HideFrame(1),
									$aforemny$material_components_web_elm$Material$IconButton$config)),
							$aforemny$material_components_web_elm$Material$IconButton$icon('navigate_before'));
					}(),
						function () {
						var isDisabled = function () {
							var _v2 = model.H;
							if (!_v2.$) {
								var template = _v2.a;
								return $jschomay$elm_paginate$Paginate$isLast(template.G);
							} else {
								return true;
							}
						}();
						var attrs = _List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'margin-right', '12px')
							]);
						return A2(
							$aforemny$material_components_web_elm$Material$IconButton$iconButton,
							A2(
								$aforemny$material_components_web_elm$Material$IconButton$setAttributes,
								attrs,
								A2(
									$aforemny$material_components_web_elm$Material$IconButton$setDisabled,
									isDisabled,
									A2(
										$aforemny$material_components_web_elm$Material$IconButton$setOnClick,
										$author$project$Pages$CfgDevice$Design$HideFrame(0),
										$aforemny$material_components_web_elm$Material$IconButton$config))),
							$aforemny$material_components_web_elm$Material$IconButton$icon('navigate_next'));
					}(),
						$author$project$Reusable$Separator$viewVertical,
						A2(
						$author$project$Reusable$Slider$view,
						$author$project$Pages$CfgDevice$Design$LiveTemplateScale,
						_List_fromArray(
							[
								$author$project$Reusable$Slider$min(0.1),
								$author$project$Reusable$Slider$max(0.98),
								$author$project$Reusable$Slider$step(0.01),
								$author$project$Reusable$Slider$value(model.ei),
								$author$project$Reusable$Slider$label('Adjust'),
								$author$project$Reusable$Slider$style(
								_List_fromArray(
									[
										_Utils_Tuple2('width', '200px')
									]))
							]))
					]),
				k_: _List_fromArray(
					[
						function () {
						var _v3 = _Utils_Tuple3(
							model.bb,
							$author$project$Reusable$DatePicker$selectedIsoDate(model.a9),
							_Utils_Tuple3(model.H, model.aj, model.g1));
						_v3$1:
						while (true) {
							_v3$3:
							while (true) {
								if (((!_v3.a.$) && (!_v3.b.$)) && (!_v3.c.a.$)) {
									switch (_v3.c.b.$) {
										case 1:
											var _v4 = _v3.c;
											var template = _v4.a.a;
											return $author$project$Pages$CfgDevice$Design$liveTemplateViewport(
												_List_fromArray(
													[
														$aforemny$material_components_web_elm$Material$CircularProgress$indeterminate($aforemny$material_components_web_elm$Material$CircularProgress$config)
													]));
										case 4:
											switch (_v3.c.c.$) {
												case 1:
													break _v3$1;
												case 4:
													var _v6 = _v3.c;
													var template = _v6.a.a;
													var menuItems = _v6.b.a;
													var itemLists = _v6.c.a;
													return A4(
														$elm$html$Html$Lazy$lazy3,
														$author$project$Pages$CfgDevice$Design$viewLiveTemplate,
														model.ei,
														template,
														{ky: model.b7, cb: itemLists, aj: menuItems, mC: template.z, n: template.n});
												default:
													break _v3$3;
											}
										default:
											if (_v3.c.c.$ === 1) {
												break _v3$1;
											} else {
												break _v3$3;
											}
									}
								} else {
									break _v3$3;
								}
							}
							return A2($author$project$Pages$CfgDevice$Design$viewGatherData, config, model);
						}
						var _v5 = _v3.c;
						var template = _v5.a.a;
						return $author$project$Pages$CfgDevice$Design$liveTemplateViewport(
							_List_fromArray(
								[
									$aforemny$material_components_web_elm$Material$CircularProgress$indeterminate($aforemny$material_components_web_elm$Material$CircularProgress$config)
								]));
					}()
					]),
				na: $elm$core$Maybe$Just('Preview Template')
			});
	});
var $author$project$Pages$CfgDevice$Design$CloseShareEffectDialog = {$: 91};
var $author$project$Pages$CfgDevice$Design$ShareEffect = F2(
	function (a, b) {
		return {$: 38, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Design$viewShareEffectDialog = function (model) {
	return A2(
		$aforemny$material_components_web_elm$Material$Dialog$dialog,
		A2(
			$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
			$author$project$Pages$CfgDevice$Design$CloseShareEffectDialog,
			A2(
				$aforemny$material_components_web_elm$Material$Dialog$setAttributes,
				$author$project$Pages$CfgDevice$Design$dialogStyle,
				A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.cn.a, $aforemny$material_components_web_elm$Material$Dialog$config))),
		{
			kk: _List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$Button$outlined,
					A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$CfgDevice$Design$CloseShareEffectDialog, $aforemny$material_components_web_elm$Material$Button$config),
					'Close'),
					function () {
					var onClick = function () {
						var _v0 = _Utils_Tuple2(model.cn.b, model.a);
						if ((!_v0.a.$) && (_v0.b.$ === 4)) {
							var widget = _v0.a.a;
							var template = _v0.b.a;
							return A2($author$project$Pages$CfgDevice$Design$ShareEffect, template, widget);
						} else {
							return $author$project$Pages$CfgDevice$Design$NoOp;
						}
					}();
					return A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2(
							$aforemny$material_components_web_elm$Material$Button$setDisabled,
							_Utils_eq(onClick, $author$project$Pages$CfgDevice$Design$NoOp),
							A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config)),
						'Confirm');
				}()
				]),
			k_: _List_fromArray(
				[
					$elm$html$Html$text('Are you sure you want to apply the animation effect to all similar widgets in template?')
				]),
			na: $elm$core$Maybe$Just('Share Effect')
		});
};
var $author$project$Pages$CfgDevice$Design$AddSharedStyle = F2(
	function (a, b) {
		return {$: 49, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Design$CloseSharedStyleDialog = {$: 75};
var $author$project$Pages$CfgDevice$Design$isSharedStyleValid = F2(
	function (model, template) {
		var _v0 = model.bz;
		if (!_v0.$) {
			var name = _v0.a;
			return (!$elm$core$String$isEmpty(name)) && (!A2($elm$core$Dict$member, name, template.z));
		} else {
			return false;
		}
	});
var $author$project$Pages$CfgDevice$Design$NewSharedStyleSize = {$: 58};
var $author$project$Pages$CfgDevice$Design$viewEnableSizeCheckbox = function (model) {
	var checkboxState = model.cf ? $aforemny$material_components_web_elm$Material$Checkbox$checked : $aforemny$material_components_web_elm$Material$Checkbox$unchecked;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$aforemny$material_components_web_elm$Material$Checkbox$checkbox(
				A2(
					$aforemny$material_components_web_elm$Material$Checkbox$setOnChange,
					$author$project$Pages$CfgDevice$Design$NewSharedStyleSize,
					A2(
						$aforemny$material_components_web_elm$Material$Checkbox$setState,
						$elm$core$Maybe$Just(checkboxState),
						$aforemny$material_components_web_elm$Material$Checkbox$config))),
				$elm$html$Html$text('Enable Size Editor')
			]));
};
var $author$project$Pages$CfgDevice$Design$NewSharedStyleText = {$: 57};
var $author$project$Pages$CfgDevice$Design$viewEnableTextStyleCheckbox = function (model) {
	var checkboxState = model.dn ? $aforemny$material_components_web_elm$Material$Checkbox$checked : $aforemny$material_components_web_elm$Material$Checkbox$unchecked;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$aforemny$material_components_web_elm$Material$Checkbox$checkbox(
				A2(
					$aforemny$material_components_web_elm$Material$Checkbox$setOnChange,
					$author$project$Pages$CfgDevice$Design$NewSharedStyleText,
					A2(
						$aforemny$material_components_web_elm$Material$Checkbox$setState,
						$elm$core$Maybe$Just(checkboxState),
						$aforemny$material_components_web_elm$Material$Checkbox$config))),
				$elm$html$Html$text('Enable Text Style Editor')
			]));
};
var $author$project$Pages$CfgDevice$Design$NewSharedStyleName = function (a) {
	return {$: 56, a: a};
};
var $author$project$Pages$CfgDevice$Design$viewSharedStyleNameField = F3(
	function (model, template, onEnter) {
		var value = A2($elm$core$Maybe$withDefault, '', model.bz);
		var errText = function () {
			var _v0 = model.bz;
			if (!_v0.$) {
				var name = _v0.a;
				return $elm$core$String$isEmpty(name) ? 'Style name is empty' : ((!A2($author$project$Pages$CfgDevice$Design$isSharedStyleValid, model, template)) ? 'Shared style name already exists' : '');
			} else {
				return '';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$TextField$outlined(
					A2(
						$aforemny$material_components_web_elm$Material$TextField$setValid,
						$elm$core$String$isEmpty(errText),
						A2(
							$aforemny$material_components_web_elm$Material$TextField$setOnInput,
							$author$project$Pages$CfgDevice$Design$NewSharedStyleName,
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setValue,
								$elm$core$Maybe$Just(value),
								A2(
									$aforemny$material_components_web_elm$Material$TextField$setLabel,
									$elm$core$Maybe$Just('New Shared Style'),
									$aforemny$material_components_web_elm$Material$TextField$config))))),
					A2($aforemny$material_components_web_elm$Material$HelperText$helperText, $aforemny$material_components_web_elm$Material$HelperText$config, errText)
				]));
	});
var $author$project$Pages$CfgDevice$Design$viewSharedStyleDialog = F2(
	function (model, template) {
		var onClick = function () {
			var _v0 = _Utils_Tuple2(
				A2($author$project$Pages$CfgDevice$Design$isSharedStyleValid, model, template),
				model.bz);
			if (_v0.a && (!_v0.b.$)) {
				var name = _v0.b.a;
				return A2($author$project$Pages$CfgDevice$Design$AddSharedStyle, template, name);
			} else {
				return $author$project$Pages$CfgDevice$Design$NoOp;
			}
		}();
		return A2(
			$aforemny$material_components_web_elm$Material$Dialog$dialog,
			A2(
				$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
				$author$project$Pages$CfgDevice$Design$CloseSharedStyleDialog,
				A2(
					$aforemny$material_components_web_elm$Material$Dialog$setOpen,
					model.dy,
					A2($aforemny$material_components_web_elm$Material$Dialog$setAttributes, $author$project$Pages$CfgDevice$Design$dialogStyle, $aforemny$material_components_web_elm$Material$Dialog$config))),
			{
				kk: _List_fromArray(
					[
						A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$CfgDevice$Design$CloseSharedStyleDialog, $aforemny$material_components_web_elm$Material$Button$config),
						'Close'),
						A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2(
							$aforemny$material_components_web_elm$Material$Button$setDisabled,
							_Utils_eq(onClick, $author$project$Pages$CfgDevice$Design$NoOp),
							A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config)),
						'Add Shared Style')
					]),
				k_: _List_fromArray(
					[
						A3($author$project$Pages$CfgDevice$Design$viewSharedStyleNameField, model, template, onClick),
						$author$project$Pages$CfgDevice$Design$viewEnableTextStyleCheckbox(model),
						$author$project$Pages$CfgDevice$Design$viewEnableSizeCheckbox(model)
					]),
				na: $elm$core$Maybe$Just('Shared Style')
			});
	});
var $author$project$Pages$CfgDevice$Design$CloseSharedWidgetDialog = {$: 87};
var $author$project$Pages$CfgDevice$Design$ShareWidget = F3(
	function (a, b, c) {
		return {$: 43, a: a, b: b, c: c};
	});
var $author$project$Pages$CfgDevice$Design$isSharedWidgetNameValid = F2(
	function (model, _v0) {
		var widgets = _v0.n;
		var _v1 = model.aV;
		if (!_v1.$) {
			var name = _v1.a;
			return (!$elm$core$String$isEmpty(name)) && (!A2($elm$core$Dict$member, name, widgets));
		} else {
			return false;
		}
	});
var $author$project$Pages$CfgDevice$Design$SharedWidgetName = function (a) {
	return {$: 42, a: a};
};
var $aforemny$material_components_web_elm$Material$TextField$setMaxLength = F2(
	function (maxLength, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{fo: maxLength});
	});
var $author$project$Pages$CfgDevice$Design$viewWidgetNameField = F2(
	function (model, template) {
		var onEnter = function () {
			var _v1 = _Utils_Tuple3(
				model.h,
				model.aV,
				A2($author$project$Pages$CfgDevice$Design$isSharedWidgetNameValid, model, template));
			if (((!_v1.a.$) && (!_v1.b.$)) && _v1.c) {
				var position = _v1.a.a;
				var name = _v1.b.a;
				return A3($author$project$Pages$CfgDevice$Design$ShareWidget, template, position, name);
			} else {
				return $author$project$Pages$CfgDevice$Design$NoOp;
			}
		}();
		var errText = function () {
			var _v0 = model.aV;
			if (_v0.$ === 1) {
				return '';
			} else {
				var name = _v0.a;
				return $elm$core$String$isEmpty(name) ? 'Widget name is empty' : ((!A2($author$project$Pages$CfgDevice$Design$isSharedWidgetNameValid, model, template)) ? 'Widget name already exists' : '');
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$TextField$outlined(
					A2(
						$aforemny$material_components_web_elm$Material$TextField$setAttributes,
						_List_fromArray(
							[
								$author$project$Utils$onEnter(onEnter)
							]),
						A2(
							$aforemny$material_components_web_elm$Material$TextField$setMaxLength,
							$elm$core$Maybe$Just(14),
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setValid,
								$elm$core$String$isEmpty(errText),
								A2(
									$aforemny$material_components_web_elm$Material$TextField$setOnInput,
									$author$project$Pages$CfgDevice$Design$SharedWidgetName,
									A2(
										$aforemny$material_components_web_elm$Material$TextField$setValue,
										model.aV,
										A2(
											$aforemny$material_components_web_elm$Material$TextField$setLabel,
											$elm$core$Maybe$Just('Widget Name'),
											$aforemny$material_components_web_elm$Material$TextField$config))))))),
					A2($aforemny$material_components_web_elm$Material$HelperText$helperText, $aforemny$material_components_web_elm$Material$HelperText$config, errText)
				]));
	});
var $author$project$Pages$CfgDevice$Design$viewSharedWidgetDialog = F2(
	function (model, template) {
		return A2(
			$aforemny$material_components_web_elm$Material$Dialog$dialog,
			A2(
				$aforemny$material_components_web_elm$Material$Dialog$setAttributes,
				$author$project$Pages$CfgDevice$Design$dialogStyle,
				A2(
					$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
					$author$project$Pages$CfgDevice$Design$CloseSharedWidgetDialog,
					A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.dz, $aforemny$material_components_web_elm$Material$Dialog$config))),
			{
				kk: _List_fromArray(
					[
						A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$CfgDevice$Design$CloseSharedWidgetDialog, $aforemny$material_components_web_elm$Material$Button$config),
						'Close'),
						function () {
						var onClick = function () {
							var _v0 = _Utils_Tuple3(
								model.h,
								model.aV,
								A2($author$project$Pages$CfgDevice$Design$isSharedWidgetNameValid, model, template));
							if (((!_v0.a.$) && (!_v0.b.$)) && _v0.c) {
								var position = _v0.a.a;
								var name = _v0.b.a;
								return A3($author$project$Pages$CfgDevice$Design$ShareWidget, template, position, name);
							} else {
								return $author$project$Pages$CfgDevice$Design$NoOp;
							}
						}();
						return A2(
							$aforemny$material_components_web_elm$Material$Button$outlined,
							A2(
								$aforemny$material_components_web_elm$Material$Button$setDisabled,
								_Utils_eq(onClick, $author$project$Pages$CfgDevice$Design$NoOp),
								A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config)),
							'Share');
					}()
					]),
				k_: _List_fromArray(
					[
						A2($author$project$Pages$CfgDevice$Design$viewWidgetNameField, model, template)
					]),
				na: $elm$core$Maybe$Just('Shared Widget')
			});
	});
var $author$project$Pages$CfgDevice$Design$viewStatus = function (status) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'width', '100%'),
				A2($elm$html$Html$Attributes$style, 'text-align', 'center'),
				A2($elm$html$Html$Attributes$style, 'padding', '24px 0px')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(status)
			]));
};
var $author$project$Pages$CfgDevice$Design$CloseSyncBackgroundDialog = {$: 85};
var $author$project$Pages$CfgDevice$Design$SyncFrameBackground = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Design$viewSyncBackgroundDialog = function (model) {
	return A2(
		$aforemny$material_components_web_elm$Material$Dialog$dialog,
		A2(
			$aforemny$material_components_web_elm$Material$Dialog$setAttributes,
			$author$project$Pages$CfgDevice$Design$dialogStyle,
			A2(
				$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
				$author$project$Pages$CfgDevice$Design$CloseSyncBackgroundDialog,
				A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.dE, $aforemny$material_components_web_elm$Material$Dialog$config))),
		{
			kk: _List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$Button$outlined,
					A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$CfgDevice$Design$CloseSyncBackgroundDialog, $aforemny$material_components_web_elm$Material$Button$config),
					'Close'),
					function () {
					var onClick = function () {
						var _v0 = _Utils_Tuple2(model.a, model.ey);
						if ((_v0.a.$ === 4) && (!_v0.b.$)) {
							var template = _v0.a.a;
							var val = _v0.b.a;
							return A2($author$project$Pages$CfgDevice$Design$SyncFrameBackground, template, val);
						} else {
							return $author$project$Pages$CfgDevice$Design$NoOp;
						}
					}();
					return A2(
						$aforemny$material_components_web_elm$Material$Button$raised,
						A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config),
						'Sync');
				}()
				]),
			k_: _List_fromArray(
				[
					$elm$html$Html$text('Are you sure you want to sync the current background settings Sync Bawith all frames?')
				]),
			na: $elm$core$Maybe$Just('Sync Background')
		});
};
var $author$project$Pages$CfgDevice$Design$AddTagName = function (a) {
	return {$: 55, a: a};
};
var $author$project$Pages$CfgDevice$Design$FlipTagMode = {$: 54};
var $author$project$Pages$CfgDevice$Design$TemplateUpdate = function (a) {
	return {$: 46, a: a};
};
var $author$project$Pages$CfgDevice$Design$Tooltip = function (a) {
	return {$: 3, a: a};
};
var $author$project$Reusable$Tooltip$Bottom = 1;
var $author$project$Reusable$Tooltip$Position = function (a) {
	return {$: 1, a: a};
};
var $author$project$Reusable$Tooltip$bottom = $author$project$Reusable$Tooltip$Position(1);
var $author$project$Reusable$Tooltip$Label = function (a) {
	return {$: 0, a: a};
};
var $author$project$Reusable$Tooltip$label = function (str) {
	return $author$project$Reusable$Tooltip$Label(str);
};
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $elm$core$Set$size = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$size(dict);
};
var $author$project$Reusable$Input$string = F3(
	function (currVal, toMsg, set) {
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '60px'),
					A2($elm$html$Html$Attributes$style, 'font-size', '14px'),
					$elm$html$Html$Attributes$value(currVal),
					$elm$html$Html$Attributes$maxlength(10),
					$author$project$Utils$onEnter(set),
					$elm$html$Html$Events$onInput(toMsg)
				]),
			_List_Nil);
	});
var $author$project$Reusable$Tooltip$CloseTooltip = function (a) {
	return {$: 1, a: a};
};
var $author$project$Reusable$Tooltip$OpenTooltip = function (a) {
	return {$: 0, a: a};
};
var $author$project$Reusable$Tooltip$collect = F2(
	function (attr, config) {
		if (!attr.$) {
			var str = attr.a;
			return _Utils_update(
				config,
				{c9: str});
		} else {
			var pos = attr.a;
			return _Utils_update(
				config,
				{x: pos});
		}
	});
var $rtfeldman$elm_css$Css$dotted = {aa: 0, cw: 0, eL: 'dotted'};
var $rtfeldman$elm_css$Css$inlineBlock = {D: 0, eL: 'inline-block'};
var $rtfeldman$elm_css$Html$Styled$Events$onMouseOut = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'mouseout',
		$elm$json$Json$Decode$succeed(msg));
};
var $rtfeldman$elm_css$Html$Styled$Events$onMouseOver = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'mouseover',
		$elm$json$Json$Decode$succeed(msg));
};
var $rtfeldman$elm_css$Css$borderColor4 = F4(
	function (c1, c2, c3, c4) {
		var value = A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[c1.eL, c2.eL, c3.eL, c4.eL]));
		return A2($rtfeldman$elm_css$Css$property, 'border-color', value);
	});
var $rtfeldman$elm_css$Css$borderStyle = $rtfeldman$elm_css$Css$prop1('border-style');
var $rtfeldman$elm_css$Css$borderWidth = $rtfeldman$elm_css$Css$prop1('border-width');
var $rtfeldman$elm_css$Css$bottom = $rtfeldman$elm_css$Css$prop1('bottom');
var $author$project$Reusable$Tooltip$arrowStyle = function (pos) {
	return _Utils_ap(
		_List_fromArray(
			[
				A2($rtfeldman$elm_css$Css$property, 'content', '\"\"'),
				$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
				$rtfeldman$elm_css$Css$left(
				$rtfeldman$elm_css$Css$pct(50)),
				$rtfeldman$elm_css$Css$marginLeft(
				$rtfeldman$elm_css$Css$px(-5)),
				$rtfeldman$elm_css$Css$borderWidth(
				$rtfeldman$elm_css$Css$px(5)),
				$rtfeldman$elm_css$Css$borderStyle($rtfeldman$elm_css$Css$solid)
			]),
		function () {
			switch (pos) {
				case 0:
					return _List_fromArray(
						[
							A4(
							$rtfeldman$elm_css$Css$borderColor4,
							$rtfeldman$elm_css$Css$hex('#555'),
							$rtfeldman$elm_css$Css$transparent,
							$rtfeldman$elm_css$Css$transparent,
							$rtfeldman$elm_css$Css$transparent),
							$rtfeldman$elm_css$Css$top(
							$rtfeldman$elm_css$Css$pct(100))
						]);
				case 1:
					return _List_fromArray(
						[
							A4(
							$rtfeldman$elm_css$Css$borderColor4,
							$rtfeldman$elm_css$Css$transparent,
							$rtfeldman$elm_css$Css$transparent,
							$rtfeldman$elm_css$Css$hex('#555'),
							$rtfeldman$elm_css$Css$transparent),
							$rtfeldman$elm_css$Css$bottom(
							$rtfeldman$elm_css$Css$pct(100))
						]);
				case 2:
					return _List_fromArray(
						[
							A4(
							$rtfeldman$elm_css$Css$borderColor4,
							$rtfeldman$elm_css$Css$transparent,
							$rtfeldman$elm_css$Css$hex('#555'),
							$rtfeldman$elm_css$Css$transparent,
							$rtfeldman$elm_css$Css$transparent),
							$rtfeldman$elm_css$Css$right(
							$rtfeldman$elm_css$Css$pct(100))
						]);
				default:
					return _List_fromArray(
						[
							A4(
							$rtfeldman$elm_css$Css$borderColor4,
							$rtfeldman$elm_css$Css$transparent,
							$rtfeldman$elm_css$Css$transparent,
							$rtfeldman$elm_css$Css$transparent,
							$rtfeldman$elm_css$Css$hex('#555')),
							$rtfeldman$elm_css$Css$left(
							$rtfeldman$elm_css$Css$pct(100))
						]);
			}
		}());
};
var $rtfeldman$elm_css$Css$marginRight = $rtfeldman$elm_css$Css$prop1('margin-right');
var $author$project$Reusable$Tooltip$viewTooltipText = F2(
	function (config, isOpen) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$px(120)),
							$rtfeldman$elm_css$Css$backgroundColor(
							$rtfeldman$elm_css$Css$hex('#555')),
							$rtfeldman$elm_css$Css$color(
							$rtfeldman$elm_css$Css$hex('#FFF')),
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
							A2(
							$rtfeldman$elm_css$Css$padding2,
							$rtfeldman$elm_css$Css$px(5),
							$rtfeldman$elm_css$Css$px(0)),
							$rtfeldman$elm_css$Css$borderRadius(
							$rtfeldman$elm_css$Css$px(6)),
							$rtfeldman$elm_css$Css$Transitions$transition(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$Transitions$opacity(300)
								]))
						])),
					function () {
					var _v0 = config.x;
					switch (_v0) {
						case 0:
							return $rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
										$rtfeldman$elm_css$Css$zIndex(
										$rtfeldman$elm_css$Css$int(1)),
										$rtfeldman$elm_css$Css$bottom(
										$rtfeldman$elm_css$Css$pct(125)),
										$rtfeldman$elm_css$Css$left(
										$rtfeldman$elm_css$Css$pct(50)),
										$rtfeldman$elm_css$Css$marginLeft(
										$rtfeldman$elm_css$Css$px(-60)),
										A2(
										$rtfeldman$elm_css$Css$pseudoClass,
										':after',
										$author$project$Reusable$Tooltip$arrowStyle(config.x))
									]));
						case 1:
							return $rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
										$rtfeldman$elm_css$Css$zIndex(
										$rtfeldman$elm_css$Css$int(1)),
										$rtfeldman$elm_css$Css$top(
										$rtfeldman$elm_css$Css$pct(125)),
										$rtfeldman$elm_css$Css$left(
										$rtfeldman$elm_css$Css$pct(50)),
										$rtfeldman$elm_css$Css$marginLeft(
										$rtfeldman$elm_css$Css$px(-60)),
										A2(
										$rtfeldman$elm_css$Css$pseudoClass,
										':before',
										$author$project$Reusable$Tooltip$arrowStyle(config.x))
									]));
						case 2:
							return $rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
										$rtfeldman$elm_css$Css$zIndex(
										$rtfeldman$elm_css$Css$int(1)),
										$rtfeldman$elm_css$Css$left(
										$rtfeldman$elm_css$Css$pct(100)),
										$rtfeldman$elm_css$Css$marginRight(
										$rtfeldman$elm_css$Css$px(-60)),
										A2(
										$rtfeldman$elm_css$Css$pseudoClass,
										':before',
										$author$project$Reusable$Tooltip$arrowStyle(config.x))
									]));
						default:
							return $rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
										$rtfeldman$elm_css$Css$zIndex(
										$rtfeldman$elm_css$Css$int(1)),
										$rtfeldman$elm_css$Css$right(
										$rtfeldman$elm_css$Css$pct(100)),
										$rtfeldman$elm_css$Css$marginLeft(
										$rtfeldman$elm_css$Css$px(-60)),
										A2(
										$rtfeldman$elm_css$Css$pseudoClass,
										':before',
										$author$project$Reusable$Tooltip$arrowStyle(config.x))
									]));
					}
				}(),
					isOpen ? $rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$visibility($rtfeldman$elm_css$Css$visible),
							$rtfeldman$elm_css$Css$opacity(
							$rtfeldman$elm_css$Css$int(1))
						])) : $rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$visibility($rtfeldman$elm_css$Css$hidden),
							$rtfeldman$elm_css$Css$opacity(
							$rtfeldman$elm_css$Css$int(0))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(config.c9)
				]));
	});
var $author$project$Reusable$Tooltip$view = F5(
	function (toMsg, index, model, attrs, node) {
		var isOpen = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Dict$get, index, model));
		var config = A3(
			$elm$core$List$foldl,
			$author$project$Reusable$Tooltip$collect,
			{c9: 'Tooltip', x: 1},
			attrs);
		return $rtfeldman$elm_css$Html$Styled$toUnstyled(
			A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
								$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
								A3(
								$rtfeldman$elm_css$Css$borderBottom3,
								$rtfeldman$elm_css$Css$px(1),
								$rtfeldman$elm_css$Css$dotted,
								$rtfeldman$elm_css$Css$hex('#0000000'))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onMouseOver(
								toMsg(
									$author$project$Reusable$Tooltip$OpenTooltip(index))),
								$rtfeldman$elm_css$Html$Styled$Events$onMouseOut(
								toMsg(
									$author$project$Reusable$Tooltip$CloseTooltip(index)))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(node)
							])),
						A2($author$project$Reusable$Tooltip$viewTooltipText, config, isOpen)
					])));
	});
var $author$project$Pages$CfgDevice$Design$viewAddTag = F2(
	function (model, template) {
		var viewButton = function (msg) {
			return A5(
				$author$project$Reusable$Tooltip$view,
				$author$project$Pages$CfgDevice$Design$Tooltip,
				_List_fromArray(
					[0]),
				model.fQ,
				_List_fromArray(
					[
						$author$project$Reusable$Tooltip$label('Add New Tag'),
						$author$project$Reusable$Tooltip$bottom
					]),
				A2(
					$aforemny$material_components_web_elm$Material$IconButton$iconButton,
					A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, msg, $aforemny$material_components_web_elm$Material$IconButton$config),
					$aforemny$material_components_web_elm$Material$IconButton$icon('add_circle_outline')));
		};
		var insTag = $elm$core$String$isEmpty(model.bO) ? $author$project$Pages$CfgDevice$Design$FlipTagMode : $author$project$Pages$CfgDevice$Design$TemplateUpdate(
			_Utils_update(
				template,
				{
					aX: A2($elm$core$Set$insert, model.bO, template.aX)
				}));
		var _v0 = model.cF;
		if (_v0) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'padding', '0px 10px'),
						A2($elm$html$Html$Attributes$style, 'background', 'rgba(0,0,0,0.1)'),
						A2($elm$html$Html$Attributes$style, 'border-radius', '20px')
					]),
				_List_fromArray(
					[
						A3($author$project$Reusable$Input$string, model.bO, $author$project$Pages$CfgDevice$Design$AddTagName, insTag),
						viewButton(insTag)
					]));
		} else {
			return ($elm$core$Set$size(template.aX) >= 6) ? $elm$html$Html$text('') : viewButton($author$project$Pages$CfgDevice$Design$FlipTagMode);
		}
	});
var $author$project$Pages$CfgDevice$Design$viewTag = F2(
	function (template, label) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mdl-chip mdl-chip--deletable'),
					A2($elm$html$Html$Attributes$style, 'margin-right', '4px'),
					A2($elm$html$Html$Attributes$style, 'margin-bottom', '4px')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mdl-chip__text')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class('mdl-chip__action'),
							$elm$html$Html$Events$onClick(
							$author$project$Pages$CfgDevice$Design$TemplateUpdate(
								_Utils_update(
									template,
									{
										aX: A2($elm$core$Set$remove, label, template.aX)
									})))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('material-icons')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('cancel')
								]))
						]))
				]));
	});
var $author$project$Pages$CfgDevice$Design$viewTags = function (model) {
	var _v0 = model.a;
	if (_v0.$ === 4) {
		var template = _v0.a;
		return $author$project$Reusable$Flex$viewVertical(
			_List_fromArray(
				[
					$author$project$Reusable$Header$sectionHeader('Tags'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '100%'),
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'flex-wrap', 'wrap'),
							A2($elm$html$Html$Attributes$style, 'align-items', 'center')
						]),
					_Utils_ap(
						A2(
							$elm$core$List$map,
							$author$project$Pages$CfgDevice$Design$viewTag(template),
							$elm$core$Set$toList(template.aX)),
						_List_fromArray(
							[
								A2($author$project$Pages$CfgDevice$Design$viewAddTag, model, template)
							])))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Reusable$Flex$viewCompactHorizontal = function (nodes) {
	return $rtfeldman$elm_css$Html$Styled$toUnstyled(
		A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
						]))
				]),
			A2($elm$core$List$map, $rtfeldman$elm_css$Html$Styled$fromUnstyled, nodes)));
};
var $author$project$Pages$CfgDevice$Design$OpenPlayTemplateDialog = F2(
	function (a, b) {
		return {$: 82, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Design$viewPlayTemplateButton = F2(
	function (config, model) {
		var onClick = A2($author$project$Pages$CfgDevice$Design$OpenPlayTemplateDialog, config.an, config.iB);
		var isDisabled = _Utils_eq(
			$author$project$DataState$toMaybe(model.a),
			$elm$core$Maybe$Nothing);
		return A5(
			$author$project$Reusable$Tooltip$view,
			$author$project$Pages$CfgDevice$Design$Tooltip,
			_List_fromArray(
				[9999]),
			model.fQ,
			_List_fromArray(
				[
					$author$project$Reusable$Tooltip$label('Preview Template'),
					$author$project$Reusable$Tooltip$bottom
				]),
			A2(
				$aforemny$material_components_web_elm$Material$IconButton$iconButton,
				A2(
					$aforemny$material_components_web_elm$Material$IconButton$setDisabled,
					isDisabled,
					A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, onClick, $aforemny$material_components_web_elm$Material$IconButton$config)),
				$aforemny$material_components_web_elm$Material$IconButton$icon('play_arrow')));
	});
var $author$project$Pages$CfgDevice$Design$viewSaveButton = function (model) {
	var onClick = function () {
		var _v0 = $author$project$DataState$toMaybe(model.a);
		if (!_v0.$) {
			var template = _v0.a;
			return A2(
				$author$project$Pages$CfgDevice$Design$PublishTemplate,
				template,
				{hi: false});
		} else {
			return $author$project$Pages$CfgDevice$Design$NoOp;
		}
	}();
	return A5(
		$author$project$Reusable$Tooltip$view,
		$author$project$Pages$CfgDevice$Design$Tooltip,
		_List_fromArray(
			[9998]),
		model.fQ,
		_List_fromArray(
			[
				$author$project$Reusable$Tooltip$label('Save Template'),
				$author$project$Reusable$Tooltip$bottom
			]),
		A2(
			$aforemny$material_components_web_elm$Material$IconButton$iconButton,
			A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, onClick, $aforemny$material_components_web_elm$Material$IconButton$config),
			$aforemny$material_components_web_elm$Material$IconButton$icon('save')));
};
var $author$project$Pages$CfgDevice$Design$viewSaveButtonContainer = function (model) {
	var _v0 = model.eB;
	if (!_v0) {
		return $author$project$Pages$CfgDevice$Design$viewSaveButton(model);
	} else {
		return $aforemny$material_components_web_elm$Material$CircularProgress$indeterminate($aforemny$material_components_web_elm$Material$CircularProgress$config);
	}
};
var $author$project$Select$HelpText = function (a) {
	return {$: 5, a: a};
};
var $author$project$Select$helpText = function (str) {
	return $author$project$Select$HelpText(str);
};
var $author$project$Pages$CfgDevice$Design$selectTemplateFilter = function (template) {
	return template.g8 + ('-' + A2(
		$elm$core$Basics$composeR,
		$elm$core$Set$toList,
		$elm$core$String$join(' '))(template.aX));
};
var $author$project$Pages$CfgDevice$Design$viewSelectTemplate = F2(
	function (config, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'height', '100%'),
					A2($elm$html$Html$Attributes$style, 'margin-left', '12px'),
					A2($elm$html$Html$Attributes$style, 'width', '200px'),
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'center')
				]),
			_List_fromArray(
				[
					A5(
					$author$project$Select$view,
					$author$project$Pages$CfgDevice$Design$Select,
					_List_fromArray(
						[0]),
					model.r,
					{
						dS: F2(
							function (a, b) {
								return _Utils_eq(a.g8, b.g8);
							}),
						d8: $author$project$Pages$CfgDevice$Design$selectTemplateFilter,
						ep: function ($) {
							return $.g8;
						}
					},
					_List_fromArray(
						[
							$author$project$Select$label('Choose Template'),
							$author$project$Select$searchable,
							$author$project$Select$options(model.al),
							$author$project$Select$onSelect(
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.g8;
								},
								$author$project$Pages$CfgDevice$Design$ReqTemplate)),
							$author$project$Select$value(
							A2(
								$elm$core$Maybe$andThen,
								function (a) {
									return $elm$core$Maybe$Just(
										A2($author$project$Template$Core$MinimalTemplate, a.g8, a.aX));
								},
								$author$project$DataState$toMaybe(model.a))),
							$author$project$Select$helpText(
							$elm$core$List$isEmpty(model.al) ? $elm$core$Maybe$Just('Empty/Loading') : $elm$core$Maybe$Nothing)
						]))
				]));
	});
var $author$project$Pages$CfgDevice$Design$CloseTaskbarMenu = {$: 113};
var $author$project$Pages$CfgDevice$Design$OpenTaskbarMenu = {$: 112};
var $aforemny$material_components_web_elm$Material$List$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$List$config = {fZ: _List_Nil, f4: false, gk: false, g9: false, hS: false, nl: false, h0: false};
var $aforemny$material_components_web_elm$Material$Menu$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Menu$config = {fZ: _List_Nil, hf: $elm$core$Maybe$Nothing, a6: false, hy: false};
var $aforemny$material_components_web_elm$Material$List$avatarListCs = function (_v0) {
	var avatarList = _v0.f4;
	return avatarList ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-list--avatar-list')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$List$clickHandler = function (listItems) {
	var getOnClick = function (listItem_) {
		switch (listItem_.$) {
			case 0:
				var onClick = listItem_.a.he;
				return $elm$core$Maybe$Just(onClick);
			case 1:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	};
	var nthOnClick = function (index) {
		return A2(
			$elm$core$Maybe$andThen,
			$elm$core$Basics$identity,
			$elm$core$List$head(
				A2(
					$elm$core$List$drop,
					index,
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						A2($elm$core$List$map, getOnClick, listItems)))));
	};
	var mergedClickHandler = A2(
		$elm$json$Json$Decode$andThen,
		function (index) {
			var _v0 = nthOnClick(index);
			if (!_v0.$) {
				var msg_ = _v0.a;
				return $elm$json$Json$Decode$succeed(msg_);
			} else {
				return $elm$json$Json$Decode$fail('');
			}
		},
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['detail', 'index']),
			$elm$json$Json$Decode$int));
	return $elm$core$Maybe$Just(
		A2($elm$html$Html$Events$on, 'MDCList:action', mergedClickHandler));
};
var $aforemny$material_components_web_elm$Material$List$denseCs = function (_v0) {
	var dense = _v0.gk;
	return dense ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-list--dense')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$List$nonInteractiveCs = function (_v0) {
	var nonInteractive = _v0.g9;
	return nonInteractive ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-list--non-interactive')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$List$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-list'));
var $aforemny$material_components_web_elm$Material$List$selectedIndexProp = function (listItems) {
	var selectedIndex = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, listItem_) {
					switch (listItem_.$) {
						case 0:
							var selection = listItem_.a.mx;
							return (!_Utils_eq(selection, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(index) : $elm$core$Maybe$Nothing;
						case 1:
							return $elm$core$Maybe$Nothing;
						default:
							return $elm$core$Maybe$Nothing;
					}
				}),
			A2(
				$elm$core$List$filter,
				function (listItem_) {
					switch (listItem_.$) {
						case 0:
							return true;
						case 1:
							return false;
						default:
							return false;
					}
				},
				listItems)));
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'selectedIndex',
			A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, selectedIndex)));
};
var $aforemny$material_components_web_elm$Material$List$twoLineCs = function (_v0) {
	var twoLine = _v0.hS;
	return twoLine ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-list--two-line')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$List$wrapFocusProp = function (_v0) {
	var wrapFocus = _v0.h0;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'wrapFocus',
			$elm$json$Json$Encode$bool(wrapFocus)));
};
var $aforemny$material_components_web_elm$Material$List$list = F3(
	function (config_, firstListItem, remainingListItems) {
		var additionalAttributes = config_.fZ;
		var listItems = A2($elm$core$List$cons, firstListItem, remainingListItems);
		return A3(
			$elm$html$Html$node,
			'mdc-list',
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$List$rootCs,
							$aforemny$material_components_web_elm$Material$List$nonInteractiveCs(config_),
							$aforemny$material_components_web_elm$Material$List$denseCs(config_),
							$aforemny$material_components_web_elm$Material$List$avatarListCs(config_),
							$aforemny$material_components_web_elm$Material$List$twoLineCs(config_),
							$aforemny$material_components_web_elm$Material$List$wrapFocusProp(config_),
							$aforemny$material_components_web_elm$Material$List$clickHandler(listItems),
							$aforemny$material_components_web_elm$Material$List$selectedIndexProp(listItems)
						])),
				additionalAttributes),
			A2(
				$elm$core$List$map,
				function (listItem_) {
					switch (listItem_.$) {
						case 0:
							var node = listItem_.a.aJ;
							return node;
						case 1:
							var node = listItem_.a;
							return node;
						default:
							var node = listItem_.a;
							return node;
					}
				},
				listItems));
	});
var $aforemny$material_components_web_elm$Material$Menu$setAttributes = F2(
	function (additionalAttributes, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{fZ: additionalAttributes});
	});
var $aforemny$material_components_web_elm$Material$Menu$setOnClose = F2(
	function (onClose, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{
				hf: $elm$core$Maybe$Just(onClose)
			});
	});
var $aforemny$material_components_web_elm$Material$Menu$setOpen = F2(
	function (open, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{a6: open});
	});
var $aforemny$material_components_web_elm$Material$List$setWrapFocus = F2(
	function (wrapFocus, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{h0: wrapFocus});
	});
var $aforemny$material_components_web_elm$Material$List$Divider$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$List$Divider$config = {fZ: _List_Nil, gS: false, hm: false};
var $aforemny$material_components_web_elm$Material$List$Item$Internal$ListItemDivider = function (a) {
	return {$: 1, a: a};
};
var $aforemny$material_components_web_elm$Material$List$Divider$insetCs = function (_v0) {
	var inset = _v0.gS;
	return inset ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-list-divider--inset')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$List$Divider$listDividerCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-list-divider'));
var $aforemny$material_components_web_elm$Material$List$Divider$paddedCs = function (_v0) {
	var padded = _v0.hm;
	return padded ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-list-divider--padded')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$List$Divider$separatorRoleAttr = $elm$core$Maybe$Just(
	A2($elm$html$Html$Attributes$attribute, 'role', 'separator'));
var $aforemny$material_components_web_elm$Material$List$Divider$listItem = function (config_) {
	var additionalAttributes = config_.fZ;
	return $aforemny$material_components_web_elm$Material$List$Item$Internal$ListItemDivider(
		A2(
			$elm$html$Html$li,
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$List$Divider$listDividerCs,
							$aforemny$material_components_web_elm$Material$List$Divider$separatorRoleAttr,
							$aforemny$material_components_web_elm$Material$List$Divider$insetCs(config_),
							$aforemny$material_components_web_elm$Material$List$Divider$paddedCs(config_)
						])),
				additionalAttributes),
			_List_Nil));
};
var $author$project$Pages$CfgDevice$Design$viewListDivider = $aforemny$material_components_web_elm$Material$List$Divider$listItem($aforemny$material_components_web_elm$Material$List$Divider$config);
var $aforemny$material_components_web_elm$Material$List$Item$Internal$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$List$Item$config = {
	fZ: _List_Nil,
	d$: false,
	ed: $elm$core$Maybe$Nothing,
	aJ: $elm$html$Html$text(''),
	he: $elm$core$Maybe$Nothing,
	mx: $elm$core$Maybe$Nothing,
	hN: $elm$core$Maybe$Nothing
};
var $aforemny$material_components_web_elm$Material$List$Item$Internal$ListItem = function (a) {
	return {$: 0, a: a};
};
var $aforemny$material_components_web_elm$Material$List$Item$Internal$Activated = 1;
var $aforemny$material_components_web_elm$Material$List$Item$activatedCs = function (_v0) {
	var selection = _v0.mx;
	return _Utils_eq(
		selection,
		$elm$core$Maybe$Just(1)) ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-list-item--activated')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$List$Item$ariaSelectedAttr = function (_v0) {
	var selection = _v0.mx;
	return (!_Utils_eq(selection, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(
		A2($elm$html$Html$Attributes$attribute, 'aria-selected', 'true')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$List$Item$disabledCs = function (_v0) {
	var disabled = _v0.d$;
	return disabled ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-list-item--disabled')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$List$Item$hrefAttr = function (_v0) {
	var href = _v0.ed;
	return A2($elm$core$Maybe$map, $elm$html$Html$Attributes$href, href);
};
var $aforemny$material_components_web_elm$Material$List$Item$listItemCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-list-item'));
var $aforemny$material_components_web_elm$Material$List$Item$Internal$Selected = 0;
var $aforemny$material_components_web_elm$Material$List$Item$selectedCs = function (_v0) {
	var selection = _v0.mx;
	return _Utils_eq(
		selection,
		$elm$core$Maybe$Just(0)) ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-list-item--selected')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$List$Item$targetAttr = function (_v0) {
	var href = _v0.ed;
	var target = _v0.hN;
	return (!_Utils_eq(href, $elm$core$Maybe$Nothing)) ? A2($elm$core$Maybe$map, $elm$html$Html$Attributes$target, target) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$List$Item$listItemView = F2(
	function (config_, nodes) {
		var additionalAttributes = config_.fZ;
		var href = config_.ed;
		return function (attributes) {
			return (!_Utils_eq(href, $elm$core$Maybe$Nothing)) ? A3(
				$elm$html$Html$node,
				'mdc-list-item',
				_List_Nil,
				_List_fromArray(
					[
						A2($elm$html$Html$a, attributes, nodes)
					])) : A3($elm$html$Html$node, 'mdc-list-item', attributes, nodes);
		}(
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$List$Item$listItemCs,
							$aforemny$material_components_web_elm$Material$List$Item$hrefAttr(config_),
							$aforemny$material_components_web_elm$Material$List$Item$targetAttr(config_),
							$aforemny$material_components_web_elm$Material$List$Item$disabledCs(config_),
							$aforemny$material_components_web_elm$Material$List$Item$selectedCs(config_),
							$aforemny$material_components_web_elm$Material$List$Item$activatedCs(config_),
							$aforemny$material_components_web_elm$Material$List$Item$ariaSelectedAttr(config_)
						])),
				additionalAttributes));
	});
var $aforemny$material_components_web_elm$Material$List$Item$listItem = F2(
	function (_v0, nodes) {
		var config_ = _v0;
		var additionalAttributes = config_.fZ;
		var href = config_.ed;
		return $aforemny$material_components_web_elm$Material$List$Item$Internal$ListItem(
			_Utils_update(
				config_,
				{
					aJ: A2($aforemny$material_components_web_elm$Material$List$Item$listItemView, config_, nodes)
				}));
	});
var $aforemny$material_components_web_elm$Material$List$Item$setDisabled = F2(
	function (disabled, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{d$: disabled});
	});
var $aforemny$material_components_web_elm$Material$List$Item$setOnClick = F2(
	function (onClick, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{
				he: $elm$core$Maybe$Just(onClick)
			});
	});
var $author$project$Pages$CfgDevice$Design$viewTaskbarAutoSaveOption = function (model) {
	var onClick = function () {
		var _v0 = $author$project$DataState$toMaybe(model.a);
		if (!_v0.$) {
			var template = _v0.a;
			return $author$project$Pages$CfgDevice$Design$TemplateUpdate(
				_Utils_update(
					template,
					{eh: !template.eh}));
		} else {
			return $author$project$Pages$CfgDevice$Design$NoOp;
		}
	}();
	return A2(
		$aforemny$material_components_web_elm$Material$List$Item$listItem,
		A2(
			$aforemny$material_components_web_elm$Material$List$Item$setDisabled,
			_Utils_eq(onClick, $author$project$Pages$CfgDevice$Design$NoOp),
			A2($aforemny$material_components_web_elm$Material$List$Item$setOnClick, onClick, $aforemny$material_components_web_elm$Material$List$Item$config)),
		_List_fromArray(
			[
				function (a) {
				return A2(
					$aforemny$material_components_web_elm$Material$Icon$icon,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '48px')
						]),
					a);
			}(
				A2(
					$elm$core$Maybe$withDefault,
					'check_box_outline_blank',
					A2(
						$elm$core$Maybe$andThen,
						function (isLive) {
							return isLive ? $elm$core$Maybe$Just('check_box_outline') : $elm$core$Maybe$Just('check_box_outline_blank');
						},
						A2(
							$elm$core$Maybe$andThen,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$Maybe$Just,
								function ($) {
									return $.eh;
								}),
							$author$project$DataState$toMaybe(model.a))))),
				$elm$html$Html$text('Auto Save')
			]));
};
var $author$project$Pages$CfgDevice$Design$CleanupTemplate = function (a) {
	return {$: 47, a: a};
};
var $author$project$Pages$CfgDevice$Design$viewTaskbarCleanupOption = function (model) {
	var onClick = function () {
		var _v0 = model.a;
		if (_v0.$ === 4) {
			var template = _v0.a;
			return $author$project$Pages$CfgDevice$Design$CleanupTemplate(template);
		} else {
			return $author$project$Pages$CfgDevice$Design$NoOp;
		}
	}();
	return A2(
		$aforemny$material_components_web_elm$Material$List$Item$listItem,
		A2(
			$aforemny$material_components_web_elm$Material$List$Item$setDisabled,
			_Utils_eq(onClick, $author$project$Pages$CfgDevice$Design$NoOp),
			A2($aforemny$material_components_web_elm$Material$List$Item$setOnClick, onClick, $aforemny$material_components_web_elm$Material$List$Item$config)),
		_List_fromArray(
			[
				$elm$html$Html$text('Cleanup')
			]));
};
var $author$project$Pages$CfgDevice$Design$viewTaskbarCreateNewOption = A2(
	$aforemny$material_components_web_elm$Material$List$Item$listItem,
	A2(
		$aforemny$material_components_web_elm$Material$List$Item$setOnClick,
		$author$project$Pages$CfgDevice$Design$OpenTemplateDialog(0),
		$aforemny$material_components_web_elm$Material$List$Item$config),
	_List_fromArray(
		[
			$elm$html$Html$text('Create New')
		]));
var $author$project$Pages$CfgDevice$Design$OpenDelTemplateDialog = {$: 70};
var $author$project$Pages$CfgDevice$Design$viewTaskbarDeleteOption = function (model) {
	var onClick = function () {
		var _v0 = $author$project$DataState$toMaybe(model.a);
		if (!_v0.$) {
			return $author$project$Pages$CfgDevice$Design$OpenDelTemplateDialog;
		} else {
			return $author$project$Pages$CfgDevice$Design$NoOp;
		}
	}();
	return A2(
		$aforemny$material_components_web_elm$Material$List$Item$listItem,
		A2(
			$aforemny$material_components_web_elm$Material$List$Item$setDisabled,
			_Utils_eq(onClick, $author$project$Pages$CfgDevice$Design$NoOp),
			A2($aforemny$material_components_web_elm$Material$List$Item$setOnClick, onClick, $aforemny$material_components_web_elm$Material$List$Item$config)),
		_List_fromArray(
			[
				$elm$html$Html$text('Delete')
			]));
};
var $author$project$Pages$CfgDevice$Design$DuplicateMode = 2;
var $author$project$Pages$CfgDevice$Design$viewTaskbarDuplicateOption = function (model) {
	var onClick = function () {
		var _v0 = model.a;
		if (_v0.$ === 4) {
			return $author$project$Pages$CfgDevice$Design$OpenTemplateDialog(2);
		} else {
			return $author$project$Pages$CfgDevice$Design$NoOp;
		}
	}();
	return A2(
		$aforemny$material_components_web_elm$Material$List$Item$listItem,
		A2(
			$aforemny$material_components_web_elm$Material$List$Item$setDisabled,
			_Utils_eq(onClick, $author$project$Pages$CfgDevice$Design$NoOp),
			A2($aforemny$material_components_web_elm$Material$List$Item$setOnClick, onClick, $aforemny$material_components_web_elm$Material$List$Item$config)),
		_List_fromArray(
			[
				$elm$html$Html$text('Duplicate')
			]));
};
var $aforemny$material_components_web_elm$Material$List$Item$setAttributes = F2(
	function (additionalAttributes, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{fZ: additionalAttributes});
	});
var $author$project$Pages$CfgDevice$Design$viewTaskbarPartiallyFillOption = function (model) {
	var onClick = function () {
		var _v0 = $author$project$DataState$toMaybe(model.a);
		if (!_v0.$) {
			var template = _v0.a;
			return $author$project$Pages$CfgDevice$Design$TemplateUpdate(
				_Utils_update(
					template,
					{ho: !template.ho}));
		} else {
			return $author$project$Pages$CfgDevice$Design$NoOp;
		}
	}();
	return A2(
		$aforemny$material_components_web_elm$Material$List$Item$listItem,
		A2(
			$aforemny$material_components_web_elm$Material$List$Item$setAttributes,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'min-width', '125px')
				]),
			A2(
				$aforemny$material_components_web_elm$Material$List$Item$setDisabled,
				_Utils_eq(onClick, $author$project$Pages$CfgDevice$Design$NoOp),
				A2($aforemny$material_components_web_elm$Material$List$Item$setOnClick, onClick, $aforemny$material_components_web_elm$Material$List$Item$config))),
		_List_fromArray(
			[
				function (a) {
				return A2(
					$aforemny$material_components_web_elm$Material$Icon$icon,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '48px')
						]),
					a);
			}(
				A2(
					$elm$core$Maybe$withDefault,
					'check_box_outline_blank',
					A2(
						$elm$core$Maybe$andThen,
						function (isLive) {
							return isLive ? $elm$core$Maybe$Just('check_box_outline') : $elm$core$Maybe$Just('check_box_outline_blank');
						},
						A2(
							$elm$core$Maybe$andThen,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$Maybe$Just,
								function ($) {
									return $.ho;
								}),
							$author$project$DataState$toMaybe(model.a))))),
				$elm$html$Html$text('Partially Fill')
			]));
};
var $author$project$Pages$CfgDevice$Design$RenameMode = 1;
var $author$project$Pages$CfgDevice$Design$viewTaskbarRenameOption = function (model) {
	var onClick = function () {
		var _v0 = model.a;
		if (_v0.$ === 4) {
			return $author$project$Pages$CfgDevice$Design$OpenTemplateDialog(1);
		} else {
			return $author$project$Pages$CfgDevice$Design$NoOp;
		}
	}();
	return A2(
		$aforemny$material_components_web_elm$Material$List$Item$listItem,
		A2(
			$aforemny$material_components_web_elm$Material$List$Item$setDisabled,
			_Utils_eq(onClick, $author$project$Pages$CfgDevice$Design$NoOp),
			A2($aforemny$material_components_web_elm$Material$List$Item$setOnClick, onClick, $aforemny$material_components_web_elm$Material$List$Item$config)),
		_List_fromArray(
			[
				$elm$html$Html$text('Rename')
			]));
};
var $author$project$Pages$CfgDevice$Design$viewTaskbarMenu = F2(
	function (config, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[$aforemny$material_components_web_elm$Material$Menu$surfaceAnchor]),
			_List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$IconButton$iconButton,
					A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, $author$project$Pages$CfgDevice$Design$OpenTaskbarMenu, $aforemny$material_components_web_elm$Material$IconButton$config),
					$aforemny$material_components_web_elm$Material$IconButton$icon('more_vert')),
					A2(
					$aforemny$material_components_web_elm$Material$Menu$menu,
					A2(
						$aforemny$material_components_web_elm$Material$Menu$setAttributes,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'margin-right', '8px')
							]),
						A2(
							$aforemny$material_components_web_elm$Material$Menu$setOnClose,
							$author$project$Pages$CfgDevice$Design$CloseTaskbarMenu,
							A2($aforemny$material_components_web_elm$Material$Menu$setOpen, model.eA, $aforemny$material_components_web_elm$Material$Menu$config))),
					_List_fromArray(
						[
							A3(
							$aforemny$material_components_web_elm$Material$List$list,
							A2($aforemny$material_components_web_elm$Material$List$setWrapFocus, true, $aforemny$material_components_web_elm$Material$List$config),
							$author$project$Pages$CfgDevice$Design$viewTaskbarCreateNewOption,
							_List_fromArray(
								[
									$author$project$Pages$CfgDevice$Design$viewTaskbarDuplicateOption(model),
									$author$project$Pages$CfgDevice$Design$viewListDivider,
									$author$project$Pages$CfgDevice$Design$viewTaskbarCleanupOption(model),
									$author$project$Pages$CfgDevice$Design$viewTaskbarRenameOption(model),
									$author$project$Pages$CfgDevice$Design$viewTaskbarDeleteOption(model),
									$author$project$Pages$CfgDevice$Design$viewListDivider,
									$author$project$Pages$CfgDevice$Design$viewTaskbarAutoSaveOption(model),
									$author$project$Pages$CfgDevice$Design$viewTaskbarPartiallyFillOption(model)
								]))
						]))
				]));
	});
var $author$project$Pages$CfgDevice$Design$viewTaskbar = F2(
	function (config, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '100%'),
					A2($elm$html$Html$Attributes$style, 'height', '74px'),
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'border-radius', '8px'),
					A2($elm$html$Html$Attributes$style, 'justify-content', 'space-between'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
					A2($elm$html$Html$Attributes$style, 'margin-top', '8px'),
					A2($elm$html$Html$Attributes$style, 'position', 'sticky'),
					A2($elm$html$Html$Attributes$style, 'top', '74px'),
					A2($elm$html$Html$Attributes$style, 'align-self', 'center'),
					A2($elm$html$Html$Attributes$style, 'background', 'white'),
					A2($elm$html$Html$Attributes$style, 'z-index', '3'),
					$author$project$Mdl$Elevation$e4
				]),
			_List_fromArray(
				[
					A2($author$project$Pages$CfgDevice$Design$viewSelectTemplate, config, model),
					$author$project$Reusable$Flex$viewCompactHorizontal(
					_List_fromArray(
						[
							$author$project$Pages$CfgDevice$Design$viewSaveButtonContainer(model),
							$author$project$Reusable$Separator$viewVertical,
							A2($author$project$Pages$CfgDevice$Design$viewPlayTemplateButton, config, model),
							A2($author$project$Pages$CfgDevice$Design$viewTaskbarMenu, config, model)
						]))
				]));
	});
var $author$project$Pages$CfgDevice$Design$OpenDelFrameDialog = function (a) {
	return {$: 80, a: a};
};
var $author$project$Reusable$Tooltip$Top = 0;
var $author$project$Reusable$Tooltip$top = $author$project$Reusable$Tooltip$Position(0);
var $author$project$Pages$CfgDevice$Design$viewDropFrameButton = F2(
	function (model, frameIndex) {
		return A5(
			$author$project$Reusable$Tooltip$view,
			$author$project$Pages$CfgDevice$Design$Tooltip,
			_List_fromArray(
				[frameIndex, 64]),
			model.fQ,
			_List_fromArray(
				[
					$author$project$Reusable$Tooltip$label('Drop Slide'),
					$author$project$Reusable$Tooltip$top
				]),
			A2(
				$aforemny$material_components_web_elm$Material$IconButton$iconButton,
				A2(
					$aforemny$material_components_web_elm$Material$IconButton$setOnClick,
					$author$project$Pages$CfgDevice$Design$OpenDelFrameDialog(frameIndex),
					$aforemny$material_components_web_elm$Material$IconButton$config),
				$aforemny$material_components_web_elm$Material$IconButton$icon('delete')));
	});
var $author$project$Pages$CfgDevice$Design$viewFrameIndex = function (frameIndex) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'font-size', '24px'),
				A2($elm$html$Html$Attributes$style, 'font-family', 'roboto'),
				A2($elm$html$Html$Attributes$style, 'width', '55px')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				'# ' + $elm$core$String$fromInt(frameIndex + 1))
			]));
};
var $author$project$Pages$CfgDevice$Design$OpenNewFrameOptions = function (a) {
	return {$: 114, a: a};
};
var $aforemny$material_components_web_elm$Material$IconButton$setMenu = F2(
	function (menu_, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{g0: menu_});
	});
var $author$project$Pages$CfgDevice$Design$CloseNewFrameOptions = {$: 115};
var $author$project$Pages$CfgDevice$Design$DuplicateFrame = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Design$NewFrame = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $aforemny$material_components_web_elm$Material$IconButton$Internal$Menu = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $aforemny$material_components_web_elm$Material$IconButton$menu = F2(
	function (config_, nodes) {
		return A2($aforemny$material_components_web_elm$Material$IconButton$Internal$Menu, config_, nodes);
	});
var $author$project$Pages$CfgDevice$Design$viewMoreFrameMenu = F3(
	function (model, template, frameIndex) {
		var isOpen = model.dm.a && _Utils_eq(model.dm.b, frameIndex);
		return A2(
			$aforemny$material_components_web_elm$Material$IconButton$menu,
			A2(
				$aforemny$material_components_web_elm$Material$Menu$setOnClose,
				$author$project$Pages$CfgDevice$Design$CloseNewFrameOptions,
				A2($aforemny$material_components_web_elm$Material$Menu$setOpen, isOpen, $aforemny$material_components_web_elm$Material$Menu$config)),
			_List_fromArray(
				[
					A3(
					$aforemny$material_components_web_elm$Material$List$list,
					A2($aforemny$material_components_web_elm$Material$List$setWrapFocus, true, $aforemny$material_components_web_elm$Material$List$config),
					A2(
						$aforemny$material_components_web_elm$Material$List$Item$listItem,
						A2(
							$aforemny$material_components_web_elm$Material$List$Item$setOnClick,
							A2($author$project$Pages$CfgDevice$Design$NewFrame, frameIndex, template),
							$aforemny$material_components_web_elm$Material$List$Item$config),
						_List_fromArray(
							[
								$elm$html$Html$text('New Slide')
							])),
					_List_fromArray(
						[
							A2(
							$aforemny$material_components_web_elm$Material$List$Item$listItem,
							A2(
								$aforemny$material_components_web_elm$Material$List$Item$setOnClick,
								A2($author$project$Pages$CfgDevice$Design$DuplicateFrame, frameIndex, template),
								$aforemny$material_components_web_elm$Material$List$Item$config),
							_List_fromArray(
								[
									$elm$html$Html$text('Duplicate Slide')
								]))
						]))
				]));
	});
var $author$project$Pages$CfgDevice$Design$viewMoreFrameOptions = F3(
	function (model, template, frameIndex) {
		return A5(
			$author$project$Reusable$Tooltip$view,
			$author$project$Pages$CfgDevice$Design$Tooltip,
			_List_fromArray(
				[frameIndex, 561]),
			model.fQ,
			_List_fromArray(
				[
					$author$project$Reusable$Tooltip$label('Add/Duplicate Slide'),
					$author$project$Reusable$Tooltip$top
				]),
			A2(
				$aforemny$material_components_web_elm$Material$IconButton$iconButton,
				A2(
					$aforemny$material_components_web_elm$Material$IconButton$setAttributes,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(
							'view-more' + $elm$core$String$fromInt(frameIndex))
						]),
					A2(
						$aforemny$material_components_web_elm$Material$IconButton$setMenu,
						$elm$core$Maybe$Just(
							A3($author$project$Pages$CfgDevice$Design$viewMoreFrameMenu, model, template, frameIndex)),
						A2(
							$aforemny$material_components_web_elm$Material$IconButton$setOnClick,
							$author$project$Pages$CfgDevice$Design$OpenNewFrameOptions(frameIndex),
							$aforemny$material_components_web_elm$Material$IconButton$config))),
				$aforemny$material_components_web_elm$Material$IconButton$icon('add_box')));
	});
var $author$project$Pages$CfgDevice$Design$MoveFrameDown = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Design$viewMoveFrameDownButton = F3(
	function (model, template, frameIndex) {
		return A5(
			$author$project$Reusable$Tooltip$view,
			$author$project$Pages$CfgDevice$Design$Tooltip,
			_List_fromArray(
				[frameIndex, 63]),
			model.fQ,
			_List_fromArray(
				[
					$author$project$Reusable$Tooltip$label('Move Frame Down'),
					$author$project$Reusable$Tooltip$top
				]),
			A2(
				$aforemny$material_components_web_elm$Material$IconButton$iconButton,
				A2(
					$aforemny$material_components_web_elm$Material$IconButton$setDisabled,
					_Utils_eq(
						frameIndex,
						$elm$core$List$length(template.G) - 1),
					A2(
						$aforemny$material_components_web_elm$Material$IconButton$setOnClick,
						A2($author$project$Pages$CfgDevice$Design$MoveFrameDown, frameIndex, template),
						$aforemny$material_components_web_elm$Material$IconButton$config)),
				$aforemny$material_components_web_elm$Material$IconButton$icon('arrow_downward')));
	});
var $author$project$Pages$CfgDevice$Design$MoveFrameUp = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Design$viewMoveFrameUpButton = F3(
	function (model, template, frameIndex) {
		return A5(
			$author$project$Reusable$Tooltip$view,
			$author$project$Pages$CfgDevice$Design$Tooltip,
			_List_fromArray(
				[frameIndex, 60]),
			model.fQ,
			_List_fromArray(
				[
					$author$project$Reusable$Tooltip$label('Move Frame Up'),
					$author$project$Reusable$Tooltip$top
				]),
			A2(
				$aforemny$material_components_web_elm$Material$IconButton$iconButton,
				A2(
					$aforemny$material_components_web_elm$Material$IconButton$setDisabled,
					!frameIndex,
					A2(
						$aforemny$material_components_web_elm$Material$IconButton$setOnClick,
						A2($author$project$Pages$CfgDevice$Design$MoveFrameUp, frameIndex, template),
						$aforemny$material_components_web_elm$Material$IconButton$config)),
				$aforemny$material_components_web_elm$Material$IconButton$icon('arrow_upward')));
	});
var $author$project$Pages$CfgDevice$Design$viewFrameEditorLeftSection = F3(
	function (model, template, frameIndex) {
		return $author$project$Reusable$Flex$viewCompactHorizontal(
			_List_fromArray(
				[
					$author$project$Pages$CfgDevice$Design$viewFrameIndex(frameIndex),
					A3($author$project$Pages$CfgDevice$Design$viewMoveFrameUpButton, model, template, frameIndex),
					A3($author$project$Pages$CfgDevice$Design$viewMoveFrameDownButton, model, template, frameIndex),
					$author$project$Reusable$Separator$viewVertical,
					A2($author$project$Pages$CfgDevice$Design$viewDropFrameButton, model, frameIndex),
					$author$project$Reusable$Separator$viewVertical,
					A3($author$project$Pages$CfgDevice$Design$viewMoreFrameOptions, model, template, frameIndex)
				]));
	});
var $author$project$Pages$CfgDevice$Design$EditFrameBg = function (a) {
	return {$: 14, a: a};
};
var $aforemny$material_components_web_elm$Material$Fab$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Fab$config = {fZ: _List_Nil, gq: false, g5: false, he: $elm$core$Maybe$Nothing, eE: true};
var $aforemny$material_components_web_elm$Material$Fab$clickHandler = function (_v0) {
	var onClick = _v0.he;
	return A2($elm$core$Maybe$map, $elm$html$Html$Events$onClick, onClick);
};
var $aforemny$material_components_web_elm$Material$Fab$exitedCs = function (_v0) {
	var exited = _v0.gq;
	return exited ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-fab--exited')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$Fab$iconElt = function (icon_) {
	if (!icon_.$) {
		var node = icon_.a.aJ;
		var attributes = icon_.a.eP;
		var nodes = icon_.a.ft;
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$never,
			A2(
				node,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('mdc-fab__icon'),
					attributes),
				nodes));
	} else {
		var node = icon_.a.aJ;
		var attributes = icon_.a.eP;
		var nodes = icon_.a.ft;
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$never,
			A2(
				node,
				A2(
					$elm$core$List$cons,
					$elm$svg$Svg$Attributes$class('mdc-fab__icon'),
					attributes),
				nodes));
	}
};
var $aforemny$material_components_web_elm$Material$Fab$miniCs = function (_v0) {
	var mini = _v0.g5;
	return mini ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-fab--mini')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$Fab$rippleElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-fab__ripple')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$Fab$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-fab'));
var $aforemny$material_components_web_elm$Material$Fab$tabIndexProp = function (tabIndex) {
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'tabIndex',
			$elm$json$Json$Encode$int(tabIndex)));
};
var $aforemny$material_components_web_elm$Material$Fab$touchCs = function (_v0) {
	var touch = _v0.eE;
	return touch ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-fab--touch')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$Fab$fab = F2(
	function (config_, icon_) {
		var additionalAttributes = config_.fZ;
		var touch = config_.eE;
		var wrapTouch = function (node) {
			return touch ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mdc-touch-target-wrapper')
					]),
				_List_fromArray(
					[node])) : node;
		};
		return wrapTouch(
			A3(
				$elm$html$Html$node,
				'mdc-fab',
				_Utils_ap(
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$aforemny$material_components_web_elm$Material$Fab$rootCs,
								$aforemny$material_components_web_elm$Material$Fab$miniCs(config_),
								$aforemny$material_components_web_elm$Material$Fab$touchCs(config_),
								$aforemny$material_components_web_elm$Material$Fab$exitedCs(config_),
								$aforemny$material_components_web_elm$Material$Fab$clickHandler(config_),
								$aforemny$material_components_web_elm$Material$Fab$tabIndexProp(0)
							])),
					additionalAttributes),
				_List_fromArray(
					[
						$aforemny$material_components_web_elm$Material$Fab$rippleElt,
						$aforemny$material_components_web_elm$Material$Fab$iconElt(icon_)
					])));
	});
var $aforemny$material_components_web_elm$Material$Fab$Icon = function (a) {
	return {$: 0, a: a};
};
var $aforemny$material_components_web_elm$Material$Fab$customIcon = F3(
	function (node, attributes, nodes) {
		return $aforemny$material_components_web_elm$Material$Fab$Icon(
			{eP: attributes, aJ: node, ft: nodes});
	});
var $aforemny$material_components_web_elm$Material$Fab$icon = function (iconName) {
	return A3(
		$aforemny$material_components_web_elm$Material$Fab$customIcon,
		$elm$html$Html$i,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('material-icons')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(iconName)
			]));
};
var $author$project$Pages$CfgDevice$Design$isFrameSelected = F2(
	function (model, frameIndex) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Maybe$Just,
					$elm$core$Basics$eq(frameIndex)),
				model.aw));
	});
var $aforemny$material_components_web_elm$Material$Fab$setAttributes = F2(
	function (additionalAttributes, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{fZ: additionalAttributes});
	});
var $aforemny$material_components_web_elm$Material$Fab$setMini = F2(
	function (mini, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{g5: mini});
	});
var $aforemny$material_components_web_elm$Material$Fab$setOnClick = F2(
	function (onClick, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{
				he: $elm$core$Maybe$Just(onClick)
			});
	});
var $author$project$Pages$CfgDevice$Design$viewEditFrameBackground = F3(
	function (model, template, frameIndex) {
		var tooltip = A4(
			$author$project$Reusable$Tooltip$view,
			$author$project$Pages$CfgDevice$Design$Tooltip,
			_List_fromArray(
				[frameIndex, 50]),
			model.fQ,
			_List_fromArray(
				[
					$author$project$Reusable$Tooltip$label('Edit Background'),
					$author$project$Reusable$Tooltip$top
				]));
		var onClick = $author$project$Pages$CfgDevice$Design$EditFrameBg(frameIndex);
		var attrs = A2($author$project$Pages$CfgDevice$Design$isFrameSelected, model, frameIndex) ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'background', 'rgb(26,35,126'),
				A2($elm$html$Html$Attributes$style, 'color', 'white')
			]) : _List_Nil;
		return A2($author$project$Pages$CfgDevice$Design$isFrameSelected, model, frameIndex) ? tooltip(
			A2(
				$aforemny$material_components_web_elm$Material$Fab$fab,
				A2(
					$aforemny$material_components_web_elm$Material$Fab$setMini,
					true,
					A2(
						$aforemny$material_components_web_elm$Material$Fab$setAttributes,
						attrs,
						A2($aforemny$material_components_web_elm$Material$Fab$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Fab$config))),
				$aforemny$material_components_web_elm$Material$Fab$icon('wallpaper'))) : tooltip(
			A2(
				$aforemny$material_components_web_elm$Material$IconButton$iconButton,
				A2(
					$aforemny$material_components_web_elm$Material$IconButton$setAttributes,
					attrs,
					A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, onClick, $aforemny$material_components_web_elm$Material$IconButton$config)),
				$aforemny$material_components_web_elm$Material$IconButton$icon('wallpaper')));
	});
var $author$project$Pages$CfgDevice$Design$FrameInterval = F3(
	function (a, b, c) {
		return {$: 9, a: a, b: b, c: c};
	});
var $author$project$Pages$CfgDevice$Design$viewEditFrameInterval = F4(
	function (model, template, frameIndex, frame) {
		return A5(
			$author$project$Reusable$Tooltip$view,
			$author$project$Pages$CfgDevice$Design$Tooltip,
			_List_fromArray(
				[frameIndex, 551]),
			model.fQ,
			_List_fromArray(
				[
					$author$project$Reusable$Tooltip$label('Slide Interval'),
					$author$project$Reusable$Tooltip$top
				]),
			$author$project$Reusable$Flex$viewCompactHorizontal(
				_List_fromArray(
					[
						A2(
						$aforemny$material_components_web_elm$Material$Icon$icon,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'margin-right', '6px')
							]),
						'timer'),
						A2(
						$author$project$Reusable$Input$number,
						A2($author$project$Pages$CfgDevice$Design$FrameInterval, template, frameIndex),
						_List_fromArray(
							[
								$author$project$Reusable$Input$value(frame.lH)
							]))
					])));
	});
var $author$project$Pages$CfgDevice$Design$FrameOrientation = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$Template$Frame$vertical = 1;
var $author$project$Pages$CfgDevice$Design$viewSwitchOrientationButton = F4(
	function (model, template, frameIndex, frame) {
		var onClick = function () {
			var _v1 = frame.fz;
			if (!_v1) {
				return A3($author$project$Pages$CfgDevice$Design$FrameOrientation, $author$project$Template$Frame$vertical, frameIndex, template);
			} else {
				return A3($author$project$Pages$CfgDevice$Design$FrameOrientation, $author$project$Template$Frame$horizontal, frameIndex, template);
			}
		}();
		var icon = function () {
			var _v0 = frame.fz;
			if (!_v0) {
				return 'swap_horiz';
			} else {
				return 'swap_vert';
			}
		}();
		return A5(
			$author$project$Reusable$Tooltip$view,
			$author$project$Pages$CfgDevice$Design$Tooltip,
			_List_fromArray(
				[frameIndex, 51]),
			model.fQ,
			_List_fromArray(
				[
					$author$project$Reusable$Tooltip$label('Swap Orientation'),
					$author$project$Reusable$Tooltip$top
				]),
			A2(
				$aforemny$material_components_web_elm$Material$IconButton$iconButton,
				A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, onClick, $aforemny$material_components_web_elm$Material$IconButton$config),
				$aforemny$material_components_web_elm$Material$IconButton$icon(icon)));
	});
var $author$project$Pages$CfgDevice$Design$viewFrameEditorRightSection = F4(
	function (model, template, frameIndex, frame) {
		return $author$project$Reusable$Flex$viewCompactHorizontal(
			_List_fromArray(
				[
					A4($author$project$Pages$CfgDevice$Design$viewSwitchOrientationButton, model, template, frameIndex, frame),
					$author$project$Reusable$Separator$viewVertical,
					A3($author$project$Pages$CfgDevice$Design$viewEditFrameBackground, model, template, frameIndex),
					$author$project$Reusable$Separator$viewVertical,
					A4($author$project$Pages$CfgDevice$Design$viewEditFrameInterval, model, template, frameIndex, frame),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-right', '16px'),
							A2($elm$html$Html$Attributes$style, 'margin-left', '4px')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('sec')
						]))
				]));
	});
var $author$project$Pages$CfgDevice$Design$viewBottomBar = F5(
	function (config, model, template, frameIndex, frame) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'width', '98%'),
					A2($elm$html$Html$Attributes$style, 'padding', '10px 12px'),
					A2($elm$html$Html$Attributes$style, 'justify-content', 'space-between'),
					A2($elm$html$Html$Attributes$style, 'flex-wrap', 'wrap')
				]),
			_List_fromArray(
				[
					A3($author$project$Pages$CfgDevice$Design$viewFrameEditorLeftSection, model, template, frameIndex),
					A4($author$project$Pages$CfgDevice$Design$viewFrameEditorRightSection, model, template, frameIndex, frame)
				]));
	});
var $author$project$Pages$CfgDevice$Design$AddFreshSection = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Design$EditWidgetCfg = function (a) {
	return {$: 34, a: a};
};
var $author$project$Template$Helpers$WidgetPosition = F3(
	function (frameIndex, columnIndex, rowIndex) {
		return {C: columnIndex, ap: frameIndex, y: rowIndex};
	});
var $author$project$Pages$CfgDevice$Design$getWidgetPosition = function (config) {
	return A3($author$project$Template$Helpers$WidgetPosition, config.ap, config.C, config.y);
};
var $author$project$Pages$CfgDevice$Design$getOrientation = F2(
	function (model, cfg) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Maybe$Just,
					function ($) {
						return $.fz;
					}),
				A2($elm_community$list_extra$List$Extra$getAt, cfg.x.ap, cfg.fN.G)));
	});
var $author$project$Pages$CfgDevice$Design$isWidgetSharingStyle = F2(
	function (model, style) {
		var _v0 = _Utils_Tuple2(
			$author$project$Entity$Style$getSharedId(style),
			model.aS);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var a = _v0.a.a;
			var b = _v0.b.a;
			return _Utils_eq(a, b);
		} else {
			return false;
		}
	});
var $author$project$Pages$CfgDevice$Design$isEditingStyle = F2(
	function (model, cfg) {
		return A2(
			$elm$core$List$any,
			$elm$core$Basics$identity,
			A2(
				$elm$core$List$map,
				$author$project$Pages$CfgDevice$Design$isWidgetSharingStyle(model),
				cfg.z));
	});
var $author$project$Pages$CfgDevice$Design$isWidgetSelected = F2(
	function (_v0, position) {
		var selectedWidget = _v0.h;
		if (selectedWidget.$ === 1) {
			return false;
		} else {
			var pos = selectedWidget.a;
			return _Utils_eq(pos, position);
		}
	});
var $author$project$Html$Attributes$Extra$when = F2(
	function (condition, attr) {
		return condition ? attr : $elm$html$Html$Attributes$classList(_List_Nil);
	});
var $author$project$Pages$CfgDevice$Design$getSectionStyles = F2(
	function (model, cfg) {
		var isSelected = A2($author$project$Pages$CfgDevice$Design$isWidgetSelected, model, cfg.x);
		var isHighlighted = isSelected || A2($author$project$Pages$CfgDevice$Design$isEditingStyle, model, cfg);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$style,
				'flex-grow',
				$elm$core$String$fromInt(cfg.ae)),
				A2($elm$html$Html$Attributes$style, 'border', '0.5px dashed rgb(0,0,0,0.1)'),
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'width', '100%'),
				function () {
				var _v0 = A2($author$project$Pages$CfgDevice$Design$getOrientation, model, cfg);
				if (!_v0) {
					return A2(
						$elm$html$Html$Attributes$style,
						'height',
						A2($elm$core$Maybe$withDefault, '100%', cfg.gH));
				} else {
					return A2($elm$html$Html$Attributes$style, 'height', 'initial');
				}
			}(),
				A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
				isHighlighted ? A2($elm$html$Html$Attributes$style, 'background', 'rgba(0,0,0, 0.1)') : A2($elm$html$Html$Attributes$style, 'background', '#FFFFFF'),
				A2(
				$author$project$Html$Attributes$Extra$when,
				isSelected,
				A2($elm$html$Html$Attributes$style, 'z-index', '1')),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('mdl-shadow--4dp', isSelected)
					]))
			]);
	});
var $author$project$Reusable$Flex$viewHorizontal = function (nodes) {
	return $rtfeldman$elm_css$Html$Styled$toUnstyled(
		A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$pct(100)),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
						]))
				]),
			A2($elm$core$List$map, $rtfeldman$elm_css$Html$Styled$fromUnstyled, nodes)));
};
var $author$project$Pages$CfgDevice$Design$viewSectionEditConfigButton = F2(
	function (model, cfg) {
		var onClick = $author$project$Pages$CfgDevice$Design$EditWidgetCfg(cfg.x);
		var conditionalAttrs = A2($author$project$Pages$CfgDevice$Design$isWidgetSelected, model, cfg.x) ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'background', 'rgb(26,35,126)'),
				A2($elm$html$Html$Attributes$style, 'color', 'white')
			]) : _List_Nil;
		var attrs = _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'border-radius', '0%')
			]);
		return A2(
			$aforemny$material_components_web_elm$Material$IconButton$iconButton,
			A2(
				$aforemny$material_components_web_elm$Material$IconButton$setAttributes,
				_Utils_ap(attrs, conditionalAttrs),
				A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, onClick, $aforemny$material_components_web_elm$Material$IconButton$config)),
			$aforemny$material_components_web_elm$Material$IconButton$icon('edit'));
	});
var $author$project$Pages$CfgDevice$Design$EditWidgetStyle = F2(
	function (a, b) {
		return {$: 35, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Design$viewSectionEditStyleButton = F2(
	function (model, cfg) {
		var onClick = A2($author$project$Pages$CfgDevice$Design$EditWidgetStyle, $elm$core$Maybe$Nothing, cfg.x);
		var conditionalAttrs = A2($author$project$Pages$CfgDevice$Design$isWidgetSelected, model, cfg.x) ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'background', 'rgb(26,35,126)'),
				A2($elm$html$Html$Attributes$style, 'color', 'white')
			]) : _List_Nil;
		var attrs = _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'border-radius', '0%')
			]);
		return A2(
			$aforemny$material_components_web_elm$Material$IconButton$iconButton,
			A2(
				$aforemny$material_components_web_elm$Material$IconButton$setAttributes,
				_Utils_ap(attrs, conditionalAttrs),
				A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, onClick, $aforemny$material_components_web_elm$Material$IconButton$config)),
			$aforemny$material_components_web_elm$Material$IconButton$icon('style'));
	});
var $author$project$Pages$CfgDevice$Design$EditWidgetLayout = function (a) {
	return {$: 33, a: a};
};
var $elm$html$Html$Events$onDoubleClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'dblclick',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Pages$CfgDevice$Design$viewSelectSectionButton = F2(
	function (model, cfg) {
		var conditionalStyles = A2($author$project$Pages$CfgDevice$Design$isWidgetSelected, model, cfg.x) ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'background', 'rgb(26,35,126)'),
				A2($elm$html$Html$Attributes$style, 'color', 'white'),
				A2($elm$html$Html$Attributes$style, 'padding', '0px 4px 0px 16px')
			]) : (A2($author$project$Pages$CfgDevice$Design$isEditingStyle, model, cfg) ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'background', 'rgb(191, 54, 12)'),
				A2($elm$html$Html$Attributes$style, 'color', 'white')
			]) : _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'background', '#FFFFFF'),
				A2($elm$html$Html$Attributes$style, 'color', '#000000')
			]));
		return A2(
			$elm$html$Html$button,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$Pages$CfgDevice$Design$EditWidgetLayout(cfg.x)),
						$elm$html$Html$Events$onDoubleClick(
						$author$project$Pages$CfgDevice$Design$EditWidgetCfg(cfg.x)),
						$elm$html$Html$Attributes$class('mdl-button'),
						$elm$html$Html$Attributes$tabindex(0),
						A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
						A2($elm$html$Html$Attributes$style, 'outline', 'none'),
						A2($elm$html$Html$Attributes$style, 'width', '100%'),
						A2($elm$html$Html$Attributes$style, 'height', '100%'),
						A2($elm$html$Html$Attributes$style, 'display', 'flex'),
						A2($elm$html$Html$Attributes$style, 'justify-content', 'space-between'),
						A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
						A2($elm$html$Html$Attributes$style, 'border', '1px solid rgba(0,0,0,0.1)')
					]),
				conditionalStyles),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'inline-block'),
							A2($elm$html$Html$Attributes$style, 'width', '120px'),
							A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
							A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
							A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis'),
							A2($elm$html$Html$Attributes$style, 'text-align', 'left')
						]),
					_List_fromArray(
						[
							cfg.U ? A2(
							$aforemny$material_components_web_elm$Material$Icon$icon,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'margin-right', '4px')
								]),
							'repeat') : $elm$html$Html$text(''),
							$elm$html$Html$text(cfg.c9)
						])),
					function () {
					var _v0 = A2($author$project$Pages$CfgDevice$Design$isWidgetSelected, model, cfg.x);
					if (_v0) {
						return $elm$html$Html$text('');
					} else {
						return A2($aforemny$material_components_web_elm$Material$Icon$icon, _List_Nil, 'more_horiz');
					}
				}()
				]));
	});
var $author$project$Html$Conditions$when = F2(
	function (proceed, htmlMsg) {
		return proceed ? htmlMsg : $elm$html$Html$text('');
	});
var $author$project$Pages$CfgDevice$Design$viewSectionConfigBar = F2(
	function (model, cfg) {
		return $author$project$Reusable$Flex$viewHorizontal(
			_List_fromArray(
				[
					A2($author$project$Pages$CfgDevice$Design$viewSelectSectionButton, model, cfg),
					A2(
					$author$project$Html$Conditions$when,
					A2($author$project$Pages$CfgDevice$Design$isWidgetSelected, model, cfg.x),
					A2($author$project$Pages$CfgDevice$Design$viewSectionEditConfigButton, model, cfg)),
					A2(
					$author$project$Html$Conditions$when,
					A2($author$project$Pages$CfgDevice$Design$isWidgetSelected, model, cfg.x),
					A2($author$project$Pages$CfgDevice$Design$viewSectionEditStyleButton, model, cfg))
				]));
	});
var $author$project$Pages$CfgDevice$Design$viewSection = F2(
	function (model, cfg) {
		return A2(
			$elm$html$Html$div,
			A2($author$project$Pages$CfgDevice$Design$getSectionStyles, model, cfg),
			_List_fromArray(
				[
					A2($author$project$Pages$CfgDevice$Design$viewSectionConfigBar, model, cfg),
					cfg.aJ
				]));
	});
var $author$project$Pages$CfgDevice$Design$viewEmptySection = F2(
	function (model, config) {
		var button = A2(
			$aforemny$material_components_web_elm$Material$Button$outlined,
			A2(
				$aforemny$material_components_web_elm$Material$Button$setOnClick,
				$author$project$Pages$CfgDevice$Design$EditWidgetCfg(
					$author$project$Pages$CfgDevice$Design$getWidgetPosition(config)),
				$aforemny$material_components_web_elm$Material$Button$config),
			'Add');
		return A2(
			$author$project$Pages$CfgDevice$Design$viewSection,
			model,
			{
				ae: 1,
				gH: $elm$core$Maybe$Nothing,
				U: false,
				c9: 'Empty',
				aJ: A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '100%'),
							A2($elm$html$Html$Attributes$style, 'height', '100%'),
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
							A2($elm$html$Html$Attributes$style, 'align-items', 'center')
						]),
					_List_fromArray(
						[button])),
				x: $author$project$Pages$CfgDevice$Design$getWidgetPosition(config),
				z: _List_Nil,
				fN: config.fN
			});
	});
var $author$project$Pages$CfgDevice$Design$RemoveWidget = F2(
	function (a, b) {
		return {$: 30, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Design$viewErrorSection = F4(
	function (model, template, position, isShared) {
		var button = A2(
			$aforemny$material_components_web_elm$Material$IconButton$iconButton,
			A2(
				$aforemny$material_components_web_elm$Material$IconButton$setAttributes,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', '100%'),
						A2($elm$html$Html$Attributes$style, 'height', '100%')
					]),
				A2(
					$aforemny$material_components_web_elm$Material$IconButton$setOnClick,
					A2($author$project$Pages$CfgDevice$Design$RemoveWidget, template, position),
					$aforemny$material_components_web_elm$Material$IconButton$config)),
			$aforemny$material_components_web_elm$Material$IconButton$icon('clear'));
		return A2(
			$author$project$Pages$CfgDevice$Design$viewSection,
			model,
			{ae: 1, gH: $elm$core$Maybe$Nothing, U: isShared, c9: 'Error', aJ: button, x: position, z: _List_Nil, fN: template});
	});
var $author$project$Template$Widget$Core$displayName = function (widget) {
	switch (widget.$) {
		case 0:
			return 'Empty';
		case 1:
			return 'Text Box';
		case 2:
			return 'Image';
		case 3:
			return 'Video';
		case 4:
			return 'Menu Planning';
		default:
			return 'Menu Item List';
	}
};
var $author$project$Pages$CfgDevice$Design$getDisplayName = F2(
	function (isShared, _v0) {
		var widgetId = _v0.a;
		var widget = _v0.b;
		return isShared ? widgetId : $author$project$Template$Widget$Core$displayName(widget);
	});
var $author$project$Template$Helpers$LayoutStyle = 0;
var $author$project$Pages$CfgDevice$Design$MdlIcon = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$CfgDevice$Design$isInnerStyleSelected = F3(
	function (model, position, innerStyle) {
		var _v0 = _Utils_Tuple2(model.h, model.aR);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var a = _v0.a.a;
			var b = _v0.b.a;
			return _Utils_eq(a, position) && _Utils_eq(b, innerStyle);
		} else {
			return false;
		}
	});
var $author$project$Pages$CfgDevice$Design$OpenBindStyleDialog = function (a) {
	return {$: 88, a: a};
};
var $author$project$Pages$CfgDevice$Design$viewBindStyleButton = F2(
	function (model, position) {
		return A5(
			$author$project$Reusable$Tooltip$view,
			$author$project$Pages$CfgDevice$Design$Tooltip,
			_List_fromArray(
				[9876543]),
			model.fQ,
			_List_fromArray(
				[
					$author$project$Reusable$Tooltip$label('Bind Style'),
					$author$project$Reusable$Tooltip$bottom
				]),
			A2(
				$aforemny$material_components_web_elm$Material$Fab$fab,
				A2(
					$aforemny$material_components_web_elm$Material$Fab$setMini,
					true,
					A2(
						$aforemny$material_components_web_elm$Material$Fab$setOnClick,
						$author$project$Pages$CfgDevice$Design$OpenBindStyleDialog(position),
						$aforemny$material_components_web_elm$Material$Fab$config)),
				$aforemny$material_components_web_elm$Material$Fab$icon('sync_disabled')));
	});
var $author$project$Pages$CfgDevice$Design$getPositionIndex = function (_v0) {
	var frameIndex = _v0.ap;
	var columnIndex = _v0.C;
	var rowIndex = _v0.y;
	return _List_fromArray(
		[frameIndex, columnIndex, rowIndex]);
};
var $author$project$Pages$CfgDevice$Design$viewEditWidgetStyle = F5(
	function (model, _v0, _v1, iconType, _v2) {
		var tooltip = _v0.a;
		var isTransparent = _v0.b;
		var secIn = _v1.a;
		var position = _v1.b;
		var style = _v2.a;
		var innerStyle = _v2.b;
		var viewTooltip = A4(
			$author$project$Reusable$Tooltip$view,
			$author$project$Pages$CfgDevice$Design$Tooltip,
			_Utils_ap(
				secIn,
				$author$project$Pages$CfgDevice$Design$getPositionIndex(position)),
			model.fQ,
			_List_fromArray(
				[
					$author$project$Reusable$Tooltip$label(tooltip),
					$author$project$Reusable$Tooltip$bottom
				]));
		var onClick = A2(
			$author$project$Pages$CfgDevice$Design$EditWidgetStyle,
			$elm$core$Maybe$Just(innerStyle),
			position);
		var isSharingStyle = A2($author$project$Pages$CfgDevice$Design$isWidgetSharingStyle, model, style);
		var isBoundedStyle = A3($author$project$Pages$CfgDevice$Design$isInnerStyleSelected, model, position, innerStyle);
		var iconContent = function () {
			if (!iconType.$) {
				var t = iconType.a;
				return t;
			} else {
				var t = iconType.a;
				return t;
			}
		}();
		var attrs = _List_fromArray(
			[
				A2(
				$author$project$Html$Attributes$Extra$when,
				isSharingStyle,
				A2($elm$html$Html$Attributes$style, 'margin-left', '4px'))
			]);
		return (isBoundedStyle && (!isSharingStyle)) ? viewTooltip(
			A2(
				$aforemny$material_components_web_elm$Material$Fab$fab,
				A2(
					$aforemny$material_components_web_elm$Material$Fab$setMini,
					true,
					A2(
						$aforemny$material_components_web_elm$Material$Fab$setAttributes,
						attrs,
						A2($aforemny$material_components_web_elm$Material$Fab$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Fab$config))),
				$aforemny$material_components_web_elm$Material$Fab$icon(iconContent))) : viewTooltip(
			A2(
				$aforemny$material_components_web_elm$Material$IconButton$iconButton,
				A2(
					$aforemny$material_components_web_elm$Material$IconButton$setAttributes,
					attrs,
					A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, onClick, $aforemny$material_components_web_elm$Material$IconButton$config)),
				$aforemny$material_components_web_elm$Material$IconButton$icon(iconContent)));
	});
var $author$project$Pages$CfgDevice$Design$viewIconButton = F5(
	function (model, _v0, _v1, iconType, _v2) {
		var tooltip = _v0.a;
		var isTransparent = _v0.b;
		var secIn = _v1.a;
		var position = _v1.b;
		var style = _v2.a;
		var innerStyle = _v2.b;
		var isSharingStyle = A2($author$project$Pages$CfgDevice$Design$isWidgetSharingStyle, model, style);
		var isBoundedStyle = A3($author$project$Pages$CfgDevice$Design$isInnerStyleSelected, model, position, innerStyle);
		var conditionalStyles = isSharingStyle ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'padding', '4px'),
				A2($elm$html$Html$Attributes$style, 'background', '#FFFFFF')
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$style,
				'background',
				isTransparent ? 'transparent' : '#FFFFFF')
			]);
		return A2(
			$elm$html$Html$span,
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$author$project$Html$Attributes$Extra$when,
						isSharingStyle,
						$elm$html$Html$Attributes$class('mdl-shadow--4dp')),
						A2($elm$html$Html$Attributes$style, 'border-radius', '20px'),
						A2($elm$html$Html$Attributes$style, 'margin', '2px')
					]),
				conditionalStyles),
			_List_fromArray(
				[
					A2(
					$author$project$Html$Conditions$when,
					isSharingStyle,
					A2($author$project$Pages$CfgDevice$Design$viewBindStyleButton, model, position)),
					A5(
					$author$project$Pages$CfgDevice$Design$viewEditWidgetStyle,
					model,
					_Utils_Tuple2(tooltip, isTransparent),
					_Utils_Tuple2(secIn, position),
					iconType,
					_Utils_Tuple2(style, innerStyle))
				]));
	});
var $author$project$Pages$CfgDevice$Design$viewImageEditor = F3(
	function (model, _v0, _v1) {
		var template = _v0.a;
		var position = _v0.b;
		var isShared = _v1.a;
		var label = _v1.b;
		var config = _v1.c;
		return A2(
			$author$project$Pages$CfgDevice$Design$viewSection,
			model,
			{
				ae: 2,
				gH: $elm$core$Maybe$Just('100%'),
				U: isShared,
				c9: label,
				aJ: A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'background-repeat', 'no-repeat'),
							A2($elm$html$Html$Attributes$style, 'background-position', 'center'),
							A2($elm$html$Html$Attributes$style, 'background-image', 'url(\"' + (config.ly + '\")')),
							A2($elm$html$Html$Attributes$style, 'width', '98%'),
							A2($elm$html$Html$Attributes$style, 'height', '98%'),
							A2($elm$html$Html$Attributes$style, 'overflow', 'auto'),
							A2($elm$html$Html$Attributes$style, 'background-size', config.dB),
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
							A2($elm$html$Html$Attributes$style, 'align-items', 'center')
						]),
					_List_fromArray(
						[
							A5(
							$author$project$Pages$CfgDevice$Design$viewIconButton,
							model,
							_Utils_Tuple2('Layout Style', false),
							_Utils_Tuple2(
								_List_fromArray(
									[8, 1]),
								position),
							$author$project$Pages$CfgDevice$Design$MdlIcon('layers'),
							_Utils_Tuple2(config.cs, 0))
						])),
				x: position,
				z: _List_fromArray(
					[config.cs]),
				fN: template
			});
	});
var $author$project$Template$Helpers$DescriptionStyle = 6;
var $author$project$Template$Helpers$PricingStyle = 8;
var $author$project$Template$Helpers$TitleStyle = 1;
var $author$project$Reusable$Flex$viewWrapHorizontal = F2(
	function (size, nodes) {
		return $rtfeldman$elm_css$Html$Styled$toUnstyled(
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
								$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
								$rtfeldman$elm_css$Css$maxWidth(
								$rtfeldman$elm_css$Css$pct(size))
							]))
					]),
				A2($elm$core$List$map, $rtfeldman$elm_css$Html$Styled$fromUnstyled, nodes)));
	});
var $author$project$Pages$CfgDevice$Design$viewMenuItemListEditor = F4(
	function (viewCfg, model, _v0, _v1) {
		var template = _v0.a;
		var position = _v0.b;
		var isShared = _v1.a;
		var label = _v1.b;
		var config = _v1.c;
		return A2(
			$author$project$Pages$CfgDevice$Design$viewSection,
			model,
			{
				ae: 2,
				gH: $elm$core$Maybe$Nothing,
				U: isShared,
				c9: label,
				aJ: A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
							A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
							A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
							A2($elm$html$Html$Attributes$style, 'width', '100%'),
							A2($elm$html$Html$Attributes$style, 'height', '100%'),
							A2($elm$html$Html$Attributes$style, 'overflow', 'auto')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'Menu Item List',
								A2(
									$elm$core$Dict$get,
									config.i7,
									$elm$core$Dict$fromList(viewCfg.g1)))),
							A2(
							$author$project$Reusable$Flex$viewWrapHorizontal,
							95,
							_List_fromArray(
								[
									A5(
									$author$project$Pages$CfgDevice$Design$viewIconButton,
									model,
									_Utils_Tuple2('Title Style', true),
									_Utils_Tuple2(
										_List_fromArray(
											[3, 1]),
										position),
									$author$project$Pages$CfgDevice$Design$MdlIcon('title'),
									_Utils_Tuple2(config.na, 1)),
									A5(
									$author$project$Pages$CfgDevice$Design$viewIconButton,
									model,
									_Utils_Tuple2('Description Style', true),
									_Utils_Tuple2(
										_List_fromArray(
											[3, 2]),
										position),
									$author$project$Pages$CfgDevice$Design$MdlIcon('text_fields'),
									_Utils_Tuple2(config.k9, 6)),
									A5(
									$author$project$Pages$CfgDevice$Design$viewIconButton,
									model,
									_Utils_Tuple2('Pricing Style', true),
									_Utils_Tuple2(
										_List_fromArray(
											[3, 3]),
										position),
									$author$project$Pages$CfgDevice$Design$MdlIcon('attach_money'),
									_Utils_Tuple2(config.hw, 8))
								]))
						])),
				x: position,
				z: _List_fromArray(
					[config.na, config.k9, config.hw]),
				fN: template
			});
	});
var $author$project$Template$Helpers$CaloriesStyle = 4;
var $author$project$Template$Helpers$FoodComponentsStyle = 7;
var $author$project$Template$Helpers$ImageStyle = 3;
var $author$project$Template$Helpers$LocationStyle = 2;
var $author$project$Pages$CfgDevice$Design$PlainIcon = function (a) {
	return {$: 0, a: a};
};
var $author$project$Template$Helpers$RatingsStyle = 5;
var $author$project$Pages$CfgDevice$Design$viewMenuPlanningEditor = F3(
	function (model, _v0, _v1) {
		var template = _v0.a;
		var position = _v0.b;
		var isShared = _v1.a;
		var label = _v1.b;
		var config = _v1.c;
		return A2(
			$author$project$Pages$CfgDevice$Design$viewSection,
			model,
			{
				ae: 2,
				gH: $elm$core$Maybe$Nothing,
				U: isShared,
				c9: label,
				aJ: A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
							A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
							A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
							A2($elm$html$Html$Attributes$style, 'height', '100%'),
							A2($elm$html$Html$Attributes$style, 'width', '100%'),
							A2($elm$html$Html$Attributes$style, 'overflow-y', 'auto'),
							A2($elm$html$Html$Attributes$style, 'overflow-x', 'hidden')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'margin-bottom', '3px'),
									A2($elm$html$Html$Attributes$style, 'font-weight', 'bold')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, '', config.mz))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'margin-bottom', '6px')
								]),
							_List_fromArray(
								[
									function () {
									var _v2 = _Utils_Tuple2(config.iq, config.ai);
									if (!_v2.a.$) {
										if (!_v2.b.$) {
											var catName = _v2.a.a;
											var mktName = _v2.b.a;
											return $elm$html$Html$text(
												mktName + (' [' + (catName + (']' + (' (' + ($elm$core$String$fromInt(config.ej) + ')'))))));
										} else {
											var catName = _v2.a.a;
											var _v3 = _v2.b;
											return $elm$html$Html$text(
												catName + (' (' + ($elm$core$String$fromInt(config.ej) + ')')));
										}
									} else {
										var _v4 = _v2.a;
										return $elm$html$Html$text('Select Category');
									}
								}()
								])),
							A2(
							$author$project$Reusable$Flex$viewWrapHorizontal,
							78,
							_List_fromArray(
								[
									A5(
									$author$project$Pages$CfgDevice$Design$viewIconButton,
									model,
									_Utils_Tuple2('Size', true),
									_Utils_Tuple2(
										_List_fromArray(
											[2, 0, 0]),
										position),
									$author$project$Pages$CfgDevice$Design$MdlIcon('crop_free'),
									_Utils_Tuple2(config.da, 0)),
									A5(
									$author$project$Pages$CfgDevice$Design$viewIconButton,
									model,
									_Utils_Tuple2('Title Style', true),
									_Utils_Tuple2(
										_List_fromArray(
											[2, 1]),
										position),
									$author$project$Pages$CfgDevice$Design$MdlIcon('title'),
									_Utils_Tuple2(config.na, 1)),
									_Utils_eq(config.mz, $elm$core$Maybe$Nothing) ? $elm$html$Html$text('') : A5(
									$author$project$Pages$CfgDevice$Design$viewIconButton,
									model,
									_Utils_Tuple2('Serving Line Style', true),
									_Utils_Tuple2(
										_List_fromArray(
											[2, 12]),
										position),
									$author$project$Pages$CfgDevice$Design$MdlIcon('edit_location'),
									_Utils_Tuple2(config.gY, 2)),
									A5(
									$author$project$Pages$CfgDevice$Design$viewIconButton,
									model,
									_Utils_Tuple2('Image Style', true),
									_Utils_Tuple2(
										_List_fromArray(
											[2, 2]),
										position),
									$author$project$Pages$CfgDevice$Design$MdlIcon('image'),
									_Utils_Tuple2(config.gL, 3)),
									A5(
									$author$project$Pages$CfgDevice$Design$viewIconButton,
									model,
									_Utils_Tuple2('Description Style', true),
									_Utils_Tuple2(
										_List_fromArray(
											[2, 3]),
										position),
									$author$project$Pages$CfgDevice$Design$MdlIcon('text_fields'),
									_Utils_Tuple2(config.k9, 6)),
									A5(
									$author$project$Pages$CfgDevice$Design$viewIconButton,
									model,
									_Utils_Tuple2('Calories Style', true),
									_Utils_Tuple2(
										_List_fromArray(
											[2, 4]),
										position),
									$author$project$Pages$CfgDevice$Design$PlainIcon('C'),
									_Utils_Tuple2(config.kR, 4)),
									A5(
									$author$project$Pages$CfgDevice$Design$viewIconButton,
									model,
									_Utils_Tuple2('Ratings Style', true),
									_Utils_Tuple2(
										_List_fromArray(
											[2, 5]),
										position),
									$author$project$Pages$CfgDevice$Design$MdlIcon('grade'),
									_Utils_Tuple2(config.mf, 5)),
									A5(
									$author$project$Pages$CfgDevice$Design$viewIconButton,
									model,
									_Utils_Tuple2('Food Components Style', true),
									_Utils_Tuple2(
										_List_fromArray(
											[2, 6]),
										position),
									$author$project$Pages$CfgDevice$Design$MdlIcon('donut_small'),
									_Utils_Tuple2(config.gA, 7))
								]))
						])),
				x: position,
				z: _List_fromArray(
					[config.da, config.na, config.gY, config.k9, config.gL, config.kR, config.mf, config.gA]),
				fN: template
			});
	});
var $author$project$Pages$CfgDevice$Design$viewTextBoxEditor = F3(
	function (model, _v0, _v1) {
		var template = _v0.a;
		var position = _v0.b;
		var isShared = _v1.a;
		var label = _v1.b;
		var config = _v1.c;
		return A2(
			$author$project$Pages$CfgDevice$Design$viewSection,
			model,
			{
				ae: 1,
				gH: $elm$core$Maybe$Nothing,
				U: isShared,
				c9: label,
				aJ: A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'width', '100%'),
							A2($elm$html$Html$Attributes$style, 'height', '100%'),
							A2($elm$html$Html$Attributes$style, 'overflow', 'auto'),
							A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
							A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
							A2($elm$html$Html$Attributes$style, 'align-items', 'center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_Utils_ap(
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'background', '#000000'),
										A2($elm$html$Html$Attributes$style, 'border', '1px solid grey'),
										A2($elm$html$Html$Attributes$style, 'display', 'flex'),
										A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
										A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
										A2($elm$html$Html$Attributes$style, 'max-height', '95%'),
										A2($elm$html$Html$Attributes$style, 'overflow-y', 'auto'),
										A2($elm$html$Html$Attributes$style, 'padding', '4px 0px'),
										A2($elm$html$Html$Attributes$style, 'white-space', 'pre-wrap'),
										A2($elm$html$Html$Attributes$style, 'margin-bottom', '6px'),
										A2($elm$html$Html$Attributes$style, 'font-size', '18px')
									]),
								A2($author$project$Entity$Style$toList, template.z, config.cs)),
							_List_fromArray(
								[
									$elm$html$Html$text(config.hO)
								])),
							A2(
							$author$project$Reusable$Flex$viewWrapHorizontal,
							88,
							_List_fromArray(
								[
									A5(
									$author$project$Pages$CfgDevice$Design$viewIconButton,
									model,
									_Utils_Tuple2('Size', true),
									_Utils_Tuple2(
										_List_fromArray(
											[8, 3]),
										position),
									$author$project$Pages$CfgDevice$Design$MdlIcon('crop_free'),
									_Utils_Tuple2(config.dB, 0)),
									A5(
									$author$project$Pages$CfgDevice$Design$viewIconButton,
									model,
									_Utils_Tuple2('Text Style', true),
									_Utils_Tuple2(
										_List_fromArray(
											[8, 1]),
										position),
									$author$project$Pages$CfgDevice$Design$MdlIcon('text_fields'),
									_Utils_Tuple2(config.cs, 1))
								]))
						])),
				x: position,
				z: _List_fromArray(
					[config.dB, config.cs]),
				fN: template
			});
	});
var $author$project$Pages$CfgDevice$Design$viewYoutubeEditor = F3(
	function (model, _v0, _v1) {
		var template = _v0.a;
		var position = _v0.b;
		var isShared = _v1.a;
		var label = _v1.b;
		var config = _v1.c;
		return A2(
			$author$project$Pages$CfgDevice$Design$viewSection,
			model,
			{
				ae: 2,
				gH: $elm$core$Maybe$Nothing,
				U: isShared,
				c9: label,
				aJ: A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '100%'),
							A2($elm$html$Html$Attributes$style, 'height', '100%'),
							A2($elm$html$Html$Attributes$style, 'background-size', 'cover'),
							A2($elm$html$Html$Attributes$style, 'background-repeat', 'no-repeat'),
							A2(
							$elm$html$Html$Attributes$style,
							'background-image',
							'url(\"https://img.youtube.com/vi/' + (function () {
								var _v2 = config.ka;
								if (!_v2.$) {
									var id = _v2.a;
									return id;
								} else {
									var id = _v2.a;
									return id;
								}
							}() + '/mqdefault.jpg\")')),
							A2($elm$html$Html$Attributes$style, 'overflow', 'auto')
						]),
					_List_Nil),
				x: position,
				z: _List_Nil,
				fN: template
			});
	});
var $author$project$Pages$CfgDevice$Design$viewWidgetEditor = F5(
	function (viewCfg, model, template, position, _v0) {
		var isShared = _v0.a;
		var widgetId = _v0.b;
		var widget = _v0.c;
		switch (widget.$) {
			case 1:
				var config = widget.a;
				return A3(
					$author$project$Pages$CfgDevice$Design$viewTextBoxEditor,
					model,
					_Utils_Tuple2(template, position),
					_Utils_Tuple3(
						isShared,
						A2(
							$author$project$Pages$CfgDevice$Design$getDisplayName,
							isShared,
							_Utils_Tuple2(widgetId, widget)),
						config));
			case 2:
				var config = widget.a;
				return A3(
					$author$project$Pages$CfgDevice$Design$viewImageEditor,
					model,
					_Utils_Tuple2(template, position),
					_Utils_Tuple3(
						isShared,
						A2(
							$author$project$Pages$CfgDevice$Design$getDisplayName,
							isShared,
							_Utils_Tuple2(widgetId, widget)),
						config));
			case 3:
				var config = widget.a;
				return A3(
					$author$project$Pages$CfgDevice$Design$viewYoutubeEditor,
					model,
					_Utils_Tuple2(template, position),
					_Utils_Tuple3(
						isShared,
						A2(
							$author$project$Pages$CfgDevice$Design$getDisplayName,
							isShared,
							_Utils_Tuple2(widgetId, widget)),
						config));
			case 4:
				var config = widget.a;
				return A3(
					$author$project$Pages$CfgDevice$Design$viewMenuPlanningEditor,
					model,
					_Utils_Tuple2(template, position),
					_Utils_Tuple3(
						isShared,
						A2(
							$author$project$Pages$CfgDevice$Design$getDisplayName,
							isShared,
							_Utils_Tuple2(widgetId, widget)),
						config));
			case 5:
				var config = widget.a;
				return A4(
					$author$project$Pages$CfgDevice$Design$viewMenuItemListEditor,
					viewCfg,
					model,
					_Utils_Tuple2(template, position),
					_Utils_Tuple3(
						isShared,
						A2(
							$author$project$Pages$CfgDevice$Design$getDisplayName,
							isShared,
							_Utils_Tuple2(widgetId, widget)),
						config));
			default:
				return A2(
					$author$project$Pages$CfgDevice$Design$viewSection,
					model,
					{
						ae: 1,
						gH: $elm$core$Maybe$Nothing,
						U: false,
						c9: 'Unknown',
						aJ: $elm$html$Html$text('Unable to recognize the widget'),
						x: position,
						z: _List_Nil,
						fN: template
					});
		}
	});
var $author$project$Pages$CfgDevice$Design$viewSectionEditor = F4(
	function (config, model, secConfig, editorConfig) {
		var _v0 = A2(
			$author$project$Template$Helpers$getWidget,
			secConfig.fN,
			$author$project$Pages$CfgDevice$Design$getWidgetPosition(secConfig));
		if (!_v0.$) {
			var _v1 = _v0.a;
			var widgetId = _v1.a;
			var widget = _v1.b;
			return A5(
				$author$project$Pages$CfgDevice$Design$viewWidgetEditor,
				config,
				model,
				secConfig.fN,
				$author$project$Pages$CfgDevice$Design$getWidgetPosition(secConfig),
				_Utils_Tuple3(editorConfig.U, editorConfig.fU, widget));
		} else {
			return A4(
				$author$project$Pages$CfgDevice$Design$viewErrorSection,
				model,
				secConfig.fN,
				$author$project$Pages$CfgDevice$Design$getWidgetPosition(secConfig),
				editorConfig.U);
		}
	});
var $author$project$Pages$CfgDevice$Design$viewLayoutRow = F3(
	function (config, model, sectionConfig) {
		var _v0 = sectionConfig.hF;
		switch (_v0.$) {
			case 2:
				return A2($author$project$Pages$CfgDevice$Design$viewEmptySection, model, sectionConfig);
			case 0:
				var a = _v0.a;
				return A4(
					$author$project$Pages$CfgDevice$Design$viewSectionEditor,
					config,
					model,
					sectionConfig,
					{U: false, fU: a});
			default:
				var a = _v0.a;
				return A4(
					$author$project$Pages$CfgDevice$Design$viewSectionEditor,
					config,
					model,
					sectionConfig,
					{U: true, fU: a});
		}
	});
var $author$project$Pages$CfgDevice$Design$viewLayoutColumn = F7(
	function (viewCfg, model, template, orientation, frIndex, colIndex, _v0) {
		var flexGrow = _v0.ae;
		var rows = _v0.jJ;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2(
					$elm$html$Html$Attributes$style,
					'flex-direction',
					function () {
						if (!orientation) {
							return 'column';
						} else {
							return 'row';
						}
					}()),
					A2($elm$html$Html$Attributes$style, 'max-height', '100%'),
					A2(
					$elm$html$Html$Attributes$style,
					'flex-grow',
					$elm$core$String$fromInt(flexGrow))
				]),
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (rowIndex, section) {
						return A3(
							$author$project$Pages$CfgDevice$Design$viewLayoutRow,
							viewCfg,
							model,
							{
								C: colIndex,
								ap: frIndex,
								jf: $elm$core$List$length(rows),
								y: rowIndex,
								hF: section,
								fN: template
							});
					}),
				rows));
	});
var $author$project$Pages$CfgDevice$Design$viewLayoutEditor = F5(
	function (viewCfg, model, template, frIndex, _v0) {
		var layout = _v0.da;
		var orientation = _v0.fz;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '700px'),
					A2($elm$html$Html$Attributes$style, 'height', '392px'),
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2(
					$elm$html$Html$Attributes$style,
					'flex-direction',
					function () {
						if (!orientation) {
							return 'row';
						} else {
							return 'column';
						}
					}())
				]),
			$elm$core$List$isEmpty(layout) ? _List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mdl-button mdl-button-raised'),
							A2($elm$html$Html$Attributes$style, 'width', '100%'),
							A2($elm$html$Html$Attributes$style, 'height', '100%'),
							$elm$html$Html$Events$onClick(
							A2($author$project$Pages$CfgDevice$Design$AddFreshSection, template, frIndex))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Add Section')
						]))
				]) : A2(
				$elm$core$List$indexedMap,
				A5($author$project$Pages$CfgDevice$Design$viewLayoutColumn, viewCfg, model, template, orientation, frIndex),
				layout));
	});
var $author$project$Pages$CfgDevice$Design$viewFrameEditor = F5(
	function (config, model, template, frameIndex, frame) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '100%'),
					A2($elm$html$Html$Attributes$style, 'border-radius', '6px'),
					A2($elm$html$Html$Attributes$style, 'margin-bottom', '12px '),
					$elm$html$Html$Attributes$class('mdl-shadow--8dp')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'overflow-x', 'auto'),
							A2($elm$html$Html$Attributes$style, 'background', '#FFFFFF'),
							A2($elm$html$Html$Attributes$style, 'margin', '12px')
						]),
					_List_fromArray(
						[
							A5($author$project$Pages$CfgDevice$Design$viewLayoutEditor, config, model, template, frameIndex, frame)
						])),
					A5($author$project$Pages$CfgDevice$Design$viewBottomBar, config, model, template, frameIndex, frame)
				]));
	});
var $author$project$Pages$CfgDevice$Design$viewNewTemplateButton = function (template) {
	return A2(
		$aforemny$material_components_web_elm$Material$Button$outlined,
		A2(
			$aforemny$material_components_web_elm$Material$Button$setOnClick,
			A2($author$project$Pages$CfgDevice$Design$NewFrame, 0, template),
			$aforemny$material_components_web_elm$Material$Button$config),
		'Add Frame');
};
var $author$project$Pages$CfgDevice$Design$viewTemplate = F3(
	function (viewCfg, model, template) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'center')
				]),
			$elm$core$List$isEmpty(template.G) ? _List_fromArray(
				[
					$author$project$Pages$CfgDevice$Design$viewNewTemplateButton(template)
				]) : A2(
				$elm$core$List$indexedMap,
				A3($author$project$Pages$CfgDevice$Design$viewFrameEditor, viewCfg, model, template),
				template.G));
	});
var $author$project$Pages$CfgDevice$Design$CloseTemplateDialog = {$: 77};
var $author$project$Pages$CfgDevice$Design$NewTemplate = function (a) {
	return {$: 51, a: a};
};
var $author$project$Pages$CfgDevice$Design$RenameTemplate = F2(
	function (a, b) {
		return {$: 53, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Design$isTemplateNameValid = function (model) {
	var _v0 = model.av;
	if (!_v0.$) {
		var name = _v0.a;
		return (!$elm$core$String$isEmpty(name)) && (!A2(
			$elm$core$List$member,
			name,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.g8;
				},
				model.al)));
	} else {
		return false;
	}
};
var $author$project$Pages$CfgDevice$Design$viewModifyTemplateButton = F2(
	function (model, onClick) {
		return A2(
			$aforemny$material_components_web_elm$Material$Button$outlined,
			A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config),
			function () {
				var _v0 = model.bI;
				switch (_v0) {
					case 0:
						return 'Add Template';
					case 1:
						return 'Rename Template';
					default:
						return 'Duplicate Template';
				}
			}());
	});
var $author$project$Pages$CfgDevice$Design$NewTemplateName = function (a) {
	return {$: 50, a: a};
};
var $author$project$Pages$CfgDevice$Design$viewTemplateNameField = F3(
	function (config, model, onEnter) {
		var errText = function () {
			var _v0 = model.av;
			if (!_v0.$) {
				var name = _v0.a;
				return $elm$core$String$isEmpty(name) ? 'Template name is empty' : ((!$author$project$Pages$CfgDevice$Design$isTemplateNameValid(model)) ? 'Template name already exists' : '');
			} else {
				return '';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$TextField$outlined(
					A2(
						$aforemny$material_components_web_elm$Material$TextField$setAttributes,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'width', '100%'),
								A2($elm$html$Html$Attributes$style, 'margin-top', '12px'),
								$author$project$Utils$onEnter(onEnter)
							]),
						A2(
							$aforemny$material_components_web_elm$Material$TextField$setValid,
							$elm$core$String$isEmpty(errText),
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setOnInput,
								$author$project$Pages$CfgDevice$Design$NewTemplateName,
								A2(
									$aforemny$material_components_web_elm$Material$TextField$setValue,
									model.av,
									A2(
										$aforemny$material_components_web_elm$Material$TextField$setLabel,
										$elm$core$Maybe$Just('Template Name'),
										$aforemny$material_components_web_elm$Material$TextField$config)))))),
					A2($aforemny$material_components_web_elm$Material$HelperText$helperText, $aforemny$material_components_web_elm$Material$HelperText$config, errText)
				]));
	});
var $author$project$Pages$CfgDevice$Design$viewTemplateDialog = F2(
	function (config, model) {
		var onEverythingOk = function () {
			var _v1 = _Utils_Tuple3(
				$author$project$Pages$CfgDevice$Design$isTemplateNameValid(model),
				model.bI,
				_Utils_Tuple2(model.a, model.av));
			_v1$3:
			while (true) {
				if (_v1.a) {
					switch (_v1.b) {
						case 0:
							var _v2 = _v1.b;
							var _v3 = _v1.c;
							return $author$project$Pages$CfgDevice$Design$NewTemplate(config.eO);
						case 2:
							if (_v1.c.a.$ === 4) {
								var _v4 = _v1.b;
								var _v5 = _v1.c;
								return $author$project$Pages$CfgDevice$Design$NewTemplate(config.eO);
							} else {
								break _v1$3;
							}
						default:
							if ((_v1.c.a.$ === 4) && (!_v1.c.b.$)) {
								var _v6 = _v1.b;
								var _v7 = _v1.c;
								var template = _v7.a.a;
								var name = _v7.b.a;
								return A2(
									$author$project$Pages$CfgDevice$Design$RenameTemplate,
									_Utils_update(
										template,
										{g8: name}),
									template.g8);
							} else {
								break _v1$3;
							}
					}
				} else {
					break _v1$3;
				}
			}
			return $author$project$Pages$CfgDevice$Design$NoOp;
		}();
		return A2(
			$aforemny$material_components_web_elm$Material$Dialog$dialog,
			A2(
				$aforemny$material_components_web_elm$Material$Dialog$setAttributes,
				$author$project$Pages$CfgDevice$Design$dialogStyle,
				A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.cv, $aforemny$material_components_web_elm$Material$Dialog$config)),
			{
				kk: _List_fromArray(
					[
						A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$CfgDevice$Design$CloseTemplateDialog, $aforemny$material_components_web_elm$Material$Button$config),
						'Close'),
						A2($author$project$Pages$CfgDevice$Design$viewModifyTemplateButton, model, onEverythingOk)
					]),
				k_: _List_fromArray(
					[
						A3($author$project$Pages$CfgDevice$Design$viewTemplateNameField, config, model, onEverythingOk)
					]),
				na: function () {
					var _v0 = model.bI;
					switch (_v0) {
						case 0:
							return $elm$core$Maybe$Just('New Template');
						case 1:
							return $elm$core$Maybe$Just('Rename');
						default:
							return $elm$core$Maybe$Just('Duplicate');
					}
				}()
			});
	});
var $author$project$Pages$CfgDevice$Design$CloseUploadImageDialog = {$: 92};
var $author$project$Pages$CfgDevice$Design$UploadImage = function (a) {
	return {$: 116, a: a};
};
var $author$project$Pages$CfgDevice$Design$viewUploadButton = F2(
	function (config, model) {
		return A2(
			$elm$html$Html$label,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('file'),
							$elm$html$Html$Attributes$id(config.gm),
							(model.bu === 1) ? $elm$html$Html$Attributes$disabled(true) : $elm$html$Html$Attributes$disabled(false),
							A2(
							$elm$html$Html$Events$on,
							'change',
							$elm$json$Json$Decode$succeed(
								$author$project$Pages$CfgDevice$Design$UploadImage(config)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Upload')
						]))
				]));
	});
var $author$project$Pages$CfgDevice$Design$viewUploadImageDialog = F2(
	function (config, model) {
		var viewConfig = {h5: config.h5, gm: config.gm, gM: config.gM};
		return A2(
			$aforemny$material_components_web_elm$Material$Dialog$dialog,
			A2(
				$aforemny$material_components_web_elm$Material$Dialog$setAttributes,
				$author$project$Pages$CfgDevice$Design$dialogStyle,
				A2(
					$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
					$author$project$Pages$CfgDevice$Design$CloseUploadImageDialog,
					A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.eI, $aforemny$material_components_web_elm$Material$Dialog$config))),
			{
				kk: _List_fromArray(
					[
						A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$CfgDevice$Design$CloseUploadImageDialog, $aforemny$material_components_web_elm$Material$Button$config),
						'Close')
					]),
				k_: _List_fromArray(
					[
						A2($author$project$Pages$CfgDevice$Design$viewUploadButton, viewConfig, model),
						function () {
						var _v0 = model.bu;
						switch (_v0) {
							case 1:
								return $aforemny$material_components_web_elm$Material$CircularProgress$indeterminate($aforemny$material_components_web_elm$Material$CircularProgress$config);
							case 2:
								return A2(
									$danmarcab$material_icons$Material$Icons$Action$check_circle,
									A3($avh4$elm_color$Color$rgb, 0, 0, 0),
									24);
							case 0:
								return $elm$html$Html$text('');
							default:
								return A2(
									$danmarcab$material_icons$Material$Icons$Alert$error,
									A3($avh4$elm_color$Color$rgb, 255, 0, 0),
									24);
						}
					}()
					]),
				na: $elm$core$Maybe$Just('Upload Image')
			});
	});
var $author$project$Pages$CfgDevice$Design$view = F2(
	function (viewCfg, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
					A2($elm$html$Html$Attributes$style, 'width', '100%')
				]),
			_List_fromArray(
				[
					A2($author$project$Pages$CfgDevice$Design$viewTaskbar, viewCfg, model),
					$author$project$Pages$CfgDevice$Design$viewTags(model),
					function () {
					var _v0 = model.a;
					if (_v0.$ === 4) {
						var template = _v0.a;
						return $author$project$Reusable$Header$sectionHeader('Slides');
					} else {
						return $elm$html$Html$text('');
					}
				}(),
					function () {
					var _v1 = model.a;
					switch (_v1.$) {
						case 0:
							return $author$project$Reusable$Flex$viewVertical(
								_List_fromArray(
									[
										$author$project$Pages$CfgDevice$Design$viewStatus('Select a template to continue (or)'),
										A2(
										$aforemny$material_components_web_elm$Material$Button$raised,
										A2(
											$aforemny$material_components_web_elm$Material$Button$setOnClick,
											$author$project$Pages$CfgDevice$Design$OpenTemplateDialog(0),
											$aforemny$material_components_web_elm$Material$Button$config),
										'Create New Template')
									]));
						case 1:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'width', '100%'),
										A2($elm$html$Html$Attributes$style, 'display', 'flex'),
										A2($elm$html$Html$Attributes$style, 'height', '64px'),
										A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
										A2($elm$html$Html$Attributes$style, 'align-items', 'center')
									]),
								_List_fromArray(
									[
										$aforemny$material_components_web_elm$Material$CircularProgress$indeterminate($aforemny$material_components_web_elm$Material$CircularProgress$config)
									]));
						case 4:
							var template = _v1.a;
							return A3($author$project$Pages$CfgDevice$Design$viewTemplate, viewCfg, model, template);
						default:
							return $author$project$Pages$CfgDevice$Design$viewStatus('Not ready yet');
					}
				}(),
					$author$project$Pages$CfgDevice$Design$viewDelFrameDialog(model),
					$author$project$Pages$CfgDevice$Design$viewDelSectionDialog(model),
					$author$project$Pages$CfgDevice$Design$viewDelColumnDialog(model),
					$author$project$Pages$CfgDevice$Design$viewDelTemplateDialog(model),
					A2($author$project$Pages$CfgDevice$Design$viewTemplateDialog, viewCfg, model),
					A2($author$project$Pages$CfgDevice$Design$viewPlayTemplate, viewCfg, model),
					$author$project$Pages$CfgDevice$Design$viewSyncBackgroundDialog(model),
					$author$project$Pages$CfgDevice$Design$viewBindStyleDialog(model),
					$author$project$Pages$CfgDevice$Design$viewShareEffectDialog(model),
					A2($author$project$Pages$CfgDevice$Design$viewUploadImageDialog, viewCfg, model),
					function () {
					var _v2 = model.a;
					if (_v2.$ === 4) {
						var template = _v2.a;
						return A2($author$project$Pages$CfgDevice$Design$viewSharedStyleDialog, model, template);
					} else {
						return $elm$html$Html$text('');
					}
				}(),
					function () {
					var _v3 = model.a;
					if (_v3.$ === 4) {
						var template = _v3.a;
						return A2($author$project$Pages$CfgDevice$Design$viewSharedWidgetDialog, model, template);
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$Pages$CfgDevice$Schedule$ResetTimings = function (a) {
	return {$: 10, a: a};
};
var $author$project$Entity$Schedule$Time$isAfter = F2(
	function (time1, time2) {
		return (_Utils_cmp(time1.c5, time2.c5) > 0) || (_Utils_eq(time1.c5, time2.c5) && (_Utils_cmp(time1.dk, time2.dk) > 0));
	});
var $author$project$Pages$CfgDevice$Schedule$viewResetTimings = function (model) {
	var isDisabled = function () {
		var _v1 = $author$project$Pages$CfgDevice$Schedule$isOriginalTimings(model);
		if (_v1.$ === 1) {
			return true;
		} else {
			if (_v1.a) {
				return true;
			} else {
				return false;
			}
		}
	}();
	var isAfter = function () {
		var _v0 = _Utils_Tuple3(
			A2($elm$core$Dict$get, 'breakfast', model.mo),
			A2($elm$core$Dict$get, 'lunch', model.mo),
			A2($elm$core$Dict$get, 'supper', model.mo));
		if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
			var lschd = _v0.b.a;
			var sprhd = _v0.c.a;
			return A2($author$project$Entity$Schedule$Time$isAfter, $author$project$Entity$Schedule$Defaults$breakfastEndTime, lschd.fI);
		} else {
			return false;
		}
	}();
	return A2(
		$aforemny$material_components_web_elm$Material$Button$outlined,
		A2(
			$aforemny$material_components_web_elm$Material$Button$setAttributes,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'align-self', 'flex-end')
				]),
			A2(
				$aforemny$material_components_web_elm$Material$Button$setOnClick,
				$author$project$Pages$CfgDevice$Schedule$ResetTimings(isAfter),
				$aforemny$material_components_web_elm$Material$Button$config)),
		'Reset Timings');
};
var $author$project$Pages$CfgDevice$Schedule$InitiateEditTemplate = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Schedule$SelectMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$CfgDevice$Schedule$SelectTemplate = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Schedule$Tooltip = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$Structure$AllQuery = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Media$all = $rtfeldman$elm_css$Css$Structure$AllQuery;
var $rtfeldman$elm_css$Css$Media$feature = F2(
	function (key, _v0) {
		var value = _v0.eL;
		return {
			iH: key,
			eL: $elm$core$Maybe$Just(value)
		};
	});
var $rtfeldman$elm_css$Css$Media$maxWidth = function (value) {
	return A2($rtfeldman$elm_css$Css$Media$feature, 'max-width', value);
};
var $rtfeldman$elm_css$Css$Preprocess$WithMedia = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Media$withMedia = $rtfeldman$elm_css$Css$Preprocess$WithMedia;
var $author$project$Reusable$Card$configTabInnerSection1 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(50)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMedia,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Media$all(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$Media$maxWidth(
							$rtfeldman$elm_css$Css$px(700))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$paddingLeft(
					$rtfeldman$elm_css$Css$px(0)),
					$rtfeldman$elm_css$Css$marginTop(
					$rtfeldman$elm_css$Css$px(24))
				]))
		]));
var $author$project$Reusable$Card$configTabInnerSection2 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(40)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMedia,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Media$all(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$Media$maxWidth(
							$rtfeldman$elm_css$Css$px(700))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$paddingLeft(
					$rtfeldman$elm_css$Css$px(64))
				]))
		]));
var $author$project$Reusable$Card$configTabCard = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(12))
		]));
var $author$project$Reusable$Card$configTabSectionRoot = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]));
var $author$project$Reusable$Card$viewConfigCard = F2(
	function (title, nodes) {
		return $rtfeldman$elm_css$Html$Styled$toUnstyled(
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled($author$project$Mdl$Elevation$e2),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$author$project$Reusable$Card$configTabCard]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$fromUnstyled(
						$author$project$Reusable$Card$viewTitle(title)),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[$author$project$Reusable$Card$configTabSectionRoot]))
							]),
						A2($elm$core$List$map, $rtfeldman$elm_css$Html$Styled$fromUnstyled, nodes))
					])));
	});
var $author$project$Reusable$Card$viewConfigCard2 = F3(
	function (title, main, side) {
		return A2(
			$author$project$Reusable$Card$viewConfigCard,
			title,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$toUnstyled(
					A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[$author$project$Reusable$Card$configTabInnerSection1]))
							]),
						A2($elm$core$List$map, $rtfeldman$elm_css$Html$Styled$fromUnstyled, main))),
					$rtfeldman$elm_css$Html$Styled$toUnstyled(
					A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[$author$project$Reusable$Card$configTabInnerSection2]))
							]),
						A2($elm$core$List$map, $rtfeldman$elm_css$Html$Styled$fromUnstyled, side)))
				]));
	});
var $author$project$TimePicker$Label = function (a) {
	return {$: 0, a: a};
};
var $author$project$TimePicker$label = function (str) {
	return $author$project$TimePicker$Label(str);
};
var $author$project$TimePicker$Value = function (a) {
	return {$: 3, a: a};
};
var $author$project$TimePicker$value = function (time) {
	return $author$project$TimePicker$Value(time);
};
var $author$project$TimePicker$initTime = {c5: 0, dk: 0};
var $author$project$TimePicker$initConfig = function (onChange) {
	return {
		d$: false,
		ld: '',
		c9: 'Label',
		ca: {c5: 24, dk: 59},
		cd: $author$project$TimePicker$initTime,
		fx: onChange,
		eL: $author$project$TimePicker$initTime
	};
};
var $author$project$TimePicker$toProp = F2(
	function (prop, config) {
		switch (prop.$) {
			case 0:
				var str = prop.a;
				return _Utils_update(
					config,
					{c9: str});
			case 1:
				var str = prop.a;
				return _Utils_update(
					config,
					{ld: str});
			case 3:
				var time = prop.a;
				return _Utils_update(
					config,
					{eL: time});
			case 4:
				var time = prop.a;
				return _Utils_update(
					config,
					{cd: time});
			case 5:
				var time = prop.a;
				return _Utils_update(
					config,
					{ca: time});
			case 6:
				var func = prop.a;
				return _Utils_update(
					config,
					{fx: func});
			default:
				var bool = prop.a;
				return _Utils_update(
					config,
					{d$: bool});
		}
	});
var $author$project$TimePicker$props = F2(
	function (attrs, config) {
		return A3($elm$core$List$foldr, $author$project$TimePicker$toProp, config, attrs);
	});
var $author$project$TimePicker$viewLabel = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'margin-bottom', '4px'),
				A2($elm$html$Html$Attributes$style, 'font-family', 'roboto'),
				A2($elm$html$Html$Attributes$style, 'color', 'rgba(0,0,0,0.54)'),
				A2($elm$html$Html$Attributes$style, 'line-height', '16px')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(config.c9)
			]));
};
var $author$project$TimePicker$formatTime = function (time) {
	var suffix = (time.c5 < 12) ? 'am' : 'pm';
	var minute = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(time.dk));
	var hour = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			A2($elm$core$Basics$modBy, 12, time.c5)));
	return hour + (':' + (minute + (' ' + suffix)));
};
var $author$project$TimePicker$inputStyle = _List_fromArray(
	[
		A2($elm$html$Html$Attributes$style, 'font-family', ' roboto'),
		A2($elm$html$Html$Attributes$style, 'font-size', ' 16px'),
		A2($elm$html$Html$Attributes$style, 'color', ' rgba(0,0,0,0.87)')
	]);
var $author$project$TimePicker$formatValue = function (val) {
	return ((val >= 0) && (val <= 9)) ? ('0' + $elm$core$String$fromInt(val)) : $elm$core$String$fromInt(val);
};
var $author$project$TimePicker$viewSelectHour = function (config) {
	var hourMsg = F3(
		function (minute, func, hourStr) {
			var _v0 = $elm$core$String$toInt(hourStr);
			if (!_v0.$) {
				var hour = _v0.a;
				return ((_Utils_cmp(hour, config.ca.c5) > 0) || (_Utils_cmp(hour, config.cd.c5) < 0)) ? func($elm$core$Maybe$Nothing) : func(
					$elm$core$Maybe$Just(
						{c5: hour, dk: minute}));
			} else {
				return func($elm$core$Maybe$Nothing);
			}
		});
	return A2(
		$elm$html$Html$input,
		_Utils_ap(
			$author$project$TimePicker$inputStyle,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('number'),
					A2($elm$html$Html$Attributes$style, 'width', '35px'),
					$elm$html$Html$Attributes$value(
					$author$project$TimePicker$formatValue(config.eL.c5)),
					$elm$html$Html$Attributes$min(
					$elm$core$String$fromInt(config.cd.c5)),
					$elm$html$Html$Attributes$max(
					$elm$core$String$fromInt(config.ca.c5)),
					$elm$html$Html$Attributes$disabled(config.d$),
					$elm$html$Html$Attributes$size(2),
					$elm$html$Html$Attributes$maxlength(2),
					$elm$html$Html$Events$onInput(
					A2(hourMsg, config.eL.dk, config.fx))
				])),
		_List_Nil);
};
var $author$project$TimePicker$viewSelectMinute = function (config) {
	var minValue = _Utils_eq(config.cd.c5, config.eL.c5) ? config.cd.dk : 0;
	var maxValue = _Utils_eq(config.ca.c5, config.eL.c5) ? config.ca.dk : 59;
	var minuteMsg = F3(
		function (hour, func, minuteStr) {
			var _v0 = $elm$core$String$toInt(minuteStr);
			if (!_v0.$) {
				var minute = _v0.a;
				return ((_Utils_cmp(minute, minValue) < 0) || (_Utils_cmp(minute, maxValue) > 0)) ? func($elm$core$Maybe$Nothing) : func(
					$elm$core$Maybe$Just(
						{c5: hour, dk: minute}));
			} else {
				return func($elm$core$Maybe$Nothing);
			}
		});
	return A2(
		$elm$html$Html$input,
		_Utils_ap(
			$author$project$TimePicker$inputStyle,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('number'),
					A2($elm$html$Html$Attributes$style, 'width', '35px'),
					$elm$html$Html$Attributes$value(
					$author$project$TimePicker$formatValue(config.eL.dk)),
					$elm$html$Html$Attributes$min(
					$elm$core$String$fromInt(minValue)),
					$elm$html$Html$Attributes$max(
					$elm$core$String$fromInt(maxValue)),
					$elm$html$Html$Attributes$size(2),
					$elm$html$Html$Attributes$maxlength(2),
					$elm$html$Html$Attributes$disabled(config.d$),
					$elm$html$Html$Events$onInput(
					A2(minuteMsg, config.eL.c5, config.fx))
				])),
		_List_Nil);
};
var $author$project$TimePicker$viewValue = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'align-items', 'center')
			]),
		_List_fromArray(
			[
				$author$project$TimePicker$viewSelectHour(config),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'margin', '0px 6px')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(':')
					])),
				$author$project$TimePicker$viewSelectMinute(config),
				A2(
				$elm$html$Html$div,
				_Utils_ap(
					$author$project$TimePicker$inputStyle,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-left', '8px')
						])),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$TimePicker$formatTime(config.eL))
					]))
			]));
};
var $author$project$TimePicker$view = F2(
	function (onChange, attrs) {
		var config = A2(
			$author$project$TimePicker$props,
			attrs,
			$author$project$TimePicker$initConfig(onChange));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'flex-direction', 'column')
				]),
			_List_fromArray(
				[
					$author$project$TimePicker$viewLabel(config),
					$author$project$TimePicker$viewValue(config)
				]));
	});
var $author$project$Pages$CfgDevice$Schedule$viewEndTime = F2(
	function (schdName, schedule) {
		return A2(
			$author$project$TimePicker$view,
			$author$project$Pages$CfgDevice$Schedule$EndTime(schdName),
			_List_fromArray(
				[
					$author$project$TimePicker$label('End Time'),
					$author$project$TimePicker$value(schedule.e2)
				]));
	});
var $author$project$Pages$CfgDevice$Schedule$ServingLineChange = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Select$MultiSelect = function (a) {
	return {$: 3, a: a};
};
var $author$project$Select$multiSelect = $author$project$Select$MultiSelect(true);
var $author$project$Select$MultiValue = function (a) {
	return {$: 13, a: a};
};
var $author$project$Select$multiValue = function (val) {
	return $author$project$Select$MultiValue(val);
};
var $author$project$Select$OnMultiSelect = function (a) {
	return {$: 14, a: a};
};
var $author$project$Select$onMultiSelect = function (val) {
	return $author$project$Select$OnMultiSelect(val);
};
var $author$project$Select$string = {dS: $elm$core$Basics$eq, d8: $elm$core$Basics$identity, ep: $elm$core$Basics$identity};
var $author$project$Pages$CfgDevice$Schedule$viewServingLine = F4(
	function (model, index, schdName, schedule) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'margin-top', '12px')
				]),
			_List_fromArray(
				[
					A5(
					$author$project$Select$view,
					$author$project$Pages$CfgDevice$Schedule$SelectMsg,
					_List_fromArray(
						[index, 1]),
					model.r,
					$author$project$Select$string,
					_List_fromArray(
						[
							$author$project$Select$label('Serving Line(s)'),
							$author$project$Select$multiSelect,
							$author$project$Select$searchable,
							$author$project$Select$options(
							A2($elm$core$List$cons, $author$project$Entity$ServingLine$allLines, model.jR)),
							$author$project$Select$multiValue(schedule.fp.jR),
							$author$project$Select$onMultiSelect(
							A2(
								$elm$core$Basics$composeR,
								$author$project$Entity$ServingLine$filterLines,
								$author$project$Pages$CfgDevice$Schedule$ServingLineChange(schdName)))
						]))
				]));
	});
var $author$project$Pages$CfgDevice$Schedule$viewStartTime = F2(
	function (schdName, schedule) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'margin', '12px 0px')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$TimePicker$view,
					$author$project$Pages$CfgDevice$Schedule$StartTime(schdName),
					_List_fromArray(
						[
							$author$project$TimePicker$label('Start Time'),
							$author$project$TimePicker$value(schedule.fI)
						]))
				]));
	});
var $author$project$Pages$CfgDevice$Schedule$EnableSchedule = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Schedule$viewToggleStatusCheckbox = F2(
	function (schdName, schedule) {
		var state = schedule.fi ? $aforemny$material_components_web_elm$Material$Checkbox$checked : $aforemny$material_components_web_elm$Material$Checkbox$unchecked;
		var label = function () {
			var _v0 = schedule.fi;
			if (_v0) {
				return 'Status (Active)';
			} else {
				return 'Status (Disabled)';
			}
		}();
		return A2(
			$aforemny$material_components_web_elm$Material$FormField$formField,
			A2(
				$aforemny$material_components_web_elm$Material$FormField$setAttributes,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'display', 'flex'),
						A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
						A2($elm$html$Html$Attributes$style, 'width', '250px')
					]),
				A2(
					$aforemny$material_components_web_elm$Material$FormField$setLabel,
					$elm$core$Maybe$Just(label),
					$aforemny$material_components_web_elm$Material$FormField$config)),
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$Checkbox$checkbox(
					A2(
						$aforemny$material_components_web_elm$Material$Checkbox$setOnChange,
						A2($author$project$Pages$CfgDevice$Schedule$EnableSchedule, schdName, !schedule.fi),
						A2(
							$aforemny$material_components_web_elm$Material$Checkbox$setState,
							$elm$core$Maybe$Just(state),
							$aforemny$material_components_web_elm$Material$Checkbox$config)))
				]));
	});
var $author$project$Pages$CfgDevice$Schedule$viewSchedule = F5(
	function (flags, device, model, index, _v0) {
		var schdName = _v0.a;
		var schedule = _v0.b;
		var isCurrentlyPlaying = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Basics$eq(schdName),
					$elm$core$Maybe$Just),
				device.jd));
		return A3(
			$author$project$Reusable$Card$viewConfigCard2,
			isCurrentlyPlaying ? ('▸ ' + schedule.g8) : schedule.g8,
			_List_fromArray(
				[
					isCurrentlyPlaying ? A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'font-size', '12px'),
							A2($elm$html$Html$Attributes$style, 'color', 'rgb(45,45,45)')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('(This is currently playing)')
						])) : $elm$html$Html$text(''),
					$author$project$Reusable$Flex$viewHorizontal(
					_List_fromArray(
						[
							A5(
							$author$project$Select$view,
							$author$project$Pages$CfgDevice$Schedule$SelectMsg,
							_List_fromArray(
								[index, 0]),
							model.r,
							{
								dS: F2(
									function (a, b) {
										return _Utils_eq(a.g8, b.g8);
									}),
								d8: function (a) {
									return a.g8 + ('-' + A2(
										$elm$core$Basics$composeR,
										$elm$core$Set$toList,
										$elm$core$String$join(' '))(a.aX));
								},
								ep: function ($) {
									return $.g8;
								}
							},
							_List_fromArray(
								[
									$author$project$Select$label('Template'),
									$author$project$Select$searchable,
									$author$project$Select$options(model.al),
									$author$project$Select$value(
									$elm$core$Maybe$Just(
										A2($author$project$Template$Core$MinimalTemplate, schedule.fN, $elm$core$Set$empty))),
									$author$project$Select$onSelect(
									$author$project$Pages$CfgDevice$Schedule$SelectTemplate(schdName))
								])),
							A5(
							$author$project$Reusable$Tooltip$view,
							$author$project$Pages$CfgDevice$Schedule$Tooltip,
							_List_fromArray(
								[index, 0]),
							model.fQ,
							_List_fromArray(
								[
									$author$project$Reusable$Tooltip$label('Edit Template')
								]),
							A2(
								$aforemny$material_components_web_elm$Material$IconButton$iconButton,
								A2(
									$aforemny$material_components_web_elm$Material$IconButton$setOnClick,
									A2($author$project$Pages$CfgDevice$Schedule$InitiateEditTemplate, flags.an, schedule.fN),
									$aforemny$material_components_web_elm$Material$IconButton$config),
								$aforemny$material_components_web_elm$Material$IconButton$icon('edit')))
						])),
					A4($author$project$Pages$CfgDevice$Schedule$viewServingLine, model, index, schdName, schedule)
				]),
			_List_fromArray(
				[
					A2($author$project$Pages$CfgDevice$Schedule$viewToggleStatusCheckbox, schdName, schedule),
					A2($author$project$Pages$CfgDevice$Schedule$viewStartTime, schdName, schedule),
					A2($author$project$Pages$CfgDevice$Schedule$viewEndTime, schdName, schedule)
				]));
	});
var $author$project$Pages$CfgDevice$Schedule$view = F3(
	function (flags, model, device) {
		var _v0 = $elm$core$Dict$isEmpty(model.mo);
		if (_v0) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', '100%'),
						A2($elm$html$Html$Attributes$style, 'margin-top', '30px'),
						A2($elm$html$Html$Attributes$style, 'display', 'flex'),
						A2($elm$html$Html$Attributes$style, 'justify-content', 'center')
					]),
				_List_fromArray(
					[
						$aforemny$material_components_web_elm$Material$CircularProgress$indeterminate($aforemny$material_components_web_elm$Material$CircularProgress$config)
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', '100%'),
						A2($elm$html$Html$Attributes$style, 'display', 'flex'),
						A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
						A2($elm$html$Html$Attributes$style, 'margin-top', '12px')
					]),
				_List_fromArray(
					[
						_Utils_eq(device.jd, $elm$core$Maybe$Nothing) ? A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'font-weight', '600')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('The Device is currently displaying the screensaver')
							])) : $elm$html$Html$text(''),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'display', 'flex'),
								A2($elm$html$Html$Attributes$style, 'flex-direction', 'column')
							]),
						A2(
							$elm$core$List$indexedMap,
							A3($author$project$Pages$CfgDevice$Schedule$viewSchedule, flags, device, model),
							$elm$core$Dict$toList(model.mo))),
						$author$project$Pages$CfgDevice$Schedule$viewResetTimings(model)
					]));
		}
	});
var $author$project$Reusable$Header$subHeader = function (str) {
	return A2(
		$elm$html$Html$h4,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'box-sizing', 'border-box'),
				A2($elm$html$Html$Attributes$style, 'color', 'rgb(0,0,0,0.54)'),
				A2($elm$html$Html$Attributes$style, 'font-size', '14px'),
				A2($elm$html$Html$Attributes$style, 'font-weight', '500'),
				A2($elm$html$Html$Attributes$style, 'line-height', '48px'),
				A2($elm$html$Html$Attributes$style, 'padding-left', '16px'),
				A2($elm$html$Html$Attributes$style, 'margin', '0px'),
				A2($elm$html$Html$Attributes$style, 'width', '100%')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $author$project$Reusable$Header$subHeader2 = F2(
	function (str, node) {
		return A2(
			$elm$html$Html$h4,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'box-sizing', 'border-box'),
					A2($elm$html$Html$Attributes$style, 'color', 'rgb(0,0,0,0.54)'),
					A2($elm$html$Html$Attributes$style, 'font-size', '14px'),
					A2($elm$html$Html$Attributes$style, 'font-weight', '500'),
					A2($elm$html$Html$Attributes$style, 'line-height', '48px'),
					A2($elm$html$Html$Attributes$style, 'padding-left', '16px'),
					A2($elm$html$Html$Attributes$style, 'margin', '0px'),
					A2($elm$html$Html$Attributes$style, 'width', '100%'),
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
					A2($elm$html$Html$Attributes$style, 'justify-content', 'space-between')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(str),
					node
				]));
	});
var $aforemny$material_components_web_elm$Material$LinearProgress$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$LinearProgress$config = {fZ: _List_Nil, gb: false, hC: false};
var $aforemny$material_components_web_elm$Material$LinearProgress$Indeterminate = {$: 0};
var $aforemny$material_components_web_elm$Material$LinearProgress$bufferBarElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-linear-progress__buffer-bar')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$LinearProgress$bufferDotsElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-linear-progress__buffer-dots')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$LinearProgress$bufferElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-linear-progress__buffer')
		]),
	_List_fromArray(
		[$aforemny$material_components_web_elm$Material$LinearProgress$bufferBarElt, $aforemny$material_components_web_elm$Material$LinearProgress$bufferDotsElt]));
var $aforemny$material_components_web_elm$Material$LinearProgress$bufferProp = function (variant) {
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'buffer',
			$elm$json$Json$Encode$float(
				function () {
					if (variant.$ === 2) {
						var buffer = variant.b;
						return buffer;
					} else {
						return 0;
					}
				}())));
};
var $aforemny$material_components_web_elm$Material$LinearProgress$closedProp = function (_v0) {
	var closed = _v0.gb;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'closed',
			$elm$json$Json$Encode$bool(closed)));
};
var $aforemny$material_components_web_elm$Material$LinearProgress$determinateProp = function (variant) {
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'determinate',
			$elm$json$Json$Encode$bool(
				!_Utils_eq(variant, $aforemny$material_components_web_elm$Material$LinearProgress$Indeterminate))));
};
var $aforemny$material_components_web_elm$Material$LinearProgress$displayCss = $elm$core$Maybe$Just(
	A2($elm$html$Html$Attributes$style, 'display', 'block'));
var $aforemny$material_components_web_elm$Material$LinearProgress$barInnerElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-linear-progress__bar-inner')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$LinearProgress$primaryBarElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-linear-progress__bar mdc-linear-progress__primary-bar')
		]),
	_List_fromArray(
		[$aforemny$material_components_web_elm$Material$LinearProgress$barInnerElt]));
var $aforemny$material_components_web_elm$Material$LinearProgress$progressProp = function (variant) {
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'progress',
			$elm$json$Json$Encode$float(
				function () {
					switch (variant.$) {
						case 1:
							var progress = variant.a;
							return progress;
						case 2:
							var progress = variant.a;
							return progress;
						default:
							return 0;
					}
				}())));
};
var $aforemny$material_components_web_elm$Material$LinearProgress$reverseProp = function (_v0) {
	var reverse = _v0.hC;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'reverse',
			$elm$json$Json$Encode$bool(reverse)));
};
var $aforemny$material_components_web_elm$Material$LinearProgress$roleAttr = $elm$core$Maybe$Just(
	A2($elm$html$Html$Attributes$attribute, 'role', 'progressbar'));
var $aforemny$material_components_web_elm$Material$LinearProgress$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-linear-progress'));
var $aforemny$material_components_web_elm$Material$LinearProgress$secondaryBarElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-linear-progress__bar mdc-linear-progress__secondary-bar')
		]),
	_List_fromArray(
		[$aforemny$material_components_web_elm$Material$LinearProgress$barInnerElt]));
var $aforemny$material_components_web_elm$Material$LinearProgress$variantCs = function (variant) {
	if (!variant.$) {
		return $elm$core$Maybe$Just(
			$elm$html$Html$Attributes$class('mdc-linear-progress--indeterminate'));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $aforemny$material_components_web_elm$Material$LinearProgress$linearProgress = F2(
	function (variant, config_) {
		var additionalAttributes = config_.fZ;
		return A3(
			$elm$html$Html$node,
			'mdc-linear-progress',
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$LinearProgress$rootCs,
							$aforemny$material_components_web_elm$Material$LinearProgress$displayCss,
							$aforemny$material_components_web_elm$Material$LinearProgress$roleAttr,
							$aforemny$material_components_web_elm$Material$LinearProgress$variantCs(variant),
							$aforemny$material_components_web_elm$Material$LinearProgress$determinateProp(variant),
							$aforemny$material_components_web_elm$Material$LinearProgress$progressProp(variant),
							$aforemny$material_components_web_elm$Material$LinearProgress$bufferProp(variant),
							$aforemny$material_components_web_elm$Material$LinearProgress$reverseProp(config_),
							$aforemny$material_components_web_elm$Material$LinearProgress$closedProp(config_)
						])),
				additionalAttributes),
			_List_fromArray(
				[$aforemny$material_components_web_elm$Material$LinearProgress$bufferElt, $aforemny$material_components_web_elm$Material$LinearProgress$primaryBarElt, $aforemny$material_components_web_elm$Material$LinearProgress$secondaryBarElt]));
	});
var $aforemny$material_components_web_elm$Material$LinearProgress$indeterminate = function (config_) {
	return A2($aforemny$material_components_web_elm$Material$LinearProgress$linearProgress, $aforemny$material_components_web_elm$Material$LinearProgress$Indeterminate, config_);
};
var $author$project$Pages$CfgDevice$Settings$loading = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'display', 'flex'),
			A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
			A2($elm$html$Html$Attributes$style, 'width', '100%'),
			A2($elm$html$Html$Attributes$style, 'margin', '4px 0px')
		]),
	_List_fromArray(
		[
			$aforemny$material_components_web_elm$Material$LinearProgress$indeterminate($aforemny$material_components_web_elm$Material$LinearProgress$config)
		]));
var $author$project$Pages$CfgDevice$Settings$PermText = function (a) {
	return {$: 23, a: a};
};
var $aforemny$material_components_web_elm$Material$TextArea$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$TextArea$config = {fZ: _List_Nil, gd: $elm$core$Maybe$Nothing, d$: false, ea: false, c9: $elm$core$Maybe$Nothing, fo: $elm$core$Maybe$Nothing, fr: $elm$core$Maybe$Nothing, fx: $elm$core$Maybe$Nothing, hg: $elm$core$Maybe$Nothing, ht: $elm$core$Maybe$Nothing, hB: false, jJ: $elm$core$Maybe$Nothing, hU: true, eL: $elm$core$Maybe$Nothing};
var $aforemny$material_components_web_elm$Material$TextArea$disabledCs = function (_v0) {
	var disabled = _v0.d$;
	return disabled ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--disabled')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextArea$disabledProp = function (_v0) {
	var disabled = _v0.d$;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'disabled',
			$elm$json$Json$Encode$bool(disabled)));
};
var $aforemny$material_components_web_elm$Material$TextArea$fullwidthCs = function (_v0) {
	var fullwidth = _v0.ea;
	return fullwidth ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--fullwidth')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextArea$ariaLabelAttr = function (_v0) {
	var fullwidth = _v0.ea;
	var placeholder = _v0.ht;
	var label = _v0.c9;
	return fullwidth ? A2(
		$elm$core$Maybe$map,
		$elm$html$Html$Attributes$attribute('aria-label'),
		label) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextArea$changeHandler = function (_v0) {
	var onChange = _v0.fx;
	return A2(
		$elm$core$Maybe$map,
		function (f) {
			return A2(
				$elm$html$Html$Events$on,
				'change',
				A2($elm$json$Json$Decode$map, f, $elm$html$Html$Events$targetValue));
		},
		onChange);
};
var $elm$html$Html$Attributes$cols = function (n) {
	return A2(
		_VirtualDom_attribute,
		'cols',
		$elm$core$String$fromInt(n));
};
var $aforemny$material_components_web_elm$Material$TextArea$colsAttr = function (_v0) {
	var cols = _v0.gd;
	return A2($elm$core$Maybe$map, $elm$html$Html$Attributes$cols, cols);
};
var $aforemny$material_components_web_elm$Material$TextArea$inputCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-text-field__input'));
var $aforemny$material_components_web_elm$Material$TextArea$inputHandler = function (_v0) {
	var onInput = _v0.hg;
	return A2($elm$core$Maybe$map, $elm$html$Html$Events$onInput, onInput);
};
var $aforemny$material_components_web_elm$Material$TextArea$maxLengthAttr = function (_v0) {
	var maxLength = _v0.fo;
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$html$Html$Attributes$attribute('maxLength'),
			$elm$core$String$fromInt),
		maxLength);
};
var $aforemny$material_components_web_elm$Material$TextArea$minLengthAttr = function (_v0) {
	var minLength = _v0.fr;
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$html$Html$Attributes$attribute('minLength'),
			$elm$core$String$fromInt),
		minLength);
};
var $aforemny$material_components_web_elm$Material$TextArea$placeholderAttr = function (_v0) {
	var placeholder = _v0.ht;
	return A2($elm$core$Maybe$map, $elm$html$Html$Attributes$placeholder, placeholder);
};
var $elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		$elm$core$String$fromInt(n));
};
var $aforemny$material_components_web_elm$Material$TextArea$rowsAttr = function (_v0) {
	var rows = _v0.jJ;
	return A2($elm$core$Maybe$map, $elm$html$Html$Attributes$rows, rows);
};
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $aforemny$material_components_web_elm$Material$TextArea$inputElt = function (config_) {
	return A2(
		$elm$html$Html$textarea,
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$TextArea$inputCs,
					$aforemny$material_components_web_elm$Material$TextArea$ariaLabelAttr(config_),
					$aforemny$material_components_web_elm$Material$TextArea$rowsAttr(config_),
					$aforemny$material_components_web_elm$Material$TextArea$colsAttr(config_),
					$aforemny$material_components_web_elm$Material$TextArea$placeholderAttr(config_),
					$aforemny$material_components_web_elm$Material$TextArea$inputHandler(config_),
					$aforemny$material_components_web_elm$Material$TextArea$changeHandler(config_),
					$aforemny$material_components_web_elm$Material$TextArea$minLengthAttr(config_),
					$aforemny$material_components_web_elm$Material$TextArea$maxLengthAttr(config_)
				])),
		_List_Nil);
};
var $aforemny$material_components_web_elm$Material$TextArea$maxLengthProp = function (_v0) {
	var maxLength = _v0.fo;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'maxLength',
			$elm$json$Json$Encode$int(
				A2($elm$core$Maybe$withDefault, -1, maxLength))));
};
var $aforemny$material_components_web_elm$Material$TextArea$minLengthProp = function (_v0) {
	var minLength = _v0.fr;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'minLength',
			$elm$json$Json$Encode$int(
				A2($elm$core$Maybe$withDefault, -1, minLength))));
};
var $aforemny$material_components_web_elm$Material$TextArea$noLabelCs = function (_v0) {
	var label = _v0.c9;
	return _Utils_eq(label, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--no-label')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextArea$notchedOutlineLeadingElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-notched-outline__leading')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$TextArea$labelElt = function (_v0) {
	var label = _v0.c9;
	var value = _v0.eL;
	var floatingLabelFloatAboveCs = 'mdc-floating-label--float-above';
	var floatingLabelCs = 'mdc-floating-label';
	if (!label.$) {
		var str = label.a;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					(A2($elm$core$Maybe$withDefault, '', value) !== '') ? $elm$html$Html$Attributes$class(floatingLabelCs + (' ' + floatingLabelFloatAboveCs)) : $elm$html$Html$Attributes$class(floatingLabelCs),
					A2(
					$elm$html$Html$Attributes$property,
					'foucClassNames',
					A2(
						$elm$json$Json$Encode$list,
						$elm$json$Json$Encode$string,
						_List_fromArray(
							[floatingLabelFloatAboveCs])))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(str)
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $aforemny$material_components_web_elm$Material$TextArea$notchedOutlineNotchElt = function (config_) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mdc-notched-outline__notch')
			]),
		_List_fromArray(
			[
				$aforemny$material_components_web_elm$Material$TextArea$labelElt(config_)
			]));
};
var $aforemny$material_components_web_elm$Material$TextArea$notchedOutlineTrailingElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-notched-outline__trailing')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$TextArea$notchedOutlineElt = function (config_) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mdc-notched-outline')
			]),
		_List_fromArray(
			[
				$aforemny$material_components_web_elm$Material$TextArea$notchedOutlineLeadingElt,
				$aforemny$material_components_web_elm$Material$TextArea$notchedOutlineNotchElt(config_),
				$aforemny$material_components_web_elm$Material$TextArea$notchedOutlineTrailingElt
			]));
};
var $aforemny$material_components_web_elm$Material$TextArea$outlinedCs = function (outlined_) {
	return outlined_ ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--outlined')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextArea$requiredProp = function (_v0) {
	var required = _v0.hB;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'required',
			$elm$json$Json$Encode$bool(required)));
};
var $aforemny$material_components_web_elm$Material$TextArea$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-text-field mdc-text-field--textarea'));
var $aforemny$material_components_web_elm$Material$TextArea$validProp = function (_v0) {
	var valid = _v0.hU;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'valid',
			$elm$json$Json$Encode$bool(valid)));
};
var $aforemny$material_components_web_elm$Material$TextArea$valueProp = function (_v0) {
	var value = _v0.eL;
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$html$Html$Attributes$property('value'),
			$elm$json$Json$Encode$string),
		value);
};
var $aforemny$material_components_web_elm$Material$TextArea$textArea = F2(
	function (outlined_, config_) {
		var additionalAttributes = config_.fZ;
		var fullwidth = config_.ea;
		return A3(
			$elm$html$Html$node,
			'mdc-text-field',
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$TextArea$rootCs,
							$aforemny$material_components_web_elm$Material$TextArea$noLabelCs(config_),
							$aforemny$material_components_web_elm$Material$TextArea$outlinedCs(outlined_),
							$aforemny$material_components_web_elm$Material$TextArea$fullwidthCs(config_),
							$aforemny$material_components_web_elm$Material$TextArea$disabledCs(config_),
							$aforemny$material_components_web_elm$Material$TextArea$valueProp(config_),
							$aforemny$material_components_web_elm$Material$TextArea$disabledProp(config_),
							$aforemny$material_components_web_elm$Material$TextArea$requiredProp(config_),
							$aforemny$material_components_web_elm$Material$TextArea$validProp(config_),
							$aforemny$material_components_web_elm$Material$TextArea$minLengthProp(config_),
							$aforemny$material_components_web_elm$Material$TextArea$maxLengthProp(config_)
						])),
				additionalAttributes),
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$TextArea$inputElt(config_),
					$aforemny$material_components_web_elm$Material$TextArea$notchedOutlineElt(config_)
				]));
	});
var $aforemny$material_components_web_elm$Material$TextArea$outlined = function (config_) {
	return A2($aforemny$material_components_web_elm$Material$TextArea$textArea, true, config_);
};
var $aforemny$material_components_web_elm$Material$TextArea$setAttributes = F2(
	function (additionalAttributes, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{fZ: additionalAttributes});
	});
var $aforemny$material_components_web_elm$Material$TextArea$setLabel = F2(
	function (label, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{c9: label});
	});
var $aforemny$material_components_web_elm$Material$TextArea$setOnInput = F2(
	function (onInput, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{
				hg: $elm$core$Maybe$Just(onInput)
			});
	});
var $aforemny$material_components_web_elm$Material$TextArea$setRows = F2(
	function (rows, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{jJ: rows});
	});
var $aforemny$material_components_web_elm$Material$TextArea$setValue = F2(
	function (value, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{eL: value});
	});
var $author$project$Pages$CfgDevice$Settings$viewPermTextField = F2(
	function (model, theme) {
		return $aforemny$material_components_web_elm$Material$TextArea$outlined(
			A2(
				$aforemny$material_components_web_elm$Material$TextArea$setAttributes,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'padding-right', '6px'),
						A2($elm$html$Html$Attributes$style, 'width', '100%')
					]),
				A2(
					$aforemny$material_components_web_elm$Material$TextArea$setRows,
					$elm$core$Maybe$Just(2),
					A2(
						$aforemny$material_components_web_elm$Material$TextArea$setOnInput,
						$author$project$Pages$CfgDevice$Settings$PermText,
						A2(
							$aforemny$material_components_web_elm$Material$TextArea$setValue,
							$elm$core$Maybe$Just(model.hq),
							A2(
								$aforemny$material_components_web_elm$Material$TextArea$setLabel,
								$elm$core$Maybe$Just('Banner Text'),
								$aforemny$material_components_web_elm$Material$TextArea$config))))));
	});
var $author$project$Pages$CfgDevice$Settings$SetPermText = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$CfgDevice$Settings$Tooltip = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$CfgDevice$Settings$viewSetPermTextButton = F2(
	function (model, theme) {
		var onClick = $author$project$Pages$CfgDevice$Settings$SetPermText(theme);
		var isDisabled = $elm$core$String$isEmpty(model.hq);
		return A5(
			$author$project$Reusable$Tooltip$view,
			$author$project$Pages$CfgDevice$Settings$Tooltip,
			_List_fromArray(
				[5, 5]),
			model.fQ,
			_List_fromArray(
				[
					$author$project$Reusable$Tooltip$label('Save Banner Text')
				]),
			A2(
				$aforemny$material_components_web_elm$Material$IconButton$iconButton,
				A2(
					$aforemny$material_components_web_elm$Material$IconButton$setDisabled,
					isDisabled,
					A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, onClick, $aforemny$material_components_web_elm$Material$IconButton$config)),
				$aforemny$material_components_web_elm$Material$IconButton$icon('save')));
	});
var $author$project$Pages$CfgDevice$Settings$viewPermTextEditor = F2(
	function (model, theme) {
		return $author$project$Reusable$Flex$viewHorizontal(
			_List_fromArray(
				[
					A2($author$project$Pages$CfgDevice$Settings$viewPermTextField, model, theme),
					A2($author$project$Pages$CfgDevice$Settings$viewSetPermTextButton, model, theme)
				]));
	});
var $author$project$Pages$CfgDevice$Settings$UpdateTheme = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$CfgDevice$Settings$viewPermTextFontSizeSelector = F2(
	function (model, theme) {
		return A2(
			$author$project$Reusable$Slider$view,
			function (val) {
				return $author$project$Pages$CfgDevice$Settings$UpdateTheme(
					_Utils_update(
						theme,
						{hr: val}));
			},
			_List_fromArray(
				[
					$author$project$Reusable$Slider$label('Font Size'),
					$author$project$Reusable$Slider$style(
					_List_fromArray(
						[
							_Utils_Tuple2('width', '100%'),
							_Utils_Tuple2('margin-bottom', '16px')
						])),
					$author$project$Reusable$Slider$min(38),
					$author$project$Reusable$Slider$max(64),
					$author$project$Reusable$Slider$value(theme.hr)
				]));
	});
var $author$project$Pages$CfgDevice$Settings$viewBannerEditor = function (model) {
	var _v0 = model.bH;
	if (!_v0.$) {
		var theme = _v0.a;
		return A3(
			$author$project$Reusable$Card$viewConfigCard2,
			'Banner',
			_List_fromArray(
				[
					A2($author$project$Pages$CfgDevice$Settings$viewPermTextFontSizeSelector, model, theme),
					A2($author$project$Pages$CfgDevice$Settings$viewPermTextEditor, model, theme)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[$aforemny$material_components_web_elm$Material$Typography$body1]),
					_List_fromArray(
						[
							$elm$html$Html$text('Banner text is displayed in the status bar')
						]))
				]));
	} else {
		return $author$project$Pages$CfgDevice$Settings$loading;
	}
};
var $author$project$Pages$CfgDevice$Settings$CloseDeactivateDialog = {$: 6};
var $author$project$Pages$CfgDevice$Settings$RunDeactivateCmd = function (a) {
	return {$: 10, a: a};
};
var $author$project$Entity$Device$isDeviceOffline = function (device) {
	return !$author$project$Entity$Device$isDeviceOnline(device);
};
var $author$project$Pages$CfgDevice$Settings$viewDeactivateButton = F2(
	function (config, model) {
		var onClick = $author$project$Pages$CfgDevice$Settings$RunDeactivateCmd(config);
		var isDisabled = $author$project$Entity$Device$isDeviceOffline(config.cV);
		return A2(
			$aforemny$material_components_web_elm$Material$Button$outlined,
			A2(
				$aforemny$material_components_web_elm$Material$Button$setDisabled,
				isDisabled,
				A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config)),
			'Deactivate');
	});
var $author$project$Pages$CfgDevice$Settings$viewConfirmDeactivationDialog = F2(
	function (config, model) {
		return A2(
			$aforemny$material_components_web_elm$Material$Dialog$dialog,
			A2(
				$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
				$author$project$Pages$CfgDevice$Settings$CloseDeactivateDialog,
				A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.cO, $aforemny$material_components_web_elm$Material$Dialog$config)),
			{
				kk: _List_fromArray(
					[
						A2($author$project$Pages$CfgDevice$Settings$viewDeactivateButton, config, model),
						A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$CfgDevice$Settings$CloseDeactivateDialog, $aforemny$material_components_web_elm$Material$Button$config),
						'Cancel')
					]),
				k_: _List_fromArray(
					[
						$elm$html$Html$text('This action will erase all data on the device and server.')
					]),
				na: $elm$core$Maybe$Just('Confirm')
			});
	});
var $author$project$Pages$CfgDevice$Settings$CloseRestartDialog = {$: 7};
var $author$project$Pages$CfgDevice$Settings$RunRestartCmd = {$: 11};
var $author$project$Pages$CfgDevice$Settings$viewRestartButton = F2(
	function (config, model) {
		var isDisabled = $author$project$Entity$Device$isDeviceOffline(config.cV);
		return A2(
			$aforemny$material_components_web_elm$Material$Button$outlined,
			A2(
				$aforemny$material_components_web_elm$Material$Button$setDisabled,
				isDisabled,
				A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$CfgDevice$Settings$RunRestartCmd, $aforemny$material_components_web_elm$Material$Button$config)),
			'Restart');
	});
var $author$project$Pages$CfgDevice$Settings$viewConfirmRestartDialog = F2(
	function (config, model) {
		return A2(
			$aforemny$material_components_web_elm$Material$Dialog$dialog,
			A2(
				$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
				$author$project$Pages$CfgDevice$Settings$CloseRestartDialog,
				A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.cP, $aforemny$material_components_web_elm$Material$Dialog$config)),
			{
				kk: _List_fromArray(
					[
						A2($author$project$Pages$CfgDevice$Settings$viewRestartButton, config, model),
						A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$CfgDevice$Settings$CloseRestartDialog, $aforemny$material_components_web_elm$Material$Button$config),
						'Cancel')
					]),
				k_: _List_fromArray(
					[
						$elm$html$Html$text('This action will restart the device. It may take a couple of minutes before the device is back online.')
					]),
				na: $elm$core$Maybe$Just('Confirm')
			});
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $author$project$Pages$CfgDevice$Settings$viewCpuInfo = function (model) {
	var _v0 = model.dY;
	if (_v0.$ === 1) {
		return $author$project$Pages$CfgDevice$Settings$loading;
	} else {
		var data = _v0.a;
		return A3(
			$author$project$Reusable$Card$viewConfigCard2,
			'Processor',
			_List_fromArray(
				[
					A2($author$project$Reusable$Label$view, 'Model Name', data.i9),
					A2($author$project$Reusable$Label$view, 'Architecture', data.ie)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Reusable$Label$view,
					'Temperature (℃)',
					$elm$core$List$isEmpty(data.jZ) ? 'Not available' : A2(
						$myrho$elm_round$Round$round,
						1,
						$elm$core$List$sum(data.jZ) / $elm$core$List$length(data.jZ)))
				]));
	}
};
var $author$project$Pages$CfgDevice$Settings$viewCommandDescription = A2(
	$elm$html$Html$p,
	_List_fromArray(
		[$aforemny$material_components_web_elm$Material$Typography$body1]),
	_List_fromArray(
		[
			$elm$html$Html$text('Commands are actions that are run directly on the device')
		]));
var $author$project$Pages$CfgDevice$Settings$RunCommand = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$CfgDevice$Settings$viewRunCommandButton = function (model) {
	var styles = _List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'min-width', '40px'),
			A2($elm$html$Html$Attributes$style, 'width', '40px'),
			A2($elm$html$Html$Attributes$style, 'height', '40px'),
			A2($elm$html$Html$Attributes$style, 'margin', '0px 8px')
		]);
	var onClick = function () {
		var _v0 = model.dv;
		if (!_v0.$) {
			var cmd = _v0.a;
			return $author$project$Pages$CfgDevice$Settings$RunCommand(cmd);
		} else {
			return $author$project$Pages$CfgDevice$Settings$NoOp;
		}
	}();
	return A5(
		$author$project$Reusable$Tooltip$view,
		$author$project$Pages$CfgDevice$Settings$Tooltip,
		_List_fromArray(
			[0]),
		model.fQ,
		_List_fromArray(
			[
				$author$project$Reusable$Tooltip$label('Run Command')
			]),
		A2(
			$aforemny$material_components_web_elm$Material$Fab$fab,
			A2(
				$aforemny$material_components_web_elm$Material$Fab$setAttributes,
				styles,
				A2($aforemny$material_components_web_elm$Material$Fab$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Fab$config)),
			$aforemny$material_components_web_elm$Material$Fab$icon('play_arrow')));
};
var $author$project$Pages$CfgDevice$Settings$DeactivateDevice = 1;
var $author$project$Pages$CfgDevice$Settings$HardReloadDevice = 0;
var $author$project$Pages$CfgDevice$Settings$ReloadMenu = 6;
var $author$project$Pages$CfgDevice$Settings$SaveDeviceState = 3;
var $author$project$Pages$CfgDevice$Settings$SaveSerialNumber = 2;
var $author$project$Pages$CfgDevice$Settings$SelectCommand = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$CfgDevice$Settings$SelectMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$CfgDevice$Settings$getCommandName = function (command) {
	switch (command) {
		case 0:
			return 'Restart Device';
		case 3:
			return 'Backup Device Data';
		case 2:
			return 'Save Serial Number';
		case 1:
			return 'Deactivate Device';
		case 4:
			return 'Mock Data Loss';
		case 5:
			return 'Start/Stop Animation';
		default:
			return 'Reload Menu';
	}
};
var $author$project$Pages$CfgDevice$Settings$viewSelectCommand = function (model) {
	return A5(
		$author$project$Select$view,
		$author$project$Pages$CfgDevice$Settings$SelectMsg,
		_List_fromArray(
			[0]),
		model.r,
		{dS: $elm$core$Basics$eq, d8: $author$project$Pages$CfgDevice$Settings$getCommandName, ep: $author$project$Pages$CfgDevice$Settings$getCommandName},
		_List_fromArray(
			[
				$author$project$Select$label('Choose a command and run'),
				$author$project$Select$options(
				_List_fromArray(
					[0, 2, 3, 1, 6])),
				$author$project$Select$value(model.dv),
				$author$project$Select$onSelect($author$project$Pages$CfgDevice$Settings$SelectCommand),
				$author$project$Select$rootStyle(
				_List_fromArray(
					[
						_Utils_Tuple2('width', '300px')
					]))
			]));
};
var $author$project$Pages$CfgDevice$Settings$viewDeviceCommands = function (model) {
	return A3(
		$author$project$Reusable$Card$viewConfigCard2,
		'Commands',
		_List_fromArray(
			[
				$author$project$Reusable$Flex$viewHorizontal(
				_List_fromArray(
					[
						$author$project$Pages$CfgDevice$Settings$viewSelectCommand(model),
						$author$project$Pages$CfgDevice$Settings$viewRunCommandButton(model)
					]))
			]),
		_List_fromArray(
			[$author$project$Pages$CfgDevice$Settings$viewCommandDescription]));
};
var $author$project$Pages$CfgDevice$Settings$ChangeName = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$CfgDevice$Settings$DeviceName = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $aforemny$material_components_web_elm$Material$TextField$setDisabled = F2(
	function (disabled, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{d$: disabled});
	});
var $author$project$Pages$CfgDevice$Settings$viewNameField = F2(
	function (config, model) {
		var value = A2(
			$elm$core$Maybe$withDefault,
			config.cV.g8,
			A2(
				$elm$core$Maybe$andThen,
				A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $elm$core$Tuple$first),
				model.bS));
		var onInput = $author$project$Pages$CfgDevice$Settings$DeviceName(
			$elm$core$Set$fromList(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.g8;
					},
					A2(
						$elm$core$List$filter,
						function (device) {
							return _Utils_eq(device.du.aF, config.cV.du.aF);
						},
						config.kv))));
		var onEnter = $author$project$Pages$CfgDevice$Settings$ChangeName(config);
		var isDisabled = $author$project$Entity$Device$isDeviceOffline(config.cV);
		var errorText = function (maybeErr) {
			if (!maybeErr.$) {
				var err = maybeErr.a;
				return (!$elm$core$String$isEmpty(err)) ? err : '';
			} else {
				return '';
			}
		}(
			A2(
				$elm$core$Maybe$andThen,
				A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $elm$core$Tuple$second),
				model.bS));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$TextField$outlined(
					A2(
						$aforemny$material_components_web_elm$Material$TextField$setAttributes,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'margin-right', '8px')
							]),
						A2(
							$aforemny$material_components_web_elm$Material$TextField$setDisabled,
							isDisabled,
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setOnInput,
								onInput,
								A2(
									$aforemny$material_components_web_elm$Material$TextField$setValue,
									$elm$core$Maybe$Just(value),
									A2(
										$aforemny$material_components_web_elm$Material$TextField$setLabel,
										$elm$core$Maybe$Just('Device Name'),
										$aforemny$material_components_web_elm$Material$TextField$config)))))),
					A2($aforemny$material_components_web_elm$Material$HelperText$helperText, $aforemny$material_components_web_elm$Material$HelperText$config, errorText)
				]));
	});
var $author$project$Pages$CfgDevice$Settings$viewSaveNameButton = F2(
	function (config, model) {
		var onClick = $author$project$Pages$CfgDevice$Settings$ChangeName(config);
		var isDisabled = $author$project$Entity$Device$isDeviceOffline(config.cV);
		return A5(
			$author$project$Reusable$Tooltip$view,
			$author$project$Pages$CfgDevice$Settings$Tooltip,
			_List_fromArray(
				[3]),
			model.fQ,
			_List_fromArray(
				[
					$author$project$Reusable$Tooltip$label('Save Name')
				]),
			A2(
				$aforemny$material_components_web_elm$Material$IconButton$iconButton,
				A2(
					$aforemny$material_components_web_elm$Material$IconButton$setDisabled,
					isDisabled,
					A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, onClick, $aforemny$material_components_web_elm$Material$IconButton$config)),
				$aforemny$material_components_web_elm$Material$IconButton$icon('save')));
	});
var $author$project$Pages$CfgDevice$Settings$viewChangeName = F2(
	function (config, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
					A2($elm$html$Html$Attributes$style, 'width', '100%'),
					A2($elm$html$Html$Attributes$style, 'margin-bottom', '5px')
				]),
			_List_fromArray(
				[
					A2($author$project$Pages$CfgDevice$Settings$viewNameField, config, model),
					A2($author$project$Pages$CfgDevice$Settings$viewSaveNameButton, config, model)
				]));
	});
var $author$project$Pages$CfgDevice$Settings$viewDeviceInformation = F2(
	function (config, model) {
		return A3(
			$author$project$Reusable$Card$viewConfigCard2,
			'Device Information',
			_List_fromArray(
				[
					A2(
					$author$project$Reusable$Label$view,
					'Serial Number',
					A2($elm$core$Maybe$withDefault, 'Unknown', model.jP)),
					A2($author$project$Pages$CfgDevice$Settings$viewChangeName, config, model)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Reusable$Label$view,
					'App Version',
					A2(
						$elm$core$Maybe$withDefault,
						'Unknown',
						A2(
							$elm$core$Maybe$andThen,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$Maybe$Just,
								function ($) {
									return $.hW;
								}),
							model.fl)))
				]));
	});
var $author$project$Pages$CfgDevice$Settings$viewChooseDate = function (model) {
	return A2(
		$elm$html$Html$map,
		$author$project$Pages$CfgDevice$Settings$DatePickerMsg,
		$author$project$Reusable$DatePicker$view(model.b8));
};
var $author$project$Pages$CfgDevice$Settings$SelectSchedule = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$CfgDevice$Settings$viewChooseSchedule = F2(
	function (_v0, model) {
		return A5(
			$author$project$Select$view,
			$author$project$Pages$CfgDevice$Settings$SelectMsg,
			_List_fromArray(
				[1]),
			model.r,
			{
				dS: F2(
					function (a, b) {
						return _Utils_eq(a.g8, b.g8);
					}),
				d8: function ($) {
					return $.g8;
				},
				ep: function ($) {
					return $.g8;
				}
			},
			_List_fromArray(
				[
					$author$project$Select$label('Select Schedule'),
					$author$project$Select$options(
					$elm$core$Dict$values(model.mo)),
					$author$project$Select$value(model.cl),
					$author$project$Select$onSelect($author$project$Pages$CfgDevice$Settings$SelectSchedule)
				]));
	});
var $author$project$Pages$CfgDevice$Settings$LoadCustomMenu = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Pages$CfgDevice$Settings$viewLoadMenuButton = F2(
	function (config, model) {
		var onClick = function () {
			var _v0 = _Utils_Tuple2(
				model.cl,
				$author$project$Reusable$DatePicker$selectedIsoDate(model.b8));
			if ((!_v0.a.$) && (!_v0.b.$)) {
				var a = _v0.a.a;
				var b = _v0.b.a;
				return A2($author$project$Pages$CfgDevice$Settings$LoadCustomMenu, a, b);
			} else {
				return $author$project$Pages$CfgDevice$Settings$NoOp;
			}
		}();
		var isDisabled = _Utils_eq(
			$author$project$Reusable$DatePicker$selectedIsoDate(model.b8),
			$elm$core$Maybe$Nothing) || ($author$project$Entity$Device$isDeviceOffline(config.cV) || _Utils_eq(model.cl, $elm$core$Maybe$Nothing));
		return A2(
			$aforemny$material_components_web_elm$Material$Button$outlined,
			A2(
				$aforemny$material_components_web_elm$Material$Button$setDisabled,
				isDisabled,
				A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config)),
			'Load Menu');
	});
var $author$project$Pages$CfgDevice$Settings$viewLoadMenuDescription = A2(
	$elm$html$Html$p,
	_List_fromArray(
		[$aforemny$material_components_web_elm$Material$Typography$body1]),
	_List_fromArray(
		[
			$elm$html$Html$text('This option can be used to test devices' + 'by loading a menu plan on a different date temporarily.')
		]));
var $author$project$Pages$CfgDevice$Settings$viewLoadMenuWarning = A2(
	$elm$html$Html$p,
	_List_fromArray(
		[$aforemny$material_components_web_elm$Material$Typography$body1]),
	_List_fromArray(
		[
			$elm$html$Html$text('[ Use for testing only ]')
		]));
var $author$project$Pages$CfgDevice$Settings$viewLoadMenu = F2(
	function (config, model) {
		return A3(
			$author$project$Reusable$Card$viewConfigCard2,
			'Temporarily Load Different Menu',
			_List_fromArray(
				[
					A2($author$project$Pages$CfgDevice$Settings$viewChooseSchedule, config, model),
					$author$project$Pages$CfgDevice$Settings$viewChooseDate(model),
					A2($author$project$Pages$CfgDevice$Settings$viewLoadMenuButton, config, model)
				]),
			_List_fromArray(
				[$author$project$Pages$CfgDevice$Settings$viewLoadMenuDescription, $author$project$Pages$CfgDevice$Settings$viewLoadMenuWarning]));
	});
var $author$project$Pages$CfgDevice$Settings$viewMemInfo = function (model) {
	var usage = F2(
		function (total, used) {
			return A2($myrho$elm_round$Round$round, 2, 100 * ((total - used) / total));
		});
	var byteToMb = F2(
		function (num, val) {
			return A2($myrho$elm_round$Round$round, num, val / 1073741824);
		});
	var _v0 = model.el;
	if (_v0.$ === 1) {
		return $author$project$Pages$CfgDevice$Settings$loading;
	} else {
		var data = _v0.a;
		return A3(
			$author$project$Reusable$Card$viewConfigCard2,
			'Memory',
			_List_fromArray(
				[
					A2(
					$author$project$Reusable$Label$view,
					'Total Capacity (GB)',
					A2(byteToMb, 0, data.io)),
					A2(
					$author$project$Reusable$Label$view,
					'Available Memory (GB)',
					A2(byteToMb, 2, data.$8))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Reusable$Label$view,
					'Usage (%)',
					A2(usage, data.io, data.$8))
				]));
	}
};
var $author$project$Pages$CfgDevice$Settings$ReqMonitoringData = {$: 17};
var $author$project$Pages$CfgDevice$Settings$viewPlatformInfoRefreshButton = function (model) {
	return A5(
		$author$project$Reusable$Tooltip$view,
		$author$project$Pages$CfgDevice$Settings$Tooltip,
		_List_fromArray(
			[99, 29]),
		model.fQ,
		_List_fromArray(
			[
				$author$project$Reusable$Tooltip$label('Refresh Data')
			]),
		A2(
			$aforemny$material_components_web_elm$Material$IconButton$iconButton,
			A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, $author$project$Pages$CfgDevice$Settings$ReqMonitoringData, $aforemny$material_components_web_elm$Material$IconButton$config),
			$aforemny$material_components_web_elm$Material$IconButton$icon('refresh')));
};
var $author$project$Entity$Screensaver$darkBg = 0;
var $author$project$Entity$Screensaver$images = 1;
var $author$project$Entity$Screensaver$optionName = function (opt) {
	if (!opt) {
		return 'Dark Background';
	} else {
		return 'Images';
	}
};
var $author$project$Pages$CfgDevice$Settings$viewScreensaverSelector = function (model) {
	return A5(
		$author$project$Select$view,
		$author$project$Pages$CfgDevice$Settings$SelectMsg,
		_List_fromArray(
			[1, 99, 45]),
		model.r,
		{
			dS: F2(
				function (a, b) {
					return _Utils_eq(
						$author$project$Entity$Screensaver$optionName(a),
						$author$project$Entity$Screensaver$optionName(b));
				}),
			d8: $author$project$Entity$Screensaver$optionName,
			ep: $author$project$Entity$Screensaver$optionName
		},
		_List_fromArray(
			[
				$author$project$Select$label('Select Screensaver'),
				$author$project$Select$value(model.eu),
				$author$project$Select$options(
				_List_fromArray(
					[$author$project$Entity$Screensaver$darkBg, $author$project$Entity$Screensaver$images])),
				$author$project$Select$onSelect($author$project$Pages$CfgDevice$Settings$SelectScreensaver)
			]));
};
var $author$project$Pages$CfgDevice$Settings$viewScreensaverEditor = function (model) {
	var _v0 = model.eu;
	if (!_v0.$) {
		var opt = _v0.a;
		return A3(
			$author$project$Reusable$Card$viewConfigCard2,
			'Screensaver',
			_List_fromArray(
				[
					$author$project$Pages$CfgDevice$Settings$viewScreensaverSelector(model)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[$aforemny$material_components_web_elm$Material$Typography$body1]),
					_List_fromArray(
						[
							$elm$html$Html$text('Screensaver is played between schedules')
						]))
				]));
	} else {
		return $author$project$Pages$CfgDevice$Settings$loading;
	}
};
var $author$project$Pages$CfgDevice$Settings$viewBackgroundSelector = F2(
	function (model, theme) {
		return A5(
			$author$project$Select$view,
			$author$project$Pages$CfgDevice$Settings$SelectMsg,
			_List_fromArray(
				[1, 23, 46]),
			model.r,
			$author$project$Select$string,
			_List_fromArray(
				[
					$author$project$Select$label('Background'),
					$author$project$Select$options(
					_List_fromArray(
						['Transparent', 'Light', 'Dark'])),
					$author$project$Select$onSelect(
					function (val) {
						return $author$project$Pages$CfgDevice$Settings$UpdateTheme(
							_Utils_update(
								theme,
								{f6: val}));
					}),
					$author$project$Select$value(
					$elm$core$Maybe$Just(theme.f6))
				]));
	});
var $author$project$Pages$CfgDevice$Settings$ColorPicker = function (a) {
	return {$: 4, a: a};
};
var $author$project$ColorPicker$Label = function (a) {
	return {$: 0, a: a};
};
var $author$project$ColorPicker$label = function (str) {
	return $author$project$ColorPicker$Label(str);
};
var $author$project$ColorPicker$OnChange = function (a) {
	return {$: 1, a: a};
};
var $author$project$ColorPicker$onChange = function (func) {
	return $author$project$ColorPicker$OnChange(func);
};
var $author$project$ColorPicker$Value = function (a) {
	return {$: 3, a: a};
};
var $author$project$ColorPicker$value = function (val) {
	return $author$project$ColorPicker$Value(val);
};
var $author$project$ColorPicker$NoOp = {$: 0};
var $author$project$ColorPicker$defaultConfig = F3(
	function (uniqueId, toMsg, isOpen) {
		return {
			dR: 'rgb(0,0,0)',
			d$: false,
			e8: false,
			fb: false,
			ef: isOpen,
			c9: $elm$core$Maybe$Nothing,
			fx: $elm$core$Basics$always(
				toMsg($author$project$ColorPicker$NoOp)),
			cz: toMsg,
			cB: uniqueId
		};
	});
var $author$project$ColorPicker$collect = F2(
	function (attr, config) {
		switch (attr.$) {
			case 0:
				var str = attr.a;
				return _Utils_update(
					config,
					{
						c9: $elm$core$Maybe$Just(str)
					});
			case 1:
				var func = attr.a;
				return _Utils_update(
					config,
					{fx: func});
			case 3:
				var val = attr.a;
				return _Utils_update(
					config,
					{dR: val});
			case 5:
				var val = attr.a;
				return _Utils_update(
					config,
					{d$: val});
			case 2:
				var val = attr.a;
				return _Utils_update(
					config,
					{e8: val});
			default:
				return _Utils_update(
					config,
					{fb: true});
		}
	});
var $author$project$ColorPicker$props = F2(
	function (listProp, config) {
		return A3($elm$core$List$foldl, $author$project$ColorPicker$collect, config, listProp);
	});
var $author$project$ColorPicker$ClosePicker = function (a) {
	return {$: 2, a: a};
};
var $rtfeldman$elm_css$Css$Transitions$Background = 0;
var $rtfeldman$elm_css$Css$Transitions$background = $rtfeldman$elm_css$Css$Transitions$durationTransition(0);
var $author$project$ColorPicker$viewCancelOverlay = function (config) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$vw(100)),
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$vh(100)),
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
						$rtfeldman$elm_css$Css$left(
						$rtfeldman$elm_css$Css$px(0)),
						$rtfeldman$elm_css$Css$top(
						$rtfeldman$elm_css$Css$px(0)),
						$rtfeldman$elm_css$Css$zIndex(
						$rtfeldman$elm_css$Css$int(1)),
						$rtfeldman$elm_css$Css$Transitions$transition(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Transitions$background(0.5)
							])),
						$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
						(config.ef === 1) ? $rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none) : $rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$initial)
					])),
				$rtfeldman$elm_css$Html$Styled$Events$onClick(
				config.cz(
					$author$project$ColorPicker$ClosePicker(config.cB)))
			]),
		_List_Nil);
};
var $rtfeldman$elm_css$Css$alignSelf = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'alignSelf',
		'align-self',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $noahzgordon$elm_color_extra$Color$Convert$colorToCssRgb = function (cl) {
	var _v0 = $avh4$elm_color$Color$toRgba(cl);
	var red = _v0.hz;
	var green = _v0.gF;
	var blue = _v0.f8;
	var alpha = _v0.f3;
	return A2(
		$noahzgordon$elm_color_extra$Color$Convert$cssColorString,
		'rgb',
		_List_fromArray(
			[
				$elm$core$String$fromFloat(red * 255),
				$elm$core$String$fromFloat(green * 255),
				$elm$core$String$fromFloat(blue * 255)
			]));
};
var $noahzgordon$elm_color_extra$Color$Convert$toRadix = function (n) {
	var getChr = function (c) {
		return (c < 10) ? $elm$core$String$fromInt(c) : $elm$core$String$fromChar(
			$elm$core$Char$fromCode(87 + c));
	};
	return (n < 16) ? getChr(n) : _Utils_ap(
		$noahzgordon$elm_color_extra$Color$Convert$toRadix((n / 16) | 0),
		getChr(
			A2($elm$core$Basics$modBy, 16, n)));
};
var $noahzgordon$elm_color_extra$Color$Convert$toHex = A2(
	$elm$core$Basics$composeR,
	$noahzgordon$elm_color_extra$Color$Convert$toRadix,
	A2($elm$core$String$padLeft, 2, '0'));
var $noahzgordon$elm_color_extra$Color$Convert$colorToHex = function (cl) {
	var _v0 = $avh4$elm_color$Color$toRgba(cl);
	var red = _v0.hz;
	var green = _v0.gF;
	var blue = _v0.f8;
	return A2(
		$elm$core$String$join,
		'',
		A2(
			$elm$core$List$cons,
			'#',
			A2(
				$elm$core$List$map,
				A2($elm$core$Basics$composeR, $elm$core$Basics$round, $noahzgordon$elm_color_extra$Color$Convert$toHex),
				_List_fromArray(
					[red * 255, green * 255, blue * 255]))));
};
var $avh4$elm_color$Color$scaleFrom255 = function (c) {
	return c / 255;
};
var $avh4$elm_color$Color$rgb255 = F3(
	function (r, g, b) {
		return A4(
			$avh4$elm_color$Color$RgbaSpace,
			$avh4$elm_color$Color$scaleFrom255(r),
			$avh4$elm_color$Color$scaleFrom255(g),
			$avh4$elm_color$Color$scaleFrom255(b),
			1.0);
	});
var $jpagex$elm_material_color$MaterialColor$amber100 = A3($avh4$elm_color$Color$rgb255, 255, 236, 179);
var $jpagex$elm_material_color$MaterialColor$amber200 = A3($avh4$elm_color$Color$rgb255, 255, 224, 130);
var $jpagex$elm_material_color$MaterialColor$amber300 = A3($avh4$elm_color$Color$rgb255, 255, 213, 79);
var $jpagex$elm_material_color$MaterialColor$amber400 = A3($avh4$elm_color$Color$rgb255, 255, 202, 40);
var $jpagex$elm_material_color$MaterialColor$amber50 = A3($avh4$elm_color$Color$rgb255, 255, 248, 225);
var $jpagex$elm_material_color$MaterialColor$amber500 = A3($avh4$elm_color$Color$rgb255, 255, 193, 7);
var $jpagex$elm_material_color$MaterialColor$amber600 = A3($avh4$elm_color$Color$rgb255, 255, 179, 0);
var $jpagex$elm_material_color$MaterialColor$amber700 = A3($avh4$elm_color$Color$rgb255, 255, 160, 0);
var $jpagex$elm_material_color$MaterialColor$amber800 = A3($avh4$elm_color$Color$rgb255, 255, 143, 0);
var $jpagex$elm_material_color$MaterialColor$amber900 = A3($avh4$elm_color$Color$rgb255, 255, 111, 0);
var $jpagex$elm_material_color$MaterialColor$amberA100 = A3($avh4$elm_color$Color$rgb255, 255, 229, 127);
var $jpagex$elm_material_color$MaterialColor$amberA200 = A3($avh4$elm_color$Color$rgb255, 255, 215, 64);
var $jpagex$elm_material_color$MaterialColor$amberA400 = A3($avh4$elm_color$Color$rgb255, 255, 196, 0);
var $jpagex$elm_material_color$MaterialColor$amberA700 = A3($avh4$elm_color$Color$rgb255, 255, 171, 0);
var $author$project$Colors$amber = _List_fromArray(
	[$jpagex$elm_material_color$MaterialColor$amber50, $jpagex$elm_material_color$MaterialColor$amber100, $jpagex$elm_material_color$MaterialColor$amber200, $jpagex$elm_material_color$MaterialColor$amber300, $jpagex$elm_material_color$MaterialColor$amber400, $jpagex$elm_material_color$MaterialColor$amber500, $jpagex$elm_material_color$MaterialColor$amber600, $jpagex$elm_material_color$MaterialColor$amber700, $jpagex$elm_material_color$MaterialColor$amber800, $jpagex$elm_material_color$MaterialColor$amber900, $jpagex$elm_material_color$MaterialColor$amberA100, $jpagex$elm_material_color$MaterialColor$amberA200, $jpagex$elm_material_color$MaterialColor$amberA400, $jpagex$elm_material_color$MaterialColor$amberA700]);
var $author$project$Colors$blackWhite = _List_fromArray(
	[
		A3($avh4$elm_color$Color$rgb, 0, 0, 0),
		A3($avh4$elm_color$Color$rgb, 255, 255, 255)
	]);
var $jpagex$elm_material_color$MaterialColor$blue100 = A3($avh4$elm_color$Color$rgb255, 187, 222, 251);
var $jpagex$elm_material_color$MaterialColor$blue200 = A3($avh4$elm_color$Color$rgb255, 144, 202, 249);
var $jpagex$elm_material_color$MaterialColor$blue300 = A3($avh4$elm_color$Color$rgb255, 100, 181, 246);
var $jpagex$elm_material_color$MaterialColor$blue400 = A3($avh4$elm_color$Color$rgb255, 66, 165, 245);
var $jpagex$elm_material_color$MaterialColor$blue50 = A3($avh4$elm_color$Color$rgb255, 227, 242, 253);
var $jpagex$elm_material_color$MaterialColor$blue500 = A3($avh4$elm_color$Color$rgb255, 33, 150, 243);
var $jpagex$elm_material_color$MaterialColor$blue600 = A3($avh4$elm_color$Color$rgb255, 30, 136, 229);
var $jpagex$elm_material_color$MaterialColor$blue700 = A3($avh4$elm_color$Color$rgb255, 25, 118, 210);
var $jpagex$elm_material_color$MaterialColor$blue800 = A3($avh4$elm_color$Color$rgb255, 21, 101, 192);
var $jpagex$elm_material_color$MaterialColor$blue900 = A3($avh4$elm_color$Color$rgb255, 13, 71, 161);
var $jpagex$elm_material_color$MaterialColor$blueA100 = A3($avh4$elm_color$Color$rgb255, 130, 177, 255);
var $jpagex$elm_material_color$MaterialColor$blueA200 = A3($avh4$elm_color$Color$rgb255, 68, 138, 255);
var $jpagex$elm_material_color$MaterialColor$blueA400 = A3($avh4$elm_color$Color$rgb255, 41, 121, 255);
var $jpagex$elm_material_color$MaterialColor$blueA700 = A3($avh4$elm_color$Color$rgb255, 41, 98, 255);
var $author$project$Colors$blue = _List_fromArray(
	[$jpagex$elm_material_color$MaterialColor$blue50, $jpagex$elm_material_color$MaterialColor$blue100, $jpagex$elm_material_color$MaterialColor$blue200, $jpagex$elm_material_color$MaterialColor$blue300, $jpagex$elm_material_color$MaterialColor$blue400, $jpagex$elm_material_color$MaterialColor$blue500, $jpagex$elm_material_color$MaterialColor$blue600, $jpagex$elm_material_color$MaterialColor$blue700, $jpagex$elm_material_color$MaterialColor$blue800, $jpagex$elm_material_color$MaterialColor$blue900, $jpagex$elm_material_color$MaterialColor$blueA100, $jpagex$elm_material_color$MaterialColor$blueA200, $jpagex$elm_material_color$MaterialColor$blueA400, $jpagex$elm_material_color$MaterialColor$blueA700]);
var $jpagex$elm_material_color$MaterialColor$blueGrey100 = A3($avh4$elm_color$Color$rgb255, 207, 216, 220);
var $jpagex$elm_material_color$MaterialColor$blueGrey200 = A3($avh4$elm_color$Color$rgb255, 176, 190, 197);
var $jpagex$elm_material_color$MaterialColor$blueGrey300 = A3($avh4$elm_color$Color$rgb255, 144, 164, 174);
var $jpagex$elm_material_color$MaterialColor$blueGrey400 = A3($avh4$elm_color$Color$rgb255, 120, 144, 156);
var $jpagex$elm_material_color$MaterialColor$blueGrey50 = A3($avh4$elm_color$Color$rgb255, 236, 239, 241);
var $jpagex$elm_material_color$MaterialColor$blueGrey500 = A3($avh4$elm_color$Color$rgb255, 96, 125, 139);
var $jpagex$elm_material_color$MaterialColor$blueGrey600 = A3($avh4$elm_color$Color$rgb255, 84, 110, 122);
var $jpagex$elm_material_color$MaterialColor$blueGrey700 = A3($avh4$elm_color$Color$rgb255, 69, 90, 100);
var $jpagex$elm_material_color$MaterialColor$blueGrey800 = A3($avh4$elm_color$Color$rgb255, 55, 71, 79);
var $jpagex$elm_material_color$MaterialColor$blueGrey900 = A3($avh4$elm_color$Color$rgb255, 38, 50, 56);
var $author$project$Colors$blueGrey = _List_fromArray(
	[$jpagex$elm_material_color$MaterialColor$blueGrey50, $jpagex$elm_material_color$MaterialColor$blueGrey100, $jpagex$elm_material_color$MaterialColor$blueGrey200, $jpagex$elm_material_color$MaterialColor$blueGrey300, $jpagex$elm_material_color$MaterialColor$blueGrey400, $jpagex$elm_material_color$MaterialColor$blueGrey500, $jpagex$elm_material_color$MaterialColor$blueGrey600, $jpagex$elm_material_color$MaterialColor$blueGrey700, $jpagex$elm_material_color$MaterialColor$blueGrey800, $jpagex$elm_material_color$MaterialColor$blueGrey900]);
var $jpagex$elm_material_color$MaterialColor$brown100 = A3($avh4$elm_color$Color$rgb255, 215, 204, 200);
var $jpagex$elm_material_color$MaterialColor$brown200 = A3($avh4$elm_color$Color$rgb255, 188, 170, 164);
var $jpagex$elm_material_color$MaterialColor$brown300 = A3($avh4$elm_color$Color$rgb255, 161, 136, 127);
var $jpagex$elm_material_color$MaterialColor$brown400 = A3($avh4$elm_color$Color$rgb255, 141, 110, 99);
var $jpagex$elm_material_color$MaterialColor$brown50 = A3($avh4$elm_color$Color$rgb255, 239, 235, 233);
var $jpagex$elm_material_color$MaterialColor$brown500 = A3($avh4$elm_color$Color$rgb255, 121, 85, 72);
var $jpagex$elm_material_color$MaterialColor$brown600 = A3($avh4$elm_color$Color$rgb255, 109, 76, 65);
var $jpagex$elm_material_color$MaterialColor$brown700 = A3($avh4$elm_color$Color$rgb255, 93, 64, 55);
var $jpagex$elm_material_color$MaterialColor$brown800 = A3($avh4$elm_color$Color$rgb255, 78, 52, 46);
var $jpagex$elm_material_color$MaterialColor$brown900 = A3($avh4$elm_color$Color$rgb255, 62, 39, 35);
var $author$project$Colors$brown = _List_fromArray(
	[$jpagex$elm_material_color$MaterialColor$brown50, $jpagex$elm_material_color$MaterialColor$brown100, $jpagex$elm_material_color$MaterialColor$brown200, $jpagex$elm_material_color$MaterialColor$brown300, $jpagex$elm_material_color$MaterialColor$brown400, $jpagex$elm_material_color$MaterialColor$brown500, $jpagex$elm_material_color$MaterialColor$brown600, $jpagex$elm_material_color$MaterialColor$brown700, $jpagex$elm_material_color$MaterialColor$brown800, $jpagex$elm_material_color$MaterialColor$brown900]);
var $jpagex$elm_material_color$MaterialColor$cyan100 = A3($avh4$elm_color$Color$rgb255, 178, 235, 242);
var $jpagex$elm_material_color$MaterialColor$cyan200 = A3($avh4$elm_color$Color$rgb255, 128, 222, 234);
var $jpagex$elm_material_color$MaterialColor$cyan300 = A3($avh4$elm_color$Color$rgb255, 77, 208, 225);
var $jpagex$elm_material_color$MaterialColor$cyan400 = A3($avh4$elm_color$Color$rgb255, 38, 198, 218);
var $jpagex$elm_material_color$MaterialColor$cyan50 = A3($avh4$elm_color$Color$rgb255, 224, 247, 250);
var $jpagex$elm_material_color$MaterialColor$cyan500 = A3($avh4$elm_color$Color$rgb255, 0, 188, 212);
var $jpagex$elm_material_color$MaterialColor$cyan600 = A3($avh4$elm_color$Color$rgb255, 0, 172, 193);
var $jpagex$elm_material_color$MaterialColor$cyan700 = A3($avh4$elm_color$Color$rgb255, 0, 151, 167);
var $jpagex$elm_material_color$MaterialColor$cyan800 = A3($avh4$elm_color$Color$rgb255, 0, 131, 143);
var $jpagex$elm_material_color$MaterialColor$cyan900 = A3($avh4$elm_color$Color$rgb255, 0, 96, 100);
var $jpagex$elm_material_color$MaterialColor$cyanA100 = A3($avh4$elm_color$Color$rgb255, 132, 255, 255);
var $jpagex$elm_material_color$MaterialColor$cyanA200 = A3($avh4$elm_color$Color$rgb255, 24, 255, 255);
var $jpagex$elm_material_color$MaterialColor$cyanA400 = A3($avh4$elm_color$Color$rgb255, 0, 229, 255);
var $jpagex$elm_material_color$MaterialColor$cyanA700 = A3($avh4$elm_color$Color$rgb255, 0, 184, 212);
var $author$project$Colors$cyan = _List_fromArray(
	[$jpagex$elm_material_color$MaterialColor$cyan50, $jpagex$elm_material_color$MaterialColor$cyan100, $jpagex$elm_material_color$MaterialColor$cyan200, $jpagex$elm_material_color$MaterialColor$cyan300, $jpagex$elm_material_color$MaterialColor$cyan400, $jpagex$elm_material_color$MaterialColor$cyan500, $jpagex$elm_material_color$MaterialColor$cyan600, $jpagex$elm_material_color$MaterialColor$cyan700, $jpagex$elm_material_color$MaterialColor$cyan800, $jpagex$elm_material_color$MaterialColor$cyan900, $jpagex$elm_material_color$MaterialColor$cyanA100, $jpagex$elm_material_color$MaterialColor$cyanA200, $jpagex$elm_material_color$MaterialColor$cyanA400, $jpagex$elm_material_color$MaterialColor$cyanA700]);
var $jpagex$elm_material_color$MaterialColor$deepOrange100 = A3($avh4$elm_color$Color$rgb255, 255, 204, 188);
var $jpagex$elm_material_color$MaterialColor$deepOrange200 = A3($avh4$elm_color$Color$rgb255, 255, 171, 145);
var $jpagex$elm_material_color$MaterialColor$deepOrange300 = A3($avh4$elm_color$Color$rgb255, 255, 138, 101);
var $jpagex$elm_material_color$MaterialColor$deepOrange400 = A3($avh4$elm_color$Color$rgb255, 255, 112, 67);
var $jpagex$elm_material_color$MaterialColor$deepOrange50 = A3($avh4$elm_color$Color$rgb255, 251, 233, 231);
var $jpagex$elm_material_color$MaterialColor$deepOrange500 = A3($avh4$elm_color$Color$rgb255, 255, 87, 34);
var $jpagex$elm_material_color$MaterialColor$deepOrange600 = A3($avh4$elm_color$Color$rgb255, 244, 81, 30);
var $jpagex$elm_material_color$MaterialColor$deepOrange700 = A3($avh4$elm_color$Color$rgb255, 230, 74, 25);
var $jpagex$elm_material_color$MaterialColor$deepOrange800 = A3($avh4$elm_color$Color$rgb255, 216, 67, 21);
var $jpagex$elm_material_color$MaterialColor$deepOrange900 = A3($avh4$elm_color$Color$rgb255, 191, 54, 12);
var $jpagex$elm_material_color$MaterialColor$deepOrangeA100 = A3($avh4$elm_color$Color$rgb255, 255, 158, 128);
var $jpagex$elm_material_color$MaterialColor$deepOrangeA200 = A3($avh4$elm_color$Color$rgb255, 255, 110, 64);
var $jpagex$elm_material_color$MaterialColor$deepOrangeA400 = A3($avh4$elm_color$Color$rgb255, 255, 61, 0);
var $jpagex$elm_material_color$MaterialColor$deepOrangeA700 = A3($avh4$elm_color$Color$rgb255, 221, 44, 0);
var $author$project$Colors$deepOrange = _List_fromArray(
	[$jpagex$elm_material_color$MaterialColor$deepOrange50, $jpagex$elm_material_color$MaterialColor$deepOrange100, $jpagex$elm_material_color$MaterialColor$deepOrange200, $jpagex$elm_material_color$MaterialColor$deepOrange300, $jpagex$elm_material_color$MaterialColor$deepOrange400, $jpagex$elm_material_color$MaterialColor$deepOrange500, $jpagex$elm_material_color$MaterialColor$deepOrange600, $jpagex$elm_material_color$MaterialColor$deepOrange700, $jpagex$elm_material_color$MaterialColor$deepOrange800, $jpagex$elm_material_color$MaterialColor$deepOrange900, $jpagex$elm_material_color$MaterialColor$deepOrangeA100, $jpagex$elm_material_color$MaterialColor$deepOrangeA200, $jpagex$elm_material_color$MaterialColor$deepOrangeA400, $jpagex$elm_material_color$MaterialColor$deepOrangeA700]);
var $jpagex$elm_material_color$MaterialColor$deepPurple100 = A3($avh4$elm_color$Color$rgb255, 209, 196, 233);
var $jpagex$elm_material_color$MaterialColor$deepPurple200 = A3($avh4$elm_color$Color$rgb255, 179, 157, 219);
var $jpagex$elm_material_color$MaterialColor$deepPurple300 = A3($avh4$elm_color$Color$rgb255, 149, 117, 205);
var $jpagex$elm_material_color$MaterialColor$deepPurple400 = A3($avh4$elm_color$Color$rgb255, 126, 87, 194);
var $jpagex$elm_material_color$MaterialColor$deepPurple50 = A3($avh4$elm_color$Color$rgb255, 237, 231, 246);
var $jpagex$elm_material_color$MaterialColor$deepPurple500 = A3($avh4$elm_color$Color$rgb255, 103, 58, 183);
var $jpagex$elm_material_color$MaterialColor$deepPurple600 = A3($avh4$elm_color$Color$rgb255, 94, 53, 177);
var $jpagex$elm_material_color$MaterialColor$deepPurple700 = A3($avh4$elm_color$Color$rgb255, 81, 45, 168);
var $jpagex$elm_material_color$MaterialColor$deepPurple800 = A3($avh4$elm_color$Color$rgb255, 69, 39, 160);
var $jpagex$elm_material_color$MaterialColor$deepPurple900 = A3($avh4$elm_color$Color$rgb255, 49, 27, 146);
var $jpagex$elm_material_color$MaterialColor$deepPurpleA100 = A3($avh4$elm_color$Color$rgb255, 179, 136, 255);
var $jpagex$elm_material_color$MaterialColor$deepPurpleA200 = A3($avh4$elm_color$Color$rgb255, 124, 77, 255);
var $jpagex$elm_material_color$MaterialColor$deepPurpleA400 = A3($avh4$elm_color$Color$rgb255, 101, 31, 255);
var $jpagex$elm_material_color$MaterialColor$deepPurpleA700 = A3($avh4$elm_color$Color$rgb255, 98, 0, 234);
var $author$project$Colors$deepPurple = _List_fromArray(
	[$jpagex$elm_material_color$MaterialColor$deepPurple50, $jpagex$elm_material_color$MaterialColor$deepPurple100, $jpagex$elm_material_color$MaterialColor$deepPurple200, $jpagex$elm_material_color$MaterialColor$deepPurple300, $jpagex$elm_material_color$MaterialColor$deepPurple400, $jpagex$elm_material_color$MaterialColor$deepPurple500, $jpagex$elm_material_color$MaterialColor$deepPurple600, $jpagex$elm_material_color$MaterialColor$deepPurple700, $jpagex$elm_material_color$MaterialColor$deepPurple800, $jpagex$elm_material_color$MaterialColor$deepPurple900, $jpagex$elm_material_color$MaterialColor$deepPurpleA100, $jpagex$elm_material_color$MaterialColor$deepPurpleA200, $jpagex$elm_material_color$MaterialColor$deepPurpleA400, $jpagex$elm_material_color$MaterialColor$deepPurpleA700]);
var $jpagex$elm_material_color$MaterialColor$green100 = A3($avh4$elm_color$Color$rgb255, 200, 230, 201);
var $jpagex$elm_material_color$MaterialColor$green200 = A3($avh4$elm_color$Color$rgb255, 165, 214, 167);
var $jpagex$elm_material_color$MaterialColor$green300 = A3($avh4$elm_color$Color$rgb255, 129, 199, 132);
var $jpagex$elm_material_color$MaterialColor$green400 = A3($avh4$elm_color$Color$rgb255, 102, 187, 106);
var $jpagex$elm_material_color$MaterialColor$green50 = A3($avh4$elm_color$Color$rgb255, 232, 245, 233);
var $jpagex$elm_material_color$MaterialColor$green500 = A3($avh4$elm_color$Color$rgb255, 76, 175, 80);
var $jpagex$elm_material_color$MaterialColor$green600 = A3($avh4$elm_color$Color$rgb255, 67, 160, 71);
var $jpagex$elm_material_color$MaterialColor$green700 = A3($avh4$elm_color$Color$rgb255, 56, 142, 60);
var $jpagex$elm_material_color$MaterialColor$green800 = A3($avh4$elm_color$Color$rgb255, 46, 125, 50);
var $jpagex$elm_material_color$MaterialColor$green900 = A3($avh4$elm_color$Color$rgb255, 27, 94, 32);
var $jpagex$elm_material_color$MaterialColor$greenA100 = A3($avh4$elm_color$Color$rgb255, 185, 246, 202);
var $jpagex$elm_material_color$MaterialColor$greenA200 = A3($avh4$elm_color$Color$rgb255, 105, 240, 174);
var $jpagex$elm_material_color$MaterialColor$greenA400 = A3($avh4$elm_color$Color$rgb255, 0, 230, 118);
var $jpagex$elm_material_color$MaterialColor$greenA700 = A3($avh4$elm_color$Color$rgb255, 0, 200, 83);
var $author$project$Colors$green = _List_fromArray(
	[$jpagex$elm_material_color$MaterialColor$green50, $jpagex$elm_material_color$MaterialColor$green100, $jpagex$elm_material_color$MaterialColor$green200, $jpagex$elm_material_color$MaterialColor$green300, $jpagex$elm_material_color$MaterialColor$green400, $jpagex$elm_material_color$MaterialColor$green500, $jpagex$elm_material_color$MaterialColor$green600, $jpagex$elm_material_color$MaterialColor$green700, $jpagex$elm_material_color$MaterialColor$green800, $jpagex$elm_material_color$MaterialColor$green900, $jpagex$elm_material_color$MaterialColor$greenA100, $jpagex$elm_material_color$MaterialColor$greenA200, $jpagex$elm_material_color$MaterialColor$greenA400, $jpagex$elm_material_color$MaterialColor$greenA700]);
var $jpagex$elm_material_color$MaterialColor$grey100 = A3($avh4$elm_color$Color$rgb255, 245, 245, 245);
var $jpagex$elm_material_color$MaterialColor$grey200 = A3($avh4$elm_color$Color$rgb255, 238, 238, 238);
var $jpagex$elm_material_color$MaterialColor$grey300 = A3($avh4$elm_color$Color$rgb255, 224, 224, 224);
var $jpagex$elm_material_color$MaterialColor$grey400 = A3($avh4$elm_color$Color$rgb255, 189, 189, 189);
var $jpagex$elm_material_color$MaterialColor$grey50 = A3($avh4$elm_color$Color$rgb255, 250, 250, 250);
var $jpagex$elm_material_color$MaterialColor$grey500 = A3($avh4$elm_color$Color$rgb255, 158, 158, 158);
var $jpagex$elm_material_color$MaterialColor$grey600 = A3($avh4$elm_color$Color$rgb255, 117, 117, 117);
var $jpagex$elm_material_color$MaterialColor$grey700 = A3($avh4$elm_color$Color$rgb255, 97, 97, 97);
var $jpagex$elm_material_color$MaterialColor$grey800 = A3($avh4$elm_color$Color$rgb255, 66, 66, 66);
var $jpagex$elm_material_color$MaterialColor$grey900 = A3($avh4$elm_color$Color$rgb255, 33, 33, 33);
var $author$project$Colors$grey = _List_fromArray(
	[
		$jpagex$elm_material_color$MaterialColor$grey50,
		$jpagex$elm_material_color$MaterialColor$grey100,
		$jpagex$elm_material_color$MaterialColor$grey200,
		$jpagex$elm_material_color$MaterialColor$grey300,
		$jpagex$elm_material_color$MaterialColor$grey400,
		$jpagex$elm_material_color$MaterialColor$grey500,
		$jpagex$elm_material_color$MaterialColor$grey600,
		$jpagex$elm_material_color$MaterialColor$grey700,
		$jpagex$elm_material_color$MaterialColor$grey800,
		$jpagex$elm_material_color$MaterialColor$grey900,
		A4($avh4$elm_color$Color$rgba, 0, 0, 0, 0.7)
	]);
var $jpagex$elm_material_color$MaterialColor$indigo100 = A3($avh4$elm_color$Color$rgb255, 197, 202, 233);
var $jpagex$elm_material_color$MaterialColor$indigo200 = A3($avh4$elm_color$Color$rgb255, 159, 168, 218);
var $jpagex$elm_material_color$MaterialColor$indigo300 = A3($avh4$elm_color$Color$rgb255, 121, 134, 203);
var $jpagex$elm_material_color$MaterialColor$indigo400 = A3($avh4$elm_color$Color$rgb255, 92, 107, 192);
var $jpagex$elm_material_color$MaterialColor$indigo50 = A3($avh4$elm_color$Color$rgb255, 232, 234, 246);
var $jpagex$elm_material_color$MaterialColor$indigo500 = A3($avh4$elm_color$Color$rgb255, 63, 81, 181);
var $jpagex$elm_material_color$MaterialColor$indigo600 = A3($avh4$elm_color$Color$rgb255, 57, 73, 171);
var $jpagex$elm_material_color$MaterialColor$indigo700 = A3($avh4$elm_color$Color$rgb255, 48, 63, 159);
var $jpagex$elm_material_color$MaterialColor$indigo800 = A3($avh4$elm_color$Color$rgb255, 40, 53, 147);
var $jpagex$elm_material_color$MaterialColor$indigo900 = A3($avh4$elm_color$Color$rgb255, 26, 35, 126);
var $jpagex$elm_material_color$MaterialColor$indigoA100 = A3($avh4$elm_color$Color$rgb255, 140, 158, 255);
var $jpagex$elm_material_color$MaterialColor$indigoA200 = A3($avh4$elm_color$Color$rgb255, 83, 109, 254);
var $jpagex$elm_material_color$MaterialColor$indigoA400 = A3($avh4$elm_color$Color$rgb255, 61, 90, 254);
var $jpagex$elm_material_color$MaterialColor$indigoA700 = A3($avh4$elm_color$Color$rgb255, 48, 79, 254);
var $author$project$Colors$indigo = _List_fromArray(
	[$jpagex$elm_material_color$MaterialColor$indigo50, $jpagex$elm_material_color$MaterialColor$indigo100, $jpagex$elm_material_color$MaterialColor$indigo200, $jpagex$elm_material_color$MaterialColor$indigo300, $jpagex$elm_material_color$MaterialColor$indigo400, $jpagex$elm_material_color$MaterialColor$indigo500, $jpagex$elm_material_color$MaterialColor$indigo600, $jpagex$elm_material_color$MaterialColor$indigo700, $jpagex$elm_material_color$MaterialColor$indigo800, $jpagex$elm_material_color$MaterialColor$indigo900, $jpagex$elm_material_color$MaterialColor$indigoA100, $jpagex$elm_material_color$MaterialColor$indigoA200, $jpagex$elm_material_color$MaterialColor$indigoA400, $jpagex$elm_material_color$MaterialColor$indigoA700]);
var $jpagex$elm_material_color$MaterialColor$lightBlue100 = A3($avh4$elm_color$Color$rgb255, 179, 229, 252);
var $jpagex$elm_material_color$MaterialColor$lightBlue200 = A3($avh4$elm_color$Color$rgb255, 129, 212, 250);
var $jpagex$elm_material_color$MaterialColor$lightBlue300 = A3($avh4$elm_color$Color$rgb255, 79, 195, 247);
var $jpagex$elm_material_color$MaterialColor$lightBlue400 = A3($avh4$elm_color$Color$rgb255, 41, 182, 246);
var $jpagex$elm_material_color$MaterialColor$lightBlue50 = A3($avh4$elm_color$Color$rgb255, 225, 245, 254);
var $jpagex$elm_material_color$MaterialColor$lightBlue500 = A3($avh4$elm_color$Color$rgb255, 3, 169, 244);
var $jpagex$elm_material_color$MaterialColor$lightBlue600 = A3($avh4$elm_color$Color$rgb255, 3, 155, 229);
var $jpagex$elm_material_color$MaterialColor$lightBlue700 = A3($avh4$elm_color$Color$rgb255, 2, 136, 209);
var $jpagex$elm_material_color$MaterialColor$lightBlue800 = A3($avh4$elm_color$Color$rgb255, 2, 119, 189);
var $jpagex$elm_material_color$MaterialColor$lightBlue900 = A3($avh4$elm_color$Color$rgb255, 1, 87, 155);
var $jpagex$elm_material_color$MaterialColor$lightBlueA100 = A3($avh4$elm_color$Color$rgb255, 128, 216, 255);
var $jpagex$elm_material_color$MaterialColor$lightBlueA200 = A3($avh4$elm_color$Color$rgb255, 64, 196, 255);
var $jpagex$elm_material_color$MaterialColor$lightBlueA400 = A3($avh4$elm_color$Color$rgb255, 0, 176, 255);
var $jpagex$elm_material_color$MaterialColor$lightBlueA700 = A3($avh4$elm_color$Color$rgb255, 0, 145, 234);
var $author$project$Colors$lightBlue = _List_fromArray(
	[$jpagex$elm_material_color$MaterialColor$lightBlue50, $jpagex$elm_material_color$MaterialColor$lightBlue100, $jpagex$elm_material_color$MaterialColor$lightBlue200, $jpagex$elm_material_color$MaterialColor$lightBlue300, $jpagex$elm_material_color$MaterialColor$lightBlue400, $jpagex$elm_material_color$MaterialColor$lightBlue500, $jpagex$elm_material_color$MaterialColor$lightBlue600, $jpagex$elm_material_color$MaterialColor$lightBlue700, $jpagex$elm_material_color$MaterialColor$lightBlue800, $jpagex$elm_material_color$MaterialColor$lightBlue900, $jpagex$elm_material_color$MaterialColor$lightBlueA100, $jpagex$elm_material_color$MaterialColor$lightBlueA200, $jpagex$elm_material_color$MaterialColor$lightBlueA400, $jpagex$elm_material_color$MaterialColor$lightBlueA700]);
var $jpagex$elm_material_color$MaterialColor$lightGreen100 = A3($avh4$elm_color$Color$rgb255, 220, 237, 200);
var $jpagex$elm_material_color$MaterialColor$lightGreen200 = A3($avh4$elm_color$Color$rgb255, 197, 225, 165);
var $jpagex$elm_material_color$MaterialColor$lightGreen300 = A3($avh4$elm_color$Color$rgb255, 174, 213, 129);
var $jpagex$elm_material_color$MaterialColor$lightGreen400 = A3($avh4$elm_color$Color$rgb255, 156, 204, 101);
var $jpagex$elm_material_color$MaterialColor$lightGreen50 = A3($avh4$elm_color$Color$rgb255, 241, 248, 233);
var $jpagex$elm_material_color$MaterialColor$lightGreen500 = A3($avh4$elm_color$Color$rgb255, 139, 195, 74);
var $jpagex$elm_material_color$MaterialColor$lightGreen600 = A3($avh4$elm_color$Color$rgb255, 124, 179, 66);
var $jpagex$elm_material_color$MaterialColor$lightGreen700 = A3($avh4$elm_color$Color$rgb255, 104, 159, 56);
var $jpagex$elm_material_color$MaterialColor$lightGreen800 = A3($avh4$elm_color$Color$rgb255, 85, 139, 47);
var $jpagex$elm_material_color$MaterialColor$lightGreen900 = A3($avh4$elm_color$Color$rgb255, 51, 105, 30);
var $jpagex$elm_material_color$MaterialColor$lightGreenA100 = A3($avh4$elm_color$Color$rgb255, 204, 255, 144);
var $jpagex$elm_material_color$MaterialColor$lightGreenA200 = A3($avh4$elm_color$Color$rgb255, 178, 255, 89);
var $jpagex$elm_material_color$MaterialColor$lightGreenA400 = A3($avh4$elm_color$Color$rgb255, 118, 255, 3);
var $jpagex$elm_material_color$MaterialColor$lightGreenA700 = A3($avh4$elm_color$Color$rgb255, 100, 221, 23);
var $author$project$Colors$lightGreen = _List_fromArray(
	[$jpagex$elm_material_color$MaterialColor$lightGreen50, $jpagex$elm_material_color$MaterialColor$lightGreen100, $jpagex$elm_material_color$MaterialColor$lightGreen200, $jpagex$elm_material_color$MaterialColor$lightGreen300, $jpagex$elm_material_color$MaterialColor$lightGreen400, $jpagex$elm_material_color$MaterialColor$lightGreen500, $jpagex$elm_material_color$MaterialColor$lightGreen600, $jpagex$elm_material_color$MaterialColor$lightGreen700, $jpagex$elm_material_color$MaterialColor$lightGreen800, $jpagex$elm_material_color$MaterialColor$lightGreen900, $jpagex$elm_material_color$MaterialColor$lightGreenA100, $jpagex$elm_material_color$MaterialColor$lightGreenA200, $jpagex$elm_material_color$MaterialColor$lightGreenA400, $jpagex$elm_material_color$MaterialColor$lightGreenA700]);
var $jpagex$elm_material_color$MaterialColor$lime100 = A3($avh4$elm_color$Color$rgb255, 240, 244, 195);
var $jpagex$elm_material_color$MaterialColor$lime200 = A3($avh4$elm_color$Color$rgb255, 230, 238, 156);
var $jpagex$elm_material_color$MaterialColor$lime300 = A3($avh4$elm_color$Color$rgb255, 220, 231, 117);
var $jpagex$elm_material_color$MaterialColor$lime400 = A3($avh4$elm_color$Color$rgb255, 212, 225, 87);
var $jpagex$elm_material_color$MaterialColor$lime50 = A3($avh4$elm_color$Color$rgb255, 249, 251, 231);
var $jpagex$elm_material_color$MaterialColor$lime500 = A3($avh4$elm_color$Color$rgb255, 205, 220, 57);
var $jpagex$elm_material_color$MaterialColor$lime600 = A3($avh4$elm_color$Color$rgb255, 192, 202, 51);
var $jpagex$elm_material_color$MaterialColor$lime700 = A3($avh4$elm_color$Color$rgb255, 175, 180, 43);
var $jpagex$elm_material_color$MaterialColor$lime800 = A3($avh4$elm_color$Color$rgb255, 158, 157, 36);
var $jpagex$elm_material_color$MaterialColor$lime900 = A3($avh4$elm_color$Color$rgb255, 130, 119, 23);
var $jpagex$elm_material_color$MaterialColor$limeA100 = A3($avh4$elm_color$Color$rgb255, 244, 255, 129);
var $jpagex$elm_material_color$MaterialColor$limeA200 = A3($avh4$elm_color$Color$rgb255, 238, 255, 65);
var $jpagex$elm_material_color$MaterialColor$limeA400 = A3($avh4$elm_color$Color$rgb255, 198, 255, 0);
var $jpagex$elm_material_color$MaterialColor$limeA700 = A3($avh4$elm_color$Color$rgb255, 174, 234, 0);
var $author$project$Colors$lime = _List_fromArray(
	[$jpagex$elm_material_color$MaterialColor$lime50, $jpagex$elm_material_color$MaterialColor$lime100, $jpagex$elm_material_color$MaterialColor$lime200, $jpagex$elm_material_color$MaterialColor$lime300, $jpagex$elm_material_color$MaterialColor$lime400, $jpagex$elm_material_color$MaterialColor$lime500, $jpagex$elm_material_color$MaterialColor$lime600, $jpagex$elm_material_color$MaterialColor$lime700, $jpagex$elm_material_color$MaterialColor$lime800, $jpagex$elm_material_color$MaterialColor$lime900, $jpagex$elm_material_color$MaterialColor$limeA100, $jpagex$elm_material_color$MaterialColor$limeA200, $jpagex$elm_material_color$MaterialColor$limeA400, $jpagex$elm_material_color$MaterialColor$limeA700]);
var $jpagex$elm_material_color$MaterialColor$orange100 = A3($avh4$elm_color$Color$rgb255, 255, 224, 178);
var $jpagex$elm_material_color$MaterialColor$orange200 = A3($avh4$elm_color$Color$rgb255, 255, 204, 128);
var $jpagex$elm_material_color$MaterialColor$orange300 = A3($avh4$elm_color$Color$rgb255, 255, 183, 77);
var $jpagex$elm_material_color$MaterialColor$orange400 = A3($avh4$elm_color$Color$rgb255, 255, 167, 38);
var $jpagex$elm_material_color$MaterialColor$orange50 = A3($avh4$elm_color$Color$rgb255, 255, 243, 224);
var $jpagex$elm_material_color$MaterialColor$orange500 = A3($avh4$elm_color$Color$rgb255, 255, 152, 0);
var $jpagex$elm_material_color$MaterialColor$orange600 = A3($avh4$elm_color$Color$rgb255, 251, 140, 0);
var $jpagex$elm_material_color$MaterialColor$orange700 = A3($avh4$elm_color$Color$rgb255, 245, 124, 0);
var $jpagex$elm_material_color$MaterialColor$orange800 = A3($avh4$elm_color$Color$rgb255, 239, 108, 0);
var $jpagex$elm_material_color$MaterialColor$orange900 = A3($avh4$elm_color$Color$rgb255, 230, 81, 0);
var $jpagex$elm_material_color$MaterialColor$orangeA100 = A3($avh4$elm_color$Color$rgb255, 255, 209, 128);
var $jpagex$elm_material_color$MaterialColor$orangeA200 = A3($avh4$elm_color$Color$rgb255, 255, 171, 64);
var $jpagex$elm_material_color$MaterialColor$orangeA400 = A3($avh4$elm_color$Color$rgb255, 255, 145, 0);
var $jpagex$elm_material_color$MaterialColor$orangeA700 = A3($avh4$elm_color$Color$rgb255, 255, 109, 0);
var $author$project$Colors$orange = _List_fromArray(
	[$jpagex$elm_material_color$MaterialColor$orange50, $jpagex$elm_material_color$MaterialColor$orange100, $jpagex$elm_material_color$MaterialColor$orange200, $jpagex$elm_material_color$MaterialColor$orange300, $jpagex$elm_material_color$MaterialColor$orange400, $jpagex$elm_material_color$MaterialColor$orange500, $jpagex$elm_material_color$MaterialColor$orange600, $jpagex$elm_material_color$MaterialColor$orange700, $jpagex$elm_material_color$MaterialColor$orange800, $jpagex$elm_material_color$MaterialColor$orange900, $jpagex$elm_material_color$MaterialColor$orangeA100, $jpagex$elm_material_color$MaterialColor$orangeA200, $jpagex$elm_material_color$MaterialColor$orangeA400, $jpagex$elm_material_color$MaterialColor$orangeA700]);
var $jpagex$elm_material_color$MaterialColor$pink100 = A3($avh4$elm_color$Color$rgb255, 248, 187, 208);
var $jpagex$elm_material_color$MaterialColor$pink200 = A3($avh4$elm_color$Color$rgb255, 244, 143, 177);
var $jpagex$elm_material_color$MaterialColor$pink300 = A3($avh4$elm_color$Color$rgb255, 240, 98, 146);
var $jpagex$elm_material_color$MaterialColor$pink400 = A3($avh4$elm_color$Color$rgb255, 236, 64, 122);
var $jpagex$elm_material_color$MaterialColor$pink50 = A3($avh4$elm_color$Color$rgb255, 252, 228, 236);
var $jpagex$elm_material_color$MaterialColor$pink500 = A3($avh4$elm_color$Color$rgb255, 233, 30, 99);
var $jpagex$elm_material_color$MaterialColor$pink600 = A3($avh4$elm_color$Color$rgb255, 216, 27, 96);
var $jpagex$elm_material_color$MaterialColor$pink700 = A3($avh4$elm_color$Color$rgb255, 194, 24, 91);
var $jpagex$elm_material_color$MaterialColor$pink800 = A3($avh4$elm_color$Color$rgb255, 173, 20, 87);
var $jpagex$elm_material_color$MaterialColor$pink900 = A3($avh4$elm_color$Color$rgb255, 136, 14, 79);
var $jpagex$elm_material_color$MaterialColor$pinkA100 = A3($avh4$elm_color$Color$rgb255, 255, 128, 171);
var $jpagex$elm_material_color$MaterialColor$pinkA200 = A3($avh4$elm_color$Color$rgb255, 255, 64, 129);
var $jpagex$elm_material_color$MaterialColor$pinkA400 = A3($avh4$elm_color$Color$rgb255, 245, 0, 87);
var $jpagex$elm_material_color$MaterialColor$pinkA700 = A3($avh4$elm_color$Color$rgb255, 197, 17, 98);
var $author$project$Colors$pink = _List_fromArray(
	[$jpagex$elm_material_color$MaterialColor$pink50, $jpagex$elm_material_color$MaterialColor$pink100, $jpagex$elm_material_color$MaterialColor$pink200, $jpagex$elm_material_color$MaterialColor$pink300, $jpagex$elm_material_color$MaterialColor$pink400, $jpagex$elm_material_color$MaterialColor$pink500, $jpagex$elm_material_color$MaterialColor$pink600, $jpagex$elm_material_color$MaterialColor$pink700, $jpagex$elm_material_color$MaterialColor$pink800, $jpagex$elm_material_color$MaterialColor$pink900, $jpagex$elm_material_color$MaterialColor$pinkA100, $jpagex$elm_material_color$MaterialColor$pinkA200, $jpagex$elm_material_color$MaterialColor$pinkA400, $jpagex$elm_material_color$MaterialColor$pinkA700]);
var $jpagex$elm_material_color$MaterialColor$purple100 = A3($avh4$elm_color$Color$rgb255, 225, 190, 231);
var $jpagex$elm_material_color$MaterialColor$purple200 = A3($avh4$elm_color$Color$rgb255, 206, 147, 216);
var $jpagex$elm_material_color$MaterialColor$purple300 = A3($avh4$elm_color$Color$rgb255, 186, 104, 200);
var $jpagex$elm_material_color$MaterialColor$purple400 = A3($avh4$elm_color$Color$rgb255, 171, 71, 188);
var $jpagex$elm_material_color$MaterialColor$purple50 = A3($avh4$elm_color$Color$rgb255, 243, 229, 245);
var $jpagex$elm_material_color$MaterialColor$purple500 = A3($avh4$elm_color$Color$rgb255, 156, 39, 176);
var $jpagex$elm_material_color$MaterialColor$purple600 = A3($avh4$elm_color$Color$rgb255, 142, 36, 170);
var $jpagex$elm_material_color$MaterialColor$purple700 = A3($avh4$elm_color$Color$rgb255, 123, 31, 162);
var $jpagex$elm_material_color$MaterialColor$purple800 = A3($avh4$elm_color$Color$rgb255, 106, 27, 154);
var $jpagex$elm_material_color$MaterialColor$purple900 = A3($avh4$elm_color$Color$rgb255, 74, 20, 140);
var $jpagex$elm_material_color$MaterialColor$purpleA100 = A3($avh4$elm_color$Color$rgb255, 234, 128, 252);
var $jpagex$elm_material_color$MaterialColor$purpleA200 = A3($avh4$elm_color$Color$rgb255, 224, 64, 251);
var $jpagex$elm_material_color$MaterialColor$purpleA400 = A3($avh4$elm_color$Color$rgb255, 213, 0, 249);
var $jpagex$elm_material_color$MaterialColor$purpleA700 = A3($avh4$elm_color$Color$rgb255, 170, 0, 255);
var $author$project$Colors$purple = _List_fromArray(
	[$jpagex$elm_material_color$MaterialColor$purple50, $jpagex$elm_material_color$MaterialColor$purple100, $jpagex$elm_material_color$MaterialColor$purple200, $jpagex$elm_material_color$MaterialColor$purple300, $jpagex$elm_material_color$MaterialColor$purple400, $jpagex$elm_material_color$MaterialColor$purple500, $jpagex$elm_material_color$MaterialColor$purple600, $jpagex$elm_material_color$MaterialColor$purple700, $jpagex$elm_material_color$MaterialColor$purple800, $jpagex$elm_material_color$MaterialColor$purple900, $jpagex$elm_material_color$MaterialColor$purpleA100, $jpagex$elm_material_color$MaterialColor$purpleA200, $jpagex$elm_material_color$MaterialColor$purpleA400, $jpagex$elm_material_color$MaterialColor$purpleA700]);
var $jpagex$elm_material_color$MaterialColor$red100 = A3($avh4$elm_color$Color$rgb255, 255, 205, 210);
var $jpagex$elm_material_color$MaterialColor$red200 = A3($avh4$elm_color$Color$rgb255, 239, 154, 154);
var $jpagex$elm_material_color$MaterialColor$red300 = A3($avh4$elm_color$Color$rgb255, 229, 115, 115);
var $jpagex$elm_material_color$MaterialColor$red400 = A3($avh4$elm_color$Color$rgb255, 239, 83, 80);
var $jpagex$elm_material_color$MaterialColor$red50 = A3($avh4$elm_color$Color$rgb255, 255, 235, 238);
var $jpagex$elm_material_color$MaterialColor$red500 = A3($avh4$elm_color$Color$rgb255, 244, 67, 54);
var $jpagex$elm_material_color$MaterialColor$red600 = A3($avh4$elm_color$Color$rgb255, 229, 57, 53);
var $jpagex$elm_material_color$MaterialColor$red700 = A3($avh4$elm_color$Color$rgb255, 211, 47, 47);
var $jpagex$elm_material_color$MaterialColor$red800 = A3($avh4$elm_color$Color$rgb255, 198, 40, 40);
var $jpagex$elm_material_color$MaterialColor$red900 = A3($avh4$elm_color$Color$rgb255, 183, 28, 28);
var $jpagex$elm_material_color$MaterialColor$redA100 = A3($avh4$elm_color$Color$rgb255, 255, 138, 128);
var $jpagex$elm_material_color$MaterialColor$redA200 = A3($avh4$elm_color$Color$rgb255, 255, 82, 82);
var $jpagex$elm_material_color$MaterialColor$redA400 = A3($avh4$elm_color$Color$rgb255, 255, 23, 68);
var $jpagex$elm_material_color$MaterialColor$redA700 = A3($avh4$elm_color$Color$rgb255, 213, 0, 0);
var $author$project$Colors$red = _List_fromArray(
	[$jpagex$elm_material_color$MaterialColor$red50, $jpagex$elm_material_color$MaterialColor$red100, $jpagex$elm_material_color$MaterialColor$red200, $jpagex$elm_material_color$MaterialColor$red300, $jpagex$elm_material_color$MaterialColor$red400, $jpagex$elm_material_color$MaterialColor$red500, $jpagex$elm_material_color$MaterialColor$red600, $jpagex$elm_material_color$MaterialColor$red700, $jpagex$elm_material_color$MaterialColor$red800, $jpagex$elm_material_color$MaterialColor$red900, $jpagex$elm_material_color$MaterialColor$redA100, $jpagex$elm_material_color$MaterialColor$redA200, $jpagex$elm_material_color$MaterialColor$redA400, $jpagex$elm_material_color$MaterialColor$redA700]);
var $jpagex$elm_material_color$MaterialColor$teal100 = A3($avh4$elm_color$Color$rgb255, 178, 223, 219);
var $jpagex$elm_material_color$MaterialColor$teal200 = A3($avh4$elm_color$Color$rgb255, 128, 203, 196);
var $jpagex$elm_material_color$MaterialColor$teal300 = A3($avh4$elm_color$Color$rgb255, 77, 182, 172);
var $jpagex$elm_material_color$MaterialColor$teal400 = A3($avh4$elm_color$Color$rgb255, 38, 166, 154);
var $jpagex$elm_material_color$MaterialColor$teal50 = A3($avh4$elm_color$Color$rgb255, 224, 242, 241);
var $jpagex$elm_material_color$MaterialColor$teal500 = A3($avh4$elm_color$Color$rgb255, 0, 150, 136);
var $jpagex$elm_material_color$MaterialColor$teal600 = A3($avh4$elm_color$Color$rgb255, 0, 137, 123);
var $jpagex$elm_material_color$MaterialColor$teal700 = A3($avh4$elm_color$Color$rgb255, 0, 121, 107);
var $jpagex$elm_material_color$MaterialColor$teal800 = A3($avh4$elm_color$Color$rgb255, 0, 105, 92);
var $jpagex$elm_material_color$MaterialColor$teal900 = A3($avh4$elm_color$Color$rgb255, 0, 77, 64);
var $jpagex$elm_material_color$MaterialColor$tealA100 = A3($avh4$elm_color$Color$rgb255, 167, 255, 235);
var $jpagex$elm_material_color$MaterialColor$tealA200 = A3($avh4$elm_color$Color$rgb255, 100, 255, 218);
var $jpagex$elm_material_color$MaterialColor$tealA400 = A3($avh4$elm_color$Color$rgb255, 29, 233, 182);
var $jpagex$elm_material_color$MaterialColor$tealA700 = A3($avh4$elm_color$Color$rgb255, 0, 191, 165);
var $author$project$Colors$teal = _List_fromArray(
	[$jpagex$elm_material_color$MaterialColor$teal50, $jpagex$elm_material_color$MaterialColor$teal100, $jpagex$elm_material_color$MaterialColor$teal200, $jpagex$elm_material_color$MaterialColor$teal300, $jpagex$elm_material_color$MaterialColor$teal400, $jpagex$elm_material_color$MaterialColor$teal500, $jpagex$elm_material_color$MaterialColor$teal600, $jpagex$elm_material_color$MaterialColor$teal700, $jpagex$elm_material_color$MaterialColor$teal800, $jpagex$elm_material_color$MaterialColor$teal900, $jpagex$elm_material_color$MaterialColor$tealA100, $jpagex$elm_material_color$MaterialColor$tealA200, $jpagex$elm_material_color$MaterialColor$tealA400, $jpagex$elm_material_color$MaterialColor$tealA700]);
var $jpagex$elm_material_color$MaterialColor$yellow100 = A3($avh4$elm_color$Color$rgb255, 255, 249, 196);
var $jpagex$elm_material_color$MaterialColor$yellow200 = A3($avh4$elm_color$Color$rgb255, 255, 245, 157);
var $jpagex$elm_material_color$MaterialColor$yellow300 = A3($avh4$elm_color$Color$rgb255, 255, 241, 118);
var $jpagex$elm_material_color$MaterialColor$yellow400 = A3($avh4$elm_color$Color$rgb255, 255, 238, 88);
var $jpagex$elm_material_color$MaterialColor$yellow50 = A3($avh4$elm_color$Color$rgb255, 255, 253, 231);
var $jpagex$elm_material_color$MaterialColor$yellow500 = A3($avh4$elm_color$Color$rgb255, 255, 235, 59);
var $jpagex$elm_material_color$MaterialColor$yellow600 = A3($avh4$elm_color$Color$rgb255, 253, 216, 53);
var $jpagex$elm_material_color$MaterialColor$yellow700 = A3($avh4$elm_color$Color$rgb255, 251, 192, 45);
var $jpagex$elm_material_color$MaterialColor$yellow800 = A3($avh4$elm_color$Color$rgb255, 249, 168, 37);
var $jpagex$elm_material_color$MaterialColor$yellow900 = A3($avh4$elm_color$Color$rgb255, 245, 127, 23);
var $jpagex$elm_material_color$MaterialColor$yellowA100 = A3($avh4$elm_color$Color$rgb255, 255, 255, 141);
var $jpagex$elm_material_color$MaterialColor$yellowA200 = A3($avh4$elm_color$Color$rgb255, 255, 255, 0);
var $jpagex$elm_material_color$MaterialColor$yellowA400 = A3($avh4$elm_color$Color$rgb255, 255, 234, 0);
var $jpagex$elm_material_color$MaterialColor$yellowA700 = A3($avh4$elm_color$Color$rgb255, 255, 214, 0);
var $author$project$Colors$yellow = _List_fromArray(
	[$jpagex$elm_material_color$MaterialColor$yellow50, $jpagex$elm_material_color$MaterialColor$yellow100, $jpagex$elm_material_color$MaterialColor$yellow200, $jpagex$elm_material_color$MaterialColor$yellow300, $jpagex$elm_material_color$MaterialColor$yellow400, $jpagex$elm_material_color$MaterialColor$yellow500, $jpagex$elm_material_color$MaterialColor$yellow600, $jpagex$elm_material_color$MaterialColor$yellow700, $jpagex$elm_material_color$MaterialColor$yellow800, $jpagex$elm_material_color$MaterialColor$yellow900, $jpagex$elm_material_color$MaterialColor$yellowA100, $jpagex$elm_material_color$MaterialColor$yellowA200, $jpagex$elm_material_color$MaterialColor$yellowA400, $jpagex$elm_material_color$MaterialColor$yellowA700]);
var $author$project$Colors$colors = _List_fromArray(
	[
		_Utils_Tuple2('Black & White', $author$project$Colors$blackWhite),
		_Utils_Tuple2('Red', $author$project$Colors$red),
		_Utils_Tuple2('Pink', $author$project$Colors$pink),
		_Utils_Tuple2('Purple', $author$project$Colors$purple),
		_Utils_Tuple2('Deep Purple', $author$project$Colors$deepPurple),
		_Utils_Tuple2('Indigo', $author$project$Colors$indigo),
		_Utils_Tuple2('Blue', $author$project$Colors$blue),
		_Utils_Tuple2('Light Blue', $author$project$Colors$lightBlue),
		_Utils_Tuple2('Cyan', $author$project$Colors$cyan),
		_Utils_Tuple2('Teal', $author$project$Colors$teal),
		_Utils_Tuple2('Green', $author$project$Colors$green),
		_Utils_Tuple2('Light Green', $author$project$Colors$lightGreen),
		_Utils_Tuple2('Lime', $author$project$Colors$lime),
		_Utils_Tuple2('Yellow', $author$project$Colors$yellow),
		_Utils_Tuple2('Amber', $author$project$Colors$amber),
		_Utils_Tuple2('Orange', $author$project$Colors$orange),
		_Utils_Tuple2('Deep Orange', $author$project$Colors$deepOrange),
		_Utils_Tuple2('Brown', $author$project$Colors$brown),
		_Utils_Tuple2('Grey', $author$project$Colors$grey),
		_Utils_Tuple2('Blue Grey', $author$project$Colors$blueGrey)
	]);
var $rtfeldman$elm_css$Css$flexEnd = $rtfeldman$elm_css$Css$prop1('flex-end');
var $author$project$Gradients$gradientToCss = function (gcolor) {
	var cssColors = A2($elm$core$List$map, $noahzgordon$elm_color_extra$Color$Convert$colorToCssRgb, gcolor.t);
	return 'radial-gradient' + ('(' + (A2($elm$core$String$join, ',', cssColors) + ')'));
};
var $author$project$Gradients$gradients = _List_fromArray(
	[
		{
		t: _List_fromArray(
			[
				A3($avh4$elm_color$Color$rgb, 211, 47, 47),
				A3($avh4$elm_color$Color$rgb, 198, 40, 40),
				A3($avh4$elm_color$Color$rgb, 183, 28, 28)
			]),
		g8: 'Gradient Red'
	},
		{
		t: _List_fromArray(
			[
				A3($avh4$elm_color$Color$rgb, 194, 24, 91),
				A3($avh4$elm_color$Color$rgb, 173, 20, 87),
				A3($avh4$elm_color$Color$rgb, 136, 14, 79)
			]),
		g8: 'Gradient Dark Red'
	},
		{
		t: _List_fromArray(
			[
				A3($avh4$elm_color$Color$rgb, 124, 77, 255),
				A3($avh4$elm_color$Color$rgb, 101, 31, 255),
				A3($avh4$elm_color$Color$rgb, 98, 0, 234)
			]),
		g8: 'Gradient Violet'
	},
		{
		t: _List_fromArray(
			[
				A3($avh4$elm_color$Color$rgb, 81, 45, 168),
				A3($avh4$elm_color$Color$rgb, 69, 39, 160),
				A3($avh4$elm_color$Color$rgb, 49, 27, 146)
			]),
		g8: 'Gradient Dark Violet'
	},
		{
		t: _List_fromArray(
			[
				A3($avh4$elm_color$Color$rgb, 83, 109, 254),
				A3($avh4$elm_color$Color$rgb, 61, 90, 254),
				A3($avh4$elm_color$Color$rgb, 48, 79, 254)
			]),
		g8: 'Gradient Blue'
	},
		{
		t: _List_fromArray(
			[
				A3($avh4$elm_color$Color$rgb, 48, 63, 159),
				A3($avh4$elm_color$Color$rgb, 40, 53, 147),
				A3($avh4$elm_color$Color$rgb, 26, 35, 126)
			]),
		g8: 'Gradient Dark Blue'
	},
		{
		t: _List_fromArray(
			[
				A3($avh4$elm_color$Color$rgb, 25, 118, 210),
				A3($avh4$elm_color$Color$rgb, 21, 101, 192),
				A3($avh4$elm_color$Color$rgb, 13, 71, 161)
			]),
		g8: 'Gradient Cyan'
	},
		{
		t: _List_fromArray(
			[
				A3($avh4$elm_color$Color$rgb, 24, 255, 255),
				A3($avh4$elm_color$Color$rgb, 0, 229, 255),
				A3($avh4$elm_color$Color$rgb, 0, 184, 212)
			]),
		g8: 'Gradient Light Blue'
	},
		{
		t: _List_fromArray(
			[
				A3($avh4$elm_color$Color$rgb, 0, 151, 167),
				A3($avh4$elm_color$Color$rgb, 0, 131, 143),
				A3($avh4$elm_color$Color$rgb, 0, 96, 100)
			]),
		g8: 'Gradient Teal'
	},
		{
		t: _List_fromArray(
			[
				A3($avh4$elm_color$Color$rgb, 100, 255, 218),
				A3($avh4$elm_color$Color$rgb, 29, 233, 182),
				A3($avh4$elm_color$Color$rgb, 0, 191, 165)
			]),
		g8: 'Gradient Light Teal'
	},
		{
		t: _List_fromArray(
			[
				A3($avh4$elm_color$Color$rgb, 0, 121, 107),
				A3($avh4$elm_color$Color$rgb, 0, 105, 92),
				A3($avh4$elm_color$Color$rgb, 0, 77, 64)
			]),
		g8: 'Gradient Dark Green'
	},
		{
		t: _List_fromArray(
			[
				A3($avh4$elm_color$Color$rgb, 255, 215, 64),
				A3($avh4$elm_color$Color$rgb, 255, 196, 0),
				A3($avh4$elm_color$Color$rgb, 255, 171, 0)
			]),
		g8: 'Gradient Dark Yellow'
	},
		{
		t: _List_fromArray(
			[
				A3($avh4$elm_color$Color$rgb, 255, 255, 0),
				A3($avh4$elm_color$Color$rgb, 255, 234, 0),
				A3($avh4$elm_color$Color$rgb, 255, 214, 0)
			]),
		g8: 'Gradient Light Yellow'
	},
		{
		t: _List_fromArray(
			[
				A3($avh4$elm_color$Color$rgb, 93, 64, 55),
				A3($avh4$elm_color$Color$rgb, 78, 52, 46),
				A3($avh4$elm_color$Color$rgb, 62, 39, 35)
			]),
		g8: 'Gradient Dark Brown'
	},
		{
		t: _List_fromArray(
			[
				A3($avh4$elm_color$Color$rgb, 255, 110, 64),
				A3($avh4$elm_color$Color$rgb, 255, 61, 0),
				A3($avh4$elm_color$Color$rgb, 221, 44, 0)
			]),
		g8: 'Gradient Orange'
	},
		{
		t: _List_fromArray(
			[
				A3($avh4$elm_color$Color$rgb, 97, 97, 97),
				A3($avh4$elm_color$Color$rgb, 66, 66, 66),
				A3($avh4$elm_color$Color$rgb, 33, 33, 33)
			]),
		g8: 'Gradient Black'
	},
		{
		t: _List_fromArray(
			[
				A3($avh4$elm_color$Color$rgb, 64, 196, 255),
				A3($avh4$elm_color$Color$rgb, 0, 176, 255),
				A3($avh4$elm_color$Color$rgb, 0, 145, 234)
			]),
		g8: 'Gradient Light Blue'
	},
		{
		t: _List_fromArray(
			[
				A3($avh4$elm_color$Color$rgb, 123, 31, 162),
				A3($avh4$elm_color$Color$rgb, 106, 27, 154),
				A3($avh4$elm_color$Color$rgb, 74, 20, 140)
			]),
		g8: 'Gradient Dark Violet'
	},
		{
		t: _List_fromArray(
			[
				A3($avh4$elm_color$Color$rgb, 224, 64, 251),
				A3($avh4$elm_color$Color$rgb, 213, 0, 249),
				A3($avh4$elm_color$Color$rgb, 170, 0, 255)
			]),
		g8: 'Gradient Pink'
	},
		{
		t: _List_fromArray(
			[
				A3($avh4$elm_color$Color$rgb, 250, 250, 250),
				A3($avh4$elm_color$Color$rgb, 245, 245, 245),
				A3($avh4$elm_color$Color$rgb, 238, 238, 238)
			]),
		g8: 'Gradient White'
	},
		{
		t: _List_fromArray(
			[
				A3($avh4$elm_color$Color$rgb, 56, 142, 60),
				A3($avh4$elm_color$Color$rgb, 46, 125, 50),
				A3($avh4$elm_color$Color$rgb, 27, 94, 32)
			]),
		g8: 'Gradient Green'
	}
	]);
var $rtfeldman$elm_css$Css$bold = {bp: 0, eL: 'bold'};
var $rtfeldman$elm_css$Css$border3 = $rtfeldman$elm_css$Css$prop3('border');
var $rtfeldman$elm_css$Css$inset = {aa: 0, eL: 'inset'};
var $author$project$ColorPicker$transparentStyle = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$dashed,
			$rtfeldman$elm_css$Css$hex('#FF0000'))
		]));
var $author$project$ColorPicker$viewColor = F2(
	function (config, color) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$px(24)),
							$rtfeldman$elm_css$Css$height(
							$rtfeldman$elm_css$Css$px(24)),
							A4(
							$rtfeldman$elm_css$Css$margin4,
							$rtfeldman$elm_css$Css$px(0),
							$rtfeldman$elm_css$Css$px(2),
							$rtfeldman$elm_css$Css$px(2),
							$rtfeldman$elm_css$Css$px(2)),
							$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
							A2($rtfeldman$elm_css$Css$property, 'background', color)
						])),
					(color === 'transparent') ? $rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$author$project$ColorPicker$transparentStyle])) : $rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A3(
							$rtfeldman$elm_css$Css$border3,
							$rtfeldman$elm_css$Css$px(1),
							$rtfeldman$elm_css$Css$inset,
							A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 1))
						])),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					config.fx(color)),
					$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(0)
				]),
			_List_Nil);
	});
var $author$project$ColorPicker$viewColors = F2(
	function (config, _v0) {
		var labelName = _v0.a;
		var listColor = _v0.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(labelName)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
									$rtfeldman$elm_css$Css$marginTop(
									$rtfeldman$elm_css$Css$px(6)),
									$rtfeldman$elm_css$Css$marginBottom(
									$rtfeldman$elm_css$Css$px(16))
								]))
						]),
					A2(
						$elm$core$List$map,
						$author$project$ColorPicker$viewColor(config),
						listColor))
				]));
	});
var $author$project$ColorPicker$viewColorSelector = function (config) {
	var _v0 = config.ef;
	if (!_v0) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('mdl-shadow--8dp'),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$zIndex(
							$rtfeldman$elm_css$Css$int(3)),
							$rtfeldman$elm_css$Css$backgroundColor(
							$rtfeldman$elm_css$Css$hex('#FAFAFA')),
							$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
							$rtfeldman$elm_css$Css$bottom(
							$rtfeldman$elm_css$Css$pct(0)),
							$rtfeldman$elm_css$Css$left(
							$rtfeldman$elm_css$Css$px(10)),
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$px(200)),
							$rtfeldman$elm_css$Css$height(
							$rtfeldman$elm_css$Css$px(200)),
							$rtfeldman$elm_css$Css$padding(
							$rtfeldman$elm_css$Css$px(16)),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$auto)
						])),
					function () {
					var _v1 = config.c9;
					if (_v1.$ === 1) {
						return $rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$marginLeft(
									$rtfeldman$elm_css$Css$px(-200))
								]));
					} else {
						return $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil);
					}
				}()
				]),
			_Utils_ap(
				_List_fromArray(
					[
						config.e8 ? A2(
						$author$project$ColorPicker$viewColors,
						config,
						function (grads) {
							return _Utils_Tuple2('Gradients', grads);
						}(
							A2($elm$core$List$map, $author$project$Gradients$gradientToCss, $author$project$Gradients$gradients))) : $rtfeldman$elm_css$Html$Styled$text('')
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$author$project$ColorPicker$viewColors,
							config,
							_Utils_Tuple2(
								'Transparent',
								_List_fromArray(
									['transparent']))),
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('mdl-button mdl-button--colored'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$flexEnd)
										])),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									config.cz(
										$author$project$ColorPicker$ClosePicker(config.cB)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Close')
								]))
						]),
					A2(
						$elm$core$List$map,
						$author$project$ColorPicker$viewColors(config),
						A2(
							$elm$core$List$map,
							config.fb ? $elm$core$Tuple$mapSecond(
								$elm$core$List$map($noahzgordon$elm_color_extra$Color$Convert$colorToHex)) : $elm$core$Tuple$mapSecond(
								$elm$core$List$map($noahzgordon$elm_color_extra$Color$Convert$colorToCssRgb)),
							$author$project$Colors$colors)))));
	} else {
		return A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
	}
};
var $author$project$ColorPicker$OpenPicker = function (a) {
	return {$: 1, a: a};
};
var $author$project$ColorPicker$viewColorValue = function (config) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$button,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$px(25)),
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$px(25)),
						A2($rtfeldman$elm_css$Css$property, 'background', config.dR),
						$rtfeldman$elm_css$Css$zIndex(
						$rtfeldman$elm_css$Css$int(1))
					])),
				config.d$ ? $rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$opacity(
						$rtfeldman$elm_css$Css$num(0.42)),
						A3(
						$rtfeldman$elm_css$Css$border3,
						$rtfeldman$elm_css$Css$px(1),
						$rtfeldman$elm_css$Css$dashed,
						A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.42)),
						$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$notAllowed)
					])) : ((config.dR === 'transparent') ? $rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$author$project$ColorPicker$transparentStyle,
						$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
					])) : $rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						A3(
						$rtfeldman$elm_css$Css$border3,
						$rtfeldman$elm_css$Css$px(1),
						$rtfeldman$elm_css$Css$solid,
						A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 1))
					]))),
				$rtfeldman$elm_css$Html$Styled$Events$onClick(
				config.cz(
					$author$project$ColorPicker$OpenPicker(config.cB)))
			]),
		_List_Nil);
};
var $author$project$ColorPicker$viewLabel = function (config) {
	var msg = function () {
		var _v0 = config.ef;
		if (_v0 === 1) {
			return config.cz(
				$author$project$ColorPicker$OpenPicker(config.cB));
		} else {
			return config.cz(
				$author$project$ColorPicker$ClosePicker(config.cB));
		}
	}();
	return A2(
		$rtfeldman$elm_css$Html$Styled$button,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
						$rtfeldman$elm_css$Css$fontFamilies(
						_List_fromArray(
							['Roboto'])),
						$rtfeldman$elm_css$Css$fontSize(
						$rtfeldman$elm_css$Css$px(14)),
						$rtfeldman$elm_css$Css$color(
						A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.87)),
						$rtfeldman$elm_css$Css$lineHeight(
						$rtfeldman$elm_css$Css$px(20)),
						$rtfeldman$elm_css$Css$paddingRight(
						$rtfeldman$elm_css$Css$px(16)),
						$rtfeldman$elm_css$Css$paddingLeft(
						$rtfeldman$elm_css$Css$px(0)),
						$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
					])),
				config.d$ ? $rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$notAllowed),
						$rtfeldman$elm_css$Css$color(
						A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.42))
					])) : $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil),
				$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				A2($elm$core$Maybe$withDefault, '', config.c9))
			]));
};
var $author$project$ColorPicker$viewValueContainer = function (config) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(100)),
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$px(25)),
						$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$fontFamilies(
						_List_fromArray(
							['Roboto']))
					]))
			]),
		_List_fromArray(
			[
				$author$project$ColorPicker$viewLabel(config),
				$author$project$ColorPicker$viewColorValue(config)
			]));
};
var $author$project$ColorPicker$view = F4(
	function (toMsg, uniqueId, model, attrs) {
		var config = A2(
			$author$project$ColorPicker$props,
			attrs,
			A3(
				$author$project$ColorPicker$defaultConfig,
				uniqueId,
				toMsg,
				A2(
					$elm$core$Maybe$withDefault,
					1,
					A2($elm$core$Dict$get, uniqueId, model))));
		return $rtfeldman$elm_css$Html$Styled$toUnstyled(
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
							]))
					]),
				_List_fromArray(
					[
						function () {
						var _v0 = config.c9;
						if (!_v0.$) {
							return $author$project$ColorPicker$viewValueContainer(config);
						} else {
							return $author$project$ColorPicker$viewColorValue(config);
						}
					}(),
						$author$project$ColorPicker$viewColorSelector(config),
						$author$project$ColorPicker$viewCancelOverlay(config)
					])));
	});
var $author$project$Pages$CfgDevice$Settings$viewFontColorPicker = F2(
	function (model, theme) {
		return A4(
			$author$project$ColorPicker$view,
			$author$project$Pages$CfgDevice$Settings$ColorPicker,
			_List_fromArray(
				[1, 23, 45]),
			model.aA,
			_List_fromArray(
				[
					$author$project$ColorPicker$label('Font Color'),
					$author$project$ColorPicker$value(theme.gx),
					$author$project$ColorPicker$onChange(
					function (val) {
						return $author$project$Pages$CfgDevice$Settings$UpdateTheme(
							_Utils_update(
								theme,
								{gx: val}));
					})
				]));
	});
var $author$project$Entity$Font$applyStyle = function (a) {
	return _List_fromArray(
		[
			_Utils_Tuple2('font-family', a),
			_Utils_Tuple2('font-size', '20px')
		]);
};
var $author$project$Select$ApplyStyle = function (a) {
	return {$: 8, a: a};
};
var $author$project$Select$applyStyle = function (func) {
	return $author$project$Select$ApplyStyle(func);
};
var $author$project$Pages$CfgDevice$Settings$viewFontFamilySelector = F2(
	function (model, theme) {
		return A5(
			$author$project$Select$view,
			$author$project$Pages$CfgDevice$Settings$SelectMsg,
			_List_fromArray(
				[1, 23, 45]),
			model.r,
			$author$project$Select$string,
			_List_fromArray(
				[
					$author$project$Select$label('Font Family'),
					$author$project$Select$searchable,
					$author$project$Select$applyStyle($author$project$Entity$Font$applyStyle),
					$author$project$Select$value(
					$elm$core$Maybe$Just(theme.gy)),
					$author$project$Select$options($author$project$Entity$Font$availableFonts),
					$author$project$Select$onSelect(
					function (val) {
						return $author$project$Pages$CfgDevice$Settings$UpdateTheme(
							_Utils_update(
								theme,
								{gy: val}));
					})
				]));
	});
var $author$project$Pages$CfgDevice$Settings$viewFontSizeSelector = F2(
	function (model, theme) {
		return A2(
			$author$project$Reusable$Slider$view,
			function (val) {
				return $author$project$Pages$CfgDevice$Settings$UpdateTheme(
					_Utils_update(
						theme,
						{gz: val}));
			},
			_List_fromArray(
				[
					$author$project$Reusable$Slider$label('Font Size'),
					$author$project$Reusable$Slider$style(
					_List_fromArray(
						[
							_Utils_Tuple2('width', '100%'),
							_Utils_Tuple2('margin-bottom', '16px')
						])),
					$author$project$Reusable$Slider$min(38),
					$author$project$Reusable$Slider$max(52),
					$author$project$Reusable$Slider$value(theme.gz)
				]));
	});
var $author$project$Reusable$Slider$Disabled = function (a) {
	return {$: 4, a: a};
};
var $author$project$Reusable$Slider$disabled = function (val) {
	return $author$project$Reusable$Slider$Disabled(val);
};
var $author$project$Pages$CfgDevice$Settings$viewLogoHeightSelector = F2(
	function (model, theme) {
		return A2(
			$author$project$Reusable$Slider$view,
			function (val) {
				return $author$project$Pages$CfgDevice$Settings$UpdateTheme(
					_Utils_update(
						theme,
						{gH: val}));
			},
			_List_fromArray(
				[
					$author$project$Reusable$Slider$label(
					'Logo Height ' + ('( ' + ($elm$core$String$fromFloat(theme.gH) + 'px )'))),
					$author$project$Reusable$Slider$style(
					_List_fromArray(
						[
							_Utils_Tuple2('width', '100%')
						])),
					$author$project$Reusable$Slider$min(72),
					$author$project$Reusable$Slider$max(132),
					$author$project$Reusable$Slider$value(theme.gH),
					$author$project$Reusable$Slider$disabled(!theme.hH)
				]));
	});
var $author$project$Reusable$Separator$viewCompactVertical = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'width', '1px'),
			A2($elm$html$Html$Attributes$style, 'height', '28px'),
			A2($elm$html$Html$Attributes$style, 'margin', '0px 4px'),
			A2($elm$html$Html$Attributes$style, 'background-color', 'rgb(224, 224, 224)')
		]),
	_List_Nil);
var $author$project$Pages$CfgDevice$Settings$LogoUrl = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$CfgDevice$Settings$viewLogoUrlField = F2(
	function (model, theme) {
		var isDisabled = !theme.hH;
		return $aforemny$material_components_web_elm$Material$TextArea$outlined(
			A2(
				$aforemny$material_components_web_elm$Material$TextArea$setAttributes,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'padding-right', '6px')
					]),
				A2(
					$aforemny$material_components_web_elm$Material$TextArea$setRows,
					$elm$core$Maybe$Just(2),
					A2(
						$aforemny$material_components_web_elm$Material$TextArea$setOnInput,
						$author$project$Pages$CfgDevice$Settings$LogoUrl,
						A2(
							$aforemny$material_components_web_elm$Material$TextArea$setValue,
							$elm$core$Maybe$Just(model.gZ),
							A2(
								$aforemny$material_components_web_elm$Material$TextArea$setLabel,
								$elm$core$Maybe$Just('Logo URL'),
								$aforemny$material_components_web_elm$Material$TextArea$config))))));
	});
var $author$project$Pages$CfgDevice$Settings$OpenImageLibrary = {$: 37};
var $author$project$Pages$CfgDevice$Settings$viewOpenImageLibButton = function (model) {
	return A5(
		$author$project$Reusable$Tooltip$view,
		$author$project$Pages$CfgDevice$Settings$Tooltip,
		_List_fromArray(
			[2]),
		model.fQ,
		_List_fromArray(
			[
				$author$project$Reusable$Tooltip$label('Choose Image')
			]),
		A2(
			$aforemny$material_components_web_elm$Material$IconButton$iconButton,
			A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, $author$project$Pages$CfgDevice$Settings$OpenImageLibrary, $aforemny$material_components_web_elm$Material$IconButton$config),
			$aforemny$material_components_web_elm$Material$IconButton$icon('image')));
};
var $author$project$Pages$CfgDevice$Settings$SetLogoUrl = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$CfgDevice$Settings$viewSaveLogoButton = F2(
	function (model, theme) {
		var isDisabled = $elm$core$String$isEmpty(model.gZ);
		return A5(
			$author$project$Reusable$Tooltip$view,
			$author$project$Pages$CfgDevice$Settings$Tooltip,
			_List_fromArray(
				[1]),
			model.fQ,
			_List_fromArray(
				[
					$author$project$Reusable$Tooltip$label('Save Logo')
				]),
			A2(
				$aforemny$material_components_web_elm$Material$IconButton$iconButton,
				A2(
					$aforemny$material_components_web_elm$Material$IconButton$setDisabled,
					isDisabled,
					A2(
						$aforemny$material_components_web_elm$Material$IconButton$setOnClick,
						$author$project$Pages$CfgDevice$Settings$SetLogoUrl(theme),
						$aforemny$material_components_web_elm$Material$IconButton$config)),
				$aforemny$material_components_web_elm$Material$IconButton$icon('save')));
	});
var $author$project$Pages$CfgDevice$Settings$viewLogoSwitcher = F2(
	function (model, theme) {
		return $author$project$Reusable$Flex$viewHorizontal(
			_List_fromArray(
				[
					A2($author$project$Pages$CfgDevice$Settings$viewLogoUrlField, model, theme),
					$author$project$Pages$CfgDevice$Settings$viewOpenImageLibButton(model),
					$author$project$Reusable$Separator$viewCompactVertical,
					A2($author$project$Pages$CfgDevice$Settings$viewSaveLogoButton, model, theme)
				]));
	});
var $author$project$Pages$CfgDevice$Settings$viewLogoPreview = F2(
	function (model, theme) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$alt('logo'),
					A2($elm$html$Html$Attributes$style, 'border-radius', '12px'),
					A2(
					$elm$html$Html$Attributes$style,
					'width',
					$elm$core$String$fromFloat(theme.hY) + 'px'),
					A2(
					$elm$html$Html$Attributes$style,
					'height',
					$elm$core$String$fromFloat(theme.gH) + 'px'),
					A2($elm$html$Html$Attributes$style, 'background-color', 'rgb(240,240,240)'),
					A2($elm$html$Html$Attributes$style, 'background-size', 'cover'),
					A2($elm$html$Html$Attributes$style, 'background-repeat', 'no-repeat'),
					A2($elm$html$Html$Attributes$style, 'background-image', 'url(\"' + (model.gZ + '\")')),
					A2(
					$elm$html$Html$Attributes$style,
					'opacity',
					theme.hH ? '1' : '0.4'),
					A2(
					$elm$html$Html$Attributes$style,
					'border',
					theme.hH ? '1px solid black' : 'none')
				]),
			_List_Nil);
	});
var $author$project$Pages$CfgDevice$Settings$viewLogoToggleButton = F2(
	function (model, theme) {
		var onToggle = $author$project$Pages$CfgDevice$Settings$UpdateTheme(
			_Utils_update(
				theme,
				{hH: !theme.hH}));
		var checkboxState = theme.hH ? $aforemny$material_components_web_elm$Material$Checkbox$checked : $aforemny$material_components_web_elm$Material$Checkbox$unchecked;
		return A2(
			$aforemny$material_components_web_elm$Material$FormField$formField,
			A2(
				$aforemny$material_components_web_elm$Material$FormField$setAttributes,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'margin-right', '8px')
					]),
				A2(
					$aforemny$material_components_web_elm$Material$FormField$setLabel,
					$elm$core$Maybe$Just('Show Logo'),
					$aforemny$material_components_web_elm$Material$FormField$config)),
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$Checkbox$checkbox(
					A2(
						$aforemny$material_components_web_elm$Material$Checkbox$setOnChange,
						onToggle,
						A2(
							$aforemny$material_components_web_elm$Material$Checkbox$setState,
							$elm$core$Maybe$Just(checkboxState),
							$aforemny$material_components_web_elm$Material$Checkbox$config)))
				]));
	});
var $author$project$Pages$CfgDevice$Settings$viewLogoToggleAndPreview = F2(
	function (model, theme) {
		return $author$project$Reusable$Flex$viewHorizontal(
			_List_fromArray(
				[
					A2($author$project$Pages$CfgDevice$Settings$viewLogoToggleButton, model, theme),
					A2($author$project$Pages$CfgDevice$Settings$viewLogoPreview, model, theme)
				]));
	});
var $author$project$Pages$CfgDevice$Settings$viewLogoWidthSelector = F2(
	function (model, theme) {
		return A2(
			$author$project$Reusable$Slider$view,
			function (val) {
				return $author$project$Pages$CfgDevice$Settings$UpdateTheme(
					_Utils_update(
						theme,
						{hY: val}));
			},
			_List_fromArray(
				[
					$author$project$Reusable$Slider$label(
					'Logo Width ' + ('( ' + ($elm$core$String$fromFloat(theme.hY) + 'px )'))),
					$author$project$Reusable$Slider$style(
					_List_fromArray(
						[
							_Utils_Tuple2('width', '100%')
						])),
					$author$project$Reusable$Slider$min(72),
					$author$project$Reusable$Slider$max(132),
					$author$project$Reusable$Slider$value(theme.hY),
					$author$project$Reusable$Slider$disabled(!theme.hH)
				]));
	});
var $author$project$Pages$CfgDevice$Settings$viewToggleStatusBarButton = F2(
	function (model, theme) {
		var onToggle = $author$project$Pages$CfgDevice$Settings$UpdateTheme(
			_Utils_update(
				theme,
				{gK: !theme.gK}));
		var checkboxState = theme.gK ? $aforemny$material_components_web_elm$Material$Checkbox$checked : $aforemny$material_components_web_elm$Material$Checkbox$unchecked;
		return A2(
			$aforemny$material_components_web_elm$Material$FormField$formField,
			A2(
				$aforemny$material_components_web_elm$Material$FormField$setAttributes,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '12px')
					]),
				A2(
					$aforemny$material_components_web_elm$Material$FormField$setLabel,
					$elm$core$Maybe$Just('Hide Status Bar'),
					$aforemny$material_components_web_elm$Material$FormField$config)),
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$Checkbox$checkbox(
					A2(
						$aforemny$material_components_web_elm$Material$Checkbox$setOnChange,
						onToggle,
						A2(
							$aforemny$material_components_web_elm$Material$Checkbox$setState,
							$elm$core$Maybe$Just(checkboxState),
							$aforemny$material_components_web_elm$Material$Checkbox$config)))
				]));
	});
var $author$project$Pages$CfgDevice$Settings$viewThemeEditor = function (model) {
	var _v0 = model.bH;
	if (!_v0.$) {
		var theme = _v0.a;
		return A3(
			$author$project$Reusable$Card$viewConfigCard2,
			'Status Bar',
			_List_fromArray(
				[
					A2($author$project$Pages$CfgDevice$Settings$viewToggleStatusBarButton, model, theme),
					A2($author$project$Pages$CfgDevice$Settings$viewFontFamilySelector, model, theme),
					A2($author$project$Pages$CfgDevice$Settings$viewBackgroundSelector, model, theme),
					A2($author$project$Pages$CfgDevice$Settings$viewFontSizeSelector, model, theme),
					A2($author$project$Pages$CfgDevice$Settings$viewFontColorPicker, model, theme)
				]),
			_List_fromArray(
				[
					A2($author$project$Pages$CfgDevice$Settings$viewLogoWidthSelector, model, theme),
					A2($author$project$Pages$CfgDevice$Settings$viewLogoHeightSelector, model, theme),
					A2($author$project$Pages$CfgDevice$Settings$viewLogoSwitcher, model, theme),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'height', '12px'),
							A2($elm$html$Html$Attributes$style, 'width', '12px')
						]),
					_List_Nil),
					A2($author$project$Pages$CfgDevice$Settings$viewLogoToggleAndPreview, model, theme)
				]));
	} else {
		return $author$project$Pages$CfgDevice$Settings$loading;
	}
};
var $author$project$Pages$CfgDevice$Settings$view = F2(
	function (config, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'margin-top', '12px')
				]),
			_List_fromArray(
				[
					A2($author$project$Pages$CfgDevice$Settings$viewDeviceInformation, config, model),
					$author$project$Pages$CfgDevice$Settings$viewDeviceCommands(model),
					A2($author$project$Pages$CfgDevice$Settings$viewLoadMenu, config, model),
					$author$project$Reusable$Header$subHeader('Configuration'),
					$author$project$Pages$CfgDevice$Settings$viewThemeEditor(model),
					$author$project$Pages$CfgDevice$Settings$viewBannerEditor(model),
					$author$project$Pages$CfgDevice$Settings$viewScreensaverEditor(model),
					A2(
					$author$project$Reusable$Header$subHeader2,
					'Platform Information',
					$author$project$Pages$CfgDevice$Settings$viewPlatformInfoRefreshButton(model)),
					$author$project$Pages$CfgDevice$Settings$viewCpuInfo(model),
					$author$project$Pages$CfgDevice$Settings$viewMemInfo(model),
					A2($author$project$Pages$CfgDevice$Settings$viewConfirmDeactivationDialog, config, model),
					A2($author$project$Pages$CfgDevice$Settings$viewConfirmRestartDialog, config, model)
				]));
	});
var $aforemny$material_components_web_elm$Material$Tab$config = {
	h6: false,
	fZ: _List_Nil,
	k_: {iU: $elm$core$Maybe$Nothing, c9: ''},
	he: $elm$core$Maybe$Nothing
};
var $aforemny$material_components_web_elm$Material$Tab$setActive = F2(
	function (active, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{h6: active});
	});
var $aforemny$material_components_web_elm$Material$Tab$setOnClick = F2(
	function (onClick, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{
				he: $elm$core$Maybe$Just(onClick)
			});
	});
var $aforemny$material_components_web_elm$Material$Tab$tab = F2(
	function (_v0, content) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{k_: content});
	});
var $author$project$Pages$CfgDevice$Core$viewTabLabel = F4(
	function (config, device, model, _v0) {
		var label = _v0.a;
		var tab = _v0.b;
		return A2(
			$aforemny$material_components_web_elm$Material$Tab$tab,
			A2(
				$aforemny$material_components_web_elm$Material$Tab$setOnClick,
				A3(
					$author$project$Pages$CfgDevice$Core$SelectMainTab,
					config.k.an,
					device,
					$elm$core$Maybe$Just(tab)),
				A2(
					$aforemny$material_components_web_elm$Material$Tab$setActive,
					_Utils_eq(model.ba, tab),
					$aforemny$material_components_web_elm$Material$Tab$config)),
			{iU: $elm$core$Maybe$Nothing, c9: label});
	});
var $author$project$Pages$CfgDevice$Core$viewDeviceConfigTabs = F3(
	function (config, device, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$aforemny$material_components_web_elm$Material$TabBar$tabBar,
					A2(
						$aforemny$material_components_web_elm$Material$TabBar$setAttributes,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'margin-bottom', '32px')
							]),
						$aforemny$material_components_web_elm$Material$TabBar$config),
					A4(
						$author$project$Pages$CfgDevice$Core$viewTabLabel,
						config,
						device,
						model,
						_Utils_Tuple2('Schedule', 0)),
					_List_fromArray(
						[
							A4(
							$author$project$Pages$CfgDevice$Core$viewTabLabel,
							config,
							device,
							model,
							_Utils_Tuple2('Design', 1)),
							A4(
							$author$project$Pages$CfgDevice$Core$viewTabLabel,
							config,
							device,
							model,
							_Utils_Tuple2('Settings', 2))
						])),
					function () {
					var _v0 = _Utils_Tuple2(model.ba, device.fJ);
					if (!_v0.b.$) {
						switch (_v0.a) {
							case 0:
								var _v1 = _v0.a;
								return A2(
									$elm$html$Html$map,
									$author$project$Pages$CfgDevice$Core$ScheduleTabMsg,
									A3($author$project$Pages$CfgDevice$Schedule$view, config.k, model.a7, device));
							case 1:
								var _v2 = _v0.a;
								return A2(
									$elm$html$Html$map,
									$author$project$Pages$CfgDevice$Core$DesignTabMsg,
									A2(
										$author$project$Pages$CfgDevice$Design$view,
										{
											h5: config.h5,
											eO: config.eO,
											iB: device.aF,
											gm: 'media-image-upload-button',
											gM: _Utils_Tuple2(config.k.fT, config.iC),
											g1: config.g1,
											mo: $elm$core$Dict$values(model.a7.mo),
											an: config.k.an
										},
										model.P));
							default:
								var _v3 = _v0.a;
								return A2(
									$elm$html$Html$map,
									$author$project$Pages$CfgDevice$Core$SettingsTabMsg,
									A2(
										$author$project$Pages$CfgDevice$Settings$view,
										{kv: config.ao, cV: device, aQ: config.aQ, nb: config.h5, an: config.k.an},
										model.aU));
						}
					} else {
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'font-size', '18px'),
									A2($elm$html$Html$Attributes$style, 'text-align', 'center'),
									A2($elm$html$Html$Attributes$style, 'padding-top', '12px')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('This device is currently unreachable or offline')
								]));
					}
				}()
				]));
	});
var $author$project$Pages$CfgDevice$Core$viewMainSection = F3(
	function (config, selectedDevice, model) {
		if (selectedDevice.$ === 1) {
			return A2(
				$elm$html$Html$map,
				config.cz,
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[$aforemny$material_components_web_elm$Material$Typography$subtitle1]),
							_List_fromArray(
								[
									$elm$html$Html$text('Unable to find the selected device, Please retry again.')
								])),
							A2(
							$aforemny$material_components_web_elm$Material$Button$outlined,
							A2(
								$aforemny$material_components_web_elm$Material$Button$setHref,
								$elm$core$Maybe$Just('/alldevices'),
								$aforemny$material_components_web_elm$Material$Button$config),
							'All Devices')
						])));
		} else {
			var device = selectedDevice.a;
			return A2(
				$elm$html$Html$map,
				config.cz,
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A3($author$project$Pages$CfgDevice$Core$viewDeviceConfigTabs, config, device, model),
							A2(
							$aforemny$material_components_web_elm$Material$Snackbar$snackbar,
							$aforemny$material_components_web_elm$Material$Snackbar$config(
								{l1: $author$project$Pages$CfgDevice$Core$SnackbarClosed}),
							model.cp)
						])));
		}
	});
var $author$project$Pages$Dashboard$SnackbarClosed = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Dashboard$filterDevicesByName = F2(
	function (searchInput, deviceList) {
		return A3(
			$NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$filter,
			function (device) {
				return device.g8 + ('|' + A2($elm$core$Maybe$withDefault, '', device.jP));
			},
			searchInput,
			deviceList);
	});
var $author$project$Pages$Dashboard$filterDevicesByState = F2(
	function (state, list) {
		switch (state) {
			case 0:
				return list;
			case 1:
				return A2($elm$core$List$filter, $author$project$Entity$Device$isDeviceOnline, list);
			default:
				return A2($elm$core$List$filter, $author$project$Entity$Device$isDeviceOffline, list);
		}
	});
var $author$project$Pages$Dashboard$filterSchools = F2(
	function (maybeSchool, schools) {
		if (maybeSchool.$ === 1) {
			return schools;
		} else {
			var school = maybeSchool.a;
			return A2(
				$elm$core$List$filter,
				function (s) {
					return _Utils_eq(s.aF, school.aF);
				},
				schools);
		}
	});
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $author$project$Pages$Dashboard$isSchoolMatch = F2(
	function (devices, school) {
		var maybeSchool = A2(
			$elm_community$list_extra$List$Extra$find,
			function (device) {
				return _Utils_eq(device.du.aF, school.aF);
			},
			devices);
		if (maybeSchool.$ === 1) {
			return false;
		} else {
			return true;
		}
	});
var $author$project$Pages$Dashboard$getSchoolsWithDevices = F2(
	function (schools, devices) {
		return A2(
			$elm$core$List$filter,
			$author$project$Pages$Dashboard$isSchoolMatch(devices),
			schools);
	});
var $author$project$Pages$Dashboard$ResetAllFilters = {$: 4};
var $aforemny$material_components_web_elm$Material$Button$Text = 0;
var $aforemny$material_components_web_elm$Material$Button$text = F2(
	function (config_, label) {
		return A3($aforemny$material_components_web_elm$Material$Button$button, 0, config_, label);
	});
var $author$project$Pages$Dashboard$viewAlert = function (model) {
	var _v0 = _Utils_Tuple3(
		model.aE,
		$elm$core$String$isEmpty(model.bm),
		model.bY);
	if (((_v0.a.$ === 1) && _v0.b) && (!_v0.c)) {
		var _v1 = _v0.a;
		var _v2 = _v0.c;
		return A2($elm$html$Html$div, _List_Nil, _List_Nil);
	} else {
		return A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$Typography$body1,
					A2($elm$html$Html$Attributes$style, 'margin', '0px'),
					A2($elm$html$Html$Attributes$style, 'padding', '2px 0px 6px 0px')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Filter(s) are applied. Select RESET to view all devices.'),
					A2(
					$aforemny$material_components_web_elm$Material$Button$text,
					A2(
						$aforemny$material_components_web_elm$Material$Button$setAttributes,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'margin-left', '8px')
							]),
						A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$Dashboard$ResetAllFilters, $aforemny$material_components_web_elm$Material$Button$config)),
					'Reset')
				]));
	}
};
var $author$project$Pages$Dashboard$CloseConfirmDeactivation = {$: 18};
var $author$project$Pages$Dashboard$DeactivateDevice = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Dashboard$NoOp = {$: 0};
var $author$project$Pages$Dashboard$viewDeactivateTextButton = function (model) {
	var onClick = function () {
		var _v0 = model.bj.b;
		if (!_v0.$) {
			var dev = _v0.a;
			return $author$project$Pages$Dashboard$DeactivateDevice(dev);
		} else {
			return $author$project$Pages$Dashboard$NoOp;
		}
	}();
	return A2(
		$aforemny$material_components_web_elm$Material$Button$outlined,
		A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config),
		'Deactivate');
};
var $author$project$Pages$Dashboard$viewConfirmDeactivation = function (model) {
	return A2(
		$aforemny$material_components_web_elm$Material$Dialog$dialog,
		A2(
			$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
			$author$project$Pages$Dashboard$CloseConfirmDeactivation,
			A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.bj.a, $aforemny$material_components_web_elm$Material$Dialog$config)),
		{
			kk: _List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$Button$outlined,
					A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$Dashboard$CloseConfirmDeactivation, $aforemny$material_components_web_elm$Material$Button$config),
					'close'),
					$author$project$Pages$Dashboard$viewDeactivateTextButton(model)
				]),
			k_: _List_fromArray(
				[
					function () {
					var _v0 = model.bj.b;
					if (!_v0.$) {
						var dev = _v0.a;
						return $elm$html$Html$text('Are you sure you want to deactivate ' + (dev.g8 + (' ? ' + 'It will erase all content from device and server')));
					} else {
						return $elm$html$Html$text('Device is not selected');
					}
				}()
				]),
			na: $elm$core$Maybe$Just('Confirm Deactivation')
		});
};
var $author$project$Pages$Dashboard$CloseConfirmRestart = {$: 15};
var $author$project$Pages$Dashboard$RestartOnlineDevices = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Dashboard$viewRestartButton = function (model) {
	var onClick = $author$project$Pages$Dashboard$RestartOnlineDevices(model.cP.b);
	return A2(
		$aforemny$material_components_web_elm$Material$Button$outlined,
		A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config),
		'Restart');
};
var $author$project$Pages$Dashboard$viewConfirmRestart = function (model) {
	return A2(
		$aforemny$material_components_web_elm$Material$Dialog$dialog,
		A2(
			$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
			$author$project$Pages$Dashboard$CloseConfirmRestart,
			A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.cP.a, $aforemny$material_components_web_elm$Material$Dialog$config)),
		{
			kk: _List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$Button$outlined,
					A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$Dashboard$CloseConfirmRestart, $aforemny$material_components_web_elm$Material$Button$config),
					'close'),
					$author$project$Pages$Dashboard$viewRestartButton(model)
				]),
			k_: $elm$core$List$isEmpty(model.cP.b) ? _List_fromArray(
				[
					$elm$html$Html$text('None of the devices are online')
				]) : _List_fromArray(
				[
					$elm$html$Html$text('Are you sure you want to restart all the online devices, It will take a couple of minutes before they are back online.')
				]),
			na: $elm$core$Maybe$Just('Confirm Restart')
		});
};
var $author$project$Pages$Dashboard$FilterByName = function (a) {
	return {$: 2, a: a};
};
var $author$project$Mdl$Elevation$e3 = $elm$html$Html$Attributes$class('mdl-shadow--3dp');
var $aforemny$material_components_web_elm$Material$TextField$filled = function (config_) {
	return A2($aforemny$material_components_web_elm$Material$TextField$textField, false, config_);
};
var $aforemny$material_components_web_elm$Material$TextField$setPlaceholder = F2(
	function (placeholder, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{ht: placeholder});
	});
var $author$project$Pages$Dashboard$viewDeviceFilter = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Mdl$Elevation$e3,
				A2($elm$html$Html$Attributes$style, 'width', '99%'),
				A2($elm$html$Html$Attributes$style, 'margin-bottom', '12px'),
				A2($elm$html$Html$Attributes$style, 'position', 'sticky'),
				A2($elm$html$Html$Attributes$style, 'top', '84px'),
				A2($elm$html$Html$Attributes$style, 'z-index', '4')
			]),
		_List_fromArray(
			[
				$aforemny$material_components_web_elm$Material$TextField$filled(
				A2(
					$aforemny$material_components_web_elm$Material$TextField$setAttributes,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '100%')
						]),
					A2(
						$aforemny$material_components_web_elm$Material$TextField$setLeadingIcon,
						$elm$core$Maybe$Just(
							$aforemny$material_components_web_elm$Material$TextField$Icon$icon('search')),
						A2(
							$aforemny$material_components_web_elm$Material$TextField$setOnInput,
							$author$project$Pages$Dashboard$FilterByName,
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setValue,
								$elm$core$Maybe$Just(model.bm),
								A2(
									$aforemny$material_components_web_elm$Material$TextField$setPlaceholder,
									$elm$core$Maybe$Just('Search by Device Name, Serial Number'),
									$aforemny$material_components_web_elm$Material$TextField$config))))))
			]));
};
var $author$project$Pages$Dashboard$CloseDeviceInfo = {$: 11};
var $author$project$Pages$Dashboard$viewDeviceInformation = function (model) {
	return A2(
		$aforemny$material_components_web_elm$Material$Dialog$dialog,
		A2(
			$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
			$author$project$Pages$Dashboard$CloseDeviceInfo,
			A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.cW.a, $aforemny$material_components_web_elm$Material$Dialog$config)),
		{
			kk: _List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$Button$outlined,
					A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$Dashboard$CloseDeviceInfo, $aforemny$material_components_web_elm$Material$Button$config),
					'close')
				]),
			k_: function () {
				var _v0 = model.cW.b;
				if (!_v0.$) {
					var device = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Reusable$Label$view, 'Device Name', device.g8),
							A2(
							$author$project$Reusable$Label$view,
							'Serial Number',
							A2($elm$core$Maybe$withDefault, 'Unknown', device.jP))
						]);
				} else {
					return _List_fromArray(
						[
							$elm$html$Html$text('Unable to load information')
						]);
				}
			}(),
			na: $elm$core$Maybe$Just('Information')
		});
};
var $author$project$Pages$Dashboard$filterDevicesBySchool = F2(
	function (maybeSchool, deviceList) {
		return A2(
			$elm$core$List$filter,
			function (dev) {
				if (!maybeSchool.$) {
					var school = maybeSchool.a;
					return _Utils_eq(dev.du.aF, school.aF);
				} else {
					return true;
				}
			},
			deviceList);
	});
var $author$project$Pages$Dashboard$ConfirmDeactivation = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Dashboard$Tooltip = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Dashboard$viewDeactivateButton = F4(
	function (config, model, device, index) {
		var onClick = config.cz(
			$author$project$Pages$Dashboard$ConfirmDeactivation(device));
		return A5(
			$author$project$Reusable$Tooltip$view,
			A2($elm$core$Basics$composeR, $author$project$Pages$Dashboard$Tooltip, config.cz),
			index,
			model.fQ,
			_List_fromArray(
				[
					$author$project$Reusable$Tooltip$label('Deactivate')
				]),
			A2(
				$aforemny$material_components_web_elm$Material$IconButton$iconButton,
				A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, onClick, $aforemny$material_components_web_elm$Material$IconButton$config),
				$aforemny$material_components_web_elm$Material$IconButton$icon('delete')));
	});
var $author$project$Pages$Dashboard$viewDeviceConfigButton = F4(
	function (config, model, device, index) {
		var onClick = config.mw(device);
		var isDisabled = $author$project$Entity$Device$isDeviceOffline(device);
		return A5(
			$author$project$Reusable$Tooltip$view,
			A2($elm$core$Basics$composeR, $author$project$Pages$Dashboard$Tooltip, config.cz),
			index,
			model.fQ,
			_List_fromArray(
				[
					$author$project$Reusable$Tooltip$label('View')
				]),
			A2(
				$aforemny$material_components_web_elm$Material$IconButton$iconButton,
				A2(
					$aforemny$material_components_web_elm$Material$IconButton$setDisabled,
					isDisabled,
					A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, onClick, $aforemny$material_components_web_elm$Material$IconButton$config)),
				$aforemny$material_components_web_elm$Material$IconButton$icon('open_in_new')));
	});
var $author$project$Pages$Dashboard$viewLiveCaptureButton = F4(
	function (config, model, device, index) {
		var onClick = config.lQ(device);
		var isDisabled = $author$project$Entity$Device$isDeviceOffline(device);
		return A5(
			$author$project$Reusable$Tooltip$view,
			A2($elm$core$Basics$composeR, $author$project$Pages$Dashboard$Tooltip, config.cz),
			index,
			model.fQ,
			_List_fromArray(
				[
					$author$project$Reusable$Tooltip$label('Live Capture')
				]),
			A2(
				$aforemny$material_components_web_elm$Material$IconButton$iconButton,
				A2(
					$aforemny$material_components_web_elm$Material$IconButton$setAttributes,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin', '0px 4px')
						]),
					A2(
						$aforemny$material_components_web_elm$Material$IconButton$setDisabled,
						isDisabled,
						A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, onClick, $aforemny$material_components_web_elm$Material$IconButton$config))),
				$aforemny$material_components_web_elm$Material$IconButton$icon('camera')));
	});
var $author$project$Pages$Dashboard$ViewDeviceInfo = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Dashboard$viewSerialNumberButton = F4(
	function (config, model, device, index) {
		var onClick = config.cz(
			$author$project$Pages$Dashboard$ViewDeviceInfo(device));
		var isDisabled = function () {
			var _v0 = device.jP;
			if (!_v0.$) {
				return false;
			} else {
				return true;
			}
		}();
		return A5(
			$author$project$Reusable$Tooltip$view,
			A2($elm$core$Basics$composeR, $author$project$Pages$Dashboard$Tooltip, config.cz),
			index,
			model.fQ,
			_List_fromArray(
				[
					$author$project$Reusable$Tooltip$label('View Serial Number')
				]),
			A2(
				$aforemny$material_components_web_elm$Material$IconButton$iconButton,
				A2(
					$aforemny$material_components_web_elm$Material$IconButton$setAttributes,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin', '0px 4px')
						]),
					A2(
						$aforemny$material_components_web_elm$Material$IconButton$setDisabled,
						isDisabled,
						A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, onClick, $aforemny$material_components_web_elm$Material$IconButton$config))),
				$aforemny$material_components_web_elm$Material$IconButton$icon('perm_device_information')));
	});
var $author$project$Pages$Dashboard$toColorDeviceState = function (state) {
	switch (state.$) {
		case 0:
			return '#007F38';
		case 1:
			return '#D0021B';
		case 4:
			return '#FFD600';
		case 2:
			return '#FFD600';
		default:
			return '#FFD600';
	}
};
var $author$project$Pages$Dashboard$viewStateColor = function (device) {
	var color = $author$project$Pages$Dashboard$toColorDeviceState(device.fJ);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('device-status-color-bar'),
				A2($elm$html$Html$Attributes$style, 'background', color)
			]),
		_List_Nil);
};
var $author$project$Pages$Dashboard$toStringDeviceState = function (state) {
	switch (state.$) {
		case 0:
			return 'Online';
		case 1:
			return 'Offline';
		case 2:
			return 'Connecting ...';
		case 4:
			return 'Unknown State';
		default:
			return 'Failed to connect';
	}
};
var $elm_community$string_extra$String$Extra$regexFromString = A2(
	$elm$core$Basics$composeR,
	$elm$regex$Regex$fromString,
	$elm$core$Maybe$withDefault($elm$regex$Regex$never));
var $elm_community$string_extra$String$Extra$changeCase = F2(
	function (mutator, word) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var head = _v0.a;
					var tail = _v0.b;
					return A2(
						$elm$core$String$cons,
						mutator(head),
						tail);
				},
				$elm$core$String$uncons(word)));
	});
var $elm$core$Char$toUpper = _Char_toUpper;
var $elm_community$string_extra$String$Extra$toSentenceCase = function (word) {
	return A2($elm_community$string_extra$String$Extra$changeCase, $elm$core$Char$toUpper, word);
};
var $elm_community$string_extra$String$Extra$toTitleCase = function (ws) {
	var uppercaseMatch = A2(
		$elm$regex$Regex$replace,
		$elm_community$string_extra$String$Extra$regexFromString('\\w+'),
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.lU;
			},
			$elm_community$string_extra$String$Extra$toSentenceCase));
	return A3(
		$elm$regex$Regex$replace,
		$elm_community$string_extra$String$Extra$regexFromString('^([a-z])|\\s+([a-z])'),
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.lU;
			},
			uppercaseMatch),
		ws);
};
var $author$project$Pages$Dashboard$viewStateText = F3(
	function (config, model, device) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('device-status-text-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'line-height', '1.2em'),
							A2($elm$html$Html$Attributes$style, 'font-size', '18px'),
							A2($elm$html$Html$Attributes$style, 'outline', 'none'),
							A2($elm$html$Html$Attributes$style, 'border', 'none'),
							A2($elm$html$Html$Attributes$style, 'padding', '0px'),
							A2($elm$html$Html$Attributes$style, 'background', 'transparent'),
							A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
							A2($elm$html$Html$Attributes$style, 'text-align', 'left'),
							$elm$html$Html$Events$onClick(
							config.mw(device))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(device.g8)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'line-height', '20px'),
							A2($elm$html$Html$Attributes$style, 'font-size', '12px'),
							A2($elm$html$Html$Attributes$style, 'opacity', '0.87')
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = _Utils_Tuple2(device.fJ, device.jd);
							if (!_v0.a.$) {
								if (!_v0.b.$) {
									var schdName = _v0.b.a;
									return $elm$html$Html$text(
										'Now playing ' + $elm_community$string_extra$String$Extra$toTitleCase(schdName));
								} else {
									var _v1 = _v0.b;
									return $elm$html$Html$text('Now playing screensaver');
								}
							} else {
								return $elm$html$Html$text(
									$author$project$Pages$Dashboard$toStringDeviceState(device.fJ));
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Dashboard$viewDevice = F5(
	function (config, model, index, innerIndex, device) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('device-status-root')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Dashboard$viewStateColor(device),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('device-status-container')
						]),
					_List_fromArray(
						[
							A3($author$project$Pages$Dashboard$viewStateText, config, model, device),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'display', 'flex'),
									A2($elm$html$Html$Attributes$style, 'align-items', 'center')
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Pages$Dashboard$viewDeviceConfigButton,
									config,
									model,
									device,
									_List_fromArray(
										[1, index, innerIndex])),
									$author$project$Reusable$Separator$viewVertical,
									A4(
									$author$project$Pages$Dashboard$viewLiveCaptureButton,
									config,
									model,
									device,
									_List_fromArray(
										[2, index, innerIndex])),
									A4(
									$author$project$Pages$Dashboard$viewSerialNumberButton,
									config,
									model,
									device,
									_List_fromArray(
										[3, index, innerIndex])),
									A4(
									$author$project$Pages$Dashboard$viewDeactivateButton,
									config,
									model,
									device,
									_List_fromArray(
										[4, index, innerIndex]))
								]))
						]))
				]));
	});
var $author$project$Pages$Dashboard$FilterBySchool = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Dashboard$viewSchoolName = function (school) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
				A2($elm$html$Html$Attributes$style, 'margin-bottom', '18px'),
				A2($elm$html$Html$Attributes$style, 'color', 'black'),
				A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
				A2($elm$html$Html$Attributes$style, 'line-height', '32px'),
				A2($elm$html$Html$Attributes$style, 'opacity', '0.77'),
				A2($elm$html$Html$Attributes$style, 'font-size', '24px'),
				A2($elm$html$Html$Attributes$style, 'font-weight', '500'),
				A2($elm$html$Html$Attributes$style, 'font-family', 'Roboto'),
				$elm$html$Html$Events$onClick(
				$author$project$Pages$Dashboard$FilterBySchool(school))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(school.g8)
			]));
};
var $author$project$Pages$Dashboard$viewSchoolDevices = F5(
	function (config, model, devicesList, index, school) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Mdl$Elevation$e3,
					$elm$html$Html$Attributes$class('school-devices-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					config.cz,
					$author$project$Pages$Dashboard$viewSchoolName(school)),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						A3($author$project$Pages$Dashboard$viewDevice, config, model, index),
						A2(
							$elm$core$List$sortBy,
							function ($) {
								return $.g8;
							},
							A2(
								$author$project$Pages$Dashboard$filterDevicesBySchool,
								$elm$core$Maybe$Just(school),
								devicesList))))
				]));
	});
var $author$project$Pages$Dashboard$viewDevices = F4(
	function (config, model, schoolsWithDevices, filteredDevices) {
		var _v0 = _Utils_Tuple2(model.aE, schoolsWithDevices);
		_v0$2:
		while (true) {
			if (!_v0.a.$) {
				if (!_v0.b.b) {
					var school = _v0.a.a;
					return A2(
						$elm$html$Html$map,
						config.cz,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Mdl$Elevation$e3,
									A2($elm$html$Html$Attributes$style, 'padding', '24px'),
									$elm$html$Html$Attributes$class('school-devices-container')
								]),
							_List_fromArray(
								[
									$author$project$Pages$Dashboard$viewSchoolName(school),
									$elm$html$Html$text('No devices in this school')
								])));
				} else {
					break _v0$2;
				}
			} else {
				if (!_v0.b.b) {
					var _v1 = _v0.a;
					return A2(
						$elm$html$Html$map,
						config.cz,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Mdl$Elevation$e3,
									$elm$html$Html$Attributes$class('school-devices-container')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Looks like there are no devices')
								])));
				} else {
					break _v0$2;
				}
			}
		}
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$indexedMap,
				A3($author$project$Pages$Dashboard$viewSchoolDevices, config, model, filteredDevices),
				schoolsWithDevices));
	});
var $author$project$Pages$Dashboard$FilterByState = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Dashboard$ShowOfflineDevices = 2;
var $author$project$Pages$Dashboard$ShowOnlineDevices = 1;
var $author$project$Entity$Device$getNumberOfOffline = function (list) {
	return $elm$core$List$length(
		A2($elm$core$List$filter, $author$project$Entity$Device$isDeviceOffline, list));
};
var $author$project$Entity$Device$getNumberOfOnline = function (list) {
	return $elm$core$List$length(
		A2($elm$core$List$filter, $author$project$Entity$Device$isDeviceOnline, list));
};
var $author$project$Pages$Dashboard$NavigateTo = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Dashboard$viewMobileNewDeviceButton = A2(
	$elm$html$Html$button,
	_List_fromArray(
		[
			$author$project$Mdl$Elevation$e3,
			$elm$html$Html$Attributes$class('dashboard-main-status-box'),
			$elm$html$Html$Attributes$class('dashboard-new-device-button-mobile'),
			A2($elm$html$Html$Attributes$style, 'background', 'none'),
			$elm$html$Html$Events$onClick(
			$author$project$Pages$Dashboard$NavigateTo('/link'))
		]),
	_List_fromArray(
		[
			A2(
			$aforemny$material_components_web_elm$Material$Icon$icon,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'font-size', '48px'),
					A2($elm$html$Html$Attributes$style, 'opacity', '0.54')
				]),
			'add')
		]));
var $author$project$Pages$Dashboard$viewLabel = function (str) {
	return A2(
		$elm$html$Html$h4,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dashboard-main-status-label')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $author$project$Pages$Dashboard$viewNewDeviceButton = function (isAdmin) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$author$project$Mdl$Elevation$e3,
				$elm$html$Html$Attributes$class('dashboard-main-status-box'),
				$elm$html$Html$Attributes$class('dashboard-new-device-button-desktop'),
				A2($elm$html$Html$Attributes$style, 'background', 'none'),
				$elm$html$Html$Events$onClick(
				$author$project$Pages$Dashboard$NavigateTo('/new-device')),
				$elm$html$Html$Attributes$disabled(isAdmin),
				isAdmin ? A2($elm$html$Html$Attributes$style, 'cursor', 'auto') : A2($elm$html$Html$Attributes$style, '', '')
			]),
		_List_fromArray(
			[
				A2(
				$aforemny$material_components_web_elm$Material$Icon$icon,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'font-size', '64px'),
						A2($elm$html$Html$Attributes$style, 'opacity', '0.54'),
						A2($elm$html$Html$Attributes$style, 'margin-top', '-6px')
					]),
				'add'),
				$author$project$Pages$Dashboard$viewLabel('New Device')
			]));
};
var $author$project$Pages$Dashboard$viewStat = F2(
	function (aNumber, color) {
		return A2(
			$elm$html$Html$h4,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard-main-status-number'),
					A2($elm$html$Html$Attributes$style, 'color', color)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$fromInt(aNumber))
				]));
	});
var $author$project$Pages$Dashboard$viewStatBox = F3(
	function (numberOfDevices, msg, _v0) {
		var label = _v0.a;
		var stateColor = _v0.b;
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$author$project$Mdl$Elevation$e3,
					$elm$html$Html$Attributes$class('dashboard-main-status-box'),
					$elm$html$Html$Events$onClick(msg)
				]),
			_List_fromArray(
				[
					A2($author$project$Pages$Dashboard$viewStat, numberOfDevices, stateColor),
					$author$project$Pages$Dashboard$viewLabel(label)
				]));
	});
var $author$project$Pages$Dashboard$viewStats = F2(
	function (devices, isAdmin) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard-main-status-container')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Pages$Dashboard$viewStatBox,
					$author$project$Entity$Device$getNumberOfOnline(devices),
					$author$project$Pages$Dashboard$FilterByState(1),
					_Utils_Tuple2('Online', 'rgb(0, 127, 56)')),
					A3(
					$author$project$Pages$Dashboard$viewStatBox,
					$author$project$Entity$Device$getNumberOfOffline(devices),
					$author$project$Pages$Dashboard$FilterByState(2),
					_Utils_Tuple2('Offline', '#F44336')),
					A3(
					$author$project$Pages$Dashboard$viewStatBox,
					$elm$core$List$length(devices),
					$author$project$Pages$Dashboard$FilterByState(0),
					_Utils_Tuple2('Total', 'rgb(0,0,0)')),
					$author$project$Pages$Dashboard$viewNewDeviceButton(isAdmin),
					$author$project$Pages$Dashboard$viewMobileNewDeviceButton
				]));
	});
var $author$project$Pages$Dashboard$viewMainSection = F2(
	function (config, model) {
		var filteredSchools = A2($author$project$Pages$Dashboard$filterSchools, model.aE, config.aQ);
		var filteredSchoolIds = A2(
			$elm$core$List$map,
			function ($) {
				return $.aF;
			},
			filteredSchools);
		var filteredDevices = A2(
			$author$project$Pages$Dashboard$filterDevicesByState,
			model.bY,
			A2($author$project$Pages$Dashboard$filterDevicesByName, model.bm, config.ao));
		var schoolsWithDevices = A2($author$project$Pages$Dashboard$getSchoolsWithDevices, filteredSchools, filteredDevices);
		var devicesFromFilteredSchools = config.ao;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					config.cz,
					$author$project$Pages$Dashboard$viewDeviceFilter(model)),
					A2(
					$elm$html$Html$map,
					config.cz,
					$author$project$Pages$Dashboard$viewAlert(model)),
					A2(
					$elm$html$Html$map,
					config.cz,
					A2($author$project$Pages$Dashboard$viewStats, devicesFromFilteredSchools, config.lJ)),
					A4($author$project$Pages$Dashboard$viewDevices, config, model, schoolsWithDevices, filteredDevices),
					A2(
					$elm$html$Html$map,
					config.cz,
					$author$project$Pages$Dashboard$viewDeviceInformation(model)),
					A2(
					$elm$html$Html$map,
					config.cz,
					$author$project$Pages$Dashboard$viewConfirmRestart(model)),
					A2(
					$elm$html$Html$map,
					config.cz,
					$author$project$Pages$Dashboard$viewConfirmDeactivation(model)),
					A2(
					$elm$html$Html$map,
					config.cz,
					A2(
						$aforemny$material_components_web_elm$Material$Snackbar$snackbar,
						$aforemny$material_components_web_elm$Material$Snackbar$config(
							{l1: $author$project$Pages$Dashboard$SnackbarClosed}),
						model.cp))
				]));
	});
var $author$project$Pages$LinkNewDevice$SnackbarClosed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$LinkNewDevice$getCurrentStep = F2(
	function (config, model) {
		return ((!model.w) && config.mF) ? 1 : model.w;
	});
var $author$project$Pages$LinkNewDevice$First = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$LinkNewDevice$Fourth = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$LinkNewDevice$Second = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$LinkNewDevice$Third = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$LinkNewDevice$DelKey = function (a) {
	return {$: 10, a: a};
};
var $elm$html$Html$Attributes$autofocus = $elm$html$Html$Attributes$boolProperty('autofocus');
var $author$project$Mdl$Elevation$e8 = $elm$html$Html$Attributes$class('mdl-shadow--8dp');
var $author$project$Pages$LinkNewDevice$isOnline = function (state) {
	if (!state.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Utils$onDelete = function (msg) {
	return A2($author$project$Utils$keyDecoder, 8, msg);
};
var $author$project$Pages$LinkNewDevice$viewActivationCodeBlock = F4(
	function (state, maybeChar, domId, msg) {
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					A2(
					$author$project$Html$Attributes$Extra$when,
					!_Utils_eq(maybeChar, $elm$core$Maybe$Nothing),
					$author$project$Mdl$Elevation$e2),
					A2(
					$author$project$Html$Attributes$Extra$when,
					_Utils_eq(maybeChar, $elm$core$Maybe$Nothing),
					$author$project$Mdl$Elevation$e8),
					$elm$html$Html$Attributes$class('activation-code-block'),
					$elm$html$Html$Attributes$id(domId),
					$elm$html$Html$Attributes$value(
					$author$project$Pages$LinkNewDevice$toStringChar(maybeChar)),
					$elm$html$Html$Attributes$maxlength(1),
					$elm$html$Html$Attributes$autofocus(domId === 'first-act-code'),
					$elm$html$Html$Attributes$disabled(
					$author$project$Pages$LinkNewDevice$isOnline(state)),
					$elm$html$Html$Events$onInput(msg),
					A2(
					$author$project$Html$Attributes$Extra$when,
					!_Utils_eq(maybeChar, $elm$core$Maybe$Nothing),
					$author$project$Utils$onDelete(
						$author$project$Pages$LinkNewDevice$DelKey(domId))),
					$author$project$Utils$onEnter($author$project$Pages$LinkNewDevice$DeviceConnect)
				]),
			_List_Nil);
	});
var $author$project$Pages$LinkNewDevice$isActFull = function (code) {
	return A2(
		$elm$core$List$all,
		function (cd) {
			if (cd.$ === 1) {
				return false;
			} else {
				return true;
			}
		},
		_List_fromArray(
			[code.bZ, code.ck, code.cy, code.b_]));
};
var $author$project$Pages$LinkNewDevice$ResetFields = {$: 11};
var $author$project$Pages$LinkNewDevice$isActEmpty = function (code) {
	return A2(
		$elm$core$List$all,
		$elm$core$Basics$eq($elm$core$Maybe$Nothing),
		_List_fromArray(
			[code.bZ, code.ck, code.cy, code.b_]));
};
var $author$project$Pages$LinkNewDevice$viewResetFieldsButton = function (model) {
	var isDisabled = $author$project$Pages$LinkNewDevice$isActEmpty(model.u);
	return A2(
		$aforemny$material_components_web_elm$Material$Button$raised,
		A2(
			$aforemny$material_components_web_elm$Material$Button$setAttributes,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'margin-right', '8px')
				]),
			A2(
				$aforemny$material_components_web_elm$Material$Button$setDisabled,
				isDisabled,
				A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$LinkNewDevice$ResetFields, $aforemny$material_components_web_elm$Material$Button$config))),
		'Clear');
};
var $author$project$Pages$LinkNewDevice$viewTryAgainButton = function (model) {
	var isDisabled = $author$project$Pages$LinkNewDevice$isActEmpty(model.u);
	return A2(
		$aforemny$material_components_web_elm$Material$Button$outlined,
		A2(
			$aforemny$material_components_web_elm$Material$Button$setDisabled,
			isDisabled,
			A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$LinkNewDevice$DeviceConnect, $aforemny$material_components_web_elm$Material$Button$config)),
		'Try Again');
};
var $author$project$Pages$LinkNewDevice$viewAttemptFailed = function (model) {
	return $author$project$Reusable$Flex$viewHorizontal(
		_List_fromArray(
			[
				$author$project$Pages$LinkNewDevice$viewResetFieldsButton(model),
				$author$project$Pages$LinkNewDevice$isActFull(model.u) ? $author$project$Pages$LinkNewDevice$viewTryAgainButton(model) : $elm$html$Html$text('')
			]));
};
var $author$project$Pages$LinkNewDevice$viewActivationHelpText = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
				A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
				A2($elm$html$Html$Attributes$style, 'margin-top', '6px')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('When a new device is online, an activation code will be displayed on the screen.'),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'margin-top', '24px')
					]),
				_List_fromArray(
					[
						function () {
						var _v0 = model.A;
						switch (_v0.$) {
							case 0:
								return A2(
									$aforemny$material_components_web_elm$Material$Icon$icon,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'width', '48px'),
											A2($elm$html$Html$Attributes$style, 'height', '48px')
										]),
									'check_circle');
							case 1:
								return A2(
									$aforemny$material_components_web_elm$Material$Icon$icon,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'width', '48px'),
											A2($elm$html$Html$Attributes$style, 'height', '48px')
										]),
									'hightlight_off');
							case 4:
								return A2($elm$html$Html$div, _List_Nil, _List_Nil);
							case 2:
								return $aforemny$material_components_web_elm$Material$CircularProgress$indeterminate($aforemny$material_components_web_elm$Material$CircularProgress$config);
							default:
								return $author$project$Pages$LinkNewDevice$viewAttemptFailed(model);
						}
					}()
					]))
			]));
};
var $author$project$Pages$LinkNewDevice$viewActivationCode = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('new-device-activation-root')
					]),
				_List_fromArray(
					[
						A4($author$project$Pages$LinkNewDevice$viewActivationCodeBlock, model.A, model.u.bZ, 'first-act-code', $author$project$Pages$LinkNewDevice$First),
						A4($author$project$Pages$LinkNewDevice$viewActivationCodeBlock, model.A, model.u.ck, 'second-act-code', $author$project$Pages$LinkNewDevice$Second),
						A4($author$project$Pages$LinkNewDevice$viewActivationCodeBlock, model.A, model.u.cy, 'third-act-code', $author$project$Pages$LinkNewDevice$Third),
						A4($author$project$Pages$LinkNewDevice$viewActivationCodeBlock, model.A, model.u.b_, 'fourth-act-code', $author$project$Pages$LinkNewDevice$Fourth)
					])),
				$author$project$Pages$LinkNewDevice$viewActivationHelpText(model)
			]));
};
var $aforemny$material_components_web_elm$Material$Typography$body2 = $elm$html$Html$Attributes$class('mdc-typography--body2');
var $author$project$Pages$LinkNewDevice$viewActivationStatusStep = function (model) {
	var _v0 = model.fY;
	if (_v0.$ === 1) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$Typography$body2,
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'center')
				]),
			_List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$Icon$icon,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '48px'),
							A2($elm$html$Html$Attributes$style, 'height', '48px'),
							A2($elm$html$Html$Attributes$style, 'margin', '6px')
						]),
					'check_circle'),
					$elm$html$Html$text('Success!')
				]));
	} else {
		var err = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$Typography$body2,
					A2($elm$html$Html$Attributes$style, 'color', 'red'),
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'center')
				]),
			_List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$Icon$icon,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '48px'),
							A2($elm$html$Html$Attributes$style, 'height', '48px')
						]),
					'error'),
					$elm$html$Html$text('Activation Failed')
				]));
	}
};
var $author$project$Pages$LinkNewDevice$viewInitialSetup = F2(
	function (flags, _v0) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('new-device-step-content')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(flags.l_),
							A2($elm$html$Html$Attributes$style, 'margin-bottom', '24px'),
							A2($elm$html$Html$Attributes$style, 'max-width', '100%')
						]),
					_List_Nil),
					$elm$html$Html$text('Connect your Device to TV & Configure Network Settings')
				]));
	});
var $author$project$Pages$LinkNewDevice$NextStep = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$LinkNewDevice$OnInputName = F3(
	function (a, b, c) {
		return {$: 26, a: a, b: b, c: c};
	});
var $author$project$Pages$LinkNewDevice$viewNameDevice = F2(
	function (config, model) {
		var value = A2(
			$elm$core$Maybe$andThen,
			A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $elm$core$Tuple$first),
			model.aC);
		var onInput = A2($author$project$Pages$LinkNewDevice$OnInputName, model.du, config.ao);
		var onEnter = $author$project$Pages$LinkNewDevice$NextStep(model.w);
		var errText = function (maybeErr) {
			if (!maybeErr.$) {
				var err = maybeErr.a;
				return (!$elm$core$String$isEmpty(err)) ? err : '';
			} else {
				return '';
			}
		}(
			A2(
				$elm$core$Maybe$andThen,
				A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $elm$core$Tuple$second),
				model.aC));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$TextField$outlined(
					A2(
						$aforemny$material_components_web_elm$Material$TextField$setAttributes,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('name-your-device'),
								$author$project$Utils$onEnter(onEnter)
							]),
						A2(
							$aforemny$material_components_web_elm$Material$TextField$setValid,
							!$elm$core$String$isEmpty(errText),
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setOnInput,
								onInput,
								A2(
									$aforemny$material_components_web_elm$Material$TextField$setValue,
									value,
									A2(
										$aforemny$material_components_web_elm$Material$TextField$setLabel,
										$elm$core$Maybe$Just('Device Name'),
										$aforemny$material_components_web_elm$Material$TextField$config)))))),
					A2($aforemny$material_components_web_elm$Material$HelperText$helperText, $aforemny$material_components_web_elm$Material$HelperText$config, errText)
				]));
	});
var $author$project$Pages$LinkNewDevice$viewReviewStep = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('new-device-review-step')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Reusable$Label$view,
				'Location',
				function () {
					var _v0 = model.du;
					if (_v0.$ === 1) {
						return 'None selected';
					} else {
						var school = _v0.a;
						return school.g8;
					}
				}()),
				A2(
				$author$project$Reusable$Label$view,
				'Device Name',
				A2(
					$elm$core$Maybe$withDefault,
					'Unknown',
					A2(
						$elm$core$Maybe$andThen,
						A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $elm$core$Tuple$first),
						model.aC))),
				A2(
				$author$project$Reusable$Label$view,
				'Breakfast Serving Line(s)',
				A2($elm$core$String$join, ',', model.bR.fp.jR)),
				A2(
				$author$project$Reusable$Label$view,
				'Lunch Serving Line(s)',
				A2($elm$core$String$join, ',', model.b9.fp.jR)),
				A2(
				$author$project$Reusable$Label$view,
				'Supper Serving Line(s)',
				A2($elm$core$String$join, ',', model.ct.fp.jR))
			]));
};
var $author$project$Pages$LinkNewDevice$SelectedBreakfastCategory = F2(
	function (a, b) {
		return {$: 23, a: a, b: b};
	});
var $author$project$Pages$LinkNewDevice$SelectedLunchCategory = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Pages$LinkNewDevice$SelectedSupperCategory = F2(
	function (a, b) {
		return {$: 25, a: a, b: b};
	});
var $aforemny$material_components_web_elm$Material$Typography$caption = $elm$html$Html$Attributes$class('mdc-typography--caption');
var $author$project$Reusable$MultiSelect$viewHelpText = function (maybeStr) {
	if (maybeStr.$ === 1) {
		return A2($elm$html$Html$div, _List_Nil, _List_Nil);
	} else {
		var str = maybeStr.a;
		return A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$Typography$caption,
					A2($elm$html$Html$Attributes$style, 'color', 'red'),
					A2($elm$html$Html$Attributes$style, 'opacity', '1'),
					A2($elm$html$Html$Attributes$style, 'margin-top', '8px')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(str)
				]));
	}
};
var $author$project$Reusable$MultiSelect$viewLabel = function (label) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$aforemny$material_components_web_elm$Material$Typography$subtitle1,
				A2($elm$html$Html$Attributes$style, 'margin-top', '12px'),
				A2($elm$html$Html$Attributes$style, 'margin-bottom', '0px'),
				A2($elm$html$Html$Attributes$style, 'letter-spacing', 'inherit')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $author$project$Reusable$MultiSelect$viewList = function (listOfItems) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'flex-direction', 'column')
			]),
		listOfItems);
};
var $author$project$Reusable$MultiSelect$view = F2(
	function (config, items) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '100%')
				]),
			_List_fromArray(
				[
					$author$project$Reusable$MultiSelect$viewLabel(config.c9),
					$author$project$Reusable$MultiSelect$viewList(items),
					$author$project$Reusable$MultiSelect$viewHelpText(config.ld)
				]));
	});
var $author$project$Pages$LinkNewDevice$viewCheckbox = F5(
	function (model, hiddenCategories, onToggle, index, category) {
		var state = (!A2($elm$core$List$member, category.g8, hiddenCategories)) ? $aforemny$material_components_web_elm$Material$Checkbox$checked : $aforemny$material_components_web_elm$Material$Checkbox$unchecked;
		var onChange = A2(onToggle, hiddenCategories, category);
		return A2(
			$aforemny$material_components_web_elm$Material$FormField$formField,
			A2(
				$aforemny$material_components_web_elm$Material$FormField$setLabel,
				$elm$core$Maybe$Just(category.g8),
				$aforemny$material_components_web_elm$Material$FormField$config),
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$Checkbox$checkbox(
					A2(
						$aforemny$material_components_web_elm$Material$Checkbox$setOnChange,
						onChange,
						A2(
							$aforemny$material_components_web_elm$Material$Checkbox$setState,
							$elm$core$Maybe$Just(state),
							$aforemny$material_components_web_elm$Material$Checkbox$config)))
				]));
	});
var $author$project$Pages$LinkNewDevice$viewSelectCategories = F5(
	function (config, model, label, hiddenCategories, onToggle) {
		var _v0 = model.eU;
		switch (_v0.$) {
			case 0:
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[$aforemny$material_components_web_elm$Material$Typography$body1]),
					_List_fromArray(
						[
							$elm$html$Html$text('Select a location before proceeding.')
						]));
			case 1:
				return $aforemny$material_components_web_elm$Material$CircularProgress$indeterminate($aforemny$material_components_web_elm$Material$CircularProgress$config);
			case 2:
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[$aforemny$material_components_web_elm$Material$Typography$body1]),
					_List_fromArray(
						[
							$elm$html$Html$text('There was a problem loading the categories. Please try again.')
						]));
			case 3:
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[$aforemny$material_components_web_elm$Material$Typography$body1]),
					_List_fromArray(
						[
							$elm$html$Html$text('Empty list')
						]));
			default:
				var categories = _v0.a;
				var viewConfig = {
					ld: function () {
						if (!categories.b) {
							return $elm$core$Maybe$Just('Something went wrong. Menu Item Category list is empty.');
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}(),
					c9: label + ' Categories'
				};
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-bottom', '18px'),
							A2($elm$html$Html$Attributes$style, 'min-width', '250px')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Reusable$MultiSelect$view,
							viewConfig,
							A2(
								$elm$core$List$indexedMap,
								A3($author$project$Pages$LinkNewDevice$viewCheckbox, model, hiddenCategories, onToggle),
								categories))
						]));
		}
	});
var $author$project$Pages$LinkNewDevice$viewSelectCategoriesContainer = F2(
	function (config, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
					A2($elm$html$Html$Attributes$style, 'width', '100%'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '80%'),
							A2($elm$html$Html$Attributes$style, 'text-align', 'center')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Choose which menu item categories you would like to display on this device.' + 'Category information can be updated in the PrimeroEdge Menu Planning module.')
						])),
					A5($author$project$Pages$LinkNewDevice$viewSelectCategories, config, model, 'Breakfast', model.bs, $author$project$Pages$LinkNewDevice$SelectedBreakfastCategory),
					A5($author$project$Pages$LinkNewDevice$viewSelectCategories, config, model, 'Lunch', model.a3, $author$project$Pages$LinkNewDevice$SelectedLunchCategory),
					A5($author$project$Pages$LinkNewDevice$viewSelectCategories, config, model, 'Supper', model.bt, $author$project$Pages$LinkNewDevice$SelectedSupperCategory)
				]));
	});
var $author$project$Pages$LinkNewDevice$SelectMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$LinkNewDevice$SelectedSchool = F3(
	function (a, b, c) {
		return {$: 19, a: a, b: b, c: c};
	});
var $author$project$Select$Disabled = function (a) {
	return {$: 7, a: a};
};
var $author$project$Select$disabled = function (val) {
	return $author$project$Select$Disabled(val);
};
var $author$project$Select$entity = {
	dS: F2(
		function (a, b) {
			return _Utils_eq(
				function ($) {
					return $.aF;
				}(a),
				function ($) {
					return $.aF;
				}(b));
		}),
	d8: function ($) {
		return $.g8;
	},
	ep: function ($) {
		return $.g8;
	}
};
var $author$project$Pages$LinkNewDevice$viewSelectSchool = F2(
	function (config, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '300px')
				]),
			_List_fromArray(
				[
					A5(
					$author$project$Select$view,
					$author$project$Pages$LinkNewDevice$SelectMsg,
					_List_fromArray(
						[3]),
					model.r,
					$author$project$Select$entity,
					_List_fromArray(
						[
							$author$project$Select$label('Select Location'),
							$author$project$Select$searchable,
							$author$project$Select$options(config.aQ),
							$author$project$Select$value(model.du),
							$author$project$Select$onSelect(
							A2($author$project$Pages$LinkNewDevice$SelectedSchool, config.k.an, config.h5)),
							$author$project$Select$disabled(
							!$elm$core$List$length(config.aQ)),
							$author$project$Select$helpText(
							(!$elm$core$List$length(config.aQ)) ? $elm$core$Maybe$Just('No sites exist') : $elm$core$Maybe$Nothing)
						]))
				]));
	});
var $author$project$Pages$LinkNewDevice$BreakfastServingLine = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$LinkNewDevice$LunchServingLine = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$LinkNewDevice$SupperServingLine = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$LinkNewDevice$viewSelectServingLines = F2(
	function (model, lines) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '250px')
				]),
			_List_fromArray(
				[
					A5(
					$author$project$Select$view,
					$author$project$Pages$LinkNewDevice$SelectMsg,
					_List_fromArray(
						[0]),
					model.r,
					$author$project$Select$string,
					_List_fromArray(
						[
							$author$project$Select$label('Breakfast Serving Line(s)'),
							$author$project$Select$searchable,
							$author$project$Select$options(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.g8;
								},
								lines)),
							$author$project$Select$multiSelect,
							$author$project$Select$multiValue(model.bR.fp.jR),
							$author$project$Select$onMultiSelect($author$project$Pages$LinkNewDevice$BreakfastServingLine),
							$author$project$Select$disabled(
							!$elm$core$List$length(lines)),
							$author$project$Select$helpText(
							(!$elm$core$List$length(lines)) ? $elm$core$Maybe$Just('No serving lines available') : $elm$core$Maybe$Nothing)
						])),
					A5(
					$author$project$Select$view,
					$author$project$Pages$LinkNewDevice$SelectMsg,
					_List_fromArray(
						[1]),
					model.r,
					$author$project$Select$string,
					_List_fromArray(
						[
							$author$project$Select$label('Lunch Serving Line(s)'),
							$author$project$Select$searchable,
							$author$project$Select$options(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.g8;
								},
								lines)),
							$author$project$Select$multiSelect,
							$author$project$Select$multiValue(model.b9.fp.jR),
							$author$project$Select$onMultiSelect($author$project$Pages$LinkNewDevice$LunchServingLine),
							$author$project$Select$disabled(
							!$elm$core$List$length(lines)),
							$author$project$Select$helpText(
							(!$elm$core$List$length(lines)) ? $elm$core$Maybe$Just('No serving lines available') : $elm$core$Maybe$Nothing)
						])),
					A5(
					$author$project$Select$view,
					$author$project$Pages$LinkNewDevice$SelectMsg,
					_List_fromArray(
						[2]),
					model.r,
					$author$project$Select$string,
					_List_fromArray(
						[
							$author$project$Select$label('Supper Serving Line(s)'),
							$author$project$Select$searchable,
							$author$project$Select$options(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.g8;
								},
								lines)),
							$author$project$Select$multiSelect,
							$author$project$Select$multiValue(model.ct.fp.jR),
							$author$project$Select$onMultiSelect($author$project$Pages$LinkNewDevice$SupperServingLine),
							$author$project$Select$disabled(
							!$elm$core$List$length(lines)),
							$author$project$Select$helpText(
							(!$elm$core$List$length(lines)) ? $elm$core$Maybe$Just('No serving lines available') : $elm$core$Maybe$Nothing)
						]))
				]));
	});
var $author$project$Pages$LinkNewDevice$viewSelectServingLinesContainer = F2(
	function (config, model) {
		var _v0 = model.jR;
		switch (_v0.$) {
			case 4:
				var lines = _v0.a;
				return A2(
					$author$project$Pages$LinkNewDevice$viewSelectServingLines,
					model,
					A2($elm$core$List$cons, $author$project$Entity$ServingLine$allServingLinesOption, lines));
			case 2:
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[$aforemny$material_components_web_elm$Material$Typography$body1]),
					_List_fromArray(
						[
							$elm$html$Html$text('Failed to load the serving lines, try later')
						]));
			case 1:
				return $aforemny$material_components_web_elm$Material$CircularProgress$indeterminate($aforemny$material_components_web_elm$Material$CircularProgress$config);
			case 3:
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[$aforemny$material_components_web_elm$Material$Typography$body1]),
					_List_fromArray(
						[
							$elm$html$Html$text('Empty list')
						]));
			default:
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[$aforemny$material_components_web_elm$Material$Typography$body1]),
					_List_fromArray(
						[
							$elm$html$Html$text('Serving lines are not loaded yet')
						]));
		}
	});
var $author$project$Pages$LinkNewDevice$getStepContent = F2(
	function (config, model) {
		var _v0 = A2($author$project$Pages$LinkNewDevice$getCurrentStep, config, model);
		switch (_v0) {
			case 0:
				return A2($author$project$Pages$LinkNewDevice$viewInitialSetup, config.k, model);
			case 1:
				return $author$project$Pages$LinkNewDevice$viewActivationCode(model);
			case 2:
				return A2($author$project$Pages$LinkNewDevice$viewSelectSchool, config, model);
			case 3:
				return A2($author$project$Pages$LinkNewDevice$viewSelectCategoriesContainer, config, model);
			case 4:
				return A2($author$project$Pages$LinkNewDevice$viewSelectServingLinesContainer, config, model);
			case 5:
				return A2($author$project$Pages$LinkNewDevice$viewNameDevice, config, model);
			case 6:
				return $author$project$Pages$LinkNewDevice$viewReviewStep(model);
			default:
				return $author$project$Pages$LinkNewDevice$viewActivationStatusStep(model);
		}
	});
var $aforemny$material_components_web_elm$Material$CircularProgress$setClosed = F2(
	function (closed, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{gb: closed});
	});
var $author$project$Pages$LinkNewDevice$BackStep = {$: 4};
var $author$project$Pages$LinkNewDevice$viewBackButton = function (model) {
	var isDisabled = ($author$project$Pages$LinkNewDevice$toIntStep(model.w) < 4) || ((model.w === 7) || model.aH);
	return A2(
		$aforemny$material_components_web_elm$Material$Button$outlined,
		A2(
			$aforemny$material_components_web_elm$Material$Button$setAttributes,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'margin-right', '8px')
				]),
			A2(
				$aforemny$material_components_web_elm$Material$Button$setDisabled,
				isDisabled,
				A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$LinkNewDevice$BackStep, $aforemny$material_components_web_elm$Material$Button$config))),
		'Back');
};
var $author$project$Pages$LinkNewDevice$viewCancelButton = function (model) {
	var isDisabled = $author$project$Pages$LinkNewDevice$toIntStep(model.w) < 3;
	return A2(
		$aforemny$material_components_web_elm$Material$Button$raised,
		A2(
			$aforemny$material_components_web_elm$Material$Button$setDisabled,
			isDisabled,
			A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$LinkNewDevice$CancelActivation, $aforemny$material_components_web_elm$Material$Button$config)),
		'Start Over');
};
var $author$project$Pages$LinkNewDevice$ActivateDevice = function (a) {
	return {$: 27, a: a};
};
var $author$project$Pages$LinkNewDevice$viewNextButton = F2(
	function (config, model) {
		var onClick = (model.w === 6) ? $author$project$Pages$LinkNewDevice$ActivateDevice(
			$author$project$Pages$LinkNewDevice$getActivationPayload(model)) : $author$project$Pages$LinkNewDevice$NextStep(model.w);
		var label = (model.w === 6) ? 'Activate' : 'Next';
		var isCompletelyHidden = function (hiddenList) {
			var _v1 = model.eU;
			if (_v1.$ === 4) {
				var categories = _v1.a;
				return _Utils_eq(
					$elm$core$List$length(hiddenList),
					$elm$core$List$length(categories));
			} else {
				return false;
			}
		};
		var isDisabled = function () {
			var _v0 = model.w;
			switch (_v0) {
				case 1:
					return true;
				case 2:
					return _Utils_eq(model.du, $elm$core$Maybe$Nothing);
				case 7:
					return true;
				case 3:
					return isCompletelyHidden(model.bs) || (isCompletelyHidden(model.a3) || isCompletelyHidden(model.bt));
				case 5:
					return _Utils_eq(model.aC, $elm$core$Maybe$Nothing);
				default:
					return !model.en;
			}
		}();
		return A2(
			$aforemny$material_components_web_elm$Material$Button$outlined,
			A2(
				$aforemny$material_components_web_elm$Material$Button$setAttributes,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('next-button'),
						A2($elm$html$Html$Attributes$style, 'align-self', 'flex-end')
					]),
				A2(
					$aforemny$material_components_web_elm$Material$Button$setDisabled,
					isDisabled,
					A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config))),
			label);
	});
var $author$project$Pages$LinkNewDevice$toStringStep = function (step) {
	switch (step) {
		case 0:
			return 'Let\'s set up your new TV!';
		case 1:
			return 'Enter Activation Code';
		case 2:
			return 'Device Location';
		case 3:
			return 'Select Menu Item Categories';
		case 4:
			return 'Select Serving Lines';
		case 5:
			return 'Name Your Device';
		case 6:
			return 'Confirmation';
		default:
			return 'Status';
	}
};
var $author$project$Pages$LinkNewDevice$viewStepName = function (step) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('new-device-step-name')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Pages$LinkNewDevice$toStringStep(step))
			]));
};
var $author$project$Pages$LinkNewDevice$viewCurrentStep = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('stepper-current'),
			$elm$html$Html$Attributes$class('stepper-common')
		]),
	_List_Nil);
var $author$project$Pages$LinkNewDevice$viewStepDone = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('stepper-done'),
			$elm$html$Html$Attributes$class('stepper-common')
		]),
	_List_Nil);
var $author$project$Pages$LinkNewDevice$viewStepNotDone = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('stepper-not-done'),
			$elm$html$Html$Attributes$class('stepper-common')
		]),
	_List_Nil);
var $author$project$Pages$LinkNewDevice$viewStepStatus = function (step) {
	var stepNumber = $author$project$Pages$LinkNewDevice$toIntStep(step);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('stepper-root')
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2($elm$core$List$repeat, stepNumber - 1, $author$project$Pages$LinkNewDevice$viewStepDone),
					_List_fromArray(
					[$author$project$Pages$LinkNewDevice$viewCurrentStep]),
					A2($elm$core$List$repeat, 7 - stepNumber, $author$project$Pages$LinkNewDevice$viewStepNotDone)
				])));
};
var $author$project$Pages$LinkNewDevice$viewMainSection = F2(
	function (config, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('new-device-main-section-root')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('new-device-container'),
							$author$project$Mdl$Elevation$e4
						]),
					_List_fromArray(
						[
							$author$project$Pages$LinkNewDevice$viewStepName(
							A2($author$project$Pages$LinkNewDevice$getCurrentStep, config, model)),
							$author$project$Pages$LinkNewDevice$viewStepStatus(
							A2($author$project$Pages$LinkNewDevice$getCurrentStep, config, model)),
							A2($author$project$Pages$LinkNewDevice$getStepContent, config, model)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-top', '12px'),
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'justify-content', 'space-between'),
							A2($elm$html$Html$Attributes$style, 'width', '100%')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Pages$LinkNewDevice$viewCancelButton(model)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'display', 'flex'),
									A2($elm$html$Html$Attributes$style, 'align-items', 'center')
								]),
							_List_fromArray(
								[
									$aforemny$material_components_web_elm$Material$CircularProgress$indeterminate(
									A2($aforemny$material_components_web_elm$Material$CircularProgress$setClosed, !model.aH, $aforemny$material_components_web_elm$Material$CircularProgress$config)),
									$author$project$Pages$LinkNewDevice$viewBackButton(model),
									A2($author$project$Pages$LinkNewDevice$viewNextButton, config, model)
								])),
							A2(
							$aforemny$material_components_web_elm$Material$Snackbar$snackbar,
							$aforemny$material_components_web_elm$Material$Snackbar$config(
								{l1: $author$project$Pages$LinkNewDevice$SnackbarClosed}),
							model.cp)
						]))
				]));
	});
var $author$project$Pages$MenuItemList$CancelAddItem = {$: 27};
var $author$project$Pages$MenuItemList$NoOp = {$: 0};
var $author$project$Pages$MenuItemList$isItemNameValid = function (model) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Tuple$first,
		A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not))(model.V) && A2($author$project$Pages$MenuItemList$isItemNameUnique, model.V.a, model);
};
var $author$project$Pages$MenuItemList$prepareItemPayload = function (model) {
	var _v0 = A2($elm$core$Basics$composeL, $elm$core$String$toFloat, $elm$core$Tuple$first)(model.at);
	if (!_v0.$) {
		var price = _v0.a;
		return (!A2($elm$core$Basics$composeL, $elm$core$String$isEmpty, $elm$core$Tuple$first)(model.V)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(model.V.a, price)) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$MenuItemList$ItemName = function (a) {
	return {$: 28, a: a};
};
var $author$project$Pages$MenuItemList$viewItemNameField = function (model) {
	var errText = A2($elm$core$Maybe$withDefault, '', model.V.b);
	return A2(
		$author$project$Material$Local$textFieldWithErr,
		errText,
		$aforemny$material_components_web_elm$Material$TextField$outlined(
			A2(
				$aforemny$material_components_web_elm$Material$TextField$setAttributes,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$tabindex(0),
						A2($elm$html$Html$Attributes$style, 'width', '100%')
					]),
				A2(
					$aforemny$material_components_web_elm$Material$TextField$setValid,
					$elm$core$String$isEmpty(errText),
					A2(
						$aforemny$material_components_web_elm$Material$TextField$setOnInput,
						$author$project$Pages$MenuItemList$ItemName,
						A2(
							$aforemny$material_components_web_elm$Material$TextField$setValue,
							$elm$core$Maybe$Just(model.V.a),
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setLabel,
								$elm$core$Maybe$Just('Item Name'),
								$aforemny$material_components_web_elm$Material$TextField$config)))))));
};
var $author$project$Pages$MenuItemList$ItemPrice = function (a) {
	return {$: 29, a: a};
};
var $author$project$Pages$MenuItemList$viewItemPriceField = function (model) {
	var errText = function () {
		var _v0 = model.at.b;
		if (!_v0.$) {
			var err = _v0.a;
			return err;
		} else {
			return '';
		}
	}();
	return A2(
		$author$project$Material$Local$textFieldWithErr,
		errText,
		$aforemny$material_components_web_elm$Material$TextField$outlined(
			A2(
				$aforemny$material_components_web_elm$Material$TextField$setLeadingIcon,
				$elm$core$Maybe$Just(
					$aforemny$material_components_web_elm$Material$TextField$Icon$icon('attach_money')),
				A2(
					$aforemny$material_components_web_elm$Material$TextField$setAttributes,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '100%')
						]),
					A2(
						$aforemny$material_components_web_elm$Material$TextField$setValid,
						$elm$core$String$isEmpty(errText),
						A2(
							$aforemny$material_components_web_elm$Material$TextField$setLabel,
							$elm$core$Maybe$Just('Item Price'),
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setOnInput,
								$author$project$Pages$MenuItemList$ItemPrice,
								A2(
									$aforemny$material_components_web_elm$Material$TextField$setValue,
									$elm$core$Maybe$Just(model.at.a),
									$aforemny$material_components_web_elm$Material$TextField$config))))))));
};
var $author$project$Pages$MenuItemList$viewItemContent = function (model) {
	return $author$project$Reusable$Flex$viewVertical(
		_List_fromArray(
			[
				$author$project$Pages$MenuItemList$viewItemNameField(model),
				$author$project$Pages$MenuItemList$viewItemPriceField(model)
			]));
};
var $author$project$Pages$MenuItemList$viewAddItemDialog = F2(
	function (config, model) {
		var onClick = function () {
			var _v0 = _Utils_Tuple3(
				$author$project$Pages$MenuItemList$isItemNameValid(model),
				model.B,
				$author$project$Pages$MenuItemList$prepareItemPayload(model));
			if ((_v0.a && (!_v0.b.$)) && (!_v0.c.$)) {
				var id = _v0.b.a;
				var _v1 = _v0.c.a;
				var name = _v1.a;
				var price = _v1.b;
				return A4(
					$author$project$Pages$MenuItemList$AddNewItem,
					config.h5,
					id,
					0,
					_Utils_Tuple2(name, price));
			} else {
				return $author$project$Pages$MenuItemList$NoOp;
			}
		}();
		return A2(
			$aforemny$material_components_web_elm$Material$Dialog$dialog,
			A2(
				$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
				$author$project$Pages$MenuItemList$CancelAddItem,
				A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.cE, $aforemny$material_components_web_elm$Material$Dialog$config)),
			{
				kk: _List_fromArray(
					[
						A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2(
							$aforemny$material_components_web_elm$Material$Button$setAttributes,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'margin-right', '6px')
								]),
							A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$MenuItemList$CancelAddItem, $aforemny$material_components_web_elm$Material$Button$config)),
						'Close'),
						A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config),
						'Add Item')
					]),
				k_: _List_fromArray(
					[
						$author$project$Pages$MenuItemList$viewItemContent(model)
					]),
				na: $elm$core$Maybe$Just('Add New Item')
			});
	});
var $author$project$Pages$MenuItemList$AddNewList = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$MenuItemList$CancelNewList = {$: 5};
var $author$project$Pages$MenuItemList$isListNameValid = function (model) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Tuple$first,
		A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not))(model.E) && A2($author$project$Pages$MenuItemList$isListNameUnique, model.E.a, model);
};
var $author$project$Pages$MenuItemList$ListName = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$MenuItemList$viewListNameField = function (model) {
	var errText = A2($elm$core$Maybe$withDefault, '', model.E.b);
	return A2(
		$author$project$Material$Local$textFieldWithErr,
		errText,
		$aforemny$material_components_web_elm$Material$TextField$filled(
			A2(
				$aforemny$material_components_web_elm$Material$TextField$setAttributes,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$tabindex(0),
						A2($elm$html$Html$Attributes$style, 'width', '100%')
					]),
				A2(
					$aforemny$material_components_web_elm$Material$TextField$setValid,
					$elm$core$String$isEmpty(errText),
					A2(
						$aforemny$material_components_web_elm$Material$TextField$setOnInput,
						$author$project$Pages$MenuItemList$ListName,
						A2(
							$aforemny$material_components_web_elm$Material$TextField$setValue,
							$elm$core$Maybe$Just(model.E.a),
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setLabel,
								$elm$core$Maybe$Just('New List Name'),
								$aforemny$material_components_web_elm$Material$TextField$config)))))));
};
var $author$project$Pages$MenuItemList$viewAddListDialog = F2(
	function (config, model) {
		var confirmUpdate = (!A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$String$isEmpty)(model.E)) ? A2($author$project$Pages$MenuItemList$AddNewList, config.h5, model.E.a) : $author$project$Pages$MenuItemList$NoOp;
		return A2(
			$aforemny$material_components_web_elm$Material$Dialog$dialog,
			A2(
				$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
				$author$project$Pages$MenuItemList$CancelNewList,
				A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.bN, $aforemny$material_components_web_elm$Material$Dialog$config)),
			{
				kk: _List_fromArray(
					[
						A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2(
							$aforemny$material_components_web_elm$Material$Button$setAttributes,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'margin-right', '6px')
								]),
							A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$MenuItemList$CancelNewList, $aforemny$material_components_web_elm$Material$Button$config)),
						'Close'),
						A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2(
							$aforemny$material_components_web_elm$Material$Button$setDisabled,
							!$author$project$Pages$MenuItemList$isListNameValid(model),
							A2($aforemny$material_components_web_elm$Material$Button$setOnClick, confirmUpdate, $aforemny$material_components_web_elm$Material$Button$config)),
						'Add List')
					]),
				k_: _List_fromArray(
					[
						$author$project$Pages$MenuItemList$viewListNameField(model)
					]),
				na: $elm$core$Maybe$Just('New List')
			});
	});
var $author$project$Pages$MenuItemList$CancelDeleteItem = {$: 36};
var $author$project$Pages$MenuItemList$DeleteItem = F2(
	function (a, b) {
		return {$: 38, a: a, b: b};
	});
var $author$project$Pages$MenuItemList$viewDelItemDialog = F2(
	function (config, model) {
		var confirmDelete = function () {
			var _v0 = $author$project$Pages$MenuItemList$getMenuItem(model);
			if (!_v0.$) {
				var menuItem = _v0.a;
				return A2($author$project$Pages$MenuItemList$DeleteItem, config.h5, menuItem);
			} else {
				return $author$project$Pages$MenuItemList$NoOp;
			}
		}();
		return A2(
			$aforemny$material_components_web_elm$Material$Dialog$dialog,
			A2(
				$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
				$author$project$Pages$MenuItemList$CancelDeleteItem,
				A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.cS, $aforemny$material_components_web_elm$Material$Dialog$config)),
			{
				kk: _List_fromArray(
					[
						A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2(
							$aforemny$material_components_web_elm$Material$Button$setAttributes,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'margin-right', '6px')
								]),
							A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$MenuItemList$CancelDeleteItem, $aforemny$material_components_web_elm$Material$Button$config)),
						'Close'),
						A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2($aforemny$material_components_web_elm$Material$Button$setOnClick, confirmDelete, $aforemny$material_components_web_elm$Material$Button$config),
						'Confirm Delete')
					]),
				k_: _List_fromArray(
					[
						$elm$html$Html$text('Are you sure you want to delete the item')
					]),
				na: $elm$core$Maybe$Just('Delete Item')
			});
	});
var $author$project$Pages$MenuItemList$CancelDeleteList = {$: 21};
var $author$project$Pages$MenuItemList$DeleteMenuItemList = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Pages$MenuItemList$viewDelListDialog = F2(
	function (config, model) {
		return A2(
			$aforemny$material_components_web_elm$Material$Dialog$dialog,
			A2(
				$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
				$author$project$Pages$MenuItemList$CancelDeleteList,
				A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.cT, $aforemny$material_components_web_elm$Material$Dialog$config)),
			{
				kk: _List_fromArray(
					[
						A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2(
							$aforemny$material_components_web_elm$Material$Button$setAttributes,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'margin-right', '6px')
								]),
							A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$MenuItemList$CancelDeleteList, $aforemny$material_components_web_elm$Material$Button$config)),
						'Close'),
						function () {
						var onClick = function () {
							var _v0 = model.B;
							if (!_v0.$) {
								var listId = _v0.a;
								return A2($author$project$Pages$MenuItemList$DeleteMenuItemList, config.h5, listId);
							} else {
								return $author$project$Pages$MenuItemList$NoOp;
							}
						}();
						return A2(
							$aforemny$material_components_web_elm$Material$Button$outlined,
							A2(
								$aforemny$material_components_web_elm$Material$Button$setDisabled,
								_Utils_eq(model.B, $elm$core$Maybe$Nothing),
								A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config)),
							'Delete');
					}()
					]),
				k_: _List_fromArray(
					[
						$elm$html$Html$text('Are you sure do you want to delete the selected item list')
					]),
				na: $elm$core$Maybe$Just('Delete Item List')
			});
	});
var $author$project$Pages$MenuItemList$CancelDuplicateList = {$: 15};
var $author$project$Pages$MenuItemList$DuplicateList = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Pages$MenuItemList$viewDuplicateListDialog = F2(
	function (config, model) {
		var onClick = function () {
			var _v0 = _Utils_Tuple2(
				$author$project$Pages$MenuItemList$getMenuItemList(model),
				model.E);
			if ((!_v0.a.$) && (_v0.b.b.$ === 1)) {
				var itemList = _v0.a.a;
				var _v1 = _v0.b;
				var listName = _v1.a;
				var _v2 = _v1.b;
				return A2(
					$author$project$Pages$MenuItemList$DuplicateList,
					config.h5,
					_Utils_update(
						itemList,
						{g8: listName}));
			} else {
				return $author$project$Pages$MenuItemList$NoOp;
			}
		}();
		return A2(
			$aforemny$material_components_web_elm$Material$Dialog$dialog,
			A2(
				$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
				$author$project$Pages$MenuItemList$CancelDuplicateList,
				A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.cX, $aforemny$material_components_web_elm$Material$Dialog$config)),
			{
				kk: _List_fromArray(
					[
						A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2(
							$aforemny$material_components_web_elm$Material$Button$setAttributes,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'margin-right', '6px')
								]),
							A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$MenuItemList$CancelDuplicateList, $aforemny$material_components_web_elm$Material$Button$config)),
						'Close'),
						A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config),
						'Duplicate')
					]),
				k_: _List_fromArray(
					[
						$author$project$Pages$MenuItemList$viewListNameField(model)
					]),
				na: $elm$core$Maybe$Just('Duplicate List')
			});
	});
var $author$project$Pages$MenuItemList$CancelEditItem = {$: 33};
var $author$project$Pages$MenuItemList$ConfirmItem = F2(
	function (a, b) {
		return {$: 34, a: a, b: b};
	});
var $author$project$Pages$MenuItemList$viewEditItemDialog = F2(
	function (config, model) {
		var confirmEdit = function () {
			var _v0 = _Utils_Tuple2(
				$author$project$Pages$MenuItemList$getMenuItem(model),
				$author$project$Pages$MenuItemList$prepareItemPayload(model));
			if ((!_v0.a.$) && (!_v0.b.$)) {
				var menuItem = _v0.a.a;
				var _v1 = _v0.b.a;
				var name = _v1.a;
				var price = _v1.b;
				return A2(
					$author$project$Pages$MenuItemList$ConfirmItem,
					config.h5,
					_Utils_update(
						menuItem,
						{g8: name, ju: price}));
			} else {
				return $author$project$Pages$MenuItemList$NoOp;
			}
		}();
		return A2(
			$aforemny$material_components_web_elm$Material$Dialog$dialog,
			A2(
				$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
				$author$project$Pages$MenuItemList$CancelEditItem,
				A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.cY, $aforemny$material_components_web_elm$Material$Dialog$config)),
			{
				kk: _List_fromArray(
					[
						A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2(
							$aforemny$material_components_web_elm$Material$Button$setAttributes,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'margin-right', '6px')
								]),
							A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$MenuItemList$CancelEditItem, $aforemny$material_components_web_elm$Material$Button$config)),
						'Close'),
						A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2($aforemny$material_components_web_elm$Material$Button$setOnClick, confirmEdit, $aforemny$material_components_web_elm$Material$Button$config),
						'Confirm Edit')
					]),
				k_: _List_fromArray(
					[
						$author$project$Pages$MenuItemList$viewItemContent(model)
					]),
				na: $elm$core$Maybe$Just('Edit Item')
			});
	});
var $author$project$Pages$MenuItemList$CancelEditListName = {$: 9};
var $author$project$Pages$MenuItemList$ConfirmListName = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Pages$MenuItemList$viewEditListDialog = F2(
	function (config, model) {
		var isDisabled = _Utils_eq(model.B, $elm$core$Maybe$Nothing) || ((!_Utils_eq(model.E.b, $elm$core$Maybe$Nothing)) || (!$author$project$Pages$MenuItemList$isListNameValid(model)));
		var confirmUpdate = function () {
			var _v0 = _Utils_Tuple2(model.g1, model.B);
			if ((_v0.a.$ === 4) && (!_v0.b.$)) {
				var data = _v0.a.a;
				var listId = _v0.b.a;
				return A2(
					$author$project$Pages$MenuItemList$ConfirmListName,
					config.h5,
					A2($elm$core$Dict$get, listId, data));
			} else {
				return $author$project$Pages$MenuItemList$NoOp;
			}
		}();
		return A2(
			$aforemny$material_components_web_elm$Material$Dialog$dialog,
			A2(
				$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
				$author$project$Pages$MenuItemList$CancelEditListName,
				A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.cZ, $aforemny$material_components_web_elm$Material$Dialog$config)),
			{
				kk: _List_fromArray(
					[
						A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2(
							$aforemny$material_components_web_elm$Material$Button$setAttributes,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'margin-right', '6px')
								]),
							A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$MenuItemList$CancelEditListName, $aforemny$material_components_web_elm$Material$Button$config)),
						'Close'),
						A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2(
							$aforemny$material_components_web_elm$Material$Button$setDisabled,
							isDisabled,
							A2($aforemny$material_components_web_elm$Material$Button$setOnClick, confirmUpdate, $aforemny$material_components_web_elm$Material$Button$config)),
						'Update')
					]),
				k_: _List_fromArray(
					[
						$author$project$Pages$MenuItemList$viewListNameField(model)
					]),
				na: $elm$core$Maybe$Just('Edit Name')
			});
	});
var $author$project$Pages$MenuItemList$InitAddItem = {$: 26};
var $aforemny$material_components_web_elm$Material$Theme$primary = $elm$html$Html$Attributes$class('mdc-theme--primary');
var $author$project$Pages$MenuItemList$viewAddNewItem = function (model) {
	var isDisabled = _Utils_eq(model.B, $elm$core$Maybe$Nothing);
	return A2(
		$aforemny$material_components_web_elm$Material$Button$outlined,
		A2(
			$aforemny$material_components_web_elm$Material$Button$setAttributes,
			_List_fromArray(
				[$aforemny$material_components_web_elm$Material$Theme$primary]),
			A2(
				$aforemny$material_components_web_elm$Material$Button$setDisabled,
				isDisabled,
				A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$MenuItemList$InitAddItem, $aforemny$material_components_web_elm$Material$Button$config))),
		'Add New Item');
};
var $author$project$Pages$MenuItemList$InitDeleteList = {$: 18};
var $author$project$Pages$MenuItemList$InitEditList = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$MenuItemList$Tooltip = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$MenuItemList$viewListName = F3(
	function (config, model, menuItemList) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'justify-content', 'space-between'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
					A2($elm$html$Html$Attributes$style, 'padding', '6px 0px'),
					A2($elm$html$Html$Attributes$style, 'width', '98%')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'font-size', '24px'),
							A2($elm$html$Html$Attributes$style, 'font-weight', '500')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(menuItemList.g8)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A5(
							$author$project$Reusable$Tooltip$view,
							$author$project$Pages$MenuItemList$Tooltip,
							_List_fromArray(
								[406]),
							model.fQ,
							_List_fromArray(
								[
									$author$project$Reusable$Tooltip$label('Edit')
								]),
							A2(
								$aforemny$material_components_web_elm$Material$IconButton$iconButton,
								A2(
									$aforemny$material_components_web_elm$Material$IconButton$setOnClick,
									$author$project$Pages$MenuItemList$InitEditList(menuItemList.g8),
									$aforemny$material_components_web_elm$Material$IconButton$config),
								$aforemny$material_components_web_elm$Material$IconButton$icon('edit'))),
							A5(
							$author$project$Reusable$Tooltip$view,
							$author$project$Pages$MenuItemList$Tooltip,
							_List_fromArray(
								[606]),
							model.fQ,
							_List_fromArray(
								[
									$author$project$Reusable$Tooltip$label('New Item')
								]),
							A2(
								$aforemny$material_components_web_elm$Material$IconButton$iconButton,
								A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, $author$project$Pages$MenuItemList$InitAddItem, $aforemny$material_components_web_elm$Material$IconButton$config),
								$aforemny$material_components_web_elm$Material$IconButton$icon('add_box'))),
							A5(
							$author$project$Reusable$Tooltip$view,
							$author$project$Pages$MenuItemList$Tooltip,
							_List_fromArray(
								[407]),
							model.fQ,
							_List_fromArray(
								[
									$author$project$Reusable$Tooltip$label('Delete')
								]),
							A2(
								$aforemny$material_components_web_elm$Material$IconButton$iconButton,
								A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, $author$project$Pages$MenuItemList$InitDeleteList, $aforemny$material_components_web_elm$Material$IconButton$config),
								$aforemny$material_components_web_elm$Material$IconButton$icon('delete')))
						]))
				]));
	});
var $author$project$Reusable$Card$viewMainCard = function (nodes) {
	return $rtfeldman$elm_css$Html$Styled$toUnstyled(
		A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled($author$project$Mdl$Elevation$e2),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$pct(96.5)),
							$rtfeldman$elm_css$Css$padding(
							$rtfeldman$elm_css$Css$px(12)),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$px(8)),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$borderRadius(
							$rtfeldman$elm_css$Css$px(8))
						]))
				]),
			A2($elm$core$List$map, $rtfeldman$elm_css$Html$Styled$fromUnstyled, nodes)));
};
var $author$project$Pages$MenuItemList$alignLeft = A2($elm$html$Html$Attributes$style, 'text-align', 'left');
var $aforemny$material_components_web_elm$Material$DataTable$Cell = function (a) {
	return {$: 0, a: a};
};
var $aforemny$material_components_web_elm$Material$DataTable$cell = F2(
	function (attributes, nodes) {
		return $aforemny$material_components_web_elm$Material$DataTable$Cell(
			{eP: attributes, ft: nodes, fv: false});
	});
var $aforemny$material_components_web_elm$Material$DataTable$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$DataTable$config = {fZ: _List_Nil, c9: $elm$core$Maybe$Nothing};
var $aforemny$material_components_web_elm$Material$DataTable$ariaLabelAttr = function (_v0) {
	var label = _v0.c9;
	return A2(
		$elm$core$Maybe$map,
		$elm$html$Html$Attributes$attribute('aria-label'),
		label);
};
var $aforemny$material_components_web_elm$Material$DataTable$dataTableCellCheckboxCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-data-table__cell--checkbox'));
var $aforemny$material_components_web_elm$Material$DataTable$dataTableCellCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-data-table__cell'));
var $aforemny$material_components_web_elm$Material$DataTable$dataTableCellNumericCs = function (numeric) {
	return numeric ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-data-table__cell--numeric')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$DataTable$bodyCell = function (cell_) {
	if (!cell_.$) {
		var numeric = cell_.a.fv;
		var attributes = cell_.a.eP;
		var nodes = cell_.a.ft;
		return A2(
			$elm$html$Html$td,
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$DataTable$dataTableCellCs,
							$aforemny$material_components_web_elm$Material$DataTable$dataTableCellNumericCs(numeric)
						])),
				attributes),
			nodes);
	} else {
		var attributes = cell_.a.eP;
		var config_ = cell_.a.ge;
		return A2(
			$elm$html$Html$td,
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[$aforemny$material_components_web_elm$Material$DataTable$dataTableCellCs, $aforemny$material_components_web_elm$Material$DataTable$dataTableCellCheckboxCs])),
				attributes),
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$Checkbox$checkbox(
					function () {
						var config__ = config_;
						return _Utils_update(
							config__,
							{
								fZ: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('mdc-data-table__row-checkbox'),
									config__.fZ)
							});
					}())
				]));
	}
};
var $aforemny$material_components_web_elm$Material$DataTable$dataTableRowCs = $elm$html$Html$Attributes$class('mdc-data-table__row');
var $aforemny$material_components_web_elm$Material$DataTable$bodyRow = function (_v0) {
	var attributes = _v0.eP;
	var nodes = _v0.ft;
	return A2(
		$elm$html$Html$tr,
		A2($elm$core$List$cons, $aforemny$material_components_web_elm$Material$DataTable$dataTableRowCs, attributes),
		A2($elm$core$List$map, $aforemny$material_components_web_elm$Material$DataTable$bodyCell, nodes));
};
var $aforemny$material_components_web_elm$Material$DataTable$dataTableContentCs = $elm$html$Html$Attributes$class('mdc-data-table__content');
var $aforemny$material_components_web_elm$Material$DataTable$dataTableCs = $elm$html$Html$Attributes$class('mdc-data-table');
var $aforemny$material_components_web_elm$Material$DataTable$dataTableTableCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-data-table__table'));
var $aforemny$material_components_web_elm$Material$DataTable$dataTableHeaderRowCs = $elm$html$Html$Attributes$class('mdc-data-table__header-row');
var $aforemny$material_components_web_elm$Material$DataTable$colScopeAttr = $elm$core$Maybe$Just(
	A2($elm$html$Html$Attributes$attribute, 'scope', 'col'));
var $aforemny$material_components_web_elm$Material$DataTable$columnHeaderRoleAttr = $elm$core$Maybe$Just(
	A2($elm$html$Html$Attributes$attribute, 'role', 'columnheader'));
var $aforemny$material_components_web_elm$Material$DataTable$dataTableHeaderCellCheckboxCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-data-table__header-cell--checkbox'));
var $aforemny$material_components_web_elm$Material$DataTable$dataTableHeaderCellCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-data-table__header-cell'));
var $aforemny$material_components_web_elm$Material$DataTable$dataTableHeaderCellNumericCs = function (numeric) {
	return numeric ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-data-table__header-cell--numeric')) : $elm$core$Maybe$Nothing;
};
var $elm$html$Html$th = _VirtualDom_node('th');
var $aforemny$material_components_web_elm$Material$DataTable$headerCell = function (cell_) {
	if (!cell_.$) {
		var numeric = cell_.a.fv;
		var attributes = cell_.a.eP;
		var nodes = cell_.a.ft;
		return A2(
			$elm$html$Html$th,
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$DataTable$dataTableHeaderCellCs,
							$aforemny$material_components_web_elm$Material$DataTable$columnHeaderRoleAttr,
							$aforemny$material_components_web_elm$Material$DataTable$colScopeAttr,
							$aforemny$material_components_web_elm$Material$DataTable$dataTableHeaderCellNumericCs(numeric)
						])),
				attributes),
			nodes);
	} else {
		var attributes = cell_.a.eP;
		var config_ = cell_.a.ge;
		return A2(
			$elm$html$Html$th,
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[$aforemny$material_components_web_elm$Material$DataTable$dataTableHeaderCellCs, $aforemny$material_components_web_elm$Material$DataTable$columnHeaderRoleAttr, $aforemny$material_components_web_elm$Material$DataTable$colScopeAttr, $aforemny$material_components_web_elm$Material$DataTable$dataTableHeaderCellCheckboxCs])),
				attributes),
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$Checkbox$checkbox(
					function () {
						var config__ = config_;
						return _Utils_update(
							config__,
							{
								fZ: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('mdc-data-table__row-checkbox'),
									config__.fZ)
							});
					}())
				]));
	}
};
var $aforemny$material_components_web_elm$Material$DataTable$headerRow = function (_v0) {
	var attributes = _v0.eP;
	var nodes = _v0.ft;
	return A2(
		$elm$html$Html$tr,
		A2($elm$core$List$cons, $aforemny$material_components_web_elm$Material$DataTable$dataTableHeaderRowCs, attributes),
		A2($elm$core$List$map, $aforemny$material_components_web_elm$Material$DataTable$headerCell, nodes));
};
var $aforemny$material_components_web_elm$Material$DataTable$dataTable = F2(
	function (config_, _v0) {
		var additionalAttributes = config_.fZ;
		var thead = _v0.m7;
		var tbody = _v0.mQ;
		return A3(
			$elm$html$Html$node,
			'mdc-data-table',
			A2($elm$core$List$cons, $aforemny$material_components_web_elm$Material$DataTable$dataTableCs, additionalAttributes),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$table,
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$aforemny$material_components_web_elm$Material$DataTable$dataTableTableCs,
								$aforemny$material_components_web_elm$Material$DataTable$ariaLabelAttr(config_)
							])),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_Nil,
							A2($elm$core$List$map, $aforemny$material_components_web_elm$Material$DataTable$headerRow, thead)),
							A2(
							$elm$html$Html$tbody,
							_List_fromArray(
								[$aforemny$material_components_web_elm$Material$DataTable$dataTableContentCs]),
							A2($elm$core$List$map, $aforemny$material_components_web_elm$Material$DataTable$bodyRow, tbody))
						]))
				]));
	});
var $aforemny$material_components_web_elm$Material$DataTable$Row = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$DataTable$row = F2(
	function (attributes, nodes) {
		return {eP: attributes, ft: nodes};
	});
var $aforemny$material_components_web_elm$Material$DataTable$setAttributes = F2(
	function (additionalAttributes, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{fZ: additionalAttributes});
	});
var $author$project$Pages$MenuItemList$InitDeleteItem = function (a) {
	return {$: 35, a: a};
};
var $author$project$Pages$MenuItemList$InitEditItem = function (a) {
	return {$: 32, a: a};
};
var $author$project$Pages$MenuItemList$viewMenuItem = F6(
	function (config, model, listId, i, j, _v0) {
		var itemId = _v0.a;
		var menuItem = _v0.b;
		return A2(
			$aforemny$material_components_web_elm$Material$DataTable$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$DataTable$cell,
					_List_fromArray(
						[
							$author$project$Pages$MenuItemList$alignLeft,
							A2($elm$html$Html$Attributes$style, 'width', '50%')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(menuItem.g8)
						])),
					A2(
					$aforemny$material_components_web_elm$Material$DataTable$cell,
					_List_fromArray(
						[
							$author$project$Pages$MenuItemList$alignLeft,
							A2($elm$html$Html$Attributes$style, 'width', '50%')
						]),
					_List_fromArray(
						[
							function () {
							var index = _List_fromArray(
								[i, j, 3]);
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'display', 'flex')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'margin-right', '6px')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												'$  ' + A2($myrho$elm_round$Round$round, 2, menuItem.ju))
											]))
									]));
						}()
						])),
					A2(
					$aforemny$material_components_web_elm$Material$DataTable$cell,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'align-text', 'center')
						]),
					_List_fromArray(
						[
							A5(
							$author$project$Reusable$Tooltip$view,
							$author$project$Pages$MenuItemList$Tooltip,
							_List_fromArray(
								[i, j, 22]),
							model.fQ,
							_List_fromArray(
								[
									$author$project$Reusable$Tooltip$label('Edit')
								]),
							A2(
								$aforemny$material_components_web_elm$Material$IconButton$iconButton,
								A2(
									$aforemny$material_components_web_elm$Material$IconButton$setOnClick,
									$author$project$Pages$MenuItemList$InitEditItem(menuItem),
									$aforemny$material_components_web_elm$Material$IconButton$config),
								$aforemny$material_components_web_elm$Material$IconButton$icon('edit'))),
							A5(
							$author$project$Reusable$Tooltip$view,
							$author$project$Pages$MenuItemList$Tooltip,
							_List_fromArray(
								[i, j, 20]),
							model.fQ,
							_List_fromArray(
								[
									$author$project$Reusable$Tooltip$label('Delete')
								]),
							A2(
								$aforemny$material_components_web_elm$Material$IconButton$iconButton,
								A2(
									$aforemny$material_components_web_elm$Material$IconButton$setOnClick,
									$author$project$Pages$MenuItemList$InitDeleteItem(menuItem.aF),
									$aforemny$material_components_web_elm$Material$IconButton$config),
								$aforemny$material_components_web_elm$Material$IconButton$icon('delete')))
						]))
				]));
	});
var $author$project$Pages$MenuItemList$viewMenuItemTable = F4(
	function (config, model, index, _v0) {
		var listId = _v0.a;
		var menuItemList = _v0.b;
		return $elm$core$Dict$isEmpty(menuItemList.lM) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[$aforemny$material_components_web_elm$Material$Typography$body1]),
			_List_fromArray(
				[
					$elm$html$Html$text('There are no items in this list.')
				])) : A2(
			$aforemny$material_components_web_elm$Material$DataTable$dataTable,
			A2(
				$aforemny$material_components_web_elm$Material$DataTable$setAttributes,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', '100%')
					]),
				$aforemny$material_components_web_elm$Material$DataTable$config),
			{
				mQ: A2(
					$elm$core$List$indexedMap,
					A4($author$project$Pages$MenuItemList$viewMenuItem, config, model, listId, index),
					A2(
						$elm$core$List$sortBy,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$second,
							function ($) {
								return $.g8;
							}),
						$elm$core$Dict$toList(menuItemList.lM))),
				m7: _List_fromArray(
					[
						A2(
						$aforemny$material_components_web_elm$Material$DataTable$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$aforemny$material_components_web_elm$Material$DataTable$cell,
								_List_fromArray(
									[$author$project$Pages$MenuItemList$alignLeft]),
								_List_fromArray(
									[
										$elm$html$Html$text('Name')
									])),
								A2(
								$aforemny$material_components_web_elm$Material$DataTable$cell,
								_List_fromArray(
									[$author$project$Pages$MenuItemList$alignLeft]),
								_List_fromArray(
									[
										$elm$html$Html$text('Price')
									])),
								A2(
								$aforemny$material_components_web_elm$Material$DataTable$cell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Actions')
									]))
							]))
					])
			});
	});
var $author$project$Pages$MenuItemList$viewMenuItemList = F4(
	function (config, model, index, _v0) {
		var itemId = _v0.a;
		var menuItemList = _v0.b;
		return $author$project$Reusable$Card$viewMainCard(
			_List_fromArray(
				[
					A3($author$project$Pages$MenuItemList$viewListName, config, model, menuItemList),
					A4(
					$author$project$Pages$MenuItemList$viewMenuItemTable,
					config,
					model,
					index,
					_Utils_Tuple2(itemId, menuItemList)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-top', '12px')
						]),
					_List_fromArray(
						[
							$author$project$Pages$MenuItemList$viewAddNewItem(model)
						]))
				]));
	});
var $author$project$Pages$MenuItemList$PublishList = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Pages$MenuItemList$viewPublishChangesButton = F2(
	function (config, model) {
		var onClick = function () {
			var _v0 = model.B;
			if (!_v0.$) {
				var listId = _v0.a;
				return A2($author$project$Pages$MenuItemList$PublishList, config.ao, listId);
			} else {
				return $author$project$Pages$MenuItemList$NoOp;
			}
		}();
		return A2(
			$aforemny$material_components_web_elm$Material$Button$outlined,
			A2(
				$aforemny$material_components_web_elm$Material$Button$setAttributes,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'margin-top', '6px')
					]),
				A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config)),
			'Publish Changes');
	});
var $author$project$Pages$MenuItemList$Select = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$MenuItemList$SelectItemList = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$MenuItemList$viewSelectList = F2(
	function (config, model) {
		return A5(
			$author$project$Select$view,
			$author$project$Pages$MenuItemList$Select,
			_List_fromArray(
				[0]),
			model.r,
			$author$project$Select$entity,
			_List_fromArray(
				[
					$author$project$Select$label('Select Menu Item List'),
					$author$project$Select$searchable,
					$author$project$Select$value(
					function () {
						var _v0 = _Utils_Tuple2(model.g1, model.B);
						if ((_v0.a.$ === 4) && (!_v0.b.$)) {
							var data = _v0.a.a;
							var listId = _v0.b.a;
							return A2($elm$core$Dict$get, listId, data);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}()),
					$author$project$Select$onSelect($author$project$Pages$MenuItemList$SelectItemList),
					$author$project$Select$options(
					function () {
						var _v1 = model.g1;
						if (_v1.$ === 4) {
							var data = _v1.a;
							return $elm$core$Dict$values(data);
						} else {
							return _List_Nil;
						}
					}()),
					$author$project$Select$helpText(
					function () {
						var _v2 = model.g1;
						switch (_v2.$) {
							case 0:
								return $elm$core$Maybe$Just('About to load list');
							case 3:
								return $elm$core$Maybe$Just('No items available');
							case 1:
								return $elm$core$Maybe$Just('Loading...');
							case 4:
								var data = _v2.a;
								return $elm$core$Maybe$Nothing;
							default:
								return $elm$core$Maybe$Just('Error loading, refresh');
						}
					}())
				]));
	});
var $author$project$Pages$MenuItemList$viewTaskBar = F2(
	function (config, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Mdl$Elevation$e2,
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'padding', '12px 12px 0px 12px'),
					A2($elm$html$Html$Attributes$style, 'justify-content', 'space-between'),
					A2($elm$html$Html$Attributes$style, 'margin-bottom', '8px'),
					A2($elm$html$Html$Attributes$style, 'position', 'sticky'),
					A2($elm$html$Html$Attributes$style, 'background', '#FFFFFF'),
					A2($elm$html$Html$Attributes$style, 'top', '76px'),
					A2($elm$html$Html$Attributes$style, 'z-index', '2'),
					A2($elm$html$Html$Attributes$style, 'border-radius', '8px'),
					A2($elm$html$Html$Attributes$style, 'flex-wrap', 'wrap')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '300px')
						]),
					_List_fromArray(
						[
							A2($author$project$Pages$MenuItemList$viewSelectList, config, model)
						])),
					A2($author$project$Pages$MenuItemList$viewPublishChangesButton, config, model)
				]));
	});
var $author$project$Pages$MenuItemList$viewMainSection = F2(
	function (config, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Pages$MenuItemList$viewTaskBar, config, model),
					function () {
					var _v0 = _Utils_Tuple2(model.g1, model.B);
					if (!_v0.b.$) {
						if (_v0.a.$ === 4) {
							var data = _v0.a.a;
							var listId = _v0.b.a;
							var _v1 = A2($elm$core$Dict$get, listId, data);
							if (!_v1.$) {
								var itemList = _v1.a;
								return A4(
									$author$project$Pages$MenuItemList$viewMenuItemList,
									config,
									model,
									0,
									_Utils_Tuple2(itemList.aF, itemList));
							} else {
								return A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$aforemny$material_components_web_elm$Material$Typography$body1,
											$author$project$Mdl$Elevation$e4,
											A2($elm$html$Html$Attributes$style, 'padding', '16px')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Unable to find the menu item list')
										]));
							}
						} else {
							return A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$aforemny$material_components_web_elm$Material$Typography$body1,
										$author$project$Mdl$Elevation$e4,
										A2($elm$html$Html$Attributes$style, 'padding', '16px')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Something went wrong')
									]));
						}
					} else {
						var _v2 = _v0.b;
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$aforemny$material_components_web_elm$Material$Typography$body1,
									$author$project$Mdl$Elevation$e4,
									A2($elm$html$Html$Attributes$style, 'padding', '16px')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Please select a menu item list.')
								]));
					}
				}(),
					A2($author$project$Pages$MenuItemList$viewAddListDialog, config, model),
					A2($author$project$Pages$MenuItemList$viewEditListDialog, config, model),
					A2($author$project$Pages$MenuItemList$viewDelListDialog, config, model),
					A2($author$project$Pages$MenuItemList$viewDuplicateListDialog, config, model),
					A2($author$project$Pages$MenuItemList$viewAddItemDialog, config, model),
					A2($author$project$Pages$MenuItemList$viewEditItemDialog, config, model),
					A2($author$project$Pages$MenuItemList$viewDelItemDialog, config, model)
				]));
	});
var $author$project$Pages$SyncDevices$centerDiv = function (node) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'width', '100%'),
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
				A2($elm$html$Html$Attributes$style, 'align-items', 'center')
			]),
		_List_fromArray(
			[node]));
};
var $author$project$Pages$SyncDevices$CloseConfirmSyncDialog = {$: 18};
var $author$project$Pages$SyncDevices$ImportData = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$SyncDevices$viewConfirmSync = F2(
	function (config, model) {
		var confirmSync = function () {
			var _v0 = model.bk.b;
			if (!_v0.$) {
				var dev = _v0.a;
				return $author$project$Pages$SyncDevices$ImportData(
					A2($elm$core$Dict$get, dev.aF, config.ao));
			} else {
				return $author$project$Pages$SyncDevices$NoOp;
			}
		}();
		return A2(
			$aforemny$material_components_web_elm$Material$Dialog$dialog,
			A2(
				$aforemny$material_components_web_elm$Material$Dialog$setOnClose,
				$author$project$Pages$SyncDevices$CloseConfirmSyncDialog,
				A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, model.bk.a, $aforemny$material_components_web_elm$Material$Dialog$config)),
			{
				kk: _List_fromArray(
					[
						A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$SyncDevices$CloseConfirmSyncDialog, $aforemny$material_components_web_elm$Material$Button$config),
						'Cancel'),
						A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2($aforemny$material_components_web_elm$Material$Button$setOnClick, confirmSync, $aforemny$material_components_web_elm$Material$Button$config),
						'Confirm Sync')
					]),
				k_: _List_fromArray(
					[
						$elm$html$Html$text('You are about to sync data between devices from ' + ('different schools, data such as serving lines and meal categories ' + ('may not be the same. This can cause templates to not display menu items as expected. ' + 'Are you sure you want to continue ?')))
					]),
				na: $elm$core$Maybe$Just('Confirm Sync')
			});
	});
var $author$project$Pages$SyncDevices$SelectExportDevices = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$SyncDevices$SelectMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$SyncDevices$filterDevices = F2(
	function (model, devices) {
		return A2(
			$elm$core$List$filter,
			$author$project$Pages$SyncDevices$isDeviceOnline,
			$elm$core$Dict$values(devices));
	});
var $author$project$Select$GroupBy = function (a) {
	return {$: 15, a: a};
};
var $author$project$Select$groupBy = function (toKey) {
	return $author$project$Select$GroupBy(
		$elm$core$Maybe$Just(toKey));
};
var $author$project$Pages$SyncDevices$viewExportTo = F2(
	function (config, model) {
		return A5(
			$author$project$Select$view,
			$author$project$Pages$SyncDevices$SelectMsg,
			_List_fromArray(
				[2]),
			model.r,
			$author$project$Select$entity,
			_List_fromArray(
				[
					$author$project$Select$label('Sync To'),
					$author$project$Select$searchable,
					$author$project$Select$rootStyle(
					_List_fromArray(
						[
							_Utils_Tuple2('width', '270px'),
							_Utils_Tuple2('margin-top', '12px')
						])),
					$author$project$Select$multiSelect,
					$author$project$Select$groupBy(
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.du;
						},
						function ($) {
							return $.g8;
						})),
					$author$project$Select$options(
					A2(
						$elm$core$List$filter,
						function (dev) {
							var _v0 = model.ar;
							if (!_v0.$) {
								var impD = _v0.a;
								return !_Utils_eq(impD.aF, dev.aF);
							} else {
								return true;
							}
						},
						A2($author$project$Pages$SyncDevices$filterDevices, model, config.ao))),
					$author$project$Select$multiValue(model.X),
					$author$project$Select$onMultiSelect($author$project$Pages$SyncDevices$SelectExportDevices)
				]));
	});
var $author$project$Pages$SyncDevices$viewIcon = F2(
	function (iconName, isCircle) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '100%'),
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
					A2($elm$html$Html$Attributes$style, 'padding', '12px 0px')
				]),
			_List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$Icon$icon,
					_List_fromArray(
						[
							A2(
							$author$project$Html$Attributes$Extra$when,
							isCircle,
							A2($elm$html$Html$Attributes$style, 'border-radius', '50%')),
							A2(
							$author$project$Html$Attributes$Extra$when,
							isCircle,
							A2($elm$html$Html$Attributes$style, 'border', '1px solid black'))
						]),
					iconName)
				]));
	});
var $author$project$Pages$SyncDevices$SelectIntrImportDevice = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$SyncDevices$viewImportFrom = F2(
	function (config, model) {
		return A5(
			$author$project$Select$view,
			$author$project$Pages$SyncDevices$SelectMsg,
			_List_fromArray(
				[1]),
			model.r,
			$author$project$Select$entity,
			_List_fromArray(
				[
					$author$project$Select$label('Sync From'),
					$author$project$Select$searchable,
					$author$project$Select$rootStyle(
					_List_fromArray(
						[
							_Utils_Tuple2('width', '270px'),
							_Utils_Tuple2('margin-top', '12px')
						])),
					$author$project$Select$groupBy(
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.du;
						},
						function ($) {
							return $.g8;
						})),
					$author$project$Select$options(
					A2($author$project$Pages$SyncDevices$filterDevices, model, config.ao)),
					$author$project$Select$value(model.ar),
					$author$project$Select$onSelect($author$project$Pages$SyncDevices$SelectIntrImportDevice)
				]));
	});
var $author$project$Pages$SyncDevices$ResetConfig = {$: 16};
var $author$project$Pages$SyncDevices$viewResetButton = function (model) {
	var isDisabled = _Utils_eq(model.ar, $elm$core$Maybe$Nothing) && ($elm$core$List$isEmpty(model.X) && _Utils_eq(model.dw, $elm$core$Maybe$Nothing));
	return A2(
		$aforemny$material_components_web_elm$Material$Button$outlined,
		A2(
			$aforemny$material_components_web_elm$Material$Button$setDisabled,
			isDisabled,
			A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$SyncDevices$ResetConfig, $aforemny$material_components_web_elm$Material$Button$config)),
		'Reset');
};
var $author$project$Pages$SyncDevices$AskConfirmSync = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$SyncDevices$isSharingSchool = F2(
	function (importFrom, exportTo) {
		return A2(
			$elm$core$List$all,
			function (dev) {
				return _Utils_eq(dev.du.aF, importFrom.du.aF);
			},
			exportTo);
	});
var $author$project$Pages$SyncDevices$viewSyncButton = F2(
	function (config, model) {
		var onClick = function () {
			var _v0 = _Utils_Tuple3(
				model.ar,
				$elm$core$List$isEmpty(model.X),
				(!model.bc) && ((!model.bd) && (!model.be)));
			if (((!_v0.a.$) && (!_v0.b)) && (!_v0.c)) {
				var importFrom = _v0.a.a;
				return A2($author$project$Pages$SyncDevices$isSharingSchool, importFrom, model.X) ? $author$project$Pages$SyncDevices$ImportData(
					A2($elm$core$Dict$get, importFrom.aF, config.ao)) : $author$project$Pages$SyncDevices$AskConfirmSync(
					$elm$core$Maybe$Just(importFrom));
			} else {
				return $author$project$Pages$SyncDevices$NoOp;
			}
		}();
		var isDisabled = _Utils_eq(model.ar, $elm$core$Maybe$Nothing) || ($elm$core$List$isEmpty(model.X) || ((!model.bc) && ((!model.bd) && (!model.be))));
		return A2(
			$aforemny$material_components_web_elm$Material$Button$outlined,
			A2(
				$aforemny$material_components_web_elm$Material$Button$setDisabled,
				isDisabled,
				A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config)),
			'Sync Devices');
	});
var $author$project$Pages$SyncDevices$ToggleDesign = {$: 6};
var $author$project$Pages$SyncDevices$viewSyncDesignCheckbox = function (model) {
	var checkboxState = model.bc ? $aforemny$material_components_web_elm$Material$Checkbox$checked : $aforemny$material_components_web_elm$Material$Checkbox$unchecked;
	return A2(
		$aforemny$material_components_web_elm$Material$FormField$formField,
		A2(
			$aforemny$material_components_web_elm$Material$FormField$setLabel,
			$elm$core$Maybe$Just('Sync Design'),
			$aforemny$material_components_web_elm$Material$FormField$config),
		_List_fromArray(
			[
				$aforemny$material_components_web_elm$Material$Checkbox$checkbox(
				A2(
					$aforemny$material_components_web_elm$Material$Checkbox$setOnChange,
					$author$project$Pages$SyncDevices$ToggleDesign,
					A2(
						$aforemny$material_components_web_elm$Material$Checkbox$setState,
						$elm$core$Maybe$Just(checkboxState),
						$aforemny$material_components_web_elm$Material$Checkbox$config)))
			]));
};
var $author$project$Pages$SyncDevices$ToggleSchedules = {$: 7};
var $author$project$Pages$SyncDevices$viewSyncScheduleCheckbox = function (model) {
	var checkboxState = model.bd ? $aforemny$material_components_web_elm$Material$Checkbox$checked : $aforemny$material_components_web_elm$Material$Checkbox$unchecked;
	return A2(
		$aforemny$material_components_web_elm$Material$FormField$formField,
		A2(
			$aforemny$material_components_web_elm$Material$FormField$setLabel,
			$elm$core$Maybe$Just('Sync Schedule'),
			$aforemny$material_components_web_elm$Material$FormField$config),
		_List_fromArray(
			[
				$aforemny$material_components_web_elm$Material$Checkbox$checkbox(
				A2(
					$aforemny$material_components_web_elm$Material$Checkbox$setOnChange,
					$author$project$Pages$SyncDevices$ToggleSchedules,
					A2(
						$aforemny$material_components_web_elm$Material$Checkbox$setState,
						$elm$core$Maybe$Just(checkboxState),
						$aforemny$material_components_web_elm$Material$Checkbox$config))),
				$elm$html$Html$text('Sync Schedule')
			]));
};
var $author$project$Pages$SyncDevices$ToggleStatusBar = {$: 8};
var $author$project$Pages$SyncDevices$viewSyncStatusBarCheckbox = function (model) {
	var checkboxState = model.be ? $aforemny$material_components_web_elm$Material$Checkbox$checked : $aforemny$material_components_web_elm$Material$Checkbox$unchecked;
	return A2(
		$aforemny$material_components_web_elm$Material$FormField$formField,
		A2(
			$aforemny$material_components_web_elm$Material$FormField$setLabel,
			$elm$core$Maybe$Just('Sync Status Bar (Including Logo)'),
			$aforemny$material_components_web_elm$Material$FormField$config),
		_List_fromArray(
			[
				$aforemny$material_components_web_elm$Material$Checkbox$checkbox(
				A2(
					$aforemny$material_components_web_elm$Material$Checkbox$setOnChange,
					$author$project$Pages$SyncDevices$ToggleStatusBar,
					A2(
						$aforemny$material_components_web_elm$Material$Checkbox$setState,
						$elm$core$Maybe$Just(checkboxState),
						$aforemny$material_components_web_elm$Material$Checkbox$config)))
			]));
};
var $author$project$Pages$SyncDevices$viewSyncOptions = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'margin-bottom', '16px'),
				A2($elm$html$Html$Attributes$style, 'margin-top', '16px'),
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'flex-direction', 'column')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$aforemny$material_components_web_elm$Material$Typography$caption,
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '6px')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Sync Options')
					])),
				$author$project$Pages$SyncDevices$viewSyncDesignCheckbox(model),
				$author$project$Pages$SyncDevices$viewSyncScheduleCheckbox(model),
				$author$project$Pages$SyncDevices$viewSyncStatusBarCheckbox(model)
			]));
};
var $author$project$Pages$SyncDevices$viewAttrStatus = function (attrStatus) {
	var viewBlock = function (color) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mdl-shadow--2dp'),
					A2($elm$html$Html$Attributes$style, 'width', '10px'),
					A2($elm$html$Html$Attributes$style, 'height', '30px'),
					A2($elm$html$Html$Attributes$style, 'background', color),
					A2($elm$html$Html$Attributes$style, 'margin', '0px 2px'),
					A2($elm$html$Html$Attributes$style, 'border-radius', '4px')
				]),
			_List_Nil);
	};
	if (attrStatus.$ === 4) {
		if (attrStatus.a) {
			return viewBlock('green');
		} else {
			return viewBlock('red');
		}
	} else {
		return viewBlock('rgb(200,200,200)');
	}
};
var $author$project$Pages$SyncDevices$viewIndividualStatus = function (_v0) {
	var deviceName = _v0.a;
	var status = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'align-items', 'center')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'display', 'flex'),
						A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
						A2($elm$html$Html$Attributes$style, 'margin-right', '12px')
					]),
				_List_fromArray(
					[
						$author$project$Pages$SyncDevices$viewAttrStatus(status.e1),
						$author$project$Pages$SyncDevices$viewAttrStatus(status.fH),
						$author$project$Pages$SyncDevices$viewAttrStatus(status.fK)
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'padding', '8px'),
						A2($elm$html$Html$Attributes$style, 'font-weight', '500')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(deviceName)
					]))
			]));
};
var $author$project$Pages$SyncDevices$viewSyncStatus = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'block')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$aforemny$material_components_web_elm$Material$Typography$caption,
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '6px')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Sync Status')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'display', 'block')
					]),
				A2(
					$elm$core$List$map,
					$author$project$Pages$SyncDevices$viewIndividualStatus,
					$elm$core$Dict$values(model.ak)))
			]));
};
var $author$project$Pages$SyncDevices$viewMainSection = F2(
	function (config, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mdl-shadow--4dp'),
							A2($elm$html$Html$Attributes$style, 'padding', '12px'),
							A2($elm$html$Html$Attributes$style, 'display', 'block')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$aforemny$material_components_web_elm$Material$Typography$headline4,
									A2($elm$html$Html$Attributes$style, 'text-align', 'center'),
									A2($elm$html$Html$Attributes$style, 'margin-bottom', '24px'),
									A2($elm$html$Html$Attributes$style, 'font-weight', '700')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Sync Settings between Online Devices')
								])),
							$author$project$Pages$SyncDevices$centerDiv(
							A2($author$project$Pages$SyncDevices$viewImportFrom, config, model)),
							A2($author$project$Pages$SyncDevices$viewIcon, 'arrow_downward', true),
							$author$project$Pages$SyncDevices$centerDiv(
							A2($author$project$Pages$SyncDevices$viewExportTo, config, model)),
							$author$project$Pages$SyncDevices$viewSyncOptions(model),
							$author$project$Pages$SyncDevices$viewSyncStatus(model),
							A2($author$project$Pages$SyncDevices$viewConfirmSync, config, model)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
							A2($elm$html$Html$Attributes$style, 'justify-content', 'space-between'),
							A2($elm$html$Html$Attributes$style, 'margin-top', '12px')
						]),
					_List_fromArray(
						[
							$author$project$Pages$SyncDevices$viewResetButton(model),
							A2($author$project$Pages$SyncDevices$viewSyncButton, config, model)
						]))
				]));
	});
var $danmarcab$material_icons$Material$Icons$Hardware$cast = A2(
	$danmarcab$material_icons$Material$Icons$Internal$icon,
	'0 0 48 48',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M42 6H6c-2.21 0-4 1.79-4 4v6h4v-6h36v28H28v4h14c2.21 0 4-1.79 4-4V10c0-2.21-1.79-4-4-4zM2 36v6h6c0-3.31-2.69-6-6-6zm0-8v4c5.52 0 10 4.48 10 10h4c0-7.73-6.27-14-14-14zm0-8v4c9.94 0 18 8.06 18 18h4c0-12.15-9.85-22-22-22z')
				]),
			_List_Nil)
		]));
var $danmarcab$material_icons$Material$Icons$Hardware$cast_connected = A2(
	$danmarcab$material_icons$Material$Icons$Internal$icon,
	'0 0 48 48',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M2 36v6h6c0-3.31-2.69-6-6-6zm0-8v4c5.52 0 10 4.48 10 10h4c0-7.73-6.27-14-14-14zm36-14H10v3.27c7.92 2.56 14.17 8.81 16.73 16.73H38V14zM2 20v4c9.94 0 18 8.06 18 18h4c0-12.15-9.85-22-22-22zM42 6H6c-2.21 0-4 1.79-4 4v6h4v-6h36v28H28v4h14c2.21 0 4-1.79 4-4V10c0-2.21-1.79-4-4-4z')
				]),
			_List_Nil)
		]));
var $danmarcab$material_icons$Material$Icons$Communication$location_on = A2(
	$danmarcab$material_icons$Material$Icons$Internal$icon,
	'0 0 48 48',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M24 4c-7.73 0-14 6.27-14 14 0 10.5 14 26 14 26s14-15.5 14-26c0-7.73-6.27-14-14-14zm0 19c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z')
				]),
			_List_Nil)
		]));
var $avh4$elm_color$Color$red = A4($avh4$elm_color$Color$RgbaSpace, 204 / 255, 0 / 255, 0 / 255, 1.0);
var $danmarcab$material_icons$Material$Icons$File$cloud = A2(
	$danmarcab$material_icons$Material$Icons$Internal$icon,
	'0 0 48 48',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M38.71 20.07C37.35 13.19 31.28 8 24 8c-5.78 0-10.79 3.28-13.3 8.07C4.69 16.72 0 21.81 0 28c0 6.63 5.37 12 12 12h26c5.52 0 10-4.48 10-10 0-5.28-4.11-9.56-9.29-9.93z')
				]),
			_List_Nil)
		]));
var $danmarcab$material_icons$Material$Icons$File$cloud_off = A2(
	$danmarcab$material_icons$Material$Icons$Internal$icon,
	'0 0 48 48',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M38.71 20.07C37.35 13.19 31.28 8 24 8c-2.95 0-5.7.87-8.02 2.34l2.92 2.92C20.43 12.47 22.16 12 24 12c6.08 0 11 4.92 11 11v1h3c3.31 0 6 2.69 6 6 0 2.27-1.27 4.22-3.13 5.24l2.9 2.9C46.32 36.33 48 33.37 48 30c0-5.28-4.11-9.56-9.29-9.93zM6 10.55l5.5 5.48C5.12 16.3 0 21.55 0 28c0 6.63 5.37 12 12 12h23.45l4 4L42 41.46 8.55 8 6 10.55zM15.45 20l16 16H12c-4.42 0-8-3.58-8-8s3.58-8 8-8h3.45z')
				]),
			_List_Nil)
		]));
var $author$project$Reusable$IconStatus$view = F3(
	function (materialIcon, statusColor, _v0) {
		var title = _v0.a;
		var statusText = _v0.b;
		return $rtfeldman$elm_css$Html$Styled$toUnstyled(
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$marginBottom(
								$rtfeldman$elm_css$Css$px(6))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$fromUnstyled(
						A2(materialIcon, statusColor, 42)),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$displayFlex,
										$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
										$rtfeldman$elm_css$Css$marginLeft(
										$rtfeldman$elm_css$Css$px(6)),
										$rtfeldman$elm_css$Css$width(
										$rtfeldman$elm_css$Css$pct(75))
									]))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$fontFamilies(
												_List_fromArray(
													['Roboto'])),
												$rtfeldman$elm_css$Css$fontWeight(
												$rtfeldman$elm_css$Css$int(700)),
												$rtfeldman$elm_css$Css$fontSize(
												$rtfeldman$elm_css$Css$px(18)),
												$rtfeldman$elm_css$Css$lineHeight(
												$rtfeldman$elm_css$Css$em(1)),
												A2($rtfeldman$elm_css$Css$property, 'white-space', 'nowrap'),
												$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
												$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis)
											]))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(title)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$fontFamilies(
												_List_fromArray(
													['Roboto'])),
												$rtfeldman$elm_css$Css$fontWeight(
												$rtfeldman$elm_css$Css$int(400)),
												$rtfeldman$elm_css$Css$fontSize(
												$rtfeldman$elm_css$Css$px(16)),
												$rtfeldman$elm_css$Css$lineHeight(
												$rtfeldman$elm_css$Css$em(1)),
												$rtfeldman$elm_css$Css$color(
												$rtfeldman$elm_css$Css$hex(
													$noahzgordon$elm_color_extra$Color$Convert$colorToHex(statusColor)))
											]))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(statusText)
									]))
							]))
					])));
	});
var $author$project$FabricStatus$view = function (state) {
	switch (state) {
		case 0:
			return A3(
				$author$project$Reusable$IconStatus$view,
				$danmarcab$material_icons$Material$Icons$File$cloud,
				$avh4$elm_color$Color$black,
				_Utils_Tuple2('Fabric Server', 'Connected'));
		case 1:
			return A3(
				$author$project$Reusable$IconStatus$view,
				$danmarcab$material_icons$Material$Icons$File$cloud_off,
				$avh4$elm_color$Color$red,
				_Utils_Tuple2('Fabric Server', 'Disconnected'));
		default:
			return A3(
				$author$project$Reusable$IconStatus$view,
				$danmarcab$material_icons$Material$Icons$File$cloud_off,
				$avh4$elm_color$Color$red,
				_Utils_Tuple2('Fabric Server', 'Reconnecting...'));
	}
};
var $author$project$Pages$CfgDevice$Core$OpenLiveCapture = $elm$core$Basics$identity;
var $author$project$Pages$CfgDevice$Core$ToMain = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$CfgDevice$Core$viewDeviceOptions = F3(
	function (config, model, device) {
		var attrs = _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'width', '100%'),
				A2($elm$html$Html$Attributes$style, 'margin-bottom', '6px')
			]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
					A2($elm$html$Html$Attributes$style, 'width', '100%')
				]),
			_List_fromArray(
				[
					function () {
					var onClick = config.cz(
						$author$project$Pages$CfgDevice$Core$ToMain(device));
					var isDisabled = $author$project$Entity$Device$isDeviceOffline(device);
					return A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2(
							$aforemny$material_components_web_elm$Material$Button$setAttributes,
							attrs,
							A2(
								$aforemny$material_components_web_elm$Material$Button$setDisabled,
								isDisabled,
								A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config))),
						'Live Capture');
				}(),
					function () {
					var onClick = config.le(device);
					var isDisabled = $author$project$Entity$Device$isDeviceOffline(device);
					return A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2(
							$aforemny$material_components_web_elm$Material$Button$setAttributes,
							attrs,
							A2(
								$aforemny$material_components_web_elm$Material$Button$setDisabled,
								isDisabled,
								A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config))),
						'Export Settings');
				}()
				]));
	});
var $author$project$Pages$CfgDevice$Design$viewTemplateInfo = function (model) {
	var _v0 = model.a;
	if (_v0.$ === 4) {
		var template = _v0.a;
		return $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mdl-shadow--2dp'),
						A2($elm$html$Html$Attributes$style, 'padding', '12px'),
						A2($elm$html$Html$Attributes$style, 'margin-right', '6px'),
						A2($elm$html$Html$Attributes$style, 'margin-left', '2px')
					]),
				_List_fromArray(
					[
						$author$project$Reusable$Flex$viewVertical(
						_List_fromArray(
							[
								A2($author$project$Reusable$Label$view, 'Created By', template.k2),
								A2(
								$author$project$Reusable$Label$view,
								'Created On',
								A2($justinmimbs$date$Date$format, 'MMMM d, y', template.iw))
							]))
					])));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$CfgDevice$Core$viewInformationPanels = F3(
	function (config, model, device) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Reusable$Header$subHeader('Information'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mdl-shadow--2dp'),
							A2($elm$html$Html$Attributes$style, 'padding', '12px'),
							A2($elm$html$Html$Attributes$style, 'margin-right', '6px'),
							A2($elm$html$Html$Attributes$style, 'margin-left', '2px')
						]),
					_List_fromArray(
						[
							$author$project$FabricStatus$view(config.aD),
							function () {
							var _v0 = device.fJ;
							switch (_v0.$) {
								case 0:
									return A3(
										$author$project$Reusable$IconStatus$view,
										$danmarcab$material_icons$Material$Icons$Hardware$cast_connected,
										$avh4$elm_color$Color$black,
										_Utils_Tuple2(device.g8, 'Online'));
								case 2:
									return A3(
										$author$project$Reusable$IconStatus$view,
										$danmarcab$material_icons$Material$Icons$Hardware$cast,
										$avh4$elm_color$Color$red,
										_Utils_Tuple2(device.g8, 'Connecting...'));
								case 3:
									return A3(
										$author$project$Reusable$IconStatus$view,
										$danmarcab$material_icons$Material$Icons$Hardware$cast,
										$avh4$elm_color$Color$red,
										_Utils_Tuple2(device.g8, 'Connect Failed'));
								case 1:
									return A3(
										$author$project$Reusable$IconStatus$view,
										$danmarcab$material_icons$Material$Icons$Hardware$cast,
										$avh4$elm_color$Color$red,
										_Utils_Tuple2(device.g8, 'Offline'));
								default:
									return A3(
										$author$project$Reusable$IconStatus$view,
										$danmarcab$material_icons$Material$Icons$Hardware$cast,
										$avh4$elm_color$Color$red,
										_Utils_Tuple2(device.g8, 'Unknown'));
							}
						}(),
							A3(
							$author$project$Reusable$IconStatus$view,
							$danmarcab$material_icons$Material$Icons$Communication$location_on,
							$avh4$elm_color$Color$black,
							_Utils_Tuple2('Location', device.du.g8)),
							$author$project$Reusable$Separator$viewHorizontal,
							A3($author$project$Pages$CfgDevice$Core$viewDeviceOptions, config, model, device)
						])),
					function () {
					var maybeNode = $author$project$Pages$CfgDevice$Design$viewTemplateInfo(model.P);
					if (!maybeNode.$) {
						var desNode = maybeNode.a;
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Reusable$Header$subHeader('Template'),
									A2(
									$elm$html$Html$map,
									A2($elm$core$Basics$composeR, $author$project$Pages$CfgDevice$Core$DesignTabMsg, config.cz),
									desNode)
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $aforemny$material_components_web_elm$Material$TabBar$setStacked = F2(
	function (stacked, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{hI: stacked});
	});
var $author$project$Pages$CfgDevice$Core$viewSideTab = function (node) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'height', '65vh'),
				A2($elm$html$Html$Attributes$style, 'overflow-y', 'auto'),
				A2($elm$html$Html$Attributes$style, 'overflow-x', 'hidden')
			]),
		_List_fromArray(
			[node]));
};
var $author$project$Pages$CfgDevice$Design$ChangeBoundedStyle = F3(
	function (a, b, c) {
		return {$: 40, a: a, b: b, c: c};
	});
var $author$project$Pages$CfgDevice$Design$ChangeSharedStyle = F3(
	function (a, b, c) {
		return {$: 39, a: a, b: b, c: c};
	});
var $author$project$Pages$CfgDevice$Design$isElementVisible = function (css) {
	var isVisible = A2(
		$elm$core$Maybe$withDefault,
		true,
		A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $elm$core$Basics$not),
				$elm$core$Basics$eq('hidden')),
			A2($elm$core$Dict$get, 'visibility', css.a$)));
	var isDisplayed = A2(
		$elm$core$Maybe$withDefault,
		true,
		A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $elm$core$Basics$not),
				$elm$core$Basics$eq('none')),
			A2($elm$core$Dict$get, 'display', css.a$)));
	return isVisible && isDisplayed;
};
var $author$project$Reusable$Flex$viewCompactLabelValue = F2(
	function (label, nodes) {
		return $rtfeldman$elm_css$Html$Styled$toUnstyled(
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$pct(100)),
								$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
								$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(label),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[$rtfeldman$elm_css$Css$displayFlex]))
							]),
						A2($elm$core$List$map, $rtfeldman$elm_css$Html$Styled$fromUnstyled, nodes))
					])));
	});
var $author$project$Reusable$Card$viewSidebarCard = function (nodes) {
	return $rtfeldman$elm_css$Html$Styled$toUnstyled(
		A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled($author$project$Mdl$Elevation$e2),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$pct(88)),
							$rtfeldman$elm_css$Css$padding(
							$rtfeldman$elm_css$Css$px(12)),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$px(8)),
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$borderRadius(
							$rtfeldman$elm_css$Css$px(8))
						]))
				]),
			A2($elm$core$List$map, $rtfeldman$elm_css$Html$Styled$fromUnstyled, nodes)));
};
var $author$project$Pages$CfgDevice$Design$viewElementStyleEditor = F3(
	function (model, css, msg) {
		var set = function (updated) {
			return msg(
				_Utils_update(
					css,
					{
						a$: A2(
							$elm$core$Dict$union,
							$elm$core$Dict$fromList(updated),
							css.a$)
					}));
		};
		var onClick = function () {
			var _v0 = _Utils_Tuple2(
				A2($elm$core$Dict$get, 'visibility', css.a$),
				A2($elm$core$Dict$get, 'display', css.a$));
			if ((!_v0.b.$) && (_v0.b.a === 'none')) {
				return set(
					_List_fromArray(
						[
							_Utils_Tuple2('visibility', 'visible'),
							_Utils_Tuple2('display', 'initial')
						]));
			} else {
				if ((!_v0.a.$) && (_v0.a.a === 'hidden')) {
					return set(
						_List_fromArray(
							[
								_Utils_Tuple2('display', 'none')
							]));
				} else {
					return set(
						_List_fromArray(
							[
								_Utils_Tuple2('display', 'none')
							]));
				}
			}
		}();
		var iconName = $author$project$Pages$CfgDevice$Design$isElementVisible(css) ? 'check_box' : 'check_box_outline_blank';
		return $author$project$Reusable$Card$viewSidebarCard(
			_List_fromArray(
				[
					A2(
					$author$project$Reusable$Flex$viewCompactLabelValue,
					'Visibility',
					_List_fromArray(
						[
							A2(
							$aforemny$material_components_web_elm$Material$IconButton$iconButton,
							A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, onClick, $aforemny$material_components_web_elm$Material$IconButton$config),
							$aforemny$material_components_web_elm$Material$IconButton$icon(iconName))
						]))
				]));
	});
var $author$project$Pages$CfgDevice$Design$OpenSharedStyleDialog = {$: 74};
var $author$project$Pages$CfgDevice$Design$SelectSharedStyle = function (a) {
	return {$: 41, a: a};
};
var $author$project$Pages$CfgDevice$Design$viewSharedStyleSelector = F2(
	function (model, _v0) {
		var styles = _v0.z;
		return $author$project$Reusable$Flex$viewVertical(
			_List_fromArray(
				[
					A2(
					$author$project$Reusable$Header$subHeader2,
					'Shared Styles',
					A2(
						$aforemny$material_components_web_elm$Material$IconButton$iconButton,
						A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, $author$project$Pages$CfgDevice$Design$OpenSharedStyleDialog, $aforemny$material_components_web_elm$Material$IconButton$config),
						$aforemny$material_components_web_elm$Material$IconButton$icon('add'))),
					$author$project$Reusable$Card$viewSidebarCard(
					_List_fromArray(
						[
							A5(
							$author$project$Select$view,
							$author$project$Pages$CfgDevice$Design$Select,
							_List_fromArray(
								[1001]),
							model.r,
							$author$project$Select$string,
							_List_fromArray(
								[
									$author$project$Select$label('Choose Style'),
									$author$project$Select$searchable,
									$author$project$Select$options(
									$elm$core$Dict$keys(styles)),
									$author$project$Select$value(model.aS),
									$author$project$Select$onSelect($author$project$Pages$CfgDevice$Design$SelectSharedStyle)
								]))
						]))
				]));
	});
var $author$project$Pages$CfgDevice$Design$getCssValue = function (str) {
	var regex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('\\d+'));
	return A2(
		$elm$core$Maybe$andThen,
		$elm$core$String$toFloat,
		$elm$core$List$head(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.lU;
				},
				A3($elm$regex$Regex$findAtMost, 1, regex, str))));
};
var $author$project$Reusable$Flex$viewLabelValue = F2(
	function (label, nodes) {
		return $rtfeldman$elm_css$Html$Styled$toUnstyled(
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$pct(100)),
								$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
								$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
								A2(
								$rtfeldman$elm_css$Css$padding2,
								$rtfeldman$elm_css$Css$px(6),
								$rtfeldman$elm_css$Css$px(0))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(label),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[$rtfeldman$elm_css$Css$displayFlex]))
							]),
						A2($elm$core$List$map, $rtfeldman$elm_css$Html$Styled$fromUnstyled, nodes))
					])));
	});
var $author$project$Pages$CfgDevice$Design$viewUnitValue = F4(
	function (unit, _v0, css, toMsg) {
		var key = _v0.a;
		var defaultVal = _v0.b;
		var onInput = function (val) {
			return toMsg(
				_Utils_update(
					css,
					{
						a$: A3(
							$elm$core$Dict$insert,
							key,
							_Utils_ap(
								$elm$core$String$fromFloat(val),
								unit),
							css.a$)
					}));
		};
		return _List_fromArray(
			[
				A2(
				$author$project$Reusable$Input$number,
				onInput,
				_List_fromArray(
					[
						$author$project$Reusable$Input$value(
						A2(
							$elm$core$Maybe$withDefault,
							defaultVal,
							A2(
								$elm$core$Maybe$andThen,
								$author$project$Pages$CfgDevice$Design$getCssValue,
								A2($elm$core$Dict$get, key, css.a$))))
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'margin-left', '6px')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(unit)
					]))
			]);
	});
var $author$project$Pages$CfgDevice$Design$viewPctValue = $author$project$Pages$CfgDevice$Design$viewUnitValue('%');
var $author$project$Pages$CfgDevice$Design$viewSizeEditor = F3(
	function (model, css, msg) {
		var viewEl = F2(
			function (_v0, toMsg) {
				var name = _v0.a;
				var attr = _v0.b;
				return _List_fromArray(
					[
						A2(
						$author$project$Reusable$Flex$viewLabelValue,
						name,
						A3(
							$author$project$Pages$CfgDevice$Design$viewPctValue,
							_Utils_Tuple2(attr, 100),
							css,
							msg)),
						A2(
						$author$project$Reusable$Slider$view,
						toMsg,
						_List_fromArray(
							[
								$author$project$Reusable$Slider$min(1),
								$author$project$Reusable$Slider$max(100),
								$author$project$Reusable$Slider$value(
								A2(
									$elm$core$Maybe$withDefault,
									100,
									A2(
										$elm$core$Maybe$andThen,
										$author$project$Pages$CfgDevice$Design$getCssValue,
										A2($elm$core$Dict$get, attr, css.a$))))
							]))
					]);
			});
		var setWidth = function (val) {
			return msg(
				_Utils_update(
					css,
					{
						a$: A3(
							$elm$core$Dict$insert,
							'width',
							$elm$core$String$fromFloat(val) + '%',
							css.a$)
					}));
		};
		var setHeight = function (val) {
			return msg(
				_Utils_update(
					css,
					{
						a$: A3(
							$elm$core$Dict$insert,
							'height',
							$elm$core$String$fromFloat(val) + '%',
							css.a$)
					}));
		};
		return $author$project$Reusable$Card$viewSidebarCard(
			_Utils_ap(
				A2(
					viewEl,
					_Utils_Tuple2('Width', 'width'),
					setWidth),
				A2(
					viewEl,
					_Utils_Tuple2('Height', 'height'),
					setHeight)));
	});
var $author$project$Pages$CfgDevice$Design$ColorPicker = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$CfgDevice$Design$viewPxValue = $author$project$Pages$CfgDevice$Design$viewUnitValue('px');
var $author$project$Pages$CfgDevice$Design$viewTextStyleEditor = F3(
	function (model, css, msg) {
		return $author$project$Reusable$Card$viewSidebarCard(
			_List_fromArray(
				[
					A5(
					$author$project$Select$view,
					$author$project$Pages$CfgDevice$Design$Select,
					_List_fromArray(
						[5005]),
					model.r,
					$author$project$Select$string,
					_List_fromArray(
						[
							$author$project$Select$label('Font Family'),
							$author$project$Select$searchable,
							$author$project$Select$applyStyle($author$project$Entity$Font$applyStyle),
							$author$project$Select$options($author$project$Entity$Font$availableFonts),
							$author$project$Select$value(
							A2($elm$core$Dict$get, 'font-family', css.a$)),
							$author$project$Select$onSelect(
							function (opt) {
								return msg(
									_Utils_update(
										css,
										{
											a$: A3($elm$core$Dict$insert, 'font-family', opt, css.a$)
										}));
							})
						])),
					A2(
					$author$project$Reusable$Flex$viewLabelValue,
					'Color',
					_List_fromArray(
						[
							A4(
							$author$project$ColorPicker$view,
							$author$project$Pages$CfgDevice$Design$ColorPicker,
							_List_fromArray(
								[1]),
							model.aA,
							_List_fromArray(
								[
									$author$project$ColorPicker$value(
									A2(
										$elm$core$Maybe$withDefault,
										'none',
										A2($elm$core$Dict$get, 'color', css.a$))),
									$author$project$ColorPicker$onChange(
									function (opt) {
										return msg(
											_Utils_update(
												css,
												{
													a$: A3($elm$core$Dict$insert, 'color', opt, css.a$)
												}));
									})
								]))
						])),
					A2(
					$author$project$Reusable$Flex$viewLabelValue,
					'Background',
					_List_fromArray(
						[
							A4(
							$author$project$ColorPicker$view,
							$author$project$Pages$CfgDevice$Design$ColorPicker,
							_List_fromArray(
								[4]),
							model.aA,
							_List_fromArray(
								[
									$author$project$ColorPicker$value(
									A2(
										$elm$core$Maybe$withDefault,
										'transparent',
										A2($elm$core$Dict$get, 'background', css.a$))),
									$author$project$ColorPicker$onChange(
									function (opt) {
										return msg(
											_Utils_update(
												css,
												{
													a$: A3($elm$core$Dict$insert, 'background', opt, css.a$)
												}));
									})
								]))
						])),
					$author$project$Reusable$Separator$viewHorizontal,
					A2(
					$author$project$Reusable$Flex$viewLabelValue,
					'Font Size',
					A3(
						$author$project$Pages$CfgDevice$Design$viewPxValue,
						_Utils_Tuple2('font-size', 0),
						css,
						msg)),
					A2(
					$author$project$Reusable$Slider$view,
					function (val) {
						return msg(
							_Utils_update(
								css,
								{
									a$: A3(
										$elm$core$Dict$insert,
										'font-size',
										$elm$core$String$fromFloat(val) + 'px',
										css.a$)
								}));
					},
					_List_fromArray(
						[
							$author$project$Reusable$Slider$min(1),
							$author$project$Reusable$Slider$max(124),
							$author$project$Reusable$Slider$value(
							A2(
								$elm$core$Maybe$withDefault,
								1,
								A2(
									$elm$core$Maybe$andThen,
									$author$project$Pages$CfgDevice$Design$getCssValue,
									A2($elm$core$Dict$get, 'font-size', css.a$))))
						]))
				]));
	});
var $author$project$Entity$Style$getCss = F2(
	function (collection, style) {
		if (!style.$) {
			var id = style.a;
			return A2(
				$elm$core$Maybe$withDefault,
				$author$project$Entity$Style$empty,
				A2($elm$core$Dict$get, id, collection));
		} else {
			var css = style.a;
			return css;
		}
	});
var $author$project$Pages$CfgDevice$Design$ShareStyle = F3(
	function (a, b, c) {
		return {$: 37, a: a, b: b, c: c};
	});
var $author$project$Pages$CfgDevice$Design$viewBoundedStyleEditor = F4(
	function (model, template, position, css) {
		return $author$project$Reusable$Card$viewSidebarCard(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin', '12px 0px')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('This widget uses a bounded style. Use the option below to use a shared style.')
						])),
					A5(
					$author$project$Select$view,
					$author$project$Pages$CfgDevice$Design$Select,
					_List_fromArray(
						[10001]),
					model.r,
					$author$project$Select$string,
					_List_fromArray(
						[
							$author$project$Select$label('Choose a Shared Style'),
							$author$project$Select$searchable,
							$author$project$Select$options(
							A2(
								$elm$core$List$map,
								$elm$core$Tuple$first,
								A2(
									$elm$core$List$filter,
									css.d1 ? A2(
										$elm$core$Basics$composeR,
										$elm$core$Tuple$second,
										function ($) {
											return $.d1;
										}) : A2(
										$elm$core$Basics$composeR,
										$elm$core$Tuple$second,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.d1;
											},
											$elm$core$Basics$not)),
									A2(
										$elm$core$List$filter,
										css.d2 ? A2(
											$elm$core$Basics$composeR,
											$elm$core$Tuple$second,
											function ($) {
												return $.d2;
											}) : A2(
											$elm$core$Basics$composeR,
											$elm$core$Tuple$second,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.d2;
												},
												$elm$core$Basics$not)),
										$elm$core$Dict$toList(template.z))))),
							$author$project$Select$value($elm$core$Maybe$Nothing),
							$author$project$Select$onSelect(
							A2($author$project$Pages$CfgDevice$Design$ShareStyle, template, position))
						]))
				]));
	});
var $author$project$Pages$CfgDevice$Design$viewWidgetStyleEditor = F4(
	function (model, template, _v0, msg) {
		var position = _v0.a;
		var maybeWidget = _v0.b;
		var viewEditor = function (style) {
			var css = A2($author$project$Entity$Style$getCss, template.z, style);
			return $author$project$Reusable$Flex$viewVertical(
				_List_fromArray(
					[
						$author$project$Reusable$Header$sectionHeader('Bounded Style'),
						A4($author$project$Pages$CfgDevice$Design$viewBoundedStyleEditor, model, template, position, css),
						$author$project$Reusable$Header$sectionHeader('Bounded Style Editor'),
						A3($author$project$Pages$CfgDevice$Design$viewElementStyleEditor, model, css, msg),
						css.d2 ? A3($author$project$Pages$CfgDevice$Design$viewTextStyleEditor, model, css, msg) : $elm$html$Html$text(''),
						css.d1 ? A3($author$project$Pages$CfgDevice$Design$viewSizeEditor, model, css, msg) : $elm$html$Html$text('')
					]));
		};
		var _v1 = _Utils_Tuple2(maybeWidget, model.aR);
		_v1$14:
		while (true) {
			if (!_v1.a.$) {
				switch (_v1.a.a.$) {
					case 1:
						if (!_v1.b.$) {
							switch (_v1.b.a) {
								case 0:
									var size = _v1.a.a.a.dB;
									var _v2 = _v1.b.a;
									return viewEditor(size);
								case 1:
									var style = _v1.a.a.a.cs;
									var _v3 = _v1.b.a;
									return viewEditor(style);
								default:
									break _v1$14;
							}
						} else {
							break _v1$14;
						}
					case 2:
						var config = _v1.a.a.a;
						return viewEditor(config.cs);
					case 4:
						if (!_v1.b.$) {
							switch (_v1.b.a) {
								case 0:
									var layout = _v1.a.a.a.da;
									var _v4 = _v1.b.a;
									return viewEditor(layout);
								case 1:
									var title = _v1.a.a.a.na;
									var _v5 = _v1.b.a;
									return viewEditor(title);
								case 2:
									var location = _v1.a.a.a.gY;
									var _v6 = _v1.b.a;
									return viewEditor(location);
								case 3:
									var image = _v1.a.a.a.gL;
									var _v7 = _v1.b.a;
									return viewEditor(image);
								case 5:
									var ratings = _v1.a.a.a.mf;
									var _v8 = _v1.b.a;
									return viewEditor(ratings);
								case 6:
									var description = _v1.a.a.a.k9;
									var _v9 = _v1.b.a;
									return viewEditor(description);
								case 4:
									var calories = _v1.a.a.a.kR;
									var _v10 = _v1.b.a;
									return viewEditor(calories);
								case 7:
									var foodComponents = _v1.a.a.a.gA;
									var _v11 = _v1.b.a;
									return viewEditor(foodComponents);
								default:
									break _v1$14;
							}
						} else {
							break _v1$14;
						}
					case 5:
						if (!_v1.b.$) {
							switch (_v1.b.a) {
								case 1:
									var title = _v1.a.a.a.na;
									var _v12 = _v1.b.a;
									return viewEditor(title);
								case 6:
									var description = _v1.a.a.a.k9;
									var _v13 = _v1.b.a;
									return viewEditor(description);
								case 8:
									var pricing = _v1.a.a.a.hw;
									var _v14 = _v1.b.a;
									return viewEditor(pricing);
								default:
									break _v1$14;
							}
						} else {
							break _v1$14;
						}
					default:
						break _v1$14;
				}
			} else {
				var _v15 = _v1.a;
				return $author$project$Reusable$Header$subHeader('Select Widget to edit styles');
			}
		}
		var widget = _v1.a.a;
		return $author$project$Reusable$Header$subHeader('Invalid Selection');
	});
var $author$project$Pages$CfgDevice$Design$viewStyleEditor = function (model) {
	var _v0 = _Utils_Tuple3(model.a, model.aS, model.h);
	if (_v0.a.$ === 4) {
		if (!_v0.b.$) {
			var template = _v0.a.a;
			var styleId = _v0.b.a;
			return $author$project$Reusable$Flex$viewVertical(
				_List_fromArray(
					[
						A2($author$project$Pages$CfgDevice$Design$viewSharedStyleSelector, model, template),
						function () {
						var _v1 = A2($elm$core$Dict$get, styleId, template.z);
						if (!_v1.$) {
							var css = _v1.a;
							return $author$project$Reusable$Flex$viewVertical(
								_List_fromArray(
									[
										$author$project$Reusable$Header$sectionHeader('Shared Style Editor'),
										A3(
										$author$project$Pages$CfgDevice$Design$viewElementStyleEditor,
										model,
										css,
										A2($author$project$Pages$CfgDevice$Design$ChangeSharedStyle, template, styleId)),
										css.d2 ? A3(
										$author$project$Pages$CfgDevice$Design$viewTextStyleEditor,
										model,
										css,
										A2($author$project$Pages$CfgDevice$Design$ChangeSharedStyle, template, styleId)) : $elm$html$Html$text(''),
										css.d1 ? A3(
										$author$project$Pages$CfgDevice$Design$viewSizeEditor,
										model,
										css,
										A2($author$project$Pages$CfgDevice$Design$ChangeSharedStyle, template, styleId)) : $elm$html$Html$text('')
									]));
						} else {
							return $elm$html$Html$text('');
						}
					}()
					]));
		} else {
			if (!_v0.c.$) {
				var template = _v0.a.a;
				var _v2 = _v0.b;
				var position = _v0.c.a;
				var maybeWidgetId = A2($author$project$Template$Helpers$getWidgetId, template, position);
				if (maybeWidgetId.$ === 1) {
					return $author$project$Reusable$Header$subHeader('Widget Unavailable');
				} else {
					var widgetId = maybeWidgetId.a;
					return $author$project$Reusable$Flex$viewVertical(
						_List_fromArray(
							[
								A2($author$project$Pages$CfgDevice$Design$viewSharedStyleSelector, model, template),
								A4(
								$author$project$Pages$CfgDevice$Design$viewWidgetStyleEditor,
								model,
								template,
								_Utils_Tuple2(
									position,
									A2(
										$elm$core$Maybe$andThen,
										A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $elm$core$Tuple$second),
										A2($author$project$Template$Helpers$getWidget, template, position))),
								A2($author$project$Pages$CfgDevice$Design$ChangeBoundedStyle, template, widgetId))
							]));
				}
			} else {
				var template = _v0.a.a;
				var _v4 = _v0.b;
				var _v5 = _v0.c;
				return A2($author$project$Pages$CfgDevice$Design$viewSharedStyleSelector, model, template);
			}
		}
	} else {
		return $author$project$Reusable$Header$subHeader('Style Editor');
	}
};
var $author$project$Pages$CfgDevice$Core$SelectSideTab = function (a) {
	return {$: 5, a: a};
};
var $aforemny$material_components_web_elm$Material$Tab$Internal$Icon = function (a) {
	return {$: 0, a: a};
};
var $aforemny$material_components_web_elm$Material$Tab$customIcon = F3(
	function (node, attributes, nodes) {
		return $aforemny$material_components_web_elm$Material$Tab$Internal$Icon(
			{eP: attributes, aJ: node, ft: nodes});
	});
var $aforemny$material_components_web_elm$Material$Tab$icon = function (iconName) {
	return A3(
		$aforemny$material_components_web_elm$Material$Tab$customIcon,
		$elm$html$Html$i,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('material-icons')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(iconName)
			]));
};
var $aforemny$material_components_web_elm$Material$Tab$setAttributes = F2(
	function (additionalAttributes, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{fZ: additionalAttributes});
	});
var $author$project$Pages$CfgDevice$Core$viewTabIcon = F3(
	function (config, model, _v0) {
		var icon = _v0.a;
		var tooltip = _v0.b;
		var tab = _v0.c;
		return A2(
			$aforemny$material_components_web_elm$Material$Tab$tab,
			A2(
				$aforemny$material_components_web_elm$Material$Tab$setAttributes,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'height', '48px'),
						A2($elm$html$Html$Attributes$style, 'padding', '0px 12px')
					]),
				A2(
					$aforemny$material_components_web_elm$Material$Tab$setOnClick,
					config.cz(
						$author$project$Pages$CfgDevice$Core$SelectSideTab(
							$elm$core$Maybe$Just(tab))),
					A2(
						$aforemny$material_components_web_elm$Material$Tab$setActive,
						_Utils_eq(model.bG, tab),
						$aforemny$material_components_web_elm$Material$Tab$config))),
			{
				iU: $elm$core$Maybe$Just(
					$aforemny$material_components_web_elm$Material$Tab$icon(icon)),
				c9: ''
			});
	});
var $author$project$Pages$CfgDevice$Design$OpenSharedWidgetDialog = {$: 86};
var $author$project$Template$Helpers$isSharedWidget = F2(
	function (position, template) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$andThen,
				function (sec) {
					switch (sec.$) {
						case 0:
							var id = sec.a;
							return $elm$core$Maybe$Just(false);
						case 1:
							var id = sec.a;
							return $elm$core$Maybe$Just(true);
						default:
							return $elm$core$Maybe$Just(false);
					}
				},
				A2(
					$elm$core$Maybe$andThen,
					function (column) {
						return A2($elm_community$list_extra$List$Extra$getAt, position.y, column.jJ);
					},
					A2(
						$elm$core$Maybe$andThen,
						function (frame) {
							return A2($elm_community$list_extra$List$Extra$getAt, position.C, frame.da);
						},
						A2($elm_community$list_extra$List$Extra$getAt, position.ap, template.G)))));
	});
var $author$project$Reusable$Header$multiLineSubHeader = function (str) {
	return A2(
		$elm$html$Html$h4,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'box-sizing', 'border-box'),
				A2($elm$html$Html$Attributes$style, 'color', 'rgb(0,0,0,0.54)'),
				A2($elm$html$Html$Attributes$style, 'font-size', '14px'),
				A2($elm$html$Html$Attributes$style, 'font-weight', '500'),
				A2($elm$html$Html$Attributes$style, 'line-height', '18px'),
				A2($elm$html$Html$Attributes$style, 'padding-left', '16px'),
				A2($elm$html$Html$Attributes$style, 'padding-top', '14px'),
				A2($elm$html$Html$Attributes$style, 'margin', '0px'),
				A2($elm$html$Html$Attributes$style, 'width', '100%')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $author$project$Pages$CfgDevice$Design$AddWidget = F3(
	function (a, b, c) {
		return {$: 28, a: a, b: b, c: c};
	});
var $author$project$Template$Helpers$addImage = $author$project$Template$Widget$Core$Image(
	{
		bf: $author$project$Template$Animation$fadeIn,
		ly: 'https://iili.io/2FphxdG.jpg',
		dB: 'contain',
		cs: $author$project$Entity$Style$shared('Image Widget')
	});
var $author$project$Template$Helpers$addMenuItemList = $author$project$Template$Widget$Core$MenuItemListWidget(
	{
		bf: $author$project$Template$Animation$fadeIn,
		k9: $author$project$Entity$Style$shared('Menu Item List - Description'),
		i7: '',
		E: '',
		hw: $author$project$Entity$Style$shared('Menu Item List - Description'),
		na: $author$project$Entity$Style$shared('Menu Item List - Title')
	});
var $author$project$Template$Helpers$addMenuPlanning = $author$project$Template$Widget$Core$MenuPlanning(
	{
		bf: $author$project$Template$Animation$flipVertical,
		kR: $author$project$Entity$Style$shared('Menu Planning - Calories'),
		ip: $author$project$Template$Widget$MenuPlanning$smallCard,
		iq: $elm$core$Maybe$Nothing,
		k9: $author$project$Entity$Style$shared('Menu Planning - Description'),
		gA: $author$project$Entity$Style$shared('Menu Planning - Food Components'),
		gL: $author$project$Entity$Style$shared('Menu Planning - Image'),
		da: $author$project$Entity$Style$bounded(
			{
				a$: $elm$core$Dict$fromList(
					_List_fromArray(
						[
							_Utils_Tuple2('visibility', 'visible'),
							_Utils_Tuple2('width', '98%'),
							_Utils_Tuple2('height', '98%')
						])),
				d1: true,
				d2: false
			}),
		gY: $author$project$Entity$Style$shared('Location'),
		ai: $elm$core$Maybe$Nothing,
		ej: 5,
		aj: _List_Nil,
		mf: $author$project$Entity$Style$shared('Menu Planning - Ratings'),
		hD: 1,
		mz: $elm$core$Maybe$Nothing,
		na: $author$project$Entity$Style$shared('Category Name')
	});
var $author$project$Template$Helpers$addTextBox = $author$project$Template$Widget$Core$TextBox(
	{
		bf: $author$project$Template$Animation$fadeIn,
		dB: A2(
			$author$project$Entity$Style$initBounded,
			_List_fromArray(
				[$author$project$Entity$Style$elSize]),
			_List_fromArray(
				[
					_Utils_Tuple2('width', '98%'),
					_Utils_Tuple2('height', '98%')
				])),
		cs: A2(
			$author$project$Entity$Style$initBounded,
			_List_fromArray(
				[$author$project$Entity$Style$textStyle]),
			_List_fromArray(
				[
					_Utils_Tuple2('font-size', '36px'),
					_Utils_Tuple2('font-family', 'Abel'),
					_Utils_Tuple2('text-align', 'center'),
					_Utils_Tuple2('color', '#FFFFFF')
				])),
		hO: 'Text'
	});
var $author$project$Template$Helpers$addYoutube = $author$project$Template$Widget$Core$Youtube(
	$author$project$Template$Widget$Youtube$video('1KlkD5ub4Cc'));
var $author$project$Template$Frame$sharedWidgetIds = function (frame) {
	return A2(
		$elm$core$List$filter,
		A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
		A2(
			$elm$core$List$map,
			function (sec) {
				switch (sec.$) {
					case 2:
						return '';
					case 1:
						var id = sec.a;
						return id;
					default:
						var id = sec.a;
						return '';
				}
			},
			$elm$core$List$concat(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.jJ;
					},
					frame.da))));
};
var $author$project$Template$Helpers$getSharedWidgetIds = function (template) {
	return $elm_community$list_extra$List$Extra$unique(
		$elm$core$List$concat(
			A2($elm$core$List$map, $author$project$Template$Frame$sharedWidgetIds, template.G)));
};
var $author$project$Pages$CfgDevice$Design$viewMdlIconButton = F4(
	function (model, index, _v0, onClick) {
		var iconName = _v0.a;
		var label = _v0.b;
		var attrs = _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'width', '100%'),
				A2($elm$html$Html$Attributes$style, 'margin-bottom', '12px')
			]);
		return A2(
			$aforemny$material_components_web_elm$Material$Button$outlined,
			A2(
				$aforemny$material_components_web_elm$Material$Button$setAttributes,
				attrs,
				A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config)),
			label);
	});
var $author$project$Pages$CfgDevice$Design$AddSharedWidget = F3(
	function (a, b, c) {
		return {$: 29, a: a, b: b, c: c};
	});
var $author$project$Pages$CfgDevice$Design$SelectSharedWidget = function (a) {
	return {$: 44, a: a};
};
var $author$project$Pages$CfgDevice$Design$viewSelectSharedWidgets = F3(
	function (model, template, position) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '89%'),
					A2($elm$html$Html$Attributes$style, 'padding', '12px'),
					$elm$html$Html$Attributes$class('mdl-shadow--2dp')
				]),
			_List_fromArray(
				[
					A5(
					$author$project$Select$view,
					$author$project$Pages$CfgDevice$Design$Select,
					_List_fromArray(
						[133, 423, 4]),
					model.r,
					$author$project$Select$string,
					_List_fromArray(
						[
							$author$project$Select$label(''),
							$author$project$Select$searchable,
							$author$project$Select$options(
							$author$project$Template$Helpers$getSharedWidgetIds(template)),
							$author$project$Select$onSelect($author$project$Pages$CfgDevice$Design$SelectSharedWidget),
							$author$project$Select$value(model.dx)
						])),
					function () {
					var onClick = function () {
						var _v0 = model.dx;
						if (!_v0.$) {
							var widgetName = _v0.a;
							return A3($author$project$Pages$CfgDevice$Design$AddSharedWidget, template, position, widgetName);
						} else {
							return $author$project$Pages$CfgDevice$Design$NoOp;
						}
					}();
					var isDisabled = _Utils_eq(model.dx, $elm$core$Maybe$Nothing);
					var attrs = _List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '100%')
						]);
					return A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2(
							$aforemny$material_components_web_elm$Material$Button$setAttributes,
							attrs,
							A2(
								$aforemny$material_components_web_elm$Material$Button$setDisabled,
								isDisabled,
								A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config))),
						'Add Shared Widget');
				}()
				]));
	});
var $author$project$Pages$CfgDevice$Design$viewAddNew = F3(
	function (model, template, position) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'flex-direction', 'column')
				]),
			_List_fromArray(
				[
					$author$project$Reusable$Header$subHeader('Select Widget'),
					A4(
					$author$project$Pages$CfgDevice$Design$viewMdlIconButton,
					model,
					_List_fromArray(
						[2000, 201]),
					_Utils_Tuple2(
						'text_fields',
						$author$project$Template$Widget$Core$displayName($author$project$Template$Helpers$addTextBox)),
					A3($author$project$Pages$CfgDevice$Design$AddWidget, template, position, $author$project$Template$Helpers$addTextBox)),
					A4(
					$author$project$Pages$CfgDevice$Design$viewMdlIconButton,
					model,
					_List_fromArray(
						[2000, 200]),
					_Utils_Tuple2(
						'image',
						$author$project$Template$Widget$Core$displayName($author$project$Template$Helpers$addImage)),
					A3($author$project$Pages$CfgDevice$Design$AddWidget, template, position, $author$project$Template$Helpers$addImage)),
					A4(
					$author$project$Pages$CfgDevice$Design$viewMdlIconButton,
					model,
					_List_fromArray(
						[2000, 202]),
					_Utils_Tuple2(
						'ondemand_video',
						$author$project$Template$Widget$Core$displayName($author$project$Template$Helpers$addYoutube)),
					A3($author$project$Pages$CfgDevice$Design$AddWidget, template, position, $author$project$Template$Helpers$addYoutube)),
					A4(
					$author$project$Pages$CfgDevice$Design$viewMdlIconButton,
					model,
					_List_fromArray(
						[2000, 203]),
					_Utils_Tuple2(
						'restaurant',
						$author$project$Template$Widget$Core$displayName($author$project$Template$Helpers$addMenuPlanning)),
					A3($author$project$Pages$CfgDevice$Design$AddWidget, template, position, $author$project$Template$Helpers$addMenuPlanning)),
					A4(
					$author$project$Pages$CfgDevice$Design$viewMdlIconButton,
					model,
					_List_fromArray(
						[2000, 204]),
					_Utils_Tuple2(
						'list',
						$author$project$Template$Widget$Core$displayName($author$project$Template$Helpers$addMenuItemList)),
					A3($author$project$Pages$CfgDevice$Design$AddWidget, template, position, $author$project$Template$Helpers$addMenuItemList)),
					$elm$core$List$isEmpty(
					$author$project$Template$Helpers$getSharedWidgetIds(template)) ? $elm$html$Html$text('') : A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Reusable$Header$subHeader('Shared Widgets'),
							A3($author$project$Pages$CfgDevice$Design$viewSelectSharedWidgets, model, template, position)
						]))
				]));
	});
var $author$project$Pages$CfgDevice$Design$FrameBackground = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Pages$CfgDevice$Design$OpenSyncBackgroundDialog = function (a) {
	return {$: 84, a: a};
};
var $author$project$Pages$CfgDevice$Design$OpenUploadImageDialog = function (a) {
	return {$: 93, a: a};
};
var $author$project$Pages$CfgDevice$Design$ToggleStylePanel = function (a) {
	return {$: 31, a: a};
};
var $author$project$ColorPicker$Gradients = function (a) {
	return {$: 2, a: a};
};
var $author$project$ColorPicker$showGradients = function (val) {
	return $author$project$ColorPicker$Gradients(val);
};
var $rtfeldman$elm_css$Css$Transitions$Margin = 55;
var $rtfeldman$elm_css$Css$Transitions$margin = $rtfeldman$elm_css$Css$Transitions$durationTransition(55);
var $rtfeldman$elm_css$Css$paddingTop = $rtfeldman$elm_css$Css$prop1('padding-top');
var $rtfeldman$elm_css$Html$Styled$styled = F4(
	function (fn, styles, attrs, children) {
		return A2(
			fn,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Internal$css(styles),
				attrs),
			children);
	});
var $author$project$Reusable$ExpansionPanel$viewActions = F2(
	function (config, node) {
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$paddingTop(
					$rtfeldman$elm_css$Css$px(16)),
					$rtfeldman$elm_css$Css$paddingBottom(
					$rtfeldman$elm_css$Css$px(16)),
					config.ef ? $rtfeldman$elm_css$Css$displayFlex : $rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none),
					$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd),
					A2($rtfeldman$elm_css$Css$property, 'animation', '1.0s fade')
				]),
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$fromUnstyled(node)
				]));
	});
var $author$project$Reusable$ExpansionPanel$viewContent = F2(
	function (config, content) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A4(
							$rtfeldman$elm_css$Css$margin4,
							$rtfeldman$elm_css$Css$px(8),
							$rtfeldman$elm_css$Css$px(24),
							$rtfeldman$elm_css$Css$px(8),
							$rtfeldman$elm_css$Css$px(24)),
							config.ef ? $rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inherit) : $rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$fromUnstyled(content)
				]));
	});
var $author$project$Reusable$ExpansionPanel$iconButton = F2(
	function (icon, msg) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('material-icons md-24'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('mdl-button--icon'),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero)
						])),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(icon)
				]));
	});
var $author$project$Reusable$ExpansionPanel$viewTitle = function (config) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
						A2(
						$rtfeldman$elm_css$Css$padding2,
						$rtfeldman$elm_css$Css$px(0),
						$rtfeldman$elm_css$Css$px(24)),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						config.ef ? $rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$px(64)) : $rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$px(48)),
						A2($rtfeldman$elm_css$Css$property, 'border-bottom', '1px solid rgba(0,0,0,0.1)'),
						A2($rtfeldman$elm_css$Css$property, 'transition', 'height 0.4s ease-in-out')
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$fromUnstyled(config.c9),
				config.ef ? A2($author$project$Reusable$ExpansionPanel$iconButton, 'expand_less', config.hh) : A2($author$project$Reusable$ExpansionPanel$iconButton, 'expand_more', config.hh)
			]));
};
var $author$project$Reusable$ExpansionPanel$view = function (config) {
	return $rtfeldman$elm_css$Html$Styled$toUnstyled(
		A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							config.ef ? A2(
							$rtfeldman$elm_css$Css$margin2,
							$rtfeldman$elm_css$Css$px(12),
							$rtfeldman$elm_css$Css$px(0)) : A2(
							$rtfeldman$elm_css$Css$margin2,
							$rtfeldman$elm_css$Css$px(0),
							$rtfeldman$elm_css$Css$px(0)),
							$rtfeldman$elm_css$Css$Transitions$transition(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$Transitions$margin(500)
								])),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$pct(98)),
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$backgroundColor(
							$rtfeldman$elm_css$Css$hex('#FFFFFF')),
							A2(
							$rtfeldman$elm_css$Css$property,
							'box-shadow',
							A2(
								$elm$core$String$join,
								',',
								_List_fromArray(
									['0 2px 4px 0 rgba(0,0,0,0.14)', '0 3px 5px 0 rgba(0,0,0,0.12)', '0 1px 5px 0 rgba(0,0,0,0.20);'])))
						]))
				]),
			_List_fromArray(
				[
					$author$project$Reusable$ExpansionPanel$viewTitle(config),
					A2($author$project$Reusable$ExpansionPanel$viewContent, config, config.k_),
					function () {
					var _v0 = config.kk;
					if (_v0.$ === 1) {
						return $rtfeldman$elm_css$Html$Styled$fromUnstyled(
							$elm$html$Html$text(''));
					} else {
						var actions = _v0.a;
						return A2($author$project$Reusable$ExpansionPanel$viewActions, config, actions);
					}
				}()
				])));
};
var $author$project$Template$Widget$Background$viewDynamicBgImage = F2(
	function (imageUrl, imageName) {
		return A4(
			$author$project$Template$Widget$Background$BgLocalImage,
			_Utils_ap(imageUrl, imageName),
			'./backgrounds/' + imageName,
			65,
			0);
	});
var $author$project$Pages$CfgDevice$Design$viewUnsplashImg = F4(
	function (model, _v0, template, frIndex) {
		var imageName = _v0.a;
		var imgUrl = _v0.b;
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '170px'),
					A2($elm$html$Html$Attributes$style, 'height', '127.5px'),
					A2($elm$html$Html$Attributes$style, 'border', '0'),
					A2($elm$html$Html$Attributes$style, 'padding', '0'),
					A2($elm$html$Html$Attributes$style, 'margin', '2px 0px'),
					A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
					A2($elm$html$Html$Attributes$style, 'transform', 'scale(0.95)'),
					A2($elm$html$Html$Attributes$style, 'appearance', 'none'),
					$elm$html$Html$Attributes$class('elevation-e2'),
					$elm$html$Html$Events$onClick(
					A3(
						$author$project$Pages$CfgDevice$Design$FrameBackground,
						template,
						frIndex,
						A2($author$project$Template$Widget$Background$viewDynamicBgImage, imgUrl, imageName)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(
							_Utils_ap(imgUrl, imageName)),
							A2($elm$html$Html$Attributes$style, 'max-width', '100%'),
							A2($elm$html$Html$Attributes$style, 'max-height', '100%'),
							$elm$html$Html$Attributes$alt(imageName)
						]),
					_List_Nil)
				]));
	});
var $author$project$Pages$CfgDevice$Design$viewBackgroundImgGrid = F3(
	function (model, template, frIndex) {
		var imageIds = model.ah;
		var dictArray = _List_Nil;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'width', '100%'),
					A2($elm$html$Html$Attributes$style, 'flex-direction', 'row'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
					A2($elm$html$Html$Attributes$style, 'justift-content', 'center'),
					A2($elm$html$Html$Attributes$style, 'flex-wrap', 'wrap'),
					A2($elm$html$Html$Attributes$style, 'max-height', '240px'),
					A2($elm$html$Html$Attributes$style, 'overflow', 'auto')
				]),
			function () {
				switch (imageIds.$) {
					case 0:
						return _List_fromArray(
							[
								$elm$html$Html$text('Images are loading...')
							]);
					case 1:
						return _List_fromArray(
							[
								$elm$html$Html$text('Unable to load images at this time')
							]);
					default:
						var images = imageIds.a;
						return $elm$core$Dict$isEmpty(images) ? _List_fromArray(
							[
								$elm$html$Html$text('No Images in your library or images are loading')
							]) : A2(
							$elm$core$List$map,
							function (a) {
								return A4($author$project$Pages$CfgDevice$Design$viewUnsplashImg, model, a, template, frIndex);
							},
							$elm$core$Dict$toList(images));
				}
			}());
	});
var $author$project$Pages$CfgDevice$Design$viewBgImageSettingsEditor = F6(
	function (model, template, frIndex, imgUrl, _v0, onChange) {
		var brightness = _v0.a;
		var blur = _v0.b;
		var changeBrightness = function (val) {
			return A3(
				$author$project$Pages$CfgDevice$Design$FrameBackground,
				template,
				frIndex,
				A2(onChange, val, blur));
		};
		var changeBlur = function (val) {
			return A3(
				$author$project$Pages$CfgDevice$Design$FrameBackground,
				template,
				frIndex,
				A2(onChange, brightness, val));
		};
		return $author$project$Reusable$ExpansionPanel$view(
			{
				kk: $elm$core$Maybe$Nothing,
				k_: $author$project$Reusable$Flex$viewVertical(
					_List_fromArray(
						[
							A2(
							$author$project$Reusable$Flex$viewLabelValue,
							'Brightness',
							_List_fromArray(
								[
									A2(
									$author$project$Reusable$Input$number,
									changeBrightness,
									_List_fromArray(
										[
											$author$project$Reusable$Input$value(brightness)
										]))
								])),
							A2(
							$author$project$Reusable$Slider$view,
							changeBrightness,
							_List_fromArray(
								[
									$author$project$Reusable$Slider$max(80),
									$author$project$Reusable$Slider$value(brightness)
								])),
							$author$project$Reusable$Separator$viewHorizontal,
							A2(
							$author$project$Reusable$Flex$viewLabelValue,
							'Blur',
							_List_fromArray(
								[
									A2(
									$author$project$Reusable$Input$number,
									changeBlur,
									_List_fromArray(
										[
											$author$project$Reusable$Input$value(blur)
										]))
								])),
							A2(
							$author$project$Reusable$Slider$view,
							changeBlur,
							_List_fromArray(
								[
									$author$project$Reusable$Slider$max(80),
									$author$project$Reusable$Slider$value(blur)
								]))
						])),
				ef: A2($elm$core$Set$member, 'bg-img-props', model.S),
				c9: $elm$html$Html$text('Image Settings'),
				hh: $author$project$Pages$CfgDevice$Design$ToggleStylePanel('bg-img-props')
			});
	});
var $author$project$Template$Widget$Background$viewMini = function (bgType) {
	var imgStyle = F3(
		function (url, brightness, blur) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'background-image', 'url(' + (url + ')')),
						A2($elm$html$Html$Attributes$style, 'width', '1920px'),
						A2($elm$html$Html$Attributes$style, 'height', '1080px'),
						A2(
						$elm$html$Html$Attributes$style,
						'filter',
						'blur(' + ($elm$core$String$fromFloat(blur) + ('px) brightness(' + ($elm$core$String$fromFloat(brightness) + '%)')))),
						A2($elm$html$Html$Attributes$style, 'background-size', 'cover'),
						A2($elm$html$Html$Attributes$style, 'background-repeat', 'no-repeat'),
						A2($elm$html$Html$Attributes$style, 'background-position', 'center'),
						A2($elm$html$Html$Attributes$style, 'transform', 'scale(0.116)'),
						A2($elm$html$Html$Attributes$style, 'transform-origin', 'left top')
					]),
				_List_Nil);
		});
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'height', '124px'),
				A2($elm$html$Html$Attributes$style, 'width', '220px'),
				A2($elm$html$Html$Attributes$style, 'border', '2px solid black'),
				A2($elm$html$Html$Attributes$style, 'border-radius', '6px'),
				A2($elm$html$Html$Attributes$style, 'margin-bottom', '12px'),
				A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
				function () {
				if (!bgType.$) {
					var color = bgType.a;
					return A2($elm$html$Html$Attributes$style, 'background', color);
				} else {
					return A2($elm$html$Html$Attributes$style, 'background', 'black');
				}
			}()
			]),
		_List_fromArray(
			[
				function () {
				switch (bgType.$) {
					case 1:
						var imgUrl = bgType.a;
						var brightness = bgType.b;
						var blur = bgType.c;
						return A3(imgStyle, imgUrl, brightness, blur);
					case 2:
						var imgUrl = bgType.a;
						var brightness = bgType.c;
						var blur = bgType.d;
						return A3(imgStyle, imgUrl, brightness, blur);
					default:
						return $elm$html$Html$text('');
				}
			}()
			]));
};
var $author$project$Pages$CfgDevice$Design$viewBgEditor = F3(
	function (model, template, _v0) {
		var frIndex = _v0.a;
		var background = _v0.b.f6;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'max-height', '65vh'),
					A2($elm$html$Html$Attributes$style, 'overflow-y', 'scroll')
				]),
			_List_fromArray(
				[
					$author$project$Reusable$Flex$viewVertical(
					_List_fromArray(
						[
							$author$project$Reusable$Header$subHeader('Background Editor'),
							function () {
							switch (background.$) {
								case 1:
									var imgUrl = background.a;
									var brightness = background.b;
									var blur = background.c;
									var unspashReplaceUrlCheck = A2($elm$core$String$contains, 'unsplash', imgUrl) ? '' : imgUrl;
									return $aforemny$material_components_web_elm$Material$TextField$outlined(
										A2(
											$aforemny$material_components_web_elm$Material$TextField$setAttributes,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'width', '100%'),
													A2($elm$html$Html$Attributes$style, 'margin-bottom', '12px'),
													A2($elm$html$Html$Attributes$style, 'margin-top', '12px')
												]),
											A2(
												$aforemny$material_components_web_elm$Material$TextField$setValue,
												$elm$core$Maybe$Just(unspashReplaceUrlCheck),
												A2(
													$aforemny$material_components_web_elm$Material$TextField$setLabel,
													$elm$core$Maybe$Just('Image Url'),
													$aforemny$material_components_web_elm$Material$TextField$config))));
								case 2:
									var imgUrl = background.a;
									var b = background.b;
									var brightness = background.c;
									var blur = background.d;
									var unspashUrlCheck = A2($elm$core$String$contains, 'unsplash', imgUrl) ? '' : imgUrl;
									return $aforemny$material_components_web_elm$Material$TextField$outlined(
										A2(
											$aforemny$material_components_web_elm$Material$TextField$setAttributes,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'width', '100%'),
													A2($elm$html$Html$Attributes$style, 'margin-bottom', '12px'),
													A2($elm$html$Html$Attributes$style, 'margin-top', '12px')
												]),
											A2(
												$aforemny$material_components_web_elm$Material$TextField$setValue,
												$elm$core$Maybe$Just(unspashUrlCheck),
												A2(
													$aforemny$material_components_web_elm$Material$TextField$setLabel,
													$elm$core$Maybe$Just('Image Url'),
													$aforemny$material_components_web_elm$Material$TextField$config))));
								default:
									return $elm$html$Html$text('');
							}
						}(),
							$author$project$Template$Widget$Background$viewMini(background),
							$author$project$Reusable$ExpansionPanel$view(
							{
								kk: $elm$core$Maybe$Nothing,
								k_: $author$project$Reusable$Flex$viewVertical(
									_List_fromArray(
										[
											A2(
											$author$project$Reusable$Flex$viewLabelValue,
											'Background Color',
											_List_fromArray(
												[
													A4(
													$author$project$ColorPicker$view,
													$author$project$Pages$CfgDevice$Design$ColorPicker,
													_List_fromArray(
														[2]),
													model.aA,
													_List_fromArray(
														[
															$author$project$ColorPicker$showGradients(true),
															$author$project$ColorPicker$value(
															function () {
																if (!background.$) {
																	var val = background.a;
																	return val;
																} else {
																	return '#FFFFFF';
																}
															}()),
															$author$project$ColorPicker$onChange(
															function (color) {
																return A3(
																	$author$project$Pages$CfgDevice$Design$FrameBackground,
																	template,
																	frIndex,
																	$author$project$Template$Widget$Background$bgColor(color));
															})
														]))
												]))
										])),
								ef: A2($elm$core$Set$member, 'bg-img-style', model.S),
								c9: $elm$html$Html$text('Color'),
								hh: $author$project$Pages$CfgDevice$Design$ToggleStylePanel('bg-img-style')
							}),
							$author$project$Reusable$ExpansionPanel$view(
							{
								kk: $elm$core$Maybe$Nothing,
								k_: A3($author$project$Pages$CfgDevice$Design$viewBackgroundImgGrid, model, template, frIndex),
								ef: A2($elm$core$Set$member, 'bg-img-lib', model.S),
								c9: $elm$html$Html$text('Background Images'),
								hh: $author$project$Pages$CfgDevice$Design$ToggleStylePanel('bg-img-lib')
							}),
							function () {
							switch (background.$) {
								case 0:
									return $elm$html$Html$text('');
								case 1:
									var imgUrl = background.a;
									var brightness = background.b;
									var blur = background.c;
									return A6(
										$author$project$Pages$CfgDevice$Design$viewBgImageSettingsEditor,
										model,
										template,
										frIndex,
										imgUrl,
										_Utils_Tuple2(brightness, blur),
										$author$project$Template$Widget$Background$BgImage(imgUrl));
								default:
									var a = background.a;
									var b = background.b;
									var brightness = background.c;
									var blur = background.d;
									return A6(
										$author$project$Pages$CfgDevice$Design$viewBgImageSettingsEditor,
										model,
										template,
										frIndex,
										b,
										_Utils_Tuple2(brightness, blur),
										A2($author$project$Template$Widget$Background$BgLocalImage, a, b));
							}
						}(),
							function () {
							var onClick = $author$project$Pages$CfgDevice$Design$OpenUploadImageDialog(background);
							var attrs = _List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'width', '100%'),
									A2($elm$html$Html$Attributes$style, 'margin', '5px 0px  20px 0px')
								]);
							return A2(
								$aforemny$material_components_web_elm$Material$Button$raised,
								A2(
									$aforemny$material_components_web_elm$Material$Button$setAttributes,
									attrs,
									A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config)),
								'Upload Image');
						}(),
							function () {
							var onClick = $author$project$Pages$CfgDevice$Design$OpenSyncBackgroundDialog(background);
							var attrs = _List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'width', '100%'),
									A2($elm$html$Html$Attributes$style, 'margin', '5px 0px  20px 0px')
								]);
							return A2(
								$aforemny$material_components_web_elm$Material$Button$raised,
								A2(
									$aforemny$material_components_web_elm$Material$Button$setAttributes,
									attrs,
									A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config)),
								'Sync Background');
						}()
						]))
				]));
	});
var $author$project$Pages$CfgDevice$Design$UpdateWidget = F3(
	function (a, b, c) {
		return {$: 15, a: a, b: b, c: c};
	});
var $author$project$Template$Animation$available = _List_fromArray(
	[0, 1, 2, 5, 3, 4, 6, 7]);
var $author$project$Template$Animation$toString = function (effect) {
	switch (effect) {
		case 0:
			return 'Appear';
		case 1:
			return 'Fade In (Center)';
		case 2:
			return 'Fade In (Top)';
		case 5:
			return 'Fade In (Bottom)';
		case 4:
			return 'Fade In (Right)';
		case 3:
			return 'Fade In (Left)';
		case 6:
			return 'Flip Vertical';
		default:
			return 'Flip Horizontal';
	}
};
var $author$project$Pages$CfgDevice$Design$selectAnimation = {dS: $elm$core$Basics$eq, d8: $author$project$Template$Animation$toString, ep: $author$project$Template$Animation$toString};
var $author$project$Pages$CfgDevice$Design$OpenImgLibrary = {$: 110};
var $author$project$Pages$CfgDevice$Design$viewImageLib = function (model) {
	var attrs = _List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'width', '100%')
		]);
	return A2(
		$aforemny$material_components_web_elm$Material$Button$raised,
		A2(
			$aforemny$material_components_web_elm$Material$Button$setAttributes,
			attrs,
			A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$CfgDevice$Design$OpenImgLibrary, $aforemny$material_components_web_elm$Material$Button$config)),
		'Choose Image');
};
var $author$project$Pages$CfgDevice$Design$viewImageCfg = F4(
	function (model, template, position, _v0) {
		var wid = _v0.a;
		var config = _v0.b;
		return $author$project$Reusable$Card$viewSidebarCard(
			_List_fromArray(
				[
					function () {
					var onInput = function (val) {
						return A3(
							$author$project$Pages$CfgDevice$Design$UpdateWidget,
							template,
							wid,
							$author$project$Template$Widget$Core$Image(
								_Utils_update(
									config,
									{ly: val})));
					};
					return $aforemny$material_components_web_elm$Material$TextArea$outlined(
						A2(
							$aforemny$material_components_web_elm$Material$TextArea$setOnInput,
							onInput,
							A2(
								$aforemny$material_components_web_elm$Material$TextArea$setValue,
								$elm$core$Maybe$Just(config.ly),
								A2(
									$aforemny$material_components_web_elm$Material$TextArea$setLabel,
									$elm$core$Maybe$Just('Image URL'),
									$aforemny$material_components_web_elm$Material$TextArea$config))));
				}(),
					A5(
					$author$project$Select$view,
					$author$project$Pages$CfgDevice$Design$Select,
					$author$project$Pages$CfgDevice$Design$getPositionIndex(position),
					model.r,
					$author$project$Pages$CfgDevice$Design$selectAnimation,
					_List_fromArray(
						[
							$author$project$Select$label('Animation'),
							$author$project$Select$options($author$project$Template$Animation$available),
							$author$project$Select$value(
							$elm$core$Maybe$Just(config.bf)),
							$author$project$Select$onSelect(
							function (val) {
								return A3(
									$author$project$Pages$CfgDevice$Design$UpdateWidget,
									template,
									wid,
									$author$project$Template$Widget$Core$Image(
										_Utils_update(
											config,
											{bf: val})));
							})
						])),
					A5(
					$author$project$Select$view,
					$author$project$Pages$CfgDevice$Design$Select,
					_List_fromArray(
						[12345]),
					model.r,
					$author$project$Select$string,
					_List_fromArray(
						[
							$author$project$Select$label('Image Size'),
							$author$project$Select$options(
							_List_fromArray(
								['contain', 'cover'])),
							$author$project$Select$onSelect(
							function (val) {
								return A3(
									$author$project$Pages$CfgDevice$Design$UpdateWidget,
									template,
									wid,
									$author$project$Template$Widget$Core$Image(
										_Utils_update(
											config,
											{dB: val})));
							}),
							$author$project$Select$value(
							$elm$core$Maybe$Just(config.dB))
						])),
					$author$project$Pages$CfgDevice$Design$viewImageLib(model)
				]));
	});
var $author$project$Pages$CfgDevice$Design$viewMenuItemCfg = F5(
	function (viewCfg, model, template, position, _v0) {
		var wid = _v0.a;
		var config = _v0.b;
		return $author$project$Reusable$Card$viewSidebarCard(
			_List_fromArray(
				[
					A5(
					$author$project$Select$view,
					$author$project$Pages$CfgDevice$Design$Select,
					$author$project$Pages$CfgDevice$Design$getPositionIndex(position),
					model.r,
					{dS: $elm$core$Basics$eq, d8: $elm$core$Tuple$second, ep: $elm$core$Tuple$second},
					_List_fromArray(
						[
							$author$project$Select$label('List Name'),
							$author$project$Select$searchable,
							$author$project$Select$options(viewCfg.g1),
							$author$project$Select$value(
							A2(
								$elm$core$Maybe$andThen,
								function (a) {
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(config.i7, a));
								},
								A2(
									$elm$core$Dict$get,
									config.i7,
									$elm$core$Dict$fromList(viewCfg.g1)))),
							$author$project$Select$onSelect(
							function (_v1) {
								var listId = _v1.a;
								return A3(
									$author$project$Pages$CfgDevice$Design$UpdateWidget,
									template,
									wid,
									$author$project$Template$Widget$Core$MenuItemListWidget(
										_Utils_update(
											config,
											{i7: listId})));
							})
						])),
					A5(
					$author$project$Select$view,
					$author$project$Pages$CfgDevice$Design$Select,
					A2(
						$elm$core$List$cons,
						123,
						$author$project$Pages$CfgDevice$Design$getPositionIndex(position)),
					model.r,
					$author$project$Pages$CfgDevice$Design$selectAnimation,
					_List_fromArray(
						[
							$author$project$Select$label('Animation'),
							$author$project$Select$options($author$project$Template$Animation$available),
							$author$project$Select$value(
							$elm$core$Maybe$Just(config.bf)),
							$author$project$Select$onSelect(
							function (val) {
								return A3(
									$author$project$Pages$CfgDevice$Design$UpdateWidget,
									template,
									wid,
									$author$project$Template$Widget$Core$MenuItemListWidget(
										_Utils_update(
											config,
											{bf: val})));
							})
						]))
				]));
	});
var $author$project$Pages$CfgDevice$Design$MarketingName = function (a) {
	return {$: 45, a: a};
};
var $author$project$Pages$CfgDevice$Design$OpenShareEffectDialog = function (a) {
	return {$: 90, a: a};
};
var $author$project$Template$Widget$MenuPlanning$availableCardTypes = _List_fromArray(
	[0, 1, 2, 3]);
var $author$project$Template$Widget$MenuPlanning$cardSizeName = function (cardSize) {
	switch (cardSize) {
		case 0:
			return 'Image Overlay Card';
		case 1:
			return 'Big Card';
		case 2:
			return 'Small Card';
		default:
			return 'Compact Card';
	}
};
var $author$project$Reusable$Input$Max = function (a) {
	return {$: 0, a: a};
};
var $author$project$Reusable$Input$max = function (val) {
	return $author$project$Reusable$Input$Max(val);
};
var $author$project$Reusable$Input$Min = function (a) {
	return {$: 1, a: a};
};
var $author$project$Reusable$Input$min = function (val) {
	return $author$project$Reusable$Input$Min(val);
};
var $author$project$Reusable$Flex$viewSpaceEvenly = function (nodes) {
	return $rtfeldman$elm_css$Html$Styled$toUnstyled(
		A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$pct(100)),
							A2($rtfeldman$elm_css$Css$property, 'justify-content', 'space-evenly'),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
						]))
				]),
			A2($elm$core$List$map, $rtfeldman$elm_css$Html$Styled$fromUnstyled, nodes)));
};
var $author$project$Pages$CfgDevice$Design$viewMenuPlanningCfg = F4(
	function (model, template, position, _v0) {
		var wid = _v0.a;
		var config = _v0.b;
		var smallX = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'font-size', '8px'),
					A2($elm$html$Html$Attributes$style, 'text-transform', 'lowercase')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('x')
				]));
		var setScaleFactor = function (val) {
			return A3(
				$author$project$Pages$CfgDevice$Design$UpdateWidget,
				template,
				wid,
				$author$project$Template$Widget$Core$MenuPlanning(
					_Utils_update(
						config,
						{hD: val})));
		};
		var onChangeNumItems = function (val) {
			return A3(
				$author$project$Pages$CfgDevice$Design$UpdateWidget,
				template,
				wid,
				$author$project$Template$Widget$Core$MenuPlanning(
					_Utils_update(
						config,
						{
							ej: $elm$core$Basics$round(val)
						})));
		};
		var clearMarketingName = A3(
			$author$project$Pages$CfgDevice$Design$UpdateWidget,
			template,
			wid,
			$author$project$Template$Widget$Core$MenuPlanning(
				_Utils_update(
					config,
					{ai: $elm$core$Maybe$Nothing})));
		var checkIfEmpty = function (marketingName) {
			return A2(
				$elm$core$Maybe$andThen,
				function (name) {
					return $elm$core$String$isEmpty(name) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(name);
				},
				marketingName);
		};
		var updateMarketingName = A3(
			$author$project$Pages$CfgDevice$Design$UpdateWidget,
			template,
			wid,
			$author$project$Template$Widget$Core$MenuPlanning(
				_Utils_update(
					config,
					{
						ai: checkIfEmpty(model.ai)
					})));
		return $author$project$Reusable$Card$viewSidebarCard(
			_List_fromArray(
				[
					$author$project$Reusable$Flex$viewHorizontal(
					_List_fromArray(
						[
							A5(
							$author$project$Select$view,
							$author$project$Pages$CfgDevice$Design$Select,
							A2(
								$elm$core$List$cons,
								178,
								$author$project$Pages$CfgDevice$Design$getPositionIndex(position)),
							model.r,
							$author$project$Select$string,
							_List_fromArray(
								[
									$author$project$Select$label('Serving Line (Location)'),
									$author$project$Select$searchable,
									$author$project$Select$options(model.jR),
									$author$project$Select$value(config.mz),
									$author$project$Select$onSelect(
									function (val) {
										return A3(
											$author$project$Pages$CfgDevice$Design$UpdateWidget,
											template,
											wid,
											$author$project$Template$Widget$Core$MenuPlanning(
												_Utils_update(
													config,
													{
														mz: $elm$core$Maybe$Just(val)
													})));
									})
								])),
							function () {
							if (_Utils_eq(config.mz, $elm$core$Maybe$Nothing)) {
								return $elm$html$Html$text('');
							} else {
								var onClick = A3(
									$author$project$Pages$CfgDevice$Design$UpdateWidget,
									template,
									wid,
									$author$project$Template$Widget$Core$MenuPlanning(
										_Utils_update(
											config,
											{mz: $elm$core$Maybe$Nothing})));
								return A2(
									$aforemny$material_components_web_elm$Material$IconButton$iconButton,
									A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, onClick, $aforemny$material_components_web_elm$Material$IconButton$config),
									$aforemny$material_components_web_elm$Material$IconButton$icon('clear'));
							}
						}()
						])),
					A5(
					$author$project$Select$view,
					$author$project$Pages$CfgDevice$Design$Select,
					A2(
						$elm$core$List$cons,
						1,
						$author$project$Pages$CfgDevice$Design$getPositionIndex(position)),
					model.r,
					$author$project$Select$string,
					_List_fromArray(
						[
							$author$project$Select$label('Category'),
							$author$project$Select$searchable,
							$author$project$Select$options(model.eU),
							$author$project$Select$value(config.iq),
							$author$project$Select$onSelect(
							function (val) {
								return A3(
									$author$project$Pages$CfgDevice$Design$UpdateWidget,
									template,
									wid,
									$author$project$Template$Widget$Core$MenuPlanning(
										_Utils_update(
											config,
											{
												iq: $elm$core$Maybe$Just(val)
											})));
							})
						])),
					$author$project$Reusable$Flex$viewHorizontal(
					_List_fromArray(
						[
							function () {
							var value = function () {
								var _v1 = _Utils_Tuple2(config.ai, model.ai);
								if (!_v1.a.$) {
									if (_v1.b.$ === 1) {
										var name = _v1.a.a;
										var _v2 = _v1.b;
										return name;
									} else {
										var editedName = _v1.b.a;
										return editedName;
									}
								} else {
									if (!_v1.b.$) {
										var _v3 = _v1.a;
										var editedName = _v1.b.a;
										return editedName;
									} else {
										var _v4 = _v1.a;
										var _v5 = _v1.b;
										return '';
									}
								}
							}();
							return $aforemny$material_components_web_elm$Material$TextField$outlined(
								A2(
									$aforemny$material_components_web_elm$Material$TextField$setAttributes,
									_List_fromArray(
										[
											$author$project$Utils$onEnter(updateMarketingName)
										]),
									A2(
										$aforemny$material_components_web_elm$Material$TextField$setOnInput,
										$author$project$Pages$CfgDevice$Design$MarketingName,
										A2(
											$aforemny$material_components_web_elm$Material$TextField$setValue,
											$elm$core$Maybe$Just(value),
											A2(
												$aforemny$material_components_web_elm$Material$TextField$setLabel,
												$elm$core$Maybe$Just('Marketing Name'),
												$aforemny$material_components_web_elm$Material$TextField$config)))));
						}(),
							function () {
							var isSame = function () {
								var _v6 = _Utils_Tuple2(model.ai, config.ai);
								_v6$2:
								while (true) {
									if (!_v6.a.$) {
										if (!_v6.b.$) {
											var name1 = _v6.a.a;
											var name2 = _v6.b.a;
											return _Utils_eq(name1, name2);
										} else {
											break _v6$2;
										}
									} else {
										if (!_v6.b.$) {
											var _v7 = _v6.a;
											return true;
										} else {
											break _v6$2;
										}
									}
								}
								return false;
							}();
							var onClick = isSame ? clearMarketingName : updateMarketingName;
							var icon = isSame ? $aforemny$material_components_web_elm$Material$IconButton$icon('clear') : $aforemny$material_components_web_elm$Material$IconButton$icon('save');
							return A2(
								$aforemny$material_components_web_elm$Material$IconButton$iconButton,
								A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, onClick, $aforemny$material_components_web_elm$Material$IconButton$config),
								icon);
						}()
						])),
					A5(
					$author$project$Select$view,
					$author$project$Pages$CfgDevice$Design$Select,
					A2(
						$elm$core$List$cons,
						2,
						$author$project$Pages$CfgDevice$Design$getPositionIndex(position)),
					model.r,
					{dS: $elm$core$Basics$eq, d8: $author$project$Template$Widget$MenuPlanning$cardSizeName, ep: $author$project$Template$Widget$MenuPlanning$cardSizeName},
					_List_fromArray(
						[
							$author$project$Select$label('Card Type'),
							$author$project$Select$value(
							$elm$core$Maybe$Just(config.ip)),
							$author$project$Select$options($author$project$Template$Widget$MenuPlanning$availableCardTypes),
							$author$project$Select$onSelect(
							function (val) {
								return A3(
									$author$project$Pages$CfgDevice$Design$UpdateWidget,
									template,
									wid,
									$author$project$Template$Widget$Core$MenuPlanning(
										_Utils_update(
											config,
											{ip: val})));
							})
						])),
					A2(
					$author$project$Reusable$Flex$viewLabelValue,
					'Number of Items',
					_List_fromArray(
						[
							A2(
							$author$project$Reusable$Input$number,
							onChangeNumItems,
							_List_fromArray(
								[
									$author$project$Reusable$Input$value(config.ej),
									$author$project$Reusable$Input$min(1),
									$author$project$Reusable$Input$max(20)
								]))
						])),
					A2(
					$author$project$Reusable$Slider$view,
					onChangeNumItems,
					_List_fromArray(
						[
							$author$project$Reusable$Slider$max(20),
							$author$project$Reusable$Slider$min(1),
							$author$project$Reusable$Slider$value(config.ej)
						])),
					$author$project$Reusable$Flex$viewSpaceEvenly(
					_List_fromArray(
						[
							function () {
							var button = (config.hD === 1) ? $aforemny$material_components_web_elm$Material$Button$raised : $aforemny$material_components_web_elm$Material$Button$text;
							return A2(
								button,
								A2(
									$aforemny$material_components_web_elm$Material$Button$setAttributes,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'font-size', '12px')
										]),
									A2(
										$aforemny$material_components_web_elm$Material$Button$setOnClick,
										setScaleFactor(1),
										$aforemny$material_components_web_elm$Material$Button$config)),
								'1x');
						}(),
							function () {
							var button = (config.hD === 0.5) ? $aforemny$material_components_web_elm$Material$Button$raised : $aforemny$material_components_web_elm$Material$Button$text;
							return A2(
								button,
								A2(
									$aforemny$material_components_web_elm$Material$Button$setAttributes,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'font-size', '12px')
										]),
									A2(
										$aforemny$material_components_web_elm$Material$Button$setOnClick,
										setScaleFactor(0.5),
										$aforemny$material_components_web_elm$Material$Button$config)),
								'0.5x');
						}()
						])),
					$author$project$Reusable$Separator$viewHorizontal,
					$author$project$Reusable$Flex$viewHorizontal(
					_List_fromArray(
						[
							A5(
							$author$project$Select$view,
							$author$project$Pages$CfgDevice$Design$Select,
							$author$project$Pages$CfgDevice$Design$getPositionIndex(position),
							model.r,
							$author$project$Pages$CfgDevice$Design$selectAnimation,
							_List_fromArray(
								[
									$author$project$Select$label('Animation'),
									$author$project$Select$options($author$project$Template$Animation$available),
									$author$project$Select$value(
									$elm$core$Maybe$Just(config.bf)),
									$author$project$Select$onSelect(
									function (val) {
										return A3(
											$author$project$Pages$CfgDevice$Design$UpdateWidget,
											template,
											wid,
											$author$project$Template$Widget$Core$MenuPlanning(
												_Utils_update(
													config,
													{bf: val})));
									})
								])),
							A5(
							$author$project$Reusable$Tooltip$view,
							$author$project$Pages$CfgDevice$Design$Tooltip,
							_List_fromArray(
								[123, 234, 24]),
							model.fQ,
							_List_fromArray(
								[
									$author$project$Reusable$Tooltip$label('Sync Effect'),
									$author$project$Reusable$Tooltip$bottom
								]),
							A2(
								$aforemny$material_components_web_elm$Material$IconButton$iconButton,
								A2(
									$aforemny$material_components_web_elm$Material$IconButton$setOnClick,
									$author$project$Pages$CfgDevice$Design$OpenShareEffectDialog(
										$author$project$Template$Widget$Core$MenuPlanning(config)),
									$aforemny$material_components_web_elm$Material$IconButton$config),
								$aforemny$material_components_web_elm$Material$IconButton$icon('sync')))
						]))
				]));
	});
var $author$project$Pages$CfgDevice$Design$TextBoxVal = function (a) {
	return {$: 109, a: a};
};
var $author$project$Pages$CfgDevice$Design$viewTextBoxCfg = F4(
	function (model, template, position, _v0) {
		var wid = _v0.a;
		var config = _v0.b;
		var setValue = A3(
			$author$project$Pages$CfgDevice$Design$UpdateWidget,
			template,
			wid,
			$author$project$Template$Widget$Core$TextBox(
				_Utils_update(
					config,
					{hO: model.bJ})));
		return $author$project$Reusable$Card$viewSidebarCard(
			_List_fromArray(
				[
					function () {
					var value = $elm$core$String$isEmpty(model.bJ) ? config.hO : model.bJ;
					return $aforemny$material_components_web_elm$Material$TextField$outlined(
						A2(
							$aforemny$material_components_web_elm$Material$TextField$setAttributes,
							_List_fromArray(
								[
									$author$project$Utils$onEnter(setValue)
								]),
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setOnInput,
								$author$project$Pages$CfgDevice$Design$TextBoxVal,
								A2(
									$aforemny$material_components_web_elm$Material$TextField$setValue,
									$elm$core$Maybe$Just(value),
									A2(
										$aforemny$material_components_web_elm$Material$TextField$setLabel,
										$elm$core$Maybe$Just('Text'),
										$aforemny$material_components_web_elm$Material$TextField$config)))));
				}(),
					function () {
					var isDisabled = $elm$core$String$isEmpty(model.bJ);
					var attrs = _List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '100%')
						]);
					return A2(
						$aforemny$material_components_web_elm$Material$Button$outlined,
						A2(
							$aforemny$material_components_web_elm$Material$Button$setAttributes,
							attrs,
							A2(
								$aforemny$material_components_web_elm$Material$Button$setDisabled,
								isDisabled,
								A2($aforemny$material_components_web_elm$Material$Button$setOnClick, setValue, $aforemny$material_components_web_elm$Material$Button$config))),
						'Update');
				}(),
					$author$project$Reusable$Separator$viewHorizontal,
					A5(
					$author$project$Select$view,
					$author$project$Pages$CfgDevice$Design$Select,
					$author$project$Pages$CfgDevice$Design$getPositionIndex(position),
					model.r,
					$author$project$Pages$CfgDevice$Design$selectAnimation,
					_List_fromArray(
						[
							$author$project$Select$label('Animation'),
							$author$project$Select$options($author$project$Template$Animation$available),
							$author$project$Select$value(
							$elm$core$Maybe$Just(config.bf)),
							$author$project$Select$onSelect(
							function (val) {
								return A3(
									$author$project$Pages$CfgDevice$Design$UpdateWidget,
									template,
									wid,
									$author$project$Template$Widget$Core$TextBox(
										_Utils_update(
											config,
											{bf: val})));
							})
						]))
				]));
	});
var $author$project$Pages$CfgDevice$Design$ParseYoutubeUrl = function (a) {
	return {$: 60, a: a};
};
var $author$project$Pages$CfgDevice$Design$YoutubeUrl = function (a) {
	return {$: 59, a: a};
};
var $author$project$Pages$CfgDevice$Design$viewYoutubeCfg = F4(
	function (model, template, position, _v0) {
		var wid = _v0.a;
		var config = _v0.b;
		return $author$project$Reusable$Card$viewSidebarCard(
			_List_fromArray(
				[
					function () {
					var genLink = function (id) {
						return $elm$core$String$isEmpty(id) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('https://youtu.be/' + id);
					};
					var maybeLink = function () {
						var _v2 = config.ka;
						if (!_v2.$) {
							var id = _v2.a;
							return genLink(id);
						} else {
							var id = _v2.a;
							return genLink(id);
						}
					}();
					if (!maybeLink.$) {
						var link = maybeLink.a;
						return A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(link),
									$elm$html$Html$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(link)
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}(),
					$author$project$Reusable$Separator$viewHorizontal,
					$aforemny$material_components_web_elm$Material$TextArea$outlined(
					A2(
						$aforemny$material_components_web_elm$Material$TextArea$setOnInput,
						$author$project$Pages$CfgDevice$Design$YoutubeUrl,
						A2(
							$aforemny$material_components_web_elm$Material$TextArea$setValue,
							$elm$core$Maybe$Just(model.d4),
							A2(
								$aforemny$material_components_web_elm$Material$TextArea$setLabel,
								$elm$core$Maybe$Just('YouTube URL'),
								$aforemny$material_components_web_elm$Material$TextArea$config)))),
					A2(
					$aforemny$material_components_web_elm$Material$Button$outlined,
					A2(
						$aforemny$material_components_web_elm$Material$Button$setAttributes,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'width', '100%')
							]),
						A2(
							$aforemny$material_components_web_elm$Material$Button$setOnClick,
							$author$project$Pages$CfgDevice$Design$ParseYoutubeUrl(wid),
							$aforemny$material_components_web_elm$Material$Button$config)),
					'Set'),
					$author$project$Reusable$Separator$viewHorizontal,
					A2(
					$author$project$Reusable$Flex$viewLabelValue,
					'Width',
					_List_fromArray(
						[
							A2(
							$author$project$Reusable$Input$number,
							function (val) {
								return A3(
									$author$project$Pages$CfgDevice$Design$UpdateWidget,
									template,
									wid,
									$author$project$Template$Widget$Core$Youtube(
										_Utils_update(
											config,
											{gH: (val * 9) / 16, hY: val})));
							},
							_List_fromArray(
								[
									$author$project$Reusable$Input$value(config.hY),
									$author$project$Reusable$Input$min(0),
									$author$project$Reusable$Input$max(1000)
								]))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'font-size', '12px'),
							A2($elm$html$Html$Attributes$style, 'padding-top', '12px'),
							A2($elm$html$Html$Attributes$style, 'text-align', 'left'),
							A2($elm$html$Html$Attributes$style, 'line-height', '1rem')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Height is set automatically to maintain 16:9 aspect ratio')
						]))
				]));
	});
var $author$project$Pages$CfgDevice$Design$viewTemplateWidgetConfiguration = F5(
	function (viewCfg, model, template, position, _v0) {
		var wid = _v0.a;
		var widget = _v0.b;
		return $author$project$Reusable$Flex$viewVertical(
			_List_fromArray(
				[
					$author$project$Reusable$Header$subHeader('Widget Configuration'),
					function () {
					switch (widget.$) {
						case 0:
							return $elm$html$Html$text('');
						case 1:
							var config = widget.a;
							return A4(
								$author$project$Pages$CfgDevice$Design$viewTextBoxCfg,
								model,
								template,
								position,
								_Utils_Tuple2(wid, config));
						case 2:
							var config = widget.a;
							return A4(
								$author$project$Pages$CfgDevice$Design$viewImageCfg,
								model,
								template,
								position,
								_Utils_Tuple2(wid, config));
						case 3:
							var config = widget.a;
							return A4(
								$author$project$Pages$CfgDevice$Design$viewYoutubeCfg,
								model,
								template,
								position,
								_Utils_Tuple2(wid, config));
						case 4:
							var config = widget.a;
							return A4(
								$author$project$Pages$CfgDevice$Design$viewMenuPlanningCfg,
								model,
								template,
								position,
								_Utils_Tuple2(wid, config));
						default:
							var config = widget.a;
							return A5(
								$author$project$Pages$CfgDevice$Design$viewMenuItemCfg,
								viewCfg,
								model,
								template,
								position,
								_Utils_Tuple2(wid, config));
					}
				}()
				]));
	});
var $author$project$Pages$CfgDevice$Design$viewWidgetCfgEditor = F2(
	function (config, model) {
		var _v0 = _Utils_Tuple3(model.a, model.h, model.aw);
		if (_v0.a.$ === 4) {
			if (!_v0.c.$) {
				var template = _v0.a.a;
				var frameIndex = _v0.c.a;
				var _v1 = A2($elm_community$list_extra$List$Extra$getAt, frameIndex, template.G);
				if (!_v1.$) {
					var frame = _v1.a;
					return A3(
						$author$project$Pages$CfgDevice$Design$viewBgEditor,
						model,
						template,
						_Utils_Tuple2(frameIndex, frame));
				} else {
					return $author$project$Reusable$Header$subHeader('Select a frame to edit its background');
				}
			} else {
				if (!_v0.b.$) {
					var template = _v0.a.a;
					var position = _v0.b.a;
					var _v2 = _v0.c;
					var _v3 = A2($author$project$Template$Helpers$getWidgetId, template, position);
					if (!_v3.$) {
						var widgetId = _v3.a;
						var _v4 = A2($elm$core$Dict$get, widgetId, template.n);
						if (!_v4.$) {
							var widget = _v4.a;
							return $author$project$Reusable$Flex$viewVertical(
								_List_fromArray(
									[
										A5(
										$author$project$Pages$CfgDevice$Design$viewTemplateWidgetConfiguration,
										config,
										model,
										template,
										position,
										_Utils_Tuple2(widgetId, widget)),
										A2(
										$aforemny$material_components_web_elm$Material$Button$outlined,
										A2(
											$aforemny$material_components_web_elm$Material$Button$setAttributes,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'width', '100%')
												]),
											A2(
												$aforemny$material_components_web_elm$Material$Button$setDisabled,
												A2($author$project$Template$Helpers$isSharedWidget, position, template),
												A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$CfgDevice$Design$OpenSharedWidgetDialog, $aforemny$material_components_web_elm$Material$Button$config))),
										'Share Widget')
									]));
						} else {
							return $author$project$Reusable$Header$subHeader('Invalid Widget');
						}
					} else {
						return A3($author$project$Pages$CfgDevice$Design$viewAddNew, model, template, position);
					}
				} else {
					var _v5 = _v0.b;
					return $author$project$Reusable$Header$multiLineSubHeader('Select a widget to configure its properties');
				}
			}
		} else {
			return $author$project$Reusable$Header$subHeader('Widget Configuration');
		}
	});
var $author$project$Pages$CfgDevice$Design$OpenDelColumnDialog = {$: 72};
var $author$project$Pages$CfgDevice$Design$OpenDelSectionDialog = {$: 78};
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $author$project$Template$Helpers$getFrameOrientation = F2(
	function (maybePos, maybeTemplate) {
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Maybe$Just,
				function ($) {
					return $.fz;
				}),
			A2(
				$elm$core$Maybe$andThen,
				function (_v0) {
					var position = _v0.a;
					var template = _v0.b;
					return A2($elm_community$list_extra$List$Extra$getAt, position.ap, template.G);
				},
				A3(
					$elm$core$Maybe$map2,
					F2(
						function (a, b) {
							return _Utils_Tuple2(a, b);
						}),
					maybePos,
					maybeTemplate)));
	});
var $author$project$Pages$CfgDevice$Design$isSectionEmpty = F2(
	function (template, position) {
		var _v0 = A2($author$project$Template$Helpers$getWidgetId, template, position);
		if (!_v0.$) {
			return false;
		} else {
			return true;
		}
	});
var $author$project$Pages$CfgDevice$Design$isSectionFilled = F2(
	function (a, b) {
		return !A2($author$project$Pages$CfgDevice$Design$isSectionEmpty, a, b);
	});
var $author$project$Pages$CfgDevice$Design$AddBottomSection = F3(
	function (a, b, c) {
		return {$: 20, a: a, b: b, c: c};
	});
var $author$project$Pages$CfgDevice$Design$AddLeftSection = F3(
	function (a, b, c) {
		return {$: 17, a: a, b: b, c: c};
	});
var $author$project$Pages$CfgDevice$Design$AddRightSection = F3(
	function (a, b, c) {
		return {$: 18, a: a, b: b, c: c};
	});
var $author$project$Pages$CfgDevice$Design$AddTopSection = F3(
	function (a, b, c) {
		return {$: 19, a: a, b: b, c: c};
	});
var $author$project$Template$Frame$numColumns = function (_v0) {
	var layout = _v0.da;
	return $elm$core$List$length(layout);
};
var $author$project$Template$Frame$numRows = F2(
	function (colIndex, _v0) {
		var layout = _v0.da;
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $elm$core$List$length),
					function ($) {
						return $.jJ;
					}),
				A2($elm_community$list_extra$List$Extra$getAt, colIndex, layout)));
	});
var $author$project$Template$Helpers$canAddColumn = F2(
	function (_v0, template) {
		var frameIndex = _v0.ap;
		var columnIndex = _v0.C;
		var rowIndex = _v0.y;
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$andThen,
				function (frame) {
					var _v1 = frame.fz;
					if (!_v1) {
						return $elm$core$Maybe$Just(
							!($author$project$Template$Frame$numColumns(frame) >= 3));
					} else {
						return $elm$core$Maybe$Just(
							!(A2($author$project$Template$Frame$numRows, columnIndex, frame) >= 4));
					}
				},
				A2($elm_community$list_extra$List$Extra$getAt, frameIndex, template.G)));
	});
var $author$project$Template$Helpers$canAddSection = F2(
	function (_v0, template) {
		var frameIndex = _v0.ap;
		var columnIndex = _v0.C;
		var rowIndex = _v0.y;
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$andThen,
				function (frame) {
					var _v1 = frame.fz;
					if (!_v1) {
						return $elm$core$Maybe$Just(
							!(A2($author$project$Template$Frame$numRows, columnIndex, frame) >= 4));
					} else {
						return $elm$core$Maybe$Just(
							!($author$project$Template$Frame$numColumns(frame) >= 3));
					}
				},
				A2($elm_community$list_extra$List$Extra$getAt, frameIndex, template.G)));
	});
var $author$project$Template$Frame$isHorizontal = function (frame) {
	return !frame.fz;
};
var $author$project$Template$Helpers$isHorizontal = F2(
	function (_v0, template) {
		var frameIndex = _v0.ap;
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$andThen,
				A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $author$project$Template$Frame$isHorizontal),
				A2($elm_community$list_extra$List$Extra$getAt, frameIndex, template.G)));
	});
var $author$project$Template$Frame$isVertical = function (frame) {
	return frame.fz === 1;
};
var $author$project$Template$Helpers$isVertical = F2(
	function (_v0, template) {
		var frameIndex = _v0.ap;
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$andThen,
				A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $author$project$Template$Frame$isVertical),
				A2($elm_community$list_extra$List$Extra$getAt, frameIndex, template.G)));
	});
var $author$project$Reusable$Flex$viewCenter = function (nodes) {
	return $rtfeldman$elm_css$Html$Styled$toUnstyled(
		A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$pct(100)),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
						]))
				]),
			A2($elm$core$List$map, $rtfeldman$elm_css$Html$Styled$fromUnstyled, nodes)));
};
var $author$project$Reusable$Flex$viewCompactVertical = function (nodes) {
	return $rtfeldman$elm_css$Html$Styled$toUnstyled(
		A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
						]))
				]),
			A2($elm$core$List$map, $rtfeldman$elm_css$Html$Styled$fromUnstyled, nodes)));
};
var $author$project$Pages$CfgDevice$Design$viewLayoutIcon = F5(
	function (model, index, _v0, _v1, onClick) {
		var isDisabled = _v0.a;
		var highlight = _v0.b;
		var icon = _v1.a;
		var tooltip = _v1.b;
		var tooltipPos = _v1.c;
		var viewTooltip = A4(
			$author$project$Reusable$Tooltip$view,
			$author$project$Pages$CfgDevice$Design$Tooltip,
			index,
			model.fQ,
			_List_fromArray(
				[
					$author$project$Reusable$Tooltip$label(tooltip),
					tooltipPos
				]));
		var attrs = highlight ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'border', '1px solid black')
			]) : _List_Nil;
		return highlight ? viewTooltip(
			A2(
				$aforemny$material_components_web_elm$Material$Fab$fab,
				A2(
					$aforemny$material_components_web_elm$Material$Fab$setMini,
					true,
					A2(
						$aforemny$material_components_web_elm$Material$Fab$setAttributes,
						attrs,
						A2($aforemny$material_components_web_elm$Material$Fab$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Fab$config))),
				$aforemny$material_components_web_elm$Material$Fab$icon(icon))) : viewTooltip(
			A2(
				$aforemny$material_components_web_elm$Material$IconButton$iconButton,
				A2(
					$aforemny$material_components_web_elm$Material$IconButton$setAttributes,
					attrs,
					A2(
						$aforemny$material_components_web_elm$Material$IconButton$setDisabled,
						isDisabled,
						A2($aforemny$material_components_web_elm$Material$IconButton$setOnClick, onClick, $aforemny$material_components_web_elm$Material$IconButton$config))),
				$aforemny$material_components_web_elm$Material$IconButton$icon(icon)));
	});
var $author$project$Pages$CfgDevice$Design$viewLayoutAddOpts = F4(
	function (model, orientation, position, template) {
		return $author$project$Reusable$Flex$viewCenter(
			_List_fromArray(
				[
					A5(
					$author$project$Pages$CfgDevice$Design$viewLayoutIcon,
					model,
					_List_fromArray(
						[200, 1]),
					_Utils_Tuple2(
						!A2($author$project$Template$Helpers$canAddColumn, position, template),
						A2($author$project$Template$Helpers$isHorizontal, position, template)),
					_Utils_Tuple3('add_circle', 'Add Left', $author$project$Reusable$Tooltip$top),
					A3($author$project$Pages$CfgDevice$Design$AddLeftSection, orientation, template, position)),
					$author$project$Reusable$Flex$viewCompactVertical(
					_List_fromArray(
						[
							A5(
							$author$project$Pages$CfgDevice$Design$viewLayoutIcon,
							model,
							_List_fromArray(
								[203, 1]),
							_Utils_Tuple2(
								!A2($author$project$Template$Helpers$canAddSection, position, template),
								A2($author$project$Template$Helpers$isVertical, position, template)),
							_Utils_Tuple3('add_circle', 'Add Top Section', $author$project$Reusable$Tooltip$top),
							A3($author$project$Pages$CfgDevice$Design$AddTopSection, orientation, template, position)),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'width', '28px'),
									A2($elm$html$Html$Attributes$style, 'height', '28px')
								]),
							_List_Nil),
							A5(
							$author$project$Pages$CfgDevice$Design$viewLayoutIcon,
							model,
							_List_fromArray(
								[203, 2]),
							_Utils_Tuple2(
								!A2($author$project$Template$Helpers$canAddSection, position, template),
								A2($author$project$Template$Helpers$isVertical, position, template)),
							_Utils_Tuple3('add_circle', 'Add Bottom Section', $author$project$Reusable$Tooltip$bottom),
							A3($author$project$Pages$CfgDevice$Design$AddBottomSection, orientation, template, position))
						])),
					A5(
					$author$project$Pages$CfgDevice$Design$viewLayoutIcon,
					model,
					_List_fromArray(
						[200, 2]),
					_Utils_Tuple2(
						!A2($author$project$Template$Helpers$canAddColumn, position, template),
						A2($author$project$Template$Helpers$isHorizontal, position, template)),
					_Utils_Tuple3('add_circle', 'Add Right', $author$project$Reusable$Tooltip$bottom),
					A3($author$project$Pages$CfgDevice$Design$AddRightSection, orientation, template, position))
				]));
	});
var $author$project$Pages$CfgDevice$Design$viewLayoutButton = F4(
	function (model, _v0, label, onClick) {
		var index = _v0.a;
		var isDisabled = _v0.b;
		return A2(
			$aforemny$material_components_web_elm$Material$Button$outlined,
			A2(
				$aforemny$material_components_web_elm$Material$Button$setAttributes,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', '100%'),
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '6px')
					]),
				A2(
					$aforemny$material_components_web_elm$Material$Button$setDisabled,
					isDisabled,
					A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config))),
			label);
	});
var $author$project$Pages$CfgDevice$Design$MoveSectionDown = F3(
	function (a, b, c) {
		return {$: 24, a: a, b: b, c: c};
	});
var $author$project$Pages$CfgDevice$Design$MoveSectionLeft = F3(
	function (a, b, c) {
		return {$: 25, a: a, b: b, c: c};
	});
var $author$project$Pages$CfgDevice$Design$MoveSectionRight = F3(
	function (a, b, c) {
		return {$: 26, a: a, b: b, c: c};
	});
var $author$project$Pages$CfgDevice$Design$MoveSectionUp = F3(
	function (a, b, c) {
		return {$: 23, a: a, b: b, c: c};
	});
var $author$project$Template$Frame$canSectionMoveDown = F3(
	function (colIndex, rowIndex, frame) {
		var _v0 = frame.fz;
		if (!_v0) {
			return !_Utils_eq(
				rowIndex,
				A2($author$project$Template$Frame$numRows, colIndex, frame) - 1);
		} else {
			return !_Utils_eq(
				colIndex,
				$author$project$Template$Frame$numColumns(frame) - 1);
		}
	});
var $author$project$Template$Helpers$canMoveDown = F2(
	function (_v0, template) {
		var frameIndex = _v0.ap;
		var columnIndex = _v0.C;
		var rowIndex = _v0.y;
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Maybe$Just,
					A2($author$project$Template$Frame$canSectionMoveDown, columnIndex, rowIndex)),
				A2($elm_community$list_extra$List$Extra$getAt, frameIndex, template.G)));
	});
var $author$project$Template$Frame$canSectionMoveLeft = F3(
	function (colIndex, rowIndex, frame) {
		var _v0 = frame.fz;
		if (!_v0) {
			return !(!colIndex);
		} else {
			return !(!rowIndex);
		}
	});
var $author$project$Template$Helpers$canMoveLeft = F2(
	function (_v0, template) {
		var frameIndex = _v0.ap;
		var columnIndex = _v0.C;
		var rowIndex = _v0.y;
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Maybe$Just,
					A2($author$project$Template$Frame$canSectionMoveLeft, columnIndex, rowIndex)),
				A2($elm_community$list_extra$List$Extra$getAt, frameIndex, template.G)));
	});
var $author$project$Template$Frame$canSectionMoveRight = F3(
	function (colIndex, rowIndex, frame) {
		var _v0 = frame.fz;
		if (!_v0) {
			return !_Utils_eq(
				colIndex,
				$author$project$Template$Frame$numColumns(frame) - 1);
		} else {
			return !_Utils_eq(
				rowIndex,
				A2($author$project$Template$Frame$numRows, colIndex, frame) - 1);
		}
	});
var $author$project$Template$Helpers$canMoveRight = F2(
	function (_v0, template) {
		var frameIndex = _v0.ap;
		var columnIndex = _v0.C;
		var rowIndex = _v0.y;
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Maybe$Just,
					A2($author$project$Template$Frame$canSectionMoveRight, columnIndex, rowIndex)),
				A2($elm_community$list_extra$List$Extra$getAt, frameIndex, template.G)));
	});
var $author$project$Template$Frame$canSectionMoveUp = F3(
	function (colIndex, rowIndex, frame) {
		var _v0 = frame.fz;
		if (!_v0) {
			return !(!rowIndex);
		} else {
			return !(!colIndex);
		}
	});
var $author$project$Template$Helpers$canMoveUp = F2(
	function (_v0, template) {
		var frameIndex = _v0.ap;
		var columnIndex = _v0.C;
		var rowIndex = _v0.y;
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Maybe$Just,
					A2($author$project$Template$Frame$canSectionMoveUp, columnIndex, rowIndex)),
				A2($elm_community$list_extra$List$Extra$getAt, frameIndex, template.G)));
	});
var $author$project$Pages$CfgDevice$Design$viewLayoutPositionOpts = F4(
	function (model, orientation, position, template) {
		return $author$project$Reusable$Flex$viewCenter(
			_List_fromArray(
				[
					A5(
					$author$project$Pages$CfgDevice$Design$viewLayoutIcon,
					model,
					_List_fromArray(
						[100, 1]),
					_Utils_Tuple2(
						!A2($author$project$Template$Helpers$canMoveLeft, position, template),
						A2($author$project$Template$Helpers$isHorizontal, position, template)),
					_Utils_Tuple3('arrow_back', 'Move Left', $author$project$Reusable$Tooltip$top),
					A3($author$project$Pages$CfgDevice$Design$MoveSectionLeft, orientation, template, position)),
					$author$project$Reusable$Flex$viewCompactVertical(
					_List_fromArray(
						[
							A5(
							$author$project$Pages$CfgDevice$Design$viewLayoutIcon,
							model,
							_List_fromArray(
								[103, 1]),
							_Utils_Tuple2(
								!A2($author$project$Template$Helpers$canMoveUp, position, template),
								A2($author$project$Template$Helpers$isVertical, position, template)),
							_Utils_Tuple3('arrow_upward', 'Move Up', $author$project$Reusable$Tooltip$top),
							A3($author$project$Pages$CfgDevice$Design$MoveSectionUp, orientation, template, position)),
							A2($aforemny$material_components_web_elm$Material$Icon$icon, _List_Nil, 'stop'),
							A5(
							$author$project$Pages$CfgDevice$Design$viewLayoutIcon,
							model,
							_List_fromArray(
								[103, 2]),
							_Utils_Tuple2(
								!A2($author$project$Template$Helpers$canMoveDown, position, template),
								A2($author$project$Template$Helpers$isVertical, position, template)),
							_Utils_Tuple3('arrow_downward', 'Move Down', $author$project$Reusable$Tooltip$bottom),
							A3($author$project$Pages$CfgDevice$Design$MoveSectionDown, orientation, template, position))
						])),
					A5(
					$author$project$Pages$CfgDevice$Design$viewLayoutIcon,
					model,
					_List_fromArray(
						[100, 2]),
					_Utils_Tuple2(
						!A2($author$project$Template$Helpers$canMoveRight, position, template),
						A2($author$project$Template$Helpers$isHorizontal, position, template)),
					_Utils_Tuple3('arrow_forward', 'Move Right', $author$project$Reusable$Tooltip$bottom),
					A3($author$project$Pages$CfgDevice$Design$MoveSectionRight, orientation, template, position))
				]));
	});
var $author$project$Pages$CfgDevice$Design$FlexGrow = F3(
	function (a, b, c) {
		return {$: 27, a: a, b: b, c: c};
	});
var $author$project$Pages$CfgDevice$Design$viewLayoutSizeButtons = F4(
	function (model, orientation, position, template) {
		var viewTooltip = F2(
			function (index, tooltip) {
				return A4(
					$author$project$Reusable$Tooltip$view,
					$author$project$Pages$CfgDevice$Design$Tooltip,
					index,
					model.fQ,
					_List_fromArray(
						[
							$author$project$Reusable$Tooltip$label(tooltip)
						]));
			});
		var msg = function (val) {
			return A3($author$project$Pages$CfgDevice$Design$FlexGrow, template, position, val);
		};
		var maybeVal = A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Maybe$Just,
				function ($) {
					return $.ae;
				}),
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.da;
					},
					$elm_community$list_extra$List$Extra$getAt(position.C)),
				A2($elm_community$list_extra$List$Extra$getAt, position.ap, template.G)));
		var attrs = _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'margin', '0px 6px'),
				A2($elm$html$Html$Attributes$style, 'font-size', '12px')
			]);
		var button = F3(
			function (index, _v1, val) {
				var name = _v1.a;
				var tooltip = _v1.b;
				if (!maybeVal.$) {
					var activalVal = maybeVal.a;
					return _Utils_eq(activalVal, val) ? A3(
						viewTooltip,
						index,
						tooltip,
						A2(
							$aforemny$material_components_web_elm$Material$Button$raised,
							A2(
								$aforemny$material_components_web_elm$Material$Button$setAttributes,
								attrs,
								A2(
									$aforemny$material_components_web_elm$Material$Button$setOnClick,
									msg(val),
									$aforemny$material_components_web_elm$Material$Button$config)),
							name)) : A3(
						viewTooltip,
						index,
						tooltip,
						A2(
							$aforemny$material_components_web_elm$Material$Button$outlined,
							A2(
								$aforemny$material_components_web_elm$Material$Button$setAttributes,
								attrs,
								A2(
									$aforemny$material_components_web_elm$Material$Button$setOnClick,
									msg(val),
									$aforemny$material_components_web_elm$Material$Button$config)),
							name));
				} else {
					return A3(
						viewTooltip,
						index,
						tooltip,
						A2(
							$aforemny$material_components_web_elm$Material$Button$outlined,
							A2(
								$aforemny$material_components_web_elm$Material$Button$setAttributes,
								attrs,
								A2(
									$aforemny$material_components_web_elm$Material$Button$setOnClick,
									msg(val),
									$aforemny$material_components_web_elm$Material$Button$config)),
							name));
				}
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
					A2($elm$html$Html$Attributes$style, 'width', '100%'),
					A2($elm$html$Html$Attributes$style, 'margin-bottom', '8px')
				]),
			_List_fromArray(
				[
					A3(
					button,
					_List_fromArray(
						[1423]),
					_Utils_Tuple2('S', 'Small'),
					0),
					A3(
					button,
					_List_fromArray(
						[1424]),
					_Utils_Tuple2('R', 'Regular'),
					1),
					A3(
					button,
					_List_fromArray(
						[1425]),
					_Utils_Tuple2('L', 'Large'),
					5)
				]));
	});
var $author$project$Pages$CfgDevice$Design$viewWidgetLayoutEditor = function (model) {
	return $author$project$Reusable$Flex$viewVertical(
		_List_fromArray(
			[
				function () {
				var _v0 = _Utils_Tuple3(
					$author$project$DataState$toMaybe(model.a),
					model.h,
					A2(
						$author$project$Template$Helpers$getFrameOrientation,
						model.h,
						$author$project$DataState$toMaybe(model.a)));
				_v0$2:
				while (true) {
					if (!_v0.a.$) {
						if (!_v0.b.$) {
							if (!_v0.c.$) {
								var template = _v0.a.a;
								var position = _v0.b.a;
								var orientation = _v0.c.a;
								return $author$project$Reusable$Flex$viewVertical(
									_List_fromArray(
										[
											$author$project$Reusable$Header$subHeader('Position'),
											A4($author$project$Pages$CfgDevice$Design$viewLayoutPositionOpts, model, orientation, position, template),
											$author$project$Reusable$Header$subHeader('Add Sections'),
											A4($author$project$Pages$CfgDevice$Design$viewLayoutAddOpts, model, orientation, position, template),
											function () {
											if (!orientation) {
												return $author$project$Reusable$Header$subHeader('Column Size');
											} else {
												return $author$project$Reusable$Header$subHeader('Row Size');
											}
										}(),
											A4($author$project$Pages$CfgDevice$Design$viewLayoutSizeButtons, model, orientation, position, template),
											$author$project$Reusable$Header$subHeader('Widget Settings'),
											$author$project$Reusable$Card$viewSidebarCard(
											_List_fromArray(
												[
													A4(
													$author$project$Pages$CfgDevice$Design$viewLayoutButton,
													model,
													_Utils_Tuple2(
														_List_fromArray(
															[98]),
														A2($author$project$Pages$CfgDevice$Design$isSectionFilled, template, position)),
													'Select Widget',
													$author$project$Pages$CfgDevice$Design$EditWidgetCfg(position)),
													A4(
													$author$project$Pages$CfgDevice$Design$viewLayoutButton,
													model,
													_Utils_Tuple2(
														_List_fromArray(
															[1001]),
														A2($author$project$Pages$CfgDevice$Design$isSectionEmpty, template, position)),
													'Edit Widget',
													$author$project$Pages$CfgDevice$Design$EditWidgetCfg(position)),
													A4(
													$author$project$Pages$CfgDevice$Design$viewLayoutButton,
													model,
													_Utils_Tuple2(
														_List_fromArray(
															[10002]),
														A2($author$project$Pages$CfgDevice$Design$isSectionEmpty, template, position)),
													'Edit Style',
													A2($author$project$Pages$CfgDevice$Design$EditWidgetStyle, $elm$core$Maybe$Nothing, position))
												])),
											$author$project$Reusable$Header$subHeader('Options'),
											$author$project$Reusable$Card$viewSidebarCard(
											_List_fromArray(
												[
													A4(
													$author$project$Pages$CfgDevice$Design$viewLayoutButton,
													model,
													_Utils_Tuple2(
														_List_fromArray(
															[97]),
														A2($author$project$Pages$CfgDevice$Design$isSectionEmpty, template, position)),
													'Drop Widget',
													A2($author$project$Pages$CfgDevice$Design$RemoveWidget, template, position)),
													A4(
													$author$project$Pages$CfgDevice$Design$viewLayoutButton,
													model,
													_Utils_Tuple2(
														_List_fromArray(
															[105]),
														false),
													'Drop Section',
													$author$project$Pages$CfgDevice$Design$OpenDelSectionDialog),
													A4(
													$author$project$Pages$CfgDevice$Design$viewLayoutButton,
													model,
													_Utils_Tuple2(
														_List_fromArray(
															[106]),
														false),
													'Drop Column',
													$author$project$Pages$CfgDevice$Design$OpenDelColumnDialog)
												]))
										]));
							} else {
								break _v0$2;
							}
						} else {
							var template = _v0.a.a;
							var _v2 = _v0.b;
							return $author$project$Reusable$Header$multiLineSubHeader('Select a widget to configure its layout');
						}
					} else {
						break _v0$2;
					}
				}
				return $author$project$Reusable$Header$subHeader('Load template and select widget');
			}()
			]));
};
var $author$project$Pages$CfgDevice$Core$viewSideTabs = F3(
	function (config, model, device) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$aforemny$material_components_web_elm$Material$TabBar$tabBar,
					A2($aforemny$material_components_web_elm$Material$TabBar$setStacked, true, $aforemny$material_components_web_elm$Material$TabBar$config),
					A3(
						$author$project$Pages$CfgDevice$Core$viewTabIcon,
						config,
						model,
						_Utils_Tuple3('border_all', 'Layout Editor', 0)),
					_List_fromArray(
						[
							A3(
							$author$project$Pages$CfgDevice$Core$viewTabIcon,
							config,
							model,
							_Utils_Tuple3('edit', 'Widget Editor', 1)),
							A3(
							$author$project$Pages$CfgDevice$Core$viewTabIcon,
							config,
							model,
							_Utils_Tuple3('style', 'Style Editor', 2)),
							A3(
							$author$project$Pages$CfgDevice$Core$viewTabIcon,
							config,
							model,
							_Utils_Tuple3('info', 'Information', 3))
						])),
					function () {
					var _v0 = model.bG;
					switch (_v0) {
						case 0:
							return $author$project$Pages$CfgDevice$Core$viewSideTab(
								A2(
									$elm$html$Html$map,
									A2($elm$core$Basics$composeR, $author$project$Pages$CfgDevice$Core$DesignTabMsg, config.cz),
									$author$project$Pages$CfgDevice$Design$viewWidgetLayoutEditor(model.P)));
						case 3:
							return $author$project$Pages$CfgDevice$Core$viewSideTab(
								A3($author$project$Pages$CfgDevice$Core$viewInformationPanels, config, model, device));
						case 2:
							return $author$project$Pages$CfgDevice$Core$viewSideTab(
								A2(
									$elm$html$Html$map,
									A2($elm$core$Basics$composeR, $author$project$Pages$CfgDevice$Core$DesignTabMsg, config.cz),
									$author$project$Pages$CfgDevice$Design$viewStyleEditor(model.P)));
						default:
							return $author$project$Pages$CfgDevice$Core$viewSideTab(
								A2(
									$elm$html$Html$map,
									A2($elm$core$Basics$composeR, $author$project$Pages$CfgDevice$Core$DesignTabMsg, config.cz),
									A2(
										$author$project$Pages$CfgDevice$Design$viewWidgetCfgEditor,
										{
											h5: '',
											eO: config.eO,
											iB: '',
											gm: '',
											gM: _Utils_Tuple2('', ''),
											g1: config.g1,
											mo: _List_Nil,
											an: ''
										},
										model.P)));
					}
				}()
				]));
	});
var $author$project$Pages$CfgDevice$Core$viewSideSection = F2(
	function (config, model) {
		var _v0 = config.lV;
		if (_v0.$ === 1) {
			return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		} else {
			var device = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'display', 'flex'),
						A2($elm$html$Html$Attributes$style, 'flex-direction', 'column')
					]),
				_List_fromArray(
					[
						function () {
						var _v1 = model.ba;
						if (_v1 === 1) {
							return A3($author$project$Pages$CfgDevice$Core$viewSideTabs, config, model, device);
						} else {
							return A3($author$project$Pages$CfgDevice$Core$viewInformationPanels, config, model, device);
						}
					}()
					]));
		}
	});
var $author$project$Pages$Dashboard$OpenMediaLibrary = {$: 20};
var $author$project$Pages$Dashboard$viewImageLib = function (model) {
	return A2(
		$aforemny$material_components_web_elm$Material$Button$outlined,
		A2(
			$aforemny$material_components_web_elm$Material$Button$setAttributes,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'margin-top', '12px'),
					A2($elm$html$Html$Attributes$style, 'width', '100%')
				]),
			A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$Dashboard$OpenMediaLibrary, $aforemny$material_components_web_elm$Material$Button$config)),
		'Image Library');
};
var $author$project$Pages$Dashboard$SelectMsg = function (a) {
	return {$: 7, a: a};
};
var $elm$html$Html$section = _VirtualDom_node('section');
var $author$project$Pages$Dashboard$viewFilter = F2(
	function (_v0, nodes) {
		var padding = _v0.a;
		var margin = _v0.b;
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Mdl$Elevation$e3,
					A2($elm$html$Html$Attributes$style, 'padding', padding),
					A2($elm$html$Html$Attributes$style, 'margin-top', margin),
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'flex-direction', 'column')
				]),
			nodes);
	});
var $author$project$Pages$Dashboard$viewSchoolFilter = F2(
	function (schools, model) {
		return A2(
			$author$project$Pages$Dashboard$viewFilter,
			_Utils_Tuple2('12px 12px 0px 12px', '4px'),
			_List_fromArray(
				[
					A5(
					$author$project$Select$view,
					$author$project$Pages$Dashboard$SelectMsg,
					_List_fromArray(
						[0]),
					model.r,
					$author$project$Select$entity,
					_List_fromArray(
						[
							$author$project$Select$label('Filter By Location'),
							$author$project$Select$searchable,
							$author$project$Select$options(
							A2($elm$core$List$cons, $author$project$Pages$Dashboard$resetFilter, schools)),
							$author$project$Select$value(model.aE),
							$author$project$Select$onSelect($author$project$Pages$Dashboard$FilterBySchool)
						]))
				]));
	});
var $author$project$Pages$Dashboard$RunCommand = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Dashboard$viewRunCommandButton = function (model) {
	var onClick = function () {
		var _v0 = model.a8;
		if (!_v0.$) {
			var cmd = _v0.a;
			return $author$project$Pages$Dashboard$RunCommand(cmd);
		} else {
			return $author$project$Pages$Dashboard$NoOp;
		}
	}();
	return A2(
		$aforemny$material_components_web_elm$Material$Fab$fab,
		A2(
			$aforemny$material_components_web_elm$Material$Fab$setAttributes,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'margin-left', '6px')
				]),
			A2(
				$aforemny$material_components_web_elm$Material$Fab$setMini,
				true,
				A2($aforemny$material_components_web_elm$Material$Fab$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Fab$config))),
		$aforemny$material_components_web_elm$Material$Fab$icon('play_arrow'));
};
var $author$project$Pages$Dashboard$BackupDevices = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Dashboard$ReloadMenus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Dashboard$ReqSerialNumbers = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Dashboard$RestartDevices = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Dashboard$SelectCommand = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Dashboard$toStringCommand = function (cmd) {
	switch (cmd.$) {
		case 0:
			return 'Restart Devices';
		case 1:
			return 'Request Serial Numbers';
		case 2:
			return 'Backup Devices';
		default:
			return 'Reload Menu';
	}
};
var $author$project$Pages$Dashboard$viewSelectCommand = F2(
	function (devices, model) {
		return A5(
			$author$project$Select$view,
			$author$project$Pages$Dashboard$SelectMsg,
			_List_fromArray(
				[12, 12]),
			model.r,
			{
				dS: F2(
					function (a, b) {
						return _Utils_eq(
							$author$project$Pages$Dashboard$toStringCommand(a),
							$author$project$Pages$Dashboard$toStringCommand(b));
					}),
				d8: $author$project$Pages$Dashboard$toStringCommand,
				ep: $author$project$Pages$Dashboard$toStringCommand
			},
			_List_fromArray(
				[
					$author$project$Select$label('Select Command and run'),
					$author$project$Select$options(
					_List_fromArray(
						[
							$author$project$Pages$Dashboard$RestartDevices(devices),
							$author$project$Pages$Dashboard$BackupDevices(devices),
							$author$project$Pages$Dashboard$ReqSerialNumbers(devices),
							$author$project$Pages$Dashboard$ReloadMenus(devices)
						])),
					$author$project$Select$value(model.a8),
					$author$project$Select$onSelect($author$project$Pages$Dashboard$SelectCommand),
					$author$project$Select$disabled(
					$elm$core$List$isEmpty(devices))
				]));
	});
var $author$project$Pages$Dashboard$viewSelectCommandContainer = F2(
	function (devices, model) {
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Mdl$Elevation$e3,
					A2($elm$html$Html$Attributes$style, 'padding', '12px 12px 0px 12px'),
					A2($elm$html$Html$Attributes$style, 'margin-top', '8px'),
					A2($elm$html$Html$Attributes$style, 'display', 'flex')
				]),
			_List_fromArray(
				[
					A2($author$project$Pages$Dashboard$viewSelectCommand, devices, model),
					$author$project$Pages$Dashboard$viewRunCommandButton(model)
				]));
	});
var $author$project$Pages$Dashboard$viewSideSection = F4(
	function (model, schools, devices, fabricState) {
		var numOffline = $elm$core$List$length(
			A2($elm$core$List$filter, $author$project$Entity$Device$isDeviceOffline, devices));
		var filteredDevices = A2(
			$author$project$Pages$Dashboard$filterDevicesBySchool,
			model.aE,
			A2(
				$author$project$Pages$Dashboard$filterDevicesByName,
				model.bm,
				A2($author$project$Pages$Dashboard$filterDevicesByState, model.bY, devices)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard-side-section')
				]),
			_List_fromArray(
				[
					$author$project$FabricStatus$view(fabricState),
					A2($author$project$Pages$Dashboard$viewSchoolFilter, schools, model),
					A2($author$project$Pages$Dashboard$viewSelectCommandContainer, filteredDevices, model),
					$author$project$Pages$Dashboard$viewImageLib(model)
				]));
	});
var $author$project$Pages$CfgDevice$Helpers$viewDeviceState = function (deviceState) {
	switch (deviceState.$) {
		case 0:
			return A3(
				$author$project$Reusable$IconStatus$view,
				$danmarcab$material_icons$Material$Icons$Hardware$cast_connected,
				$avh4$elm_color$Color$black,
				_Utils_Tuple2('Device', 'Online'));
		case 2:
			return A3(
				$author$project$Reusable$IconStatus$view,
				$danmarcab$material_icons$Material$Icons$Hardware$cast,
				$avh4$elm_color$Color$red,
				_Utils_Tuple2('Device', 'Connecting...'));
		case 3:
			return A3(
				$author$project$Reusable$IconStatus$view,
				$danmarcab$material_icons$Material$Icons$Hardware$cast,
				$avh4$elm_color$Color$red,
				_Utils_Tuple2('Device', 'Connect Failed'));
		case 1:
			return A3(
				$author$project$Reusable$IconStatus$view,
				$danmarcab$material_icons$Material$Icons$Hardware$cast,
				$avh4$elm_color$Color$red,
				_Utils_Tuple2('Device', 'Offline'));
		default:
			return A3(
				$author$project$Reusable$IconStatus$view,
				$danmarcab$material_icons$Material$Icons$Hardware$cast,
				$avh4$elm_color$Color$black,
				_Utils_Tuple2('Device', 'Not Connected'));
	}
};
var $author$project$Pages$LinkNewDevice$viewSideSection = F2(
	function (serverState, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$FabricStatus$view(serverState),
					$author$project$Pages$CfgDevice$Helpers$viewDeviceState(model.A)
				]));
	});
var $author$project$Pages$MenuItemList$InitNewList = {$: 4};
var $author$project$Pages$MenuItemList$viewAddNewListButton = function (model) {
	return A2(
		$aforemny$material_components_web_elm$Material$Button$outlined,
		A2(
			$aforemny$material_components_web_elm$Material$Button$setAttributes,
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$Theme$primary,
					A2($elm$html$Html$Attributes$style, 'width', '100%')
				]),
			A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$MenuItemList$InitNewList, $aforemny$material_components_web_elm$Material$Button$config)),
		'Add New List');
};
var $author$project$Pages$MenuItemList$InitDuplicateList = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$MenuItemList$viewDuplicateListButton = F2(
	function (config, model) {
		var onClick = function () {
			var _v0 = $author$project$Pages$MenuItemList$getMenuItemList(model);
			if (!_v0.$) {
				var itemList = _v0.a;
				return $author$project$Pages$MenuItemList$InitDuplicateList(itemList);
			} else {
				return $author$project$Pages$MenuItemList$NoOp;
			}
		}();
		return A2(
			$aforemny$material_components_web_elm$Material$Button$outlined,
			A2(
				$aforemny$material_components_web_elm$Material$Button$setAttributes,
				_List_fromArray(
					[
						$aforemny$material_components_web_elm$Material$Theme$primary,
						A2($elm$html$Html$Attributes$style, 'width', '100%')
					]),
				A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config)),
			'Duplicate List');
	});
var $author$project$Pages$MenuItemList$viewSideSection = F2(
	function (config, model) {
		return $author$project$Reusable$Card$viewSidebarCard(
			_List_fromArray(
				[
					A2($author$project$Pages$MenuItemList$viewDuplicateListButton, config, model),
					$author$project$Pages$MenuItemList$viewAddNewListButton(model)
				]));
	});
var $author$project$Pages$SyncDevices$viewSideSection = F3(
	function (config, serverState, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
					A2($elm$html$Html$Attributes$style, 'width', '100%')
				]),
			_List_fromArray(
				[
					$author$project$FabricStatus$view(serverState)
				]));
	});
var $author$project$Pages$User$viewUserPage = F2(
	function (model, user) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Mdl$Elevation$e2,
					A2($elm$html$Html$Attributes$style, 'padding', '12px')
				]),
			_List_fromArray(
				[
					$author$project$Reusable$Card$viewTitle('User Profile'),
					A2($author$project$Reusable$Label$view, 'Name', user.li),
					A2($author$project$Reusable$Label$view, 'User Name', user.ax),
					A2($author$project$Reusable$Label$view, 'District', user.iC.g8),
					A2(
					$aforemny$material_components_web_elm$Material$Button$outlined,
					A2($aforemny$material_components_web_elm$Material$Button$setOnClick, $author$project$Pages$User$LogoutUser, $aforemny$material_components_web_elm$Material$Button$config),
					'Logout')
				]));
	});
var $author$project$Main$viewSections = function (model) {
	var _v0 = _Utils_Tuple3(
		model.I.dq,
		model.j7.eK,
		_Utils_Tuple3(
			model.aQ,
			model.K.ao,
			_Utils_Tuple2(model.cb.g1, model.K.kV)));
	_v0$1:
	while (true) {
		_v0$7:
		while (true) {
			_v0$12:
			while (true) {
				_v0$13:
				while (true) {
					_v0$14:
					while (true) {
						_v0$15:
						while (true) {
							_v0$16:
							while (true) {
								_v0$17:
								while (true) {
									_v0$18:
									while (true) {
										_v0$19:
										while (true) {
											switch (_v0.a.$) {
												case 1:
													switch (_v0.b.$) {
														case 4:
															var _v1 = _v0.a;
															var user = _v0.b.a;
															var _v2 = _v0.c;
															var _v3 = _v2.c;
															return _Utils_Tuple2(
																A2(
																	$elm$html$Html$map,
																	$author$project$Main$UserMsg,
																	A2($author$project$Pages$User$viewUserPage, model.j7, user)),
																$elm$html$Html$text(''));
														case 1:
															break _v0$1;
														default:
															break _v0$1;
													}
												case 0:
													var _v7 = _v0.a;
													var _v8 = _v0.c;
													var _v9 = _v8.c;
													return _Utils_Tuple2(
														A2(
															$elm$html$Html$map,
															$author$project$Main$UserMsg,
															A2($author$project$Pages$User$viewLoginPage, model.k, model.j7)),
														$elm$html$Html$text(''));
												case 7:
													var _v10 = _v0.a;
													var _v11 = _v0.c;
													var _v12 = _v11.c;
													return _Utils_Tuple2(
														$author$project$Pages$ContactUs$view,
														$elm$html$Html$text(''));
												case 8:
													var _v13 = _v0.a;
													var _v14 = _v0.c;
													var _v15 = _v14.c;
													return _Utils_Tuple2(
														A2(
															$elm$html$Html$map,
															$author$project$Main$FaqsMsg,
															$author$project$Pages$Faqs$view(model.d6)),
														$elm$html$Html$text(''));
												case 2:
													switch (_v0.c.a.$) {
														case 4:
															switch (_v0.c.b.$) {
																case 4:
																	switch (_v0.b.$) {
																		case 4:
																			var _v16 = _v0.a;
																			var user = _v0.b.a;
																			var _v17 = _v0.c;
																			var schools = _v17.a.a;
																			var devices = _v17.b.a;
																			var _v18 = _v17.c;
																			return _Utils_Tuple2(
																				A2(
																					$author$project$Pages$Dashboard$viewMainSection,
																					{
																						ao: $elm$core$Dict$values(devices),
																						lJ: user.h4 === 3,
																						lQ: function (device) {
																							return $author$project$Main$LiveCaptureMsg(
																								$author$project$Dialogs$LiveCapture$StartLiveCapture(device));
																						},
																						aQ: schools,
																						mw: function (device) {
																							return $author$project$Main$CfgDeviceMsg(
																								A3($author$project$Pages$CfgDevice$Core$ConfigureDevice, model.k.an, user.h5, device));
																						},
																						cz: $author$project$Main$DashboardMsg,
																						W: model.W
																					},
																					model.aB),
																				A2(
																					$elm$html$Html$map,
																					$author$project$Main$DashboardMsg,
																					A4(
																						$author$project$Pages$Dashboard$viewSideSection,
																						model.aB,
																						schools,
																						$elm$core$Dict$values(devices),
																						model.aD)));
																		case 1:
																			break _v0$12;
																		default:
																			switch (_v0.c.c.a.$) {
																				case 1:
																					break _v0$15;
																				case 2:
																					break _v0$18;
																				default:
																					break _v0$19;
																			}
																	}
																case 1:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																	}
																case 2:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$17;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$17;
																			}
																	}
																default:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$18;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$19;
																			}
																	}
															}
														case 1:
															switch (_v0.c.b.$) {
																case 1:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																	}
																case 2:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																	}
																default:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																	}
															}
														case 2:
															switch (_v0.c.b.$) {
																case 1:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																	}
																case 2:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$16;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$16;
																			}
																	}
																default:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$16;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$16;
																			}
																	}
															}
														default:
															switch (_v0.c.b.$) {
																case 1:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																	}
																case 2:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$17;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$17;
																			}
																	}
																default:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$18;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$19;
																			}
																	}
															}
													}
												case 6:
													switch (_v0.c.a.$) {
														case 4:
															switch (_v0.c.b.$) {
																case 4:
																	switch (_v0.b.$) {
																		case 4:
																			switch (_v0.c.c.a.$) {
																				case 4:
																					if (!_v0.c.c.b.$) {
																						var _v19 = _v0.a;
																						var user = _v0.b.a;
																						var _v20 = _v0.c;
																						var schools = _v20.a.a;
																						var devices = _v20.b.a;
																						var _v21 = _v20.c;
																						var lists = _v21.a.a;
																						var cfgId = _v21.b.a;
																						return _Utils_Tuple2(
																							A3(
																								$author$project$Pages$CfgDevice$Core$viewMainSection,
																								{
																									h5: user.h5,
																									eO: user.eO,
																									ao: $elm$core$Dict$values(devices),
																									iC: A2(
																										$elm$core$Maybe$withDefault,
																										'0',
																										$author$project$Pages$User$getDistrictId(model.j7)),
																									k: model.k,
																									g1: $author$project$Pages$MenuItemList$getData(lists),
																									aQ: schools,
																									cz: $author$project$Main$CfgDeviceMsg
																								},
																								A2($author$project$Main$findDeviceById, cfgId, model.K.ao),
																								model.K),
																							A2(
																								$author$project$Pages$CfgDevice$Core$viewSideSection,
																								{
																									eO: user.eO,
																									le: function (device) {
																										return $author$project$Main$SyncDevicesMsg(
																											$author$project$Pages$SyncDevices$SelectImportDevice(device));
																									},
																									aD: model.aD,
																									lV: A2($author$project$Main$findDeviceById, cfgId, model.K.ao),
																									g1: $author$project$Pages$MenuItemList$getData(lists),
																									cz: $author$project$Main$CfgDeviceMsg
																								},
																								model.K));
																					} else {
																						break _v0$7;
																					}
																				case 1:
																					if (_v0.c.c.b.$ === 1) {
																						break _v0$7;
																					} else {
																						break _v0$15;
																					}
																				case 2:
																					if (_v0.c.c.b.$ === 1) {
																						break _v0$7;
																					} else {
																						break _v0$18;
																					}
																				default:
																					if (_v0.c.c.b.$ === 1) {
																						break _v0$7;
																					} else {
																						break _v0$19;
																					}
																			}
																		case 1:
																			break _v0$12;
																		default:
																			switch (_v0.c.c.a.$) {
																				case 1:
																					break _v0$15;
																				case 2:
																					break _v0$18;
																				default:
																					break _v0$19;
																			}
																	}
																case 1:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																	}
																case 2:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$17;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$17;
																			}
																	}
																default:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$18;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$19;
																			}
																	}
															}
														case 1:
															switch (_v0.c.b.$) {
																case 1:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																	}
																case 2:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																	}
																default:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																	}
															}
														case 2:
															switch (_v0.c.b.$) {
																case 1:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																	}
																case 2:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$16;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$16;
																			}
																	}
																default:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$16;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$16;
																			}
																	}
															}
														default:
															switch (_v0.c.b.$) {
																case 1:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																	}
																case 2:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$17;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$17;
																			}
																	}
																default:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$18;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$19;
																			}
																	}
															}
													}
												case 9:
													var _v26 = _v0.a;
													var _v27 = _v0.c;
													var _v28 = _v27.c;
													return _Utils_Tuple2(
														$author$project$Pages$Error404$view,
														$elm$html$Html$text(''));
												case 3:
													switch (_v0.c.a.$) {
														case 4:
															switch (_v0.b.$) {
																case 4:
																	var opt = _v0.a.a;
																	var user = _v0.b.a;
																	var _v29 = _v0.c;
																	var schools = _v29.a.a;
																	var _v30 = _v29.c;
																	return (user.h4 === 3) ? _Utils_Tuple2(
																		$author$project$Pages$Error404$view,
																		$elm$html$Html$text('')) : _Utils_Tuple2(
																		A2(
																			$elm$html$Html$map,
																			$author$project$Main$LinkNewDeviceMsg,
																			A2(
																				$author$project$Pages$LinkNewDevice$viewMainSection,
																				{
																					h5: user.h5,
																					ao: function () {
																						var _v31 = model.K.ao;
																						if (_v31.$ === 4) {
																							var devices = _v31.a;
																							return devices;
																						} else {
																							return $elm$core$Dict$empty;
																						}
																					}(),
																					k: model.k,
																					aQ: schools,
																					mF: !opt
																				},
																				model.ce)),
																		A2(
																			$elm$html$Html$map,
																			$author$project$Main$LinkNewDeviceMsg,
																			A2($author$project$Pages$LinkNewDevice$viewSideSection, model.aD, model.ce)));
																case 1:
																	break _v0$12;
																default:
																	switch (_v0.c.b.$) {
																		case 1:
																			break _v0$14;
																		case 2:
																			switch (_v0.c.c.a.$) {
																				case 1:
																					break _v0$15;
																				case 2:
																					break _v0$17;
																				default:
																					break _v0$17;
																			}
																		default:
																			switch (_v0.c.c.a.$) {
																				case 1:
																					break _v0$15;
																				case 2:
																					break _v0$18;
																				default:
																					break _v0$19;
																			}
																	}
															}
														case 1:
															switch (_v0.c.b.$) {
																case 1:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																	}
																case 2:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																	}
																default:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																	}
															}
														case 2:
															switch (_v0.c.b.$) {
																case 1:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																	}
																case 2:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$16;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$16;
																			}
																	}
																default:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$16;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$16;
																			}
																	}
															}
														default:
															switch (_v0.c.b.$) {
																case 1:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																	}
																case 2:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$17;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$17;
																			}
																	}
																default:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$18;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$19;
																			}
																	}
															}
													}
												case 5:
													switch (_v0.c.a.$) {
														case 4:
															switch (_v0.c.b.$) {
																case 4:
																	switch (_v0.b.$) {
																		case 4:
																			var _v32 = _v0.a;
																			var _v33 = _v0.c;
																			var schools = _v33.a.a;
																			var devices = _v33.b.a;
																			var _v34 = _v33.c;
																			return _Utils_Tuple2(
																				A2(
																					$elm$html$Html$map,
																					$author$project$Main$SyncDevicesMsg,
																					A2(
																						$author$project$Pages$SyncDevices$viewMainSection,
																						{ao: devices, aQ: schools},
																						model.cu)),
																				A2(
																					$elm$html$Html$map,
																					$author$project$Main$SyncDevicesMsg,
																					A3(
																						$author$project$Pages$SyncDevices$viewSideSection,
																						{ao: devices, aQ: schools},
																						model.aD,
																						model.cu)));
																		case 1:
																			break _v0$12;
																		default:
																			switch (_v0.c.c.a.$) {
																				case 1:
																					break _v0$15;
																				case 2:
																					break _v0$18;
																				default:
																					break _v0$19;
																			}
																	}
																case 1:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																	}
																case 2:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$17;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$17;
																			}
																	}
																default:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$18;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$19;
																			}
																	}
															}
														case 1:
															switch (_v0.c.b.$) {
																case 1:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																	}
																case 2:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																	}
																default:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																	}
															}
														case 2:
															switch (_v0.c.b.$) {
																case 1:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																	}
																case 2:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$16;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$16;
																			}
																	}
																default:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$16;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$16;
																			}
																	}
															}
														default:
															switch (_v0.c.b.$) {
																case 1:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																	}
																case 2:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$17;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$17;
																			}
																	}
																default:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$18;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$19;
																			}
																	}
															}
													}
												default:
													switch (_v0.c.b.$) {
														case 4:
															switch (_v0.c.c.a.$) {
																case 4:
																	switch (_v0.b.$) {
																		case 4:
																			var _v35 = _v0.a;
																			var user = _v0.b.a;
																			var _v36 = _v0.c;
																			var devices = _v36.b.a;
																			var _v37 = _v36.c;
																			var config = {
																				h5: user.h5,
																				ao: $elm$core$Dict$values(devices),
																				k: model.k
																			};
																			return _Utils_Tuple2(
																				A2(
																					$elm$html$Html$map,
																					$author$project$Main$MenuItemListMsg,
																					A2($author$project$Pages$MenuItemList$viewMainSection, config, model.cb)),
																				A2(
																					$elm$html$Html$map,
																					$author$project$Main$MenuItemListMsg,
																					A2($author$project$Pages$MenuItemList$viewSideSection, config, model.cb)));
																		case 1:
																			break _v0$12;
																		default:
																			switch (_v0.c.a.$) {
																				case 1:
																					break _v0$13;
																				case 2:
																					break _v0$16;
																				default:
																					break _v0$19;
																			}
																	}
																case 1:
																	switch (_v0.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																	}
																case 2:
																	switch (_v0.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$16;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$18;
																			}
																	}
																default:
																	switch (_v0.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$16;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$19;
																			}
																	}
															}
														case 1:
															switch (_v0.c.a.$) {
																case 1:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																	}
																case 2:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																	}
																default:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$14;
																			}
																	}
															}
														case 2:
															switch (_v0.c.a.$) {
																case 1:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																	}
																case 2:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$16;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$16;
																			}
																	}
																default:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$17;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$17;
																			}
																	}
															}
														default:
															switch (_v0.c.a.$) {
																case 1:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$13;
																			}
																	}
																case 2:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$16;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$16;
																			}
																	}
																default:
																	switch (_v0.c.c.a.$) {
																		case 1:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$15;
																			}
																		case 2:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$18;
																			}
																		default:
																			if (_v0.b.$ === 1) {
																				break _v0$12;
																			} else {
																				break _v0$19;
																			}
																	}
															}
													}
											}
										}
										return _Utils_Tuple2(
											A2(
												$elm$html$Html$map,
												$author$project$Main$UserMsg,
												A2($author$project$Pages$User$viewLoginPage, model.k, model.j7)),
											$elm$html$Html$text(''));
									}
									var _v50 = _v0.c;
									var _v51 = _v50.c;
									var msgStr = _v51.a.a;
									return _Utils_Tuple2(
										$author$project$Main$viewErrorLoadingScreen(msgStr),
										$elm$html$Html$text(''));
								}
								var _v48 = _v0.c;
								var msgStr = _v48.b.a;
								var _v49 = _v48.c;
								return _Utils_Tuple2(
									$author$project$Main$viewErrorLoadingScreen(msgStr),
									$elm$html$Html$text(''));
							}
							var _v46 = _v0.c;
							var msgStr = _v46.a.a;
							var _v47 = _v46.c;
							return _Utils_Tuple2(
								$author$project$Main$viewErrorLoadingScreen(msgStr),
								$elm$html$Html$text(''));
						}
						var _v44 = _v0.c;
						var _v45 = _v44.c;
						return _Utils_Tuple2(
							$author$project$Main$viewLoadingScreen,
							$elm$html$Html$text(''));
					}
					var _v42 = _v0.c;
					var _v43 = _v42.c;
					return _Utils_Tuple2(
						$author$project$Main$viewLoadingScreen,
						$elm$html$Html$text(''));
				}
				var _v40 = _v0.c;
				var _v41 = _v40.c;
				return _Utils_Tuple2(
					$author$project$Main$viewLoadingScreen,
					$elm$html$Html$text(''));
			}
			var _v38 = _v0.c;
			var _v39 = _v38.c;
			return _Utils_Tuple2(
				$author$project$Main$viewLoadingScreen,
				$elm$html$Html$text(''));
		}
		var _v22 = _v0.a;
		var _v23 = _v0.c;
		var _v24 = _v23.c;
		var _v25 = _v24.b;
		return _Utils_Tuple2(
			A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$aforemny$material_components_web_elm$Material$Typography$body1,
						A2($elm$html$Html$Attributes$style, 'display', 'flex'),
						A2($elm$html$Html$Attributes$style, 'flex-direction', 'column')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Select a device from the Dashboard to configure it.'),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var onClick = $author$project$Main$NavigateTo($author$project$Routing$DashboardPage);
								var attrs = _List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'margin-top', '12px')
									]);
								return A2(
									$aforemny$material_components_web_elm$Material$Button$raised,
									A2(
										$aforemny$material_components_web_elm$Material$Button$setAttributes,
										attrs,
										A2($aforemny$material_components_web_elm$Material$Button$setOnClick, onClick, $aforemny$material_components_web_elm$Material$Button$config)),
									'All Devices');
							}()
							]))
					])),
			$elm$html$Html$text(''));
	}
	var _v4 = _v0.a;
	var _v5 = _v0.c;
	var _v6 = _v5.c;
	return _Utils_Tuple2(
		A2(
			$elm$html$Html$map,
			$author$project$Main$UserMsg,
			A2($author$project$Pages$User$viewLoginPage, model.k, model.j7)),
		$elm$html$Html$text(''));
};
var $author$project$Reusable$Drawer$viewSecondary = F3(
	function (isOpen, msg, inner) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('common-cancel-field'),
							A2(
							$author$project$Html$Attributes$Extra$when,
							!isOpen,
							$elm$html$Html$Attributes$class('common-hidden')),
							$elm$html$Html$Events$onClick(msg)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Mdl$Elevation$e4,
							A2($elm$html$Html$Attributes$style, 'z-index', '10'),
							A2($elm$html$Html$Attributes$style, 'height', '100vh'),
							A2($elm$html$Html$Attributes$style, 'position', 'fixed'),
							A2($elm$html$Html$Attributes$style, 'top', '0px'),
							A2($elm$html$Html$Attributes$style, 'width', '300px'),
							A2($elm$html$Html$Attributes$style, 'background', 'white'),
							A2($elm$html$Html$Attributes$style, 'transition', '0.4s right'),
							A2(
							$author$project$Html$Attributes$Extra$when,
							!isOpen,
							A2($elm$html$Html$Attributes$style, 'right', '-324px')),
							A2(
							$author$project$Html$Attributes$Extra$when,
							isOpen,
							A2($elm$html$Html$Attributes$style, 'right', '0px'))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'height', '64px'),
									A2($elm$html$Html$Attributes$style, 'background', '#007F38'),
									A2($elm$html$Html$Attributes$style, 'display', 'flex'),
									A2($elm$html$Html$Attributes$style, 'padding', '0px 12px'),
									A2($elm$html$Html$Attributes$style, 'align-items', 'center')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'color', 'white'),
											A2($elm$html$Html$Attributes$style, 'background', 'transparent'),
											A2($elm$html$Html$Attributes$style, 'border', 'none'),
											A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
											A2($elm$html$Html$Attributes$style, 'display', 'flex'),
											A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
											A2($elm$html$Html$Attributes$style, 'font-family', 'Roboto, sans-serif'),
											A2($elm$html$Html$Attributes$style, 'font-size', '14px'),
											A2($elm$html$Html$Attributes$style, 'font-weight', '500'),
											A2($elm$html$Html$Attributes$style, 'letter-spacing', '0.5px'),
											A2($elm$html$Html$Attributes$style, 'text-transform', 'uppercase'),
											A2($elm$html$Html$Attributes$style, 'padding', '0 8px'),
											$elm$html$Html$Events$onClick(msg)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$i,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('material-icons'),
													A2($elm$html$Html$Attributes$style, 'color', 'white'),
													A2($elm$html$Html$Attributes$style, 'margin-right', '8px'),
													A2($elm$html$Html$Attributes$style, 'font-size', '20px')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('close')
												])),
											$elm$html$Html$text('CLOSE')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'padding', '0px 12px'),
									A2($elm$html$Html$Attributes$style, 'margin-top', '8px')
								]),
							inner)
						]))
				]));
	});
var $author$project$Main$viewSideSectionDrawer = F2(
	function (model, section) {
		return A3(
			$author$project$Reusable$Drawer$viewSecondary,
			model.b3,
			$author$project$Main$ToggleSidebar,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'flex-direction', 'column')
						]),
					_List_fromArray(
						[section]))
				]));
	});
var $author$project$Main$view = function (model) {
	var _v0 = $author$project$Main$viewSections(model);
	var mainSection = _v0.a;
	var sideSection = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('base')
			]),
		_List_fromArray(
			[
				$author$project$Main$viewAppBar(model),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('page')
					]),
				_List_fromArray(
					[
						$author$project$Main$viewNavBar(model),
						function () {
						var _v1 = model.W;
						switch (_v1) {
							case 2:
								return model.as ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'width', '300px')
										]),
									_List_Nil) : A2($elm$html$Html$div, _List_Nil, _List_Nil);
							case 1:
								return A2($elm$html$Html$div, _List_Nil, _List_Nil);
							default:
								return A2($elm$html$Html$div, _List_Nil, _List_Nil);
						}
					}(),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('main-section')
							]),
						_List_fromArray(
							[mainSection])),
						function () {
						var _v2 = model.W;
						switch (_v2) {
							case 2:
								return $author$project$Main$sideSectionWrapper(sideSection);
							case 1:
								return $author$project$Main$sideSectionWrapper(sideSection);
							default:
								return A2($author$project$Main$viewSideSectionDrawer, model, sideSection);
						}
					}()
					])),
				model.$7 ? A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Main$LiveCaptureMsg,
						$author$project$Dialogs$LiveCapture$view(model.de)),
						A2(
						$elm$html$Html$map,
						$author$project$Main$ReleaseNotesMsg,
						$author$project$Dialogs$ReleaseNotes$view(model.ds)),
						A2(
						$elm$html$Html$map,
						$author$project$Main$ContactUsMsg,
						$author$project$Dialogs$ContactUs$view(model.dT)),
						A2(
						$elm$html$Html$map,
						$author$project$Main$FaqMsg,
						$author$project$Pages$Faq$view(model.d5))
					])) : A2($elm$html$Html$div, _List_Nil, _List_Nil),
				function () {
				var _v3 = model.j7.eK;
				if (_v3.$ === 4) {
					var user = _v3.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Main$GalleryMsg,
						A2(
							$author$project$Dialogs$Gallery$view,
							{
								h5: user.h5,
								gm: 'media-upload-button',
								gM: _Utils_Tuple2(
									model.k.fT,
									A2(
										$elm$core$Maybe$withDefault,
										'0',
										$author$project$Pages$User$getDistrictId(model.j7)))
							},
							model.c3));
				} else {
					return $elm$html$Html$text('');
				}
			}(),
				A2(
				$aforemny$material_components_web_elm$Material$Snackbar$snackbar,
				$aforemny$material_components_web_elm$Material$Snackbar$config(
					{l1: $author$project$Main$SnackbarClosed}),
				model.cp),
				A2(
				$author$project$Footer$view,
				model.k,
				{
					jj: $author$project$Main$ContactUsMsg(0),
					jk: $author$project$Main$FaqMsg($author$project$Pages$Faq$OpenDialog),
					jl: $author$project$Main$ReleaseNotesMsg($author$project$Dialogs$ReleaseNotes$OpenDialog)
				})
			]));
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{
		lB: $author$project$Main$initModel,
		l6: function (a) {
			return $author$project$Main$RouteMsg(
				$author$project$Routing$UrlChange(a));
		},
		l7: function (a) {
			return $author$project$Main$RouteMsg(
				$author$project$Routing$UrlRequest(a));
		},
		mN: $author$project$Main$subscriptions,
		nh: $author$project$Main$update,
		nm: function (model) {
			return {
				kG: _List_fromArray(
					[
						$author$project$Main$view(model)
					]),
				na: 'SchoolCafe TV'
			};
		}
	});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (year) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (windowWidth) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (welcomeSideChromeUrl) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (welcomeSideAppleUrl) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (version) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (urlPrefix) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (urlFabric) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (templateSingularity) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (templateHelios) {
																			return A2(
																				$elm$json$Json$Decode$andThen,
																				function (templateEthereal) {
																					return A2(
																						$elm$json$Json$Decode$andThen,
																						function (templateCosmos) {
																							return A2(
																								$elm$json$Json$Decode$andThen,
																								function (templateAura) {
																									return A2(
																										$elm$json$Json$Decode$andThen,
																										function (syncFeatureUrl) {
																											return A2(
																												$elm$json$Json$Decode$andThen,
																												function (setupDeviceFeatureUrl) {
																													return A2(
																														$elm$json$Json$Decode$andThen,
																														function (sctvLogoWhite) {
																															return A2(
																																$elm$json$Json$Decode$andThen,
																																function (remoteMgmtFeatureUrl) {
																																	return A2(
																																		$elm$json$Json$Decode$andThen,
																																		function (primeroedgeFeatureUrl) {
																																			return A2(
																																				$elm$json$Json$Decode$andThen,
																																				function (newDeviceInitStepUrl) {
																																					return A2(
																																						$elm$json$Json$Decode$andThen,
																																						function (logoPath) {
																																							return A2(
																																								$elm$json$Json$Decode$andThen,
																																								function (initialSeed) {
																																									return A2(
																																										$elm$json$Json$Decode$andThen,
																																										function (customizeFeatureUrl) {
																																											return $elm$json$Json$Decode$succeed(
																																												{k5: customizeFeatureUrl, fe: initialSeed, lR: logoPath, l_: newDeviceInitStepUrl, me: primeroedgeFeatureUrl, mj: remoteMgmtFeatureUrl, hE: sctvLogoWhite, mA: setupDeviceFeatureUrl, mP: syncFeatureUrl, mR: templateAura, mS: templateCosmos, mT: templateEthereal, mU: templateHelios, mV: templateSingularity, fT: urlFabric, an: urlPrefix, hW: version, no: welcomeSideAppleUrl, np: welcomeSideChromeUrl, kf: windowWidth, nr: year});
																																										},
																																										A2($elm$json$Json$Decode$field, 'customizeFeatureUrl', $elm$json$Json$Decode$string));
																																								},
																																								A2($elm$json$Json$Decode$field, 'initialSeed', $elm$json$Json$Decode$int));
																																						},
																																						A2($elm$json$Json$Decode$field, 'logoPath', $elm$json$Json$Decode$string));
																																				},
																																				A2($elm$json$Json$Decode$field, 'newDeviceInitStepUrl', $elm$json$Json$Decode$string));
																																		},
																																		A2($elm$json$Json$Decode$field, 'primeroedgeFeatureUrl', $elm$json$Json$Decode$string));
																																},
																																A2($elm$json$Json$Decode$field, 'remoteMgmtFeatureUrl', $elm$json$Json$Decode$string));
																														},
																														A2($elm$json$Json$Decode$field, 'sctvLogoWhite', $elm$json$Json$Decode$string));
																												},
																												A2($elm$json$Json$Decode$field, 'setupDeviceFeatureUrl', $elm$json$Json$Decode$string));
																										},
																										A2($elm$json$Json$Decode$field, 'syncFeatureUrl', $elm$json$Json$Decode$string));
																								},
																								A2($elm$json$Json$Decode$field, 'templateAura', $elm$json$Json$Decode$string));
																						},
																						A2($elm$json$Json$Decode$field, 'templateCosmos', $elm$json$Json$Decode$string));
																				},
																				A2($elm$json$Json$Decode$field, 'templateEthereal', $elm$json$Json$Decode$string));
																		},
																		A2($elm$json$Json$Decode$field, 'templateHelios', $elm$json$Json$Decode$string));
																},
																A2($elm$json$Json$Decode$field, 'templateSingularity', $elm$json$Json$Decode$string));
														},
														A2($elm$json$Json$Decode$field, 'urlFabric', $elm$json$Json$Decode$string));
												},
												A2($elm$json$Json$Decode$field, 'urlPrefix', $elm$json$Json$Decode$string));
										},
										A2($elm$json$Json$Decode$field, 'version', $elm$json$Json$Decode$string));
								},
								A2($elm$json$Json$Decode$field, 'welcomeSideAppleUrl', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'welcomeSideChromeUrl', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'windowWidth', $elm$json$Json$Decode$float));
		},
		A2($elm$json$Json$Decode$field, 'year', $elm$json$Json$Decode$string)))(0)}});}(this));